(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global["oas-generator"] = {}));
})(this, (function (exports) { 'use strict';

	var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

	function getAugmentedNamespace(n) {
	  var f = n.default;
		if (typeof f == "function") {
			var a = function a () {
				if (this instanceof a) {
					var args = [null];
					args.push.apply(args, arguments);
					var Ctor = Function.bind.apply(f, args);
					return new Ctor();
				}
				return f.apply(this, arguments);
			};
			a.prototype = f.prototype;
	  } else a = {};
	  Object.defineProperty(a, '__esModule', {value: true});
		Object.keys(n).forEach(function (k) {
			var d = Object.getOwnPropertyDescriptor(n, k);
			Object.defineProperty(a, k, d.get ? d : {
				enumerable: true,
				get: function () {
					return n[k];
				}
			});
		});
		return a;
	}

	var dist = {};

	(function (exports) {
		exports.__esModule = true;
		exports.OpenAPIV2 = exports.OpenAPIV3 = void 0;
		(function (OpenAPIV3) {
		    (function (HttpMethods) {
		        HttpMethods["GET"] = "get";
		        HttpMethods["PUT"] = "put";
		        HttpMethods["POST"] = "post";
		        HttpMethods["DELETE"] = "delete";
		        HttpMethods["OPTIONS"] = "options";
		        HttpMethods["HEAD"] = "head";
		        HttpMethods["PATCH"] = "patch";
		        HttpMethods["TRACE"] = "trace";
		    })(OpenAPIV3.HttpMethods || (OpenAPIV3.HttpMethods = {}));
		})(exports.OpenAPIV3 || (exports.OpenAPIV3 = {}));
		(function (OpenAPIV2) {
		    (function (HttpMethods) {
		        HttpMethods["GET"] = "get";
		        HttpMethods["PUT"] = "put";
		        HttpMethods["POST"] = "post";
		        HttpMethods["DELETE"] = "delete";
		        HttpMethods["OPTIONS"] = "options";
		        HttpMethods["HEAD"] = "head";
		        HttpMethods["PATCH"] = "patch";
		    })(OpenAPIV2.HttpMethods || (OpenAPIV2.HttpMethods = {}));
		})(exports.OpenAPIV2 || (exports.OpenAPIV2 = {}));
		
	} (dist));

	var util$5 = {};

	var global$1 = (typeof global !== "undefined" ? global :
	  typeof self !== "undefined" ? self :
	  typeof window !== "undefined" ? window : {});

	var lookup = [];
	var revLookup = [];
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
	var inited = false;
	function init () {
	  inited = true;
	  var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
	  for (var i = 0, len = code.length; i < len; ++i) {
	    lookup[i] = code[i];
	    revLookup[code.charCodeAt(i)] = i;
	  }

	  revLookup['-'.charCodeAt(0)] = 62;
	  revLookup['_'.charCodeAt(0)] = 63;
	}

	function toByteArray (b64) {
	  if (!inited) {
	    init();
	  }
	  var i, j, l, tmp, placeHolders, arr;
	  var len = b64.length;

	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }

	  // the number of equal signs (place holders)
	  // if there are two placeholders, than the two characters before it
	  // represent one byte
	  // if there is only one, then the three characters before it represent 2 bytes
	  // this is just a cheap hack to not do indexOf twice
	  placeHolders = b64[len - 2] === '=' ? 2 : b64[len - 1] === '=' ? 1 : 0;

	  // base64 is 4/3 + up to two characters of the original data
	  arr = new Arr(len * 3 / 4 - placeHolders);

	  // if there are placeholders, only get up to the last complete 4 chars
	  l = placeHolders > 0 ? len - 4 : len;

	  var L = 0;

	  for (i = 0, j = 0; i < l; i += 4, j += 3) {
	    tmp = (revLookup[b64.charCodeAt(i)] << 18) | (revLookup[b64.charCodeAt(i + 1)] << 12) | (revLookup[b64.charCodeAt(i + 2)] << 6) | revLookup[b64.charCodeAt(i + 3)];
	    arr[L++] = (tmp >> 16) & 0xFF;
	    arr[L++] = (tmp >> 8) & 0xFF;
	    arr[L++] = tmp & 0xFF;
	  }

	  if (placeHolders === 2) {
	    tmp = (revLookup[b64.charCodeAt(i)] << 2) | (revLookup[b64.charCodeAt(i + 1)] >> 4);
	    arr[L++] = tmp & 0xFF;
	  } else if (placeHolders === 1) {
	    tmp = (revLookup[b64.charCodeAt(i)] << 10) | (revLookup[b64.charCodeAt(i + 1)] << 4) | (revLookup[b64.charCodeAt(i + 2)] >> 2);
	    arr[L++] = (tmp >> 8) & 0xFF;
	    arr[L++] = tmp & 0xFF;
	  }

	  return arr
	}

	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F]
	}

	function encodeChunk (uint8, start, end) {
	  var tmp;
	  var output = [];
	  for (var i = start; i < end; i += 3) {
	    tmp = (uint8[i] << 16) + (uint8[i + 1] << 8) + (uint8[i + 2]);
	    output.push(tripletToBase64(tmp));
	  }
	  return output.join('')
	}

	function fromByteArray (uint8) {
	  if (!inited) {
	    init();
	  }
	  var tmp;
	  var len = uint8.length;
	  var extraBytes = len % 3; // if we have 1 byte left, pad 2 bytes
	  var output = '';
	  var parts = [];
	  var maxChunkLength = 16383; // must be multiple of 3

	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)));
	  }

	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1];
	    output += lookup[tmp >> 2];
	    output += lookup[(tmp << 4) & 0x3F];
	    output += '==';
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + (uint8[len - 1]);
	    output += lookup[tmp >> 10];
	    output += lookup[(tmp >> 4) & 0x3F];
	    output += lookup[(tmp << 2) & 0x3F];
	    output += '=';
	  }

	  parts.push(output);

	  return parts.join('')
	}

	function read (buffer, offset, isLE, mLen, nBytes) {
	  var e, m;
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var nBits = -7;
	  var i = isLE ? (nBytes - 1) : 0;
	  var d = isLE ? -1 : 1;
	  var s = buffer[offset + i];

	  i += d;

	  e = s & ((1 << (-nBits)) - 1);
	  s >>= (-nBits);
	  nBits += eLen;
	  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}

	  m = e & ((1 << (-nBits)) - 1);
	  e >>= (-nBits);
	  nBits += mLen;
	  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}

	  if (e === 0) {
	    e = 1 - eBias;
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen);
	    e = e - eBias;
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}

	function write (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c;
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0);
	  var i = isLE ? 0 : (nBytes - 1);
	  var d = isLE ? 1 : -1;
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0;

	  value = Math.abs(value);

	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0;
	    e = eMax;
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2);
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--;
	      c *= 2;
	    }
	    if (e + eBias >= 1) {
	      value += rt / c;
	    } else {
	      value += rt * Math.pow(2, 1 - eBias);
	    }
	    if (value * c >= 2) {
	      e++;
	      c /= 2;
	    }

	    if (e + eBias >= eMax) {
	      m = 0;
	      e = eMax;
	    } else if (e + eBias >= 1) {
	      m = (value * c - 1) * Math.pow(2, mLen);
	      e = e + eBias;
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
	      e = 0;
	    }
	  }

	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

	  e = (e << mLen) | m;
	  eLen += mLen;
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

	  buffer[offset + i - d] |= s * 128;
	}

	var toString$4 = {}.toString;

	var isArray$4 = Array.isArray || function (arr) {
	  return toString$4.call(arr) == '[object Array]';
	};

	/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */

	var INSPECT_MAX_BYTES = 50;

	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.

	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global$1.TYPED_ARRAY_SUPPORT !== undefined
	  ? global$1.TYPED_ARRAY_SUPPORT
	  : true;

	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	kMaxLength();

	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}

	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length);
	    that.__proto__ = Buffer.prototype;
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length);
	    }
	    that.length = length;
	  }

	  return that
	}

	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */

	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }

	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}

	Buffer.poolSize = 8192; // not used by this implementation

	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype;
	  return arr
	};

	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }

	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }

	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }

	  return fromObject(that, value)
	}

	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	};

	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype;
	  Buffer.__proto__ = Uint8Array;
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) ;
	}

	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}

	function alloc (that, size, fill, encoding) {
	  assertSize(size);
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}

	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	};

	function allocUnsafe (that, size) {
	  assertSize(size);
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0);
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0;
	    }
	  }
	  return that
	}

	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	};
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	};

	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8';
	  }

	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }

	  var length = byteLength(string, encoding) | 0;
	  that = createBuffer(that, length);

	  var actual = that.write(string, encoding);

	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual);
	  }

	  return that
	}

	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0;
	  that = createBuffer(that, length);
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255;
	  }
	  return that
	}

	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength; // this throws if `array` is not a valid ArrayBuffer

	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }

	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }

	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array);
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset);
	  } else {
	    array = new Uint8Array(array, byteOffset, length);
	  }

	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array;
	    that.__proto__ = Buffer.prototype;
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array);
	  }
	  return that
	}

	function fromObject (that, obj) {
	  if (internalIsBuffer(obj)) {
	    var len = checked(obj.length) | 0;
	    that = createBuffer(that, len);

	    if (that.length === 0) {
	      return that
	    }

	    obj.copy(that, 0, 0, len);
	    return that
	  }

	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }

	    if (obj.type === 'Buffer' && isArray$4(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }

	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}

	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	Buffer.isBuffer = isBuffer$1;
	function internalIsBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}

	Buffer.compare = function compare (a, b) {
	  if (!internalIsBuffer(a) || !internalIsBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }

	  if (a === b) return 0

	  var x = a.length;
	  var y = b.length;

	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i];
	      y = b[i];
	      break
	    }
	  }

	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	};

	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	};

	Buffer.concat = function concat (list, length) {
	  if (!isArray$4(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }

	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }

	  var i;
	  if (length === undefined) {
	    length = 0;
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length;
	    }
	  }

	  var buffer = Buffer.allocUnsafe(length);
	  var pos = 0;
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i];
	    if (!internalIsBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos);
	    pos += buf.length;
	  }
	  return buffer
	};

	function byteLength (string, encoding) {
	  if (internalIsBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string;
	  }

	  var len = string.length;
	  if (len === 0) return 0

	  // Use a for loop to avoid recursion
	  var loweredCase = false;
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase();
	        loweredCase = true;
	    }
	  }
	}
	Buffer.byteLength = byteLength;

	function slowToString (encoding, start, end) {
	  var loweredCase = false;

	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.

	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0;
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }

	  if (end === undefined || end > this.length) {
	    end = this.length;
	  }

	  if (end <= 0) {
	    return ''
	  }

	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0;
	  start >>>= 0;

	  if (end <= start) {
	    return ''
	  }

	  if (!encoding) encoding = 'utf8';

	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)

	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)

	      case 'ascii':
	        return asciiSlice(this, start, end)

	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)

	      case 'base64':
	        return base64Slice(this, start, end)

	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)

	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase();
	        loweredCase = true;
	    }
	  }
	}

	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true;

	function swap (b, n, m) {
	  var i = b[n];
	  b[n] = b[m];
	  b[m] = i;
	}

	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length;
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1);
	  }
	  return this
	};

	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length;
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3);
	    swap(this, i + 1, i + 2);
	  }
	  return this
	};

	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length;
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7);
	    swap(this, i + 1, i + 6);
	    swap(this, i + 2, i + 5);
	    swap(this, i + 3, i + 4);
	  }
	  return this
	};

	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0;
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	};

	Buffer.prototype.equals = function equals (b) {
	  if (!internalIsBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	};

	Buffer.prototype.inspect = function inspect () {
	  var str = '';
	  var max = INSPECT_MAX_BYTES;
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ');
	    if (this.length > max) str += ' ... ';
	  }
	  return '<Buffer ' + str + '>'
	};

	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!internalIsBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }

	  if (start === undefined) {
	    start = 0;
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0;
	  }
	  if (thisStart === undefined) {
	    thisStart = 0;
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length;
	  }

	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }

	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }

	  start >>>= 0;
	  end >>>= 0;
	  thisStart >>>= 0;
	  thisEnd >>>= 0;

	  if (this === target) return 0

	  var x = thisEnd - thisStart;
	  var y = end - start;
	  var len = Math.min(x, y);

	  var thisCopy = this.slice(thisStart, thisEnd);
	  var targetCopy = target.slice(start, end);

	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i];
	      y = targetCopy[i];
	      break
	    }
	  }

	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	};

	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1

	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset;
	    byteOffset = 0;
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff;
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000;
	  }
	  byteOffset = +byteOffset;  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1);
	  }

	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1;
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0;
	    else return -1
	  }

	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding);
	  }

	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (internalIsBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF; // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }

	  throw new TypeError('val must be string, number or Buffer')
	}

	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1;
	  var arrLength = arr.length;
	  var valLength = val.length;

	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase();
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2;
	      arrLength /= 2;
	      valLength /= 2;
	      byteOffset /= 2;
	    }
	  }

	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }

	  var i;
	  if (dir) {
	    var foundIndex = -1;
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i;
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex;
	        foundIndex = -1;
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true;
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false;
	          break
	        }
	      }
	      if (found) return i
	    }
	  }

	  return -1
	}

	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	};

	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	};

	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	};

	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0;
	  var remaining = buf.length - offset;
	  if (!length) {
	    length = remaining;
	  } else {
	    length = Number(length);
	    if (length > remaining) {
	      length = remaining;
	    }
	  }

	  // must be an even number of digits
	  var strLen = string.length;
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

	  if (length > strLen / 2) {
	    length = strLen / 2;
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16);
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed;
	  }
	  return i
	}

	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}

	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}

	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}

	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}

	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}

	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8';
	    length = this.length;
	    offset = 0;
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset;
	    length = this.length;
	    offset = 0;
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0;
	    if (isFinite(length)) {
	      length = length | 0;
	      if (encoding === undefined) encoding = 'utf8';
	    } else {
	      encoding = length;
	      length = undefined;
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }

	  var remaining = this.length - offset;
	  if (length === undefined || length > remaining) length = remaining;

	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }

	  if (!encoding) encoding = 'utf8';

	  var loweredCase = false;
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)

	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)

	      case 'ascii':
	        return asciiWrite(this, string, offset, length)

	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)

	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)

	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)

	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase();
	        loweredCase = true;
	    }
	  }
	};

	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	};

	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return fromByteArray(buf)
	  } else {
	    return fromByteArray(buf.slice(start, end))
	  }
	}

	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end);
	  var res = [];

	  var i = start;
	  while (i < end) {
	    var firstByte = buf[i];
	    var codePoint = null;
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1;

	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint;

	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte;
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1];
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F);
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint;
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1];
	          thirdByte = buf[i + 2];
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F);
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint;
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1];
	          thirdByte = buf[i + 2];
	          fourthByte = buf[i + 3];
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F);
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint;
	            }
	          }
	      }
	    }

	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD;
	      bytesPerSequence = 1;
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000;
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800);
	      codePoint = 0xDC00 | codePoint & 0x3FF;
	    }

	    res.push(codePoint);
	    i += bytesPerSequence;
	  }

	  return decodeCodePointsArray(res)
	}

	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000;

	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length;
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }

	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = '';
	  var i = 0;
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    );
	  }
	  return res
	}

	function asciiSlice (buf, start, end) {
	  var ret = '';
	  end = Math.min(buf.length, end);

	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F);
	  }
	  return ret
	}

	function latin1Slice (buf, start, end) {
	  var ret = '';
	  end = Math.min(buf.length, end);

	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i]);
	  }
	  return ret
	}

	function hexSlice (buf, start, end) {
	  var len = buf.length;

	  if (!start || start < 0) start = 0;
	  if (!end || end < 0 || end > len) end = len;

	  var out = '';
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i]);
	  }
	  return out
	}

	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end);
	  var res = '';
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
	  }
	  return res
	}

	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length;
	  start = ~~start;
	  end = end === undefined ? len : ~~end;

	  if (start < 0) {
	    start += len;
	    if (start < 0) start = 0;
	  } else if (start > len) {
	    start = len;
	  }

	  if (end < 0) {
	    end += len;
	    if (end < 0) end = 0;
	  } else if (end > len) {
	    end = len;
	  }

	  if (end < start) end = start;

	  var newBuf;
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end);
	    newBuf.__proto__ = Buffer.prototype;
	  } else {
	    var sliceLen = end - start;
	    newBuf = new Buffer(sliceLen, undefined);
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start];
	    }
	  }

	  return newBuf
	};

	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}

	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0;
	  byteLength = byteLength | 0;
	  if (!noAssert) checkOffset(offset, byteLength, this.length);

	  var val = this[offset];
	  var mul = 1;
	  var i = 0;
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul;
	  }

	  return val
	};

	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0;
	  byteLength = byteLength | 0;
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length);
	  }

	  var val = this[offset + --byteLength];
	  var mul = 1;
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul;
	  }

	  return val
	};

	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length);
	  return this[offset]
	};

	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length);
	  return this[offset] | (this[offset + 1] << 8)
	};

	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length);
	  return (this[offset] << 8) | this[offset + 1]
	};

	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length);

	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	};

	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length);

	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	};

	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0;
	  byteLength = byteLength | 0;
	  if (!noAssert) checkOffset(offset, byteLength, this.length);

	  var val = this[offset];
	  var mul = 1;
	  var i = 0;
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul;
	  }
	  mul *= 0x80;

	  if (val >= mul) val -= Math.pow(2, 8 * byteLength);

	  return val
	};

	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0;
	  byteLength = byteLength | 0;
	  if (!noAssert) checkOffset(offset, byteLength, this.length);

	  var i = byteLength;
	  var mul = 1;
	  var val = this[offset + --i];
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul;
	  }
	  mul *= 0x80;

	  if (val >= mul) val -= Math.pow(2, 8 * byteLength);

	  return val
	};

	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length);
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	};

	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length);
	  var val = this[offset] | (this[offset + 1] << 8);
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	};

	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length);
	  var val = this[offset + 1] | (this[offset] << 8);
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	};

	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length);

	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	};

	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length);

	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	};

	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length);
	  return read(this, offset, true, 23, 4)
	};

	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length);
	  return read(this, offset, false, 23, 4)
	};

	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length);
	  return read(this, offset, true, 52, 8)
	};

	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length);
	  return read(this, offset, false, 52, 8)
	};

	function checkInt (buf, value, offset, ext, max, min) {
	  if (!internalIsBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}

	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  byteLength = byteLength | 0;
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1;
	    checkInt(this, value, offset, byteLength, maxBytes, 0);
	  }

	  var mul = 1;
	  var i = 0;
	  this[offset] = value & 0xFF;
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF;
	  }

	  return offset + byteLength
	};

	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  byteLength = byteLength | 0;
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1;
	    checkInt(this, value, offset, byteLength, maxBytes, 0);
	  }

	  var i = byteLength - 1;
	  var mul = 1;
	  this[offset + i] = value & 0xFF;
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF;
	  }

	  return offset + byteLength
	};

	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
	  this[offset] = (value & 0xff);
	  return offset + 1
	};

	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1;
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8;
	  }
	}

	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff);
	    this[offset + 1] = (value >>> 8);
	  } else {
	    objectWriteUInt16(this, value, offset, true);
	  }
	  return offset + 2
	};

	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8);
	    this[offset + 1] = (value & 0xff);
	  } else {
	    objectWriteUInt16(this, value, offset, false);
	  }
	  return offset + 2
	};

	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1;
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff;
	  }
	}

	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24);
	    this[offset + 2] = (value >>> 16);
	    this[offset + 1] = (value >>> 8);
	    this[offset] = (value & 0xff);
	  } else {
	    objectWriteUInt32(this, value, offset, true);
	  }
	  return offset + 4
	};

	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24);
	    this[offset + 1] = (value >>> 16);
	    this[offset + 2] = (value >>> 8);
	    this[offset + 3] = (value & 0xff);
	  } else {
	    objectWriteUInt32(this, value, offset, false);
	  }
	  return offset + 4
	};

	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1);

	    checkInt(this, value, offset, byteLength, limit - 1, -limit);
	  }

	  var i = 0;
	  var mul = 1;
	  var sub = 0;
	  this[offset] = value & 0xFF;
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1;
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF;
	  }

	  return offset + byteLength
	};

	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1);

	    checkInt(this, value, offset, byteLength, limit - 1, -limit);
	  }

	  var i = byteLength - 1;
	  var mul = 1;
	  var sub = 0;
	  this[offset + i] = value & 0xFF;
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1;
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF;
	  }

	  return offset + byteLength
	};

	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80);
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
	  if (value < 0) value = 0xff + value + 1;
	  this[offset] = (value & 0xff);
	  return offset + 1
	};

	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff);
	    this[offset + 1] = (value >>> 8);
	  } else {
	    objectWriteUInt16(this, value, offset, true);
	  }
	  return offset + 2
	};

	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8);
	    this[offset + 1] = (value & 0xff);
	  } else {
	    objectWriteUInt16(this, value, offset, false);
	  }
	  return offset + 2
	};

	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff);
	    this[offset + 1] = (value >>> 8);
	    this[offset + 2] = (value >>> 16);
	    this[offset + 3] = (value >>> 24);
	  } else {
	    objectWriteUInt32(this, value, offset, true);
	  }
	  return offset + 4
	};

	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
	  if (value < 0) value = 0xffffffff + value + 1;
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24);
	    this[offset + 1] = (value >>> 16);
	    this[offset + 2] = (value >>> 8);
	    this[offset + 3] = (value & 0xff);
	  } else {
	    objectWriteUInt32(this, value, offset, false);
	  }
	  return offset + 4
	};

	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}

	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4);
	  }
	  write(buf, value, offset, littleEndian, 23, 4);
	  return offset + 4
	}

	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	};

	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	};

	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8);
	  }
	  write(buf, value, offset, littleEndian, 52, 8);
	  return offset + 8
	}

	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	};

	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	};

	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0;
	  if (!end && end !== 0) end = this.length;
	  if (targetStart >= target.length) targetStart = target.length;
	  if (!targetStart) targetStart = 0;
	  if (end > 0 && end < start) end = start;

	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0

	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')

	  // Are we oob?
	  if (end > this.length) end = this.length;
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start;
	  }

	  var len = end - start;
	  var i;

	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start];
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start];
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    );
	  }

	  return len
	};

	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start;
	      start = 0;
	      end = this.length;
	    } else if (typeof end === 'string') {
	      encoding = end;
	      end = this.length;
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0);
	      if (code < 256) {
	        val = code;
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255;
	  }

	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }

	  if (end <= start) {
	    return this
	  }

	  start = start >>> 0;
	  end = end === undefined ? this.length : end >>> 0;

	  if (!val) val = 0;

	  var i;
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val;
	    }
	  } else {
	    var bytes = internalIsBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString());
	    var len = bytes.length;
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len];
	    }
	  }

	  return this
	};

	// HELPER FUNCTIONS
	// ================

	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g;

	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '');
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '=';
	  }
	  return str
	}

	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}

	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}

	function utf8ToBytes (string, units) {
	  units = units || Infinity;
	  var codePoint;
	  var length = string.length;
	  var leadSurrogate = null;
	  var bytes = [];

	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i);

	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
	          continue
	        }

	        // valid lead
	        leadSurrogate = codePoint;

	        continue
	      }

	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
	        leadSurrogate = codePoint;
	        continue
	      }

	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
	    }

	    leadSurrogate = null;

	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint);
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      );
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      );
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      );
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }

	  return bytes
	}

	function asciiToBytes (str) {
	  var byteArray = [];
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF);
	  }
	  return byteArray
	}

	function utf16leToBytes (str, units) {
	  var c, hi, lo;
	  var byteArray = [];
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break

	    c = str.charCodeAt(i);
	    hi = c >> 8;
	    lo = c % 256;
	    byteArray.push(lo);
	    byteArray.push(hi);
	  }

	  return byteArray
	}


	function base64ToBytes (str) {
	  return toByteArray(base64clean(str))
	}

	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i];
	  }
	  return i
	}

	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}


	// the following is from is-buffer, also by Feross Aboukhadijeh and with same lisence
	// The _isBuffer check is for Safari 5-7 support, because it's missing
	// Object.prototype.constructor. Remove this eventually
	function isBuffer$1(obj) {
	  return obj != null && (!!obj._isBuffer || isFastBuffer(obj) || isSlowBuffer(obj))
	}

	function isFastBuffer (obj) {
	  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
	}

	// For Node v0.10 support. Remove this eventually.
	function isSlowBuffer (obj) {
	  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isFastBuffer(obj.slice(0, 0))
	}

	// shim for using process in browser
	// based off https://github.com/defunctzombie/node-process/blob/master/browser.js

	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	var cachedSetTimeout = defaultSetTimout;
	var cachedClearTimeout = defaultClearTimeout;
	if (typeof global$1.setTimeout === 'function') {
	    cachedSetTimeout = setTimeout;
	}
	if (typeof global$1.clearTimeout === 'function') {
	    cachedClearTimeout = clearTimeout;
	}

	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }


	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }



	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;

	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}

	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;

	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	function nextTick(fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	}
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	var title$2 = 'browser';
	var platform = 'browser';
	var browser = true;
	var env = {};
	var argv = [];
	var version = ''; // empty string to avoid regexp issues
	var versions = {};
	var release = {};
	var config = {};

	function noop() {}

	var on = noop;
	var addListener = noop;
	var once = noop;
	var off = noop;
	var removeListener = noop;
	var removeAllListeners = noop;
	var emit = noop;

	function binding(name) {
	    throw new Error('process.binding is not supported');
	}

	function cwd () { return '/' }
	function chdir (dir) {
	    throw new Error('process.chdir is not supported');
	}function umask() { return 0; }

	// from https://github.com/kumavis/browser-process-hrtime/blob/master/index.js
	var performance = global$1.performance || {};
	var performanceNow =
	  performance.now        ||
	  performance.mozNow     ||
	  performance.msNow      ||
	  performance.oNow       ||
	  performance.webkitNow  ||
	  function(){ return (new Date()).getTime() };

	// generate timestamp or delta
	// see http://nodejs.org/api/process.html#process_process_hrtime
	function hrtime(previousTimestamp){
	  var clocktime = performanceNow.call(performance)*1e-3;
	  var seconds = Math.floor(clocktime);
	  var nanoseconds = Math.floor((clocktime%1)*1e9);
	  if (previousTimestamp) {
	    seconds = seconds - previousTimestamp[0];
	    nanoseconds = nanoseconds - previousTimestamp[1];
	    if (nanoseconds<0) {
	      seconds--;
	      nanoseconds += 1e9;
	    }
	  }
	  return [seconds,nanoseconds]
	}

	var startTime = new Date();
	function uptime() {
	  var currentTime = new Date();
	  var dif = currentTime - startTime;
	  return dif / 1000;
	}

	var browser$1 = {
	  nextTick: nextTick,
	  title: title$2,
	  browser: browser,
	  env: env,
	  argv: argv,
	  version: version,
	  versions: versions,
	  on: on,
	  addListener: addListener,
	  once: once,
	  off: off,
	  removeListener: removeListener,
	  removeAllListeners: removeAllListeners,
	  emit: emit,
	  binding: binding,
	  cwd: cwd,
	  chdir: chdir,
	  umask: umask,
	  hrtime: hrtime,
	  platform: platform,
	  release: release,
	  config: config,
	  uptime: uptime
	};

	var inherits;
	if (typeof Object.create === 'function'){
	  inherits = function inherits(ctor, superCtor) {
	    // implementation from standard node.js 'util' module
	    ctor.super_ = superCtor;
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  inherits = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor;
	    var TempCtor = function () {};
	    TempCtor.prototype = superCtor.prototype;
	    ctor.prototype = new TempCtor();
	    ctor.prototype.constructor = ctor;
	  };
	}
	var inherits$1 = inherits;

	var formatRegExp = /%[sdj%]/g;
	function format$3(f) {
	  if (!isString$1(f)) {
	    var objects = [];
	    for (var i = 0; i < arguments.length; i++) {
	      objects.push(inspect(arguments[i]));
	    }
	    return objects.join(' ');
	  }

	  var i = 1;
	  var args = arguments;
	  var len = args.length;
	  var str = String(f).replace(formatRegExp, function(x) {
	    if (x === '%%') return '%';
	    if (i >= len) return x;
	    switch (x) {
	      case '%s': return String(args[i++]);
	      case '%d': return Number(args[i++]);
	      case '%j':
	        try {
	          return JSON.stringify(args[i++]);
	        } catch (_) {
	          return '[Circular]';
	        }
	      default:
	        return x;
	    }
	  });
	  for (var x = args[i]; i < len; x = args[++i]) {
	    if (isNull$1(x) || !isObject$3(x)) {
	      str += ' ' + x;
	    } else {
	      str += ' ' + inspect(x);
	    }
	  }
	  return str;
	}

	// Mark that a method should not be used.
	// Returns a modified function which warns once by default.
	// If --no-deprecation is set, then it is a no-op.
	function deprecate(fn, msg) {
	  // Allow for deprecating things in the process of starting up.
	  if (isUndefined(global$1.process)) {
	    return function() {
	      return deprecate(fn, msg).apply(this, arguments);
	    };
	  }

	  if (browser$1.noDeprecation === true) {
	    return fn;
	  }

	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (browser$1.throwDeprecation) {
	        throw new Error(msg);
	      } else if (browser$1.traceDeprecation) {
	        console.trace(msg);
	      } else {
	        console.error(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }

	  return deprecated;
	}

	var debugs = {};
	var debugEnviron;
	function debuglog(set) {
	  if (isUndefined(debugEnviron))
	    debugEnviron = browser$1.env.NODE_DEBUG || '';
	  set = set.toUpperCase();
	  if (!debugs[set]) {
	    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
	      var pid = 0;
	      debugs[set] = function() {
	        var msg = format$3.apply(null, arguments);
	        console.error('%s %d: %s', set, pid, msg);
	      };
	    } else {
	      debugs[set] = function() {};
	    }
	  }
	  return debugs[set];
	}

	/**
	 * Echos the value of a value. Trys to print the value out
	 * in the best way possible given the different types.
	 *
	 * @param {Object} obj The object to print out.
	 * @param {Object} opts Optional options object that alters the output.
	 */
	/* legacy: obj, showHidden, depth, colors*/
	function inspect(obj, opts) {
	  // default options
	  var ctx = {
	    seen: [],
	    stylize: stylizeNoColor
	  };
	  // legacy...
	  if (arguments.length >= 3) ctx.depth = arguments[2];
	  if (arguments.length >= 4) ctx.colors = arguments[3];
	  if (isBoolean$2(opts)) {
	    // legacy...
	    ctx.showHidden = opts;
	  } else if (opts) {
	    // got an "options" object
	    _extend(ctx, opts);
	  }
	  // set default options
	  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
	  if (isUndefined(ctx.depth)) ctx.depth = 2;
	  if (isUndefined(ctx.colors)) ctx.colors = false;
	  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
	  if (ctx.colors) ctx.stylize = stylizeWithColor;
	  return formatValue(ctx, obj, ctx.depth);
	}

	// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
	inspect.colors = {
	  'bold' : [1, 22],
	  'italic' : [3, 23],
	  'underline' : [4, 24],
	  'inverse' : [7, 27],
	  'white' : [37, 39],
	  'grey' : [90, 39],
	  'black' : [30, 39],
	  'blue' : [34, 39],
	  'cyan' : [36, 39],
	  'green' : [32, 39],
	  'magenta' : [35, 39],
	  'red' : [31, 39],
	  'yellow' : [33, 39]
	};

	// Don't use 'blue' not visible on cmd.exe
	inspect.styles = {
	  'special': 'cyan',
	  'number': 'yellow',
	  'boolean': 'yellow',
	  'undefined': 'grey',
	  'null': 'bold',
	  'string': 'green',
	  'date': 'magenta',
	  // "name": intentionally not styling
	  'regexp': 'red'
	};


	function stylizeWithColor(str, styleType) {
	  var style = inspect.styles[styleType];

	  if (style) {
	    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
	           '\u001b[' + inspect.colors[style][1] + 'm';
	  } else {
	    return str;
	  }
	}


	function stylizeNoColor(str, styleType) {
	  return str;
	}


	function arrayToHash(array) {
	  var hash = {};

	  array.forEach(function(val, idx) {
	    hash[val] = true;
	  });

	  return hash;
	}


	function formatValue(ctx, value, recurseTimes) {
	  // Provide a hook for user-specified inspect functions.
	  // Check that value is an object with an inspect function on it
	  if (ctx.customInspect &&
	      value &&
	      isFunction$3(value.inspect) &&
	      // Filter out the util module, it's inspect function is special
	      value.inspect !== inspect &&
	      // Also filter out any prototype objects using the circular check.
	      !(value.constructor && value.constructor.prototype === value)) {
	    var ret = value.inspect(recurseTimes, ctx);
	    if (!isString$1(ret)) {
	      ret = formatValue(ctx, ret, recurseTimes);
	    }
	    return ret;
	  }

	  // Primitive types cannot have properties
	  var primitive = formatPrimitive(ctx, value);
	  if (primitive) {
	    return primitive;
	  }

	  // Look up the keys of the object.
	  var keys = Object.keys(value);
	  var visibleKeys = arrayToHash(keys);

	  if (ctx.showHidden) {
	    keys = Object.getOwnPropertyNames(value);
	  }

	  // IE doesn't make error fields non-enumerable
	  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
	  if (isError(value)
	      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
	    return formatError$1(value);
	  }

	  // Some type of object without properties can be shortcutted.
	  if (keys.length === 0) {
	    if (isFunction$3(value)) {
	      var name = value.name ? ': ' + value.name : '';
	      return ctx.stylize('[Function' + name + ']', 'special');
	    }
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    }
	    if (isDate$1(value)) {
	      return ctx.stylize(Date.prototype.toString.call(value), 'date');
	    }
	    if (isError(value)) {
	      return formatError$1(value);
	    }
	  }

	  var base = '', array = false, braces = ['{', '}'];

	  // Make Array say that they are Array
	  if (isArray$3(value)) {
	    array = true;
	    braces = ['[', ']'];
	  }

	  // Make functions say that they are functions
	  if (isFunction$3(value)) {
	    var n = value.name ? ': ' + value.name : '';
	    base = ' [Function' + n + ']';
	  }

	  // Make RegExps say that they are RegExps
	  if (isRegExp(value)) {
	    base = ' ' + RegExp.prototype.toString.call(value);
	  }

	  // Make dates with properties first say the date
	  if (isDate$1(value)) {
	    base = ' ' + Date.prototype.toUTCString.call(value);
	  }

	  // Make error with message first say the error
	  if (isError(value)) {
	    base = ' ' + formatError$1(value);
	  }

	  if (keys.length === 0 && (!array || value.length == 0)) {
	    return braces[0] + base + braces[1];
	  }

	  if (recurseTimes < 0) {
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    } else {
	      return ctx.stylize('[Object]', 'special');
	    }
	  }

	  ctx.seen.push(value);

	  var output;
	  if (array) {
	    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
	  } else {
	    output = keys.map(function(key) {
	      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
	    });
	  }

	  ctx.seen.pop();

	  return reduceToSingleString(output, base, braces);
	}


	function formatPrimitive(ctx, value) {
	  if (isUndefined(value))
	    return ctx.stylize('undefined', 'undefined');
	  if (isString$1(value)) {
	    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
	                                             .replace(/'/g, "\\'")
	                                             .replace(/\\"/g, '"') + '\'';
	    return ctx.stylize(simple, 'string');
	  }
	  if (isNumber$1(value))
	    return ctx.stylize('' + value, 'number');
	  if (isBoolean$2(value))
	    return ctx.stylize('' + value, 'boolean');
	  // For some reason typeof null is "object", so special case here.
	  if (isNull$1(value))
	    return ctx.stylize('null', 'null');
	}


	function formatError$1(value) {
	  return '[' + Error.prototype.toString.call(value) + ']';
	}


	function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
	  var output = [];
	  for (var i = 0, l = value.length; i < l; ++i) {
	    if (hasOwnProperty$3(value, String(i))) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          String(i), true));
	    } else {
	      output.push('');
	    }
	  }
	  keys.forEach(function(key) {
	    if (!key.match(/^\d+$/)) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          key, true));
	    }
	  });
	  return output;
	}


	function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
	  var name, str, desc;
	  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
	  if (desc.get) {
	    if (desc.set) {
	      str = ctx.stylize('[Getter/Setter]', 'special');
	    } else {
	      str = ctx.stylize('[Getter]', 'special');
	    }
	  } else {
	    if (desc.set) {
	      str = ctx.stylize('[Setter]', 'special');
	    }
	  }
	  if (!hasOwnProperty$3(visibleKeys, key)) {
	    name = '[' + key + ']';
	  }
	  if (!str) {
	    if (ctx.seen.indexOf(desc.value) < 0) {
	      if (isNull$1(recurseTimes)) {
	        str = formatValue(ctx, desc.value, null);
	      } else {
	        str = formatValue(ctx, desc.value, recurseTimes - 1);
	      }
	      if (str.indexOf('\n') > -1) {
	        if (array) {
	          str = str.split('\n').map(function(line) {
	            return '  ' + line;
	          }).join('\n').substr(2);
	        } else {
	          str = '\n' + str.split('\n').map(function(line) {
	            return '   ' + line;
	          }).join('\n');
	        }
	      }
	    } else {
	      str = ctx.stylize('[Circular]', 'special');
	    }
	  }
	  if (isUndefined(name)) {
	    if (array && key.match(/^\d+$/)) {
	      return str;
	    }
	    name = JSON.stringify('' + key);
	    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
	      name = name.substr(1, name.length - 2);
	      name = ctx.stylize(name, 'name');
	    } else {
	      name = name.replace(/'/g, "\\'")
	                 .replace(/\\"/g, '"')
	                 .replace(/(^"|"$)/g, "'");
	      name = ctx.stylize(name, 'string');
	    }
	  }

	  return name + ': ' + str;
	}


	function reduceToSingleString(output, base, braces) {
	  var length = output.reduce(function(prev, cur) {
	    if (cur.indexOf('\n') >= 0) ;
	    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
	  }, 0);

	  if (length > 60) {
	    return braces[0] +
	           (base === '' ? '' : base + '\n ') +
	           ' ' +
	           output.join(',\n  ') +
	           ' ' +
	           braces[1];
	  }

	  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
	}


	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	function isArray$3(ar) {
	  return Array.isArray(ar);
	}

	function isBoolean$2(arg) {
	  return typeof arg === 'boolean';
	}

	function isNull$1(arg) {
	  return arg === null;
	}

	function isNullOrUndefined(arg) {
	  return arg == null;
	}

	function isNumber$1(arg) {
	  return typeof arg === 'number';
	}

	function isString$1(arg) {
	  return typeof arg === 'string';
	}

	function isSymbol$1(arg) {
	  return typeof arg === 'symbol';
	}

	function isUndefined(arg) {
	  return arg === void 0;
	}

	function isRegExp(re) {
	  return isObject$3(re) && objectToString$1(re) === '[object RegExp]';
	}

	function isObject$3(arg) {
	  return typeof arg === 'object' && arg !== null;
	}

	function isDate$1(d) {
	  return isObject$3(d) && objectToString$1(d) === '[object Date]';
	}

	function isError(e) {
	  return isObject$3(e) &&
	      (objectToString$1(e) === '[object Error]' || e instanceof Error);
	}

	function isFunction$3(arg) {
	  return typeof arg === 'function';
	}

	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}

	function isBuffer(maybeBuf) {
	  return Buffer.isBuffer(maybeBuf);
	}

	function objectToString$1(o) {
	  return Object.prototype.toString.call(o);
	}


	function pad$1(n) {
	  return n < 10 ? '0' + n.toString(10) : n.toString(10);
	}


	var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
	              'Oct', 'Nov', 'Dec'];

	// 26 Feb 16:19:34
	function timestamp$1() {
	  var d = new Date();
	  var time = [pad$1(d.getHours()),
	              pad$1(d.getMinutes()),
	              pad$1(d.getSeconds())].join(':');
	  return [d.getDate(), months[d.getMonth()], time].join(' ');
	}


	// log is just a thin wrapper to console.log that prepends a timestamp
	function log() {
	  console.log('%s - %s', timestamp$1(), format$3.apply(null, arguments));
	}

	function _extend(origin, add) {
	  // Don't do anything if add isn't an object
	  if (!add || !isObject$3(add)) return origin;

	  var keys = Object.keys(add);
	  var i = keys.length;
	  while (i--) {
	    origin[keys[i]] = add[keys[i]];
	  }
	  return origin;
	}
	function hasOwnProperty$3(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}

	var _polyfillNode_util = {
	  inherits: inherits$1,
	  _extend: _extend,
	  log: log,
	  isBuffer: isBuffer,
	  isPrimitive: isPrimitive,
	  isFunction: isFunction$3,
	  isError: isError,
	  isDate: isDate$1,
	  isObject: isObject$3,
	  isRegExp: isRegExp,
	  isUndefined: isUndefined,
	  isSymbol: isSymbol$1,
	  isString: isString$1,
	  isNumber: isNumber$1,
	  isNullOrUndefined: isNullOrUndefined,
	  isNull: isNull$1,
	  isBoolean: isBoolean$2,
	  isArray: isArray$3,
	  inspect: inspect,
	  deprecate: deprecate,
	  format: format$3,
	  debuglog: debuglog
	};

	var _polyfillNode_util$1 = /*#__PURE__*/Object.freeze({
		__proto__: null,
		format: format$3,
		deprecate: deprecate,
		debuglog: debuglog,
		inspect: inspect,
		isArray: isArray$3,
		isBoolean: isBoolean$2,
		isNull: isNull$1,
		isNullOrUndefined: isNullOrUndefined,
		isNumber: isNumber$1,
		isString: isString$1,
		isSymbol: isSymbol$1,
		isUndefined: isUndefined,
		isRegExp: isRegExp,
		isObject: isObject$3,
		isDate: isDate$1,
		isError: isError,
		isFunction: isFunction$3,
		isPrimitive: isPrimitive,
		isBuffer: isBuffer,
		log: log,
		inherits: inherits$1,
		_extend: _extend,
		'default': _polyfillNode_util
	});

	var require$$3$1 = /*@__PURE__*/getAugmentedNamespace(_polyfillNode_util$1);

	const util$4 = require$$3$1;

	util$5.format = util$4.format;
	util$5.inherits = util$4.inherits;

	/**
	 * Regular Expression that matches Swagger path params.
	 */
	util$5.swaggerParamRegExp = /\{([^/}]+)}/g;

	/**
	 * Ono supports custom formatters for error messages.  In Node.js, it defaults
	 * to the `util.format()` function.  In browsers, it defaults to `Array.join()`.
	 *
	 * The Node.js functionality can be used in a web browser via a polyfill,
	 * such as "format-util".
	 *
	 * @see https://github.com/tmpfs/format-util
	 */
	const format$2 = false;

	const newline = /\r?\n/;
	const onoCall = /\bono[ @]/;
	/**
	 * Is the property lazily computed?
	 */
	function isLazyStack(stackProp) {
	    return Boolean(stackProp &&
	        stackProp.configurable &&
	        typeof stackProp.get === "function");
	}
	/**
	 * Is the stack property writable?
	 */
	function isWritableStack(stackProp) {
	    return Boolean(
	    // If there is no stack property, then it's writable, since assigning it will create it
	    !stackProp ||
	        stackProp.writable ||
	        typeof stackProp.set === "function");
	}
	/**
	 * Appends the original `Error.stack` property to the new Error's stack.
	 */
	function joinStacks(newError, originalError) {
	    let newStack = popStack(newError.stack);
	    let originalStack = originalError ? originalError.stack : undefined;
	    if (newStack && originalStack) {
	        return newStack + "\n\n" + originalStack;
	    }
	    else {
	        return newStack || originalStack;
	    }
	}
	/**
	 * Calls `joinStacks` lazily, when the `Error.stack` property is accessed.
	 */
	function lazyJoinStacks(lazyStack, newError, originalError) {
	    if (originalError) {
	        Object.defineProperty(newError, "stack", {
	            get: () => {
	                let newStack = lazyStack.get.apply(newError);
	                return joinStacks({ stack: newStack }, originalError);
	            },
	            enumerable: false,
	            configurable: true
	        });
	    }
	    else {
	        lazyPopStack(newError, lazyStack);
	    }
	}
	/**
	 * Removes Ono from the stack, so that the stack starts at the original error location
	 */
	function popStack(stack) {
	    if (stack) {
	        let lines = stack.split(newline);
	        // Find the Ono call(s) in the stack, and remove them
	        let onoStart;
	        for (let i = 0; i < lines.length; i++) {
	            let line = lines[i];
	            if (onoCall.test(line)) {
	                if (onoStart === undefined) {
	                    // We found the first Ono call in the stack trace.
	                    // There may be other subsequent Ono calls as well.
	                    onoStart = i;
	                }
	            }
	            else if (onoStart !== undefined) {
	                // We found the first non-Ono call after one or more Ono calls.
	                // So remove the Ono call lines from the stack trace
	                lines.splice(onoStart, i - onoStart);
	                break;
	            }
	        }
	        if (lines.length > 0) {
	            return lines.join("\n");
	        }
	    }
	    // If we get here, then the stack doesn't contain a call to `ono`.
	    // This may be due to minification or some optimization of the JS engine.
	    // So just return the stack as-is.
	    return stack;
	}
	/**
	 * Calls `popStack` lazily, when the `Error.stack` property is accessed.
	 */
	function lazyPopStack(error, lazyStack) {
	    Object.defineProperty(error, "stack", {
	        get: () => popStack(lazyStack.get.apply(error)),
	        enumerable: false,
	        configurable: true
	    });
	}

	const nonJsonTypes = ["function", "symbol", "undefined"];
	const protectedProps$1 = ["constructor", "prototype", "__proto__"];
	const objectPrototype = Object.getPrototypeOf({});
	/**
	 * Custom JSON serializer for Error objects.
	 * Returns all built-in error properties, as well as extended properties.
	 */
	function toJSON() {
	    // HACK: We have to cast the objects to `any` so we can use symbol indexers.
	    // see https://github.com/Microsoft/TypeScript/issues/1863
	    let pojo = {};
	    let error = this;
	    for (let key of getDeepKeys(error)) {
	        if (typeof key === "string") {
	            let value = error[key];
	            let type = typeof value;
	            if (!nonJsonTypes.includes(type)) {
	                pojo[key] = value;
	            }
	        }
	    }
	    return pojo;
	}
	/**
	 * Returns own, inherited, enumerable, non-enumerable, string, and symbol keys of `obj`.
	 * Does NOT return members of the base Object prototype, or the specified omitted keys.
	 */
	function getDeepKeys(obj, omit = []) {
	    let keys = [];
	    // Crawl the prototype chain, finding all the string and symbol keys
	    while (obj && obj !== objectPrototype) {
	        keys = keys.concat(Object.getOwnPropertyNames(obj), Object.getOwnPropertySymbols(obj));
	        obj = Object.getPrototypeOf(obj);
	    }
	    // De-duplicate the list of keys
	    let uniqueKeys = new Set(keys);
	    // Remove any omitted keys
	    for (let key of omit.concat(protectedProps$1)) {
	        uniqueKeys.delete(key);
	    }
	    return uniqueKeys;
	}

	const protectedProps = ["name", "message", "stack"];
	/**
	 * Extends the new error with the properties of the original error and the `props` object.
	 *
	 * @param newError - The error object to extend
	 * @param originalError - The original error object, if any
	 * @param props - Additional properties to add, if any
	 */
	function extendError(error, originalError, props) {
	    let onoError = error;
	    extendStack(onoError, originalError);
	    // Copy properties from the original error
	    if (originalError && typeof originalError === "object") {
	        mergeErrors(onoError, originalError);
	    }
	    // The default `toJSON` method doesn't output props like `name`, `message`, `stack`, etc.
	    // So replace it with one that outputs every property of the error.
	    onoError.toJSON = toJSON;
	    // Finally, copy custom properties that were specified by the user.
	    // These props OVERWRITE any previous props
	    if (props && typeof props === "object") {
	        Object.assign(onoError, props);
	    }
	    return onoError;
	}
	/**
	 * Extend the error stack to include its cause
	 */
	function extendStack(newError, originalError) {
	    let stackProp = Object.getOwnPropertyDescriptor(newError, "stack");
	    if (isLazyStack(stackProp)) {
	        lazyJoinStacks(stackProp, newError, originalError);
	    }
	    else if (isWritableStack(stackProp)) {
	        newError.stack = joinStacks(newError, originalError);
	    }
	}
	/**
	 * Merges properties of the original error with the new error.
	 *
	 * @param newError - The error object to extend
	 * @param originalError - The original error object, if any
	 */
	function mergeErrors(newError, originalError) {
	    // Get the original error's keys
	    // NOTE: We specifically exclude properties that we have already set on the new error.
	    // This is _especially_ important for the `stack` property, because this property has
	    // a lazy getter in some environments
	    let keys = getDeepKeys(originalError, protectedProps);
	    // HACK: We have to cast the errors to `any` so we can use symbol indexers.
	    // see https://github.com/Microsoft/TypeScript/issues/1863
	    let _newError = newError;
	    let _originalError = originalError;
	    for (let key of keys) {
	        if (_newError[key] === undefined) {
	            try {
	                _newError[key] = _originalError[key];
	            }
	            catch (e) {
	                // This property is read-only, so it can't be copied
	            }
	        }
	    }
	}

	/**
	 * Normalizes Ono options, accounting for defaults and optional options.
	 */
	function normalizeOptions$1(options) {
	    options = options || {};
	    return {
	        concatMessages: options.concatMessages === undefined ? true : Boolean(options.concatMessages),
	        format: options.format === undefined ? format$2
	            : (typeof options.format === "function" ? options.format : false),
	    };
	}
	/**
	 * Normalizes the Ono arguments, accounting for defaults, options, and optional arguments.
	 */
	function normalizeArgs$3(args, options) {
	    let originalError;
	    let props;
	    let formatArgs;
	    let message = "";
	    // Determine which arguments were actually specified
	    if (typeof args[0] === "string") {
	        formatArgs = args;
	    }
	    else if (typeof args[1] === "string") {
	        if (args[0] instanceof Error) {
	            originalError = args[0];
	        }
	        else {
	            props = args[0];
	        }
	        formatArgs = args.slice(1);
	    }
	    else {
	        originalError = args[0];
	        props = args[1];
	        formatArgs = args.slice(2);
	    }
	    // If there are any format arguments, then format the error message
	    if (formatArgs.length > 0) {
	        if (options.format) {
	            message = options.format.apply(undefined, formatArgs);
	        }
	        else {
	            message = formatArgs.join(" ");
	        }
	    }
	    if (options.concatMessages && originalError && originalError.message) {
	        // The inner-error's message will be added to the new message
	        message += (message ? " \n" : "") + originalError.message;
	    }
	    return { originalError, props, message };
	}

	const constructor = Ono$1;
	/**
	 * Creates an `Ono` instance for a specifc error type.
	 */
	// eslint-disable-next-line @typescript-eslint/naming-convention
	function Ono$1(ErrorConstructor, options) {
	    options = normalizeOptions$1(options);
	    function ono(...args) {
	        let { originalError, props, message } = normalizeArgs$3(args, options);
	        // Create a new error of the specified type
	        let newError = new ErrorConstructor(message);
	        // Extend the error with the properties of the original error and the `props` object
	        return extendError(newError, originalError, props);
	    }
	    ono[Symbol.species] = ErrorConstructor;
	    return ono;
	}
	/**
	 * Returns an object containing all properties of the given Error object,
	 * which can be used with `JSON.stringify()`.
	 */
	Ono$1.toJSON = function toJSON$1(error) {
	    return toJSON.call(error);
	};
	/**
	 * Extends the given Error object with enhanced Ono functionality, such as nested stack traces,
	 * additional properties, and improved support for `JSON.stringify()`.
	 */
	Ono$1.extend = function extend(error, originalError, props) {
	    if (props || originalError instanceof Error) {
	        return extendError(error, originalError, props);
	    }
	    else if (originalError) {
	        return extendError(error, undefined, originalError);
	    }
	    else {
	        return extendError(error);
	    }
	};

	const singleton = ono$9;
	ono$9.error = new constructor(Error);
	ono$9.eval = new constructor(EvalError);
	ono$9.range = new constructor(RangeError);
	ono$9.reference = new constructor(ReferenceError);
	ono$9.syntax = new constructor(SyntaxError);
	ono$9.type = new constructor(TypeError);
	ono$9.uri = new constructor(URIError);
	const onoMap = ono$9;
	/**
	 * Creates a new error with the specified message, properties, and/or inner error.
	 * If an inner error is provided, then the new error will match its type, if possible.
	 */
	function ono$9(...args) {
	    let originalError = args[0];
	    // Is the first argument an Error-like object?
	    if (typeof originalError === "object" && typeof originalError.name === "string") {
	        // Try to find an Ono singleton method that matches this error type
	        for (let typedOno of Object.values(onoMap)) {
	            if (typeof typedOno === "function" && typedOno.name === "ono") {
	                let species = typedOno[Symbol.species];
	                if (species && species !== Error && (originalError instanceof species || originalError.name === species.name)) {
	                    // Create an error of the same type
	                    return typedOno.apply(undefined, args);
	                }
	            }
	        }
	    }
	    // By default, create a base Error object
	    return ono$9.error.apply(undefined, args);
	}

	/* eslint-env commonjs */
	// CommonJS default export hack
	if (typeof module === "object" && typeof module.exports === "object") ;

	var esm = /*#__PURE__*/Object.freeze({
		__proto__: null,
		ono: singleton,
		'default': singleton,
		Ono: constructor
	});

	var require$$6 = /*@__PURE__*/getAugmentedNamespace(esm);

	// Number.isFinite polyfill
	// http://people.mozilla.org/~jorendorff/es6-draft.html#sec-number.isfinite
	if (typeof Number.isFinite !== "function") {
	    Number.isFinite = function isFinite(value) {
	        // 1. If Type(number) is not Number, return false.
	        if (typeof value !== "number") {
	            return false;
	        }
	        // 2. If number is NaN, +∞, or −∞, return false.
	        if (value !== value || value === Infinity || value === -Infinity) {
	            return false;
	        }
	        // 3. Otherwise, return true.
	        return true;
	    };
	}

	/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */

	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';

	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;

	/** `Object#toString` result references. */
	var funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    symbolTag = '[object Symbol]';

	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/,
	    reLeadingDot = /^\./,
	    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;

	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;

	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}

	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}

	/** Used for built-in method references. */
	var arrayProto = Array.prototype,
	    funcProto = Function.prototype,
	    objectProto = Object.prototype;

	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];

	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());

	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;

	/** Used to check objects for own properties. */
	var hasOwnProperty$2 = objectProto.hasOwnProperty;

	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;

	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty$2).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);

	/** Built-in value references. */
	var Symbol$1 = root.Symbol,
	    splice = arrayProto.splice;

	/* Built-in method references that are verified to be native. */
	var Map$1 = getNative(root, 'Map'),
	    nativeCreate = getNative(Object, 'create');

	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol$1 ? Symbol$1.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;

	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash$1(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;

	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}

	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	}

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  return this.has(key) && delete this.__data__[key];
	}

	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty$2.call(data, key) ? data[key] : undefined;
	}

	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? data[key] !== undefined : hasOwnProperty$2.call(data, key);
	}

	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}

	// Add methods to `Hash`.
	Hash$1.prototype.clear = hashClear;
	Hash$1.prototype['delete'] = hashDelete;
	Hash$1.prototype.get = hashGet;
	Hash$1.prototype.has = hashHas;
	Hash$1.prototype.set = hashSet;

	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;

	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	}

	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);

	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  return true;
	}

	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);

	  return index < 0 ? undefined : data[index][1];
	}

	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}

	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);

	  if (index < 0) {
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}

	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;

	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;

	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}

	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.__data__ = {
	    'hash': new Hash$1,
	    'map': new (Map$1 || ListCache),
	    'string': new Hash$1
	  };
	}

	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  return getMapData(this, key)['delete'](key);
	}

	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}

	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}

	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  getMapData(this, key).set(key, value);
	  return this;
	}

	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;

	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq$4(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}

	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = isKey(path, object) ? [path] : castPath(path);

	  var index = 0,
	      length = path.length;

	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}

	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject$2(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = (isFunction$2(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}

	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}

	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value) {
	  return isArray$2(value) ? value : stringToPath(value);
	}

	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}

	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}

	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray$2(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}

	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}

	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoize(function(string) {
	  string = toString$3(string);

	  var result = [];
	  if (reLeadingDot.test(string)) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, string) {
	    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});

	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}

	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}

	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;

	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result);
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}

	// Assign cache to `_.memoize`.
	memoize.Cache = MapCache;

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq$4(value, other) {
	  return value === other || (value !== value && other !== other);
	}

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray$2 = Array.isArray;

	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction$2(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject$2(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject$2(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}

	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}

	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString$3(value) {
	  return value == null ? '' : baseToString(value);
	}

	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get$6(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}

	var lodash_get = get$6;

	var Errors$1 = {

	    INVALID_TYPE:                           "Expected type {0} but found type {1}",
	    INVALID_FORMAT:                         "Object didn't pass validation for format {0}: {1}",
	    ENUM_MISMATCH:                          "No enum match for: {0}",
	    ENUM_CASE_MISMATCH:                     "Enum does not match case for: {0}",
	    ANY_OF_MISSING:                         "Data does not match any schemas from 'anyOf'",
	    ONE_OF_MISSING:                         "Data does not match any schemas from 'oneOf'",
	    ONE_OF_MULTIPLE:                        "Data is valid against more than one schema from 'oneOf'",
	    NOT_PASSED:                             "Data matches schema from 'not'",

	    // Array errors
	    ARRAY_LENGTH_SHORT:                     "Array is too short ({0}), minimum {1}",
	    ARRAY_LENGTH_LONG:                      "Array is too long ({0}), maximum {1}",
	    ARRAY_UNIQUE:                           "Array items are not unique (indexes {0} and {1})",
	    ARRAY_ADDITIONAL_ITEMS:                 "Additional items not allowed",

	    // Numeric errors
	    MULTIPLE_OF:                            "Value {0} is not a multiple of {1}",
	    MINIMUM:                                "Value {0} is less than minimum {1}",
	    MINIMUM_EXCLUSIVE:                      "Value {0} is equal or less than exclusive minimum {1}",
	    MAXIMUM:                                "Value {0} is greater than maximum {1}",
	    MAXIMUM_EXCLUSIVE:                      "Value {0} is equal or greater than exclusive maximum {1}",

	    // Object errors
	    OBJECT_PROPERTIES_MINIMUM:              "Too few properties defined ({0}), minimum {1}",
	    OBJECT_PROPERTIES_MAXIMUM:              "Too many properties defined ({0}), maximum {1}",
	    OBJECT_MISSING_REQUIRED_PROPERTY:       "Missing required property: {0}",
	    OBJECT_ADDITIONAL_PROPERTIES:           "Additional properties not allowed: {0}",
	    OBJECT_DEPENDENCY_KEY:                  "Dependency failed - key must exist: {0} (due to key: {1})",

	    // String errors
	    MIN_LENGTH:                             "String is too short ({0} chars), minimum {1}",
	    MAX_LENGTH:                             "String is too long ({0} chars), maximum {1}",
	    PATTERN:                                "String does not match pattern {0}: {1}",

	    // Schema validation errors
	    KEYWORD_TYPE_EXPECTED:                  "Keyword '{0}' is expected to be of type '{1}'",
	    KEYWORD_UNDEFINED_STRICT:               "Keyword '{0}' must be defined in strict mode",
	    KEYWORD_UNEXPECTED:                     "Keyword '{0}' is not expected to appear in the schema",
	    KEYWORD_MUST_BE:                        "Keyword '{0}' must be {1}",
	    KEYWORD_DEPENDENCY:                     "Keyword '{0}' requires keyword '{1}'",
	    KEYWORD_PATTERN:                        "Keyword '{0}' is not a valid RegExp pattern: {1}",
	    KEYWORD_VALUE_TYPE:                     "Each element of keyword '{0}' array must be a '{1}'",
	    UNKNOWN_FORMAT:                         "There is no validation function for format '{0}'",
	    CUSTOM_MODE_FORCE_PROPERTIES:           "{0} must define at least one property if present",

	    // Remote errors
	    REF_UNRESOLVED:                         "Reference has not been resolved during compilation: {0}",
	    UNRESOLVABLE_REFERENCE:                 "Reference could not be resolved: {0}",
	    SCHEMA_NOT_REACHABLE:                   "Validator was not able to read schema with uri: {0}",
	    SCHEMA_TYPE_EXPECTED:                   "Schema is expected to be of type 'object'",
	    SCHEMA_NOT_AN_OBJECT:                   "Schema is not an object: {0}",
	    ASYNC_TIMEOUT:                          "{0} asynchronous task(s) have timed out after {1} ms",
	    PARENT_SCHEMA_VALIDATION_FAILED:        "Schema failed to validate against its parent schema, see inner errors for details.",
	    REMOTE_NOT_VALID:                       "Remote reference didn't compile successfully: {0}"

	};

	var Utils$2 = {};

	(function (exports) {

		exports.jsonSymbol = Symbol.for("z-schema/json");

		exports.schemaSymbol = Symbol.for("z-schema/schema");

		/**
		 * @param {object} obj
		 *
		 * @returns {string[]}
		 */
		var sortedKeys = exports.sortedKeys = function (obj) {
		    return Object.keys(obj).sort();
		};

		/**
		 *
		 * @param {string} uri
		 *
		 * @returns {boolean}
		 */
		exports.isAbsoluteUri = function (uri) {
		    return /^https?:\/\//.test(uri);
		};

		/**
		 *
		 * @param {string} uri
		 *
		 * @returns {boolean}
		 */
		exports.isRelativeUri = function (uri) {
		    // relative URIs that end with a hash sign, issue #56
		    return /.+#/.test(uri);
		};

		exports.whatIs = function (what) {

		    var to = typeof what;

		    if (to === "object") {
		        if (what === null) {
		            return "null";
		        }
		        if (Array.isArray(what)) {
		            return "array";
		        }
		        return "object"; // typeof what === 'object' && what === Object(what) && !Array.isArray(what);
		    }

		    if (to === "number") {
		        if (Number.isFinite(what)) {
		            if (what % 1 === 0) {
		                return "integer";
		            } else {
		                return "number";
		            }
		        }
		        if (Number.isNaN(what)) {
		            return "not-a-number";
		        }
		        return "unknown-number";
		    }

		    return to; // undefined, boolean, string, function

		};

		/**
		 *
		 * @param {*} json1
		 * @param {*} json2
		 * @param {*} [options]
		 *
		 * @returns {boolean}
		 */
		exports.areEqual = function areEqual(json1, json2, options) {

		    options = options || {};
		    var caseInsensitiveComparison = options.caseInsensitiveComparison || false;

		    // http://json-schema.org/latest/json-schema-core.html#rfc.section.3.6

		    // Two JSON values are said to be equal if and only if:
		    // both are nulls; or
		    // both are booleans, and have the same value; or
		    // both are strings, and have the same value; or
		    // both are numbers, and have the same mathematical value; or
		    if (json1 === json2) {
		        return true;
		    }
		    if (
		      caseInsensitiveComparison === true &&
		      typeof json1 === "string" && typeof json2 === "string" &&
		      json1.toUpperCase() === json2.toUpperCase()) {
		        return true;
		    }

		    var i, len;

		    // both are arrays, and:
		    if (Array.isArray(json1) && Array.isArray(json2)) {
		        // have the same number of items; and
		        if (json1.length !== json2.length) {
		            return false;
		        }
		        // items at the same index are equal according to this definition; or
		        len = json1.length;
		        for (i = 0; i < len; i++) {
		            if (!areEqual(json1[i], json2[i], { caseInsensitiveComparison: caseInsensitiveComparison })) {
		                return false;
		            }
		        }
		        return true;
		    }

		    // both are objects, and:
		    if (exports.whatIs(json1) === "object" && exports.whatIs(json2) === "object") {
		        // have the same set of property names; and
		        var keys1 = sortedKeys(json1);
		        var keys2 = sortedKeys(json2);
		        if (!areEqual(keys1, keys2, { caseInsensitiveComparison: caseInsensitiveComparison })) {
		            return false;
		        }
		        // values for a same property name are equal according to this definition.
		        len = keys1.length;
		        for (i = 0; i < len; i++) {
		            if (!areEqual(json1[keys1[i]], json2[keys1[i]], { caseInsensitiveComparison: caseInsensitiveComparison })) {
		                return false;
		            }
		        }
		        return true;
		    }

		    return false;
		};

		/**
		 *
		 * @param {*[]} arr
		 * @param {number[]} [indexes]
		 *
		 * @returns {boolean}
		 */
		exports.isUniqueArray = function (arr, indexes) {
		    var i, j, l = arr.length;
		    for (i = 0; i < l; i++) {
		        for (j = i + 1; j < l; j++) {
		            if (exports.areEqual(arr[i], arr[j])) {
		                if (indexes) { indexes.push(i, j); }
		                return false;
		            }
		        }
		    }
		    return true;
		};

		/**
		 *
		 * @param {*} bigSet
		 * @param {*} subSet
		 *
		 * @returns {*[]}
		 */
		exports.difference = function (bigSet, subSet) {
		    var arr = [],
		        idx = bigSet.length;
		    while (idx--) {
		        if (subSet.indexOf(bigSet[idx]) === -1) {
		            arr.push(bigSet[idx]);
		        }
		    }
		    return arr;
		};

		// NOT a deep version of clone
		exports.clone = function (src) {
		    if (typeof src === "undefined") { return void 0; }
		    if (typeof src !== "object" || src === null) { return src; }
		    var res, idx;
		    if (Array.isArray(src)) {
		        res = [];
		        idx = src.length;
		        while (idx--) {
		            res[idx] = src[idx];
		        }
		    } else {
		        res = {};
		        var keys = Object.keys(src);
		        idx = keys.length;
		        while (idx--) {
		            var key = keys[idx];
		            res[key] = src[key];
		        }
		    }
		    return res;
		};

		exports.cloneDeep = function (src) {
		    var vidx = 0, visited = new Map(), cloned = [];
		    function cloneDeep(src) {
		        if (typeof src !== "object" || src === null) { return src; }
		        var res, idx, cidx;

		        cidx = visited.get(src);
		        if (cidx !== undefined) { return cloned[cidx]; }

		        visited.set(src, vidx++);
		        if (Array.isArray(src)) {
		            res = [];
		            cloned.push(res);
		            idx = src.length;
		            while (idx--) {
		                res[idx] = cloneDeep(src[idx]);
		            }
		        } else {
		            res = {};
		            cloned.push(res);
		            var keys = Object.keys(src);
		            idx = keys.length;
		            while (idx--) {
		                var key = keys[idx];
		                res[key] = cloneDeep(src[key]);
		            }
		        }
		        return res;
		    }
		    return cloneDeep(src);
		};

		/*
		  following function comes from punycode.js library
		  see: https://github.com/bestiejs/punycode.js
		*/
		/*jshint -W016*/
		/**
		 * Creates an array containing the numeric code points of each Unicode
		 * character in the string. While JavaScript uses UCS-2 internally,
		 * this function will convert a pair of surrogate halves (each of which
		 * UCS-2 exposes as separate characters) into a single code point,
		 * matching UTF-16.
		 * @see `punycode.ucs2.encode`
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode.ucs2
		 * @name decode
		 * @param {String} string The Unicode input string (UCS-2).
		 * @returns {Array} The new array of code points.
		 */
		exports.ucs2decode = function (string) {
		    var output = [],
		        counter = 0,
		        length = string.length,
		        value,
		        extra;
		    while (counter < length) {
		        value = string.charCodeAt(counter++);
		        if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
		            // high surrogate, and there is a next character
		            extra = string.charCodeAt(counter++);
		            if ((extra & 0xFC00) == 0xDC00) { // low surrogate
		                output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
		            } else {
		                // unmatched surrogate; only append this code unit, in case the next
		                // code unit is the high surrogate of a surrogate pair
		                output.push(value);
		                counter--;
		            }
		        } else {
		            output.push(value);
		        }
		    }
		    return output;
		};
		/*jshint +W016*/
	} (Utils$2));

	var get$5    = lodash_get;
	var Errors = Errors$1;
	var Utils$1  = Utils$2;

	/**
	 * @class
	 *
	 * @param {Report|object} parentOrOptions
	 * @param {object} [reportOptions]
	 */
	function Report$1(parentOrOptions, reportOptions) {
	    this.parentReport = parentOrOptions instanceof Report$1 ?
	                            parentOrOptions :
	                            undefined;

	    this.options = parentOrOptions instanceof Report$1 ?
	                       parentOrOptions.options :
	                       parentOrOptions || {};

	    this.reportOptions = reportOptions || {};

	    this.errors = [];
	    /**
	     * @type {string[]}
	     */
	    this.path = [];
	    this.asyncTasks = [];

	    this.rootSchema = undefined;
	    this.commonErrorMessage = undefined;
	    this.json = undefined;
	}

	/**
	 * @returns {boolean}
	 */
	Report$1.prototype.isValid = function () {
	    if (this.asyncTasks.length > 0) {
	        throw new Error("Async tasks pending, can't answer isValid");
	    }
	    return this.errors.length === 0;
	};

	/**
	 *
	 * @param {*} fn
	 * @param {*} args
	 * @param {*} asyncTaskResultProcessFn
	 */
	Report$1.prototype.addAsyncTask = function (fn, args, asyncTaskResultProcessFn) {
	    this.asyncTasks.push([fn, args, asyncTaskResultProcessFn]);
	};

	Report$1.prototype.getAncestor = function (id) {
	    if (!this.parentReport) {
	        return undefined;
	    }
	    if (this.parentReport.getSchemaId() === id) {
	        return this.parentReport;
	    }
	    return this.parentReport.getAncestor(id);
	};

	/**
	 *
	 * @param {*} timeout
	 * @param {function(*, *)} callback
	 *
	 * @returns {void}
	 */
	Report$1.prototype.processAsyncTasks = function (timeout, callback) {

	    var validationTimeout = timeout || 2000,
	        tasksCount        = this.asyncTasks.length,
	        idx               = tasksCount,
	        timedOut          = false,
	        self              = this;

	    function finish() {
	        browser$1.nextTick(function () {
	            var valid = self.errors.length === 0,
	                err = valid ? null : self.errors;
	            callback(err, valid);
	        });
	    }

	    function respond(asyncTaskResultProcessFn) {
	        return function (asyncTaskResult) {
	            if (timedOut) { return; }
	            asyncTaskResultProcessFn(asyncTaskResult);
	            if (--tasksCount === 0) {
	                finish();
	            }
	        };
	    }

	    // finish if tasks are completed or there are any errors and breaking on first error was requested
	    if (tasksCount === 0 || (this.errors.length > 0 && this.options.breakOnFirstError)) {
	        finish();
	        return;
	    }

	    while (idx--) {
	        var task = this.asyncTasks[idx];
	        task[0].apply(null, task[1].concat(respond(task[2])));
	    }

	    setTimeout(function () {
	        if (tasksCount > 0) {
	            timedOut = true;
	            self.addError("ASYNC_TIMEOUT", [tasksCount, validationTimeout]);
	            callback(self.errors, false);
	        }
	    }, validationTimeout);

	};

	/**
	 *
	 * @param {*} returnPathAsString
	 *
	 * @return {string[]|string}
	 */
	Report$1.prototype.getPath = function (returnPathAsString) {
	    /**
	     * @type {string[]|string}
	     */
	    var path = [];
	    if (this.parentReport) {
	        path = path.concat(this.parentReport.path);
	    }
	    path = path.concat(this.path);

	    if (returnPathAsString !== true) {
	        // Sanitize the path segments (http://tools.ietf.org/html/rfc6901#section-4)
	        path = "#/" + path.map(function (segment) {
	            segment = segment.toString();

	            if (Utils$1.isAbsoluteUri(segment)) {
	                return "uri(" + segment + ")";
	            }

	            return segment.replace(/\~/g, "~0").replace(/\//g, "~1");
	        }).join("/");
	    }
	    return path;
	};

	Report$1.prototype.getSchemaId = function () {

	    if (!this.rootSchema) {
	        return null;
	    }

	    // get the error path as an array
	    var path = [];
	    if (this.parentReport) {
	        path = path.concat(this.parentReport.path);
	    }
	    path = path.concat(this.path);

	    // try to find id in the error path
	    while (path.length > 0) {
	        var obj = get$5(this.rootSchema, path);
	        if (obj && obj.id) { return obj.id; }
	        path.pop();
	    }

	    // return id of the root
	    return this.rootSchema.id;
	};

	/**
	 *
	 * @param {*} errorCode
	 * @param {*} params
	 *
	 * @return {boolean}
	 */
	Report$1.prototype.hasError = function (errorCode, params) {
	    var idx = this.errors.length;
	    while (idx--) {
	        if (this.errors[idx].code === errorCode) {
	            // assume match
	            var match = true;

	            // check the params too
	            var idx2 = this.errors[idx].params.length;
	            while (idx2--) {
	                if (this.errors[idx].params[idx2] !== params[idx2]) {
	                    match = false;
	                }
	            }

	            // if match, return true
	            if (match) { return match; }
	        }
	    }
	    return false;
	};

	/**
	 *
	 * @param {*} errorCode
	 * @param {*} params
	 * @param {Report[]|Report} [subReports]
	 * @param {*} [schema]
	 *
	 * @return {void}
	 */
	Report$1.prototype.addError = function (errorCode, params, subReports, schema) {
	    if (!errorCode) { throw new Error("No errorCode passed into addError()"); }

	    this.addCustomError(errorCode, Errors[errorCode], params, subReports, schema);
	};

	Report$1.prototype.getJson = function () {
	    var self = this;
	    while (self.json === undefined) {
	        self = self.parentReport;
	        if (self === undefined) {
	            return undefined;
	        }
	    }
	    return self.json;
	};

	/**
	 *
	 * @param {*} errorCode
	 * @param {*} errorMessage
	 * @param {*[]} params
	 * @param {Report[]|Report} subReports
	 * @param {*} schema
	 *
	 * @returns {void}
	 */
	Report$1.prototype.addCustomError = function (errorCode, errorMessage, params, subReports, schema) {
	    if (this.errors.length >= this.reportOptions.maxErrors) {
	        return;
	    }

	    if (!errorMessage) { throw new Error("No errorMessage known for code " + errorCode); }

	    params = params || [];

	    var idx = params.length;
	    while (idx--) {
	        var whatIs = Utils$1.whatIs(params[idx]);
	        var param = (whatIs === "object" || whatIs === "null") ? JSON.stringify(params[idx]) : params[idx];
	        errorMessage = errorMessage.replace("{" + idx + "}", param);
	    }

	    var err = {
	        code: errorCode,
	        params: params,
	        message: errorMessage,
	        path: this.getPath(this.options.reportPathAsArray),
	        schemaId: this.getSchemaId()
	    };

	    err[Utils$1.schemaSymbol] = schema;
	    err[Utils$1.jsonSymbol] = this.getJson();

	    if (schema && typeof schema === "string") {
	        err.description = schema;
	    } else if (schema && typeof schema === "object") {
	        if (schema.title) {
	            err.title = schema.title;
	        }
	        if (schema.description) {
	            err.description = schema.description;
	        }
	    }

	    if (subReports != null) {
	        if (!Array.isArray(subReports)) {
	            subReports = [subReports];
	        }
	        err.inner = [];
	        idx = subReports.length;
	        while (idx--) {
	            var subReport = subReports[idx],
	                idx2 = subReport.errors.length;
	            while (idx2--) {
	                err.inner.push(subReport.errors[idx2]);
	            }
	        }
	        if (err.inner.length === 0) {
	            err.inner = undefined;
	        }
	    }

	    this.errors.push(err);
	};

	var Report_1 = Report$1;

	var validatorExports = {};
	var validator$1 = {
	  get exports(){ return validatorExports; },
	  set exports(v){ validatorExports = v; },
	};

	var toDateExports = {};
	var toDate = {
	  get exports(){ return toDateExports; },
	  set exports(v){ toDateExports = v; },
	};

	var assertStringExports = {};
	var assertString = {
	  get exports(){ return assertStringExports; },
	  set exports(v){ assertStringExports = v; },
	};

	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = assertString;

		function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

		function assertString(input) {
		  var isString = typeof input === 'string' || input instanceof String;

		  if (!isString) {
		    var invalidType = _typeof(input);

		    if (input === null) invalidType = 'null';else if (invalidType === 'object') invalidType = input.constructor.name;
		    throw new TypeError("Expected a string but received a ".concat(invalidType));
		  }
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
	} (assertString, assertStringExports));

	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = toDate;

		var _assertString = _interopRequireDefault(assertStringExports);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		function toDate(date) {
		  (0, _assertString.default)(date);
		  date = Date.parse(date);
		  return !isNaN(date) ? new Date(date) : null;
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
	} (toDate, toDateExports));

	var toFloatExports = {};
	var toFloat = {
	  get exports(){ return toFloatExports; },
	  set exports(v){ toFloatExports = v; },
	};

	var isFloat$2 = {};

	var alpha$1 = {};

	Object.defineProperty(alpha$1, "__esModule", {
	  value: true
	});
	alpha$1.commaDecimal = alpha$1.dotDecimal = alpha$1.farsiLocales = alpha$1.arabicLocales = alpha$1.englishLocales = alpha$1.decimal = alpha$1.alphanumeric = alpha$1.alpha = void 0;
	var alpha = {
	  'en-US': /^[A-Z]+$/i,
	  'az-AZ': /^[A-VXYZÇƏĞİıÖŞÜ]+$/i,
	  'bg-BG': /^[А-Я]+$/i,
	  'cs-CZ': /^[A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]+$/i,
	  'da-DK': /^[A-ZÆØÅ]+$/i,
	  'de-DE': /^[A-ZÄÖÜß]+$/i,
	  'el-GR': /^[Α-ώ]+$/i,
	  'es-ES': /^[A-ZÁÉÍÑÓÚÜ]+$/i,
	  'fa-IR': /^[ابپتثجچحخدذرزژسشصضطظعغفقکگلمنوهی]+$/i,
	  'fi-FI': /^[A-ZÅÄÖ]+$/i,
	  'fr-FR': /^[A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]+$/i,
	  'it-IT': /^[A-ZÀÉÈÌÎÓÒÙ]+$/i,
	  'nb-NO': /^[A-ZÆØÅ]+$/i,
	  'nl-NL': /^[A-ZÁÉËÏÓÖÜÚ]+$/i,
	  'nn-NO': /^[A-ZÆØÅ]+$/i,
	  'hu-HU': /^[A-ZÁÉÍÓÖŐÚÜŰ]+$/i,
	  'pl-PL': /^[A-ZĄĆĘŚŁŃÓŻŹ]+$/i,
	  'pt-PT': /^[A-ZÃÁÀÂÄÇÉÊËÍÏÕÓÔÖÚÜ]+$/i,
	  'ru-RU': /^[А-ЯЁ]+$/i,
	  'sl-SI': /^[A-ZČĆĐŠŽ]+$/i,
	  'sk-SK': /^[A-ZÁČĎÉÍŇÓŠŤÚÝŽĹŔĽÄÔ]+$/i,
	  'sr-RS@latin': /^[A-ZČĆŽŠĐ]+$/i,
	  'sr-RS': /^[А-ЯЂЈЉЊЋЏ]+$/i,
	  'sv-SE': /^[A-ZÅÄÖ]+$/i,
	  'th-TH': /^[ก-๐\s]+$/i,
	  'tr-TR': /^[A-ZÇĞİıÖŞÜ]+$/i,
	  'uk-UA': /^[А-ЩЬЮЯЄIЇҐі]+$/i,
	  'vi-VN': /^[A-ZÀÁẠẢÃÂẦẤẬẨẪĂẰẮẶẲẴĐÈÉẸẺẼÊỀẾỆỂỄÌÍỊỈĨÒÓỌỎÕÔỒỐỘỔỖƠỜỚỢỞỠÙÚỤỦŨƯỪỨỰỬỮỲÝỴỶỸ]+$/i,
	  'ku-IQ': /^[ئابپتجچحخدرڕزژسشعغفڤقکگلڵمنوۆھەیێيطؤثآإأكضصةظذ]+$/i,
	  ar: /^[ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]+$/,
	  he: /^[א-ת]+$/,
	  fa: /^['آاءأؤئبپتثجچحخدذرزژسشصضطظعغفقکگلمنوهةی']+$/i,
	  'hi-IN': /^[\u0900-\u0961]+[\u0972-\u097F]*$/i
	};
	alpha$1.alpha = alpha;
	var alphanumeric = {
	  'en-US': /^[0-9A-Z]+$/i,
	  'az-AZ': /^[0-9A-VXYZÇƏĞİıÖŞÜ]+$/i,
	  'bg-BG': /^[0-9А-Я]+$/i,
	  'cs-CZ': /^[0-9A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]+$/i,
	  'da-DK': /^[0-9A-ZÆØÅ]+$/i,
	  'de-DE': /^[0-9A-ZÄÖÜß]+$/i,
	  'el-GR': /^[0-9Α-ω]+$/i,
	  'es-ES': /^[0-9A-ZÁÉÍÑÓÚÜ]+$/i,
	  'fi-FI': /^[0-9A-ZÅÄÖ]+$/i,
	  'fr-FR': /^[0-9A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]+$/i,
	  'it-IT': /^[0-9A-ZÀÉÈÌÎÓÒÙ]+$/i,
	  'hu-HU': /^[0-9A-ZÁÉÍÓÖŐÚÜŰ]+$/i,
	  'nb-NO': /^[0-9A-ZÆØÅ]+$/i,
	  'nl-NL': /^[0-9A-ZÁÉËÏÓÖÜÚ]+$/i,
	  'nn-NO': /^[0-9A-ZÆØÅ]+$/i,
	  'pl-PL': /^[0-9A-ZĄĆĘŚŁŃÓŻŹ]+$/i,
	  'pt-PT': /^[0-9A-ZÃÁÀÂÄÇÉÊËÍÏÕÓÔÖÚÜ]+$/i,
	  'ru-RU': /^[0-9А-ЯЁ]+$/i,
	  'sl-SI': /^[0-9A-ZČĆĐŠŽ]+$/i,
	  'sk-SK': /^[0-9A-ZÁČĎÉÍŇÓŠŤÚÝŽĹŔĽÄÔ]+$/i,
	  'sr-RS@latin': /^[0-9A-ZČĆŽŠĐ]+$/i,
	  'sr-RS': /^[0-9А-ЯЂЈЉЊЋЏ]+$/i,
	  'sv-SE': /^[0-9A-ZÅÄÖ]+$/i,
	  'th-TH': /^[ก-๙\s]+$/i,
	  'tr-TR': /^[0-9A-ZÇĞİıÖŞÜ]+$/i,
	  'uk-UA': /^[0-9А-ЩЬЮЯЄIЇҐі]+$/i,
	  'ku-IQ': /^[٠١٢٣٤٥٦٧٨٩0-9ئابپتجچحخدرڕزژسشعغفڤقکگلڵمنوۆھەیێيطؤثآإأكضصةظذ]+$/i,
	  'vi-VN': /^[0-9A-ZÀÁẠẢÃÂẦẤẬẨẪĂẰẮẶẲẴĐÈÉẸẺẼÊỀẾỆỂỄÌÍỊỈĨÒÓỌỎÕÔỒỐỘỔỖƠỜỚỢỞỠÙÚỤỦŨƯỪỨỰỬỮỲÝỴỶỸ]+$/i,
	  ar: /^[٠١٢٣٤٥٦٧٨٩0-9ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]+$/,
	  he: /^[0-9א-ת]+$/,
	  fa: /^['0-9آاءأؤئبپتثجچحخدذرزژسشصضطظعغفقکگلمنوهةی۱۲۳۴۵۶۷۸۹۰']+$/i,
	  'hi-IN': /^[\u0900-\u0963]+[\u0966-\u097F]*$/i
	};
	alpha$1.alphanumeric = alphanumeric;
	var decimal = {
	  'en-US': '.',
	  ar: '٫'
	};
	alpha$1.decimal = decimal;
	var englishLocales = ['AU', 'GB', 'HK', 'IN', 'NZ', 'ZA', 'ZM'];
	alpha$1.englishLocales = englishLocales;

	for (var locale, i$1 = 0; i$1 < englishLocales.length; i$1++) {
	  locale = "en-".concat(englishLocales[i$1]);
	  alpha[locale] = alpha['en-US'];
	  alphanumeric[locale] = alphanumeric['en-US'];
	  decimal[locale] = decimal['en-US'];
	} // Source: http://www.localeplanet.com/java/


	var arabicLocales = ['AE', 'BH', 'DZ', 'EG', 'IQ', 'JO', 'KW', 'LB', 'LY', 'MA', 'QM', 'QA', 'SA', 'SD', 'SY', 'TN', 'YE'];
	alpha$1.arabicLocales = arabicLocales;

	for (var _locale, _i = 0; _i < arabicLocales.length; _i++) {
	  _locale = "ar-".concat(arabicLocales[_i]);
	  alpha[_locale] = alpha.ar;
	  alphanumeric[_locale] = alphanumeric.ar;
	  decimal[_locale] = decimal.ar;
	}

	var farsiLocales = ['IR', 'AF'];
	alpha$1.farsiLocales = farsiLocales;

	for (var _locale2, _i2 = 0; _i2 < farsiLocales.length; _i2++) {
	  _locale2 = "fa-".concat(farsiLocales[_i2]);
	  alphanumeric[_locale2] = alphanumeric.fa;
	  decimal[_locale2] = decimal.ar;
	} // Source: https://en.wikipedia.org/wiki/Decimal_mark


	var dotDecimal = ['ar-EG', 'ar-LB', 'ar-LY'];
	alpha$1.dotDecimal = dotDecimal;
	var commaDecimal = ['bg-BG', 'cs-CZ', 'da-DK', 'de-DE', 'el-GR', 'en-ZM', 'es-ES', 'fr-CA', 'fr-FR', 'id-ID', 'it-IT', 'ku-IQ', 'hi-IN', 'hu-HU', 'nb-NO', 'nn-NO', 'nl-NL', 'pl-PL', 'pt-PT', 'ru-RU', 'sl-SI', 'sr-RS@latin', 'sr-RS', 'sv-SE', 'tr-TR', 'uk-UA', 'vi-VN'];
	alpha$1.commaDecimal = commaDecimal;

	for (var _i3 = 0; _i3 < dotDecimal.length; _i3++) {
	  decimal[dotDecimal[_i3]] = decimal['en-US'];
	}

	for (var _i4 = 0; _i4 < commaDecimal.length; _i4++) {
	  decimal[commaDecimal[_i4]] = ',';
	}

	alpha['fr-CA'] = alpha['fr-FR'];
	alphanumeric['fr-CA'] = alphanumeric['fr-FR'];
	alpha['pt-BR'] = alpha['pt-PT'];
	alphanumeric['pt-BR'] = alphanumeric['pt-PT'];
	decimal['pt-BR'] = decimal['pt-PT']; // see #862

	alpha['pl-Pl'] = alpha['pl-PL'];
	alphanumeric['pl-Pl'] = alphanumeric['pl-PL'];
	decimal['pl-Pl'] = decimal['pl-PL']; // see #1455

	alpha['fa-AF'] = alpha.fa;

	Object.defineProperty(isFloat$2, "__esModule", {
	  value: true
	});
	isFloat$2.default = isFloat$1;
	isFloat$2.locales = void 0;

	var _assertString$a = _interopRequireDefault$a(assertStringExports);

	var _alpha$2 = alpha$1;

	function _interopRequireDefault$a(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function isFloat$1(str, options) {
	  (0, _assertString$a.default)(str);
	  options = options || {};
	  var float = new RegExp("^(?:[-+])?(?:[0-9]+)?(?:\\".concat(options.locale ? _alpha$2.decimal[options.locale] : '.', "[0-9]*)?(?:[eE][\\+\\-]?(?:[0-9]+))?$"));

	  if (str === '' || str === '.' || str === '-' || str === '+') {
	    return false;
	  }

	  var value = parseFloat(str.replace(',', '.'));
	  return float.test(str) && (!options.hasOwnProperty('min') || value >= options.min) && (!options.hasOwnProperty('max') || value <= options.max) && (!options.hasOwnProperty('lt') || value < options.lt) && (!options.hasOwnProperty('gt') || value > options.gt);
	}

	var locales$5 = Object.keys(_alpha$2.decimal);
	isFloat$2.locales = locales$5;

	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = toFloat;

		var _isFloat = _interopRequireDefault(isFloat$2);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		function toFloat(str) {
		  if (!(0, _isFloat.default)(str)) return NaN;
		  return parseFloat(str);
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
	} (toFloat, toFloatExports));

	var toIntExports = {};
	var toInt = {
	  get exports(){ return toIntExports; },
	  set exports(v){ toIntExports = v; },
	};

	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = toInt;

		var _assertString = _interopRequireDefault(assertStringExports);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		function toInt(str, radix) {
		  (0, _assertString.default)(str);
		  return parseInt(str, radix || 10);
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
	} (toInt, toIntExports));

	var toBooleanExports = {};
	var toBoolean = {
	  get exports(){ return toBooleanExports; },
	  set exports(v){ toBooleanExports = v; },
	};

	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = toBoolean;

		var _assertString = _interopRequireDefault(assertStringExports);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		function toBoolean(str, strict) {
		  (0, _assertString.default)(str);

		  if (strict) {
		    return str === '1' || /^true$/i.test(str);
		  }

		  return str !== '0' && !/^false$/i.test(str) && str !== '';
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
	} (toBoolean, toBooleanExports));

	var equalsExports = {};
	var equals = {
	  get exports(){ return equalsExports; },
	  set exports(v){ equalsExports = v; },
	};

	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = equals;

		var _assertString = _interopRequireDefault(assertStringExports);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		function equals(str, comparison) {
		  (0, _assertString.default)(str);
		  return str === comparison;
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
	} (equals, equalsExports));

	var containsExports = {};
	var contains = {
	  get exports(){ return containsExports; },
	  set exports(v){ containsExports = v; },
	};

	var toStringExports = {};
	var toString$2 = {
	  get exports(){ return toStringExports; },
	  set exports(v){ toStringExports = v; },
	};

	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = toString;

		function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

		function toString(input) {
		  if (_typeof(input) === 'object' && input !== null) {
		    if (typeof input.toString === 'function') {
		      input = input.toString();
		    } else {
		      input = '[object Object]';
		    }
		  } else if (input === null || typeof input === 'undefined' || isNaN(input) && !input.length) {
		    input = '';
		  }

		  return String(input);
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
	} (toString$2, toStringExports));

	var mergeExports = {};
	var merge$2 = {
	  get exports(){ return mergeExports; },
	  set exports(v){ mergeExports = v; },
	};

	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = merge;

		function merge() {
		  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
		  var defaults = arguments.length > 1 ? arguments[1] : undefined;

		  for (var key in defaults) {
		    if (typeof obj[key] === 'undefined') {
		      obj[key] = defaults[key];
		    }
		  }

		  return obj;
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
	} (merge$2, mergeExports));

	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = contains;

		var _assertString = _interopRequireDefault(assertStringExports);

		var _toString = _interopRequireDefault(toStringExports);

		var _merge = _interopRequireDefault(mergeExports);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		var defaulContainsOptions = {
		  ignoreCase: false,
		  minOccurrences: 1
		};

		function contains(str, elem, options) {
		  (0, _assertString.default)(str);
		  options = (0, _merge.default)(options, defaulContainsOptions);

		  if (options.ignoreCase) {
		    return str.toLowerCase().split((0, _toString.default)(elem).toLowerCase()).length > options.minOccurrences;
		  }

		  return str.split((0, _toString.default)(elem)).length > options.minOccurrences;
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
	} (contains, containsExports));

	var matchesExports = {};
	var matches = {
	  get exports(){ return matchesExports; },
	  set exports(v){ matchesExports = v; },
	};

	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = matches;

		var _assertString = _interopRequireDefault(assertStringExports);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		function matches(str, pattern, modifiers) {
		  (0, _assertString.default)(str);

		  if (Object.prototype.toString.call(pattern) !== '[object RegExp]') {
		    pattern = new RegExp(pattern, modifiers);
		  }

		  return pattern.test(str);
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
	} (matches, matchesExports));

	var isEmailExports = {};
	var isEmail = {
	  get exports(){ return isEmailExports; },
	  set exports(v){ isEmailExports = v; },
	};

	var isByteLengthExports = {};
	var isByteLength = {
	  get exports(){ return isByteLengthExports; },
	  set exports(v){ isByteLengthExports = v; },
	};

	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = isByteLength;

		var _assertString = _interopRequireDefault(assertStringExports);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

		/* eslint-disable prefer-rest-params */
		function isByteLength(str, options) {
		  (0, _assertString.default)(str);
		  var min;
		  var max;

		  if (_typeof(options) === 'object') {
		    min = options.min || 0;
		    max = options.max;
		  } else {
		    // backwards compatibility: isByteLength(str, min [, max])
		    min = arguments[1];
		    max = arguments[2];
		  }

		  var len = encodeURI(str).split(/%..|./).length - 1;
		  return len >= min && (typeof max === 'undefined' || len <= max);
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
	} (isByteLength, isByteLengthExports));

	var isFQDNExports = {};
	var isFQDN = {
	  get exports(){ return isFQDNExports; },
	  set exports(v){ isFQDNExports = v; },
	};

	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = isFQDN;

		var _assertString = _interopRequireDefault(assertStringExports);

		var _merge = _interopRequireDefault(mergeExports);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		var default_fqdn_options = {
		  require_tld: true,
		  allow_underscores: false,
		  allow_trailing_dot: false,
		  allow_numeric_tld: false,
		  allow_wildcard: false
		};

		function isFQDN(str, options) {
		  (0, _assertString.default)(str);
		  options = (0, _merge.default)(options, default_fqdn_options);
		  /* Remove the optional trailing dot before checking validity */

		  if (options.allow_trailing_dot && str[str.length - 1] === '.') {
		    str = str.substring(0, str.length - 1);
		  }
		  /* Remove the optional wildcard before checking validity */


		  if (options.allow_wildcard === true && str.indexOf('*.') === 0) {
		    str = str.substring(2);
		  }

		  var parts = str.split('.');
		  var tld = parts[parts.length - 1];

		  if (options.require_tld) {
		    // disallow fqdns without tld
		    if (parts.length < 2) {
		      return false;
		    }

		    if (!/^([a-z\u00A1-\u00A8\u00AA-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}|xn[a-z0-9-]{2,})$/i.test(tld)) {
		      return false;
		    } // disallow spaces


		    if (/\s/.test(tld)) {
		      return false;
		    }
		  } // reject numeric TLDs


		  if (!options.allow_numeric_tld && /^\d+$/.test(tld)) {
		    return false;
		  }

		  return parts.every(function (part) {
		    if (part.length > 63) {
		      return false;
		    }

		    if (!/^[a-z_\u00a1-\uffff0-9-]+$/i.test(part)) {
		      return false;
		    } // disallow full-width chars


		    if (/[\uff01-\uff5e]/.test(part)) {
		      return false;
		    } // disallow parts starting or ending with hyphen


		    if (/^-|-$/.test(part)) {
		      return false;
		    }

		    if (!options.allow_underscores && /_/.test(part)) {
		      return false;
		    }

		    return true;
		  });
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
	} (isFQDN, isFQDNExports));

	var isIPExports = {};
	var isIP = {
	  get exports(){ return isIPExports; },
	  set exports(v){ isIPExports = v; },
	};

	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = isIP;

		var _assertString = _interopRequireDefault(assertStringExports);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		/**
		11.3.  Examples

		   The following addresses

		             fe80::1234 (on the 1st link of the node)
		             ff02::5678 (on the 5th link of the node)
		             ff08::9abc (on the 10th organization of the node)

		   would be represented as follows:

		             fe80::1234%1
		             ff02::5678%5
		             ff08::9abc%10

		   (Here we assume a natural translation from a zone index to the
		   <zone_id> part, where the Nth zone of any scope is translated into
		   "N".)

		   If we use interface names as <zone_id>, those addresses could also be
		   represented as follows:

		            fe80::1234%ne0
		            ff02::5678%pvc1.3
		            ff08::9abc%interface10

		   where the interface "ne0" belongs to the 1st link, "pvc1.3" belongs
		   to the 5th link, and "interface10" belongs to the 10th organization.
		 * * */
		var IPv4SegmentFormat = '(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])';
		var IPv4AddressFormat = "(".concat(IPv4SegmentFormat, "[.]){3}").concat(IPv4SegmentFormat);
		var IPv4AddressRegExp = new RegExp("^".concat(IPv4AddressFormat, "$"));
		var IPv6SegmentFormat = '(?:[0-9a-fA-F]{1,4})';
		var IPv6AddressRegExp = new RegExp('^(' + "(?:".concat(IPv6SegmentFormat, ":){7}(?:").concat(IPv6SegmentFormat, "|:)|") + "(?:".concat(IPv6SegmentFormat, ":){6}(?:").concat(IPv4AddressFormat, "|:").concat(IPv6SegmentFormat, "|:)|") + "(?:".concat(IPv6SegmentFormat, ":){5}(?::").concat(IPv4AddressFormat, "|(:").concat(IPv6SegmentFormat, "){1,2}|:)|") + "(?:".concat(IPv6SegmentFormat, ":){4}(?:(:").concat(IPv6SegmentFormat, "){0,1}:").concat(IPv4AddressFormat, "|(:").concat(IPv6SegmentFormat, "){1,3}|:)|") + "(?:".concat(IPv6SegmentFormat, ":){3}(?:(:").concat(IPv6SegmentFormat, "){0,2}:").concat(IPv4AddressFormat, "|(:").concat(IPv6SegmentFormat, "){1,4}|:)|") + "(?:".concat(IPv6SegmentFormat, ":){2}(?:(:").concat(IPv6SegmentFormat, "){0,3}:").concat(IPv4AddressFormat, "|(:").concat(IPv6SegmentFormat, "){1,5}|:)|") + "(?:".concat(IPv6SegmentFormat, ":){1}(?:(:").concat(IPv6SegmentFormat, "){0,4}:").concat(IPv4AddressFormat, "|(:").concat(IPv6SegmentFormat, "){1,6}|:)|") + "(?::((?::".concat(IPv6SegmentFormat, "){0,5}:").concat(IPv4AddressFormat, "|(?::").concat(IPv6SegmentFormat, "){1,7}|:))") + ')(%[0-9a-zA-Z-.:]{1,})?$');

		function isIP(str) {
		  var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
		  (0, _assertString.default)(str);
		  version = String(version);

		  if (!version) {
		    return isIP(str, 4) || isIP(str, 6);
		  }

		  if (version === '4') {
		    if (!IPv4AddressRegExp.test(str)) {
		      return false;
		    }

		    var parts = str.split('.').sort(function (a, b) {
		      return a - b;
		    });
		    return parts[3] <= 255;
		  }

		  if (version === '6') {
		    return !!IPv6AddressRegExp.test(str);
		  }

		  return false;
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
	} (isIP, isIPExports));

	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = isEmail;

		var _assertString = _interopRequireDefault(assertStringExports);

		var _merge = _interopRequireDefault(mergeExports);

		var _isByteLength = _interopRequireDefault(isByteLengthExports);

		var _isFQDN = _interopRequireDefault(isFQDNExports);

		var _isIP = _interopRequireDefault(isIPExports);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		var default_email_options = {
		  allow_display_name: false,
		  require_display_name: false,
		  allow_utf8_local_part: true,
		  require_tld: true,
		  blacklisted_chars: '',
		  ignore_max_length: false,
		  host_blacklist: []
		};
		/* eslint-disable max-len */

		/* eslint-disable no-control-regex */

		var splitNameAddress = /^([^\x00-\x1F\x7F-\x9F\cX]+)</i;
		var emailUserPart = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~]+$/i;
		var gmailUserPart = /^[a-z\d]+$/;
		var quotedEmailUser = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f]))*$/i;
		var emailUserUtf8Part = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+$/i;
		var quotedEmailUserUtf8 = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*$/i;
		var defaultMaxEmailLength = 254;
		/* eslint-enable max-len */

		/* eslint-enable no-control-regex */

		/**
		 * Validate display name according to the RFC2822: https://tools.ietf.org/html/rfc2822#appendix-A.1.2
		 * @param {String} display_name
		 */

		function validateDisplayName(display_name) {
		  var display_name_without_quotes = display_name.replace(/^"(.+)"$/, '$1'); // display name with only spaces is not valid

		  if (!display_name_without_quotes.trim()) {
		    return false;
		  } // check whether display name contains illegal character


		  var contains_illegal = /[\.";<>]/.test(display_name_without_quotes);

		  if (contains_illegal) {
		    // if contains illegal characters,
		    // must to be enclosed in double-quotes, otherwise it's not a valid display name
		    if (display_name_without_quotes === display_name) {
		      return false;
		    } // the quotes in display name must start with character symbol \


		    var all_start_with_back_slash = display_name_without_quotes.split('"').length === display_name_without_quotes.split('\\"').length;

		    if (!all_start_with_back_slash) {
		      return false;
		    }
		  }

		  return true;
		}

		function isEmail(str, options) {
		  (0, _assertString.default)(str);
		  options = (0, _merge.default)(options, default_email_options);

		  if (options.require_display_name || options.allow_display_name) {
		    var display_email = str.match(splitNameAddress);

		    if (display_email) {
		      var display_name = display_email[1]; // Remove display name and angle brackets to get email address
		      // Can be done in the regex but will introduce a ReDOS (See  #1597 for more info)

		      str = str.replace(display_name, '').replace(/(^<|>$)/g, ''); // sometimes need to trim the last space to get the display name
		      // because there may be a space between display name and email address
		      // eg. myname <address@gmail.com>
		      // the display name is `myname` instead of `myname `, so need to trim the last space

		      if (display_name.endsWith(' ')) {
		        display_name = display_name.substr(0, display_name.length - 1);
		      }

		      if (!validateDisplayName(display_name)) {
		        return false;
		      }
		    } else if (options.require_display_name) {
		      return false;
		    }
		  }

		  if (!options.ignore_max_length && str.length > defaultMaxEmailLength) {
		    return false;
		  }

		  var parts = str.split('@');
		  var domain = parts.pop();
		  var lower_domain = domain.toLowerCase();

		  if (options.host_blacklist.includes(lower_domain)) {
		    return false;
		  }

		  var user = parts.join('@');

		  if (options.domain_specific_validation && (lower_domain === 'gmail.com' || lower_domain === 'googlemail.com')) {
		    /*
		      Previously we removed dots for gmail addresses before validating.
		      This was removed because it allows `multiple..dots@gmail.com`
		      to be reported as valid, but it is not.
		      Gmail only normalizes single dots, removing them from here is pointless,
		      should be done in normalizeEmail
		    */
		    user = user.toLowerCase(); // Removing sub-address from username before gmail validation

		    var username = user.split('+')[0]; // Dots are not included in gmail length restriction

		    if (!(0, _isByteLength.default)(username.replace(/\./g, ''), {
		      min: 6,
		      max: 30
		    })) {
		      return false;
		    }

		    var _user_parts = username.split('.');

		    for (var i = 0; i < _user_parts.length; i++) {
		      if (!gmailUserPart.test(_user_parts[i])) {
		        return false;
		      }
		    }
		  }

		  if (options.ignore_max_length === false && (!(0, _isByteLength.default)(user, {
		    max: 64
		  }) || !(0, _isByteLength.default)(domain, {
		    max: 254
		  }))) {
		    return false;
		  }

		  if (!(0, _isFQDN.default)(domain, {
		    require_tld: options.require_tld
		  })) {
		    if (!options.allow_ip_domain) {
		      return false;
		    }

		    if (!(0, _isIP.default)(domain)) {
		      if (!domain.startsWith('[') || !domain.endsWith(']')) {
		        return false;
		      }

		      var noBracketdomain = domain.substr(1, domain.length - 2);

		      if (noBracketdomain.length === 0 || !(0, _isIP.default)(noBracketdomain)) {
		        return false;
		      }
		    }
		  }

		  if (user[0] === '"') {
		    user = user.slice(1, user.length - 1);
		    return options.allow_utf8_local_part ? quotedEmailUserUtf8.test(user) : quotedEmailUser.test(user);
		  }

		  var pattern = options.allow_utf8_local_part ? emailUserUtf8Part : emailUserPart;
		  var user_parts = user.split('.');

		  for (var _i = 0; _i < user_parts.length; _i++) {
		    if (!pattern.test(user_parts[_i])) {
		      return false;
		    }
		  }

		  if (options.blacklisted_chars) {
		    if (user.search(new RegExp("[".concat(options.blacklisted_chars, "]+"), 'g')) !== -1) return false;
		  }

		  return true;
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
	} (isEmail, isEmailExports));

	var isURLExports = {};
	var isURL = {
	  get exports(){ return isURLExports; },
	  set exports(v){ isURLExports = v; },
	};

	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = isURL;

		var _assertString = _interopRequireDefault(assertStringExports);

		var _isFQDN = _interopRequireDefault(isFQDNExports);

		var _isIP = _interopRequireDefault(isIPExports);

		var _merge = _interopRequireDefault(mergeExports);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

		function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

		function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

		function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

		function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

		function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

		/*
		options for isURL method

		require_protocol - if set as true isURL will return false if protocol is not present in the URL
		require_valid_protocol - isURL will check if the URL's protocol is present in the protocols option
		protocols - valid protocols can be modified with this option
		require_host - if set as false isURL will not check if host is present in the URL
		require_port - if set as true isURL will check if port is present in the URL
		allow_protocol_relative_urls - if set as true protocol relative URLs will be allowed
		validate_length - if set as false isURL will skip string length validation (IE maximum is 2083)

		*/
		var default_url_options = {
		  protocols: ['http', 'https', 'ftp'],
		  require_tld: true,
		  require_protocol: false,
		  require_host: true,
		  require_port: false,
		  require_valid_protocol: true,
		  allow_underscores: false,
		  allow_trailing_dot: false,
		  allow_protocol_relative_urls: false,
		  allow_fragments: true,
		  allow_query_components: true,
		  validate_length: true
		};
		var wrapped_ipv6 = /^\[([^\]]+)\](?::([0-9]+))?$/;

		function isRegExp(obj) {
		  return Object.prototype.toString.call(obj) === '[object RegExp]';
		}

		function checkHost(host, matches) {
		  for (var i = 0; i < matches.length; i++) {
		    var match = matches[i];

		    if (host === match || isRegExp(match) && match.test(host)) {
		      return true;
		    }
		  }

		  return false;
		}

		function isURL(url, options) {
		  (0, _assertString.default)(url);

		  if (!url || /[\s<>]/.test(url)) {
		    return false;
		  }

		  if (url.indexOf('mailto:') === 0) {
		    return false;
		  }

		  options = (0, _merge.default)(options, default_url_options);

		  if (options.validate_length && url.length >= 2083) {
		    return false;
		  }

		  if (!options.allow_fragments && url.includes('#')) {
		    return false;
		  }

		  if (!options.allow_query_components && (url.includes('?') || url.includes('&'))) {
		    return false;
		  }

		  var protocol, auth, host, hostname, port, port_str, split, ipv6;
		  split = url.split('#');
		  url = split.shift();
		  split = url.split('?');
		  url = split.shift();
		  split = url.split('://');

		  if (split.length > 1) {
		    protocol = split.shift().toLowerCase();

		    if (options.require_valid_protocol && options.protocols.indexOf(protocol) === -1) {
		      return false;
		    }
		  } else if (options.require_protocol) {
		    return false;
		  } else if (url.substr(0, 2) === '//') {
		    if (!options.allow_protocol_relative_urls) {
		      return false;
		    }

		    split[0] = url.substr(2);
		  }

		  url = split.join('://');

		  if (url === '') {
		    return false;
		  }

		  split = url.split('/');
		  url = split.shift();

		  if (url === '' && !options.require_host) {
		    return true;
		  }

		  split = url.split('@');

		  if (split.length > 1) {
		    if (options.disallow_auth) {
		      return false;
		    }

		    if (split[0] === '') {
		      return false;
		    }

		    auth = split.shift();

		    if (auth.indexOf(':') >= 0 && auth.split(':').length > 2) {
		      return false;
		    }

		    var _auth$split = auth.split(':'),
		        _auth$split2 = _slicedToArray(_auth$split, 2),
		        user = _auth$split2[0],
		        password = _auth$split2[1];

		    if (user === '' && password === '') {
		      return false;
		    }
		  }

		  hostname = split.join('@');
		  port_str = null;
		  ipv6 = null;
		  var ipv6_match = hostname.match(wrapped_ipv6);

		  if (ipv6_match) {
		    host = '';
		    ipv6 = ipv6_match[1];
		    port_str = ipv6_match[2] || null;
		  } else {
		    split = hostname.split(':');
		    host = split.shift();

		    if (split.length) {
		      port_str = split.join(':');
		    }
		  }

		  if (port_str !== null && port_str.length > 0) {
		    port = parseInt(port_str, 10);

		    if (!/^[0-9]+$/.test(port_str) || port <= 0 || port > 65535) {
		      return false;
		    }
		  } else if (options.require_port) {
		    return false;
		  }

		  if (options.host_whitelist) {
		    return checkHost(host, options.host_whitelist);
		  }

		  if (!(0, _isIP.default)(host) && !(0, _isFQDN.default)(host, options) && (!ipv6 || !(0, _isIP.default)(ipv6, 6))) {
		    return false;
		  }

		  host = host || ipv6;

		  if (options.host_blacklist && checkHost(host, options.host_blacklist)) {
		    return false;
		  }

		  return true;
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
	} (isURL, isURLExports));

	var isMACAddressExports = {};
	var isMACAddress = {
	  get exports(){ return isMACAddressExports; },
	  set exports(v){ isMACAddressExports = v; },
	};

	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = isMACAddress;

		var _assertString = _interopRequireDefault(assertStringExports);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		var macAddress = /^(?:[0-9a-fA-F]{2}([-:\s]))([0-9a-fA-F]{2}\1){4}([0-9a-fA-F]{2})$/;
		var macAddressNoSeparators = /^([0-9a-fA-F]){12}$/;
		var macAddressWithDots = /^([0-9a-fA-F]{4}\.){2}([0-9a-fA-F]{4})$/;

		function isMACAddress(str, options) {
		  (0, _assertString.default)(str);
		  /**
		   * @deprecated `no_colons` TODO: remove it in the next major
		  */

		  if (options && (options.no_colons || options.no_separators)) {
		    return macAddressNoSeparators.test(str);
		  }

		  return macAddress.test(str) || macAddressWithDots.test(str);
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
	} (isMACAddress, isMACAddressExports));

	var isIPRangeExports = {};
	var isIPRange = {
	  get exports(){ return isIPRangeExports; },
	  set exports(v){ isIPRangeExports = v; },
	};

	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = isIPRange;

		var _assertString = _interopRequireDefault(assertStringExports);

		var _isIP = _interopRequireDefault(isIPExports);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		var subnetMaybe = /^\d{1,3}$/;
		var v4Subnet = 32;
		var v6Subnet = 128;

		function isIPRange(str) {
		  var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
		  (0, _assertString.default)(str);
		  var parts = str.split('/'); // parts[0] -> ip, parts[1] -> subnet

		  if (parts.length !== 2) {
		    return false;
		  }

		  if (!subnetMaybe.test(parts[1])) {
		    return false;
		  } // Disallow preceding 0 i.e. 01, 02, ...


		  if (parts[1].length > 1 && parts[1].startsWith('0')) {
		    return false;
		  }

		  var isValidIP = (0, _isIP.default)(parts[0], version);

		  if (!isValidIP) {
		    return false;
		  } // Define valid subnet according to IP's version


		  var expectedSubnet = null;

		  switch (String(version)) {
		    case '4':
		      expectedSubnet = v4Subnet;
		      break;

		    case '6':
		      expectedSubnet = v6Subnet;
		      break;

		    default:
		      expectedSubnet = (0, _isIP.default)(parts[0], '6') ? v6Subnet : v4Subnet;
		  }

		  return parts[1] <= expectedSubnet && parts[1] >= 0;
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
	} (isIPRange, isIPRangeExports));

	var isDateExports = {};
	var isDate = {
	  get exports(){ return isDateExports; },
	  set exports(v){ isDateExports = v; },
	};

	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = isDate;

		var _merge = _interopRequireDefault(mergeExports);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

		function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

		function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

		function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

		function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

		function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

		function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

		var default_date_options = {
		  format: 'YYYY/MM/DD',
		  delimiters: ['/', '-'],
		  strictMode: false
		};

		function isValidFormat(format) {
		  return /(^(y{4}|y{2})[.\/-](m{1,2})[.\/-](d{1,2})$)|(^(m{1,2})[.\/-](d{1,2})[.\/-]((y{4}|y{2})$))|(^(d{1,2})[.\/-](m{1,2})[.\/-]((y{4}|y{2})$))/gi.test(format);
		}

		function zip(date, format) {
		  var zippedArr = [],
		      len = Math.min(date.length, format.length);

		  for (var i = 0; i < len; i++) {
		    zippedArr.push([date[i], format[i]]);
		  }

		  return zippedArr;
		}

		function isDate(input, options) {
		  if (typeof options === 'string') {
		    // Allow backward compatbility for old format isDate(input [, format])
		    options = (0, _merge.default)({
		      format: options
		    }, default_date_options);
		  } else {
		    options = (0, _merge.default)(options, default_date_options);
		  }

		  if (typeof input === 'string' && isValidFormat(options.format)) {
		    var formatDelimiter = options.delimiters.find(function (delimiter) {
		      return options.format.indexOf(delimiter) !== -1;
		    });
		    var dateDelimiter = options.strictMode ? formatDelimiter : options.delimiters.find(function (delimiter) {
		      return input.indexOf(delimiter) !== -1;
		    });
		    var dateAndFormat = zip(input.split(dateDelimiter), options.format.toLowerCase().split(formatDelimiter));
		    var dateObj = {};

		    var _iterator = _createForOfIteratorHelper(dateAndFormat),
		        _step;

		    try {
		      for (_iterator.s(); !(_step = _iterator.n()).done;) {
		        var _step$value = _slicedToArray(_step.value, 2),
		            dateWord = _step$value[0],
		            formatWord = _step$value[1];

		        if (dateWord.length !== formatWord.length) {
		          return false;
		        }

		        dateObj[formatWord.charAt(0)] = dateWord;
		      }
		    } catch (err) {
		      _iterator.e(err);
		    } finally {
		      _iterator.f();
		    }

		    return new Date("".concat(dateObj.m, "/").concat(dateObj.d, "/").concat(dateObj.y)).getDate() === +dateObj.d;
		  }

		  if (!options.strictMode) {
		    return Object.prototype.toString.call(input) === '[object Date]' && isFinite(input);
		  }

		  return false;
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
	} (isDate, isDateExports));

	var isBooleanExports = {};
	var isBoolean$1 = {
	  get exports(){ return isBooleanExports; },
	  set exports(v){ isBooleanExports = v; },
	};

	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = isBoolean;

		var _assertString = _interopRequireDefault(assertStringExports);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		var defaultOptions = {
		  loose: false
		};
		var strictBooleans = ['true', 'false', '1', '0'];
		var looseBooleans = [].concat(strictBooleans, ['yes', 'no']);

		function isBoolean(str) {
		  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultOptions;
		  (0, _assertString.default)(str);

		  if (options.loose) {
		    return looseBooleans.includes(str.toLowerCase());
		  }

		  return strictBooleans.includes(str);
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
	} (isBoolean$1, isBooleanExports));

	var isLocaleExports = {};
	var isLocale = {
	  get exports(){ return isLocaleExports; },
	  set exports(v){ isLocaleExports = v; },
	};

	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = isLocale;

		var _assertString = _interopRequireDefault(assertStringExports);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		var localeReg = /^[A-Za-z]{2,4}([_-]([A-Za-z]{4}|[\d]{3}))?([_-]([A-Za-z]{2}|[\d]{3}))?$/;

		function isLocale(str) {
		  (0, _assertString.default)(str);

		  if (str === 'en_US_POSIX' || str === 'ca_ES_VALENCIA') {
		    return true;
		  }

		  return localeReg.test(str);
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
	} (isLocale, isLocaleExports));

	var isAlpha$1 = {};

	Object.defineProperty(isAlpha$1, "__esModule", {
	  value: true
	});
	isAlpha$1.default = isAlpha;
	isAlpha$1.locales = void 0;

	var _assertString$9 = _interopRequireDefault$9(assertStringExports);

	var _alpha$1 = alpha$1;

	function _interopRequireDefault$9(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function isAlpha(_str) {
	  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en-US';
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  (0, _assertString$9.default)(_str);
	  var str = _str;
	  var ignore = options.ignore;

	  if (ignore) {
	    if (ignore instanceof RegExp) {
	      str = str.replace(ignore, '');
	    } else if (typeof ignore === 'string') {
	      str = str.replace(new RegExp("[".concat(ignore.replace(/[-[\]{}()*+?.,\\^$|#\\s]/g, '\\$&'), "]"), 'g'), ''); // escape regex for ignore
	    } else {
	      throw new Error('ignore should be instance of a String or RegExp');
	    }
	  }

	  if (locale in _alpha$1.alpha) {
	    return _alpha$1.alpha[locale].test(str);
	  }

	  throw new Error("Invalid locale '".concat(locale, "'"));
	}

	var locales$4 = Object.keys(_alpha$1.alpha);
	isAlpha$1.locales = locales$4;

	var isAlphanumeric$1 = {};

	Object.defineProperty(isAlphanumeric$1, "__esModule", {
	  value: true
	});
	isAlphanumeric$1.default = isAlphanumeric;
	isAlphanumeric$1.locales = void 0;

	var _assertString$8 = _interopRequireDefault$8(assertStringExports);

	var _alpha = alpha$1;

	function _interopRequireDefault$8(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function isAlphanumeric(_str) {
	  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en-US';
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  (0, _assertString$8.default)(_str);
	  var str = _str;
	  var ignore = options.ignore;

	  if (ignore) {
	    if (ignore instanceof RegExp) {
	      str = str.replace(ignore, '');
	    } else if (typeof ignore === 'string') {
	      str = str.replace(new RegExp("[".concat(ignore.replace(/[-[\]{}()*+?.,\\^$|#\\s]/g, '\\$&'), "]"), 'g'), ''); // escape regex for ignore
	    } else {
	      throw new Error('ignore should be instance of a String or RegExp');
	    }
	  }

	  if (locale in _alpha.alphanumeric) {
	    return _alpha.alphanumeric[locale].test(str);
	  }

	  throw new Error("Invalid locale '".concat(locale, "'"));
	}

	var locales$3 = Object.keys(_alpha.alphanumeric);
	isAlphanumeric$1.locales = locales$3;

	var isNumericExports = {};
	var isNumeric = {
	  get exports(){ return isNumericExports; },
	  set exports(v){ isNumericExports = v; },
	};

	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = isNumeric;

		var _assertString = _interopRequireDefault(assertStringExports);

		var _alpha = alpha$1;

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		var numericNoSymbols = /^[0-9]+$/;

		function isNumeric(str, options) {
		  (0, _assertString.default)(str);

		  if (options && options.no_symbols) {
		    return numericNoSymbols.test(str);
		  }

		  return new RegExp("^[+-]?([0-9]*[".concat((options || {}).locale ? _alpha.decimal[options.locale] : '.', "])?[0-9]+$")).test(str);
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
	} (isNumeric, isNumericExports));

	var isPassportNumberExports = {};
	var isPassportNumber = {
	  get exports(){ return isPassportNumberExports; },
	  set exports(v){ isPassportNumberExports = v; },
	};

	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = isPassportNumber;

		var _assertString = _interopRequireDefault(assertStringExports);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		/**
		 * Reference:
		 * https://en.wikipedia.org/ -- Wikipedia
		 * https://docs.microsoft.com/en-us/microsoft-365/compliance/eu-passport-number -- EU Passport Number
		 * https://countrycode.org/ -- Country Codes
		 */
		var passportRegexByCountryCode = {
		  AM: /^[A-Z]{2}\d{7}$/,
		  // ARMENIA
		  AR: /^[A-Z]{3}\d{6}$/,
		  // ARGENTINA
		  AT: /^[A-Z]\d{7}$/,
		  // AUSTRIA
		  AU: /^[A-Z]\d{7}$/,
		  // AUSTRALIA
		  BE: /^[A-Z]{2}\d{6}$/,
		  // BELGIUM
		  BG: /^\d{9}$/,
		  // BULGARIA
		  BR: /^[A-Z]{2}\d{6}$/,
		  // BRAZIL
		  BY: /^[A-Z]{2}\d{7}$/,
		  // BELARUS
		  CA: /^[A-Z]{2}\d{6}$/,
		  // CANADA
		  CH: /^[A-Z]\d{7}$/,
		  // SWITZERLAND
		  CN: /^G\d{8}$|^E(?![IO])[A-Z0-9]\d{7}$/,
		  // CHINA [G=Ordinary, E=Electronic] followed by 8-digits, or E followed by any UPPERCASE letter (except I and O) followed by 7 digits
		  CY: /^[A-Z](\d{6}|\d{8})$/,
		  // CYPRUS
		  CZ: /^\d{8}$/,
		  // CZECH REPUBLIC
		  DE: /^[CFGHJKLMNPRTVWXYZ0-9]{9}$/,
		  // GERMANY
		  DK: /^\d{9}$/,
		  // DENMARK
		  DZ: /^\d{9}$/,
		  // ALGERIA
		  EE: /^([A-Z]\d{7}|[A-Z]{2}\d{7})$/,
		  // ESTONIA (K followed by 7-digits), e-passports have 2 UPPERCASE followed by 7 digits
		  ES: /^[A-Z0-9]{2}([A-Z0-9]?)\d{6}$/,
		  // SPAIN
		  FI: /^[A-Z]{2}\d{7}$/,
		  // FINLAND
		  FR: /^\d{2}[A-Z]{2}\d{5}$/,
		  // FRANCE
		  GB: /^\d{9}$/,
		  // UNITED KINGDOM
		  GR: /^[A-Z]{2}\d{7}$/,
		  // GREECE
		  HR: /^\d{9}$/,
		  // CROATIA
		  HU: /^[A-Z]{2}(\d{6}|\d{7})$/,
		  // HUNGARY
		  IE: /^[A-Z0-9]{2}\d{7}$/,
		  // IRELAND
		  IN: /^[A-Z]{1}-?\d{7}$/,
		  // INDIA
		  ID: /^[A-C]\d{7}$/,
		  // INDONESIA
		  IR: /^[A-Z]\d{8}$/,
		  // IRAN
		  IS: /^(A)\d{7}$/,
		  // ICELAND
		  IT: /^[A-Z0-9]{2}\d{7}$/,
		  // ITALY
		  JP: /^[A-Z]{2}\d{7}$/,
		  // JAPAN
		  KR: /^[MS]\d{8}$/,
		  // SOUTH KOREA, REPUBLIC OF KOREA, [S=PS Passports, M=PM Passports]
		  LT: /^[A-Z0-9]{8}$/,
		  // LITHUANIA
		  LU: /^[A-Z0-9]{8}$/,
		  // LUXEMBURG
		  LV: /^[A-Z0-9]{2}\d{7}$/,
		  // LATVIA
		  LY: /^[A-Z0-9]{8}$/,
		  // LIBYA
		  MT: /^\d{7}$/,
		  // MALTA
		  MZ: /^([A-Z]{2}\d{7})|(\d{2}[A-Z]{2}\d{5})$/,
		  // MOZAMBIQUE
		  MY: /^[AHK]\d{8}$/,
		  // MALAYSIA
		  NL: /^[A-Z]{2}[A-Z0-9]{6}\d$/,
		  // NETHERLANDS
		  PL: /^[A-Z]{2}\d{7}$/,
		  // POLAND
		  PT: /^[A-Z]\d{6}$/,
		  // PORTUGAL
		  RO: /^\d{8,9}$/,
		  // ROMANIA
		  RU: /^\d{9}$/,
		  // RUSSIAN FEDERATION
		  SE: /^\d{8}$/,
		  // SWEDEN
		  SL: /^(P)[A-Z]\d{7}$/,
		  // SLOVANIA
		  SK: /^[0-9A-Z]\d{7}$/,
		  // SLOVAKIA
		  TR: /^[A-Z]\d{8}$/,
		  // TURKEY
		  UA: /^[A-Z]{2}\d{6}$/,
		  // UKRAINE
		  US: /^\d{9}$/ // UNITED STATES

		};
		/**
		 * Check if str is a valid passport number
		 * relative to provided ISO Country Code.
		 *
		 * @param {string} str
		 * @param {string} countryCode
		 * @return {boolean}
		 */

		function isPassportNumber(str, countryCode) {
		  (0, _assertString.default)(str);
		  /** Remove All Whitespaces, Convert to UPPERCASE */

		  var normalizedStr = str.replace(/\s/g, '').toUpperCase();
		  return countryCode.toUpperCase() in passportRegexByCountryCode && passportRegexByCountryCode[countryCode].test(normalizedStr);
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
	} (isPassportNumber, isPassportNumberExports));

	var isPortExports = {};
	var isPort = {
	  get exports(){ return isPortExports; },
	  set exports(v){ isPortExports = v; },
	};

	var isIntExports = {};
	var isInt = {
	  get exports(){ return isIntExports; },
	  set exports(v){ isIntExports = v; },
	};

	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = isInt;

		var _assertString = _interopRequireDefault(assertStringExports);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		var int = /^(?:[-+]?(?:0|[1-9][0-9]*))$/;
		var intLeadingZeroes = /^[-+]?[0-9]+$/;

		function isInt(str, options) {
		  (0, _assertString.default)(str);
		  options = options || {}; // Get the regex to use for testing, based on whether
		  // leading zeroes are allowed or not.

		  var regex = options.hasOwnProperty('allow_leading_zeroes') && !options.allow_leading_zeroes ? int : intLeadingZeroes; // Check min/max/lt/gt

		  var minCheckPassed = !options.hasOwnProperty('min') || str >= options.min;
		  var maxCheckPassed = !options.hasOwnProperty('max') || str <= options.max;
		  var ltCheckPassed = !options.hasOwnProperty('lt') || str < options.lt;
		  var gtCheckPassed = !options.hasOwnProperty('gt') || str > options.gt;
		  return regex.test(str) && minCheckPassed && maxCheckPassed && ltCheckPassed && gtCheckPassed;
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
	} (isInt, isIntExports));

	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = isPort;

		var _isInt = _interopRequireDefault(isIntExports);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		function isPort(str) {
		  return (0, _isInt.default)(str, {
		    min: 0,
		    max: 65535
		  });
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
	} (isPort, isPortExports));

	var isLowercaseExports = {};
	var isLowercase = {
	  get exports(){ return isLowercaseExports; },
	  set exports(v){ isLowercaseExports = v; },
	};

	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = isLowercase;

		var _assertString = _interopRequireDefault(assertStringExports);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		function isLowercase(str) {
		  (0, _assertString.default)(str);
		  return str === str.toLowerCase();
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
	} (isLowercase, isLowercaseExports));

	var isUppercaseExports = {};
	var isUppercase = {
	  get exports(){ return isUppercaseExports; },
	  set exports(v){ isUppercaseExports = v; },
	};

	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = isUppercase;

		var _assertString = _interopRequireDefault(assertStringExports);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		function isUppercase(str) {
		  (0, _assertString.default)(str);
		  return str === str.toUpperCase();
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
	} (isUppercase, isUppercaseExports));

	var isIMEIExports = {};
	var isIMEI = {
	  get exports(){ return isIMEIExports; },
	  set exports(v){ isIMEIExports = v; },
	};

	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = isIMEI;

		var _assertString = _interopRequireDefault(assertStringExports);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		var imeiRegexWithoutHypens = /^[0-9]{15}$/;
		var imeiRegexWithHypens = /^\d{2}-\d{6}-\d{6}-\d{1}$/;

		function isIMEI(str, options) {
		  (0, _assertString.default)(str);
		  options = options || {}; // default regex for checking imei is the one without hyphens

		  var imeiRegex = imeiRegexWithoutHypens;

		  if (options.allow_hyphens) {
		    imeiRegex = imeiRegexWithHypens;
		  }

		  if (!imeiRegex.test(str)) {
		    return false;
		  }

		  str = str.replace(/-/g, '');
		  var sum = 0,
		      mul = 2,
		      l = 14;

		  for (var i = 0; i < l; i++) {
		    var digit = str.substring(l - i - 1, l - i);
		    var tp = parseInt(digit, 10) * mul;

		    if (tp >= 10) {
		      sum += tp % 10 + 1;
		    } else {
		      sum += tp;
		    }

		    if (mul === 1) {
		      mul += 1;
		    } else {
		      mul -= 1;
		    }
		  }

		  var chk = (10 - sum % 10) % 10;

		  if (chk !== parseInt(str.substring(14, 15), 10)) {
		    return false;
		  }

		  return true;
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
	} (isIMEI, isIMEIExports));

	var isAsciiExports = {};
	var isAscii = {
	  get exports(){ return isAsciiExports; },
	  set exports(v){ isAsciiExports = v; },
	};

	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = isAscii;

		var _assertString = _interopRequireDefault(assertStringExports);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		/* eslint-disable no-control-regex */
		var ascii = /^[\x00-\x7F]+$/;
		/* eslint-enable no-control-regex */

		function isAscii(str) {
		  (0, _assertString.default)(str);
		  return ascii.test(str);
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
	} (isAscii, isAsciiExports));

	var isFullWidth$1 = {};

	Object.defineProperty(isFullWidth$1, "__esModule", {
	  value: true
	});
	isFullWidth$1.default = isFullWidth;
	isFullWidth$1.fullWidth = void 0;

	var _assertString$7 = _interopRequireDefault$7(assertStringExports);

	function _interopRequireDefault$7(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var fullWidth = /[^\u0020-\u007E\uFF61-\uFF9F\uFFA0-\uFFDC\uFFE8-\uFFEE0-9a-zA-Z]/;
	isFullWidth$1.fullWidth = fullWidth;

	function isFullWidth(str) {
	  (0, _assertString$7.default)(str);
	  return fullWidth.test(str);
	}

	var isHalfWidth$1 = {};

	Object.defineProperty(isHalfWidth$1, "__esModule", {
	  value: true
	});
	isHalfWidth$1.default = isHalfWidth;
	isHalfWidth$1.halfWidth = void 0;

	var _assertString$6 = _interopRequireDefault$6(assertStringExports);

	function _interopRequireDefault$6(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var halfWidth = /[\u0020-\u007E\uFF61-\uFF9F\uFFA0-\uFFDC\uFFE8-\uFFEE0-9a-zA-Z]/;
	isHalfWidth$1.halfWidth = halfWidth;

	function isHalfWidth(str) {
	  (0, _assertString$6.default)(str);
	  return halfWidth.test(str);
	}

	var isVariableWidthExports = {};
	var isVariableWidth = {
	  get exports(){ return isVariableWidthExports; },
	  set exports(v){ isVariableWidthExports = v; },
	};

	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = isVariableWidth;

		var _assertString = _interopRequireDefault(assertStringExports);

		var _isFullWidth = isFullWidth$1;

		var _isHalfWidth = isHalfWidth$1;

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		function isVariableWidth(str) {
		  (0, _assertString.default)(str);
		  return _isFullWidth.fullWidth.test(str) && _isHalfWidth.halfWidth.test(str);
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
	} (isVariableWidth, isVariableWidthExports));

	var isMultibyteExports = {};
	var isMultibyte = {
	  get exports(){ return isMultibyteExports; },
	  set exports(v){ isMultibyteExports = v; },
	};

	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = isMultibyte;

		var _assertString = _interopRequireDefault(assertStringExports);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		/* eslint-disable no-control-regex */
		var multibyte = /[^\x00-\x7F]/;
		/* eslint-enable no-control-regex */

		function isMultibyte(str) {
		  (0, _assertString.default)(str);
		  return multibyte.test(str);
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
	} (isMultibyte, isMultibyteExports));

	var isSemVerExports = {};
	var isSemVer = {
	  get exports(){ return isSemVerExports; },
	  set exports(v){ isSemVerExports = v; },
	};

	var multilineRegexExports = {};
	var multilineRegex = {
	  get exports(){ return multilineRegexExports; },
	  set exports(v){ multilineRegexExports = v; },
	};

	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = multilineRegexp;

		/**
		 * Build RegExp object from an array
		 * of multiple/multi-line regexp parts
		 *
		 * @param {string[]} parts
		 * @param {string} flags
		 * @return {object} - RegExp object
		 */
		function multilineRegexp(parts, flags) {
		  var regexpAsStringLiteral = parts.join('');
		  return new RegExp(regexpAsStringLiteral, flags);
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
	} (multilineRegex, multilineRegexExports));

	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = isSemVer;

		var _assertString = _interopRequireDefault(assertStringExports);

		var _multilineRegex = _interopRequireDefault(multilineRegexExports);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		/**
		 * Regular Expression to match
		 * semantic versioning (SemVer)
		 * built from multi-line, multi-parts regexp
		 * Reference: https://semver.org/
		 */
		var semanticVersioningRegex = (0, _multilineRegex.default)(['^(0|[1-9]\\d*)\\.(0|[1-9]\\d*)\\.(0|[1-9]\\d*)', '(?:-((?:0|[1-9]\\d*|\\d*[a-z-][0-9a-z-]*)(?:\\.(?:0|[1-9]\\d*|\\d*[a-z-][0-9a-z-]*))*))', '?(?:\\+([0-9a-z-]+(?:\\.[0-9a-z-]+)*))?$'], 'i');

		function isSemVer(str) {
		  (0, _assertString.default)(str);
		  return semanticVersioningRegex.test(str);
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
	} (isSemVer, isSemVerExports));

	var isSurrogatePairExports = {};
	var isSurrogatePair = {
	  get exports(){ return isSurrogatePairExports; },
	  set exports(v){ isSurrogatePairExports = v; },
	};

	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = isSurrogatePair;

		var _assertString = _interopRequireDefault(assertStringExports);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		var surrogatePair = /[\uD800-\uDBFF][\uDC00-\uDFFF]/;

		function isSurrogatePair(str) {
		  (0, _assertString.default)(str);
		  return surrogatePair.test(str);
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
	} (isSurrogatePair, isSurrogatePairExports));

	var isDecimalExports = {};
	var isDecimal = {
	  get exports(){ return isDecimalExports; },
	  set exports(v){ isDecimalExports = v; },
	};

	var includesExports = {};
	var includes = {
	  get exports(){ return includesExports; },
	  set exports(v){ includesExports = v; },
	};

	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = void 0;

		var includes = function includes(arr, val) {
		  return arr.some(function (arrVal) {
		    return val === arrVal;
		  });
		};

		var _default = includes;
		exports.default = _default;
		module.exports = exports.default;
		module.exports.default = exports.default;
	} (includes, includesExports));

	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = isDecimal;

		var _merge = _interopRequireDefault(mergeExports);

		var _assertString = _interopRequireDefault(assertStringExports);

		var _includes = _interopRequireDefault(includesExports);

		var _alpha = alpha$1;

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		function decimalRegExp(options) {
		  var regExp = new RegExp("^[-+]?([0-9]+)?(\\".concat(_alpha.decimal[options.locale], "[0-9]{").concat(options.decimal_digits, "})").concat(options.force_decimal ? '' : '?', "$"));
		  return regExp;
		}

		var default_decimal_options = {
		  force_decimal: false,
		  decimal_digits: '1,',
		  locale: 'en-US'
		};
		var blacklist = ['', '-', '+'];

		function isDecimal(str, options) {
		  (0, _assertString.default)(str);
		  options = (0, _merge.default)(options, default_decimal_options);

		  if (options.locale in _alpha.decimal) {
		    return !(0, _includes.default)(blacklist, str.replace(/ /g, '')) && decimalRegExp(options).test(str);
		  }

		  throw new Error("Invalid locale '".concat(options.locale, "'"));
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
	} (isDecimal, isDecimalExports));

	var isHexadecimalExports = {};
	var isHexadecimal = {
	  get exports(){ return isHexadecimalExports; },
	  set exports(v){ isHexadecimalExports = v; },
	};

	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = isHexadecimal;

		var _assertString = _interopRequireDefault(assertStringExports);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		var hexadecimal = /^(0x|0h)?[0-9A-F]+$/i;

		function isHexadecimal(str) {
		  (0, _assertString.default)(str);
		  return hexadecimal.test(str);
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
	} (isHexadecimal, isHexadecimalExports));

	var isOctalExports = {};
	var isOctal = {
	  get exports(){ return isOctalExports; },
	  set exports(v){ isOctalExports = v; },
	};

	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = isOctal;

		var _assertString = _interopRequireDefault(assertStringExports);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		var octal = /^(0o)?[0-7]+$/i;

		function isOctal(str) {
		  (0, _assertString.default)(str);
		  return octal.test(str);
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
	} (isOctal, isOctalExports));

	var isDivisibleByExports = {};
	var isDivisibleBy = {
	  get exports(){ return isDivisibleByExports; },
	  set exports(v){ isDivisibleByExports = v; },
	};

	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = isDivisibleBy;

		var _assertString = _interopRequireDefault(assertStringExports);

		var _toFloat = _interopRequireDefault(toFloatExports);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		function isDivisibleBy(str, num) {
		  (0, _assertString.default)(str);
		  return (0, _toFloat.default)(str) % parseInt(num, 10) === 0;
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
	} (isDivisibleBy, isDivisibleByExports));

	var isHexColorExports = {};
	var isHexColor = {
	  get exports(){ return isHexColorExports; },
	  set exports(v){ isHexColorExports = v; },
	};

	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = isHexColor;

		var _assertString = _interopRequireDefault(assertStringExports);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		var hexcolor = /^#?([0-9A-F]{3}|[0-9A-F]{4}|[0-9A-F]{6}|[0-9A-F]{8})$/i;

		function isHexColor(str) {
		  (0, _assertString.default)(str);
		  return hexcolor.test(str);
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
	} (isHexColor, isHexColorExports));

	var isRgbColorExports = {};
	var isRgbColor = {
	  get exports(){ return isRgbColorExports; },
	  set exports(v){ isRgbColorExports = v; },
	};

	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = isRgbColor;

		var _assertString = _interopRequireDefault(assertStringExports);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		var rgbColor = /^rgb\((([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5]),){2}([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\)$/;
		var rgbaColor = /^rgba\((([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5]),){3}(0?\.\d|1(\.0)?|0(\.0)?)\)$/;
		var rgbColorPercent = /^rgb\((([0-9]%|[1-9][0-9]%|100%),){2}([0-9]%|[1-9][0-9]%|100%)\)/;
		var rgbaColorPercent = /^rgba\((([0-9]%|[1-9][0-9]%|100%),){3}(0?\.\d|1(\.0)?|0(\.0)?)\)/;

		function isRgbColor(str) {
		  var includePercentValues = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
		  (0, _assertString.default)(str);

		  if (!includePercentValues) {
		    return rgbColor.test(str) || rgbaColor.test(str);
		  }

		  return rgbColor.test(str) || rgbaColor.test(str) || rgbColorPercent.test(str) || rgbaColorPercent.test(str);
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
	} (isRgbColor, isRgbColorExports));

	var isHSLExports = {};
	var isHSL = {
	  get exports(){ return isHSLExports; },
	  set exports(v){ isHSLExports = v; },
	};

	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = isHSL;

		var _assertString = _interopRequireDefault(assertStringExports);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		var hslComma = /^hsla?\(((\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?))(deg|grad|rad|turn)?(,(\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?)%){2}(,((\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?)%?))?\)$/i;
		var hslSpace = /^hsla?\(((\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?))(deg|grad|rad|turn)?(\s(\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?)%){2}\s?(\/\s((\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?)%?)\s?)?\)$/i;

		function isHSL(str) {
		  (0, _assertString.default)(str); // Strip duplicate spaces before calling the validation regex (See  #1598 for more info)

		  var strippedStr = str.replace(/\s+/g, ' ').replace(/\s?(hsla?\(|\)|,)\s?/ig, '$1');

		  if (strippedStr.indexOf(',') !== -1) {
		    return hslComma.test(strippedStr);
		  }

		  return hslSpace.test(strippedStr);
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
	} (isHSL, isHSLExports));

	var isISRCExports = {};
	var isISRC = {
	  get exports(){ return isISRCExports; },
	  set exports(v){ isISRCExports = v; },
	};

	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = isISRC;

		var _assertString = _interopRequireDefault(assertStringExports);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		// see http://isrc.ifpi.org/en/isrc-standard/code-syntax
		var isrc = /^[A-Z]{2}[0-9A-Z]{3}\d{2}\d{5}$/;

		function isISRC(str) {
		  (0, _assertString.default)(str);
		  return isrc.test(str);
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
	} (isISRC, isISRCExports));

	var isIBAN$1 = {};

	Object.defineProperty(isIBAN$1, "__esModule", {
	  value: true
	});
	isIBAN$1.default = isIBAN;
	isIBAN$1.locales = void 0;

	var _assertString$5 = _interopRequireDefault$5(assertStringExports);

	function _interopRequireDefault$5(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	/**
	 * List of country codes with
	 * corresponding IBAN regular expression
	 * Reference: https://en.wikipedia.org/wiki/International_Bank_Account_Number
	 */
	var ibanRegexThroughCountryCode = {
	  AD: /^(AD[0-9]{2})\d{8}[A-Z0-9]{12}$/,
	  AE: /^(AE[0-9]{2})\d{3}\d{16}$/,
	  AL: /^(AL[0-9]{2})\d{8}[A-Z0-9]{16}$/,
	  AT: /^(AT[0-9]{2})\d{16}$/,
	  AZ: /^(AZ[0-9]{2})[A-Z0-9]{4}\d{20}$/,
	  BA: /^(BA[0-9]{2})\d{16}$/,
	  BE: /^(BE[0-9]{2})\d{12}$/,
	  BG: /^(BG[0-9]{2})[A-Z]{4}\d{6}[A-Z0-9]{8}$/,
	  BH: /^(BH[0-9]{2})[A-Z]{4}[A-Z0-9]{14}$/,
	  BR: /^(BR[0-9]{2})\d{23}[A-Z]{1}[A-Z0-9]{1}$/,
	  BY: /^(BY[0-9]{2})[A-Z0-9]{4}\d{20}$/,
	  CH: /^(CH[0-9]{2})\d{5}[A-Z0-9]{12}$/,
	  CR: /^(CR[0-9]{2})\d{18}$/,
	  CY: /^(CY[0-9]{2})\d{8}[A-Z0-9]{16}$/,
	  CZ: /^(CZ[0-9]{2})\d{20}$/,
	  DE: /^(DE[0-9]{2})\d{18}$/,
	  DK: /^(DK[0-9]{2})\d{14}$/,
	  DO: /^(DO[0-9]{2})[A-Z]{4}\d{20}$/,
	  EE: /^(EE[0-9]{2})\d{16}$/,
	  EG: /^(EG[0-9]{2})\d{25}$/,
	  ES: /^(ES[0-9]{2})\d{20}$/,
	  FI: /^(FI[0-9]{2})\d{14}$/,
	  FO: /^(FO[0-9]{2})\d{14}$/,
	  FR: /^(FR[0-9]{2})\d{10}[A-Z0-9]{11}\d{2}$/,
	  GB: /^(GB[0-9]{2})[A-Z]{4}\d{14}$/,
	  GE: /^(GE[0-9]{2})[A-Z0-9]{2}\d{16}$/,
	  GI: /^(GI[0-9]{2})[A-Z]{4}[A-Z0-9]{15}$/,
	  GL: /^(GL[0-9]{2})\d{14}$/,
	  GR: /^(GR[0-9]{2})\d{7}[A-Z0-9]{16}$/,
	  GT: /^(GT[0-9]{2})[A-Z0-9]{4}[A-Z0-9]{20}$/,
	  HR: /^(HR[0-9]{2})\d{17}$/,
	  HU: /^(HU[0-9]{2})\d{24}$/,
	  IE: /^(IE[0-9]{2})[A-Z0-9]{4}\d{14}$/,
	  IL: /^(IL[0-9]{2})\d{19}$/,
	  IQ: /^(IQ[0-9]{2})[A-Z]{4}\d{15}$/,
	  IR: /^(IR[0-9]{2})0\d{2}0\d{18}$/,
	  IS: /^(IS[0-9]{2})\d{22}$/,
	  IT: /^(IT[0-9]{2})[A-Z]{1}\d{10}[A-Z0-9]{12}$/,
	  JO: /^(JO[0-9]{2})[A-Z]{4}\d{22}$/,
	  KW: /^(KW[0-9]{2})[A-Z]{4}[A-Z0-9]{22}$/,
	  KZ: /^(KZ[0-9]{2})\d{3}[A-Z0-9]{13}$/,
	  LB: /^(LB[0-9]{2})\d{4}[A-Z0-9]{20}$/,
	  LC: /^(LC[0-9]{2})[A-Z]{4}[A-Z0-9]{24}$/,
	  LI: /^(LI[0-9]{2})\d{5}[A-Z0-9]{12}$/,
	  LT: /^(LT[0-9]{2})\d{16}$/,
	  LU: /^(LU[0-9]{2})\d{3}[A-Z0-9]{13}$/,
	  LV: /^(LV[0-9]{2})[A-Z]{4}[A-Z0-9]{13}$/,
	  MC: /^(MC[0-9]{2})\d{10}[A-Z0-9]{11}\d{2}$/,
	  MD: /^(MD[0-9]{2})[A-Z0-9]{20}$/,
	  ME: /^(ME[0-9]{2})\d{18}$/,
	  MK: /^(MK[0-9]{2})\d{3}[A-Z0-9]{10}\d{2}$/,
	  MR: /^(MR[0-9]{2})\d{23}$/,
	  MT: /^(MT[0-9]{2})[A-Z]{4}\d{5}[A-Z0-9]{18}$/,
	  MU: /^(MU[0-9]{2})[A-Z]{4}\d{19}[A-Z]{3}$/,
	  MZ: /^(MZ[0-9]{2})\d{21}$/,
	  NL: /^(NL[0-9]{2})[A-Z]{4}\d{10}$/,
	  NO: /^(NO[0-9]{2})\d{11}$/,
	  PK: /^(PK[0-9]{2})[A-Z0-9]{4}\d{16}$/,
	  PL: /^(PL[0-9]{2})\d{24}$/,
	  PS: /^(PS[0-9]{2})[A-Z0-9]{4}\d{21}$/,
	  PT: /^(PT[0-9]{2})\d{21}$/,
	  QA: /^(QA[0-9]{2})[A-Z]{4}[A-Z0-9]{21}$/,
	  RO: /^(RO[0-9]{2})[A-Z]{4}[A-Z0-9]{16}$/,
	  RS: /^(RS[0-9]{2})\d{18}$/,
	  SA: /^(SA[0-9]{2})\d{2}[A-Z0-9]{18}$/,
	  SC: /^(SC[0-9]{2})[A-Z]{4}\d{20}[A-Z]{3}$/,
	  SE: /^(SE[0-9]{2})\d{20}$/,
	  SI: /^(SI[0-9]{2})\d{15}$/,
	  SK: /^(SK[0-9]{2})\d{20}$/,
	  SM: /^(SM[0-9]{2})[A-Z]{1}\d{10}[A-Z0-9]{12}$/,
	  SV: /^(SV[0-9]{2})[A-Z0-9]{4}\d{20}$/,
	  TL: /^(TL[0-9]{2})\d{19}$/,
	  TN: /^(TN[0-9]{2})\d{20}$/,
	  TR: /^(TR[0-9]{2})\d{5}[A-Z0-9]{17}$/,
	  UA: /^(UA[0-9]{2})\d{6}[A-Z0-9]{19}$/,
	  VA: /^(VA[0-9]{2})\d{18}$/,
	  VG: /^(VG[0-9]{2})[A-Z0-9]{4}\d{16}$/,
	  XK: /^(XK[0-9]{2})\d{16}$/
	};
	/**
	 * Check whether string has correct universal IBAN format
	 * The IBAN consists of up to 34 alphanumeric characters, as follows:
	 * Country Code using ISO 3166-1 alpha-2, two letters
	 * check digits, two digits and
	 * Basic Bank Account Number (BBAN), up to 30 alphanumeric characters.
	 * NOTE: Permitted IBAN characters are: digits [0-9] and the 26 latin alphabetic [A-Z]
	 *
	 * @param {string} str - string under validation
	 * @return {boolean}
	 */

	function hasValidIbanFormat(str) {
	  // Strip white spaces and hyphens
	  var strippedStr = str.replace(/[\s\-]+/gi, '').toUpperCase();
	  var isoCountryCode = strippedStr.slice(0, 2).toUpperCase();
	  return isoCountryCode in ibanRegexThroughCountryCode && ibanRegexThroughCountryCode[isoCountryCode].test(strippedStr);
	}
	/**
	   * Check whether string has valid IBAN Checksum
	   * by performing basic mod-97 operation and
	   * the remainder should equal 1
	   * -- Start by rearranging the IBAN by moving the four initial characters to the end of the string
	   * -- Replace each letter in the string with two digits, A -> 10, B = 11, Z = 35
	   * -- Interpret the string as a decimal integer and
	   * -- compute the remainder on division by 97 (mod 97)
	   * Reference: https://en.wikipedia.org/wiki/International_Bank_Account_Number
	   *
	   * @param {string} str
	   * @return {boolean}
	   */


	function hasValidIbanChecksum(str) {
	  var strippedStr = str.replace(/[^A-Z0-9]+/gi, '').toUpperCase(); // Keep only digits and A-Z latin alphabetic

	  var rearranged = strippedStr.slice(4) + strippedStr.slice(0, 4);
	  var alphaCapsReplacedWithDigits = rearranged.replace(/[A-Z]/g, function (char) {
	    return char.charCodeAt(0) - 55;
	  });
	  var remainder = alphaCapsReplacedWithDigits.match(/\d{1,7}/g).reduce(function (acc, value) {
	    return Number(acc + value) % 97;
	  }, '');
	  return remainder === 1;
	}

	function isIBAN(str) {
	  (0, _assertString$5.default)(str);
	  return hasValidIbanFormat(str) && hasValidIbanChecksum(str);
	}

	var locales$2 = Object.keys(ibanRegexThroughCountryCode);
	isIBAN$1.locales = locales$2;

	var isBICExports = {};
	var isBIC = {
	  get exports(){ return isBICExports; },
	  set exports(v){ isBICExports = v; },
	};

	var isISO31661Alpha2$1 = {};

	Object.defineProperty(isISO31661Alpha2$1, "__esModule", {
	  value: true
	});
	isISO31661Alpha2$1.default = isISO31661Alpha2;
	isISO31661Alpha2$1.CountryCodes = void 0;

	var _assertString$4 = _interopRequireDefault$4(assertStringExports);

	function _interopRequireDefault$4(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	// from https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2
	var validISO31661Alpha2CountriesCodes = new Set(['AD', 'AE', 'AF', 'AG', 'AI', 'AL', 'AM', 'AO', 'AQ', 'AR', 'AS', 'AT', 'AU', 'AW', 'AX', 'AZ', 'BA', 'BB', 'BD', 'BE', 'BF', 'BG', 'BH', 'BI', 'BJ', 'BL', 'BM', 'BN', 'BO', 'BQ', 'BR', 'BS', 'BT', 'BV', 'BW', 'BY', 'BZ', 'CA', 'CC', 'CD', 'CF', 'CG', 'CH', 'CI', 'CK', 'CL', 'CM', 'CN', 'CO', 'CR', 'CU', 'CV', 'CW', 'CX', 'CY', 'CZ', 'DE', 'DJ', 'DK', 'DM', 'DO', 'DZ', 'EC', 'EE', 'EG', 'EH', 'ER', 'ES', 'ET', 'FI', 'FJ', 'FK', 'FM', 'FO', 'FR', 'GA', 'GB', 'GD', 'GE', 'GF', 'GG', 'GH', 'GI', 'GL', 'GM', 'GN', 'GP', 'GQ', 'GR', 'GS', 'GT', 'GU', 'GW', 'GY', 'HK', 'HM', 'HN', 'HR', 'HT', 'HU', 'ID', 'IE', 'IL', 'IM', 'IN', 'IO', 'IQ', 'IR', 'IS', 'IT', 'JE', 'JM', 'JO', 'JP', 'KE', 'KG', 'KH', 'KI', 'KM', 'KN', 'KP', 'KR', 'KW', 'KY', 'KZ', 'LA', 'LB', 'LC', 'LI', 'LK', 'LR', 'LS', 'LT', 'LU', 'LV', 'LY', 'MA', 'MC', 'MD', 'ME', 'MF', 'MG', 'MH', 'MK', 'ML', 'MM', 'MN', 'MO', 'MP', 'MQ', 'MR', 'MS', 'MT', 'MU', 'MV', 'MW', 'MX', 'MY', 'MZ', 'NA', 'NC', 'NE', 'NF', 'NG', 'NI', 'NL', 'NO', 'NP', 'NR', 'NU', 'NZ', 'OM', 'PA', 'PE', 'PF', 'PG', 'PH', 'PK', 'PL', 'PM', 'PN', 'PR', 'PS', 'PT', 'PW', 'PY', 'QA', 'RE', 'RO', 'RS', 'RU', 'RW', 'SA', 'SB', 'SC', 'SD', 'SE', 'SG', 'SH', 'SI', 'SJ', 'SK', 'SL', 'SM', 'SN', 'SO', 'SR', 'SS', 'ST', 'SV', 'SX', 'SY', 'SZ', 'TC', 'TD', 'TF', 'TG', 'TH', 'TJ', 'TK', 'TL', 'TM', 'TN', 'TO', 'TR', 'TT', 'TV', 'TW', 'TZ', 'UA', 'UG', 'UM', 'US', 'UY', 'UZ', 'VA', 'VC', 'VE', 'VG', 'VI', 'VN', 'VU', 'WF', 'WS', 'YE', 'YT', 'ZA', 'ZM', 'ZW']);

	function isISO31661Alpha2(str) {
	  (0, _assertString$4.default)(str);
	  return validISO31661Alpha2CountriesCodes.has(str.toUpperCase());
	}

	var CountryCodes = validISO31661Alpha2CountriesCodes;
	isISO31661Alpha2$1.CountryCodes = CountryCodes;

	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = isBIC;

		var _assertString = _interopRequireDefault(assertStringExports);

		var _isISO31661Alpha = isISO31661Alpha2$1;

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		// https://en.wikipedia.org/wiki/ISO_9362
		var isBICReg = /^[A-Za-z]{6}[A-Za-z0-9]{2}([A-Za-z0-9]{3})?$/;

		function isBIC(str) {
		  (0, _assertString.default)(str); // toUpperCase() should be removed when a new major version goes out that changes
		  // the regex to [A-Z] (per the spec).

		  if (!_isISO31661Alpha.CountryCodes.has(str.slice(4, 6).toUpperCase())) {
		    return false;
		  }

		  return isBICReg.test(str);
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
	} (isBIC, isBICExports));

	var isMD5Exports = {};
	var isMD5 = {
	  get exports(){ return isMD5Exports; },
	  set exports(v){ isMD5Exports = v; },
	};

	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = isMD5;

		var _assertString = _interopRequireDefault(assertStringExports);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		var md5 = /^[a-f0-9]{32}$/;

		function isMD5(str) {
		  (0, _assertString.default)(str);
		  return md5.test(str);
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
	} (isMD5, isMD5Exports));

	var isHashExports = {};
	var isHash = {
	  get exports(){ return isHashExports; },
	  set exports(v){ isHashExports = v; },
	};

	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = isHash;

		var _assertString = _interopRequireDefault(assertStringExports);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		var lengths = {
		  md5: 32,
		  md4: 32,
		  sha1: 40,
		  sha256: 64,
		  sha384: 96,
		  sha512: 128,
		  ripemd128: 32,
		  ripemd160: 40,
		  tiger128: 32,
		  tiger160: 40,
		  tiger192: 48,
		  crc32: 8,
		  crc32b: 8
		};

		function isHash(str, algorithm) {
		  (0, _assertString.default)(str);
		  var hash = new RegExp("^[a-fA-F0-9]{".concat(lengths[algorithm], "}$"));
		  return hash.test(str);
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
	} (isHash, isHashExports));

	var isJWTExports = {};
	var isJWT = {
	  get exports(){ return isJWTExports; },
	  set exports(v){ isJWTExports = v; },
	};

	var isBase64Exports = {};
	var isBase64 = {
	  get exports(){ return isBase64Exports; },
	  set exports(v){ isBase64Exports = v; },
	};

	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = isBase64;

		var _assertString = _interopRequireDefault(assertStringExports);

		var _merge = _interopRequireDefault(mergeExports);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		var notBase64 = /[^A-Z0-9+\/=]/i;
		var urlSafeBase64 = /^[A-Z0-9_\-]*$/i;
		var defaultBase64Options = {
		  urlSafe: false
		};

		function isBase64(str, options) {
		  (0, _assertString.default)(str);
		  options = (0, _merge.default)(options, defaultBase64Options);
		  var len = str.length;

		  if (options.urlSafe) {
		    return urlSafeBase64.test(str);
		  }

		  if (len % 4 !== 0 || notBase64.test(str)) {
		    return false;
		  }

		  var firstPaddingChar = str.indexOf('=');
		  return firstPaddingChar === -1 || firstPaddingChar === len - 1 || firstPaddingChar === len - 2 && str[len - 1] === '=';
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
	} (isBase64, isBase64Exports));

	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = isJWT;

		var _assertString = _interopRequireDefault(assertStringExports);

		var _isBase = _interopRequireDefault(isBase64Exports);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		function isJWT(str) {
		  (0, _assertString.default)(str);
		  var dotSplit = str.split('.');
		  var len = dotSplit.length;

		  if (len > 3 || len < 2) {
		    return false;
		  }

		  return dotSplit.reduce(function (acc, currElem) {
		    return acc && (0, _isBase.default)(currElem, {
		      urlSafe: true
		    });
		  }, true);
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
	} (isJWT, isJWTExports));

	var isJSONExports = {};
	var isJSON = {
	  get exports(){ return isJSONExports; },
	  set exports(v){ isJSONExports = v; },
	};

	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = isJSON;

		var _assertString = _interopRequireDefault(assertStringExports);

		var _merge = _interopRequireDefault(mergeExports);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

		var default_json_options = {
		  allow_primitives: false
		};

		function isJSON(str, options) {
		  (0, _assertString.default)(str);

		  try {
		    options = (0, _merge.default)(options, default_json_options);
		    var primitives = [];

		    if (options.allow_primitives) {
		      primitives = [null, false, true];
		    }

		    var obj = JSON.parse(str);
		    return primitives.includes(obj) || !!obj && _typeof(obj) === 'object';
		  } catch (e) {
		    /* ignore */
		  }

		  return false;
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
	} (isJSON, isJSONExports));

	var isEmptyExports = {};
	var isEmpty$1 = {
	  get exports(){ return isEmptyExports; },
	  set exports(v){ isEmptyExports = v; },
	};

	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = isEmpty;

		var _assertString = _interopRequireDefault(assertStringExports);

		var _merge = _interopRequireDefault(mergeExports);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		var default_is_empty_options = {
		  ignore_whitespace: false
		};

		function isEmpty(str, options) {
		  (0, _assertString.default)(str);
		  options = (0, _merge.default)(options, default_is_empty_options);
		  return (options.ignore_whitespace ? str.trim().length : str.length) === 0;
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
	} (isEmpty$1, isEmptyExports));

	var isLengthExports = {};
	var isLength = {
	  get exports(){ return isLengthExports; },
	  set exports(v){ isLengthExports = v; },
	};

	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = isLength;

		var _assertString = _interopRequireDefault(assertStringExports);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

		/* eslint-disable prefer-rest-params */
		function isLength(str, options) {
		  (0, _assertString.default)(str);
		  var min;
		  var max;

		  if (_typeof(options) === 'object') {
		    min = options.min || 0;
		    max = options.max;
		  } else {
		    // backwards compatibility: isLength(str, min [, max])
		    min = arguments[1] || 0;
		    max = arguments[2];
		  }

		  var surrogatePairs = str.match(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g) || [];
		  var len = str.length - surrogatePairs.length;
		  return len >= min && (typeof max === 'undefined' || len <= max);
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
	} (isLength, isLengthExports));

	var isUUIDExports = {};
	var isUUID = {
	  get exports(){ return isUUIDExports; },
	  set exports(v){ isUUIDExports = v; },
	};

	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = isUUID;

		var _assertString = _interopRequireDefault(assertStringExports);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		var uuid = {
		  1: /^[0-9A-F]{8}-[0-9A-F]{4}-1[0-9A-F]{3}-[0-9A-F]{4}-[0-9A-F]{12}$/i,
		  2: /^[0-9A-F]{8}-[0-9A-F]{4}-2[0-9A-F]{3}-[0-9A-F]{4}-[0-9A-F]{12}$/i,
		  3: /^[0-9A-F]{8}-[0-9A-F]{4}-3[0-9A-F]{3}-[0-9A-F]{4}-[0-9A-F]{12}$/i,
		  4: /^[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
		  5: /^[0-9A-F]{8}-[0-9A-F]{4}-5[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
		  all: /^[0-9A-F]{8}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{12}$/i
		};

		function isUUID(str, version) {
		  (0, _assertString.default)(str);
		  var pattern = uuid[![undefined, null].includes(version) ? version : 'all'];
		  return !!pattern && pattern.test(str);
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
	} (isUUID, isUUIDExports));

	var isMongoIdExports = {};
	var isMongoId = {
	  get exports(){ return isMongoIdExports; },
	  set exports(v){ isMongoIdExports = v; },
	};

	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = isMongoId;

		var _assertString = _interopRequireDefault(assertStringExports);

		var _isHexadecimal = _interopRequireDefault(isHexadecimalExports);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		function isMongoId(str) {
		  (0, _assertString.default)(str);
		  return (0, _isHexadecimal.default)(str) && str.length === 24;
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
	} (isMongoId, isMongoIdExports));

	var isAfterExports = {};
	var isAfter = {
	  get exports(){ return isAfterExports; },
	  set exports(v){ isAfterExports = v; },
	};

	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = isAfter;

		var _assertString = _interopRequireDefault(assertStringExports);

		var _toDate = _interopRequireDefault(toDateExports);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		function isAfter(str) {
		  var date = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : String(new Date());
		  (0, _assertString.default)(str);
		  var comparison = (0, _toDate.default)(date);
		  var original = (0, _toDate.default)(str);
		  return !!(original && comparison && original > comparison);
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
	} (isAfter, isAfterExports));

	var isBeforeExports = {};
	var isBefore = {
	  get exports(){ return isBeforeExports; },
	  set exports(v){ isBeforeExports = v; },
	};

	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = isBefore;

		var _assertString = _interopRequireDefault(assertStringExports);

		var _toDate = _interopRequireDefault(toDateExports);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		function isBefore(str) {
		  var date = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : String(new Date());
		  (0, _assertString.default)(str);
		  var comparison = (0, _toDate.default)(date);
		  var original = (0, _toDate.default)(str);
		  return !!(original && comparison && original < comparison);
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
	} (isBefore, isBeforeExports));

	var isInExports = {};
	var isIn = {
	  get exports(){ return isInExports; },
	  set exports(v){ isInExports = v; },
	};

	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = isIn;

		var _assertString = _interopRequireDefault(assertStringExports);

		var _toString = _interopRequireDefault(toStringExports);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

		function isIn(str, options) {
		  (0, _assertString.default)(str);
		  var i;

		  if (Object.prototype.toString.call(options) === '[object Array]') {
		    var array = [];

		    for (i in options) {
		      // https://github.com/gotwarlost/istanbul/blob/master/ignoring-code-for-coverage.md#ignoring-code-for-coverage-purposes
		      // istanbul ignore else
		      if ({}.hasOwnProperty.call(options, i)) {
		        array[i] = (0, _toString.default)(options[i]);
		      }
		    }

		    return array.indexOf(str) >= 0;
		  } else if (_typeof(options) === 'object') {
		    return options.hasOwnProperty(str);
		  } else if (options && typeof options.indexOf === 'function') {
		    return options.indexOf(str) >= 0;
		  }

		  return false;
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
	} (isIn, isInExports));

	var isCreditCardExports = {};
	var isCreditCard = {
	  get exports(){ return isCreditCardExports; },
	  set exports(v){ isCreditCardExports = v; },
	};

	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = isCreditCard;

		var _assertString = _interopRequireDefault(assertStringExports);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		/* eslint-disable max-len */
		var creditCard = /^(?:4[0-9]{12}(?:[0-9]{3,6})?|5[1-5][0-9]{14}|(222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}|6(?:011|5[0-9][0-9])[0-9]{12,15}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11}|6[27][0-9]{14}|^(81[0-9]{14,17}))$/;
		/* eslint-enable max-len */

		function isCreditCard(str) {
		  (0, _assertString.default)(str);
		  var sanitized = str.replace(/[- ]+/g, '');

		  if (!creditCard.test(sanitized)) {
		    return false;
		  }

		  var sum = 0;
		  var digit;
		  var tmpNum;
		  var shouldDouble;

		  for (var i = sanitized.length - 1; i >= 0; i--) {
		    digit = sanitized.substring(i, i + 1);
		    tmpNum = parseInt(digit, 10);

		    if (shouldDouble) {
		      tmpNum *= 2;

		      if (tmpNum >= 10) {
		        sum += tmpNum % 10 + 1;
		      } else {
		        sum += tmpNum;
		      }
		    } else {
		      sum += tmpNum;
		    }

		    shouldDouble = !shouldDouble;
		  }

		  return !!(sum % 10 === 0 ? sanitized : false);
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
	} (isCreditCard, isCreditCardExports));

	var isIdentityCardExports = {};
	var isIdentityCard = {
	  get exports(){ return isIdentityCardExports; },
	  set exports(v){ isIdentityCardExports = v; },
	};

	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = isIdentityCard;

		var _assertString = _interopRequireDefault(assertStringExports);

		var _isInt = _interopRequireDefault(isIntExports);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		var validators = {
		  PL: function PL(str) {
		    (0, _assertString.default)(str);
		    var weightOfDigits = {
		      1: 1,
		      2: 3,
		      3: 7,
		      4: 9,
		      5: 1,
		      6: 3,
		      7: 7,
		      8: 9,
		      9: 1,
		      10: 3,
		      11: 0
		    };

		    if (str != null && str.length === 11 && (0, _isInt.default)(str, {
		      allow_leading_zeroes: true
		    })) {
		      var digits = str.split('').slice(0, -1);
		      var sum = digits.reduce(function (acc, digit, index) {
		        return acc + Number(digit) * weightOfDigits[index + 1];
		      }, 0);
		      var modulo = sum % 10;
		      var lastDigit = Number(str.charAt(str.length - 1));

		      if (modulo === 0 && lastDigit === 0 || lastDigit === 10 - modulo) {
		        return true;
		      }
		    }

		    return false;
		  },
		  ES: function ES(str) {
		    (0, _assertString.default)(str);
		    var DNI = /^[0-9X-Z][0-9]{7}[TRWAGMYFPDXBNJZSQVHLCKE]$/;
		    var charsValue = {
		      X: 0,
		      Y: 1,
		      Z: 2
		    };
		    var controlDigits = ['T', 'R', 'W', 'A', 'G', 'M', 'Y', 'F', 'P', 'D', 'X', 'B', 'N', 'J', 'Z', 'S', 'Q', 'V', 'H', 'L', 'C', 'K', 'E']; // sanitize user input

		    var sanitized = str.trim().toUpperCase(); // validate the data structure

		    if (!DNI.test(sanitized)) {
		      return false;
		    } // validate the control digit


		    var number = sanitized.slice(0, -1).replace(/[X,Y,Z]/g, function (char) {
		      return charsValue[char];
		    });
		    return sanitized.endsWith(controlDigits[number % 23]);
		  },
		  FI: function FI(str) {
		    // https://dvv.fi/en/personal-identity-code#:~:text=control%20character%20for%20a-,personal,-identity%20code%20calculated
		    (0, _assertString.default)(str);

		    if (str.length !== 11) {
		      return false;
		    }

		    if (!str.match(/^\d{6}[\-A\+]\d{3}[0-9ABCDEFHJKLMNPRSTUVWXY]{1}$/)) {
		      return false;
		    }

		    var checkDigits = '0123456789ABCDEFHJKLMNPRSTUVWXY';
		    var idAsNumber = parseInt(str.slice(0, 6), 10) * 1000 + parseInt(str.slice(7, 10), 10);
		    var remainder = idAsNumber % 31;
		    var checkDigit = checkDigits[remainder];
		    return checkDigit === str.slice(10, 11);
		  },
		  IN: function IN(str) {
		    var DNI = /^[1-9]\d{3}\s?\d{4}\s?\d{4}$/; // multiplication table

		    var d = [[0, 1, 2, 3, 4, 5, 6, 7, 8, 9], [1, 2, 3, 4, 0, 6, 7, 8, 9, 5], [2, 3, 4, 0, 1, 7, 8, 9, 5, 6], [3, 4, 0, 1, 2, 8, 9, 5, 6, 7], [4, 0, 1, 2, 3, 9, 5, 6, 7, 8], [5, 9, 8, 7, 6, 0, 4, 3, 2, 1], [6, 5, 9, 8, 7, 1, 0, 4, 3, 2], [7, 6, 5, 9, 8, 2, 1, 0, 4, 3], [8, 7, 6, 5, 9, 3, 2, 1, 0, 4], [9, 8, 7, 6, 5, 4, 3, 2, 1, 0]]; // permutation table

		    var p = [[0, 1, 2, 3, 4, 5, 6, 7, 8, 9], [1, 5, 7, 6, 2, 8, 3, 0, 9, 4], [5, 8, 0, 3, 7, 9, 6, 1, 4, 2], [8, 9, 1, 6, 0, 4, 3, 5, 2, 7], [9, 4, 5, 3, 1, 2, 6, 8, 7, 0], [4, 2, 8, 6, 5, 7, 3, 9, 0, 1], [2, 7, 9, 3, 8, 0, 6, 4, 1, 5], [7, 0, 4, 6, 9, 1, 3, 2, 5, 8]]; // sanitize user input

		    var sanitized = str.trim(); // validate the data structure

		    if (!DNI.test(sanitized)) {
		      return false;
		    }

		    var c = 0;
		    var invertedArray = sanitized.replace(/\s/g, '').split('').map(Number).reverse();
		    invertedArray.forEach(function (val, i) {
		      c = d[c][p[i % 8][val]];
		    });
		    return c === 0;
		  },
		  IR: function IR(str) {
		    if (!str.match(/^\d{10}$/)) return false;
		    str = "0000".concat(str).substr(str.length - 6);
		    if (parseInt(str.substr(3, 6), 10) === 0) return false;
		    var lastNumber = parseInt(str.substr(9, 1), 10);
		    var sum = 0;

		    for (var i = 0; i < 9; i++) {
		      sum += parseInt(str.substr(i, 1), 10) * (10 - i);
		    }

		    sum %= 11;
		    return sum < 2 && lastNumber === sum || sum >= 2 && lastNumber === 11 - sum;
		  },
		  IT: function IT(str) {
		    if (str.length !== 9) return false;
		    if (str === 'CA00000AA') return false; // https://it.wikipedia.org/wiki/Carta_d%27identit%C3%A0_elettronica_italiana

		    return str.search(/C[A-Z][0-9]{5}[A-Z]{2}/i) > -1;
		  },
		  NO: function NO(str) {
		    var sanitized = str.trim();
		    if (isNaN(Number(sanitized))) return false;
		    if (sanitized.length !== 11) return false;
		    if (sanitized === '00000000000') return false; // https://no.wikipedia.org/wiki/F%C3%B8dselsnummer

		    var f = sanitized.split('').map(Number);
		    var k1 = (11 - (3 * f[0] + 7 * f[1] + 6 * f[2] + 1 * f[3] + 8 * f[4] + 9 * f[5] + 4 * f[6] + 5 * f[7] + 2 * f[8]) % 11) % 11;
		    var k2 = (11 - (5 * f[0] + 4 * f[1] + 3 * f[2] + 2 * f[3] + 7 * f[4] + 6 * f[5] + 5 * f[6] + 4 * f[7] + 3 * f[8] + 2 * k1) % 11) % 11;
		    if (k1 !== f[9] || k2 !== f[10]) return false;
		    return true;
		  },
		  TH: function TH(str) {
		    if (!str.match(/^[1-8]\d{12}$/)) return false; // validate check digit

		    var sum = 0;

		    for (var i = 0; i < 12; i++) {
		      sum += parseInt(str[i], 10) * (13 - i);
		    }

		    return str[12] === ((11 - sum % 11) % 10).toString();
		  },
		  LK: function LK(str) {
		    var old_nic = /^[1-9]\d{8}[vx]$/i;
		    var new_nic = /^[1-9]\d{11}$/i;
		    if (str.length === 10 && old_nic.test(str)) return true;else if (str.length === 12 && new_nic.test(str)) return true;
		    return false;
		  },
		  'he-IL': function heIL(str) {
		    var DNI = /^\d{9}$/; // sanitize user input

		    var sanitized = str.trim(); // validate the data structure

		    if (!DNI.test(sanitized)) {
		      return false;
		    }

		    var id = sanitized;
		    var sum = 0,
		        incNum;

		    for (var i = 0; i < id.length; i++) {
		      incNum = Number(id[i]) * (i % 2 + 1); // Multiply number by 1 or 2

		      sum += incNum > 9 ? incNum - 9 : incNum; // Sum the digits up and add to total
		    }

		    return sum % 10 === 0;
		  },
		  'ar-LY': function arLY(str) {
		    // Libya National Identity Number NIN is 12 digits, the first digit is either 1 or 2
		    var NIN = /^(1|2)\d{11}$/; // sanitize user input

		    var sanitized = str.trim(); // validate the data structure

		    if (!NIN.test(sanitized)) {
		      return false;
		    }

		    return true;
		  },
		  'ar-TN': function arTN(str) {
		    var DNI = /^\d{8}$/; // sanitize user input

		    var sanitized = str.trim(); // validate the data structure

		    if (!DNI.test(sanitized)) {
		      return false;
		    }

		    return true;
		  },
		  'zh-CN': function zhCN(str) {
		    var provincesAndCities = ['11', // 北京
		    '12', // 天津
		    '13', // 河北
		    '14', // 山西
		    '15', // 内蒙古
		    '21', // 辽宁
		    '22', // 吉林
		    '23', // 黑龙江
		    '31', // 上海
		    '32', // 江苏
		    '33', // 浙江
		    '34', // 安徽
		    '35', // 福建
		    '36', // 江西
		    '37', // 山东
		    '41', // 河南
		    '42', // 湖北
		    '43', // 湖南
		    '44', // 广东
		    '45', // 广西
		    '46', // 海南
		    '50', // 重庆
		    '51', // 四川
		    '52', // 贵州
		    '53', // 云南
		    '54', // 西藏
		    '61', // 陕西
		    '62', // 甘肃
		    '63', // 青海
		    '64', // 宁夏
		    '65', // 新疆
		    '71', // 台湾
		    '81', // 香港
		    '82', // 澳门
		    '91' // 国外
		    ];
		    var powers = ['7', '9', '10', '5', '8', '4', '2', '1', '6', '3', '7', '9', '10', '5', '8', '4', '2'];
		    var parityBit = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'];

		    var checkAddressCode = function checkAddressCode(addressCode) {
		      return provincesAndCities.includes(addressCode);
		    };

		    var checkBirthDayCode = function checkBirthDayCode(birDayCode) {
		      var yyyy = parseInt(birDayCode.substring(0, 4), 10);
		      var mm = parseInt(birDayCode.substring(4, 6), 10);
		      var dd = parseInt(birDayCode.substring(6), 10);
		      var xdata = new Date(yyyy, mm - 1, dd);

		      if (xdata > new Date()) {
		        return false; // eslint-disable-next-line max-len
		      } else if (xdata.getFullYear() === yyyy && xdata.getMonth() === mm - 1 && xdata.getDate() === dd) {
		        return true;
		      }

		      return false;
		    };

		    var getParityBit = function getParityBit(idCardNo) {
		      var id17 = idCardNo.substring(0, 17);
		      var power = 0;

		      for (var i = 0; i < 17; i++) {
		        power += parseInt(id17.charAt(i), 10) * parseInt(powers[i], 10);
		      }

		      var mod = power % 11;
		      return parityBit[mod];
		    };

		    var checkParityBit = function checkParityBit(idCardNo) {
		      return getParityBit(idCardNo) === idCardNo.charAt(17).toUpperCase();
		    };

		    var check15IdCardNo = function check15IdCardNo(idCardNo) {
		      var check = /^[1-9]\d{7}((0[1-9])|(1[0-2]))((0[1-9])|([1-2][0-9])|(3[0-1]))\d{3}$/.test(idCardNo);
		      if (!check) return false;
		      var addressCode = idCardNo.substring(0, 2);
		      check = checkAddressCode(addressCode);
		      if (!check) return false;
		      var birDayCode = "19".concat(idCardNo.substring(6, 12));
		      check = checkBirthDayCode(birDayCode);
		      if (!check) return false;
		      return true;
		    };

		    var check18IdCardNo = function check18IdCardNo(idCardNo) {
		      var check = /^[1-9]\d{5}[1-9]\d{3}((0[1-9])|(1[0-2]))((0[1-9])|([1-2][0-9])|(3[0-1]))\d{3}(\d|x|X)$/.test(idCardNo);
		      if (!check) return false;
		      var addressCode = idCardNo.substring(0, 2);
		      check = checkAddressCode(addressCode);
		      if (!check) return false;
		      var birDayCode = idCardNo.substring(6, 14);
		      check = checkBirthDayCode(birDayCode);
		      if (!check) return false;
		      return checkParityBit(idCardNo);
		    };

		    var checkIdCardNo = function checkIdCardNo(idCardNo) {
		      var check = /^\d{15}|(\d{17}(\d|x|X))$/.test(idCardNo);
		      if (!check) return false;

		      if (idCardNo.length === 15) {
		        return check15IdCardNo(idCardNo);
		      }

		      return check18IdCardNo(idCardNo);
		    };

		    return checkIdCardNo(str);
		  },
		  'zh-TW': function zhTW(str) {
		    var ALPHABET_CODES = {
		      A: 10,
		      B: 11,
		      C: 12,
		      D: 13,
		      E: 14,
		      F: 15,
		      G: 16,
		      H: 17,
		      I: 34,
		      J: 18,
		      K: 19,
		      L: 20,
		      M: 21,
		      N: 22,
		      O: 35,
		      P: 23,
		      Q: 24,
		      R: 25,
		      S: 26,
		      T: 27,
		      U: 28,
		      V: 29,
		      W: 32,
		      X: 30,
		      Y: 31,
		      Z: 33
		    };
		    var sanitized = str.trim().toUpperCase();
		    if (!/^[A-Z][0-9]{9}$/.test(sanitized)) return false;
		    return Array.from(sanitized).reduce(function (sum, number, index) {
		      if (index === 0) {
		        var code = ALPHABET_CODES[number];
		        return code % 10 * 9 + Math.floor(code / 10);
		      }

		      if (index === 9) {
		        return (10 - sum % 10 - Number(number)) % 10 === 0;
		      }

		      return sum + Number(number) * (9 - index);
		    }, 0);
		  }
		};

		function isIdentityCard(str, locale) {
		  (0, _assertString.default)(str);

		  if (locale in validators) {
		    return validators[locale](str);
		  } else if (locale === 'any') {
		    for (var key in validators) {
		      // https://github.com/gotwarlost/istanbul/blob/master/ignoring-code-for-coverage.md#ignoring-code-for-coverage-purposes
		      // istanbul ignore else
		      if (validators.hasOwnProperty(key)) {
		        var validator = validators[key];

		        if (validator(str)) {
		          return true;
		        }
		      }
		    }

		    return false;
		  }

		  throw new Error("Invalid locale '".concat(locale, "'"));
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
	} (isIdentityCard, isIdentityCardExports));

	var isEANExports = {};
	var isEAN = {
	  get exports(){ return isEANExports; },
	  set exports(v){ isEANExports = v; },
	};

	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = isEAN;

		var _assertString = _interopRequireDefault(assertStringExports);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		/**
		 * The most commonly used EAN standard is
		 * the thirteen-digit EAN-13, while the
		 * less commonly used 8-digit EAN-8 barcode was
		 * introduced for use on small packages.
		 * Also EAN/UCC-14 is used for Grouping of individual
		 * trade items above unit level(Intermediate, Carton or Pallet).
		 * For more info about EAN-14 checkout: https://www.gtin.info/itf-14-barcodes/
		 * EAN consists of:
		 * GS1 prefix, manufacturer code, product code and check digit
		 * Reference: https://en.wikipedia.org/wiki/International_Article_Number
		 * Reference: https://www.gtin.info/
		 */

		/**
		 * Define EAN Lenghts; 8 for EAN-8; 13 for EAN-13; 14 for EAN-14
		 * and Regular Expression for valid EANs (EAN-8, EAN-13, EAN-14),
		 * with exact numberic matching of 8 or 13 or 14 digits [0-9]
		 */
		var LENGTH_EAN_8 = 8;
		var LENGTH_EAN_14 = 14;
		var validEanRegex = /^(\d{8}|\d{13}|\d{14})$/;
		/**
		 * Get position weight given:
		 * EAN length and digit index/position
		 *
		 * @param {number} length
		 * @param {number} index
		 * @return {number}
		 */

		function getPositionWeightThroughLengthAndIndex(length, index) {
		  if (length === LENGTH_EAN_8 || length === LENGTH_EAN_14) {
		    return index % 2 === 0 ? 3 : 1;
		  }

		  return index % 2 === 0 ? 1 : 3;
		}
		/**
		 * Calculate EAN Check Digit
		 * Reference: https://en.wikipedia.org/wiki/International_Article_Number#Calculation_of_checksum_digit
		 *
		 * @param {string} ean
		 * @return {number}
		 */


		function calculateCheckDigit(ean) {
		  var checksum = ean.slice(0, -1).split('').map(function (char, index) {
		    return Number(char) * getPositionWeightThroughLengthAndIndex(ean.length, index);
		  }).reduce(function (acc, partialSum) {
		    return acc + partialSum;
		  }, 0);
		  var remainder = 10 - checksum % 10;
		  return remainder < 10 ? remainder : 0;
		}
		/**
		 * Check if string is valid EAN:
		 * Matches EAN-8/EAN-13/EAN-14 regex
		 * Has valid check digit.
		 *
		 * @param {string} str
		 * @return {boolean}
		 */


		function isEAN(str) {
		  (0, _assertString.default)(str);
		  var actualCheckDigit = Number(str.slice(-1));
		  return validEanRegex.test(str) && actualCheckDigit === calculateCheckDigit(str);
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
	} (isEAN, isEANExports));

	var isISINExports = {};
	var isISIN = {
	  get exports(){ return isISINExports; },
	  set exports(v){ isISINExports = v; },
	};

	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = isISIN;

		var _assertString = _interopRequireDefault(assertStringExports);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		var isin = /^[A-Z]{2}[0-9A-Z]{9}[0-9]$/; // this link details how the check digit is calculated:
		// https://www.isin.org/isin-format/. it is a little bit
		// odd in that it works with digits, not numbers. in order
		// to make only one pass through the ISIN characters, the
		// each alpha character is handled as 2 characters within
		// the loop.

		function isISIN(str) {
		  (0, _assertString.default)(str);

		  if (!isin.test(str)) {
		    return false;
		  }

		  var double = true;
		  var sum = 0; // convert values

		  for (var i = str.length - 2; i >= 0; i--) {
		    if (str[i] >= 'A' && str[i] <= 'Z') {
		      var value = str[i].charCodeAt(0) - 55;
		      var lo = value % 10;
		      var hi = Math.trunc(value / 10); // letters have two digits, so handle the low order
		      // and high order digits separately.

		      for (var _i = 0, _arr = [lo, hi]; _i < _arr.length; _i++) {
		        var digit = _arr[_i];

		        if (double) {
		          if (digit >= 5) {
		            sum += 1 + (digit - 5) * 2;
		          } else {
		            sum += digit * 2;
		          }
		        } else {
		          sum += digit;
		        }

		        double = !double;
		      }
		    } else {
		      var _digit = str[i].charCodeAt(0) - '0'.charCodeAt(0);

		      if (double) {
		        if (_digit >= 5) {
		          sum += 1 + (_digit - 5) * 2;
		        } else {
		          sum += _digit * 2;
		        }
		      } else {
		        sum += _digit;
		      }

		      double = !double;
		    }
		  }

		  var check = Math.trunc((sum + 9) / 10) * 10 - sum;
		  return +str[str.length - 1] === check;
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
	} (isISIN, isISINExports));

	var isISBNExports = {};
	var isISBN = {
	  get exports(){ return isISBNExports; },
	  set exports(v){ isISBNExports = v; },
	};

	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = isISBN;

		var _assertString = _interopRequireDefault(assertStringExports);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		var isbn10Maybe = /^(?:[0-9]{9}X|[0-9]{10})$/;
		var isbn13Maybe = /^(?:[0-9]{13})$/;
		var factor = [1, 3];

		function isISBN(str) {
		  var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
		  (0, _assertString.default)(str);
		  version = String(version);

		  if (!version) {
		    return isISBN(str, 10) || isISBN(str, 13);
		  }

		  var sanitized = str.replace(/[\s-]+/g, '');
		  var checksum = 0;
		  var i;

		  if (version === '10') {
		    if (!isbn10Maybe.test(sanitized)) {
		      return false;
		    }

		    for (i = 0; i < 9; i++) {
		      checksum += (i + 1) * sanitized.charAt(i);
		    }

		    if (sanitized.charAt(9) === 'X') {
		      checksum += 10 * 10;
		    } else {
		      checksum += 10 * sanitized.charAt(9);
		    }

		    if (checksum % 11 === 0) {
		      return !!sanitized;
		    }
		  } else if (version === '13') {
		    if (!isbn13Maybe.test(sanitized)) {
		      return false;
		    }

		    for (i = 0; i < 12; i++) {
		      checksum += factor[i % 2] * sanitized.charAt(i);
		    }

		    if (sanitized.charAt(12) - (10 - checksum % 10) % 10 === 0) {
		      return !!sanitized;
		    }
		  }

		  return false;
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
	} (isISBN, isISBNExports));

	var isISSNExports = {};
	var isISSN = {
	  get exports(){ return isISSNExports; },
	  set exports(v){ isISSNExports = v; },
	};

	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = isISSN;

		var _assertString = _interopRequireDefault(assertStringExports);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		var issn = '^\\d{4}-?\\d{3}[\\dX]$';

		function isISSN(str) {
		  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
		  (0, _assertString.default)(str);
		  var testIssn = issn;
		  testIssn = options.require_hyphen ? testIssn.replace('?', '') : testIssn;
		  testIssn = options.case_sensitive ? new RegExp(testIssn) : new RegExp(testIssn, 'i');

		  if (!testIssn.test(str)) {
		    return false;
		  }

		  var digits = str.replace('-', '').toUpperCase();
		  var checksum = 0;

		  for (var i = 0; i < digits.length; i++) {
		    var digit = digits[i];
		    checksum += (digit === 'X' ? 10 : +digit) * (8 - i);
		  }

		  return checksum % 11 === 0;
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
	} (isISSN, isISSNExports));

	var isTaxIDExports = {};
	var isTaxID = {
	  get exports(){ return isTaxIDExports; },
	  set exports(v){ isTaxIDExports = v; },
	};

	var algorithms = {};

	Object.defineProperty(algorithms, "__esModule", {
	  value: true
	});
	algorithms.iso7064Check = iso7064Check;
	algorithms.luhnCheck = luhnCheck;
	algorithms.reverseMultiplyAndSum = reverseMultiplyAndSum;
	algorithms.verhoeffCheck = verhoeffCheck;

	/**
	 * Algorithmic validation functions
	 * May be used as is or implemented in the workflow of other validators.
	 */

	/*
	 * ISO 7064 validation function
	 * Called with a string of numbers (incl. check digit)
	 * to validate according to ISO 7064 (MOD 11, 10).
	 */
	function iso7064Check(str) {
	  var checkvalue = 10;

	  for (var i = 0; i < str.length - 1; i++) {
	    checkvalue = (parseInt(str[i], 10) + checkvalue) % 10 === 0 ? 10 * 2 % 11 : (parseInt(str[i], 10) + checkvalue) % 10 * 2 % 11;
	  }

	  checkvalue = checkvalue === 1 ? 0 : 11 - checkvalue;
	  return checkvalue === parseInt(str[10], 10);
	}
	/*
	 * Luhn (mod 10) validation function
	 * Called with a string of numbers (incl. check digit)
	 * to validate according to the Luhn algorithm.
	 */


	function luhnCheck(str) {
	  var checksum = 0;
	  var second = false;

	  for (var i = str.length - 1; i >= 0; i--) {
	    if (second) {
	      var product = parseInt(str[i], 10) * 2;

	      if (product > 9) {
	        // sum digits of product and add to checksum
	        checksum += product.toString().split('').map(function (a) {
	          return parseInt(a, 10);
	        }).reduce(function (a, b) {
	          return a + b;
	        }, 0);
	      } else {
	        checksum += product;
	      }
	    } else {
	      checksum += parseInt(str[i], 10);
	    }

	    second = !second;
	  }

	  return checksum % 10 === 0;
	}
	/*
	 * Reverse TIN multiplication and summation helper function
	 * Called with an array of single-digit integers and a base multiplier
	 * to calculate the sum of the digits multiplied in reverse.
	 * Normally used in variations of MOD 11 algorithmic checks.
	 */


	function reverseMultiplyAndSum(digits, base) {
	  var total = 0;

	  for (var i = 0; i < digits.length; i++) {
	    total += digits[i] * (base - i);
	  }

	  return total;
	}
	/*
	 * Verhoeff validation helper function
	 * Called with a string of numbers
	 * to validate according to the Verhoeff algorithm.
	 */


	function verhoeffCheck(str) {
	  var d_table = [[0, 1, 2, 3, 4, 5, 6, 7, 8, 9], [1, 2, 3, 4, 0, 6, 7, 8, 9, 5], [2, 3, 4, 0, 1, 7, 8, 9, 5, 6], [3, 4, 0, 1, 2, 8, 9, 5, 6, 7], [4, 0, 1, 2, 3, 9, 5, 6, 7, 8], [5, 9, 8, 7, 6, 0, 4, 3, 2, 1], [6, 5, 9, 8, 7, 1, 0, 4, 3, 2], [7, 6, 5, 9, 8, 2, 1, 0, 4, 3], [8, 7, 6, 5, 9, 3, 2, 1, 0, 4], [9, 8, 7, 6, 5, 4, 3, 2, 1, 0]];
	  var p_table = [[0, 1, 2, 3, 4, 5, 6, 7, 8, 9], [1, 5, 7, 6, 2, 8, 3, 0, 9, 4], [5, 8, 0, 3, 7, 9, 6, 1, 4, 2], [8, 9, 1, 6, 0, 4, 3, 5, 2, 7], [9, 4, 5, 3, 1, 2, 6, 8, 7, 0], [4, 2, 8, 6, 5, 7, 3, 9, 0, 1], [2, 7, 9, 3, 8, 0, 6, 4, 1, 5], [7, 0, 4, 6, 9, 1, 3, 2, 5, 8]]; // Copy (to prevent replacement) and reverse

	  var str_copy = str.split('').reverse().join('');
	  var checksum = 0;

	  for (var i = 0; i < str_copy.length; i++) {
	    checksum = d_table[checksum][p_table[i % 8][parseInt(str_copy[i], 10)]];
	  }

	  return checksum === 0;
	}

	(function (module, exports) {

		function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = isTaxID;

		var _assertString = _interopRequireDefault(assertStringExports);

		var algorithms$1 = _interopRequireWildcard(algorithms);

		var _isDate = _interopRequireDefault(isDateExports);

		function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

		function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

		function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

		function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

		function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

		function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

		function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

		/**
		 * TIN Validation
		 * Validates Tax Identification Numbers (TINs) from the US, EU member states and the United Kingdom.
		 *
		 * EU-UK:
		 * National TIN validity is calculated using public algorithms as made available by DG TAXUD.
		 *
		 * See `https://ec.europa.eu/taxation_customs/tin/specs/FS-TIN%20Algorithms-Public.docx` for more information.
		 *
		 * US:
		 * An Employer Identification Number (EIN), also known as a Federal Tax Identification Number,
		 *  is used to identify a business entity.
		 *
		 * NOTES:
		 *  - Prefix 47 is being reserved for future use
		 *  - Prefixes 26, 27, 45, 46 and 47 were previously assigned by the Philadelphia campus.
		 *
		 * See `http://www.irs.gov/Businesses/Small-Businesses-&-Self-Employed/How-EINs-are-Assigned-and-Valid-EIN-Prefixes`
		 * for more information.
		 */
		// Locale functions

		/*
		 * bg-BG validation function
		 * (Edinen graždanski nomer (EGN/ЕГН), persons only)
		 * Checks if birth date (first six digits) is valid and calculates check (last) digit
		 */
		function bgBgCheck(tin) {
		  // Extract full year, normalize month and check birth date validity
		  var century_year = tin.slice(0, 2);
		  var month = parseInt(tin.slice(2, 4), 10);

		  if (month > 40) {
		    month -= 40;
		    century_year = "20".concat(century_year);
		  } else if (month > 20) {
		    month -= 20;
		    century_year = "18".concat(century_year);
		  } else {
		    century_year = "19".concat(century_year);
		  }

		  if (month < 10) {
		    month = "0".concat(month);
		  }

		  var date = "".concat(century_year, "/").concat(month, "/").concat(tin.slice(4, 6));

		  if (!(0, _isDate.default)(date, 'YYYY/MM/DD')) {
		    return false;
		  } // split digits into an array for further processing


		  var digits = tin.split('').map(function (a) {
		    return parseInt(a, 10);
		  }); // Calculate checksum by multiplying digits with fixed values

		  var multip_lookup = [2, 4, 8, 5, 10, 9, 7, 3, 6];
		  var checksum = 0;

		  for (var i = 0; i < multip_lookup.length; i++) {
		    checksum += digits[i] * multip_lookup[i];
		  }

		  checksum = checksum % 11 === 10 ? 0 : checksum % 11;
		  return checksum === digits[9];
		}
		/*
		 * cs-CZ validation function
		 * (Rodné číslo (RČ), persons only)
		 * Checks if birth date (first six digits) is valid and divisibility by 11
		 * Material not in DG TAXUD document sourced from:
		 * -`https://lorenc.info/3MA381/overeni-spravnosti-rodneho-cisla.htm`
		 * -`https://www.mvcr.cz/clanek/rady-a-sluzby-dokumenty-rodne-cislo.aspx`
		 */


		function csCzCheck(tin) {
		  tin = tin.replace(/\W/, ''); // Extract full year from TIN length

		  var full_year = parseInt(tin.slice(0, 2), 10);

		  if (tin.length === 10) {
		    if (full_year < 54) {
		      full_year = "20".concat(full_year);
		    } else {
		      full_year = "19".concat(full_year);
		    }
		  } else {
		    if (tin.slice(6) === '000') {
		      return false;
		    } // Three-zero serial not assigned before 1954


		    if (full_year < 54) {
		      full_year = "19".concat(full_year);
		    } else {
		      return false; // No 18XX years seen in any of the resources
		    }
		  } // Add missing zero if needed


		  if (full_year.length === 3) {
		    full_year = [full_year.slice(0, 2), '0', full_year.slice(2)].join('');
		  } // Extract month from TIN and normalize


		  var month = parseInt(tin.slice(2, 4), 10);

		  if (month > 50) {
		    month -= 50;
		  }

		  if (month > 20) {
		    // Month-plus-twenty was only introduced in 2004
		    if (parseInt(full_year, 10) < 2004) {
		      return false;
		    }

		    month -= 20;
		  }

		  if (month < 10) {
		    month = "0".concat(month);
		  } // Check date validity


		  var date = "".concat(full_year, "/").concat(month, "/").concat(tin.slice(4, 6));

		  if (!(0, _isDate.default)(date, 'YYYY/MM/DD')) {
		    return false;
		  } // Verify divisibility by 11


		  if (tin.length === 10) {
		    if (parseInt(tin, 10) % 11 !== 0) {
		      // Some numbers up to and including 1985 are still valid if
		      // check (last) digit equals 0 and modulo of first 9 digits equals 10
		      var checkdigit = parseInt(tin.slice(0, 9), 10) % 11;

		      if (parseInt(full_year, 10) < 1986 && checkdigit === 10) {
		        if (parseInt(tin.slice(9), 10) !== 0) {
		          return false;
		        }
		      } else {
		        return false;
		      }
		    }
		  }

		  return true;
		}
		/*
		 * de-AT validation function
		 * (Abgabenkontonummer, persons/entities)
		 * Verify TIN validity by calling luhnCheck()
		 */


		function deAtCheck(tin) {
		  return algorithms$1.luhnCheck(tin);
		}
		/*
		 * de-DE validation function
		 * (Steueridentifikationsnummer (Steuer-IdNr.), persons only)
		 * Tests for single duplicate/triplicate value, then calculates ISO 7064 check (last) digit
		 * Partial implementation of spec (same result with both algorithms always)
		 */


		function deDeCheck(tin) {
		  // Split digits into an array for further processing
		  var digits = tin.split('').map(function (a) {
		    return parseInt(a, 10);
		  }); // Fill array with strings of number positions

		  var occurences = [];

		  for (var i = 0; i < digits.length - 1; i++) {
		    occurences.push('');

		    for (var j = 0; j < digits.length - 1; j++) {
		      if (digits[i] === digits[j]) {
		        occurences[i] += j;
		      }
		    }
		  } // Remove digits with one occurence and test for only one duplicate/triplicate


		  occurences = occurences.filter(function (a) {
		    return a.length > 1;
		  });

		  if (occurences.length !== 2 && occurences.length !== 3) {
		    return false;
		  } // In case of triplicate value only two digits are allowed next to each other


		  if (occurences[0].length === 3) {
		    var trip_locations = occurences[0].split('').map(function (a) {
		      return parseInt(a, 10);
		    });
		    var recurrent = 0; // Amount of neighbour occurences

		    for (var _i = 0; _i < trip_locations.length - 1; _i++) {
		      if (trip_locations[_i] + 1 === trip_locations[_i + 1]) {
		        recurrent += 1;
		      }
		    }

		    if (recurrent === 2) {
		      return false;
		    }
		  }

		  return algorithms$1.iso7064Check(tin);
		}
		/*
		 * dk-DK validation function
		 * (CPR-nummer (personnummer), persons only)
		 * Checks if birth date (first six digits) is valid and assigned to century (seventh) digit,
		 * and calculates check (last) digit
		 */


		function dkDkCheck(tin) {
		  tin = tin.replace(/\W/, ''); // Extract year, check if valid for given century digit and add century

		  var year = parseInt(tin.slice(4, 6), 10);
		  var century_digit = tin.slice(6, 7);

		  switch (century_digit) {
		    case '0':
		    case '1':
		    case '2':
		    case '3':
		      year = "19".concat(year);
		      break;

		    case '4':
		    case '9':
		      if (year < 37) {
		        year = "20".concat(year);
		      } else {
		        year = "19".concat(year);
		      }

		      break;

		    default:
		      if (year < 37) {
		        year = "20".concat(year);
		      } else if (year > 58) {
		        year = "18".concat(year);
		      } else {
		        return false;
		      }

		      break;
		  } // Add missing zero if needed


		  if (year.length === 3) {
		    year = [year.slice(0, 2), '0', year.slice(2)].join('');
		  } // Check date validity


		  var date = "".concat(year, "/").concat(tin.slice(2, 4), "/").concat(tin.slice(0, 2));

		  if (!(0, _isDate.default)(date, 'YYYY/MM/DD')) {
		    return false;
		  } // Split digits into an array for further processing


		  var digits = tin.split('').map(function (a) {
		    return parseInt(a, 10);
		  });
		  var checksum = 0;
		  var weight = 4; // Multiply by weight and add to checksum

		  for (var i = 0; i < 9; i++) {
		    checksum += digits[i] * weight;
		    weight -= 1;

		    if (weight === 1) {
		      weight = 7;
		    }
		  }

		  checksum %= 11;

		  if (checksum === 1) {
		    return false;
		  }

		  return checksum === 0 ? digits[9] === 0 : digits[9] === 11 - checksum;
		}
		/*
		 * el-CY validation function
		 * (Arithmos Forologikou Mitroou (AFM/ΑΦΜ), persons only)
		 * Verify TIN validity by calculating ASCII value of check (last) character
		 */


		function elCyCheck(tin) {
		  // split digits into an array for further processing
		  var digits = tin.slice(0, 8).split('').map(function (a) {
		    return parseInt(a, 10);
		  });
		  var checksum = 0; // add digits in even places

		  for (var i = 1; i < digits.length; i += 2) {
		    checksum += digits[i];
		  } // add digits in odd places


		  for (var _i2 = 0; _i2 < digits.length; _i2 += 2) {
		    if (digits[_i2] < 2) {
		      checksum += 1 - digits[_i2];
		    } else {
		      checksum += 2 * (digits[_i2] - 2) + 5;

		      if (digits[_i2] > 4) {
		        checksum += 2;
		      }
		    }
		  }

		  return String.fromCharCode(checksum % 26 + 65) === tin.charAt(8);
		}
		/*
		 * el-GR validation function
		 * (Arithmos Forologikou Mitroou (AFM/ΑΦΜ), persons/entities)
		 * Verify TIN validity by calculating check (last) digit
		 * Algorithm not in DG TAXUD document- sourced from:
		 * - `http://epixeirisi.gr/%CE%9A%CE%A1%CE%99%CE%A3%CE%99%CE%9C%CE%91-%CE%98%CE%95%CE%9C%CE%91%CE%A4%CE%91-%CE%A6%CE%9F%CE%A1%CE%9F%CE%9B%CE%9F%CE%93%CE%99%CE%91%CE%A3-%CE%9A%CE%91%CE%99-%CE%9B%CE%9F%CE%93%CE%99%CE%A3%CE%A4%CE%99%CE%9A%CE%97%CE%A3/23791/%CE%91%CF%81%CE%B9%CE%B8%CE%BC%CF%8C%CF%82-%CE%A6%CE%BF%CF%81%CE%BF%CE%BB%CE%BF%CE%B3%CE%B9%CE%BA%CE%BF%CF%8D-%CE%9C%CE%B7%CF%84%CF%81%CF%8E%CE%BF%CF%85`
		 */


		function elGrCheck(tin) {
		  // split digits into an array for further processing
		  var digits = tin.split('').map(function (a) {
		    return parseInt(a, 10);
		  });
		  var checksum = 0;

		  for (var i = 0; i < 8; i++) {
		    checksum += digits[i] * Math.pow(2, 8 - i);
		  }

		  return checksum % 11 % 10 === digits[8];
		}
		/*
		 * en-GB validation function (should go here if needed)
		 * (National Insurance Number (NINO) or Unique Taxpayer Reference (UTR),
		 * persons/entities respectively)
		 */

		/*
		 * en-IE validation function
		 * (Personal Public Service Number (PPS No), persons only)
		 * Verify TIN validity by calculating check (second to last) character
		 */


		function enIeCheck(tin) {
		  var checksum = algorithms$1.reverseMultiplyAndSum(tin.split('').slice(0, 7).map(function (a) {
		    return parseInt(a, 10);
		  }), 8);

		  if (tin.length === 9 && tin[8] !== 'W') {
		    checksum += (tin[8].charCodeAt(0) - 64) * 9;
		  }

		  checksum %= 23;

		  if (checksum === 0) {
		    return tin[7].toUpperCase() === 'W';
		  }

		  return tin[7].toUpperCase() === String.fromCharCode(64 + checksum);
		} // Valid US IRS campus prefixes


		var enUsCampusPrefix = {
		  andover: ['10', '12'],
		  atlanta: ['60', '67'],
		  austin: ['50', '53'],
		  brookhaven: ['01', '02', '03', '04', '05', '06', '11', '13', '14', '16', '21', '22', '23', '25', '34', '51', '52', '54', '55', '56', '57', '58', '59', '65'],
		  cincinnati: ['30', '32', '35', '36', '37', '38', '61'],
		  fresno: ['15', '24'],
		  internet: ['20', '26', '27', '45', '46', '47'],
		  kansas: ['40', '44'],
		  memphis: ['94', '95'],
		  ogden: ['80', '90'],
		  philadelphia: ['33', '39', '41', '42', '43', '46', '48', '62', '63', '64', '66', '68', '71', '72', '73', '74', '75', '76', '77', '81', '82', '83', '84', '85', '86', '87', '88', '91', '92', '93', '98', '99'],
		  sba: ['31']
		}; // Return an array of all US IRS campus prefixes

		function enUsGetPrefixes() {
		  var prefixes = [];

		  for (var location in enUsCampusPrefix) {
		    // https://github.com/gotwarlost/istanbul/blob/master/ignoring-code-for-coverage.md#ignoring-code-for-coverage-purposes
		    // istanbul ignore else
		    if (enUsCampusPrefix.hasOwnProperty(location)) {
		      prefixes.push.apply(prefixes, _toConsumableArray(enUsCampusPrefix[location]));
		    }
		  }

		  return prefixes;
		}
		/*
		 * en-US validation function
		 * Verify that the TIN starts with a valid IRS campus prefix
		 */


		function enUsCheck(tin) {
		  return enUsGetPrefixes().indexOf(tin.substr(0, 2)) !== -1;
		}
		/*
		 * es-ES validation function
		 * (Documento Nacional de Identidad (DNI)
		 * or Número de Identificación de Extranjero (NIE), persons only)
		 * Verify TIN validity by calculating check (last) character
		 */


		function esEsCheck(tin) {
		  // Split characters into an array for further processing
		  var chars = tin.toUpperCase().split(''); // Replace initial letter if needed

		  if (isNaN(parseInt(chars[0], 10)) && chars.length > 1) {
		    var lead_replace = 0;

		    switch (chars[0]) {
		      case 'Y':
		        lead_replace = 1;
		        break;

		      case 'Z':
		        lead_replace = 2;
		        break;
		    }

		    chars.splice(0, 1, lead_replace); // Fill with zeros if smaller than proper
		  } else {
		    while (chars.length < 9) {
		      chars.unshift(0);
		    }
		  } // Calculate checksum and check according to lookup


		  var lookup = ['T', 'R', 'W', 'A', 'G', 'M', 'Y', 'F', 'P', 'D', 'X', 'B', 'N', 'J', 'Z', 'S', 'Q', 'V', 'H', 'L', 'C', 'K', 'E'];
		  chars = chars.join('');
		  var checksum = parseInt(chars.slice(0, 8), 10) % 23;
		  return chars[8] === lookup[checksum];
		}
		/*
		 * et-EE validation function
		 * (Isikukood (IK), persons only)
		 * Checks if birth date (century digit and six following) is valid and calculates check (last) digit
		 * Material not in DG TAXUD document sourced from:
		 * - `https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Estonia-TIN.pdf`
		 */


		function etEeCheck(tin) {
		  // Extract year and add century
		  var full_year = tin.slice(1, 3);
		  var century_digit = tin.slice(0, 1);

		  switch (century_digit) {
		    case '1':
		    case '2':
		      full_year = "18".concat(full_year);
		      break;

		    case '3':
		    case '4':
		      full_year = "19".concat(full_year);
		      break;

		    default:
		      full_year = "20".concat(full_year);
		      break;
		  } // Check date validity


		  var date = "".concat(full_year, "/").concat(tin.slice(3, 5), "/").concat(tin.slice(5, 7));

		  if (!(0, _isDate.default)(date, 'YYYY/MM/DD')) {
		    return false;
		  } // Split digits into an array for further processing


		  var digits = tin.split('').map(function (a) {
		    return parseInt(a, 10);
		  });
		  var checksum = 0;
		  var weight = 1; // Multiply by weight and add to checksum

		  for (var i = 0; i < 10; i++) {
		    checksum += digits[i] * weight;
		    weight += 1;

		    if (weight === 10) {
		      weight = 1;
		    }
		  } // Do again if modulo 11 of checksum is 10


		  if (checksum % 11 === 10) {
		    checksum = 0;
		    weight = 3;

		    for (var _i3 = 0; _i3 < 10; _i3++) {
		      checksum += digits[_i3] * weight;
		      weight += 1;

		      if (weight === 10) {
		        weight = 1;
		      }
		    }

		    if (checksum % 11 === 10) {
		      return digits[10] === 0;
		    }
		  }

		  return checksum % 11 === digits[10];
		}
		/*
		 * fi-FI validation function
		 * (Henkilötunnus (HETU), persons only)
		 * Checks if birth date (first six digits plus century symbol) is valid
		 * and calculates check (last) digit
		 */


		function fiFiCheck(tin) {
		  // Extract year and add century
		  var full_year = tin.slice(4, 6);
		  var century_symbol = tin.slice(6, 7);

		  switch (century_symbol) {
		    case '+':
		      full_year = "18".concat(full_year);
		      break;

		    case '-':
		      full_year = "19".concat(full_year);
		      break;

		    default:
		      full_year = "20".concat(full_year);
		      break;
		  } // Check date validity


		  var date = "".concat(full_year, "/").concat(tin.slice(2, 4), "/").concat(tin.slice(0, 2));

		  if (!(0, _isDate.default)(date, 'YYYY/MM/DD')) {
		    return false;
		  } // Calculate check character


		  var checksum = parseInt(tin.slice(0, 6) + tin.slice(7, 10), 10) % 31;

		  if (checksum < 10) {
		    return checksum === parseInt(tin.slice(10), 10);
		  }

		  checksum -= 10;
		  var letters_lookup = ['A', 'B', 'C', 'D', 'E', 'F', 'H', 'J', 'K', 'L', 'M', 'N', 'P', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y'];
		  return letters_lookup[checksum] === tin.slice(10);
		}
		/*
		 * fr/nl-BE validation function
		 * (Numéro national (N.N.), persons only)
		 * Checks if birth date (first six digits) is valid and calculates check (last two) digits
		 */


		function frBeCheck(tin) {
		  // Zero month/day value is acceptable
		  if (tin.slice(2, 4) !== '00' || tin.slice(4, 6) !== '00') {
		    // Extract date from first six digits of TIN
		    var date = "".concat(tin.slice(0, 2), "/").concat(tin.slice(2, 4), "/").concat(tin.slice(4, 6));

		    if (!(0, _isDate.default)(date, 'YY/MM/DD')) {
		      return false;
		    }
		  }

		  var checksum = 97 - parseInt(tin.slice(0, 9), 10) % 97;
		  var checkdigits = parseInt(tin.slice(9, 11), 10);

		  if (checksum !== checkdigits) {
		    checksum = 97 - parseInt("2".concat(tin.slice(0, 9)), 10) % 97;

		    if (checksum !== checkdigits) {
		      return false;
		    }
		  }

		  return true;
		}
		/*
		 * fr-FR validation function
		 * (Numéro fiscal de référence (numéro SPI), persons only)
		 * Verify TIN validity by calculating check (last three) digits
		 */


		function frFrCheck(tin) {
		  tin = tin.replace(/\s/g, '');
		  var checksum = parseInt(tin.slice(0, 10), 10) % 511;
		  var checkdigits = parseInt(tin.slice(10, 13), 10);
		  return checksum === checkdigits;
		}
		/*
		 * fr/lb-LU validation function
		 * (numéro d’identification personnelle, persons only)
		 * Verify birth date validity and run Luhn and Verhoeff checks
		 */


		function frLuCheck(tin) {
		  // Extract date and check validity
		  var date = "".concat(tin.slice(0, 4), "/").concat(tin.slice(4, 6), "/").concat(tin.slice(6, 8));

		  if (!(0, _isDate.default)(date, 'YYYY/MM/DD')) {
		    return false;
		  } // Run Luhn check


		  if (!algorithms$1.luhnCheck(tin.slice(0, 12))) {
		    return false;
		  } // Remove Luhn check digit and run Verhoeff check


		  return algorithms$1.verhoeffCheck("".concat(tin.slice(0, 11)).concat(tin[12]));
		}
		/*
		 * hr-HR validation function
		 * (Osobni identifikacijski broj (OIB), persons/entities)
		 * Verify TIN validity by calling iso7064Check(digits)
		 */


		function hrHrCheck(tin) {
		  return algorithms$1.iso7064Check(tin);
		}
		/*
		 * hu-HU validation function
		 * (Adóazonosító jel, persons only)
		 * Verify TIN validity by calculating check (last) digit
		 */


		function huHuCheck(tin) {
		  // split digits into an array for further processing
		  var digits = tin.split('').map(function (a) {
		    return parseInt(a, 10);
		  });
		  var checksum = 8;

		  for (var i = 1; i < 9; i++) {
		    checksum += digits[i] * (i + 1);
		  }

		  return checksum % 11 === digits[9];
		}
		/*
		 * lt-LT validation function (should go here if needed)
		 * (Asmens kodas, persons/entities respectively)
		 * Current validation check is alias of etEeCheck- same format applies
		 */

		/*
		 * it-IT first/last name validity check
		 * Accepts it-IT TIN-encoded names as a three-element character array and checks their validity
		 * Due to lack of clarity between resources ("Are only Italian consonants used?
		 * What happens if a person has X in their name?" etc.) only two test conditions
		 * have been implemented:
		 * Vowels may only be followed by other vowels or an X character
		 * and X characters after vowels may only be followed by other X characters.
		 */


		function itItNameCheck(name) {
		  // true at the first occurence of a vowel
		  var vowelflag = false; // true at the first occurence of an X AFTER vowel
		  // (to properly handle last names with X as consonant)

		  var xflag = false;

		  for (var i = 0; i < 3; i++) {
		    if (!vowelflag && /[AEIOU]/.test(name[i])) {
		      vowelflag = true;
		    } else if (!xflag && vowelflag && name[i] === 'X') {
		      xflag = true;
		    } else if (i > 0) {
		      if (vowelflag && !xflag) {
		        if (!/[AEIOU]/.test(name[i])) {
		          return false;
		        }
		      }

		      if (xflag) {
		        if (!/X/.test(name[i])) {
		          return false;
		        }
		      }
		    }
		  }

		  return true;
		}
		/*
		 * it-IT validation function
		 * (Codice fiscale (TIN-IT), persons only)
		 * Verify name, birth date and codice catastale validity
		 * and calculate check character.
		 * Material not in DG-TAXUD document sourced from:
		 * `https://en.wikipedia.org/wiki/Italian_fiscal_code`
		 */


		function itItCheck(tin) {
		  // Capitalize and split characters into an array for further processing
		  var chars = tin.toUpperCase().split(''); // Check first and last name validity calling itItNameCheck()

		  if (!itItNameCheck(chars.slice(0, 3))) {
		    return false;
		  }

		  if (!itItNameCheck(chars.slice(3, 6))) {
		    return false;
		  } // Convert letters in number spaces back to numbers if any


		  var number_locations = [6, 7, 9, 10, 12, 13, 14];
		  var number_replace = {
		    L: '0',
		    M: '1',
		    N: '2',
		    P: '3',
		    Q: '4',
		    R: '5',
		    S: '6',
		    T: '7',
		    U: '8',
		    V: '9'
		  };

		  for (var _i4 = 0, _number_locations = number_locations; _i4 < _number_locations.length; _i4++) {
		    var i = _number_locations[_i4];

		    if (chars[i] in number_replace) {
		      chars.splice(i, 1, number_replace[chars[i]]);
		    }
		  } // Extract month and day, and check date validity


		  var month_replace = {
		    A: '01',
		    B: '02',
		    C: '03',
		    D: '04',
		    E: '05',
		    H: '06',
		    L: '07',
		    M: '08',
		    P: '09',
		    R: '10',
		    S: '11',
		    T: '12'
		  };
		  var month = month_replace[chars[8]];
		  var day = parseInt(chars[9] + chars[10], 10);

		  if (day > 40) {
		    day -= 40;
		  }

		  if (day < 10) {
		    day = "0".concat(day);
		  }

		  var date = "".concat(chars[6]).concat(chars[7], "/").concat(month, "/").concat(day);

		  if (!(0, _isDate.default)(date, 'YY/MM/DD')) {
		    return false;
		  } // Calculate check character by adding up even and odd characters as numbers


		  var checksum = 0;

		  for (var _i5 = 1; _i5 < chars.length - 1; _i5 += 2) {
		    var char_to_int = parseInt(chars[_i5], 10);

		    if (isNaN(char_to_int)) {
		      char_to_int = chars[_i5].charCodeAt(0) - 65;
		    }

		    checksum += char_to_int;
		  }

		  var odd_convert = {
		    // Maps of characters at odd places
		    A: 1,
		    B: 0,
		    C: 5,
		    D: 7,
		    E: 9,
		    F: 13,
		    G: 15,
		    H: 17,
		    I: 19,
		    J: 21,
		    K: 2,
		    L: 4,
		    M: 18,
		    N: 20,
		    O: 11,
		    P: 3,
		    Q: 6,
		    R: 8,
		    S: 12,
		    T: 14,
		    U: 16,
		    V: 10,
		    W: 22,
		    X: 25,
		    Y: 24,
		    Z: 23,
		    0: 1,
		    1: 0
		  };

		  for (var _i6 = 0; _i6 < chars.length - 1; _i6 += 2) {
		    var _char_to_int = 0;

		    if (chars[_i6] in odd_convert) {
		      _char_to_int = odd_convert[chars[_i6]];
		    } else {
		      var multiplier = parseInt(chars[_i6], 10);
		      _char_to_int = 2 * multiplier + 1;

		      if (multiplier > 4) {
		        _char_to_int += 2;
		      }
		    }

		    checksum += _char_to_int;
		  }

		  if (String.fromCharCode(65 + checksum % 26) !== chars[15]) {
		    return false;
		  }

		  return true;
		}
		/*
		 * lv-LV validation function
		 * (Personas kods (PK), persons only)
		 * Check validity of birth date and calculate check (last) digit
		 * Support only for old format numbers (not starting with '32', issued before 2017/07/01)
		 * Material not in DG TAXUD document sourced from:
		 * `https://boot.ritakafija.lv/forums/index.php?/topic/88314-personas-koda-algoritms-%C4%8Deksumma/`
		 */


		function lvLvCheck(tin) {
		  tin = tin.replace(/\W/, ''); // Extract date from TIN

		  var day = tin.slice(0, 2);

		  if (day !== '32') {
		    // No date/checksum check if new format
		    var month = tin.slice(2, 4);

		    if (month !== '00') {
		      // No date check if unknown month
		      var full_year = tin.slice(4, 6);

		      switch (tin[6]) {
		        case '0':
		          full_year = "18".concat(full_year);
		          break;

		        case '1':
		          full_year = "19".concat(full_year);
		          break;

		        default:
		          full_year = "20".concat(full_year);
		          break;
		      } // Check date validity


		      var date = "".concat(full_year, "/").concat(tin.slice(2, 4), "/").concat(day);

		      if (!(0, _isDate.default)(date, 'YYYY/MM/DD')) {
		        return false;
		      }
		    } // Calculate check digit


		    var checksum = 1101;
		    var multip_lookup = [1, 6, 3, 7, 9, 10, 5, 8, 4, 2];

		    for (var i = 0; i < tin.length - 1; i++) {
		      checksum -= parseInt(tin[i], 10) * multip_lookup[i];
		    }

		    return parseInt(tin[10], 10) === checksum % 11;
		  }

		  return true;
		}
		/*
		 * mt-MT validation function
		 * (Identity Card Number or Unique Taxpayer Reference, persons/entities)
		 * Verify Identity Card Number structure (no other tests found)
		 */


		function mtMtCheck(tin) {
		  if (tin.length !== 9) {
		    // No tests for UTR
		    var chars = tin.toUpperCase().split(''); // Fill with zeros if smaller than proper

		    while (chars.length < 8) {
		      chars.unshift(0);
		    } // Validate format according to last character


		    switch (tin[7]) {
		      case 'A':
		      case 'P':
		        if (parseInt(chars[6], 10) === 0) {
		          return false;
		        }

		        break;

		      default:
		        {
		          var first_part = parseInt(chars.join('').slice(0, 5), 10);

		          if (first_part > 32000) {
		            return false;
		          }

		          var second_part = parseInt(chars.join('').slice(5, 7), 10);

		          if (first_part === second_part) {
		            return false;
		          }
		        }
		    }
		  }

		  return true;
		}
		/*
		 * nl-NL validation function
		 * (Burgerservicenummer (BSN) or Rechtspersonen Samenwerkingsverbanden Informatie Nummer (RSIN),
		 * persons/entities respectively)
		 * Verify TIN validity by calculating check (last) digit (variant of MOD 11)
		 */


		function nlNlCheck(tin) {
		  return algorithms$1.reverseMultiplyAndSum(tin.split('').slice(0, 8).map(function (a) {
		    return parseInt(a, 10);
		  }), 9) % 11 === parseInt(tin[8], 10);
		}
		/*
		 * pl-PL validation function
		 * (Powszechny Elektroniczny System Ewidencji Ludności (PESEL)
		 * or Numer identyfikacji podatkowej (NIP), persons/entities)
		 * Verify TIN validity by validating birth date (PESEL) and calculating check (last) digit
		 */


		function plPlCheck(tin) {
		  // NIP
		  if (tin.length === 10) {
		    // Calculate last digit by multiplying with lookup
		    var lookup = [6, 5, 7, 2, 3, 4, 5, 6, 7];
		    var _checksum = 0;

		    for (var i = 0; i < lookup.length; i++) {
		      _checksum += parseInt(tin[i], 10) * lookup[i];
		    }

		    _checksum %= 11;

		    if (_checksum === 10) {
		      return false;
		    }

		    return _checksum === parseInt(tin[9], 10);
		  } // PESEL
		  // Extract full year using month


		  var full_year = tin.slice(0, 2);
		  var month = parseInt(tin.slice(2, 4), 10);

		  if (month > 80) {
		    full_year = "18".concat(full_year);
		    month -= 80;
		  } else if (month > 60) {
		    full_year = "22".concat(full_year);
		    month -= 60;
		  } else if (month > 40) {
		    full_year = "21".concat(full_year);
		    month -= 40;
		  } else if (month > 20) {
		    full_year = "20".concat(full_year);
		    month -= 20;
		  } else {
		    full_year = "19".concat(full_year);
		  } // Add leading zero to month if needed


		  if (month < 10) {
		    month = "0".concat(month);
		  } // Check date validity


		  var date = "".concat(full_year, "/").concat(month, "/").concat(tin.slice(4, 6));

		  if (!(0, _isDate.default)(date, 'YYYY/MM/DD')) {
		    return false;
		  } // Calculate last digit by mulitplying with odd one-digit numbers except 5


		  var checksum = 0;
		  var multiplier = 1;

		  for (var _i7 = 0; _i7 < tin.length - 1; _i7++) {
		    checksum += parseInt(tin[_i7], 10) * multiplier % 10;
		    multiplier += 2;

		    if (multiplier > 10) {
		      multiplier = 1;
		    } else if (multiplier === 5) {
		      multiplier += 2;
		    }
		  }

		  checksum = 10 - checksum % 10;
		  return checksum === parseInt(tin[10], 10);
		}
		/*
		* pt-BR validation function
		* (Cadastro de Pessoas Físicas (CPF, persons)
		* Cadastro Nacional de Pessoas Jurídicas (CNPJ, entities)
		* Both inputs will be validated
		*/


		function ptBrCheck(tin) {
		  if (tin.length === 11) {
		    var _sum;

		    var remainder;
		    _sum = 0;
		    if ( // Reject known invalid CPFs
		    tin === '11111111111' || tin === '22222222222' || tin === '33333333333' || tin === '44444444444' || tin === '55555555555' || tin === '66666666666' || tin === '77777777777' || tin === '88888888888' || tin === '99999999999' || tin === '00000000000') return false;

		    for (var i = 1; i <= 9; i++) {
		      _sum += parseInt(tin.substring(i - 1, i), 10) * (11 - i);
		    }

		    remainder = _sum * 10 % 11;
		    if (remainder === 10) remainder = 0;
		    if (remainder !== parseInt(tin.substring(9, 10), 10)) return false;
		    _sum = 0;

		    for (var _i8 = 1; _i8 <= 10; _i8++) {
		      _sum += parseInt(tin.substring(_i8 - 1, _i8), 10) * (12 - _i8);
		    }

		    remainder = _sum * 10 % 11;
		    if (remainder === 10) remainder = 0;
		    if (remainder !== parseInt(tin.substring(10, 11), 10)) return false;
		    return true;
		  }

		  if ( // Reject know invalid CNPJs
		  tin === '00000000000000' || tin === '11111111111111' || tin === '22222222222222' || tin === '33333333333333' || tin === '44444444444444' || tin === '55555555555555' || tin === '66666666666666' || tin === '77777777777777' || tin === '88888888888888' || tin === '99999999999999') {
		    return false;
		  }

		  var length = tin.length - 2;
		  var identifiers = tin.substring(0, length);
		  var verificators = tin.substring(length);
		  var sum = 0;
		  var pos = length - 7;

		  for (var _i9 = length; _i9 >= 1; _i9--) {
		    sum += identifiers.charAt(length - _i9) * pos;
		    pos -= 1;

		    if (pos < 2) {
		      pos = 9;
		    }
		  }

		  var result = sum % 11 < 2 ? 0 : 11 - sum % 11;

		  if (result !== parseInt(verificators.charAt(0), 10)) {
		    return false;
		  }

		  length += 1;
		  identifiers = tin.substring(0, length);
		  sum = 0;
		  pos = length - 7;

		  for (var _i10 = length; _i10 >= 1; _i10--) {
		    sum += identifiers.charAt(length - _i10) * pos;
		    pos -= 1;

		    if (pos < 2) {
		      pos = 9;
		    }
		  }

		  result = sum % 11 < 2 ? 0 : 11 - sum % 11;

		  if (result !== parseInt(verificators.charAt(1), 10)) {
		    return false;
		  }

		  return true;
		}
		/*
		 * pt-PT validation function
		 * (Número de identificação fiscal (NIF), persons/entities)
		 * Verify TIN validity by calculating check (last) digit (variant of MOD 11)
		 */


		function ptPtCheck(tin) {
		  var checksum = 11 - algorithms$1.reverseMultiplyAndSum(tin.split('').slice(0, 8).map(function (a) {
		    return parseInt(a, 10);
		  }), 9) % 11;

		  if (checksum > 9) {
		    return parseInt(tin[8], 10) === 0;
		  }

		  return checksum === parseInt(tin[8], 10);
		}
		/*
		 * ro-RO validation function
		 * (Cod Numeric Personal (CNP) or Cod de înregistrare fiscală (CIF),
		 * persons only)
		 * Verify CNP validity by calculating check (last) digit (test not found for CIF)
		 * Material not in DG TAXUD document sourced from:
		 * `https://en.wikipedia.org/wiki/National_identification_number#Romania`
		 */


		function roRoCheck(tin) {
		  if (tin.slice(0, 4) !== '9000') {
		    // No test found for this format
		    // Extract full year using century digit if possible
		    var full_year = tin.slice(1, 3);

		    switch (tin[0]) {
		      case '1':
		      case '2':
		        full_year = "19".concat(full_year);
		        break;

		      case '3':
		      case '4':
		        full_year = "18".concat(full_year);
		        break;

		      case '5':
		      case '6':
		        full_year = "20".concat(full_year);
		        break;
		    } // Check date validity


		    var date = "".concat(full_year, "/").concat(tin.slice(3, 5), "/").concat(tin.slice(5, 7));

		    if (date.length === 8) {
		      if (!(0, _isDate.default)(date, 'YY/MM/DD')) {
		        return false;
		      }
		    } else if (!(0, _isDate.default)(date, 'YYYY/MM/DD')) {
		      return false;
		    } // Calculate check digit


		    var digits = tin.split('').map(function (a) {
		      return parseInt(a, 10);
		    });
		    var multipliers = [2, 7, 9, 1, 4, 6, 3, 5, 8, 2, 7, 9];
		    var checksum = 0;

		    for (var i = 0; i < multipliers.length; i++) {
		      checksum += digits[i] * multipliers[i];
		    }

		    if (checksum % 11 === 10) {
		      return digits[12] === 1;
		    }

		    return digits[12] === checksum % 11;
		  }

		  return true;
		}
		/*
		 * sk-SK validation function
		 * (Rodné číslo (RČ) or bezvýznamové identifikačné číslo (BIČ), persons only)
		 * Checks validity of pre-1954 birth numbers (rodné číslo) only
		 * Due to the introduction of the pseudo-random BIČ it is not possible to test
		 * post-1954 birth numbers without knowing whether they are BIČ or RČ beforehand
		 */


		function skSkCheck(tin) {
		  if (tin.length === 9) {
		    tin = tin.replace(/\W/, '');

		    if (tin.slice(6) === '000') {
		      return false;
		    } // Three-zero serial not assigned before 1954
		    // Extract full year from TIN length


		    var full_year = parseInt(tin.slice(0, 2), 10);

		    if (full_year > 53) {
		      return false;
		    }

		    if (full_year < 10) {
		      full_year = "190".concat(full_year);
		    } else {
		      full_year = "19".concat(full_year);
		    } // Extract month from TIN and normalize


		    var month = parseInt(tin.slice(2, 4), 10);

		    if (month > 50) {
		      month -= 50;
		    }

		    if (month < 10) {
		      month = "0".concat(month);
		    } // Check date validity


		    var date = "".concat(full_year, "/").concat(month, "/").concat(tin.slice(4, 6));

		    if (!(0, _isDate.default)(date, 'YYYY/MM/DD')) {
		      return false;
		    }
		  }

		  return true;
		}
		/*
		 * sl-SI validation function
		 * (Davčna številka, persons/entities)
		 * Verify TIN validity by calculating check (last) digit (variant of MOD 11)
		 */


		function slSiCheck(tin) {
		  var checksum = 11 - algorithms$1.reverseMultiplyAndSum(tin.split('').slice(0, 7).map(function (a) {
		    return parseInt(a, 10);
		  }), 8) % 11;

		  if (checksum === 10) {
		    return parseInt(tin[7], 10) === 0;
		  }

		  return checksum === parseInt(tin[7], 10);
		}
		/*
		 * sv-SE validation function
		 * (Personnummer or samordningsnummer, persons only)
		 * Checks validity of birth date and calls luhnCheck() to validate check (last) digit
		 */


		function svSeCheck(tin) {
		  // Make copy of TIN and normalize to two-digit year form
		  var tin_copy = tin.slice(0);

		  if (tin.length > 11) {
		    tin_copy = tin_copy.slice(2);
		  } // Extract date of birth


		  var full_year = '';
		  var month = tin_copy.slice(2, 4);
		  var day = parseInt(tin_copy.slice(4, 6), 10);

		  if (tin.length > 11) {
		    full_year = tin.slice(0, 4);
		  } else {
		    full_year = tin.slice(0, 2);

		    if (tin.length === 11 && day < 60) {
		      // Extract full year from centenarian symbol
		      // Should work just fine until year 10000 or so
		      var current_year = new Date().getFullYear().toString();
		      var current_century = parseInt(current_year.slice(0, 2), 10);
		      current_year = parseInt(current_year, 10);

		      if (tin[6] === '-') {
		        if (parseInt("".concat(current_century).concat(full_year), 10) > current_year) {
		          full_year = "".concat(current_century - 1).concat(full_year);
		        } else {
		          full_year = "".concat(current_century).concat(full_year);
		        }
		      } else {
		        full_year = "".concat(current_century - 1).concat(full_year);

		        if (current_year - parseInt(full_year, 10) < 100) {
		          return false;
		        }
		      }
		    }
		  } // Normalize day and check date validity


		  if (day > 60) {
		    day -= 60;
		  }

		  if (day < 10) {
		    day = "0".concat(day);
		  }

		  var date = "".concat(full_year, "/").concat(month, "/").concat(day);

		  if (date.length === 8) {
		    if (!(0, _isDate.default)(date, 'YY/MM/DD')) {
		      return false;
		    }
		  } else if (!(0, _isDate.default)(date, 'YYYY/MM/DD')) {
		    return false;
		  }

		  return algorithms$1.luhnCheck(tin.replace(/\W/, ''));
		} // Locale lookup objects

		/*
		 * Tax id regex formats for various locales
		 *
		 * Where not explicitly specified in DG-TAXUD document both
		 * uppercase and lowercase letters are acceptable.
		 */


		var taxIdFormat = {
		  'bg-BG': /^\d{10}$/,
		  'cs-CZ': /^\d{6}\/{0,1}\d{3,4}$/,
		  'de-AT': /^\d{9}$/,
		  'de-DE': /^[1-9]\d{10}$/,
		  'dk-DK': /^\d{6}-{0,1}\d{4}$/,
		  'el-CY': /^[09]\d{7}[A-Z]$/,
		  'el-GR': /^([0-4]|[7-9])\d{8}$/,
		  'en-GB': /^\d{10}$|^(?!GB|NK|TN|ZZ)(?![DFIQUV])[A-Z](?![DFIQUVO])[A-Z]\d{6}[ABCD ]$/i,
		  'en-IE': /^\d{7}[A-W][A-IW]{0,1}$/i,
		  'en-US': /^\d{2}[- ]{0,1}\d{7}$/,
		  'es-ES': /^(\d{0,8}|[XYZKLM]\d{7})[A-HJ-NP-TV-Z]$/i,
		  'et-EE': /^[1-6]\d{6}(00[1-9]|0[1-9][0-9]|[1-6][0-9]{2}|70[0-9]|710)\d$/,
		  'fi-FI': /^\d{6}[-+A]\d{3}[0-9A-FHJ-NPR-Y]$/i,
		  'fr-BE': /^\d{11}$/,
		  'fr-FR': /^[0-3]\d{12}$|^[0-3]\d\s\d{2}(\s\d{3}){3}$/,
		  // Conforms both to official spec and provided example
		  'fr-LU': /^\d{13}$/,
		  'hr-HR': /^\d{11}$/,
		  'hu-HU': /^8\d{9}$/,
		  'it-IT': /^[A-Z]{6}[L-NP-V0-9]{2}[A-EHLMPRST][L-NP-V0-9]{2}[A-ILMZ][L-NP-V0-9]{3}[A-Z]$/i,
		  'lv-LV': /^\d{6}-{0,1}\d{5}$/,
		  // Conforms both to DG TAXUD spec and original research
		  'mt-MT': /^\d{3,7}[APMGLHBZ]$|^([1-8])\1\d{7}$/i,
		  'nl-NL': /^\d{9}$/,
		  'pl-PL': /^\d{10,11}$/,
		  'pt-BR': /(?:^\d{11}$)|(?:^\d{14}$)/,
		  'pt-PT': /^\d{9}$/,
		  'ro-RO': /^\d{13}$/,
		  'sk-SK': /^\d{6}\/{0,1}\d{3,4}$/,
		  'sl-SI': /^[1-9]\d{7}$/,
		  'sv-SE': /^(\d{6}[-+]{0,1}\d{4}|(18|19|20)\d{6}[-+]{0,1}\d{4})$/
		}; // taxIdFormat locale aliases

		taxIdFormat['lb-LU'] = taxIdFormat['fr-LU'];
		taxIdFormat['lt-LT'] = taxIdFormat['et-EE'];
		taxIdFormat['nl-BE'] = taxIdFormat['fr-BE']; // Algorithmic tax id check functions for various locales

		var taxIdCheck = {
		  'bg-BG': bgBgCheck,
		  'cs-CZ': csCzCheck,
		  'de-AT': deAtCheck,
		  'de-DE': deDeCheck,
		  'dk-DK': dkDkCheck,
		  'el-CY': elCyCheck,
		  'el-GR': elGrCheck,
		  'en-IE': enIeCheck,
		  'en-US': enUsCheck,
		  'es-ES': esEsCheck,
		  'et-EE': etEeCheck,
		  'fi-FI': fiFiCheck,
		  'fr-BE': frBeCheck,
		  'fr-FR': frFrCheck,
		  'fr-LU': frLuCheck,
		  'hr-HR': hrHrCheck,
		  'hu-HU': huHuCheck,
		  'it-IT': itItCheck,
		  'lv-LV': lvLvCheck,
		  'mt-MT': mtMtCheck,
		  'nl-NL': nlNlCheck,
		  'pl-PL': plPlCheck,
		  'pt-BR': ptBrCheck,
		  'pt-PT': ptPtCheck,
		  'ro-RO': roRoCheck,
		  'sk-SK': skSkCheck,
		  'sl-SI': slSiCheck,
		  'sv-SE': svSeCheck
		}; // taxIdCheck locale aliases

		taxIdCheck['lb-LU'] = taxIdCheck['fr-LU'];
		taxIdCheck['lt-LT'] = taxIdCheck['et-EE'];
		taxIdCheck['nl-BE'] = taxIdCheck['fr-BE']; // Regexes for locales where characters should be omitted before checking format

		var allsymbols = /[-\\\/!@#$%\^&\*\(\)\+\=\[\]]+/g;
		var sanitizeRegexes = {
		  'de-AT': allsymbols,
		  'de-DE': /[\/\\]/g,
		  'fr-BE': allsymbols
		}; // sanitizeRegexes locale aliases

		sanitizeRegexes['nl-BE'] = sanitizeRegexes['fr-BE'];
		/*
		 * Validator function
		 * Return true if the passed string is a valid tax identification number
		 * for the specified locale.
		 * Throw an error exception if the locale is not supported.
		 */

		function isTaxID(str) {
		  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en-US';
		  (0, _assertString.default)(str); // Copy TIN to avoid replacement if sanitized

		  var strcopy = str.slice(0);

		  if (locale in taxIdFormat) {
		    if (locale in sanitizeRegexes) {
		      strcopy = strcopy.replace(sanitizeRegexes[locale], '');
		    }

		    if (!taxIdFormat[locale].test(strcopy)) {
		      return false;
		    }

		    if (locale in taxIdCheck) {
		      return taxIdCheck[locale](strcopy);
		    } // Fallthrough; not all locales have algorithmic checks


		    return true;
		  }

		  throw new Error("Invalid locale '".concat(locale, "'"));
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
	} (isTaxID, isTaxIDExports));

	var isMobilePhone$1 = {};

	Object.defineProperty(isMobilePhone$1, "__esModule", {
	  value: true
	});
	isMobilePhone$1.default = isMobilePhone;
	isMobilePhone$1.locales = void 0;

	var _assertString$3 = _interopRequireDefault$3(assertStringExports);

	function _interopRequireDefault$3(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	/* eslint-disable max-len */
	var phones = {
	  'am-AM': /^(\+?374|0)((10|[9|7][0-9])\d{6}$|[2-4]\d{7}$)/,
	  'ar-AE': /^((\+?971)|0)?5[024568]\d{7}$/,
	  'ar-BH': /^(\+?973)?(3|6)\d{7}$/,
	  'ar-DZ': /^(\+?213|0)(5|6|7)\d{8}$/,
	  'ar-LB': /^(\+?961)?((3|81)\d{6}|7\d{7})$/,
	  'ar-EG': /^((\+?20)|0)?1[0125]\d{8}$/,
	  'ar-IQ': /^(\+?964|0)?7[0-9]\d{8}$/,
	  'ar-JO': /^(\+?962|0)?7[789]\d{7}$/,
	  'ar-KW': /^(\+?965)[569]\d{7}$/,
	  'ar-LY': /^((\+?218)|0)?(9[1-6]\d{7}|[1-8]\d{7,9})$/,
	  'ar-MA': /^(?:(?:\+|00)212|0)[5-7]\d{8}$/,
	  'ar-OM': /^((\+|00)968)?(9[1-9])\d{6}$/,
	  'ar-PS': /^(\+?970|0)5[6|9](\d{7})$/,
	  'ar-SA': /^(!?(\+?966)|0)?5\d{8}$/,
	  'ar-SY': /^(!?(\+?963)|0)?9\d{8}$/,
	  'ar-TN': /^(\+?216)?[2459]\d{7}$/,
	  'az-AZ': /^(\+994|0)(5[015]|7[07]|99)\d{7}$/,
	  'bs-BA': /^((((\+|00)3876)|06))((([0-3]|[5-6])\d{6})|(4\d{7}))$/,
	  'be-BY': /^(\+?375)?(24|25|29|33|44)\d{7}$/,
	  'bg-BG': /^(\+?359|0)?8[789]\d{7}$/,
	  'bn-BD': /^(\+?880|0)1[13456789][0-9]{8}$/,
	  'ca-AD': /^(\+376)?[346]\d{5}$/,
	  'cs-CZ': /^(\+?420)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/,
	  'da-DK': /^(\+?45)?\s?\d{2}\s?\d{2}\s?\d{2}\s?\d{2}$/,
	  'de-DE': /^((\+49|0)[1|3])([0|5][0-45-9]\d|6([23]|0\d?)|7([0-57-9]|6\d))\d{7,9}$/,
	  'de-AT': /^(\+43|0)\d{1,4}\d{3,12}$/,
	  'de-CH': /^(\+41|0)([1-9])\d{1,9}$/,
	  'de-LU': /^(\+352)?((6\d1)\d{6})$/,
	  'dv-MV': /^(\+?960)?(7[2-9]|91|9[3-9])\d{7}$/,
	  'el-GR': /^(\+?30|0)?(69\d{8})$/,
	  'en-AU': /^(\+?61|0)4\d{8}$/,
	  'en-BM': /^(\+?1)?441(((3|7)\d{6}$)|(5[0-3][0-9]\d{4}$)|(59\d{5}))/,
	  'en-GB': /^(\+?44|0)7\d{9}$/,
	  'en-GG': /^(\+?44|0)1481\d{6}$/,
	  'en-GH': /^(\+233|0)(20|50|24|54|27|57|26|56|23|28|55|59)\d{7}$/,
	  'en-GY': /^(\+592|0)6\d{6}$/,
	  'en-HK': /^(\+?852[-\s]?)?[456789]\d{3}[-\s]?\d{4}$/,
	  'en-MO': /^(\+?853[-\s]?)?[6]\d{3}[-\s]?\d{4}$/,
	  'en-IE': /^(\+?353|0)8[356789]\d{7}$/,
	  'en-IN': /^(\+?91|0)?[6789]\d{9}$/,
	  'en-KE': /^(\+?254|0)(7|1)\d{8}$/,
	  'en-KI': /^((\+686|686)?)?( )?((6|7)(2|3|8)[0-9]{6})$/,
	  'en-MT': /^(\+?356|0)?(99|79|77|21|27|22|25)[0-9]{6}$/,
	  'en-MU': /^(\+?230|0)?\d{8}$/,
	  'en-NA': /^(\+?264|0)(6|8)\d{7}$/,
	  'en-NG': /^(\+?234|0)?[789]\d{9}$/,
	  'en-NZ': /^(\+?64|0)[28]\d{7,9}$/,
	  'en-PK': /^((00|\+)?92|0)3[0-6]\d{8}$/,
	  'en-PH': /^(09|\+639)\d{9}$/,
	  'en-RW': /^(\+?250|0)?[7]\d{8}$/,
	  'en-SG': /^(\+65)?[3689]\d{7}$/,
	  'en-SL': /^(\+?232|0)\d{8}$/,
	  'en-TZ': /^(\+?255|0)?[67]\d{8}$/,
	  'en-UG': /^(\+?256|0)?[7]\d{8}$/,
	  'en-US': /^((\+1|1)?( |-)?)?(\([2-9][0-9]{2}\)|[2-9][0-9]{2})( |-)?([2-9][0-9]{2}( |-)?[0-9]{4})$/,
	  'en-ZA': /^(\+?27|0)\d{9}$/,
	  'en-ZM': /^(\+?26)?09[567]\d{7}$/,
	  'en-ZW': /^(\+263)[0-9]{9}$/,
	  'en-BW': /^(\+?267)?(7[1-8]{1})\d{6}$/,
	  'es-AR': /^\+?549(11|[2368]\d)\d{8}$/,
	  'es-BO': /^(\+?591)?(6|7)\d{7}$/,
	  'es-CO': /^(\+?57)?3(0(0|1|2|4|5)|1\d|2[0-4]|5(0|1))\d{7}$/,
	  'es-CL': /^(\+?56|0)[2-9]\d{1}\d{7}$/,
	  'es-CR': /^(\+506)?[2-8]\d{7}$/,
	  'es-CU': /^(\+53|0053)?5\d{7}/,
	  'es-DO': /^(\+?1)?8[024]9\d{7}$/,
	  'es-HN': /^(\+?504)?[9|8]\d{7}$/,
	  'es-EC': /^(\+?593|0)([2-7]|9[2-9])\d{7}$/,
	  'es-ES': /^(\+?34)?[6|7]\d{8}$/,
	  'es-PE': /^(\+?51)?9\d{8}$/,
	  'es-MX': /^(\+?52)?(1|01)?\d{10,11}$/,
	  'es-PA': /^(\+?507)\d{7,8}$/,
	  'es-PY': /^(\+?595|0)9[9876]\d{7}$/,
	  'es-SV': /^(\+?503)?[67]\d{7}$/,
	  'es-UY': /^(\+598|0)9[1-9][\d]{6}$/,
	  'es-VE': /^(\+?58)?(2|4)\d{9}$/,
	  'et-EE': /^(\+?372)?\s?(5|8[1-4])\s?([0-9]\s?){6,7}$/,
	  'fa-IR': /^(\+?98[\-\s]?|0)9[0-39]\d[\-\s]?\d{3}[\-\s]?\d{4}$/,
	  'fi-FI': /^(\+?358|0)\s?(4(0|1|2|4|5|6)?|50)\s?(\d\s?){4,8}\d$/,
	  'fj-FJ': /^(\+?679)?\s?\d{3}\s?\d{4}$/,
	  'fo-FO': /^(\+?298)?\s?\d{2}\s?\d{2}\s?\d{2}$/,
	  'fr-BF': /^(\+226|0)[67]\d{7}$/,
	  'fr-CM': /^(\+?237)6[0-9]{8}$/,
	  'fr-FR': /^(\+?33|0)[67]\d{8}$/,
	  'fr-GF': /^(\+?594|0|00594)[67]\d{8}$/,
	  'fr-GP': /^(\+?590|0|00590)[67]\d{8}$/,
	  'fr-MQ': /^(\+?596|0|00596)[67]\d{8}$/,
	  'fr-PF': /^(\+?689)?8[789]\d{6}$/,
	  'fr-RE': /^(\+?262|0|00262)[67]\d{8}$/,
	  'he-IL': /^(\+972|0)([23489]|5[012345689]|77)[1-9]\d{6}$/,
	  'hu-HU': /^(\+?36|06)(20|30|31|50|70)\d{7}$/,
	  'id-ID': /^(\+?62|0)8(1[123456789]|2[1238]|3[1238]|5[12356789]|7[78]|9[56789]|8[123456789])([\s?|\d]{5,11})$/,
	  'it-IT': /^(\+?39)?\s?3\d{2} ?\d{6,7}$/,
	  'it-SM': /^((\+378)|(0549)|(\+390549)|(\+3780549))?6\d{5,9}$/,
	  'ja-JP': /^(\+81[ \-]?(\(0\))?|0)[6789]0[ \-]?\d{4}[ \-]?\d{4}$/,
	  'ka-GE': /^(\+?995)?(5|79)\d{7}$/,
	  'kk-KZ': /^(\+?7|8)?7\d{9}$/,
	  'kl-GL': /^(\+?299)?\s?\d{2}\s?\d{2}\s?\d{2}$/,
	  'ko-KR': /^((\+?82)[ \-]?)?0?1([0|1|6|7|8|9]{1})[ \-]?\d{3,4}[ \-]?\d{4}$/,
	  'lt-LT': /^(\+370|8)\d{8}$/,
	  'lv-LV': /^(\+?371)2\d{7}$/,
	  'ms-MY': /^(\+?6?01){1}(([0145]{1}(\-|\s)?\d{7,8})|([236789]{1}(\s|\-)?\d{7}))$/,
	  'mz-MZ': /^(\+?258)?8[234567]\d{7}$/,
	  'nb-NO': /^(\+?47)?[49]\d{7}$/,
	  'ne-NP': /^(\+?977)?9[78]\d{8}$/,
	  'nl-BE': /^(\+?32|0)4\d{8}$/,
	  'nl-NL': /^(((\+|00)?31\(0\))|((\+|00)?31)|0)6{1}\d{8}$/,
	  'nn-NO': /^(\+?47)?[49]\d{7}$/,
	  'pl-PL': /^(\+?48)? ?[5-8]\d ?\d{3} ?\d{2} ?\d{2}$/,
	  'pt-BR': /^((\+?55\ ?[1-9]{2}\ ?)|(\+?55\ ?\([1-9]{2}\)\ ?)|(0[1-9]{2}\ ?)|(\([1-9]{2}\)\ ?)|([1-9]{2}\ ?))((\d{4}\-?\d{4})|(9[2-9]{1}\d{3}\-?\d{4}))$/,
	  'pt-PT': /^(\+?351)?9[1236]\d{7}$/,
	  'pt-AO': /^(\+244)\d{9}$/,
	  'ro-RO': /^(\+?4?0)\s?7\d{2}(\/|\s|\.|\-)?\d{3}(\s|\.|\-)?\d{3}$/,
	  'ru-RU': /^(\+?7|8)?9\d{9}$/,
	  'si-LK': /^(?:0|94|\+94)?(7(0|1|2|4|5|6|7|8)( |-)?)\d{7}$/,
	  'sl-SI': /^(\+386\s?|0)(\d{1}\s?\d{3}\s?\d{2}\s?\d{2}|\d{2}\s?\d{3}\s?\d{3})$/,
	  'sk-SK': /^(\+?421)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/,
	  'sq-AL': /^(\+355|0)6[789]\d{6}$/,
	  'sr-RS': /^(\+3816|06)[- \d]{5,9}$/,
	  'sv-SE': /^(\+?46|0)[\s\-]?7[\s\-]?[02369]([\s\-]?\d){7}$/,
	  'tg-TJ': /^(\+?992)?[5][5]\d{7}$/,
	  'th-TH': /^(\+66|66|0)\d{9}$/,
	  'tr-TR': /^(\+?90|0)?5\d{9}$/,
	  'tk-TM': /^(\+993|993|8)\d{8}$/,
	  'uk-UA': /^(\+?38|8)?0\d{9}$/,
	  'uz-UZ': /^(\+?998)?(6[125-79]|7[1-69]|88|9\d)\d{7}$/,
	  'vi-VN': /^((\+?84)|0)((3([2-9]))|(5([25689]))|(7([0|6-9]))|(8([1-9]))|(9([0-9])))([0-9]{7})$/,
	  'zh-CN': /^((\+|00)86)?(1[3-9]|9[28])\d{9}$/,
	  'zh-TW': /^(\+?886\-?|0)?9\d{8}$/,
	  'dz-BT': /^(\+?975|0)?(17|16|77|02)\d{6}$/
	};
	/* eslint-enable max-len */
	// aliases

	phones['en-CA'] = phones['en-US'];
	phones['fr-CA'] = phones['en-CA'];
	phones['fr-BE'] = phones['nl-BE'];
	phones['zh-HK'] = phones['en-HK'];
	phones['zh-MO'] = phones['en-MO'];
	phones['ga-IE'] = phones['en-IE'];
	phones['fr-CH'] = phones['de-CH'];
	phones['it-CH'] = phones['fr-CH'];

	function isMobilePhone(str, locale, options) {
	  (0, _assertString$3.default)(str);

	  if (options && options.strictMode && !str.startsWith('+')) {
	    return false;
	  }

	  if (Array.isArray(locale)) {
	    return locale.some(function (key) {
	      // https://github.com/gotwarlost/istanbul/blob/master/ignoring-code-for-coverage.md#ignoring-code-for-coverage-purposes
	      // istanbul ignore else
	      if (phones.hasOwnProperty(key)) {
	        var phone = phones[key];

	        if (phone.test(str)) {
	          return true;
	        }
	      }

	      return false;
	    });
	  } else if (locale in phones) {
	    return phones[locale].test(str); // alias falsey locale as 'any'
	  } else if (!locale || locale === 'any') {
	    for (var key in phones) {
	      // istanbul ignore else
	      if (phones.hasOwnProperty(key)) {
	        var phone = phones[key];

	        if (phone.test(str)) {
	          return true;
	        }
	      }
	    }

	    return false;
	  }

	  throw new Error("Invalid locale '".concat(locale, "'"));
	}

	var locales$1 = Object.keys(phones);
	isMobilePhone$1.locales = locales$1;

	var isEthereumAddressExports = {};
	var isEthereumAddress = {
	  get exports(){ return isEthereumAddressExports; },
	  set exports(v){ isEthereumAddressExports = v; },
	};

	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = isEthereumAddress;

		var _assertString = _interopRequireDefault(assertStringExports);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		var eth = /^(0x)[0-9a-f]{40}$/i;

		function isEthereumAddress(str) {
		  (0, _assertString.default)(str);
		  return eth.test(str);
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
	} (isEthereumAddress, isEthereumAddressExports));

	var isCurrencyExports = {};
	var isCurrency = {
	  get exports(){ return isCurrencyExports; },
	  set exports(v){ isCurrencyExports = v; },
	};

	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = isCurrency;

		var _merge = _interopRequireDefault(mergeExports);

		var _assertString = _interopRequireDefault(assertStringExports);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		function currencyRegex(options) {
		  var decimal_digits = "\\d{".concat(options.digits_after_decimal[0], "}");
		  options.digits_after_decimal.forEach(function (digit, index) {
		    if (index !== 0) decimal_digits = "".concat(decimal_digits, "|\\d{").concat(digit, "}");
		  });
		  var symbol = "(".concat(options.symbol.replace(/\W/, function (m) {
		    return "\\".concat(m);
		  }), ")").concat(options.require_symbol ? '' : '?'),
		      negative = '-?',
		      whole_dollar_amount_without_sep = '[1-9]\\d*',
		      whole_dollar_amount_with_sep = "[1-9]\\d{0,2}(\\".concat(options.thousands_separator, "\\d{3})*"),
		      valid_whole_dollar_amounts = ['0', whole_dollar_amount_without_sep, whole_dollar_amount_with_sep],
		      whole_dollar_amount = "(".concat(valid_whole_dollar_amounts.join('|'), ")?"),
		      decimal_amount = "(\\".concat(options.decimal_separator, "(").concat(decimal_digits, "))").concat(options.require_decimal ? '' : '?');
		  var pattern = whole_dollar_amount + (options.allow_decimal || options.require_decimal ? decimal_amount : ''); // default is negative sign before symbol, but there are two other options (besides parens)

		  if (options.allow_negatives && !options.parens_for_negatives) {
		    if (options.negative_sign_after_digits) {
		      pattern += negative;
		    } else if (options.negative_sign_before_digits) {
		      pattern = negative + pattern;
		    }
		  } // South African Rand, for example, uses R 123 (space) and R-123 (no space)


		  if (options.allow_negative_sign_placeholder) {
		    pattern = "( (?!\\-))?".concat(pattern);
		  } else if (options.allow_space_after_symbol) {
		    pattern = " ?".concat(pattern);
		  } else if (options.allow_space_after_digits) {
		    pattern += '( (?!$))?';
		  }

		  if (options.symbol_after_digits) {
		    pattern += symbol;
		  } else {
		    pattern = symbol + pattern;
		  }

		  if (options.allow_negatives) {
		    if (options.parens_for_negatives) {
		      pattern = "(\\(".concat(pattern, "\\)|").concat(pattern, ")");
		    } else if (!(options.negative_sign_before_digits || options.negative_sign_after_digits)) {
		      pattern = negative + pattern;
		    }
		  } // ensure there's a dollar and/or decimal amount, and that
		  // it doesn't start with a space or a negative sign followed by a space


		  return new RegExp("^(?!-? )(?=.*\\d)".concat(pattern, "$"));
		}

		var default_currency_options = {
		  symbol: '$',
		  require_symbol: false,
		  allow_space_after_symbol: false,
		  symbol_after_digits: false,
		  allow_negatives: true,
		  parens_for_negatives: false,
		  negative_sign_before_digits: false,
		  negative_sign_after_digits: false,
		  allow_negative_sign_placeholder: false,
		  thousands_separator: ',',
		  decimal_separator: '.',
		  allow_decimal: true,
		  require_decimal: false,
		  digits_after_decimal: [2],
		  allow_space_after_digits: false
		};

		function isCurrency(str, options) {
		  (0, _assertString.default)(str);
		  options = (0, _merge.default)(options, default_currency_options);
		  return currencyRegex(options).test(str);
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
	} (isCurrency, isCurrencyExports));

	var isBtcAddressExports = {};
	var isBtcAddress = {
	  get exports(){ return isBtcAddressExports; },
	  set exports(v){ isBtcAddressExports = v; },
	};

	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = isBtcAddress;

		var _assertString = _interopRequireDefault(assertStringExports);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		// supports Bech32 addresses
		var bech32 = /^(bc1)[a-z0-9]{25,39}$/;
		var base58 = /^(1|3)[A-HJ-NP-Za-km-z1-9]{25,39}$/;

		function isBtcAddress(str) {
		  (0, _assertString.default)(str); // check for bech32

		  if (str.startsWith('bc1')) {
		    return bech32.test(str);
		  }

		  return base58.test(str);
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
	} (isBtcAddress, isBtcAddressExports));

	var isISO8601Exports = {};
	var isISO8601 = {
	  get exports(){ return isISO8601Exports; },
	  set exports(v){ isISO8601Exports = v; },
	};

	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = isISO8601;

		var _assertString = _interopRequireDefault(assertStringExports);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		/* eslint-disable max-len */
		// from http://goo.gl/0ejHHW
		var iso8601 = /^([\+-]?\d{4}(?!\d{2}\b))((-?)((0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?|W([0-4]\d|5[0-3])(-?[1-7])?|(00[1-9]|0[1-9]\d|[12]\d{2}|3([0-5]\d|6[1-6])))([T\s]((([01]\d|2[0-3])((:?)[0-5]\d)?|24:?00)([\.,]\d+(?!:))?)?(\17[0-5]\d([\.,]\d+)?)?([zZ]|([\+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?)?$/; // same as above, except with a strict 'T' separator between date and time

		var iso8601StrictSeparator = /^([\+-]?\d{4}(?!\d{2}\b))((-?)((0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?|W([0-4]\d|5[0-3])(-?[1-7])?|(00[1-9]|0[1-9]\d|[12]\d{2}|3([0-5]\d|6[1-6])))([T]((([01]\d|2[0-3])((:?)[0-5]\d)?|24:?00)([\.,]\d+(?!:))?)?(\17[0-5]\d([\.,]\d+)?)?([zZ]|([\+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?)?$/;
		/* eslint-enable max-len */

		var isValidDate = function isValidDate(str) {
		  // str must have passed the ISO8601 check
		  // this check is meant to catch invalid dates
		  // like 2009-02-31
		  // first check for ordinal dates
		  var ordinalMatch = str.match(/^(\d{4})-?(\d{3})([ T]{1}\.*|$)/);

		  if (ordinalMatch) {
		    var oYear = Number(ordinalMatch[1]);
		    var oDay = Number(ordinalMatch[2]); // if is leap year

		    if (oYear % 4 === 0 && oYear % 100 !== 0 || oYear % 400 === 0) return oDay <= 366;
		    return oDay <= 365;
		  }

		  var match = str.match(/(\d{4})-?(\d{0,2})-?(\d*)/).map(Number);
		  var year = match[1];
		  var month = match[2];
		  var day = match[3];
		  var monthString = month ? "0".concat(month).slice(-2) : month;
		  var dayString = day ? "0".concat(day).slice(-2) : day; // create a date object and compare

		  var d = new Date("".concat(year, "-").concat(monthString || '01', "-").concat(dayString || '01'));

		  if (month && day) {
		    return d.getUTCFullYear() === year && d.getUTCMonth() + 1 === month && d.getUTCDate() === day;
		  }

		  return true;
		};

		function isISO8601(str) {
		  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
		  (0, _assertString.default)(str);
		  var check = options.strictSeparator ? iso8601StrictSeparator.test(str) : iso8601.test(str);
		  if (check && options.strict) return isValidDate(str);
		  return check;
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
	} (isISO8601, isISO8601Exports));

	var isRFC3339Exports = {};
	var isRFC3339 = {
	  get exports(){ return isRFC3339Exports; },
	  set exports(v){ isRFC3339Exports = v; },
	};

	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = isRFC3339;

		var _assertString = _interopRequireDefault(assertStringExports);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		/* Based on https://tools.ietf.org/html/rfc3339#section-5.6 */
		var dateFullYear = /[0-9]{4}/;
		var dateMonth = /(0[1-9]|1[0-2])/;
		var dateMDay = /([12]\d|0[1-9]|3[01])/;
		var timeHour = /([01][0-9]|2[0-3])/;
		var timeMinute = /[0-5][0-9]/;
		var timeSecond = /([0-5][0-9]|60)/;
		var timeSecFrac = /(\.[0-9]+)?/;
		var timeNumOffset = new RegExp("[-+]".concat(timeHour.source, ":").concat(timeMinute.source));
		var timeOffset = new RegExp("([zZ]|".concat(timeNumOffset.source, ")"));
		var partialTime = new RegExp("".concat(timeHour.source, ":").concat(timeMinute.source, ":").concat(timeSecond.source).concat(timeSecFrac.source));
		var fullDate = new RegExp("".concat(dateFullYear.source, "-").concat(dateMonth.source, "-").concat(dateMDay.source));
		var fullTime = new RegExp("".concat(partialTime.source).concat(timeOffset.source));
		var rfc3339 = new RegExp("^".concat(fullDate.source, "[ tT]").concat(fullTime.source, "$"));

		function isRFC3339(str) {
		  (0, _assertString.default)(str);
		  return rfc3339.test(str);
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
	} (isRFC3339, isRFC3339Exports));

	var isISO31661Alpha3Exports = {};
	var isISO31661Alpha3 = {
	  get exports(){ return isISO31661Alpha3Exports; },
	  set exports(v){ isISO31661Alpha3Exports = v; },
	};

	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = isISO31661Alpha3;

		var _assertString = _interopRequireDefault(assertStringExports);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		// from https://en.wikipedia.org/wiki/ISO_3166-1_alpha-3
		var validISO31661Alpha3CountriesCodes = new Set(['AFG', 'ALA', 'ALB', 'DZA', 'ASM', 'AND', 'AGO', 'AIA', 'ATA', 'ATG', 'ARG', 'ARM', 'ABW', 'AUS', 'AUT', 'AZE', 'BHS', 'BHR', 'BGD', 'BRB', 'BLR', 'BEL', 'BLZ', 'BEN', 'BMU', 'BTN', 'BOL', 'BES', 'BIH', 'BWA', 'BVT', 'BRA', 'IOT', 'BRN', 'BGR', 'BFA', 'BDI', 'KHM', 'CMR', 'CAN', 'CPV', 'CYM', 'CAF', 'TCD', 'CHL', 'CHN', 'CXR', 'CCK', 'COL', 'COM', 'COG', 'COD', 'COK', 'CRI', 'CIV', 'HRV', 'CUB', 'CUW', 'CYP', 'CZE', 'DNK', 'DJI', 'DMA', 'DOM', 'ECU', 'EGY', 'SLV', 'GNQ', 'ERI', 'EST', 'ETH', 'FLK', 'FRO', 'FJI', 'FIN', 'FRA', 'GUF', 'PYF', 'ATF', 'GAB', 'GMB', 'GEO', 'DEU', 'GHA', 'GIB', 'GRC', 'GRL', 'GRD', 'GLP', 'GUM', 'GTM', 'GGY', 'GIN', 'GNB', 'GUY', 'HTI', 'HMD', 'VAT', 'HND', 'HKG', 'HUN', 'ISL', 'IND', 'IDN', 'IRN', 'IRQ', 'IRL', 'IMN', 'ISR', 'ITA', 'JAM', 'JPN', 'JEY', 'JOR', 'KAZ', 'KEN', 'KIR', 'PRK', 'KOR', 'KWT', 'KGZ', 'LAO', 'LVA', 'LBN', 'LSO', 'LBR', 'LBY', 'LIE', 'LTU', 'LUX', 'MAC', 'MKD', 'MDG', 'MWI', 'MYS', 'MDV', 'MLI', 'MLT', 'MHL', 'MTQ', 'MRT', 'MUS', 'MYT', 'MEX', 'FSM', 'MDA', 'MCO', 'MNG', 'MNE', 'MSR', 'MAR', 'MOZ', 'MMR', 'NAM', 'NRU', 'NPL', 'NLD', 'NCL', 'NZL', 'NIC', 'NER', 'NGA', 'NIU', 'NFK', 'MNP', 'NOR', 'OMN', 'PAK', 'PLW', 'PSE', 'PAN', 'PNG', 'PRY', 'PER', 'PHL', 'PCN', 'POL', 'PRT', 'PRI', 'QAT', 'REU', 'ROU', 'RUS', 'RWA', 'BLM', 'SHN', 'KNA', 'LCA', 'MAF', 'SPM', 'VCT', 'WSM', 'SMR', 'STP', 'SAU', 'SEN', 'SRB', 'SYC', 'SLE', 'SGP', 'SXM', 'SVK', 'SVN', 'SLB', 'SOM', 'ZAF', 'SGS', 'SSD', 'ESP', 'LKA', 'SDN', 'SUR', 'SJM', 'SWZ', 'SWE', 'CHE', 'SYR', 'TWN', 'TJK', 'TZA', 'THA', 'TLS', 'TGO', 'TKL', 'TON', 'TTO', 'TUN', 'TUR', 'TKM', 'TCA', 'TUV', 'UGA', 'UKR', 'ARE', 'GBR', 'USA', 'UMI', 'URY', 'UZB', 'VUT', 'VEN', 'VNM', 'VGB', 'VIR', 'WLF', 'ESH', 'YEM', 'ZMB', 'ZWE']);

		function isISO31661Alpha3(str) {
		  (0, _assertString.default)(str);
		  return validISO31661Alpha3CountriesCodes.has(str.toUpperCase());
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
	} (isISO31661Alpha3, isISO31661Alpha3Exports));

	var isISO4217$1 = {};

	Object.defineProperty(isISO4217$1, "__esModule", {
	  value: true
	});
	isISO4217$1.default = isISO4217;
	isISO4217$1.CurrencyCodes = void 0;

	var _assertString$2 = _interopRequireDefault$2(assertStringExports);

	function _interopRequireDefault$2(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	// from https://en.wikipedia.org/wiki/ISO_4217
	var validISO4217CurrencyCodes = new Set(['AED', 'AFN', 'ALL', 'AMD', 'ANG', 'AOA', 'ARS', 'AUD', 'AWG', 'AZN', 'BAM', 'BBD', 'BDT', 'BGN', 'BHD', 'BIF', 'BMD', 'BND', 'BOB', 'BOV', 'BRL', 'BSD', 'BTN', 'BWP', 'BYN', 'BZD', 'CAD', 'CDF', 'CHE', 'CHF', 'CHW', 'CLF', 'CLP', 'CNY', 'COP', 'COU', 'CRC', 'CUC', 'CUP', 'CVE', 'CZK', 'DJF', 'DKK', 'DOP', 'DZD', 'EGP', 'ERN', 'ETB', 'EUR', 'FJD', 'FKP', 'GBP', 'GEL', 'GHS', 'GIP', 'GMD', 'GNF', 'GTQ', 'GYD', 'HKD', 'HNL', 'HRK', 'HTG', 'HUF', 'IDR', 'ILS', 'INR', 'IQD', 'IRR', 'ISK', 'JMD', 'JOD', 'JPY', 'KES', 'KGS', 'KHR', 'KMF', 'KPW', 'KRW', 'KWD', 'KYD', 'KZT', 'LAK', 'LBP', 'LKR', 'LRD', 'LSL', 'LYD', 'MAD', 'MDL', 'MGA', 'MKD', 'MMK', 'MNT', 'MOP', 'MRU', 'MUR', 'MVR', 'MWK', 'MXN', 'MXV', 'MYR', 'MZN', 'NAD', 'NGN', 'NIO', 'NOK', 'NPR', 'NZD', 'OMR', 'PAB', 'PEN', 'PGK', 'PHP', 'PKR', 'PLN', 'PYG', 'QAR', 'RON', 'RSD', 'RUB', 'RWF', 'SAR', 'SBD', 'SCR', 'SDG', 'SEK', 'SGD', 'SHP', 'SLL', 'SOS', 'SRD', 'SSP', 'STN', 'SVC', 'SYP', 'SZL', 'THB', 'TJS', 'TMT', 'TND', 'TOP', 'TRY', 'TTD', 'TWD', 'TZS', 'UAH', 'UGX', 'USD', 'USN', 'UYI', 'UYU', 'UYW', 'UZS', 'VES', 'VND', 'VUV', 'WST', 'XAF', 'XAG', 'XAU', 'XBA', 'XBB', 'XBC', 'XBD', 'XCD', 'XDR', 'XOF', 'XPD', 'XPF', 'XPT', 'XSU', 'XTS', 'XUA', 'XXX', 'YER', 'ZAR', 'ZMW', 'ZWL']);

	function isISO4217(str) {
	  (0, _assertString$2.default)(str);
	  return validISO4217CurrencyCodes.has(str.toUpperCase());
	}

	var CurrencyCodes = validISO4217CurrencyCodes;
	isISO4217$1.CurrencyCodes = CurrencyCodes;

	var isBase32Exports = {};
	var isBase32 = {
	  get exports(){ return isBase32Exports; },
	  set exports(v){ isBase32Exports = v; },
	};

	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = isBase32;

		var _assertString = _interopRequireDefault(assertStringExports);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		var base32 = /^[A-Z2-7]+=*$/;

		function isBase32(str) {
		  (0, _assertString.default)(str);
		  var len = str.length;

		  if (len % 8 === 0 && base32.test(str)) {
		    return true;
		  }

		  return false;
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
	} (isBase32, isBase32Exports));

	var isBase58Exports = {};
	var isBase58 = {
	  get exports(){ return isBase58Exports; },
	  set exports(v){ isBase58Exports = v; },
	};

	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = isBase58;

		var _assertString = _interopRequireDefault(assertStringExports);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		// Accepted chars - 123456789ABCDEFGH JKLMN PQRSTUVWXYZabcdefghijk mnopqrstuvwxyz
		var base58Reg = /^[A-HJ-NP-Za-km-z1-9]*$/;

		function isBase58(str) {
		  (0, _assertString.default)(str);

		  if (base58Reg.test(str)) {
		    return true;
		  }

		  return false;
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
	} (isBase58, isBase58Exports));

	var isDataURIExports = {};
	var isDataURI = {
	  get exports(){ return isDataURIExports; },
	  set exports(v){ isDataURIExports = v; },
	};

	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = isDataURI;

		var _assertString = _interopRequireDefault(assertStringExports);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		var validMediaType = /^[a-z]+\/[a-z0-9\-\+]+$/i;
		var validAttribute = /^[a-z\-]+=[a-z0-9\-]+$/i;
		var validData = /^[a-z0-9!\$&'\(\)\*\+,;=\-\._~:@\/\?%\s]*$/i;

		function isDataURI(str) {
		  (0, _assertString.default)(str);
		  var data = str.split(',');

		  if (data.length < 2) {
		    return false;
		  }

		  var attributes = data.shift().trim().split(';');
		  var schemeAndMediaType = attributes.shift();

		  if (schemeAndMediaType.substr(0, 5) !== 'data:') {
		    return false;
		  }

		  var mediaType = schemeAndMediaType.substr(5);

		  if (mediaType !== '' && !validMediaType.test(mediaType)) {
		    return false;
		  }

		  for (var i = 0; i < attributes.length; i++) {
		    if (!(i === attributes.length - 1 && attributes[i].toLowerCase() === 'base64') && !validAttribute.test(attributes[i])) {
		      return false;
		    }
		  }

		  for (var _i = 0; _i < data.length; _i++) {
		    if (!validData.test(data[_i])) {
		      return false;
		    }
		  }

		  return true;
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
	} (isDataURI, isDataURIExports));

	var isMagnetURIExports = {};
	var isMagnetURI = {
	  get exports(){ return isMagnetURIExports; },
	  set exports(v){ isMagnetURIExports = v; },
	};

	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = isMagnetURI;

		var _assertString = _interopRequireDefault(assertStringExports);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		var magnetURI = /^magnet:\?xt(?:\.1)?=urn:(?:aich|bitprint|btih|ed2k|ed2khash|kzhash|md5|sha1|tree:tiger):[a-z0-9]{32}(?:[a-z0-9]{8})?($|&)/i;

		function isMagnetURI(url) {
		  (0, _assertString.default)(url);
		  return magnetURI.test(url.trim());
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
	} (isMagnetURI, isMagnetURIExports));

	var isMimeTypeExports = {};
	var isMimeType = {
	  get exports(){ return isMimeTypeExports; },
	  set exports(v){ isMimeTypeExports = v; },
	};

	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = isMimeType;

		var _assertString = _interopRequireDefault(assertStringExports);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		/*
		  Checks if the provided string matches to a correct Media type format (MIME type)

		  This function only checks is the string format follows the
		  etablished rules by the according RFC specifications.
		  This function supports 'charset' in textual media types
		  (https://tools.ietf.org/html/rfc6657).

		  This function does not check against all the media types listed
		  by the IANA (https://www.iana.org/assignments/media-types/media-types.xhtml)
		  because of lightness purposes : it would require to include
		  all these MIME types in this librairy, which would weigh it
		  significantly. This kind of effort maybe is not worth for the use that
		  this function has in this entire librairy.

		  More informations in the RFC specifications :
		  - https://tools.ietf.org/html/rfc2045
		  - https://tools.ietf.org/html/rfc2046
		  - https://tools.ietf.org/html/rfc7231#section-3.1.1.1
		  - https://tools.ietf.org/html/rfc7231#section-3.1.1.5
		*/
		// Match simple MIME types
		// NB :
		//   Subtype length must not exceed 100 characters.
		//   This rule does not comply to the RFC specs (what is the max length ?).
		var mimeTypeSimple = /^(application|audio|font|image|message|model|multipart|text|video)\/[a-zA-Z0-9\.\-\+]{1,100}$/i; // eslint-disable-line max-len
		// Handle "charset" in "text/*"

		var mimeTypeText = /^text\/[a-zA-Z0-9\.\-\+]{1,100};\s?charset=("[a-zA-Z0-9\.\-\+\s]{0,70}"|[a-zA-Z0-9\.\-\+]{0,70})(\s?\([a-zA-Z0-9\.\-\+\s]{1,20}\))?$/i; // eslint-disable-line max-len
		// Handle "boundary" in "multipart/*"

		var mimeTypeMultipart = /^multipart\/[a-zA-Z0-9\.\-\+]{1,100}(;\s?(boundary|charset)=("[a-zA-Z0-9\.\-\+\s]{0,70}"|[a-zA-Z0-9\.\-\+]{0,70})(\s?\([a-zA-Z0-9\.\-\+\s]{1,20}\))?){0,2}$/i; // eslint-disable-line max-len

		function isMimeType(str) {
		  (0, _assertString.default)(str);
		  return mimeTypeSimple.test(str) || mimeTypeText.test(str) || mimeTypeMultipart.test(str);
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
	} (isMimeType, isMimeTypeExports));

	var isLatLongExports = {};
	var isLatLong = {
	  get exports(){ return isLatLongExports; },
	  set exports(v){ isLatLongExports = v; },
	};

	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = isLatLong;

		var _assertString = _interopRequireDefault(assertStringExports);

		var _merge = _interopRequireDefault(mergeExports);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		var lat = /^\(?[+-]?(90(\.0+)?|[1-8]?\d(\.\d+)?)$/;
		var long = /^\s?[+-]?(180(\.0+)?|1[0-7]\d(\.\d+)?|\d{1,2}(\.\d+)?)\)?$/;
		var latDMS = /^(([1-8]?\d)\D+([1-5]?\d|60)\D+([1-5]?\d|60)(\.\d+)?|90\D+0\D+0)\D+[NSns]?$/i;
		var longDMS = /^\s*([1-7]?\d{1,2}\D+([1-5]?\d|60)\D+([1-5]?\d|60)(\.\d+)?|180\D+0\D+0)\D+[EWew]?$/i;
		var defaultLatLongOptions = {
		  checkDMS: false
		};

		function isLatLong(str, options) {
		  (0, _assertString.default)(str);
		  options = (0, _merge.default)(options, defaultLatLongOptions);
		  if (!str.includes(',')) return false;
		  var pair = str.split(',');
		  if (pair[0].startsWith('(') && !pair[1].endsWith(')') || pair[1].endsWith(')') && !pair[0].startsWith('(')) return false;

		  if (options.checkDMS) {
		    return latDMS.test(pair[0]) && longDMS.test(pair[1]);
		  }

		  return lat.test(pair[0]) && long.test(pair[1]);
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
	} (isLatLong, isLatLongExports));

	var isPostalCode$1 = {};

	Object.defineProperty(isPostalCode$1, "__esModule", {
	  value: true
	});
	isPostalCode$1.default = isPostalCode;
	isPostalCode$1.locales = void 0;

	var _assertString$1 = _interopRequireDefault$1(assertStringExports);

	function _interopRequireDefault$1(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	// common patterns
	var threeDigit = /^\d{3}$/;
	var fourDigit = /^\d{4}$/;
	var fiveDigit = /^\d{5}$/;
	var sixDigit = /^\d{6}$/;
	var patterns = {
	  AD: /^AD\d{3}$/,
	  AT: fourDigit,
	  AU: fourDigit,
	  AZ: /^AZ\d{4}$/,
	  BE: fourDigit,
	  BG: fourDigit,
	  BR: /^\d{5}-\d{3}$/,
	  BY: /2[1-4]{1}\d{4}$/,
	  CA: /^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][\s\-]?\d[ABCEGHJ-NPRSTV-Z]\d$/i,
	  CH: fourDigit,
	  CN: /^(0[1-7]|1[012356]|2[0-7]|3[0-6]|4[0-7]|5[1-7]|6[1-7]|7[1-5]|8[1345]|9[09])\d{4}$/,
	  CZ: /^\d{3}\s?\d{2}$/,
	  DE: fiveDigit,
	  DK: fourDigit,
	  DO: fiveDigit,
	  DZ: fiveDigit,
	  EE: fiveDigit,
	  ES: /^(5[0-2]{1}|[0-4]{1}\d{1})\d{3}$/,
	  FI: fiveDigit,
	  FR: /^\d{2}\s?\d{3}$/,
	  GB: /^(gir\s?0aa|[a-z]{1,2}\d[\da-z]?\s?(\d[a-z]{2})?)$/i,
	  GR: /^\d{3}\s?\d{2}$/,
	  HR: /^([1-5]\d{4}$)/,
	  HT: /^HT\d{4}$/,
	  HU: fourDigit,
	  ID: fiveDigit,
	  IE: /^(?!.*(?:o))[A-Za-z]\d[\dw]\s\w{4}$/i,
	  IL: /^(\d{5}|\d{7})$/,
	  IN: /^((?!10|29|35|54|55|65|66|86|87|88|89)[1-9][0-9]{5})$/,
	  IR: /\b(?!(\d)\1{3})[13-9]{4}[1346-9][013-9]{5}\b/,
	  IS: threeDigit,
	  IT: fiveDigit,
	  JP: /^\d{3}\-\d{4}$/,
	  KE: fiveDigit,
	  KR: /^(\d{5}|\d{6})$/,
	  LI: /^(948[5-9]|949[0-7])$/,
	  LT: /^LT\-\d{5}$/,
	  LU: fourDigit,
	  LV: /^LV\-\d{4}$/,
	  LK: fiveDigit,
	  MX: fiveDigit,
	  MT: /^[A-Za-z]{3}\s{0,1}\d{4}$/,
	  MY: fiveDigit,
	  NL: /^\d{4}\s?[a-z]{2}$/i,
	  NO: fourDigit,
	  NP: /^(10|21|22|32|33|34|44|45|56|57)\d{3}$|^(977)$/i,
	  NZ: fourDigit,
	  PL: /^\d{2}\-\d{3}$/,
	  PR: /^00[679]\d{2}([ -]\d{4})?$/,
	  PT: /^\d{4}\-\d{3}?$/,
	  RO: sixDigit,
	  RU: sixDigit,
	  SA: fiveDigit,
	  SE: /^[1-9]\d{2}\s?\d{2}$/,
	  SG: sixDigit,
	  SI: fourDigit,
	  SK: /^\d{3}\s?\d{2}$/,
	  TH: fiveDigit,
	  TN: fourDigit,
	  TW: /^\d{3}(\d{2})?$/,
	  UA: fiveDigit,
	  US: /^\d{5}(-\d{4})?$/,
	  ZA: fourDigit,
	  ZM: fiveDigit
	};
	var locales = Object.keys(patterns);
	isPostalCode$1.locales = locales;

	function isPostalCode(str, locale) {
	  (0, _assertString$1.default)(str);

	  if (locale in patterns) {
	    return patterns[locale].test(str);
	  } else if (locale === 'any') {
	    for (var key in patterns) {
	      // https://github.com/gotwarlost/istanbul/blob/master/ignoring-code-for-coverage.md#ignoring-code-for-coverage-purposes
	      // istanbul ignore else
	      if (patterns.hasOwnProperty(key)) {
	        var pattern = patterns[key];

	        if (pattern.test(str)) {
	          return true;
	        }
	      }
	    }

	    return false;
	  }

	  throw new Error("Invalid locale '".concat(locale, "'"));
	}

	var ltrimExports = {};
	var ltrim = {
	  get exports(){ return ltrimExports; },
	  set exports(v){ ltrimExports = v; },
	};

	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = ltrim;

		var _assertString = _interopRequireDefault(assertStringExports);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		function ltrim(str, chars) {
		  (0, _assertString.default)(str); // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions#Escaping

		  var pattern = chars ? new RegExp("^[".concat(chars.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), "]+"), 'g') : /^\s+/g;
		  return str.replace(pattern, '');
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
	} (ltrim, ltrimExports));

	var rtrimExports = {};
	var rtrim = {
	  get exports(){ return rtrimExports; },
	  set exports(v){ rtrimExports = v; },
	};

	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = rtrim;

		var _assertString = _interopRequireDefault(assertStringExports);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		function rtrim(str, chars) {
		  (0, _assertString.default)(str);

		  if (chars) {
		    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions#Escaping
		    var pattern = new RegExp("[".concat(chars.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), "]+$"), 'g');
		    return str.replace(pattern, '');
		  } // Use a faster and more safe than regex trim method https://blog.stevenlevithan.com/archives/faster-trim-javascript


		  var strIndex = str.length - 1;

		  while (/\s/.test(str.charAt(strIndex))) {
		    strIndex -= 1;
		  }

		  return str.slice(0, strIndex + 1);
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
	} (rtrim, rtrimExports));

	var trimExports = {};
	var trim$1 = {
	  get exports(){ return trimExports; },
	  set exports(v){ trimExports = v; },
	};

	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = trim;

		var _rtrim = _interopRequireDefault(rtrimExports);

		var _ltrim = _interopRequireDefault(ltrimExports);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		function trim(str, chars) {
		  return (0, _rtrim.default)((0, _ltrim.default)(str, chars), chars);
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
	} (trim$1, trimExports));

	var _escapeExports = {};
	var _escape = {
	  get exports(){ return _escapeExports; },
	  set exports(v){ _escapeExports = v; },
	};

	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = escape;

		var _assertString = _interopRequireDefault(assertStringExports);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		function escape(str) {
		  (0, _assertString.default)(str);
		  return str.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#x27;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/\//g, '&#x2F;').replace(/\\/g, '&#x5C;').replace(/`/g, '&#96;');
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
	} (_escape, _escapeExports));

	var _unescapeExports = {};
	var _unescape = {
	  get exports(){ return _unescapeExports; },
	  set exports(v){ _unescapeExports = v; },
	};

	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = unescape;

		var _assertString = _interopRequireDefault(assertStringExports);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		function unescape(str) {
		  (0, _assertString.default)(str);
		  return str.replace(/&quot;/g, '"').replace(/&#x27;/g, "'").replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&#x2F;/g, '/').replace(/&#x5C;/g, '\\').replace(/&#96;/g, '`').replace(/&amp;/g, '&'); // &amp; replacement has to be the last one to prevent
		  // bugs with intermediate strings containing escape sequences
		  // See: https://github.com/validatorjs/validator.js/issues/1827
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
	} (_unescape, _unescapeExports));

	var stripLowExports = {};
	var stripLow = {
	  get exports(){ return stripLowExports; },
	  set exports(v){ stripLowExports = v; },
	};

	var blacklistExports = {};
	var blacklist = {
	  get exports(){ return blacklistExports; },
	  set exports(v){ blacklistExports = v; },
	};

	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = blacklist;

		var _assertString = _interopRequireDefault(assertStringExports);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		function blacklist(str, chars) {
		  (0, _assertString.default)(str);
		  return str.replace(new RegExp("[".concat(chars, "]+"), 'g'), '');
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
	} (blacklist, blacklistExports));

	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = stripLow;

		var _assertString = _interopRequireDefault(assertStringExports);

		var _blacklist = _interopRequireDefault(blacklistExports);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		function stripLow(str, keep_new_lines) {
		  (0, _assertString.default)(str);
		  var chars = keep_new_lines ? '\\x00-\\x09\\x0B\\x0C\\x0E-\\x1F\\x7F' : '\\x00-\\x1F\\x7F';
		  return (0, _blacklist.default)(str, chars);
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
	} (stripLow, stripLowExports));

	var whitelistExports = {};
	var whitelist = {
	  get exports(){ return whitelistExports; },
	  set exports(v){ whitelistExports = v; },
	};

	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = whitelist;

		var _assertString = _interopRequireDefault(assertStringExports);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		function whitelist(str, chars) {
		  (0, _assertString.default)(str);
		  return str.replace(new RegExp("[^".concat(chars, "]+"), 'g'), '');
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
	} (whitelist, whitelistExports));

	var isWhitelistedExports = {};
	var isWhitelisted = {
	  get exports(){ return isWhitelistedExports; },
	  set exports(v){ isWhitelistedExports = v; },
	};

	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = isWhitelisted;

		var _assertString = _interopRequireDefault(assertStringExports);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		function isWhitelisted(str, chars) {
		  (0, _assertString.default)(str);

		  for (var i = str.length - 1; i >= 0; i--) {
		    if (chars.indexOf(str[i]) === -1) {
		      return false;
		    }
		  }

		  return true;
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
	} (isWhitelisted, isWhitelistedExports));

	var normalizeEmailExports = {};
	var normalizeEmail = {
	  get exports(){ return normalizeEmailExports; },
	  set exports(v){ normalizeEmailExports = v; },
	};

	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = normalizeEmail;

		var _merge = _interopRequireDefault(mergeExports);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		var default_normalize_email_options = {
		  // The following options apply to all email addresses
		  // Lowercases the local part of the email address.
		  // Please note this may violate RFC 5321 as per http://stackoverflow.com/a/9808332/192024).
		  // The domain is always lowercased, as per RFC 1035
		  all_lowercase: true,
		  // The following conversions are specific to GMail
		  // Lowercases the local part of the GMail address (known to be case-insensitive)
		  gmail_lowercase: true,
		  // Removes dots from the local part of the email address, as that's ignored by GMail
		  gmail_remove_dots: true,
		  // Removes the subaddress (e.g. "+foo") from the email address
		  gmail_remove_subaddress: true,
		  // Conversts the googlemail.com domain to gmail.com
		  gmail_convert_googlemaildotcom: true,
		  // The following conversions are specific to Outlook.com / Windows Live / Hotmail
		  // Lowercases the local part of the Outlook.com address (known to be case-insensitive)
		  outlookdotcom_lowercase: true,
		  // Removes the subaddress (e.g. "+foo") from the email address
		  outlookdotcom_remove_subaddress: true,
		  // The following conversions are specific to Yahoo
		  // Lowercases the local part of the Yahoo address (known to be case-insensitive)
		  yahoo_lowercase: true,
		  // Removes the subaddress (e.g. "-foo") from the email address
		  yahoo_remove_subaddress: true,
		  // The following conversions are specific to Yandex
		  // Lowercases the local part of the Yandex address (known to be case-insensitive)
		  yandex_lowercase: true,
		  // The following conversions are specific to iCloud
		  // Lowercases the local part of the iCloud address (known to be case-insensitive)
		  icloud_lowercase: true,
		  // Removes the subaddress (e.g. "+foo") from the email address
		  icloud_remove_subaddress: true
		}; // List of domains used by iCloud

		var icloud_domains = ['icloud.com', 'me.com']; // List of domains used by Outlook.com and its predecessors
		// This list is likely incomplete.
		// Partial reference:
		// https://blogs.office.com/2013/04/17/outlook-com-gets-two-step-verification-sign-in-by-alias-and-new-international-domains/

		var outlookdotcom_domains = ['hotmail.at', 'hotmail.be', 'hotmail.ca', 'hotmail.cl', 'hotmail.co.il', 'hotmail.co.nz', 'hotmail.co.th', 'hotmail.co.uk', 'hotmail.com', 'hotmail.com.ar', 'hotmail.com.au', 'hotmail.com.br', 'hotmail.com.gr', 'hotmail.com.mx', 'hotmail.com.pe', 'hotmail.com.tr', 'hotmail.com.vn', 'hotmail.cz', 'hotmail.de', 'hotmail.dk', 'hotmail.es', 'hotmail.fr', 'hotmail.hu', 'hotmail.id', 'hotmail.ie', 'hotmail.in', 'hotmail.it', 'hotmail.jp', 'hotmail.kr', 'hotmail.lv', 'hotmail.my', 'hotmail.ph', 'hotmail.pt', 'hotmail.sa', 'hotmail.sg', 'hotmail.sk', 'live.be', 'live.co.uk', 'live.com', 'live.com.ar', 'live.com.mx', 'live.de', 'live.es', 'live.eu', 'live.fr', 'live.it', 'live.nl', 'msn.com', 'outlook.at', 'outlook.be', 'outlook.cl', 'outlook.co.il', 'outlook.co.nz', 'outlook.co.th', 'outlook.com', 'outlook.com.ar', 'outlook.com.au', 'outlook.com.br', 'outlook.com.gr', 'outlook.com.pe', 'outlook.com.tr', 'outlook.com.vn', 'outlook.cz', 'outlook.de', 'outlook.dk', 'outlook.es', 'outlook.fr', 'outlook.hu', 'outlook.id', 'outlook.ie', 'outlook.in', 'outlook.it', 'outlook.jp', 'outlook.kr', 'outlook.lv', 'outlook.my', 'outlook.ph', 'outlook.pt', 'outlook.sa', 'outlook.sg', 'outlook.sk', 'passport.com']; // List of domains used by Yahoo Mail
		// This list is likely incomplete

		var yahoo_domains = ['rocketmail.com', 'yahoo.ca', 'yahoo.co.uk', 'yahoo.com', 'yahoo.de', 'yahoo.fr', 'yahoo.in', 'yahoo.it', 'ymail.com']; // List of domains used by yandex.ru

		var yandex_domains = ['yandex.ru', 'yandex.ua', 'yandex.kz', 'yandex.com', 'yandex.by', 'ya.ru']; // replace single dots, but not multiple consecutive dots

		function dotsReplacer(match) {
		  if (match.length > 1) {
		    return match;
		  }

		  return '';
		}

		function normalizeEmail(email, options) {
		  options = (0, _merge.default)(options, default_normalize_email_options);
		  var raw_parts = email.split('@');
		  var domain = raw_parts.pop();
		  var user = raw_parts.join('@');
		  var parts = [user, domain]; // The domain is always lowercased, as it's case-insensitive per RFC 1035

		  parts[1] = parts[1].toLowerCase();

		  if (parts[1] === 'gmail.com' || parts[1] === 'googlemail.com') {
		    // Address is GMail
		    if (options.gmail_remove_subaddress) {
		      parts[0] = parts[0].split('+')[0];
		    }

		    if (options.gmail_remove_dots) {
		      // this does not replace consecutive dots like example..email@gmail.com
		      parts[0] = parts[0].replace(/\.+/g, dotsReplacer);
		    }

		    if (!parts[0].length) {
		      return false;
		    }

		    if (options.all_lowercase || options.gmail_lowercase) {
		      parts[0] = parts[0].toLowerCase();
		    }

		    parts[1] = options.gmail_convert_googlemaildotcom ? 'gmail.com' : parts[1];
		  } else if (icloud_domains.indexOf(parts[1]) >= 0) {
		    // Address is iCloud
		    if (options.icloud_remove_subaddress) {
		      parts[0] = parts[0].split('+')[0];
		    }

		    if (!parts[0].length) {
		      return false;
		    }

		    if (options.all_lowercase || options.icloud_lowercase) {
		      parts[0] = parts[0].toLowerCase();
		    }
		  } else if (outlookdotcom_domains.indexOf(parts[1]) >= 0) {
		    // Address is Outlook.com
		    if (options.outlookdotcom_remove_subaddress) {
		      parts[0] = parts[0].split('+')[0];
		    }

		    if (!parts[0].length) {
		      return false;
		    }

		    if (options.all_lowercase || options.outlookdotcom_lowercase) {
		      parts[0] = parts[0].toLowerCase();
		    }
		  } else if (yahoo_domains.indexOf(parts[1]) >= 0) {
		    // Address is Yahoo
		    if (options.yahoo_remove_subaddress) {
		      var components = parts[0].split('-');
		      parts[0] = components.length > 1 ? components.slice(0, -1).join('-') : components[0];
		    }

		    if (!parts[0].length) {
		      return false;
		    }

		    if (options.all_lowercase || options.yahoo_lowercase) {
		      parts[0] = parts[0].toLowerCase();
		    }
		  } else if (yandex_domains.indexOf(parts[1]) >= 0) {
		    if (options.all_lowercase || options.yandex_lowercase) {
		      parts[0] = parts[0].toLowerCase();
		    }

		    parts[1] = 'yandex.ru'; // all yandex domains are equal, 1st preferred
		  } else if (options.all_lowercase) {
		    // Any other address
		    parts[0] = parts[0].toLowerCase();
		  }

		  return parts.join('@');
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
	} (normalizeEmail, normalizeEmailExports));

	var isSlugExports = {};
	var isSlug = {
	  get exports(){ return isSlugExports; },
	  set exports(v){ isSlugExports = v; },
	};

	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = isSlug;

		var _assertString = _interopRequireDefault(assertStringExports);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		var charsetRegex = /^[^\s-_](?!.*?[-_]{2,})[a-z0-9-\\][^\s]*[^-_\s]$/;

		function isSlug(str) {
		  (0, _assertString.default)(str);
		  return charsetRegex.test(str);
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
	} (isSlug, isSlugExports));

	var isLicensePlateExports = {};
	var isLicensePlate = {
	  get exports(){ return isLicensePlateExports; },
	  set exports(v){ isLicensePlateExports = v; },
	};

	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = isLicensePlate;

		var _assertString = _interopRequireDefault(assertStringExports);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		var validators = {
		  'cs-CZ': function csCZ(str) {
		    return /^(([ABCDEFHKIJKLMNPRSTUVXYZ]|[0-9])-?){5,8}$/.test(str);
		  },
		  'de-DE': function deDE(str) {
		    return /^((AW|UL|AK|GA|AÖ|LF|AZ|AM|AS|ZE|AN|AB|A|KG|KH|BA|EW|BZ|HY|KM|BT|HP|B|BC|BI|BO|FN|TT|ÜB|BN|AH|BS|FR|HB|ZZ|BB|BK|BÖ|OC|OK|CW|CE|C|CO|LH|CB|KW|LC|LN|DA|DI|DE|DH|SY|NÖ|DO|DD|DU|DN|D|EI|EA|EE|FI|EM|EL|EN|PF|ED|EF|ER|AU|ZP|E|ES|NT|EU|FL|FO|FT|FF|F|FS|FD|FÜ|GE|G|GI|GF|GS|ZR|GG|GP|GR|NY|ZI|GÖ|GZ|GT|HA|HH|HM|HU|WL|HZ|WR|RN|HK|HD|HN|HS|GK|HE|HF|RZ|HI|HG|HO|HX|IK|IL|IN|J|JL|KL|KA|KS|KF|KE|KI|KT|KO|KN|KR|KC|KU|K|LD|LL|LA|L|OP|LM|LI|LB|LU|LÖ|HL|LG|MD|GN|MZ|MA|ML|MR|MY|AT|DM|MC|NZ|RM|RG|MM|ME|MB|MI|FG|DL|HC|MW|RL|MK|MG|MÜ|WS|MH|M|MS|NU|NB|ND|NM|NK|NW|NR|NI|NF|DZ|EB|OZ|TG|TO|N|OA|GM|OB|CA|EH|FW|OF|OL|OE|OG|BH|LR|OS|AA|GD|OH|KY|NP|WK|PB|PA|PE|PI|PS|P|PM|PR|RA|RV|RE|R|H|SB|WN|RS|RD|RT|BM|NE|GV|RP|SU|GL|RO|GÜ|RH|EG|RW|PN|SK|MQ|RU|SZ|RI|SL|SM|SC|HR|FZ|VS|SW|SN|CR|SE|SI|SO|LP|SG|NH|SP|IZ|ST|BF|TE|HV|OD|SR|S|AC|DW|ZW|TF|TS|TR|TÜ|UM|PZ|TP|UE|UN|UH|MN|KK|VB|V|AE|PL|RC|VG|GW|PW|VR|VK|KB|WA|WT|BE|WM|WE|AP|MO|WW|FB|WZ|WI|WB|JE|WF|WO|W|WÜ|BL|Z|GC)[- ]?[A-Z]{1,2}[- ]?\d{1,4}|(AIC|FDB|ABG|SLN|SAW|KLZ|BUL|ESB|NAB|SUL|WST|ABI|AZE|BTF|KÖT|DKB|FEU|ROT|ALZ|SMÜ|WER|AUR|NOR|DÜW|BRK|HAB|TÖL|WOR|BAD|BAR|BER|BIW|EBS|KEM|MÜB|PEG|BGL|BGD|REI|WIL|BKS|BIR|WAT|BOR|BOH|BOT|BRB|BLK|HHM|NEB|NMB|WSF|LEO|HDL|WMS|WZL|BÜS|CHA|KÖZ|ROD|WÜM|CLP|NEC|COC|ZEL|COE|CUX|DAH|LDS|DEG|DEL|RSL|DLG|DGF|LAN|HEI|MED|DON|KIB|ROK|JÜL|MON|SLE|EBE|EIC|HIG|WBS|BIT|PRÜ|LIB|EMD|WIT|ERH|HÖS|ERZ|ANA|ASZ|MAB|MEK|STL|SZB|FDS|HCH|HOR|WOL|FRG|GRA|WOS|FRI|FFB|GAP|GER|BRL|CLZ|GTH|NOH|HGW|GRZ|LÖB|NOL|WSW|DUD|HMÜ|OHA|KRU|HAL|HAM|HBS|QLB|HVL|NAU|HAS|EBN|GEO|HOH|HDH|ERK|HER|WAN|HEF|ROF|HBN|ALF|HSK|USI|NAI|REH|SAN|KÜN|ÖHR|HOL|WAR|ARN|BRG|GNT|HOG|WOH|KEH|MAI|PAR|RID|ROL|KLE|GEL|KUS|KYF|ART|SDH|LDK|DIL|MAL|VIB|LER|BNA|GHA|GRM|MTL|WUR|LEV|LIF|STE|WEL|LIP|VAI|LUP|HGN|LBZ|LWL|PCH|STB|DAN|MKK|SLÜ|MSP|TBB|MGH|MTK|BIN|MSH|EIL|HET|SGH|BID|MYK|MSE|MST|MÜR|WRN|MEI|GRH|RIE|MZG|MIL|OBB|BED|FLÖ|MOL|FRW|SEE|SRB|AIB|MOS|BCH|ILL|SOB|NMS|NEA|SEF|UFF|NEW|VOH|NDH|TDO|NWM|GDB|GVM|WIS|NOM|EIN|GAN|LAU|HEB|OHV|OSL|SFB|ERB|LOS|BSK|KEL|BSB|MEL|WTL|OAL|FÜS|MOD|OHZ|OPR|BÜR|PAF|PLÖ|CAS|GLA|REG|VIT|ECK|SIM|GOA|EMS|DIZ|GOH|RÜD|SWA|NES|KÖN|MET|LRO|BÜZ|DBR|ROS|TET|HRO|ROW|BRV|HIP|PAN|GRI|SHK|EIS|SRO|SOK|LBS|SCZ|MER|QFT|SLF|SLS|HOM|SLK|ASL|BBG|SBK|SFT|SHG|MGN|MEG|ZIG|SAD|NEN|OVI|SHA|BLB|SIG|SON|SPN|FOR|GUB|SPB|IGB|WND|STD|STA|SDL|OBG|HST|BOG|SHL|PIR|FTL|SEB|SÖM|SÜW|TIR|SAB|TUT|ANG|SDT|LÜN|LSZ|MHL|VEC|VER|VIE|OVL|ANK|OVP|SBG|UEM|UER|WLG|GMN|NVP|RDG|RÜG|DAU|FKB|WAF|WAK|SLZ|WEN|SOG|APD|WUG|GUN|ESW|WIZ|WES|DIN|BRA|BÜD|WHV|HWI|GHC|WTM|WOB|WUN|MAK|SEL|OCH|HOT|WDA)[- ]?(([A-Z][- ]?\d{1,4})|([A-Z]{2}[- ]?\d{1,3})))[- ]?(E|H)?$/.test(str);
		  },
		  'de-LI': function deLI(str) {
		    return /^FL[- ]?\d{1,5}[UZ]?$/.test(str);
		  },
		  'fi-FI': function fiFI(str) {
		    return /^(?=.{4,7})(([A-Z]{1,3}|[0-9]{1,3})[\s-]?([A-Z]{1,3}|[0-9]{1,5}))$/.test(str);
		  },
		  'pt-PT': function ptPT(str) {
		    return /^([A-Z]{2}|[0-9]{2})[ -·]?([A-Z]{2}|[0-9]{2})[ -·]?([A-Z]{2}|[0-9]{2})$/.test(str);
		  },
		  'sq-AL': function sqAL(str) {
		    return /^[A-Z]{2}[- ]?((\d{3}[- ]?(([A-Z]{2})|T))|(R[- ]?\d{3}))$/.test(str);
		  },
		  'pt-BR': function ptBR(str) {
		    return /^[A-Z]{3}[ -]?[0-9][A-Z][0-9]{2}|[A-Z]{3}[ -]?[0-9]{4}$/.test(str);
		  }
		};

		function isLicensePlate(str, locale) {
		  (0, _assertString.default)(str);

		  if (locale in validators) {
		    return validators[locale](str);
		  } else if (locale === 'any') {
		    for (var key in validators) {
		      /* eslint guard-for-in: 0 */
		      var validator = validators[key];

		      if (validator(str)) {
		        return true;
		      }
		    }

		    return false;
		  }

		  throw new Error("Invalid locale '".concat(locale, "'"));
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
	} (isLicensePlate, isLicensePlateExports));

	var isStrongPasswordExports = {};
	var isStrongPassword = {
	  get exports(){ return isStrongPasswordExports; },
	  set exports(v){ isStrongPasswordExports = v; },
	};

	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = isStrongPassword;

		var _merge = _interopRequireDefault(mergeExports);

		var _assertString = _interopRequireDefault(assertStringExports);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		var upperCaseRegex = /^[A-Z]$/;
		var lowerCaseRegex = /^[a-z]$/;
		var numberRegex = /^[0-9]$/;
		var symbolRegex = /^[-#!$@%^&*()_+|~=`{}\[\]:";'<>?,.\/ ]$/;
		var defaultOptions = {
		  minLength: 8,
		  minLowercase: 1,
		  minUppercase: 1,
		  minNumbers: 1,
		  minSymbols: 1,
		  returnScore: false,
		  pointsPerUnique: 1,
		  pointsPerRepeat: 0.5,
		  pointsForContainingLower: 10,
		  pointsForContainingUpper: 10,
		  pointsForContainingNumber: 10,
		  pointsForContainingSymbol: 10
		};
		/* Counts number of occurrences of each char in a string
		 * could be moved to util/ ?
		*/

		function countChars(str) {
		  var result = {};
		  Array.from(str).forEach(function (char) {
		    var curVal = result[char];

		    if (curVal) {
		      result[char] += 1;
		    } else {
		      result[char] = 1;
		    }
		  });
		  return result;
		}
		/* Return information about a password */


		function analyzePassword(password) {
		  var charMap = countChars(password);
		  var analysis = {
		    length: password.length,
		    uniqueChars: Object.keys(charMap).length,
		    uppercaseCount: 0,
		    lowercaseCount: 0,
		    numberCount: 0,
		    symbolCount: 0
		  };
		  Object.keys(charMap).forEach(function (char) {
		    /* istanbul ignore else */
		    if (upperCaseRegex.test(char)) {
		      analysis.uppercaseCount += charMap[char];
		    } else if (lowerCaseRegex.test(char)) {
		      analysis.lowercaseCount += charMap[char];
		    } else if (numberRegex.test(char)) {
		      analysis.numberCount += charMap[char];
		    } else if (symbolRegex.test(char)) {
		      analysis.symbolCount += charMap[char];
		    }
		  });
		  return analysis;
		}

		function scorePassword(analysis, scoringOptions) {
		  var points = 0;
		  points += analysis.uniqueChars * scoringOptions.pointsPerUnique;
		  points += (analysis.length - analysis.uniqueChars) * scoringOptions.pointsPerRepeat;

		  if (analysis.lowercaseCount > 0) {
		    points += scoringOptions.pointsForContainingLower;
		  }

		  if (analysis.uppercaseCount > 0) {
		    points += scoringOptions.pointsForContainingUpper;
		  }

		  if (analysis.numberCount > 0) {
		    points += scoringOptions.pointsForContainingNumber;
		  }

		  if (analysis.symbolCount > 0) {
		    points += scoringOptions.pointsForContainingSymbol;
		  }

		  return points;
		}

		function isStrongPassword(str) {
		  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
		  (0, _assertString.default)(str);
		  var analysis = analyzePassword(str);
		  options = (0, _merge.default)(options || {}, defaultOptions);

		  if (options.returnScore) {
		    return scorePassword(analysis, options);
		  }

		  return analysis.length >= options.minLength && analysis.lowercaseCount >= options.minLowercase && analysis.uppercaseCount >= options.minUppercase && analysis.numberCount >= options.minNumbers && analysis.symbolCount >= options.minSymbols;
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
	} (isStrongPassword, isStrongPasswordExports));

	var isVAT$1 = {};

	Object.defineProperty(isVAT$1, "__esModule", {
	  value: true
	});
	isVAT$1.default = isVAT;
	isVAT$1.vatMatchers = void 0;

	var _assertString = _interopRequireDefault(assertStringExports);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var vatMatchers = {
	  GB: /^GB((\d{3} \d{4} ([0-8][0-9]|9[0-6]))|(\d{9} \d{3})|(((GD[0-4])|(HA[5-9]))[0-9]{2}))$/,
	  IT: /^(IT)?[0-9]{11}$/,
	  NL: /^(NL)?[0-9]{9}B[0-9]{2}$/
	};
	isVAT$1.vatMatchers = vatMatchers;

	function isVAT(str, countryCode) {
	  (0, _assertString.default)(str);
	  (0, _assertString.default)(countryCode);

	  if (countryCode in vatMatchers) {
	    return vatMatchers[countryCode].test(str);
	  }

	  throw new Error("Invalid country code: '".concat(countryCode, "'"));
	}

	(function (module, exports) {

		function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = void 0;

		var _toDate = _interopRequireDefault(toDateExports);

		var _toFloat = _interopRequireDefault(toFloatExports);

		var _toInt = _interopRequireDefault(toIntExports);

		var _toBoolean = _interopRequireDefault(toBooleanExports);

		var _equals = _interopRequireDefault(equalsExports);

		var _contains = _interopRequireDefault(containsExports);

		var _matches = _interopRequireDefault(matchesExports);

		var _isEmail = _interopRequireDefault(isEmailExports);

		var _isURL = _interopRequireDefault(isURLExports);

		var _isMACAddress = _interopRequireDefault(isMACAddressExports);

		var _isIP = _interopRequireDefault(isIPExports);

		var _isIPRange = _interopRequireDefault(isIPRangeExports);

		var _isFQDN = _interopRequireDefault(isFQDNExports);

		var _isDate = _interopRequireDefault(isDateExports);

		var _isBoolean = _interopRequireDefault(isBooleanExports);

		var _isLocale = _interopRequireDefault(isLocaleExports);

		var _isAlpha = _interopRequireWildcard(isAlpha$1);

		var _isAlphanumeric = _interopRequireWildcard(isAlphanumeric$1);

		var _isNumeric = _interopRequireDefault(isNumericExports);

		var _isPassportNumber = _interopRequireDefault(isPassportNumberExports);

		var _isPort = _interopRequireDefault(isPortExports);

		var _isLowercase = _interopRequireDefault(isLowercaseExports);

		var _isUppercase = _interopRequireDefault(isUppercaseExports);

		var _isIMEI = _interopRequireDefault(isIMEIExports);

		var _isAscii = _interopRequireDefault(isAsciiExports);

		var _isFullWidth = _interopRequireDefault(isFullWidth$1);

		var _isHalfWidth = _interopRequireDefault(isHalfWidth$1);

		var _isVariableWidth = _interopRequireDefault(isVariableWidthExports);

		var _isMultibyte = _interopRequireDefault(isMultibyteExports);

		var _isSemVer = _interopRequireDefault(isSemVerExports);

		var _isSurrogatePair = _interopRequireDefault(isSurrogatePairExports);

		var _isInt = _interopRequireDefault(isIntExports);

		var _isFloat = _interopRequireWildcard(isFloat$2);

		var _isDecimal = _interopRequireDefault(isDecimalExports);

		var _isHexadecimal = _interopRequireDefault(isHexadecimalExports);

		var _isOctal = _interopRequireDefault(isOctalExports);

		var _isDivisibleBy = _interopRequireDefault(isDivisibleByExports);

		var _isHexColor = _interopRequireDefault(isHexColorExports);

		var _isRgbColor = _interopRequireDefault(isRgbColorExports);

		var _isHSL = _interopRequireDefault(isHSLExports);

		var _isISRC = _interopRequireDefault(isISRCExports);

		var _isIBAN = _interopRequireWildcard(isIBAN$1);

		var _isBIC = _interopRequireDefault(isBICExports);

		var _isMD = _interopRequireDefault(isMD5Exports);

		var _isHash = _interopRequireDefault(isHashExports);

		var _isJWT = _interopRequireDefault(isJWTExports);

		var _isJSON = _interopRequireDefault(isJSONExports);

		var _isEmpty = _interopRequireDefault(isEmptyExports);

		var _isLength = _interopRequireDefault(isLengthExports);

		var _isByteLength = _interopRequireDefault(isByteLengthExports);

		var _isUUID = _interopRequireDefault(isUUIDExports);

		var _isMongoId = _interopRequireDefault(isMongoIdExports);

		var _isAfter = _interopRequireDefault(isAfterExports);

		var _isBefore = _interopRequireDefault(isBeforeExports);

		var _isIn = _interopRequireDefault(isInExports);

		var _isCreditCard = _interopRequireDefault(isCreditCardExports);

		var _isIdentityCard = _interopRequireDefault(isIdentityCardExports);

		var _isEAN = _interopRequireDefault(isEANExports);

		var _isISIN = _interopRequireDefault(isISINExports);

		var _isISBN = _interopRequireDefault(isISBNExports);

		var _isISSN = _interopRequireDefault(isISSNExports);

		var _isTaxID = _interopRequireDefault(isTaxIDExports);

		var _isMobilePhone = _interopRequireWildcard(isMobilePhone$1);

		var _isEthereumAddress = _interopRequireDefault(isEthereumAddressExports);

		var _isCurrency = _interopRequireDefault(isCurrencyExports);

		var _isBtcAddress = _interopRequireDefault(isBtcAddressExports);

		var _isISO = _interopRequireDefault(isISO8601Exports);

		var _isRFC = _interopRequireDefault(isRFC3339Exports);

		var _isISO31661Alpha = _interopRequireDefault(isISO31661Alpha2$1);

		var _isISO31661Alpha2 = _interopRequireDefault(isISO31661Alpha3Exports);

		var _isISO2 = _interopRequireDefault(isISO4217$1);

		var _isBase = _interopRequireDefault(isBase32Exports);

		var _isBase2 = _interopRequireDefault(isBase58Exports);

		var _isBase3 = _interopRequireDefault(isBase64Exports);

		var _isDataURI = _interopRequireDefault(isDataURIExports);

		var _isMagnetURI = _interopRequireDefault(isMagnetURIExports);

		var _isMimeType = _interopRequireDefault(isMimeTypeExports);

		var _isLatLong = _interopRequireDefault(isLatLongExports);

		var _isPostalCode = _interopRequireWildcard(isPostalCode$1);

		var _ltrim = _interopRequireDefault(ltrimExports);

		var _rtrim = _interopRequireDefault(rtrimExports);

		var _trim = _interopRequireDefault(trimExports);

		var _escape = _interopRequireDefault(_escapeExports);

		var _unescape = _interopRequireDefault(_unescapeExports);

		var _stripLow = _interopRequireDefault(stripLowExports);

		var _whitelist = _interopRequireDefault(whitelistExports);

		var _blacklist = _interopRequireDefault(blacklistExports);

		var _isWhitelisted = _interopRequireDefault(isWhitelistedExports);

		var _normalizeEmail = _interopRequireDefault(normalizeEmailExports);

		var _isSlug = _interopRequireDefault(isSlugExports);

		var _isLicensePlate = _interopRequireDefault(isLicensePlateExports);

		var _isStrongPassword = _interopRequireDefault(isStrongPasswordExports);

		var _isVAT = _interopRequireDefault(isVAT$1);

		function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

		function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		var version = '13.7.0';
		var validator = {
		  version: version,
		  toDate: _toDate.default,
		  toFloat: _toFloat.default,
		  toInt: _toInt.default,
		  toBoolean: _toBoolean.default,
		  equals: _equals.default,
		  contains: _contains.default,
		  matches: _matches.default,
		  isEmail: _isEmail.default,
		  isURL: _isURL.default,
		  isMACAddress: _isMACAddress.default,
		  isIP: _isIP.default,
		  isIPRange: _isIPRange.default,
		  isFQDN: _isFQDN.default,
		  isBoolean: _isBoolean.default,
		  isIBAN: _isIBAN.default,
		  isBIC: _isBIC.default,
		  isAlpha: _isAlpha.default,
		  isAlphaLocales: _isAlpha.locales,
		  isAlphanumeric: _isAlphanumeric.default,
		  isAlphanumericLocales: _isAlphanumeric.locales,
		  isNumeric: _isNumeric.default,
		  isPassportNumber: _isPassportNumber.default,
		  isPort: _isPort.default,
		  isLowercase: _isLowercase.default,
		  isUppercase: _isUppercase.default,
		  isAscii: _isAscii.default,
		  isFullWidth: _isFullWidth.default,
		  isHalfWidth: _isHalfWidth.default,
		  isVariableWidth: _isVariableWidth.default,
		  isMultibyte: _isMultibyte.default,
		  isSemVer: _isSemVer.default,
		  isSurrogatePair: _isSurrogatePair.default,
		  isInt: _isInt.default,
		  isIMEI: _isIMEI.default,
		  isFloat: _isFloat.default,
		  isFloatLocales: _isFloat.locales,
		  isDecimal: _isDecimal.default,
		  isHexadecimal: _isHexadecimal.default,
		  isOctal: _isOctal.default,
		  isDivisibleBy: _isDivisibleBy.default,
		  isHexColor: _isHexColor.default,
		  isRgbColor: _isRgbColor.default,
		  isHSL: _isHSL.default,
		  isISRC: _isISRC.default,
		  isMD5: _isMD.default,
		  isHash: _isHash.default,
		  isJWT: _isJWT.default,
		  isJSON: _isJSON.default,
		  isEmpty: _isEmpty.default,
		  isLength: _isLength.default,
		  isLocale: _isLocale.default,
		  isByteLength: _isByteLength.default,
		  isUUID: _isUUID.default,
		  isMongoId: _isMongoId.default,
		  isAfter: _isAfter.default,
		  isBefore: _isBefore.default,
		  isIn: _isIn.default,
		  isCreditCard: _isCreditCard.default,
		  isIdentityCard: _isIdentityCard.default,
		  isEAN: _isEAN.default,
		  isISIN: _isISIN.default,
		  isISBN: _isISBN.default,
		  isISSN: _isISSN.default,
		  isMobilePhone: _isMobilePhone.default,
		  isMobilePhoneLocales: _isMobilePhone.locales,
		  isPostalCode: _isPostalCode.default,
		  isPostalCodeLocales: _isPostalCode.locales,
		  isEthereumAddress: _isEthereumAddress.default,
		  isCurrency: _isCurrency.default,
		  isBtcAddress: _isBtcAddress.default,
		  isISO8601: _isISO.default,
		  isRFC3339: _isRFC.default,
		  isISO31661Alpha2: _isISO31661Alpha.default,
		  isISO31661Alpha3: _isISO31661Alpha2.default,
		  isISO4217: _isISO2.default,
		  isBase32: _isBase.default,
		  isBase58: _isBase2.default,
		  isBase64: _isBase3.default,
		  isDataURI: _isDataURI.default,
		  isMagnetURI: _isMagnetURI.default,
		  isMimeType: _isMimeType.default,
		  isLatLong: _isLatLong.default,
		  ltrim: _ltrim.default,
		  rtrim: _rtrim.default,
		  trim: _trim.default,
		  escape: _escape.default,
		  unescape: _unescape.default,
		  stripLow: _stripLow.default,
		  whitelist: _whitelist.default,
		  blacklist: _blacklist.default,
		  isWhitelisted: _isWhitelisted.default,
		  normalizeEmail: _normalizeEmail.default,
		  toString: toString,
		  isSlug: _isSlug.default,
		  isStrongPassword: _isStrongPassword.default,
		  isTaxID: _isTaxID.default,
		  isDate: _isDate.default,
		  isLicensePlate: _isLicensePlate.default,
		  isVAT: _isVAT.default,
		  ibanLocales: _isIBAN.locales
		};
		var _default = validator;
		exports.default = _default;
		module.exports = exports.default;
		module.exports.default = exports.default;
	} (validator$1, validatorExports));

	/*jshint maxlen: false*/

	var validator = validatorExports;

	var FormatValidators$1 = {
	    "date": function (date) {
	        if (typeof date !== "string") {
	            return true;
	        }
	        // full-date from http://tools.ietf.org/html/rfc3339#section-5.6
	        var matches = /^([0-9]{4})-([0-9]{2})-([0-9]{2})$/.exec(date);
	        if (matches === null) {
	            return false;
	        }
	        // var year = matches[1];
	        // var month = matches[2];
	        // var day = matches[3];
	        if (matches[2] < "01" || matches[2] > "12" || matches[3] < "01" || matches[3] > "31") {
	            return false;
	        }
	        return true;
	    },
	    "date-time": function (dateTime) {
	        if (typeof dateTime !== "string") {
	            return true;
	        }
	        // date-time from http://tools.ietf.org/html/rfc3339#section-5.6
	        var s = dateTime.toLowerCase().split("t");
	        if (!FormatValidators$1.date(s[0])) {
	            return false;
	        }
	        var matches = /^([0-9]{2}):([0-9]{2}):([0-9]{2})(.[0-9]+)?(z|([+-][0-9]{2}:[0-9]{2}))$/.exec(s[1]);
	        if (matches === null) {
	            return false;
	        }
	        // var hour = matches[1];
	        // var minute = matches[2];
	        // var second = matches[3];
	        // var fraction = matches[4];
	        // var timezone = matches[5];
	        if (matches[1] > "23" || matches[2] > "59" || matches[3] > "59") {
	            return false;
	        }
	        return true;
	    },
	    "email": function (email) {
	        if (typeof email !== "string") {
	            return true;
	        }
	        return validator.isEmail(email, { "require_tld": true });
	    },
	    "hostname": function (hostname) {
	        if (typeof hostname !== "string") {
	            return true;
	        }
	        /*
	            http://json-schema.org/latest/json-schema-validation.html#anchor114
	            A string instance is valid against this attribute if it is a valid
	            representation for an Internet host name, as defined by RFC 1034, section 3.1 [RFC1034].

	            http://tools.ietf.org/html/rfc1034#section-3.5

	            <digit> ::= any one of the ten digits 0 through 9
	            var digit = /[0-9]/;

	            <letter> ::= any one of the 52 alphabetic characters A through Z in upper case and a through z in lower case
	            var letter = /[a-zA-Z]/;

	            <let-dig> ::= <letter> | <digit>
	            var letDig = /[0-9a-zA-Z]/;

	            <let-dig-hyp> ::= <let-dig> | "-"
	            var letDigHyp = /[-0-9a-zA-Z]/;

	            <ldh-str> ::= <let-dig-hyp> | <let-dig-hyp> <ldh-str>
	            var ldhStr = /[-0-9a-zA-Z]+/;

	            <label> ::= <letter> [ [ <ldh-str> ] <let-dig> ]
	            var label = /[a-zA-Z](([-0-9a-zA-Z]+)?[0-9a-zA-Z])?/;

	            <subdomain> ::= <label> | <subdomain> "." <label>
	            var subdomain = /^[a-zA-Z](([-0-9a-zA-Z]+)?[0-9a-zA-Z])?(\.[a-zA-Z](([-0-9a-zA-Z]+)?[0-9a-zA-Z])?)*$/;

	            <domain> ::= <subdomain> | " "
	            var domain = null;
	        */
	        var valid = /^[a-zA-Z](([-0-9a-zA-Z]+)?[0-9a-zA-Z])?(\.[a-zA-Z](([-0-9a-zA-Z]+)?[0-9a-zA-Z])?)*$/.test(hostname);
	        if (valid) {
	            // the sum of all label octets and label lengths is limited to 255.
	            if (hostname.length > 255) { return false; }
	            // Each node has a label, which is zero to 63 octets in length
	            var labels = hostname.split(".");
	            for (var i = 0; i < labels.length; i++) { if (labels[i].length > 63) { return false; } }
	        }
	        return valid;
	    },
	    "host-name": function (hostname) {
	        return FormatValidators$1.hostname.call(this, hostname);
	    },
	    "ipv4": function (ipv4) {
	        if (typeof ipv4 !== "string") { return true; }
	        return validator.isIP(ipv4, 4);
	    },
	    "ipv6": function (ipv6) {
	        if (typeof ipv6 !== "string") { return true; }
	        return validator.isIP(ipv6, 6);
	    },
	    "regex": function (str) {
	        try {
	            RegExp(str);
	            return true;
	        } catch (e) {
	            return false;
	        }
	    },
	    "uri": function (uri) {
	        if (this.options.strictUris) {
	            return FormatValidators$1["strict-uri"].apply(this, arguments);
	        }
	        // https://github.com/zaggino/z-schema/issues/18
	        // RegExp from http://tools.ietf.org/html/rfc3986#appendix-B
	        return typeof uri !== "string" || RegExp("^(([^:/?#]+):)?(//([^/?#]*))?([^?#]*)(\\?([^#]*))?(#(.*))?").test(uri);
	    },
	    "strict-uri": function (uri) {
	        return typeof uri !== "string" || validator.isURL(uri);
	    }
	};

	var FormatValidators_1 = FormatValidators$1;

	var JsonValidation$1 = {};

	(function (exports) {

		var FormatValidators = FormatValidators_1,
		    Report           = Report_1,
		    Utils            = Utils$2;

		var shouldSkipValidate = function (options, errors) {
		    return options &&
		        Array.isArray(options.includeErrors) &&
		        options.includeErrors.length > 0 &&
		        !errors.some(function (err) { return options.includeErrors.includes(err);});
		};

		var JsonValidators = {
		    multipleOf: function (report, schema, json) {
		        // http://json-schema.org/latest/json-schema-validation.html#rfc.section.5.1.1.2
		        if (shouldSkipValidate(this.validateOptions, ["MULTIPLE_OF"])) {
		            return;
		        }
		        if (typeof json !== "number") {
		            return;
		        }

		        var stringMultipleOf = String(schema.multipleOf);
		        var scale = Math.pow(10, stringMultipleOf.length - stringMultipleOf.indexOf(".") - 1);
		        if (Utils.whatIs((json * scale) / (schema.multipleOf * scale)) !== "integer") {
		            report.addError("MULTIPLE_OF", [json, schema.multipleOf], null, schema);
		        }
		    },
		    maximum: function (report, schema, json) {
		        // http://json-schema.org/latest/json-schema-validation.html#rfc.section.5.1.2.2
		        if (shouldSkipValidate(this.validateOptions, ["MAXIMUM", "MAXIMUM_EXCLUSIVE"])) {
		            return;
		        }
		        if (typeof json !== "number") {
		            return;
		        }
		        if (schema.exclusiveMaximum !== true) {
		            if (json > schema.maximum) {
		                report.addError("MAXIMUM", [json, schema.maximum], null, schema);
		            }
		        } else {
		            if (json >= schema.maximum) {
		                report.addError("MAXIMUM_EXCLUSIVE", [json, schema.maximum], null, schema);
		            }
		        }
		    },
		    exclusiveMaximum: function () {
		        // covered in maximum
		    },
		    minimum: function (report, schema, json) {
		        // http://json-schema.org/latest/json-schema-validation.html#rfc.section.5.1.3.2
		        if (shouldSkipValidate(this.validateOptions, ["MINIMUM", "MINIMUM_EXCLUSIVE"])) {
		            return;
		        }
		        if (typeof json !== "number") {
		            return;
		        }
		        if (schema.exclusiveMinimum !== true) {
		            if (json < schema.minimum) {
		                report.addError("MINIMUM", [json, schema.minimum], null, schema);
		            }
		        } else {
		            if (json <= schema.minimum) {
		                report.addError("MINIMUM_EXCLUSIVE", [json, schema.minimum], null, schema);
		            }
		        }
		    },
		    exclusiveMinimum: function () {
		        // covered in minimum
		    },
		    maxLength: function (report, schema, json) {
		        // http://json-schema.org/latest/json-schema-validation.html#rfc.section.5.2.1.2
		        if (shouldSkipValidate(this.validateOptions, ["MAX_LENGTH"])) {
		            return;
		        }
		        if (typeof json !== "string") {
		            return;
		        }
		        if (Utils.ucs2decode(json).length > schema.maxLength) {
		            report.addError("MAX_LENGTH", [json.length, schema.maxLength], null, schema);
		        }
		    },
		    minLength: function (report, schema, json) {
		        // http://json-schema.org/latest/json-schema-validation.html#rfc.section.5.2.2.2
		        if (shouldSkipValidate(this.validateOptions, ["MIN_LENGTH"])) {
		            return;
		        }
		        if (typeof json !== "string") {
		            return;
		        }
		        if (Utils.ucs2decode(json).length < schema.minLength) {
		            report.addError("MIN_LENGTH", [json.length, schema.minLength], null, schema);
		        }
		    },
		    pattern: function (report, schema, json) {
		        // http://json-schema.org/latest/json-schema-validation.html#rfc.section.5.2.3.2
		        if (shouldSkipValidate(this.validateOptions, ["PATTERN"])) {
		            return;
		        }
		        if (typeof json !== "string") {
		            return;
		        }
		        if (RegExp(schema.pattern).test(json) === false) {
		            report.addError("PATTERN", [schema.pattern, json], null, schema);
		        }
		    },
		    additionalItems: function (report, schema, json) {
		        // http://json-schema.org/latest/json-schema-validation.html#rfc.section.5.3.1.2
		        if (shouldSkipValidate(this.validateOptions, ["ARRAY_ADDITIONAL_ITEMS"])) {
		            return;
		        }
		        if (!Array.isArray(json)) {
		            return;
		        }
		        // if the value of "additionalItems" is boolean value false and the value of "items" is an array,
		        // the json is valid if its size is less than, or equal to, the size of "items".
		        if (schema.additionalItems === false && Array.isArray(schema.items)) {
		            if (json.length > schema.items.length) {
		                report.addError("ARRAY_ADDITIONAL_ITEMS", null, null, schema);
		            }
		        }
		    },
		    items: function () { /*report, schema, json*/
		        // covered in additionalItems
		    },
		    maxItems: function (report, schema, json) {
		        // http://json-schema.org/latest/json-schema-validation.html#rfc.section.5.3.2.2
		        if (shouldSkipValidate(this.validateOptions, ["ARRAY_LENGTH_LONG"])) {
		            return;
		        }
		        if (!Array.isArray(json)) {
		            return;
		        }
		        if (json.length > schema.maxItems) {
		            report.addError("ARRAY_LENGTH_LONG", [json.length, schema.maxItems], null, schema);
		        }
		    },
		    minItems: function (report, schema, json) {
		        // http://json-schema.org/latest/json-schema-validation.html#rfc.section.5.3.3.2
		        if (shouldSkipValidate(this.validateOptions, ["ARRAY_LENGTH_SHORT"])) {
		            return;
		        }
		        if (!Array.isArray(json)) {
		            return;
		        }
		        if (json.length < schema.minItems) {
		            report.addError("ARRAY_LENGTH_SHORT", [json.length, schema.minItems], null, schema);
		        }
		    },
		    uniqueItems: function (report, schema, json) {
		        // http://json-schema.org/latest/json-schema-validation.html#rfc.section.5.3.4.2
		        if (shouldSkipValidate(this.validateOptions, ["ARRAY_UNIQUE"])) {
		            return;
		        }
		        if (!Array.isArray(json)) {
		            return;
		        }
		        if (schema.uniqueItems === true) {
		            var matches = [];
		            if (Utils.isUniqueArray(json, matches) === false) {
		                report.addError("ARRAY_UNIQUE", matches, null, schema);
		            }
		        }
		    },
		    maxProperties: function (report, schema, json) {
		        // http://json-schema.org/latest/json-schema-validation.html#rfc.section.5.4.1.2
		        if (shouldSkipValidate(this.validateOptions, ["OBJECT_PROPERTIES_MAXIMUM"])) {
		            return;
		        }
		        if (Utils.whatIs(json) !== "object") {
		            return;
		        }
		        var keysCount = Object.keys(json).length;
		        if (keysCount > schema.maxProperties) {
		            report.addError("OBJECT_PROPERTIES_MAXIMUM", [keysCount, schema.maxProperties], null, schema);
		        }
		    },
		    minProperties: function (report, schema, json) {
		        // http://json-schema.org/latest/json-schema-validation.html#rfc.section.5.4.2.2
		        if (shouldSkipValidate(this.validateOptions, ["OBJECT_PROPERTIES_MINIMUM"])) {
		            return;
		        }
		        if (Utils.whatIs(json) !== "object") {
		            return;
		        }
		        var keysCount = Object.keys(json).length;
		        if (keysCount < schema.minProperties) {
		            report.addError("OBJECT_PROPERTIES_MINIMUM", [keysCount, schema.minProperties], null, schema);
		        }
		    },
		    required: function (report, schema, json) {
		        // http://json-schema.org/latest/json-schema-validation.html#rfc.section.5.4.3.2
		        if (shouldSkipValidate(this.validateOptions, ["OBJECT_MISSING_REQUIRED_PROPERTY"])) {
		            return;
		        }
		        if (Utils.whatIs(json) !== "object") {
		            return;
		        }
		        var idx = schema.required.length;
		        while (idx--) {
		            var requiredPropertyName = schema.required[idx];
		            if (json[requiredPropertyName] === undefined) {
		                report.addError("OBJECT_MISSING_REQUIRED_PROPERTY", [requiredPropertyName], null, schema);
		            }
		        }
		    },
		    additionalProperties: function (report, schema, json) {
		        // covered in properties and patternProperties
		        if (schema.properties === undefined && schema.patternProperties === undefined) {
		            return JsonValidators.properties.call(this, report, schema, json);
		        }
		    },
		    patternProperties: function (report, schema, json) {
		        // covered in properties
		        if (schema.properties === undefined) {
		            return JsonValidators.properties.call(this, report, schema, json);
		        }
		    },
		    properties: function (report, schema, json) {
		        // http://json-schema.org/latest/json-schema-validation.html#rfc.section.5.4.4.2
		        if (shouldSkipValidate(this.validateOptions, ["OBJECT_ADDITIONAL_PROPERTIES"])) {
		            return;
		        }
		        if (Utils.whatIs(json) !== "object") {
		            return;
		        }
		        var properties = schema.properties !== undefined ? schema.properties : {};
		        var patternProperties = schema.patternProperties !== undefined ? schema.patternProperties : {};
		        if (schema.additionalProperties === false) {
		            // The property set of the json to validate.
		            var s = Object.keys(json);
		            // The property set from "properties".
		            var p = Object.keys(properties);
		            // The property set from "patternProperties".
		            var pp = Object.keys(patternProperties);
		            // remove from "s" all elements of "p", if any;
		            s = Utils.difference(s, p);
		            // for each regex in "pp", remove all elements of "s" which this regex matches.
		            var idx = pp.length;
		            while (idx--) {
		                var regExp = RegExp(pp[idx]),
		                    idx2 = s.length;
		                while (idx2--) {
		                    if (regExp.test(s[idx2]) === true) {
		                        s.splice(idx2, 1);
		                    }
		                }
		            }
		            // Validation of the json succeeds if, after these two steps, set "s" is empty.
		            if (s.length > 0) {
		                // assumeAdditional can be an array of allowed properties
		                var idx3 = this.options.assumeAdditional.length;
		                if (idx3) {
		                    while (idx3--) {
		                        var io = s.indexOf(this.options.assumeAdditional[idx3]);
		                        if (io !== -1) {
		                            s.splice(io, 1);
		                        }
		                    }
		                }
		                var idx4 = s.length;
		                if (idx4) {
		                    while (idx4--) {
		                        report.addError("OBJECT_ADDITIONAL_PROPERTIES", [s[idx4]], null, schema);
		                    }
		                }
		            }
		        }
		    },
		    dependencies: function (report, schema, json) {
		        // http://json-schema.org/latest/json-schema-validation.html#rfc.section.5.4.5.2
		        if (shouldSkipValidate(this.validateOptions, ["OBJECT_DEPENDENCY_KEY"])) {
		            return;
		        }
		        if (Utils.whatIs(json) !== "object") {
		            return;
		        }

		        var keys = Object.keys(schema.dependencies),
		            idx = keys.length;

		        while (idx--) {
		            // iterate all dependencies
		            var dependencyName = keys[idx];
		            if (json[dependencyName]) {
		                var dependencyDefinition = schema.dependencies[dependencyName];
		                if (Utils.whatIs(dependencyDefinition) === "object") {
		                    // if dependency is a schema, validate against this schema
		                    exports.validate.call(this, report, dependencyDefinition, json);
		                } else { // Array
		                    // if dependency is an array, object needs to have all properties in this array
		                    var idx2 = dependencyDefinition.length;
		                    while (idx2--) {
		                        var requiredPropertyName = dependencyDefinition[idx2];
		                        if (json[requiredPropertyName] === undefined) {
		                            report.addError("OBJECT_DEPENDENCY_KEY", [requiredPropertyName, dependencyName], null, schema);
		                        }
		                    }
		                }
		            }
		        }
		    },
		    enum: function (report, schema, json) {
		        // http://json-schema.org/latest/json-schema-validation.html#rfc.section.5.5.1.2
		        if (shouldSkipValidate(this.validateOptions, ["ENUM_CASE_MISMATCH", "ENUM_MISMATCH"])) {
		            return;
		        }
		        var match = false,
		            caseInsensitiveMatch = false,
		            idx = schema.enum.length;
		        while (idx--) {
		            if (Utils.areEqual(json, schema.enum[idx])) {
		                match = true;
		                break;
		            } else if (Utils.areEqual(json, schema.enum[idx]), { caseInsensitiveComparison: true }) {
		                caseInsensitiveMatch = true;
		            }
		        }

		        if (match === false) {
		            var error = caseInsensitiveMatch && this.options.enumCaseInsensitiveComparison ? "ENUM_CASE_MISMATCH" : "ENUM_MISMATCH";
		            report.addError(error, [json], null, schema);
		        }
		    },
		    type: function (report, schema, json) {
		        // http://json-schema.org/latest/json-schema-validation.html#rfc.section.5.5.2.2
		        if (shouldSkipValidate(this.validateOptions, ["INVALID_TYPE"])) {
		            return;
		        }
		        var jsonType = Utils.whatIs(json);
		        if (typeof schema.type === "string") {
		            if (jsonType !== schema.type && (jsonType !== "integer" || schema.type !== "number")) {
		                report.addError("INVALID_TYPE", [schema.type, jsonType], null, schema);
		            }
		        } else {
		            if (schema.type.indexOf(jsonType) === -1 && (jsonType !== "integer" || schema.type.indexOf("number") === -1)) {
		                report.addError("INVALID_TYPE", [schema.type, jsonType], null, schema);
		            }
		        }
		    },
		    allOf: function (report, schema, json) {
		        // http://json-schema.org/latest/json-schema-validation.html#rfc.section.5.5.3.2
		        var idx = schema.allOf.length;
		        while (idx--) {
		            var validateResult = exports.validate.call(this, report, schema.allOf[idx], json);
		            if (this.options.breakOnFirstError && validateResult === false) {
		                break;
		            }
		        }
		    },
		    anyOf: function (report, schema, json) {
		        // http://json-schema.org/latest/json-schema-validation.html#rfc.section.5.5.4.2
		        var subReports = [],
		            passed = false,
		            idx = schema.anyOf.length;

		        while (idx-- && passed === false) {
		            var subReport = new Report(report);
		            subReports.push(subReport);
		            passed = exports.validate.call(this, subReport, schema.anyOf[idx], json);
		        }

		        if (passed === false) {
		            report.addError("ANY_OF_MISSING", undefined, subReports, schema);
		        }
		    },
		    oneOf: function (report, schema, json) {
		        // http://json-schema.org/latest/json-schema-validation.html#rfc.section.5.5.5.2
		        var passes = 0,
		            subReports = [],
		            idx = schema.oneOf.length;

		        while (idx--) {
		            var subReport = new Report(report, { maxErrors: 1 });
		            subReports.push(subReport);
		            if (exports.validate.call(this, subReport, schema.oneOf[idx], json) === true) {
		                passes++;
		            }
		        }

		        if (passes === 0) {
		            report.addError("ONE_OF_MISSING", undefined, subReports, schema);
		        } else if (passes > 1) {
		            report.addError("ONE_OF_MULTIPLE", null, null, schema);
		        }
		    },
		    not: function (report, schema, json) {
		        // http://json-schema.org/latest/json-schema-validation.html#rfc.section.5.5.6.2
		        var subReport = new Report(report);
		        if (exports.validate.call(this, subReport, schema.not, json) === true) {
		            report.addError("NOT_PASSED", null, null, schema);
		        }
		    },
		    definitions: function () { /*report, schema, json*/
		        // http://json-schema.org/latest/json-schema-validation.html#rfc.section.5.5.7.2
		        // nothing to do here
		    },
		    format: function (report, schema, json) {
		        // http://json-schema.org/latest/json-schema-validation.html#rfc.section.7.2
		        var formatValidatorFn = FormatValidators[schema.format];
		        if (typeof formatValidatorFn === "function") {
		            if (shouldSkipValidate(this.validateOptions, ["INVALID_FORMAT"])) {
		                return;
		            }
		            if (formatValidatorFn.length === 2) {
		                // async - need to clone the path here, because it will change by the time async function reports back
		                var pathBeforeAsync = Utils.clone(report.path);
		                report.addAsyncTask(formatValidatorFn, [json], function (result) {
		                    if (result !== true) {
		                        var backup = report.path;
		                        report.path = pathBeforeAsync;
		                        report.addError("INVALID_FORMAT", [schema.format, json], null, schema);
		                        report.path = backup;
		                    }
		                });
		            } else {
		                // sync
		                if (formatValidatorFn.call(this, json) !== true) {
		                    report.addError("INVALID_FORMAT", [schema.format, json], null, schema);
		                }
		            }
		        } else if (this.options.ignoreUnknownFormats !== true) {
		            report.addError("UNKNOWN_FORMAT", [schema.format], null, schema);
		        }
		    }
		};

		var recurseArray = function (report, schema, json) {
		    // http://json-schema.org/latest/json-schema-validation.html#rfc.section.8.2

		    var idx = json.length;

		    // If "items" is an array, this situation, the schema depends on the index:
		    // if the index is less than, or equal to, the size of "items",
		    // the child instance must be valid against the corresponding schema in the "items" array;
		    // otherwise, it must be valid against the schema defined by "additionalItems".
		    if (Array.isArray(schema.items)) {

		        while (idx--) {
		            // equal to doesn't make sense here
		            if (idx < schema.items.length) {
		                report.path.push(idx);
		                exports.validate.call(this, report, schema.items[idx], json[idx]);
		                report.path.pop();
		            } else {
		                // might be boolean, so check that it's an object
		                if (typeof schema.additionalItems === "object") {
		                    report.path.push(idx);
		                    exports.validate.call(this, report, schema.additionalItems, json[idx]);
		                    report.path.pop();
		                }
		            }
		        }

		    } else if (typeof schema.items === "object") {

		        // If items is a schema, then the child instance must be valid against this schema,
		        // regardless of its index, and regardless of the value of "additionalItems".
		        while (idx--) {
		            report.path.push(idx);
		            exports.validate.call(this, report, schema.items, json[idx]);
		            report.path.pop();
		        }

		    }
		};

		var recurseObject = function (report, schema, json) {
		    // http://json-schema.org/latest/json-schema-validation.html#rfc.section.8.3

		    // If "additionalProperties" is absent, it is considered present with an empty schema as a value.
		    // In addition, boolean value true is considered equivalent to an empty schema.
		    var additionalProperties = schema.additionalProperties;
		    if (additionalProperties === true || additionalProperties === undefined) {
		        additionalProperties = {};
		    }

		    // p - The property set from "properties".
		    var p = schema.properties ? Object.keys(schema.properties) : [];

		    // pp - The property set from "patternProperties". Elements of this set will be called regexes for convenience.
		    var pp = schema.patternProperties ? Object.keys(schema.patternProperties) : [];

		    // m - The property name of the child.
		    var keys = Object.keys(json),
		        idx = keys.length;

		    while (idx--) {
		        var m = keys[idx],
		            propertyValue = json[m];

		        // s - The set of schemas for the child instance.
		        var s = [];

		        // 1. If set "p" contains value "m", then the corresponding schema in "properties" is added to "s".
		        if (p.indexOf(m) !== -1) {
		            s.push(schema.properties[m]);
		        }

		        // 2. For each regex in "pp", if it matches "m" successfully, the corresponding schema in "patternProperties" is added to "s".
		        var idx2 = pp.length;
		        while (idx2--) {
		            var regexString = pp[idx2];
		            if (RegExp(regexString).test(m) === true) {
		                s.push(schema.patternProperties[regexString]);
		            }
		        }

		        // 3. The schema defined by "additionalProperties" is added to "s" if and only if, at this stage, "s" is empty.
		        if (s.length === 0 && additionalProperties !== false) {
		            s.push(additionalProperties);
		        }

		        // we are passing tests even without this assert because this is covered by properties check
		        // if s is empty in this stage, no additionalProperties are allowed
		        // report.expect(s.length !== 0, 'E001', m);

		        // Instance property value must pass all schemas from s
		        idx2 = s.length;
		        while (idx2--) {
		            report.path.push(m);
		            exports.validate.call(this, report, s[idx2], propertyValue);
		            report.path.pop();
		        }
		    }
		};

		exports.JsonValidators = JsonValidators;

		/**
		 *
		 * @param {Report} report
		 * @param {*} schema
		 * @param {*} json
		 */
		exports.validate = function (report, schema, json) {

		    report.commonErrorMessage = "JSON_OBJECT_VALIDATION_FAILED";

		    // check if schema is an object
		    var to = Utils.whatIs(schema);
		    if (to !== "object") {
		        report.addError("SCHEMA_NOT_AN_OBJECT", [to], null, schema);
		        return false;
		    }

		    // check if schema is empty, everything is valid against empty schema
		    var keys = Object.keys(schema);
		    if (keys.length === 0) {
		        return true;
		    }

		    // this method can be called recursively, so we need to remember our root
		    var isRoot = false;
		    if (!report.rootSchema) {
		        report.rootSchema = schema;
		        isRoot = true;
		    }

		    // follow schema.$ref keys
		    if (schema.$ref !== undefined) {
		        // avoid infinite loop with maxRefs
		        var maxRefs = 99;
		        while (schema.$ref && maxRefs > 0) {
		            if (!schema.__$refResolved) {
		                report.addError("REF_UNRESOLVED", [schema.$ref], null, schema);
		                break;
		            } else if (schema.__$refResolved === schema) {
		                break;
		            } else {
		                schema = schema.__$refResolved;
		                keys = Object.keys(schema);
		            }
		            maxRefs--;
		        }
		        if (maxRefs === 0) {
		            throw new Error("Circular dependency by $ref references!");
		        }
		    }

		    // type checking first
		    var jsonType = Utils.whatIs(json);
		    if (schema.type) {
		        keys.splice(keys.indexOf("type"), 1);
		        JsonValidators.type.call(this, report, schema, json);
		        if (report.errors.length && this.options.breakOnFirstError) {
		            return false;
		        }
		    }

		    // now iterate all the keys in schema and execute validation methods
		    var idx = keys.length;
		    while (idx--) {
		        if (JsonValidators[keys[idx]]) {
		            JsonValidators[keys[idx]].call(this, report, schema, json);
		            if (report.errors.length && this.options.breakOnFirstError) { break; }
		        }
		    }

		    if (report.errors.length === 0 || this.options.breakOnFirstError === false) {
		        if (jsonType === "array") {
		            recurseArray.call(this, report, schema, json);
		        } else if (jsonType === "object") {
		            recurseObject.call(this, report, schema, json);
		        }
		    }

		    if (typeof this.options.customValidator === "function") {
		        this.options.customValidator.call(this, report, schema, json);
		    }

		    // we don't need the root pointer anymore
		    if (isRoot) {
		        report.rootSchema = undefined;
		    }

		    // return valid just to be able to break at some code points
		    return report.errors.length === 0;

		};
	} (JsonValidation$1));

	var SchemaCache$1 = {};

	var lodash_isequalExports = {};
	var lodash_isequal = {
	  get exports(){ return lodash_isequalExports; },
	  set exports(v){ lodash_isequalExports = v; },
	};

	/**
	 * Lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright JS Foundation and other contributors <https://js.foundation/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */

	(function (module, exports) {
		/** Used as the size to enable large array optimizations. */
		var LARGE_ARRAY_SIZE = 200;

		/** Used to stand-in for `undefined` hash values. */
		var HASH_UNDEFINED = '__lodash_hash_undefined__';

		/** Used to compose bitmasks for value comparisons. */
		var COMPARE_PARTIAL_FLAG = 1,
		    COMPARE_UNORDERED_FLAG = 2;

		/** Used as references for various `Number` constants. */
		var MAX_SAFE_INTEGER = 9007199254740991;

		/** `Object#toString` result references. */
		var argsTag = '[object Arguments]',
		    arrayTag = '[object Array]',
		    asyncTag = '[object AsyncFunction]',
		    boolTag = '[object Boolean]',
		    dateTag = '[object Date]',
		    errorTag = '[object Error]',
		    funcTag = '[object Function]',
		    genTag = '[object GeneratorFunction]',
		    mapTag = '[object Map]',
		    numberTag = '[object Number]',
		    nullTag = '[object Null]',
		    objectTag = '[object Object]',
		    promiseTag = '[object Promise]',
		    proxyTag = '[object Proxy]',
		    regexpTag = '[object RegExp]',
		    setTag = '[object Set]',
		    stringTag = '[object String]',
		    symbolTag = '[object Symbol]',
		    undefinedTag = '[object Undefined]',
		    weakMapTag = '[object WeakMap]';

		var arrayBufferTag = '[object ArrayBuffer]',
		    dataViewTag = '[object DataView]',
		    float32Tag = '[object Float32Array]',
		    float64Tag = '[object Float64Array]',
		    int8Tag = '[object Int8Array]',
		    int16Tag = '[object Int16Array]',
		    int32Tag = '[object Int32Array]',
		    uint8Tag = '[object Uint8Array]',
		    uint8ClampedTag = '[object Uint8ClampedArray]',
		    uint16Tag = '[object Uint16Array]',
		    uint32Tag = '[object Uint32Array]';

		/**
		 * Used to match `RegExp`
		 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
		 */
		var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

		/** Used to detect host constructors (Safari). */
		var reIsHostCtor = /^\[object .+?Constructor\]$/;

		/** Used to detect unsigned integer values. */
		var reIsUint = /^(?:0|[1-9]\d*)$/;

		/** Used to identify `toStringTag` values of typed arrays. */
		var typedArrayTags = {};
		typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
		typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
		typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
		typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
		typedArrayTags[uint32Tag] = true;
		typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
		typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
		typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
		typedArrayTags[errorTag] = typedArrayTags[funcTag] =
		typedArrayTags[mapTag] = typedArrayTags[numberTag] =
		typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
		typedArrayTags[setTag] = typedArrayTags[stringTag] =
		typedArrayTags[weakMapTag] = false;

		/** Detect free variable `global` from Node.js. */
		var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

		/** Detect free variable `self`. */
		var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

		/** Used as a reference to the global object. */
		var root = freeGlobal || freeSelf || Function('return this')();

		/** Detect free variable `exports`. */
		var freeExports = exports && !exports.nodeType && exports;

		/** Detect free variable `module`. */
		var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

		/** Detect the popular CommonJS extension `module.exports`. */
		var moduleExports = freeModule && freeModule.exports === freeExports;

		/** Detect free variable `process` from Node.js. */
		var freeProcess = moduleExports && freeGlobal.process;

		/** Used to access faster Node.js helpers. */
		var nodeUtil = (function() {
		  try {
		    return freeProcess && freeProcess.binding && freeProcess.binding('util');
		  } catch (e) {}
		}());

		/* Node.js helper references. */
		var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

		/**
		 * A specialized version of `_.filter` for arrays without support for
		 * iteratee shorthands.
		 *
		 * @private
		 * @param {Array} [array] The array to iterate over.
		 * @param {Function} predicate The function invoked per iteration.
		 * @returns {Array} Returns the new filtered array.
		 */
		function arrayFilter(array, predicate) {
		  var index = -1,
		      length = array == null ? 0 : array.length,
		      resIndex = 0,
		      result = [];

		  while (++index < length) {
		    var value = array[index];
		    if (predicate(value, index, array)) {
		      result[resIndex++] = value;
		    }
		  }
		  return result;
		}

		/**
		 * Appends the elements of `values` to `array`.
		 *
		 * @private
		 * @param {Array} array The array to modify.
		 * @param {Array} values The values to append.
		 * @returns {Array} Returns `array`.
		 */
		function arrayPush(array, values) {
		  var index = -1,
		      length = values.length,
		      offset = array.length;

		  while (++index < length) {
		    array[offset + index] = values[index];
		  }
		  return array;
		}

		/**
		 * A specialized version of `_.some` for arrays without support for iteratee
		 * shorthands.
		 *
		 * @private
		 * @param {Array} [array] The array to iterate over.
		 * @param {Function} predicate The function invoked per iteration.
		 * @returns {boolean} Returns `true` if any element passes the predicate check,
		 *  else `false`.
		 */
		function arraySome(array, predicate) {
		  var index = -1,
		      length = array == null ? 0 : array.length;

		  while (++index < length) {
		    if (predicate(array[index], index, array)) {
		      return true;
		    }
		  }
		  return false;
		}

		/**
		 * The base implementation of `_.times` without support for iteratee shorthands
		 * or max array length checks.
		 *
		 * @private
		 * @param {number} n The number of times to invoke `iteratee`.
		 * @param {Function} iteratee The function invoked per iteration.
		 * @returns {Array} Returns the array of results.
		 */
		function baseTimes(n, iteratee) {
		  var index = -1,
		      result = Array(n);

		  while (++index < n) {
		    result[index] = iteratee(index);
		  }
		  return result;
		}

		/**
		 * The base implementation of `_.unary` without support for storing metadata.
		 *
		 * @private
		 * @param {Function} func The function to cap arguments for.
		 * @returns {Function} Returns the new capped function.
		 */
		function baseUnary(func) {
		  return function(value) {
		    return func(value);
		  };
		}

		/**
		 * Checks if a `cache` value for `key` exists.
		 *
		 * @private
		 * @param {Object} cache The cache to query.
		 * @param {string} key The key of the entry to check.
		 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
		 */
		function cacheHas(cache, key) {
		  return cache.has(key);
		}

		/**
		 * Gets the value at `key` of `object`.
		 *
		 * @private
		 * @param {Object} [object] The object to query.
		 * @param {string} key The key of the property to get.
		 * @returns {*} Returns the property value.
		 */
		function getValue(object, key) {
		  return object == null ? undefined : object[key];
		}

		/**
		 * Converts `map` to its key-value pairs.
		 *
		 * @private
		 * @param {Object} map The map to convert.
		 * @returns {Array} Returns the key-value pairs.
		 */
		function mapToArray(map) {
		  var index = -1,
		      result = Array(map.size);

		  map.forEach(function(value, key) {
		    result[++index] = [key, value];
		  });
		  return result;
		}

		/**
		 * Creates a unary function that invokes `func` with its argument transformed.
		 *
		 * @private
		 * @param {Function} func The function to wrap.
		 * @param {Function} transform The argument transform.
		 * @returns {Function} Returns the new function.
		 */
		function overArg(func, transform) {
		  return function(arg) {
		    return func(transform(arg));
		  };
		}

		/**
		 * Converts `set` to an array of its values.
		 *
		 * @private
		 * @param {Object} set The set to convert.
		 * @returns {Array} Returns the values.
		 */
		function setToArray(set) {
		  var index = -1,
		      result = Array(set.size);

		  set.forEach(function(value) {
		    result[++index] = value;
		  });
		  return result;
		}

		/** Used for built-in method references. */
		var arrayProto = Array.prototype,
		    funcProto = Function.prototype,
		    objectProto = Object.prototype;

		/** Used to detect overreaching core-js shims. */
		var coreJsData = root['__core-js_shared__'];

		/** Used to resolve the decompiled source of functions. */
		var funcToString = funcProto.toString;

		/** Used to check objects for own properties. */
		var hasOwnProperty = objectProto.hasOwnProperty;

		/** Used to detect methods masquerading as native. */
		var maskSrcKey = (function() {
		  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
		  return uid ? ('Symbol(src)_1.' + uid) : '';
		}());

		/**
		 * Used to resolve the
		 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
		 * of values.
		 */
		var nativeObjectToString = objectProto.toString;

		/** Used to detect if a method is native. */
		var reIsNative = RegExp('^' +
		  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
		  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
		);

		/** Built-in value references. */
		var Buffer = moduleExports ? root.Buffer : undefined,
		    Symbol = root.Symbol,
		    Uint8Array = root.Uint8Array,
		    propertyIsEnumerable = objectProto.propertyIsEnumerable,
		    splice = arrayProto.splice,
		    symToStringTag = Symbol ? Symbol.toStringTag : undefined;

		/* Built-in method references for those with the same name as other `lodash` methods. */
		var nativeGetSymbols = Object.getOwnPropertySymbols,
		    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
		    nativeKeys = overArg(Object.keys, Object);

		/* Built-in method references that are verified to be native. */
		var DataView = getNative(root, 'DataView'),
		    Map = getNative(root, 'Map'),
		    Promise = getNative(root, 'Promise'),
		    Set = getNative(root, 'Set'),
		    WeakMap = getNative(root, 'WeakMap'),
		    nativeCreate = getNative(Object, 'create');

		/** Used to detect maps, sets, and weakmaps. */
		var dataViewCtorString = toSource(DataView),
		    mapCtorString = toSource(Map),
		    promiseCtorString = toSource(Promise),
		    setCtorString = toSource(Set),
		    weakMapCtorString = toSource(WeakMap);

		/** Used to convert symbols to primitives and strings. */
		var symbolProto = Symbol ? Symbol.prototype : undefined,
		    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

		/**
		 * Creates a hash object.
		 *
		 * @private
		 * @constructor
		 * @param {Array} [entries] The key-value pairs to cache.
		 */
		function Hash(entries) {
		  var index = -1,
		      length = entries == null ? 0 : entries.length;

		  this.clear();
		  while (++index < length) {
		    var entry = entries[index];
		    this.set(entry[0], entry[1]);
		  }
		}

		/**
		 * Removes all key-value entries from the hash.
		 *
		 * @private
		 * @name clear
		 * @memberOf Hash
		 */
		function hashClear() {
		  this.__data__ = nativeCreate ? nativeCreate(null) : {};
		  this.size = 0;
		}

		/**
		 * Removes `key` and its value from the hash.
		 *
		 * @private
		 * @name delete
		 * @memberOf Hash
		 * @param {Object} hash The hash to modify.
		 * @param {string} key The key of the value to remove.
		 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
		 */
		function hashDelete(key) {
		  var result = this.has(key) && delete this.__data__[key];
		  this.size -= result ? 1 : 0;
		  return result;
		}

		/**
		 * Gets the hash value for `key`.
		 *
		 * @private
		 * @name get
		 * @memberOf Hash
		 * @param {string} key The key of the value to get.
		 * @returns {*} Returns the entry value.
		 */
		function hashGet(key) {
		  var data = this.__data__;
		  if (nativeCreate) {
		    var result = data[key];
		    return result === HASH_UNDEFINED ? undefined : result;
		  }
		  return hasOwnProperty.call(data, key) ? data[key] : undefined;
		}

		/**
		 * Checks if a hash value for `key` exists.
		 *
		 * @private
		 * @name has
		 * @memberOf Hash
		 * @param {string} key The key of the entry to check.
		 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
		 */
		function hashHas(key) {
		  var data = this.__data__;
		  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
		}

		/**
		 * Sets the hash `key` to `value`.
		 *
		 * @private
		 * @name set
		 * @memberOf Hash
		 * @param {string} key The key of the value to set.
		 * @param {*} value The value to set.
		 * @returns {Object} Returns the hash instance.
		 */
		function hashSet(key, value) {
		  var data = this.__data__;
		  this.size += this.has(key) ? 0 : 1;
		  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
		  return this;
		}

		// Add methods to `Hash`.
		Hash.prototype.clear = hashClear;
		Hash.prototype['delete'] = hashDelete;
		Hash.prototype.get = hashGet;
		Hash.prototype.has = hashHas;
		Hash.prototype.set = hashSet;

		/**
		 * Creates an list cache object.
		 *
		 * @private
		 * @constructor
		 * @param {Array} [entries] The key-value pairs to cache.
		 */
		function ListCache(entries) {
		  var index = -1,
		      length = entries == null ? 0 : entries.length;

		  this.clear();
		  while (++index < length) {
		    var entry = entries[index];
		    this.set(entry[0], entry[1]);
		  }
		}

		/**
		 * Removes all key-value entries from the list cache.
		 *
		 * @private
		 * @name clear
		 * @memberOf ListCache
		 */
		function listCacheClear() {
		  this.__data__ = [];
		  this.size = 0;
		}

		/**
		 * Removes `key` and its value from the list cache.
		 *
		 * @private
		 * @name delete
		 * @memberOf ListCache
		 * @param {string} key The key of the value to remove.
		 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
		 */
		function listCacheDelete(key) {
		  var data = this.__data__,
		      index = assocIndexOf(data, key);

		  if (index < 0) {
		    return false;
		  }
		  var lastIndex = data.length - 1;
		  if (index == lastIndex) {
		    data.pop();
		  } else {
		    splice.call(data, index, 1);
		  }
		  --this.size;
		  return true;
		}

		/**
		 * Gets the list cache value for `key`.
		 *
		 * @private
		 * @name get
		 * @memberOf ListCache
		 * @param {string} key The key of the value to get.
		 * @returns {*} Returns the entry value.
		 */
		function listCacheGet(key) {
		  var data = this.__data__,
		      index = assocIndexOf(data, key);

		  return index < 0 ? undefined : data[index][1];
		}

		/**
		 * Checks if a list cache value for `key` exists.
		 *
		 * @private
		 * @name has
		 * @memberOf ListCache
		 * @param {string} key The key of the entry to check.
		 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
		 */
		function listCacheHas(key) {
		  return assocIndexOf(this.__data__, key) > -1;
		}

		/**
		 * Sets the list cache `key` to `value`.
		 *
		 * @private
		 * @name set
		 * @memberOf ListCache
		 * @param {string} key The key of the value to set.
		 * @param {*} value The value to set.
		 * @returns {Object} Returns the list cache instance.
		 */
		function listCacheSet(key, value) {
		  var data = this.__data__,
		      index = assocIndexOf(data, key);

		  if (index < 0) {
		    ++this.size;
		    data.push([key, value]);
		  } else {
		    data[index][1] = value;
		  }
		  return this;
		}

		// Add methods to `ListCache`.
		ListCache.prototype.clear = listCacheClear;
		ListCache.prototype['delete'] = listCacheDelete;
		ListCache.prototype.get = listCacheGet;
		ListCache.prototype.has = listCacheHas;
		ListCache.prototype.set = listCacheSet;

		/**
		 * Creates a map cache object to store key-value pairs.
		 *
		 * @private
		 * @constructor
		 * @param {Array} [entries] The key-value pairs to cache.
		 */
		function MapCache(entries) {
		  var index = -1,
		      length = entries == null ? 0 : entries.length;

		  this.clear();
		  while (++index < length) {
		    var entry = entries[index];
		    this.set(entry[0], entry[1]);
		  }
		}

		/**
		 * Removes all key-value entries from the map.
		 *
		 * @private
		 * @name clear
		 * @memberOf MapCache
		 */
		function mapCacheClear() {
		  this.size = 0;
		  this.__data__ = {
		    'hash': new Hash,
		    'map': new (Map || ListCache),
		    'string': new Hash
		  };
		}

		/**
		 * Removes `key` and its value from the map.
		 *
		 * @private
		 * @name delete
		 * @memberOf MapCache
		 * @param {string} key The key of the value to remove.
		 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
		 */
		function mapCacheDelete(key) {
		  var result = getMapData(this, key)['delete'](key);
		  this.size -= result ? 1 : 0;
		  return result;
		}

		/**
		 * Gets the map value for `key`.
		 *
		 * @private
		 * @name get
		 * @memberOf MapCache
		 * @param {string} key The key of the value to get.
		 * @returns {*} Returns the entry value.
		 */
		function mapCacheGet(key) {
		  return getMapData(this, key).get(key);
		}

		/**
		 * Checks if a map value for `key` exists.
		 *
		 * @private
		 * @name has
		 * @memberOf MapCache
		 * @param {string} key The key of the entry to check.
		 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
		 */
		function mapCacheHas(key) {
		  return getMapData(this, key).has(key);
		}

		/**
		 * Sets the map `key` to `value`.
		 *
		 * @private
		 * @name set
		 * @memberOf MapCache
		 * @param {string} key The key of the value to set.
		 * @param {*} value The value to set.
		 * @returns {Object} Returns the map cache instance.
		 */
		function mapCacheSet(key, value) {
		  var data = getMapData(this, key),
		      size = data.size;

		  data.set(key, value);
		  this.size += data.size == size ? 0 : 1;
		  return this;
		}

		// Add methods to `MapCache`.
		MapCache.prototype.clear = mapCacheClear;
		MapCache.prototype['delete'] = mapCacheDelete;
		MapCache.prototype.get = mapCacheGet;
		MapCache.prototype.has = mapCacheHas;
		MapCache.prototype.set = mapCacheSet;

		/**
		 *
		 * Creates an array cache object to store unique values.
		 *
		 * @private
		 * @constructor
		 * @param {Array} [values] The values to cache.
		 */
		function SetCache(values) {
		  var index = -1,
		      length = values == null ? 0 : values.length;

		  this.__data__ = new MapCache;
		  while (++index < length) {
		    this.add(values[index]);
		  }
		}

		/**
		 * Adds `value` to the array cache.
		 *
		 * @private
		 * @name add
		 * @memberOf SetCache
		 * @alias push
		 * @param {*} value The value to cache.
		 * @returns {Object} Returns the cache instance.
		 */
		function setCacheAdd(value) {
		  this.__data__.set(value, HASH_UNDEFINED);
		  return this;
		}

		/**
		 * Checks if `value` is in the array cache.
		 *
		 * @private
		 * @name has
		 * @memberOf SetCache
		 * @param {*} value The value to search for.
		 * @returns {number} Returns `true` if `value` is found, else `false`.
		 */
		function setCacheHas(value) {
		  return this.__data__.has(value);
		}

		// Add methods to `SetCache`.
		SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
		SetCache.prototype.has = setCacheHas;

		/**
		 * Creates a stack cache object to store key-value pairs.
		 *
		 * @private
		 * @constructor
		 * @param {Array} [entries] The key-value pairs to cache.
		 */
		function Stack(entries) {
		  var data = this.__data__ = new ListCache(entries);
		  this.size = data.size;
		}

		/**
		 * Removes all key-value entries from the stack.
		 *
		 * @private
		 * @name clear
		 * @memberOf Stack
		 */
		function stackClear() {
		  this.__data__ = new ListCache;
		  this.size = 0;
		}

		/**
		 * Removes `key` and its value from the stack.
		 *
		 * @private
		 * @name delete
		 * @memberOf Stack
		 * @param {string} key The key of the value to remove.
		 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
		 */
		function stackDelete(key) {
		  var data = this.__data__,
		      result = data['delete'](key);

		  this.size = data.size;
		  return result;
		}

		/**
		 * Gets the stack value for `key`.
		 *
		 * @private
		 * @name get
		 * @memberOf Stack
		 * @param {string} key The key of the value to get.
		 * @returns {*} Returns the entry value.
		 */
		function stackGet(key) {
		  return this.__data__.get(key);
		}

		/**
		 * Checks if a stack value for `key` exists.
		 *
		 * @private
		 * @name has
		 * @memberOf Stack
		 * @param {string} key The key of the entry to check.
		 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
		 */
		function stackHas(key) {
		  return this.__data__.has(key);
		}

		/**
		 * Sets the stack `key` to `value`.
		 *
		 * @private
		 * @name set
		 * @memberOf Stack
		 * @param {string} key The key of the value to set.
		 * @param {*} value The value to set.
		 * @returns {Object} Returns the stack cache instance.
		 */
		function stackSet(key, value) {
		  var data = this.__data__;
		  if (data instanceof ListCache) {
		    var pairs = data.__data__;
		    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
		      pairs.push([key, value]);
		      this.size = ++data.size;
		      return this;
		    }
		    data = this.__data__ = new MapCache(pairs);
		  }
		  data.set(key, value);
		  this.size = data.size;
		  return this;
		}

		// Add methods to `Stack`.
		Stack.prototype.clear = stackClear;
		Stack.prototype['delete'] = stackDelete;
		Stack.prototype.get = stackGet;
		Stack.prototype.has = stackHas;
		Stack.prototype.set = stackSet;

		/**
		 * Creates an array of the enumerable property names of the array-like `value`.
		 *
		 * @private
		 * @param {*} value The value to query.
		 * @param {boolean} inherited Specify returning inherited property names.
		 * @returns {Array} Returns the array of property names.
		 */
		function arrayLikeKeys(value, inherited) {
		  var isArr = isArray(value),
		      isArg = !isArr && isArguments(value),
		      isBuff = !isArr && !isArg && isBuffer(value),
		      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
		      skipIndexes = isArr || isArg || isBuff || isType,
		      result = skipIndexes ? baseTimes(value.length, String) : [],
		      length = result.length;

		  for (var key in value) {
		    if ((inherited || hasOwnProperty.call(value, key)) &&
		        !(skipIndexes && (
		           // Safari 9 has enumerable `arguments.length` in strict mode.
		           key == 'length' ||
		           // Node.js 0.10 has enumerable non-index properties on buffers.
		           (isBuff && (key == 'offset' || key == 'parent')) ||
		           // PhantomJS 2 has enumerable non-index properties on typed arrays.
		           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
		           // Skip index properties.
		           isIndex(key, length)
		        ))) {
		      result.push(key);
		    }
		  }
		  return result;
		}

		/**
		 * Gets the index at which the `key` is found in `array` of key-value pairs.
		 *
		 * @private
		 * @param {Array} array The array to inspect.
		 * @param {*} key The key to search for.
		 * @returns {number} Returns the index of the matched value, else `-1`.
		 */
		function assocIndexOf(array, key) {
		  var length = array.length;
		  while (length--) {
		    if (eq(array[length][0], key)) {
		      return length;
		    }
		  }
		  return -1;
		}

		/**
		 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
		 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
		 * symbols of `object`.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @param {Function} keysFunc The function to get the keys of `object`.
		 * @param {Function} symbolsFunc The function to get the symbols of `object`.
		 * @returns {Array} Returns the array of property names and symbols.
		 */
		function baseGetAllKeys(object, keysFunc, symbolsFunc) {
		  var result = keysFunc(object);
		  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
		}

		/**
		 * The base implementation of `getTag` without fallbacks for buggy environments.
		 *
		 * @private
		 * @param {*} value The value to query.
		 * @returns {string} Returns the `toStringTag`.
		 */
		function baseGetTag(value) {
		  if (value == null) {
		    return value === undefined ? undefinedTag : nullTag;
		  }
		  return (symToStringTag && symToStringTag in Object(value))
		    ? getRawTag(value)
		    : objectToString(value);
		}

		/**
		 * The base implementation of `_.isArguments`.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
		 */
		function baseIsArguments(value) {
		  return isObjectLike(value) && baseGetTag(value) == argsTag;
		}

		/**
		 * The base implementation of `_.isEqual` which supports partial comparisons
		 * and tracks traversed objects.
		 *
		 * @private
		 * @param {*} value The value to compare.
		 * @param {*} other The other value to compare.
		 * @param {boolean} bitmask The bitmask flags.
		 *  1 - Unordered comparison
		 *  2 - Partial comparison
		 * @param {Function} [customizer] The function to customize comparisons.
		 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
		 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
		 */
		function baseIsEqual(value, other, bitmask, customizer, stack) {
		  if (value === other) {
		    return true;
		  }
		  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
		    return value !== value && other !== other;
		  }
		  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
		}

		/**
		 * A specialized version of `baseIsEqual` for arrays and objects which performs
		 * deep comparisons and tracks traversed objects enabling objects with circular
		 * references to be compared.
		 *
		 * @private
		 * @param {Object} object The object to compare.
		 * @param {Object} other The other object to compare.
		 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
		 * @param {Function} customizer The function to customize comparisons.
		 * @param {Function} equalFunc The function to determine equivalents of values.
		 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
		 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
		 */
		function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
		  var objIsArr = isArray(object),
		      othIsArr = isArray(other),
		      objTag = objIsArr ? arrayTag : getTag(object),
		      othTag = othIsArr ? arrayTag : getTag(other);

		  objTag = objTag == argsTag ? objectTag : objTag;
		  othTag = othTag == argsTag ? objectTag : othTag;

		  var objIsObj = objTag == objectTag,
		      othIsObj = othTag == objectTag,
		      isSameTag = objTag == othTag;

		  if (isSameTag && isBuffer(object)) {
		    if (!isBuffer(other)) {
		      return false;
		    }
		    objIsArr = true;
		    objIsObj = false;
		  }
		  if (isSameTag && !objIsObj) {
		    stack || (stack = new Stack);
		    return (objIsArr || isTypedArray(object))
		      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
		      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
		  }
		  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
		    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
		        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

		    if (objIsWrapped || othIsWrapped) {
		      var objUnwrapped = objIsWrapped ? object.value() : object,
		          othUnwrapped = othIsWrapped ? other.value() : other;

		      stack || (stack = new Stack);
		      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
		    }
		  }
		  if (!isSameTag) {
		    return false;
		  }
		  stack || (stack = new Stack);
		  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
		}

		/**
		 * The base implementation of `_.isNative` without bad shim checks.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a native function,
		 *  else `false`.
		 */
		function baseIsNative(value) {
		  if (!isObject(value) || isMasked(value)) {
		    return false;
		  }
		  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
		  return pattern.test(toSource(value));
		}

		/**
		 * The base implementation of `_.isTypedArray` without Node.js optimizations.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
		 */
		function baseIsTypedArray(value) {
		  return isObjectLike(value) &&
		    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
		}

		/**
		 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @returns {Array} Returns the array of property names.
		 */
		function baseKeys(object) {
		  if (!isPrototype(object)) {
		    return nativeKeys(object);
		  }
		  var result = [];
		  for (var key in Object(object)) {
		    if (hasOwnProperty.call(object, key) && key != 'constructor') {
		      result.push(key);
		    }
		  }
		  return result;
		}

		/**
		 * A specialized version of `baseIsEqualDeep` for arrays with support for
		 * partial deep comparisons.
		 *
		 * @private
		 * @param {Array} array The array to compare.
		 * @param {Array} other The other array to compare.
		 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
		 * @param {Function} customizer The function to customize comparisons.
		 * @param {Function} equalFunc The function to determine equivalents of values.
		 * @param {Object} stack Tracks traversed `array` and `other` objects.
		 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
		 */
		function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
		  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
		      arrLength = array.length,
		      othLength = other.length;

		  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
		    return false;
		  }
		  // Assume cyclic values are equal.
		  var stacked = stack.get(array);
		  if (stacked && stack.get(other)) {
		    return stacked == other;
		  }
		  var index = -1,
		      result = true,
		      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

		  stack.set(array, other);
		  stack.set(other, array);

		  // Ignore non-index properties.
		  while (++index < arrLength) {
		    var arrValue = array[index],
		        othValue = other[index];

		    if (customizer) {
		      var compared = isPartial
		        ? customizer(othValue, arrValue, index, other, array, stack)
		        : customizer(arrValue, othValue, index, array, other, stack);
		    }
		    if (compared !== undefined) {
		      if (compared) {
		        continue;
		      }
		      result = false;
		      break;
		    }
		    // Recursively compare arrays (susceptible to call stack limits).
		    if (seen) {
		      if (!arraySome(other, function(othValue, othIndex) {
		            if (!cacheHas(seen, othIndex) &&
		                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
		              return seen.push(othIndex);
		            }
		          })) {
		        result = false;
		        break;
		      }
		    } else if (!(
		          arrValue === othValue ||
		            equalFunc(arrValue, othValue, bitmask, customizer, stack)
		        )) {
		      result = false;
		      break;
		    }
		  }
		  stack['delete'](array);
		  stack['delete'](other);
		  return result;
		}

		/**
		 * A specialized version of `baseIsEqualDeep` for comparing objects of
		 * the same `toStringTag`.
		 *
		 * **Note:** This function only supports comparing values with tags of
		 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
		 *
		 * @private
		 * @param {Object} object The object to compare.
		 * @param {Object} other The other object to compare.
		 * @param {string} tag The `toStringTag` of the objects to compare.
		 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
		 * @param {Function} customizer The function to customize comparisons.
		 * @param {Function} equalFunc The function to determine equivalents of values.
		 * @param {Object} stack Tracks traversed `object` and `other` objects.
		 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
		 */
		function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
		  switch (tag) {
		    case dataViewTag:
		      if ((object.byteLength != other.byteLength) ||
		          (object.byteOffset != other.byteOffset)) {
		        return false;
		      }
		      object = object.buffer;
		      other = other.buffer;

		    case arrayBufferTag:
		      if ((object.byteLength != other.byteLength) ||
		          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
		        return false;
		      }
		      return true;

		    case boolTag:
		    case dateTag:
		    case numberTag:
		      // Coerce booleans to `1` or `0` and dates to milliseconds.
		      // Invalid dates are coerced to `NaN`.
		      return eq(+object, +other);

		    case errorTag:
		      return object.name == other.name && object.message == other.message;

		    case regexpTag:
		    case stringTag:
		      // Coerce regexes to strings and treat strings, primitives and objects,
		      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
		      // for more details.
		      return object == (other + '');

		    case mapTag:
		      var convert = mapToArray;

		    case setTag:
		      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
		      convert || (convert = setToArray);

		      if (object.size != other.size && !isPartial) {
		        return false;
		      }
		      // Assume cyclic values are equal.
		      var stacked = stack.get(object);
		      if (stacked) {
		        return stacked == other;
		      }
		      bitmask |= COMPARE_UNORDERED_FLAG;

		      // Recursively compare objects (susceptible to call stack limits).
		      stack.set(object, other);
		      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
		      stack['delete'](object);
		      return result;

		    case symbolTag:
		      if (symbolValueOf) {
		        return symbolValueOf.call(object) == symbolValueOf.call(other);
		      }
		  }
		  return false;
		}

		/**
		 * A specialized version of `baseIsEqualDeep` for objects with support for
		 * partial deep comparisons.
		 *
		 * @private
		 * @param {Object} object The object to compare.
		 * @param {Object} other The other object to compare.
		 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
		 * @param {Function} customizer The function to customize comparisons.
		 * @param {Function} equalFunc The function to determine equivalents of values.
		 * @param {Object} stack Tracks traversed `object` and `other` objects.
		 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
		 */
		function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
		  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
		      objProps = getAllKeys(object),
		      objLength = objProps.length,
		      othProps = getAllKeys(other),
		      othLength = othProps.length;

		  if (objLength != othLength && !isPartial) {
		    return false;
		  }
		  var index = objLength;
		  while (index--) {
		    var key = objProps[index];
		    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
		      return false;
		    }
		  }
		  // Assume cyclic values are equal.
		  var stacked = stack.get(object);
		  if (stacked && stack.get(other)) {
		    return stacked == other;
		  }
		  var result = true;
		  stack.set(object, other);
		  stack.set(other, object);

		  var skipCtor = isPartial;
		  while (++index < objLength) {
		    key = objProps[index];
		    var objValue = object[key],
		        othValue = other[key];

		    if (customizer) {
		      var compared = isPartial
		        ? customizer(othValue, objValue, key, other, object, stack)
		        : customizer(objValue, othValue, key, object, other, stack);
		    }
		    // Recursively compare objects (susceptible to call stack limits).
		    if (!(compared === undefined
		          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
		          : compared
		        )) {
		      result = false;
		      break;
		    }
		    skipCtor || (skipCtor = key == 'constructor');
		  }
		  if (result && !skipCtor) {
		    var objCtor = object.constructor,
		        othCtor = other.constructor;

		    // Non `Object` object instances with different constructors are not equal.
		    if (objCtor != othCtor &&
		        ('constructor' in object && 'constructor' in other) &&
		        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
		          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
		      result = false;
		    }
		  }
		  stack['delete'](object);
		  stack['delete'](other);
		  return result;
		}

		/**
		 * Creates an array of own enumerable property names and symbols of `object`.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @returns {Array} Returns the array of property names and symbols.
		 */
		function getAllKeys(object) {
		  return baseGetAllKeys(object, keys, getSymbols);
		}

		/**
		 * Gets the data for `map`.
		 *
		 * @private
		 * @param {Object} map The map to query.
		 * @param {string} key The reference key.
		 * @returns {*} Returns the map data.
		 */
		function getMapData(map, key) {
		  var data = map.__data__;
		  return isKeyable(key)
		    ? data[typeof key == 'string' ? 'string' : 'hash']
		    : data.map;
		}

		/**
		 * Gets the native function at `key` of `object`.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @param {string} key The key of the method to get.
		 * @returns {*} Returns the function if it's native, else `undefined`.
		 */
		function getNative(object, key) {
		  var value = getValue(object, key);
		  return baseIsNative(value) ? value : undefined;
		}

		/**
		 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
		 *
		 * @private
		 * @param {*} value The value to query.
		 * @returns {string} Returns the raw `toStringTag`.
		 */
		function getRawTag(value) {
		  var isOwn = hasOwnProperty.call(value, symToStringTag),
		      tag = value[symToStringTag];

		  try {
		    value[symToStringTag] = undefined;
		    var unmasked = true;
		  } catch (e) {}

		  var result = nativeObjectToString.call(value);
		  if (unmasked) {
		    if (isOwn) {
		      value[symToStringTag] = tag;
		    } else {
		      delete value[symToStringTag];
		    }
		  }
		  return result;
		}

		/**
		 * Creates an array of the own enumerable symbols of `object`.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @returns {Array} Returns the array of symbols.
		 */
		var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
		  if (object == null) {
		    return [];
		  }
		  object = Object(object);
		  return arrayFilter(nativeGetSymbols(object), function(symbol) {
		    return propertyIsEnumerable.call(object, symbol);
		  });
		};

		/**
		 * Gets the `toStringTag` of `value`.
		 *
		 * @private
		 * @param {*} value The value to query.
		 * @returns {string} Returns the `toStringTag`.
		 */
		var getTag = baseGetTag;

		// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
		if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
		    (Map && getTag(new Map) != mapTag) ||
		    (Promise && getTag(Promise.resolve()) != promiseTag) ||
		    (Set && getTag(new Set) != setTag) ||
		    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
		  getTag = function(value) {
		    var result = baseGetTag(value),
		        Ctor = result == objectTag ? value.constructor : undefined,
		        ctorString = Ctor ? toSource(Ctor) : '';

		    if (ctorString) {
		      switch (ctorString) {
		        case dataViewCtorString: return dataViewTag;
		        case mapCtorString: return mapTag;
		        case promiseCtorString: return promiseTag;
		        case setCtorString: return setTag;
		        case weakMapCtorString: return weakMapTag;
		      }
		    }
		    return result;
		  };
		}

		/**
		 * Checks if `value` is a valid array-like index.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
		 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
		 */
		function isIndex(value, length) {
		  length = length == null ? MAX_SAFE_INTEGER : length;
		  return !!length &&
		    (typeof value == 'number' || reIsUint.test(value)) &&
		    (value > -1 && value % 1 == 0 && value < length);
		}

		/**
		 * Checks if `value` is suitable for use as unique object key.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
		 */
		function isKeyable(value) {
		  var type = typeof value;
		  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
		    ? (value !== '__proto__')
		    : (value === null);
		}

		/**
		 * Checks if `func` has its source masked.
		 *
		 * @private
		 * @param {Function} func The function to check.
		 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
		 */
		function isMasked(func) {
		  return !!maskSrcKey && (maskSrcKey in func);
		}

		/**
		 * Checks if `value` is likely a prototype object.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
		 */
		function isPrototype(value) {
		  var Ctor = value && value.constructor,
		      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

		  return value === proto;
		}

		/**
		 * Converts `value` to a string using `Object.prototype.toString`.
		 *
		 * @private
		 * @param {*} value The value to convert.
		 * @returns {string} Returns the converted string.
		 */
		function objectToString(value) {
		  return nativeObjectToString.call(value);
		}

		/**
		 * Converts `func` to its source code.
		 *
		 * @private
		 * @param {Function} func The function to convert.
		 * @returns {string} Returns the source code.
		 */
		function toSource(func) {
		  if (func != null) {
		    try {
		      return funcToString.call(func);
		    } catch (e) {}
		    try {
		      return (func + '');
		    } catch (e) {}
		  }
		  return '';
		}

		/**
		 * Performs a
		 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
		 * comparison between two values to determine if they are equivalent.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to compare.
		 * @param {*} other The other value to compare.
		 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
		 * @example
		 *
		 * var object = { 'a': 1 };
		 * var other = { 'a': 1 };
		 *
		 * _.eq(object, object);
		 * // => true
		 *
		 * _.eq(object, other);
		 * // => false
		 *
		 * _.eq('a', 'a');
		 * // => true
		 *
		 * _.eq('a', Object('a'));
		 * // => false
		 *
		 * _.eq(NaN, NaN);
		 * // => true
		 */
		function eq(value, other) {
		  return value === other || (value !== value && other !== other);
		}

		/**
		 * Checks if `value` is likely an `arguments` object.
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
		 *  else `false`.
		 * @example
		 *
		 * _.isArguments(function() { return arguments; }());
		 * // => true
		 *
		 * _.isArguments([1, 2, 3]);
		 * // => false
		 */
		var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
		  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
		    !propertyIsEnumerable.call(value, 'callee');
		};

		/**
		 * Checks if `value` is classified as an `Array` object.
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
		 * @example
		 *
		 * _.isArray([1, 2, 3]);
		 * // => true
		 *
		 * _.isArray(document.body.children);
		 * // => false
		 *
		 * _.isArray('abc');
		 * // => false
		 *
		 * _.isArray(_.noop);
		 * // => false
		 */
		var isArray = Array.isArray;

		/**
		 * Checks if `value` is array-like. A value is considered array-like if it's
		 * not a function and has a `value.length` that's an integer greater than or
		 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
		 * @example
		 *
		 * _.isArrayLike([1, 2, 3]);
		 * // => true
		 *
		 * _.isArrayLike(document.body.children);
		 * // => true
		 *
		 * _.isArrayLike('abc');
		 * // => true
		 *
		 * _.isArrayLike(_.noop);
		 * // => false
		 */
		function isArrayLike(value) {
		  return value != null && isLength(value.length) && !isFunction(value);
		}

		/**
		 * Checks if `value` is a buffer.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.3.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
		 * @example
		 *
		 * _.isBuffer(new Buffer(2));
		 * // => true
		 *
		 * _.isBuffer(new Uint8Array(2));
		 * // => false
		 */
		var isBuffer = nativeIsBuffer || stubFalse;

		/**
		 * Performs a deep comparison between two values to determine if they are
		 * equivalent.
		 *
		 * **Note:** This method supports comparing arrays, array buffers, booleans,
		 * date objects, error objects, maps, numbers, `Object` objects, regexes,
		 * sets, strings, symbols, and typed arrays. `Object` objects are compared
		 * by their own, not inherited, enumerable properties. Functions and DOM
		 * nodes are compared by strict equality, i.e. `===`.
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Lang
		 * @param {*} value The value to compare.
		 * @param {*} other The other value to compare.
		 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
		 * @example
		 *
		 * var object = { 'a': 1 };
		 * var other = { 'a': 1 };
		 *
		 * _.isEqual(object, other);
		 * // => true
		 *
		 * object === other;
		 * // => false
		 */
		function isEqual(value, other) {
		  return baseIsEqual(value, other);
		}

		/**
		 * Checks if `value` is classified as a `Function` object.
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
		 * @example
		 *
		 * _.isFunction(_);
		 * // => true
		 *
		 * _.isFunction(/abc/);
		 * // => false
		 */
		function isFunction(value) {
		  if (!isObject(value)) {
		    return false;
		  }
		  // The use of `Object#toString` avoids issues with the `typeof` operator
		  // in Safari 9 which returns 'object' for typed arrays and other constructors.
		  var tag = baseGetTag(value);
		  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
		}

		/**
		 * Checks if `value` is a valid array-like length.
		 *
		 * **Note:** This method is loosely based on
		 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
		 * @example
		 *
		 * _.isLength(3);
		 * // => true
		 *
		 * _.isLength(Number.MIN_VALUE);
		 * // => false
		 *
		 * _.isLength(Infinity);
		 * // => false
		 *
		 * _.isLength('3');
		 * // => false
		 */
		function isLength(value) {
		  return typeof value == 'number' &&
		    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
		}

		/**
		 * Checks if `value` is the
		 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
		 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
		 * @example
		 *
		 * _.isObject({});
		 * // => true
		 *
		 * _.isObject([1, 2, 3]);
		 * // => true
		 *
		 * _.isObject(_.noop);
		 * // => true
		 *
		 * _.isObject(null);
		 * // => false
		 */
		function isObject(value) {
		  var type = typeof value;
		  return value != null && (type == 'object' || type == 'function');
		}

		/**
		 * Checks if `value` is object-like. A value is object-like if it's not `null`
		 * and has a `typeof` result of "object".
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
		 * @example
		 *
		 * _.isObjectLike({});
		 * // => true
		 *
		 * _.isObjectLike([1, 2, 3]);
		 * // => true
		 *
		 * _.isObjectLike(_.noop);
		 * // => false
		 *
		 * _.isObjectLike(null);
		 * // => false
		 */
		function isObjectLike(value) {
		  return value != null && typeof value == 'object';
		}

		/**
		 * Checks if `value` is classified as a typed array.
		 *
		 * @static
		 * @memberOf _
		 * @since 3.0.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
		 * @example
		 *
		 * _.isTypedArray(new Uint8Array);
		 * // => true
		 *
		 * _.isTypedArray([]);
		 * // => false
		 */
		var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

		/**
		 * Creates an array of the own enumerable property names of `object`.
		 *
		 * **Note:** Non-object values are coerced to objects. See the
		 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
		 * for more details.
		 *
		 * @static
		 * @since 0.1.0
		 * @memberOf _
		 * @category Object
		 * @param {Object} object The object to query.
		 * @returns {Array} Returns the array of property names.
		 * @example
		 *
		 * function Foo() {
		 *   this.a = 1;
		 *   this.b = 2;
		 * }
		 *
		 * Foo.prototype.c = 3;
		 *
		 * _.keys(new Foo);
		 * // => ['a', 'b'] (iteration order is not guaranteed)
		 *
		 * _.keys('hi');
		 * // => ['0', '1']
		 */
		function keys(object) {
		  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
		}

		/**
		 * This method returns a new empty array.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.13.0
		 * @category Util
		 * @returns {Array} Returns the new empty array.
		 * @example
		 *
		 * var arrays = _.times(2, _.stubArray);
		 *
		 * console.log(arrays);
		 * // => [[], []]
		 *
		 * console.log(arrays[0] === arrays[1]);
		 * // => false
		 */
		function stubArray() {
		  return [];
		}

		/**
		 * This method returns `false`.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.13.0
		 * @category Util
		 * @returns {boolean} Returns `false`.
		 * @example
		 *
		 * _.times(2, _.stubFalse);
		 * // => [false, false]
		 */
		function stubFalse() {
		  return false;
		}

		module.exports = isEqual;
	} (lodash_isequal, lodash_isequalExports));

	var SchemaCompilation$1 = {};

	var hasRequiredSchemaCompilation;

	function requireSchemaCompilation () {
		if (hasRequiredSchemaCompilation) return SchemaCompilation$1;
		hasRequiredSchemaCompilation = 1;
		(function (exports) {

			var Report      = Report_1;
			var SchemaCache = requireSchemaCache();
			var Utils       = Utils$2;

			function mergeReference(scope, ref) {
			    if (Utils.isAbsoluteUri(ref)) {
			        return ref;
			    }

			    var joinedScope = scope.join(""),
			        isScopeAbsolute = Utils.isAbsoluteUri(joinedScope),
			        isScopeRelative = Utils.isRelativeUri(joinedScope),
			        isRefRelative = Utils.isRelativeUri(ref),
			        toRemove;

			    if (isScopeAbsolute && isRefRelative) {
			        toRemove = joinedScope.match(/\/[^\/]*$/);
			        if (toRemove) {
			            joinedScope = joinedScope.slice(0, toRemove.index + 1);
			        }
			    } else if (isScopeRelative && isRefRelative) {
			        joinedScope = "";
			    } else {
			        toRemove = joinedScope.match(/[^#/]+$/);
			        if (toRemove) {
			            joinedScope = joinedScope.slice(0, toRemove.index);
			        }
			    }

			    var res = joinedScope + ref;
			    res = res.replace(/##/, "#");
			    return res;
			}

			function collectReferences(obj, results, scope, path) {
			    results = results || [];
			    scope = scope || [];
			    path = path || [];

			    if (typeof obj !== "object" || obj === null) {
			        return results;
			    }

			    if (typeof obj.id === "string") {
			        scope.push(obj.id);
			    }

			    if (typeof obj.$ref === "string" && typeof obj.__$refResolved === "undefined") {
			        results.push({
			            ref: mergeReference(scope, obj.$ref),
			            key: "$ref",
			            obj: obj,
			            path: path.slice(0)
			        });
			    }
			    if (typeof obj.$schema === "string" && typeof obj.__$schemaResolved === "undefined") {
			        results.push({
			            ref: mergeReference(scope, obj.$schema),
			            key: "$schema",
			            obj: obj,
			            path: path.slice(0)
			        });
			    }

			    var idx;
			    if (Array.isArray(obj)) {
			        idx = obj.length;
			        while (idx--) {
			            path.push(idx.toString());
			            collectReferences(obj[idx], results, scope, path);
			            path.pop();
			        }
			    } else {
			        var keys = Object.keys(obj);
			        idx = keys.length;
			        while (idx--) {
			            // do not recurse through resolved references and other z-schema props
			            if (keys[idx].indexOf("__$") === 0) { continue; }
			            path.push(keys[idx]);
			            collectReferences(obj[keys[idx]], results, scope, path);
			            path.pop();
			        }
			    }

			    if (typeof obj.id === "string") {
			        scope.pop();
			    }

			    return results;
			}

			var compileArrayOfSchemasLoop = function (mainReport, arr) {
			    var idx = arr.length,
			        compiledCount = 0;

			    while (idx--) {

			        // try to compile each schema separately
			        var report = new Report(mainReport);
			        var isValid = exports.compileSchema.call(this, report, arr[idx]);
			        if (isValid) { compiledCount++; }

			        // copy errors to report
			        mainReport.errors = mainReport.errors.concat(report.errors);

			    }

			    return compiledCount;
			};

			function findId(arr, id) {
			    var idx = arr.length;
			    while (idx--) {
			        if (arr[idx].id === id) {
			            return arr[idx];
			        }
			    }
			    return null;
			}

			var compileArrayOfSchemas = function (report, arr) {

			    var compiled = 0,
			        lastLoopCompiled;

			    do {

			        // remove all UNRESOLVABLE_REFERENCE errors before compiling array again
			        var idx = report.errors.length;
			        while (idx--) {
			            if (report.errors[idx].code === "UNRESOLVABLE_REFERENCE") {
			                report.errors.splice(idx, 1);
			            }
			        }

			        // remember how many were compiled in the last loop
			        lastLoopCompiled = compiled;

			        // count how many are compiled now
			        compiled = compileArrayOfSchemasLoop.call(this, report, arr);

			        // fix __$missingReferences if possible
			        idx = arr.length;
			        while (idx--) {
			            var sch = arr[idx];
			            if (sch.__$missingReferences) {
			                var idx2 = sch.__$missingReferences.length;
			                while (idx2--) {
			                    var refObj = sch.__$missingReferences[idx2];
			                    var response = findId(arr, refObj.ref);
			                    if (response) {
			                        // this might create circular references
			                        refObj.obj["__" + refObj.key + "Resolved"] = response;
			                        // it's resolved now so delete it
			                        sch.__$missingReferences.splice(idx2, 1);
			                    }
			                }
			                if (sch.__$missingReferences.length === 0) {
			                    delete sch.__$missingReferences;
			                }
			            }
			        }

			        // keep repeating if not all compiled and at least one more was compiled in the last loop
			    } while (compiled !== arr.length && compiled !== lastLoopCompiled);

			    return report.isValid();

			};

			exports.compileSchema = function (report, schema) {

			    report.commonErrorMessage = "SCHEMA_COMPILATION_FAILED";

			    // if schema is a string, assume it's a uri
			    if (typeof schema === "string") {
			        var loadedSchema = SchemaCache.getSchemaByUri.call(this, report, schema);
			        if (!loadedSchema) {
			            report.addError("SCHEMA_NOT_REACHABLE", [schema]);
			            return false;
			        }
			        schema = loadedSchema;
			    }

			    // if schema is an array, assume it's an array of schemas
			    if (Array.isArray(schema)) {
			        return compileArrayOfSchemas.call(this, report, schema);
			    }

			    // if we have an id than it should be cached already (if this instance has compiled it)
			    if (schema.__$compiled && schema.id && SchemaCache.checkCacheForUri.call(this, schema.id) === false) {
			        schema.__$compiled = undefined;
			    }

			    // do not re-compile schemas
			    if (schema.__$compiled) {
			        return true;
			    }

			    if (schema.id && typeof schema.id === "string") {
			        // add this to our schemaCache (before compilation in case we have references including id)
			        SchemaCache.cacheSchemaByUri.call(this, schema.id, schema);
			    }

			    // this method can be called recursively, so we need to remember our root
			    var isRoot = false;
			    if (!report.rootSchema) {
			        report.rootSchema = schema;
			        isRoot = true;
			    }

			    // delete all __$missingReferences from previous compilation attempts
			    var isValidExceptReferences = report.isValid();
			    delete schema.__$missingReferences;

			    // collect all references that need to be resolved - $ref and $schema
			    var refs = collectReferences.call(this, schema),
			        idx = refs.length;
			    while (idx--) {
			        // resolve all the collected references into __xxxResolved pointer
			        var refObj = refs[idx];
			        var response = SchemaCache.getSchemaByUri.call(this, report, refObj.ref, schema);

			        // we can try to use custom schemaReader if available
			        if (!response) {
			            var schemaReader = this.getSchemaReader();
			            if (schemaReader) {
			                // it's supposed to return a valid schema
			                var s = schemaReader(refObj.ref);
			                if (s) {
			                    // it needs to have the id
			                    s.id = refObj.ref;
			                    // try to compile the schema
			                    var subreport = new Report(report);
			                    if (!exports.compileSchema.call(this, subreport, s)) {
			                        // copy errors to report
			                        report.errors = report.errors.concat(subreport.errors);
			                    } else {
			                        response = SchemaCache.getSchemaByUri.call(this, report, refObj.ref, schema);
			                    }
			                }
			            }
			        }

			        if (!response) {

			            var hasNotValid = report.hasError("REMOTE_NOT_VALID", [refObj.ref]);
			            var isAbsolute = Utils.isAbsoluteUri(refObj.ref);
			            var isDownloaded = false;
			            var ignoreUnresolvableRemotes = this.options.ignoreUnresolvableReferences === true;

			            if (isAbsolute) {
			                // we shouldn't add UNRESOLVABLE_REFERENCE for schemas we already have downloaded
			                // and set through setRemoteReference method
			                isDownloaded = SchemaCache.checkCacheForUri.call(this, refObj.ref);
			            }

			            if (hasNotValid) ; else if (ignoreUnresolvableRemotes && isAbsolute) ; else if (isDownloaded) ; else {
			                Array.prototype.push.apply(report.path, refObj.path);
			                report.addError("UNRESOLVABLE_REFERENCE", [refObj.ref]);
			                report.path = report.path.slice(0, -refObj.path.length);

			                // pusblish unresolved references out
			                if (isValidExceptReferences) {
			                    schema.__$missingReferences = schema.__$missingReferences || [];
			                    schema.__$missingReferences.push(refObj);
			                }
			            }
			        }
			        // this might create circular references
			        refObj.obj["__" + refObj.key + "Resolved"] = response;
			    }

			    var isValid = report.isValid();
			    if (isValid) {
			        schema.__$compiled = true;
			    } else {
			        if (schema.id && typeof schema.id === "string") {
			            // remove this schema from schemaCache because it failed to compile
			            SchemaCache.removeFromCacheByUri.call(this, schema.id);
			        }
			    }

			    // we don't need the root pointer anymore
			    if (isRoot) {
			        report.rootSchema = undefined;
			    }

			    return isValid;

			};
	} (SchemaCompilation$1));
		return SchemaCompilation$1;
	}

	var SchemaValidation$1 = {};

	(function (exports) {

		var FormatValidators = FormatValidators_1,
		    JsonValidation   = JsonValidation$1,
		    Report           = Report_1,
		    Utils            = Utils$2;

		var SchemaValidators = {
		    $ref: function (report, schema) {
		        // http://tools.ietf.org/html/draft-ietf-appsawg-json-pointer-07
		        // http://tools.ietf.org/html/draft-pbryan-zyp-json-ref-03
		        if (typeof schema.$ref !== "string") {
		            report.addError("KEYWORD_TYPE_EXPECTED", ["$ref", "string"]);
		        }
		    },
		    $schema: function (report, schema) {
		        // http://json-schema.org/latest/json-schema-core.html#rfc.section.6
		        if (typeof schema.$schema !== "string") {
		            report.addError("KEYWORD_TYPE_EXPECTED", ["$schema", "string"]);
		        }
		    },
		    multipleOf: function (report, schema) {
		        // http://json-schema.org/latest/json-schema-validation.html#rfc.section.5.1.1.1
		        if (typeof schema.multipleOf !== "number") {
		            report.addError("KEYWORD_TYPE_EXPECTED", ["multipleOf", "number"]);
		        } else if (schema.multipleOf <= 0) {
		            report.addError("KEYWORD_MUST_BE", ["multipleOf", "strictly greater than 0"]);
		        }
		    },
		    maximum: function (report, schema) {
		        // http://json-schema.org/latest/json-schema-validation.html#rfc.section.5.1.2.1
		        if (typeof schema.maximum !== "number") {
		            report.addError("KEYWORD_TYPE_EXPECTED", ["maximum", "number"]);
		        }
		    },
		    exclusiveMaximum: function (report, schema) {
		        // http://json-schema.org/latest/json-schema-validation.html#rfc.section.5.1.2.1
		        if (typeof schema.exclusiveMaximum !== "boolean") {
		            report.addError("KEYWORD_TYPE_EXPECTED", ["exclusiveMaximum", "boolean"]);
		        } else if (schema.maximum === undefined) {
		            report.addError("KEYWORD_DEPENDENCY", ["exclusiveMaximum", "maximum"]);
		        }
		    },
		    minimum: function (report, schema) {
		        // http://json-schema.org/latest/json-schema-validation.html#rfc.section.5.1.3.1
		        if (typeof schema.minimum !== "number") {
		            report.addError("KEYWORD_TYPE_EXPECTED", ["minimum", "number"]);
		        }
		    },
		    exclusiveMinimum: function (report, schema) {
		        // http://json-schema.org/latest/json-schema-validation.html#rfc.section.5.1.3.1
		        if (typeof schema.exclusiveMinimum !== "boolean") {
		            report.addError("KEYWORD_TYPE_EXPECTED", ["exclusiveMinimum", "boolean"]);
		        } else if (schema.minimum === undefined) {
		            report.addError("KEYWORD_DEPENDENCY", ["exclusiveMinimum", "minimum"]);
		        }
		    },
		    maxLength: function (report, schema) {
		        // http://json-schema.org/latest/json-schema-validation.html#rfc.section.5.2.1.1
		        if (Utils.whatIs(schema.maxLength) !== "integer") {
		            report.addError("KEYWORD_TYPE_EXPECTED", ["maxLength", "integer"]);
		        } else if (schema.maxLength < 0) {
		            report.addError("KEYWORD_MUST_BE", ["maxLength", "greater than, or equal to 0"]);
		        }
		    },
		    minLength: function (report, schema) {
		        // http://json-schema.org/latest/json-schema-validation.html#rfc.section.5.2.2.1
		        if (Utils.whatIs(schema.minLength) !== "integer") {
		            report.addError("KEYWORD_TYPE_EXPECTED", ["minLength", "integer"]);
		        } else if (schema.minLength < 0) {
		            report.addError("KEYWORD_MUST_BE", ["minLength", "greater than, or equal to 0"]);
		        }
		    },
		    pattern: function (report, schema) {
		        // http://json-schema.org/latest/json-schema-validation.html#rfc.section.5.2.3.1
		        if (typeof schema.pattern !== "string") {
		            report.addError("KEYWORD_TYPE_EXPECTED", ["pattern", "string"]);
		        } else {
		            try {
		                RegExp(schema.pattern);
		            } catch (e) {
		                report.addError("KEYWORD_PATTERN", ["pattern", schema.pattern]);
		            }
		        }
		    },
		    additionalItems: function (report, schema) {
		        // http://json-schema.org/latest/json-schema-validation.html#rfc.section.5.3.1.1
		        var type = Utils.whatIs(schema.additionalItems);
		        if (type !== "boolean" && type !== "object") {
		            report.addError("KEYWORD_TYPE_EXPECTED", ["additionalItems", ["boolean", "object"]]);
		        } else if (type === "object") {
		            report.path.push("additionalItems");
		            exports.validateSchema.call(this, report, schema.additionalItems);
		            report.path.pop();
		        }
		    },
		    items: function (report, schema) {
		        // http://json-schema.org/latest/json-schema-validation.html#rfc.section.5.3.1.1
		        var type = Utils.whatIs(schema.items);

		        if (type === "object") {
		            report.path.push("items");
		            exports.validateSchema.call(this, report, schema.items);
		            report.path.pop();
		        } else if (type === "array") {
		            var idx = schema.items.length;
		            while (idx--) {
		                report.path.push("items");
		                report.path.push(idx.toString());
		                exports.validateSchema.call(this, report, schema.items[idx]);
		                report.path.pop();
		                report.path.pop();
		            }
		        } else {
		            report.addError("KEYWORD_TYPE_EXPECTED", ["items", ["array", "object"]]);
		        }

		        // custom - strict mode
		        if (this.options.forceAdditional === true && schema.additionalItems === undefined && Array.isArray(schema.items)) {
		            report.addError("KEYWORD_UNDEFINED_STRICT", ["additionalItems"]);
		        }
		        // custome - assume defined false mode
		        if (this.options.assumeAdditional && schema.additionalItems === undefined && Array.isArray(schema.items)) {
		            schema.additionalItems = false;
		        }
		    },
		    maxItems: function (report, schema) {
		        // http://json-schema.org/latest/json-schema-validation.html#rfc.section.5.3.2.1
		        if (typeof schema.maxItems !== "number") {
		            report.addError("KEYWORD_TYPE_EXPECTED", ["maxItems", "integer"]);
		        } else if (schema.maxItems < 0) {
		            report.addError("KEYWORD_MUST_BE", ["maxItems", "greater than, or equal to 0"]);
		        }
		    },
		    minItems: function (report, schema) {
		        // http://json-schema.org/latest/json-schema-validation.html#rfc.section.5.3.3.1
		        if (Utils.whatIs(schema.minItems) !== "integer") {
		            report.addError("KEYWORD_TYPE_EXPECTED", ["minItems", "integer"]);
		        } else if (schema.minItems < 0) {
		            report.addError("KEYWORD_MUST_BE", ["minItems", "greater than, or equal to 0"]);
		        }
		    },
		    uniqueItems: function (report, schema) {
		        // http://json-schema.org/latest/json-schema-validation.html#rfc.section.5.3.4.1
		        if (typeof schema.uniqueItems !== "boolean") {
		            report.addError("KEYWORD_TYPE_EXPECTED", ["uniqueItems", "boolean"]);
		        }
		    },
		    maxProperties: function (report, schema) {
		        // http://json-schema.org/latest/json-schema-validation.html#rfc.section.5.4.1.1
		        if (Utils.whatIs(schema.maxProperties) !== "integer") {
		            report.addError("KEYWORD_TYPE_EXPECTED", ["maxProperties", "integer"]);
		        } else if (schema.maxProperties < 0) {
		            report.addError("KEYWORD_MUST_BE", ["maxProperties", "greater than, or equal to 0"]);
		        }
		    },
		    minProperties: function (report, schema) {
		        // http://json-schema.org/latest/json-schema-validation.html#rfc.section.5.4.2.1
		        if (Utils.whatIs(schema.minProperties) !== "integer") {
		            report.addError("KEYWORD_TYPE_EXPECTED", ["minProperties", "integer"]);
		        } else if (schema.minProperties < 0) {
		            report.addError("KEYWORD_MUST_BE", ["minProperties", "greater than, or equal to 0"]);
		        }
		    },
		    required: function (report, schema) {
		        // http://json-schema.org/latest/json-schema-validation.html#rfc.section.5.4.3.1
		        if (Utils.whatIs(schema.required) !== "array") {
		            report.addError("KEYWORD_TYPE_EXPECTED", ["required", "array"]);
		        } else if (schema.required.length === 0) {
		            report.addError("KEYWORD_MUST_BE", ["required", "an array with at least one element"]);
		        } else {
		            var idx = schema.required.length;
		            while (idx--) {
		                if (typeof schema.required[idx] !== "string") {
		                    report.addError("KEYWORD_VALUE_TYPE", ["required", "string"]);
		                }
		            }
		            if (Utils.isUniqueArray(schema.required) === false) {
		                report.addError("KEYWORD_MUST_BE", ["required", "an array with unique items"]);
		            }
		        }
		    },
		    additionalProperties: function (report, schema) {
		        // http://json-schema.org/latest/json-schema-validation.html#rfc.section.5.4.4.1
		        var type = Utils.whatIs(schema.additionalProperties);
		        if (type !== "boolean" && type !== "object") {
		            report.addError("KEYWORD_TYPE_EXPECTED", ["additionalProperties", ["boolean", "object"]]);
		        } else if (type === "object") {
		            report.path.push("additionalProperties");
		            exports.validateSchema.call(this, report, schema.additionalProperties);
		            report.path.pop();
		        }
		    },
		    properties: function (report, schema) {
		        // http://json-schema.org/latest/json-schema-validation.html#rfc.section.5.4.4.1
		        if (Utils.whatIs(schema.properties) !== "object") {
		            report.addError("KEYWORD_TYPE_EXPECTED", ["properties", "object"]);
		            return;
		        }

		        var keys = Object.keys(schema.properties),
		            idx = keys.length;
		        while (idx--) {
		            var key = keys[idx],
		                val = schema.properties[key];
		            report.path.push("properties");
		            report.path.push(key);
		            exports.validateSchema.call(this, report, val);
		            report.path.pop();
		            report.path.pop();
		        }

		        // custom - strict mode
		        if (this.options.forceAdditional === true && schema.additionalProperties === undefined) {
		            report.addError("KEYWORD_UNDEFINED_STRICT", ["additionalProperties"]);
		        }
		        // custome - assume defined false mode
		        if (this.options.assumeAdditional && schema.additionalProperties === undefined) {
		            schema.additionalProperties = false;
		        }
		        // custom - forceProperties
		        if (this.options.forceProperties === true && keys.length === 0) {
		            report.addError("CUSTOM_MODE_FORCE_PROPERTIES", ["properties"]);
		        }
		    },
		    patternProperties: function (report, schema) {
		        // http://json-schema.org/latest/json-schema-validation.html#rfc.section.5.4.4.1
		        if (Utils.whatIs(schema.patternProperties) !== "object") {
		            report.addError("KEYWORD_TYPE_EXPECTED", ["patternProperties", "object"]);
		            return;
		        }

		        var keys = Object.keys(schema.patternProperties),
		            idx = keys.length;
		        while (idx--) {
		            var key = keys[idx],
		                val = schema.patternProperties[key];
		            try {
		                RegExp(key);
		            } catch (e) {
		                report.addError("KEYWORD_PATTERN", ["patternProperties", key]);
		            }
		            report.path.push("patternProperties");
		            report.path.push(key.toString());
		            exports.validateSchema.call(this, report, val);
		            report.path.pop();
		            report.path.pop();
		        }

		        // custom - forceProperties
		        if (this.options.forceProperties === true && keys.length === 0) {
		            report.addError("CUSTOM_MODE_FORCE_PROPERTIES", ["patternProperties"]);
		        }
		    },
		    dependencies: function (report, schema) {
		        // http://json-schema.org/latest/json-schema-validation.html#rfc.section.5.4.5.1
		        if (Utils.whatIs(schema.dependencies) !== "object") {
		            report.addError("KEYWORD_TYPE_EXPECTED", ["dependencies", "object"]);
		        } else {
		            var keys = Object.keys(schema.dependencies),
		                idx = keys.length;
		            while (idx--) {
		                var schemaKey = keys[idx],
		                    schemaDependency = schema.dependencies[schemaKey],
		                    type = Utils.whatIs(schemaDependency);

		                if (type === "object") {
		                    report.path.push("dependencies");
		                    report.path.push(schemaKey);
		                    exports.validateSchema.call(this, report, schemaDependency);
		                    report.path.pop();
		                    report.path.pop();
		                } else if (type === "array") {
		                    var idx2 = schemaDependency.length;
		                    if (idx2 === 0) {
		                        report.addError("KEYWORD_MUST_BE", ["dependencies", "not empty array"]);
		                    }
		                    while (idx2--) {
		                        if (typeof schemaDependency[idx2] !== "string") {
		                            report.addError("KEYWORD_VALUE_TYPE", ["dependensices", "string"]);
		                        }
		                    }
		                    if (Utils.isUniqueArray(schemaDependency) === false) {
		                        report.addError("KEYWORD_MUST_BE", ["dependencies", "an array with unique items"]);
		                    }
		                } else {
		                    report.addError("KEYWORD_VALUE_TYPE", ["dependencies", "object or array"]);
		                }
		            }
		        }
		    },
		    enum: function (report, schema) {
		        // http://json-schema.org/latest/json-schema-validation.html#rfc.section.5.5.1.1
		        if (Array.isArray(schema.enum) === false) {
		            report.addError("KEYWORD_TYPE_EXPECTED", ["enum", "array"]);
		        } else if (schema.enum.length === 0) {
		            report.addError("KEYWORD_MUST_BE", ["enum", "an array with at least one element"]);
		        } else if (Utils.isUniqueArray(schema.enum) === false) {
		            report.addError("KEYWORD_MUST_BE", ["enum", "an array with unique elements"]);
		        }
		    },
		    type: function (report, schema) {
		        // http://json-schema.org/latest/json-schema-validation.html#rfc.section.5.5.2.1
		        var primitiveTypes = ["array", "boolean", "integer", "number", "null", "object", "string"],
		            primitiveTypeStr = primitiveTypes.join(","),
		            isArray = Array.isArray(schema.type);

		        if (isArray) {
		            var idx = schema.type.length;
		            while (idx--) {
		                if (primitiveTypes.indexOf(schema.type[idx]) === -1) {
		                    report.addError("KEYWORD_TYPE_EXPECTED", ["type", primitiveTypeStr]);
		                }
		            }
		            if (Utils.isUniqueArray(schema.type) === false) {
		                report.addError("KEYWORD_MUST_BE", ["type", "an object with unique properties"]);
		            }
		        } else if (typeof schema.type === "string") {
		            if (primitiveTypes.indexOf(schema.type) === -1) {
		                report.addError("KEYWORD_TYPE_EXPECTED", ["type", primitiveTypeStr]);
		            }
		        } else {
		            report.addError("KEYWORD_TYPE_EXPECTED", ["type", ["string", "array"]]);
		        }

		        if (this.options.noEmptyStrings === true) {
		            if (schema.type === "string" || isArray && schema.type.indexOf("string") !== -1) {
		                if (schema.minLength === undefined &&
		                    schema.enum === undefined &&
		                    schema.format === undefined) {

		                    schema.minLength = 1;
		                }
		            }
		        }
		        if (this.options.noEmptyArrays === true) {
		            if (schema.type === "array" || isArray && schema.type.indexOf("array") !== -1) {
		                if (schema.minItems === undefined) {
		                    schema.minItems = 1;
		                }
		            }
		        }
		        if (this.options.forceProperties === true) {
		            if (schema.type === "object" || isArray && schema.type.indexOf("object") !== -1) {
		                if (schema.properties === undefined && schema.patternProperties === undefined) {
		                    report.addError("KEYWORD_UNDEFINED_STRICT", ["properties"]);
		                }
		            }
		        }
		        if (this.options.forceItems === true) {
		            if (schema.type === "array" || isArray && schema.type.indexOf("array") !== -1) {
		                if (schema.items === undefined) {
		                    report.addError("KEYWORD_UNDEFINED_STRICT", ["items"]);
		                }
		            }
		        }
		        if (this.options.forceMinItems === true) {
		            if (schema.type === "array" || isArray && schema.type.indexOf("array") !== -1) {
		                if (schema.minItems === undefined) {
		                    report.addError("KEYWORD_UNDEFINED_STRICT", ["minItems"]);
		                }
		            }
		        }
		        if (this.options.forceMaxItems === true) {
		            if (schema.type === "array" || isArray && schema.type.indexOf("array") !== -1) {
		                if (schema.maxItems === undefined) {
		                    report.addError("KEYWORD_UNDEFINED_STRICT", ["maxItems"]);
		                }
		            }
		        }
		        if (this.options.forceMinLength === true) {
		            if (schema.type === "string" || isArray && schema.type.indexOf("string") !== -1) {
		                if (schema.minLength === undefined &&
		                    schema.format === undefined &&
		                    schema.enum === undefined &&
		                    schema.pattern === undefined) {
		                    report.addError("KEYWORD_UNDEFINED_STRICT", ["minLength"]);
		                }
		            }
		        }
		        if (this.options.forceMaxLength === true) {
		            if (schema.type === "string" || isArray && schema.type.indexOf("string") !== -1) {
		                if (schema.maxLength === undefined &&
		                    schema.format === undefined &&
		                    schema.enum === undefined &&
		                    schema.pattern === undefined) {
		                    report.addError("KEYWORD_UNDEFINED_STRICT", ["maxLength"]);
		                }
		            }
		        }
		    },
		    allOf: function (report, schema) {
		        // http://json-schema.org/latest/json-schema-validation.html#rfc.section.5.5.3.1
		        if (Array.isArray(schema.allOf) === false) {
		            report.addError("KEYWORD_TYPE_EXPECTED", ["allOf", "array"]);
		        } else if (schema.allOf.length === 0) {
		            report.addError("KEYWORD_MUST_BE", ["allOf", "an array with at least one element"]);
		        } else {
		            var idx = schema.allOf.length;
		            while (idx--) {
		                report.path.push("allOf");
		                report.path.push(idx.toString());
		                exports.validateSchema.call(this, report, schema.allOf[idx]);
		                report.path.pop();
		                report.path.pop();
		            }
		        }
		    },
		    anyOf: function (report, schema) {
		        // http://json-schema.org/latest/json-schema-validation.html#rfc.section.5.5.4.1
		        if (Array.isArray(schema.anyOf) === false) {
		            report.addError("KEYWORD_TYPE_EXPECTED", ["anyOf", "array"]);
		        } else if (schema.anyOf.length === 0) {
		            report.addError("KEYWORD_MUST_BE", ["anyOf", "an array with at least one element"]);
		        } else {
		            var idx = schema.anyOf.length;
		            while (idx--) {
		                report.path.push("anyOf");
		                report.path.push(idx.toString());
		                exports.validateSchema.call(this, report, schema.anyOf[idx]);
		                report.path.pop();
		                report.path.pop();
		            }
		        }
		    },
		    oneOf: function (report, schema) {
		        // http://json-schema.org/latest/json-schema-validation.html#rfc.section.5.5.5.1
		        if (Array.isArray(schema.oneOf) === false) {
		            report.addError("KEYWORD_TYPE_EXPECTED", ["oneOf", "array"]);
		        } else if (schema.oneOf.length === 0) {
		            report.addError("KEYWORD_MUST_BE", ["oneOf", "an array with at least one element"]);
		        } else {
		            var idx = schema.oneOf.length;
		            while (idx--) {
		                report.path.push("oneOf");
		                report.path.push(idx.toString());
		                exports.validateSchema.call(this, report, schema.oneOf[idx]);
		                report.path.pop();
		                report.path.pop();
		            }
		        }
		    },
		    not: function (report, schema) {
		        // http://json-schema.org/latest/json-schema-validation.html#rfc.section.5.5.6.1
		        if (Utils.whatIs(schema.not) !== "object") {
		            report.addError("KEYWORD_TYPE_EXPECTED", ["not", "object"]);
		        } else {
		            report.path.push("not");
		            exports.validateSchema.call(this, report, schema.not);
		            report.path.pop();
		        }
		    },
		    definitions: function (report, schema) {
		        // http://json-schema.org/latest/json-schema-validation.html#rfc.section.5.5.7.1
		        if (Utils.whatIs(schema.definitions) !== "object") {
		            report.addError("KEYWORD_TYPE_EXPECTED", ["definitions", "object"]);
		        } else {
		            var keys = Object.keys(schema.definitions),
		                idx = keys.length;
		            while (idx--) {
		                var key = keys[idx],
		                    val = schema.definitions[key];
		                report.path.push("definitions");
		                report.path.push(key);
		                exports.validateSchema.call(this, report, val);
		                report.path.pop();
		                report.path.pop();
		            }
		        }
		    },
		    format: function (report, schema) {
		        if (typeof schema.format !== "string") {
		            report.addError("KEYWORD_TYPE_EXPECTED", ["format", "string"]);
		        } else {
		            if (FormatValidators[schema.format] === undefined && this.options.ignoreUnknownFormats !== true) {
		                report.addError("UNKNOWN_FORMAT", [schema.format]);
		            }
		        }
		    },
		    id: function (report, schema) {
		        // http://json-schema.org/latest/json-schema-core.html#rfc.section.7.2
		        if (typeof schema.id !== "string") {
		            report.addError("KEYWORD_TYPE_EXPECTED", ["id", "string"]);
		        }
		    },
		    title: function (report, schema) {
		        // http://json-schema.org/latest/json-schema-validation.html#rfc.section.6.1
		        if (typeof schema.title !== "string") {
		            report.addError("KEYWORD_TYPE_EXPECTED", ["title", "string"]);
		        }
		    },
		    description: function (report, schema) {
		        // http://json-schema.org/latest/json-schema-validation.html#rfc.section.6.1
		        if (typeof schema.description !== "string") {
		            report.addError("KEYWORD_TYPE_EXPECTED", ["description", "string"]);
		        }
		    },
		    "default": function (/* report, schema */) {
		        // http://json-schema.org/latest/json-schema-validation.html#rfc.section.6.2
		        // There are no restrictions placed on the value of this keyword.
		    }
		};

		/**
		 *
		 * @param {Report} report
		 * @param {*[]} arr
		 *
		 * @returns {boolean}
		 */
		var validateArrayOfSchemas = function (report, arr) {
		    var idx = arr.length;
		    while (idx--) {
		        exports.validateSchema.call(this, report, arr[idx]);
		    }
		    return report.isValid();
		};

		/**
		 *
		 * @param {Report} report
		 * @param {*} schema
		 */
		exports.validateSchema = function (report, schema) {

		    report.commonErrorMessage = "SCHEMA_VALIDATION_FAILED";

		    // if schema is an array, assume it's an array of schemas
		    if (Array.isArray(schema)) {
		        return validateArrayOfSchemas.call(this, report, schema);
		    }

		    // do not revalidate schema that has already been validated once
		    if (schema.__$validated) {
		        return true;
		    }

		    // if $schema is present, this schema should validate against that $schema
		    var hasParentSchema = schema.$schema && schema.id !== schema.$schema;
		    if (hasParentSchema) {
		        if (schema.__$schemaResolved && schema.__$schemaResolved !== schema) {
		            var subReport = new Report(report);
		            var valid = JsonValidation.validate.call(this, subReport, schema.__$schemaResolved, schema);
		            if (valid === false) {
		                report.addError("PARENT_SCHEMA_VALIDATION_FAILED", null, subReport);
		            }
		        } else {
		            if (this.options.ignoreUnresolvableReferences !== true) {
		                report.addError("REF_UNRESOLVED", [schema.$schema]);
		            }
		        }
		    }

		    if (this.options.noTypeless === true) {
		        // issue #36 - inherit type to anyOf, oneOf, allOf if noTypeless is defined
		        if (schema.type !== undefined) {
		            var schemas = [];
		            if (Array.isArray(schema.anyOf)) { schemas = schemas.concat(schema.anyOf); }
		            if (Array.isArray(schema.oneOf)) { schemas = schemas.concat(schema.oneOf); }
		            if (Array.isArray(schema.allOf)) { schemas = schemas.concat(schema.allOf); }
		            schemas.forEach(function (sch) {
		                if (!sch.type) { sch.type = schema.type; }
		            });
		        }
		        // end issue #36
		        if (schema.enum === undefined &&
		            schema.type === undefined &&
		            schema.anyOf === undefined &&
		            schema.oneOf === undefined &&
		            schema.not === undefined &&
		            schema.$ref === undefined) {
		            report.addError("KEYWORD_UNDEFINED_STRICT", ["type"]);
		        }
		    }

		    var keys = Object.keys(schema),
		        idx = keys.length;
		    while (idx--) {
		        var key = keys[idx];
		        if (key.indexOf("__") === 0) { continue; }
		        if (SchemaValidators[key] !== undefined) {
		            SchemaValidators[key].call(this, report, schema);
		        } else if (!hasParentSchema) {
		            if (this.options.noExtraKeywords === true) {
		                report.addError("KEYWORD_UNEXPECTED", [key]);
		            }
		        }
		    }

		    if (this.options.pedanticCheck === true) {
		        if (schema.enum) {
		            // break recursion
		            var tmpSchema = Utils.clone(schema);
		            delete tmpSchema.enum;
		            delete tmpSchema.default;

		            report.path.push("enum");
		            idx = schema.enum.length;
		            while (idx--) {
		                report.path.push(idx.toString());
		                JsonValidation.validate.call(this, report, tmpSchema, schema.enum[idx]);
		                report.path.pop();
		            }
		            report.path.pop();
		        }

		        if (schema.default) {
		            report.path.push("default");
		            JsonValidation.validate.call(this, report, schema, schema.default);
		            report.path.pop();
		        }
		    }

		    var isValid = report.isValid();
		    if (isValid) {
		        schema.__$validated = true;
		    }
		    return isValid;
		};
	} (SchemaValidation$1));

	var hasRequiredSchemaCache;

	function requireSchemaCache () {
		if (hasRequiredSchemaCache) return SchemaCache$1;
		hasRequiredSchemaCache = 1;
		(function (exports) {

			var isequal             = lodash_isequalExports;
			var Report              = Report_1;
			var SchemaCompilation   = requireSchemaCompilation();
			var SchemaValidation    = SchemaValidation$1;
			var Utils               = Utils$2;

			function decodeJSONPointer(str) {
			    // http://tools.ietf.org/html/draft-ietf-appsawg-json-pointer-07#section-3
			    return decodeURIComponent(str).replace(/~[0-1]/g, function (x) {
			        return x === "~1" ? "/" : "~";
			    });
			}

			function getRemotePath(uri) {
			    var io = uri.indexOf("#");
			    return io === -1 ? uri : uri.slice(0, io);
			}

			function getQueryPath(uri) {
			    var io = uri.indexOf("#");
			    var res = io === -1 ? undefined : uri.slice(io + 1);
			    // WARN: do not slice slash, #/ means take root and go down from it
			    // if (res && res[0] === "/") { res = res.slice(1); }
			    return res;
			}

			function findId(schema, id) {
			    // process only arrays and objects
			    if (typeof schema !== "object" || schema === null) {
			        return;
			    }

			    // no id means root so return itself
			    if (!id) {
			        return schema;
			    }

			    if (schema.id) {
			        if (schema.id === id || schema.id[0] === "#" && schema.id.substring(1) === id) {
			            return schema;
			        }
			    }

			    var idx, result;
			    if (Array.isArray(schema)) {
			        idx = schema.length;
			        while (idx--) {
			            result = findId(schema[idx], id);
			            if (result) { return result; }
			        }
			    } else {
			        var keys = Object.keys(schema);
			        idx = keys.length;
			        while (idx--) {
			            var k = keys[idx];
			            if (k.indexOf("__$") === 0) {
			                continue;
			            }
			            result = findId(schema[k], id);
			            if (result) { return result; }
			        }
			    }
			}

			/**
			 *
			 * @param {*} uri
			 * @param {*} schema
			 *
			 * @returns {void}
			 */
			exports.cacheSchemaByUri = function (uri, schema) {
			    var remotePath = getRemotePath(uri);
			    if (remotePath) {
			        this.cache[remotePath] = schema;
			    }
			};

			/**
			 *
			 * @param {*} uri
			 *
			 * @returns {void}
			 */
			exports.removeFromCacheByUri = function (uri) {
			    var remotePath = getRemotePath(uri);
			    if (remotePath) {
			        delete this.cache[remotePath];
			    }
			};

			/**
			 *
			 * @param {*} uri
			 *
			 * @returns {boolean}
			 */
			exports.checkCacheForUri = function (uri) {
			    var remotePath = getRemotePath(uri);
			    return remotePath ? this.cache[remotePath] != null : false;
			};

			exports.getSchema = function (report, schema) {
			    if (typeof schema === "object") {
			        schema = exports.getSchemaByReference.call(this, report, schema);
			    }
			    if (typeof schema === "string") {
			        schema = exports.getSchemaByUri.call(this, report, schema);
			    }
			    return schema;
			};

			exports.getSchemaByReference = function (report, key) {
			    var i = this.referenceCache.length;
			    while (i--) {
			        if (isequal(this.referenceCache[i][0], key)) {
			            return this.referenceCache[i][1];
			        }
			    }
			    // not found
			    var schema = Utils.cloneDeep(key);
			    this.referenceCache.push([key, schema]);
			    return schema;
			};

			exports.getSchemaByUri = function (report, uri, root) {
			    var remotePath = getRemotePath(uri),
			        queryPath = getQueryPath(uri),
			        result = remotePath ? this.cache[remotePath] : root;

			    if (result && remotePath) {
			        // we need to avoid compiling schemas in a recursive loop
			        var compileRemote = result !== root;
			        // now we need to compile and validate resolved schema (in case it's not already)
			        if (compileRemote) {

			            report.path.push(remotePath);

			            var remoteReport;

			            var anscestorReport = report.getAncestor(result.id);
			            if (anscestorReport) {
			                remoteReport = anscestorReport;
			            } else {
			                remoteReport = new Report(report);
			                if (SchemaCompilation.compileSchema.call(this, remoteReport, result)) {
			                    var savedOptions = this.options;
			                    try {
			                        // If custom validationOptions were provided to setRemoteReference(),
			                        // use them instead of the default options
			                        this.options = result.__$validationOptions || this.options;
			                        SchemaValidation.validateSchema.call(this, remoteReport, result);
			                    } finally {
			                        this.options = savedOptions;
			                    }
			                }
			            }
			            var remoteReportIsValid = remoteReport.isValid();
			            if (!remoteReportIsValid) {
			                report.addError("REMOTE_NOT_VALID", [uri], remoteReport);
			            }

			            report.path.pop();

			            if (!remoteReportIsValid) {
			                return undefined;
			            }
			        }
			    }

			    if (result && queryPath) {
			        var parts = queryPath.split("/");
			        for (var idx = 0, lim = parts.length; result && idx < lim; idx++) {
			            var key = decodeJSONPointer(parts[idx]);
			            if (idx === 0) { // it's an id
			                result = findId(result, key);
			            } else { // it's a path behind id
			                result = result[key];
			            }
			        }
			    }

			    return result;
			};

			exports.getRemotePath = getRemotePath;
	} (SchemaCache$1));
		return SchemaCache$1;
	}

	var id$4 = "http://json-schema.org/draft-04/schema#";
	var $schema$5 = "http://json-schema.org/draft-04/schema#";
	var description$1 = "Core schema meta-schema";
	var definitions$4 = {
		schemaArray: {
			type: "array",
			minItems: 1,
			items: {
				$ref: "#"
			}
		},
		positiveInteger: {
			type: "integer",
			minimum: 0
		},
		positiveIntegerDefault0: {
			allOf: [
				{
					$ref: "#/definitions/positiveInteger"
				},
				{
					"default": 0
				}
			]
		},
		simpleTypes: {
			"enum": [
				"array",
				"boolean",
				"integer",
				"null",
				"number",
				"object",
				"string"
			]
		},
		stringArray: {
			type: "array",
			items: {
				type: "string"
			},
			minItems: 1,
			uniqueItems: true
		}
	};
	var type$5 = "object";
	var properties$5 = {
		id: {
			type: "string",
			format: "uri"
		},
		$schema: {
			type: "string",
			format: "uri"
		},
		title: {
			type: "string"
		},
		description: {
			type: "string"
		},
		"default": {
		},
		multipleOf: {
			type: "number",
			minimum: 0,
			exclusiveMinimum: true
		},
		maximum: {
			type: "number"
		},
		exclusiveMaximum: {
			type: "boolean",
			"default": false
		},
		minimum: {
			type: "number"
		},
		exclusiveMinimum: {
			type: "boolean",
			"default": false
		},
		maxLength: {
			$ref: "#/definitions/positiveInteger"
		},
		minLength: {
			$ref: "#/definitions/positiveIntegerDefault0"
		},
		pattern: {
			type: "string",
			format: "regex"
		},
		additionalItems: {
			anyOf: [
				{
					type: "boolean"
				},
				{
					$ref: "#"
				}
			],
			"default": {
			}
		},
		items: {
			anyOf: [
				{
					$ref: "#"
				},
				{
					$ref: "#/definitions/schemaArray"
				}
			],
			"default": {
			}
		},
		maxItems: {
			$ref: "#/definitions/positiveInteger"
		},
		minItems: {
			$ref: "#/definitions/positiveIntegerDefault0"
		},
		uniqueItems: {
			type: "boolean",
			"default": false
		},
		maxProperties: {
			$ref: "#/definitions/positiveInteger"
		},
		minProperties: {
			$ref: "#/definitions/positiveIntegerDefault0"
		},
		required: {
			$ref: "#/definitions/stringArray"
		},
		additionalProperties: {
			anyOf: [
				{
					type: "boolean"
				},
				{
					$ref: "#"
				}
			],
			"default": {
			}
		},
		definitions: {
			type: "object",
			additionalProperties: {
				$ref: "#"
			},
			"default": {
			}
		},
		properties: {
			type: "object",
			additionalProperties: {
				$ref: "#"
			},
			"default": {
			}
		},
		patternProperties: {
			type: "object",
			additionalProperties: {
				$ref: "#"
			},
			"default": {
			}
		},
		dependencies: {
			type: "object",
			additionalProperties: {
				anyOf: [
					{
						$ref: "#"
					},
					{
						$ref: "#/definitions/stringArray"
					}
				]
			}
		},
		"enum": {
			type: "array",
			minItems: 1,
			uniqueItems: true
		},
		type: {
			anyOf: [
				{
					$ref: "#/definitions/simpleTypes"
				},
				{
					type: "array",
					items: {
						$ref: "#/definitions/simpleTypes"
					},
					minItems: 1,
					uniqueItems: true
				}
			]
		},
		format: {
			type: "string"
		},
		allOf: {
			$ref: "#/definitions/schemaArray"
		},
		anyOf: {
			$ref: "#/definitions/schemaArray"
		},
		oneOf: {
			$ref: "#/definitions/schemaArray"
		},
		not: {
			$ref: "#"
		}
	};
	var dependencies = {
		exclusiveMaximum: [
			"maximum"
		],
		exclusiveMinimum: [
			"minimum"
		]
	};
	var require$$9 = {
		id: id$4,
		$schema: $schema$5,
		description: description$1,
		definitions: definitions$4,
		type: type$5,
		properties: properties$5,
		dependencies: dependencies,
		"default": {
	}
	};

	var $schema$4 = "http://json-schema.org/draft-04/hyper-schema#";
	var id$3 = "http://json-schema.org/draft-04/hyper-schema#";
	var title$1 = "JSON Hyper-Schema";
	var allOf = [
		{
			$ref: "http://json-schema.org/draft-04/schema#"
		}
	];
	var properties$4 = {
		additionalItems: {
			anyOf: [
				{
					type: "boolean"
				},
				{
					$ref: "#"
				}
			]
		},
		additionalProperties: {
			anyOf: [
				{
					type: "boolean"
				},
				{
					$ref: "#"
				}
			]
		},
		dependencies: {
			additionalProperties: {
				anyOf: [
					{
						$ref: "#"
					},
					{
						type: "array"
					}
				]
			}
		},
		items: {
			anyOf: [
				{
					$ref: "#"
				},
				{
					$ref: "#/definitions/schemaArray"
				}
			]
		},
		definitions: {
			additionalProperties: {
				$ref: "#"
			}
		},
		patternProperties: {
			additionalProperties: {
				$ref: "#"
			}
		},
		properties: {
			additionalProperties: {
				$ref: "#"
			}
		},
		allOf: {
			$ref: "#/definitions/schemaArray"
		},
		anyOf: {
			$ref: "#/definitions/schemaArray"
		},
		oneOf: {
			$ref: "#/definitions/schemaArray"
		},
		not: {
			$ref: "#"
		},
		links: {
			type: "array",
			items: {
				$ref: "#/definitions/linkDescription"
			}
		},
		fragmentResolution: {
			type: "string"
		},
		media: {
			type: "object",
			properties: {
				type: {
					description: "A media type, as described in RFC 2046",
					type: "string"
				},
				binaryEncoding: {
					description: "A content encoding scheme, as described in RFC 2045",
					type: "string"
				}
			}
		},
		pathStart: {
			description: "Instances' URIs must start with this value for this schema to apply to them",
			type: "string",
			format: "uri"
		}
	};
	var definitions$3 = {
		schemaArray: {
			type: "array",
			items: {
				$ref: "#"
			}
		},
		linkDescription: {
			title: "Link Description Object",
			type: "object",
			required: [
				"href",
				"rel"
			],
			properties: {
				href: {
					description: "a URI template, as defined by RFC 6570, with the addition of the $, ( and ) characters for pre-processing",
					type: "string"
				},
				rel: {
					description: "relation to the target resource of the link",
					type: "string"
				},
				title: {
					description: "a title for the link",
					type: "string"
				},
				targetSchema: {
					description: "JSON Schema describing the link target",
					$ref: "#"
				},
				mediaType: {
					description: "media type (as defined by RFC 2046) describing the link target",
					type: "string"
				},
				method: {
					description: "method for requesting the target of the link (e.g. for HTTP this might be \"GET\" or \"DELETE\")",
					type: "string"
				},
				encType: {
					description: "The media type in which to submit data along with the request",
					type: "string",
					"default": "application/json"
				},
				schema: {
					description: "Schema describing the data to submit along with the request",
					$ref: "#"
				}
			}
		}
	};
	var require$$10 = {
		$schema: $schema$4,
		id: id$3,
		title: title$1,
		allOf: allOf,
		properties: properties$4,
		definitions: definitions$3
	};

	var get$4               = lodash_get;
	var Report            = Report_1;
	var FormatValidators  = FormatValidators_1;
	var JsonValidation    = JsonValidation$1;
	var SchemaCache       = requireSchemaCache();
	var SchemaCompilation = requireSchemaCompilation();
	var SchemaValidation  = SchemaValidation$1;
	var Utils             = Utils$2;
	var Draft4Schema      = require$$9;
	var Draft4HyperSchema = require$$10;

	/**
	 * default options
	 */
	var defaultOptions$1 = {
	    // default timeout for all async tasks
	    asyncTimeout: 2000,
	    // force additionalProperties and additionalItems to be defined on "object" and "array" types
	    forceAdditional: false,
	    // assume additionalProperties and additionalItems are defined as "false" where appropriate
	    assumeAdditional: false,
	    // do case insensitive comparison for enums
	    enumCaseInsensitiveComparison: false,
	    // force items to be defined on "array" types
	    forceItems: false,
	    // force minItems to be defined on "array" types
	    forceMinItems: false,
	    // force maxItems to be defined on "array" types
	    forceMaxItems: false,
	    // force minLength to be defined on "string" types
	    forceMinLength: false,
	    // force maxLength to be defined on "string" types
	    forceMaxLength: false,
	    // force properties or patternProperties to be defined on "object" types
	    forceProperties: false,
	    // ignore references that cannot be resolved (remote schemas) // TODO: make sure this is only for remote schemas, not local ones
	    ignoreUnresolvableReferences: false,
	    // disallow usage of keywords that this validator can't handle
	    noExtraKeywords: false,
	    // disallow usage of schema's without "type" defined
	    noTypeless: false,
	    // disallow zero length strings in validated objects
	    noEmptyStrings: false,
	    // disallow zero length arrays in validated objects
	    noEmptyArrays: false,
	    // forces "uri" format to be in fully rfc3986 compliant
	    strictUris: false,
	    // turn on some of the above
	    strictMode: false,
	    // report error paths as an array of path segments to get to the offending node
	    reportPathAsArray: false,
	    // stop validation as soon as an error is found
	    breakOnFirstError: false,
	    // check if schema follows best practices and common sense
	    pedanticCheck: false,
	    // ignore unknown formats (do not report them as an error)
	    ignoreUnknownFormats: false,
	    // function to be called on every schema
	    customValidator: null
	};

	function normalizeOptions(options) {
	    var normalized;

	    // options
	    if (typeof options === "object") {
	        var keys = Object.keys(options),
	            idx = keys.length,
	            key;

	        // check that the options are correctly configured
	        while (idx--) {
	            key = keys[idx];
	            if (defaultOptions$1[key] === undefined) {
	                throw new Error("Unexpected option passed to constructor: " + key);
	            }
	        }

	        // copy the default options into passed options
	        keys = Object.keys(defaultOptions$1);
	        idx = keys.length;
	        while (idx--) {
	            key = keys[idx];
	            if (options[key] === undefined) {
	                options[key] = Utils.clone(defaultOptions$1[key]);
	            }
	        }

	        normalized = options;
	    } else {
	        normalized = Utils.clone(defaultOptions$1);
	    }

	    if (normalized.strictMode === true) {
	        normalized.forceAdditional  = true;
	        normalized.forceItems       = true;
	        normalized.forceMaxLength   = true;
	        normalized.forceProperties  = true;
	        normalized.noExtraKeywords  = true;
	        normalized.noTypeless       = true;
	        normalized.noEmptyStrings   = true;
	        normalized.noEmptyArrays    = true;
	    }

	    return normalized;
	}

	/**
	 * @class
	 *
	 * @param {*} [options]
	 */
	function ZSchema$1(options) {
	    this.cache = {};
	    this.referenceCache = [];
	    this.validateOptions = {};

	    this.options = normalizeOptions(options);

	    // Disable strict validation for the built-in schemas
	    var metaschemaOptions = normalizeOptions({ });

	    this.setRemoteReference("http://json-schema.org/draft-04/schema", Draft4Schema, metaschemaOptions);
	    this.setRemoteReference("http://json-schema.org/draft-04/hyper-schema", Draft4HyperSchema, metaschemaOptions);
	}

	/**
	 * instance methods
	 *
	 * @param {*} schema
	 *
	 * @returns {boolean}
	 */
	ZSchema$1.prototype.compileSchema = function (schema) {
	    var report = new Report(this.options);

	    schema = SchemaCache.getSchema.call(this, report, schema);

	    SchemaCompilation.compileSchema.call(this, report, schema);

	    this.lastReport = report;
	    return report.isValid();
	};

	/**
	 *
	 * @param {*} schema
	 *
	 * @returns {boolean}
	 */
	ZSchema$1.prototype.validateSchema = function (schema) {
	    if (Array.isArray(schema) && schema.length === 0) {
	        throw new Error(".validateSchema was called with an empty array");
	    }

	    var report = new Report(this.options);

	    schema = SchemaCache.getSchema.call(this, report, schema);

	    var compiled = SchemaCompilation.compileSchema.call(this, report, schema);
	    if (compiled) { SchemaValidation.validateSchema.call(this, report, schema); }

	    this.lastReport = report;
	    return report.isValid();
	};

	/**
	 *
	 * @param {*} json
	 * @param {*} schema
	 * @param {*} [options]
	 * @param {function(*, *)} [callback]
	 *
	 * @returns {boolean}
	 */
	ZSchema$1.prototype.validate = function (json, schema, options, callback) {

	    if (Utils.whatIs(options) === "function") {
	        callback = options;
	        options = {};
	    }
	    if (!options) { options = {}; }

	    this.validateOptions = options;

	    var whatIs = Utils.whatIs(schema);
	    if (whatIs !== "string" && whatIs !== "object") {
	        var e = new Error("Invalid .validate call - schema must be a string or object but " + whatIs + " was passed!");
	        if (callback) {
	            browser$1.nextTick(function () {
	                callback(e, false);
	            });
	            return;
	        }
	        throw e;
	    }

	    var foundError = false;
	    var report = new Report(this.options);
	    report.json = json;

	    if (typeof schema === "string") {
	        var schemaName = schema;
	        schema = SchemaCache.getSchema.call(this, report, schemaName);
	        if (!schema) {
	            throw new Error("Schema with id '" + schemaName + "' wasn't found in the validator cache!");
	        }
	    } else {
	        schema = SchemaCache.getSchema.call(this, report, schema);
	    }

	    var compiled = false;
	    if (!foundError) {
	        compiled = SchemaCompilation.compileSchema.call(this, report, schema);
	    }
	    if (!compiled) {
	        this.lastReport = report;
	        foundError = true;
	    }

	    var validated = false;
	    if (!foundError) {
	        validated = SchemaValidation.validateSchema.call(this, report, schema);
	    }
	    if (!validated) {
	        this.lastReport = report;
	        foundError = true;
	    }

	    if (options.schemaPath) {
	        report.rootSchema = schema;
	        schema = get$4(schema, options.schemaPath);
	        if (!schema) {
	            throw new Error("Schema path '" + options.schemaPath + "' wasn't found in the schema!");
	        }
	    }

	    if (!foundError) {
	        JsonValidation.validate.call(this, report, schema, json);
	    }

	    if (callback) {
	        report.processAsyncTasks(this.options.asyncTimeout, callback);
	        return;
	    } else if (report.asyncTasks.length > 0) {
	        throw new Error("This validation has async tasks and cannot be done in sync mode, please provide callback argument.");
	    }

	    // assign lastReport so errors are retrievable in sync mode
	    this.lastReport = report;
	    return report.isValid();
	};
	ZSchema$1.prototype.getLastError = function () {
	    if (this.lastReport.errors.length === 0) {
	        return null;
	    }
	    var e = new Error();
	    e.name = "z-schema validation error";
	    e.message = this.lastReport.commonErrorMessage;
	    e.details = this.lastReport.errors;
	    return e;
	};
	ZSchema$1.prototype.getLastErrors = function () {
	    return this.lastReport && this.lastReport.errors.length > 0 ? this.lastReport.errors : null;
	};
	ZSchema$1.prototype.getMissingReferences = function (arr) {
	    arr = arr || this.lastReport.errors;
	    var res = [],
	        idx = arr.length;
	    while (idx--) {
	        var error = arr[idx];
	        if (error.code === "UNRESOLVABLE_REFERENCE") {
	            var reference = error.params[0];
	            if (res.indexOf(reference) === -1) {
	                res.push(reference);
	            }
	        }
	        if (error.inner) {
	            res = res.concat(this.getMissingReferences(error.inner));
	        }
	    }
	    return res;
	};
	ZSchema$1.prototype.getMissingRemoteReferences = function () {
	    var missingReferences = this.getMissingReferences(),
	        missingRemoteReferences = [],
	        idx = missingReferences.length;
	    while (idx--) {
	        var remoteReference = SchemaCache.getRemotePath(missingReferences[idx]);
	        if (remoteReference && missingRemoteReferences.indexOf(remoteReference) === -1) {
	            missingRemoteReferences.push(remoteReference);
	        }
	    }
	    return missingRemoteReferences;
	};
	ZSchema$1.prototype.setRemoteReference = function (uri, schema, validationOptions) {
	    if (typeof schema === "string") {
	        schema = JSON.parse(schema);
	    } else {
	        schema = Utils.cloneDeep(schema);
	    }

	    if (validationOptions) {
	        schema.__$validationOptions = normalizeOptions(validationOptions);
	    }

	    SchemaCache.cacheSchemaByUri.call(this, uri, schema);
	};
	ZSchema$1.prototype.getResolvedSchema = function (schema) {
	    var report = new Report(this.options);
	    schema = SchemaCache.getSchema.call(this, report, schema);

	    // clone before making any modifications
	    schema = Utils.cloneDeep(schema);

	    var visited = [];

	    // clean-up the schema and resolve references
	    var cleanup = function (schema) {
	        var key,
	            typeOf = Utils.whatIs(schema);
	        if (typeOf !== "object" && typeOf !== "array") {
	            return;
	        }

	        if (schema.___$visited) {
	            return;
	        }

	        schema.___$visited = true;
	        visited.push(schema);

	        if (schema.$ref && schema.__$refResolved) {
	            var from = schema.__$refResolved;
	            var to = schema;
	            delete schema.$ref;
	            delete schema.__$refResolved;
	            for (key in from) {
	                if (from.hasOwnProperty(key)) {
	                    to[key] = from[key];
	                }
	            }
	        }
	        for (key in schema) {
	            if (schema.hasOwnProperty(key)) {
	                if (key.indexOf("__$") === 0) {
	                    delete schema[key];
	                } else {
	                    cleanup(schema[key]);
	                }
	            }
	        }
	    };

	    cleanup(schema);
	    visited.forEach(function (s) {
	        delete s.___$visited;
	    });

	    this.lastReport = report;
	    if (report.isValid()) {
	        return schema;
	    } else {
	        throw this.getLastError();
	    }
	};

	/**
	 *
	 * @param {*} schemaReader
	 *
	 * @returns {void}
	 */
	ZSchema$1.prototype.setSchemaReader = function (schemaReader) {
	    return ZSchema$1.setSchemaReader(schemaReader);
	};

	ZSchema$1.prototype.getSchemaReader = function () {
	    return ZSchema$1.schemaReader;
	};

	ZSchema$1.schemaReader = undefined;
	/*
	    static methods
	*/
	ZSchema$1.setSchemaReader = function (schemaReader) {
	    ZSchema$1.schemaReader = schemaReader;
	};
	ZSchema$1.registerFormat = function (formatName, validatorFunction) {
	    FormatValidators[formatName] = validatorFunction;
	};
	ZSchema$1.unregisterFormat = function (formatName) {
	    delete FormatValidators[formatName];
	};
	ZSchema$1.getRegisteredFormats = function () {
	    return Object.keys(FormatValidators);
	};
	ZSchema$1.getDefaultOptions = function () {
	    return Utils.cloneDeep(defaultOptions$1);
	};

	ZSchema$1.schemaSymbol = Utils.schemaSymbol;

	ZSchema$1.jsonSymbol = Utils.jsonSymbol;

	var ZSchema_1 = ZSchema$1;

	var libExports$1 = {};
	var lib$3 = {
	  get exports(){ return libExports$1; },
	  set exports(v){ libExports$1 = v; },
	};

	var id$2 = "https://raw.githubusercontent.com/OAI/OpenAPI-Specification/master/schemas/v1.2/apiDeclaration.json#";
	var $schema$3 = "http://json-schema.org/draft-04/schema#";
	var type$4 = "object";
	var required$3 = [
		"swaggerVersion",
		"basePath",
		"apis"
	];
	var properties$3 = {
		swaggerVersion: {
			"enum": [
				"1.2"
			]
		},
		apiVersion: {
			type: "string"
		},
		basePath: {
			type: "string",
			format: "uri",
			pattern: "^https?://"
		},
		resourcePath: {
			type: "string",
			format: "uri",
			pattern: "^/"
		},
		apis: {
			type: "array",
			items: {
				$ref: "#/definitions/apiObject"
			}
		},
		models: {
			type: "object",
			additionalProperties: {
				$ref: "modelsObject.json#"
			}
		},
		produces: {
			$ref: "#/definitions/mimeTypeArray"
		},
		consumes: {
			$ref: "#/definitions/mimeTypeArray"
		},
		authorizations: {
			$ref: "authorizationObject.json#"
		}
	};
	var additionalProperties$2 = false;
	var definitions$2 = {
		apiObject: {
			type: "object",
			required: [
				"path",
				"operations"
			],
			properties: {
				path: {
					type: "string",
					format: "uri-template",
					pattern: "^/"
				},
				description: {
					type: "string"
				},
				operations: {
					type: "array",
					items: {
						$ref: "operationObject.json#"
					}
				}
			},
			additionalProperties: false
		},
		mimeTypeArray: {
			type: "array",
			items: {
				type: "string",
				format: "mime-type"
			},
			uniqueItems: true
		}
	};
	var require$$0$3 = {
		id: id$2,
		$schema: $schema$3,
		type: type$4,
		required: required$3,
		properties: properties$3,
		additionalProperties: additionalProperties$2,
		definitions: definitions$2
	};

	var title = "A JSON Schema for Swagger 2.0 API.";
	var id$1 = "http://swagger.io/v2/schema.json#";
	var $schema$2 = "http://json-schema.org/draft-04/schema#";
	var type$3 = "object";
	var required$2 = [
		"swagger",
		"info",
		"paths"
	];
	var additionalProperties$1 = false;
	var patternProperties$1 = {
		"^x-": {
			$ref: "#/definitions/vendorExtension"
		}
	};
	var properties$2 = {
		swagger: {
			type: "string",
			"enum": [
				"2.0"
			],
			description: "The Swagger version of this document."
		},
		info: {
			$ref: "#/definitions/info"
		},
		host: {
			type: "string",
			pattern: "^[^{}/ :\\\\]+(?::\\d+)?$",
			description: "The host (name or ip) of the API. Example: 'swagger.io'"
		},
		basePath: {
			type: "string",
			pattern: "^/",
			description: "The base path to the API. Example: '/api'."
		},
		schemes: {
			$ref: "#/definitions/schemesList"
		},
		consumes: {
			description: "A list of MIME types accepted by the API.",
			allOf: [
				{
					$ref: "#/definitions/mediaTypeList"
				}
			]
		},
		produces: {
			description: "A list of MIME types the API can produce.",
			allOf: [
				{
					$ref: "#/definitions/mediaTypeList"
				}
			]
		},
		paths: {
			$ref: "#/definitions/paths"
		},
		definitions: {
			$ref: "#/definitions/definitions"
		},
		parameters: {
			$ref: "#/definitions/parameterDefinitions"
		},
		responses: {
			$ref: "#/definitions/responseDefinitions"
		},
		security: {
			$ref: "#/definitions/security"
		},
		securityDefinitions: {
			$ref: "#/definitions/securityDefinitions"
		},
		tags: {
			type: "array",
			items: {
				$ref: "#/definitions/tag"
			},
			uniqueItems: true
		},
		externalDocs: {
			$ref: "#/definitions/externalDocs"
		}
	};
	var definitions$1 = {
		info: {
			type: "object",
			description: "General information about the API.",
			required: [
				"version",
				"title"
			],
			additionalProperties: false,
			patternProperties: {
				"^x-": {
					$ref: "#/definitions/vendorExtension"
				}
			},
			properties: {
				title: {
					type: "string",
					description: "A unique and precise title of the API."
				},
				version: {
					type: "string",
					description: "A semantic version number of the API."
				},
				description: {
					type: "string",
					description: "A longer description of the API. Should be different from the title.  GitHub Flavored Markdown is allowed."
				},
				termsOfService: {
					type: "string",
					description: "The terms of service for the API."
				},
				contact: {
					$ref: "#/definitions/contact"
				},
				license: {
					$ref: "#/definitions/license"
				}
			}
		},
		contact: {
			type: "object",
			description: "Contact information for the owners of the API.",
			additionalProperties: false,
			properties: {
				name: {
					type: "string",
					description: "The identifying name of the contact person/organization."
				},
				url: {
					type: "string",
					description: "The URL pointing to the contact information.",
					format: "uri"
				},
				email: {
					type: "string",
					description: "The email address of the contact person/organization.",
					format: "email"
				}
			},
			patternProperties: {
				"^x-": {
					$ref: "#/definitions/vendorExtension"
				}
			}
		},
		license: {
			type: "object",
			required: [
				"name"
			],
			additionalProperties: false,
			properties: {
				name: {
					type: "string",
					description: "The name of the license type. It's encouraged to use an OSI compatible license."
				},
				url: {
					type: "string",
					description: "The URL pointing to the license.",
					format: "uri"
				}
			},
			patternProperties: {
				"^x-": {
					$ref: "#/definitions/vendorExtension"
				}
			}
		},
		paths: {
			type: "object",
			description: "Relative paths to the individual endpoints. They must be relative to the 'basePath'.",
			patternProperties: {
				"^x-": {
					$ref: "#/definitions/vendorExtension"
				},
				"^/": {
					$ref: "#/definitions/pathItem"
				}
			},
			additionalProperties: false
		},
		definitions: {
			type: "object",
			additionalProperties: {
				$ref: "#/definitions/schema"
			},
			description: "One or more JSON objects describing the schemas being consumed and produced by the API."
		},
		parameterDefinitions: {
			type: "object",
			additionalProperties: {
				$ref: "#/definitions/parameter"
			},
			description: "One or more JSON representations for parameters"
		},
		responseDefinitions: {
			type: "object",
			additionalProperties: {
				$ref: "#/definitions/response"
			},
			description: "One or more JSON representations for responses"
		},
		externalDocs: {
			type: "object",
			additionalProperties: false,
			description: "information about external documentation",
			required: [
				"url"
			],
			properties: {
				description: {
					type: "string"
				},
				url: {
					type: "string",
					format: "uri"
				}
			},
			patternProperties: {
				"^x-": {
					$ref: "#/definitions/vendorExtension"
				}
			}
		},
		examples: {
			type: "object",
			additionalProperties: true
		},
		mimeType: {
			type: "string",
			description: "The MIME type of the HTTP message."
		},
		operation: {
			type: "object",
			required: [
				"responses"
			],
			additionalProperties: false,
			patternProperties: {
				"^x-": {
					$ref: "#/definitions/vendorExtension"
				}
			},
			properties: {
				tags: {
					type: "array",
					items: {
						type: "string"
					},
					uniqueItems: true
				},
				summary: {
					type: "string",
					description: "A brief summary of the operation."
				},
				description: {
					type: "string",
					description: "A longer description of the operation, GitHub Flavored Markdown is allowed."
				},
				externalDocs: {
					$ref: "#/definitions/externalDocs"
				},
				operationId: {
					type: "string",
					description: "A unique identifier of the operation."
				},
				produces: {
					description: "A list of MIME types the API can produce.",
					allOf: [
						{
							$ref: "#/definitions/mediaTypeList"
						}
					]
				},
				consumes: {
					description: "A list of MIME types the API can consume.",
					allOf: [
						{
							$ref: "#/definitions/mediaTypeList"
						}
					]
				},
				parameters: {
					$ref: "#/definitions/parametersList"
				},
				responses: {
					$ref: "#/definitions/responses"
				},
				schemes: {
					$ref: "#/definitions/schemesList"
				},
				deprecated: {
					type: "boolean",
					"default": false
				},
				security: {
					$ref: "#/definitions/security"
				}
			}
		},
		pathItem: {
			type: "object",
			additionalProperties: false,
			patternProperties: {
				"^x-": {
					$ref: "#/definitions/vendorExtension"
				}
			},
			properties: {
				$ref: {
					type: "string"
				},
				get: {
					$ref: "#/definitions/operation"
				},
				put: {
					$ref: "#/definitions/operation"
				},
				post: {
					$ref: "#/definitions/operation"
				},
				"delete": {
					$ref: "#/definitions/operation"
				},
				options: {
					$ref: "#/definitions/operation"
				},
				head: {
					$ref: "#/definitions/operation"
				},
				patch: {
					$ref: "#/definitions/operation"
				},
				parameters: {
					$ref: "#/definitions/parametersList"
				}
			}
		},
		responses: {
			type: "object",
			description: "Response objects names can either be any valid HTTP status code or 'default'.",
			minProperties: 1,
			additionalProperties: false,
			patternProperties: {
				"^([0-9]{3})$|^(default)$": {
					$ref: "#/definitions/responseValue"
				},
				"^x-": {
					$ref: "#/definitions/vendorExtension"
				}
			},
			not: {
				type: "object",
				additionalProperties: false,
				patternProperties: {
					"^x-": {
						$ref: "#/definitions/vendorExtension"
					}
				}
			}
		},
		responseValue: {
			oneOf: [
				{
					$ref: "#/definitions/response"
				},
				{
					$ref: "#/definitions/jsonReference"
				}
			]
		},
		response: {
			type: "object",
			required: [
				"description"
			],
			properties: {
				description: {
					type: "string"
				},
				schema: {
					oneOf: [
						{
							$ref: "#/definitions/schema"
						},
						{
							$ref: "#/definitions/fileSchema"
						}
					]
				},
				headers: {
					$ref: "#/definitions/headers"
				},
				examples: {
					$ref: "#/definitions/examples"
				}
			},
			additionalProperties: false,
			patternProperties: {
				"^x-": {
					$ref: "#/definitions/vendorExtension"
				}
			}
		},
		headers: {
			type: "object",
			additionalProperties: {
				$ref: "#/definitions/header"
			}
		},
		header: {
			type: "object",
			additionalProperties: false,
			required: [
				"type"
			],
			properties: {
				type: {
					type: "string",
					"enum": [
						"string",
						"number",
						"integer",
						"boolean",
						"array"
					]
				},
				format: {
					type: "string"
				},
				items: {
					$ref: "#/definitions/primitivesItems"
				},
				collectionFormat: {
					$ref: "#/definitions/collectionFormat"
				},
				"default": {
					$ref: "#/definitions/default"
				},
				maximum: {
					$ref: "#/definitions/maximum"
				},
				exclusiveMaximum: {
					$ref: "#/definitions/exclusiveMaximum"
				},
				minimum: {
					$ref: "#/definitions/minimum"
				},
				exclusiveMinimum: {
					$ref: "#/definitions/exclusiveMinimum"
				},
				maxLength: {
					$ref: "#/definitions/maxLength"
				},
				minLength: {
					$ref: "#/definitions/minLength"
				},
				pattern: {
					$ref: "#/definitions/pattern"
				},
				maxItems: {
					$ref: "#/definitions/maxItems"
				},
				minItems: {
					$ref: "#/definitions/minItems"
				},
				uniqueItems: {
					$ref: "#/definitions/uniqueItems"
				},
				"enum": {
					$ref: "#/definitions/enum"
				},
				multipleOf: {
					$ref: "#/definitions/multipleOf"
				},
				description: {
					type: "string"
				}
			},
			patternProperties: {
				"^x-": {
					$ref: "#/definitions/vendorExtension"
				}
			}
		},
		vendorExtension: {
			description: "Any property starting with x- is valid.",
			additionalProperties: true,
			additionalItems: true
		},
		bodyParameter: {
			type: "object",
			required: [
				"name",
				"in",
				"schema"
			],
			patternProperties: {
				"^x-": {
					$ref: "#/definitions/vendorExtension"
				}
			},
			properties: {
				description: {
					type: "string",
					description: "A brief description of the parameter. This could contain examples of use.  GitHub Flavored Markdown is allowed."
				},
				name: {
					type: "string",
					description: "The name of the parameter."
				},
				"in": {
					type: "string",
					description: "Determines the location of the parameter.",
					"enum": [
						"body"
					]
				},
				required: {
					type: "boolean",
					description: "Determines whether or not this parameter is required or optional.",
					"default": false
				},
				schema: {
					$ref: "#/definitions/schema"
				}
			},
			additionalProperties: false
		},
		headerParameterSubSchema: {
			additionalProperties: false,
			patternProperties: {
				"^x-": {
					$ref: "#/definitions/vendorExtension"
				}
			},
			properties: {
				required: {
					type: "boolean",
					description: "Determines whether or not this parameter is required or optional.",
					"default": false
				},
				"in": {
					type: "string",
					description: "Determines the location of the parameter.",
					"enum": [
						"header"
					]
				},
				description: {
					type: "string",
					description: "A brief description of the parameter. This could contain examples of use.  GitHub Flavored Markdown is allowed."
				},
				name: {
					type: "string",
					description: "The name of the parameter."
				},
				type: {
					type: "string",
					"enum": [
						"string",
						"number",
						"boolean",
						"integer",
						"array"
					]
				},
				format: {
					type: "string"
				},
				items: {
					$ref: "#/definitions/primitivesItems"
				},
				collectionFormat: {
					$ref: "#/definitions/collectionFormat"
				},
				"default": {
					$ref: "#/definitions/default"
				},
				maximum: {
					$ref: "#/definitions/maximum"
				},
				exclusiveMaximum: {
					$ref: "#/definitions/exclusiveMaximum"
				},
				minimum: {
					$ref: "#/definitions/minimum"
				},
				exclusiveMinimum: {
					$ref: "#/definitions/exclusiveMinimum"
				},
				maxLength: {
					$ref: "#/definitions/maxLength"
				},
				minLength: {
					$ref: "#/definitions/minLength"
				},
				pattern: {
					$ref: "#/definitions/pattern"
				},
				maxItems: {
					$ref: "#/definitions/maxItems"
				},
				minItems: {
					$ref: "#/definitions/minItems"
				},
				uniqueItems: {
					$ref: "#/definitions/uniqueItems"
				},
				"enum": {
					$ref: "#/definitions/enum"
				},
				multipleOf: {
					$ref: "#/definitions/multipleOf"
				}
			}
		},
		queryParameterSubSchema: {
			additionalProperties: false,
			patternProperties: {
				"^x-": {
					$ref: "#/definitions/vendorExtension"
				}
			},
			properties: {
				required: {
					type: "boolean",
					description: "Determines whether or not this parameter is required or optional.",
					"default": false
				},
				"in": {
					type: "string",
					description: "Determines the location of the parameter.",
					"enum": [
						"query"
					]
				},
				description: {
					type: "string",
					description: "A brief description of the parameter. This could contain examples of use.  GitHub Flavored Markdown is allowed."
				},
				name: {
					type: "string",
					description: "The name of the parameter."
				},
				allowEmptyValue: {
					type: "boolean",
					"default": false,
					description: "allows sending a parameter by name only or with an empty value."
				},
				type: {
					type: "string",
					"enum": [
						"string",
						"number",
						"boolean",
						"integer",
						"array"
					]
				},
				format: {
					type: "string"
				},
				items: {
					$ref: "#/definitions/primitivesItems"
				},
				collectionFormat: {
					$ref: "#/definitions/collectionFormatWithMulti"
				},
				"default": {
					$ref: "#/definitions/default"
				},
				maximum: {
					$ref: "#/definitions/maximum"
				},
				exclusiveMaximum: {
					$ref: "#/definitions/exclusiveMaximum"
				},
				minimum: {
					$ref: "#/definitions/minimum"
				},
				exclusiveMinimum: {
					$ref: "#/definitions/exclusiveMinimum"
				},
				maxLength: {
					$ref: "#/definitions/maxLength"
				},
				minLength: {
					$ref: "#/definitions/minLength"
				},
				pattern: {
					$ref: "#/definitions/pattern"
				},
				maxItems: {
					$ref: "#/definitions/maxItems"
				},
				minItems: {
					$ref: "#/definitions/minItems"
				},
				uniqueItems: {
					$ref: "#/definitions/uniqueItems"
				},
				"enum": {
					$ref: "#/definitions/enum"
				},
				multipleOf: {
					$ref: "#/definitions/multipleOf"
				}
			}
		},
		formDataParameterSubSchema: {
			additionalProperties: false,
			patternProperties: {
				"^x-": {
					$ref: "#/definitions/vendorExtension"
				}
			},
			properties: {
				required: {
					type: "boolean",
					description: "Determines whether or not this parameter is required or optional.",
					"default": false
				},
				"in": {
					type: "string",
					description: "Determines the location of the parameter.",
					"enum": [
						"formData"
					]
				},
				description: {
					type: "string",
					description: "A brief description of the parameter. This could contain examples of use.  GitHub Flavored Markdown is allowed."
				},
				name: {
					type: "string",
					description: "The name of the parameter."
				},
				allowEmptyValue: {
					type: "boolean",
					"default": false,
					description: "allows sending a parameter by name only or with an empty value."
				},
				type: {
					type: "string",
					"enum": [
						"string",
						"number",
						"boolean",
						"integer",
						"array",
						"file"
					]
				},
				format: {
					type: "string"
				},
				items: {
					$ref: "#/definitions/primitivesItems"
				},
				collectionFormat: {
					$ref: "#/definitions/collectionFormatWithMulti"
				},
				"default": {
					$ref: "#/definitions/default"
				},
				maximum: {
					$ref: "#/definitions/maximum"
				},
				exclusiveMaximum: {
					$ref: "#/definitions/exclusiveMaximum"
				},
				minimum: {
					$ref: "#/definitions/minimum"
				},
				exclusiveMinimum: {
					$ref: "#/definitions/exclusiveMinimum"
				},
				maxLength: {
					$ref: "#/definitions/maxLength"
				},
				minLength: {
					$ref: "#/definitions/minLength"
				},
				pattern: {
					$ref: "#/definitions/pattern"
				},
				maxItems: {
					$ref: "#/definitions/maxItems"
				},
				minItems: {
					$ref: "#/definitions/minItems"
				},
				uniqueItems: {
					$ref: "#/definitions/uniqueItems"
				},
				"enum": {
					$ref: "#/definitions/enum"
				},
				multipleOf: {
					$ref: "#/definitions/multipleOf"
				}
			}
		},
		pathParameterSubSchema: {
			additionalProperties: false,
			patternProperties: {
				"^x-": {
					$ref: "#/definitions/vendorExtension"
				}
			},
			required: [
				"required"
			],
			properties: {
				required: {
					type: "boolean",
					"enum": [
						true
					],
					description: "Determines whether or not this parameter is required or optional."
				},
				"in": {
					type: "string",
					description: "Determines the location of the parameter.",
					"enum": [
						"path"
					]
				},
				description: {
					type: "string",
					description: "A brief description of the parameter. This could contain examples of use.  GitHub Flavored Markdown is allowed."
				},
				name: {
					type: "string",
					description: "The name of the parameter."
				},
				type: {
					type: "string",
					"enum": [
						"string",
						"number",
						"boolean",
						"integer",
						"array"
					]
				},
				format: {
					type: "string"
				},
				items: {
					$ref: "#/definitions/primitivesItems"
				},
				collectionFormat: {
					$ref: "#/definitions/collectionFormat"
				},
				"default": {
					$ref: "#/definitions/default"
				},
				maximum: {
					$ref: "#/definitions/maximum"
				},
				exclusiveMaximum: {
					$ref: "#/definitions/exclusiveMaximum"
				},
				minimum: {
					$ref: "#/definitions/minimum"
				},
				exclusiveMinimum: {
					$ref: "#/definitions/exclusiveMinimum"
				},
				maxLength: {
					$ref: "#/definitions/maxLength"
				},
				minLength: {
					$ref: "#/definitions/minLength"
				},
				pattern: {
					$ref: "#/definitions/pattern"
				},
				maxItems: {
					$ref: "#/definitions/maxItems"
				},
				minItems: {
					$ref: "#/definitions/minItems"
				},
				uniqueItems: {
					$ref: "#/definitions/uniqueItems"
				},
				"enum": {
					$ref: "#/definitions/enum"
				},
				multipleOf: {
					$ref: "#/definitions/multipleOf"
				}
			}
		},
		nonBodyParameter: {
			type: "object",
			required: [
				"name",
				"in",
				"type"
			],
			oneOf: [
				{
					$ref: "#/definitions/headerParameterSubSchema"
				},
				{
					$ref: "#/definitions/formDataParameterSubSchema"
				},
				{
					$ref: "#/definitions/queryParameterSubSchema"
				},
				{
					$ref: "#/definitions/pathParameterSubSchema"
				}
			]
		},
		parameter: {
			oneOf: [
				{
					$ref: "#/definitions/bodyParameter"
				},
				{
					$ref: "#/definitions/nonBodyParameter"
				}
			]
		},
		schema: {
			type: "object",
			description: "A deterministic version of a JSON Schema object.",
			patternProperties: {
				"^x-": {
					$ref: "#/definitions/vendorExtension"
				}
			},
			properties: {
				$ref: {
					type: "string"
				},
				format: {
					type: "string"
				},
				title: {
					$ref: "http://json-schema.org/draft-04/schema#/properties/title"
				},
				description: {
					$ref: "http://json-schema.org/draft-04/schema#/properties/description"
				},
				"default": {
					$ref: "http://json-schema.org/draft-04/schema#/properties/default"
				},
				multipleOf: {
					$ref: "http://json-schema.org/draft-04/schema#/properties/multipleOf"
				},
				maximum: {
					$ref: "http://json-schema.org/draft-04/schema#/properties/maximum"
				},
				exclusiveMaximum: {
					$ref: "http://json-schema.org/draft-04/schema#/properties/exclusiveMaximum"
				},
				minimum: {
					$ref: "http://json-schema.org/draft-04/schema#/properties/minimum"
				},
				exclusiveMinimum: {
					$ref: "http://json-schema.org/draft-04/schema#/properties/exclusiveMinimum"
				},
				maxLength: {
					$ref: "http://json-schema.org/draft-04/schema#/definitions/positiveInteger"
				},
				minLength: {
					$ref: "http://json-schema.org/draft-04/schema#/definitions/positiveIntegerDefault0"
				},
				pattern: {
					$ref: "http://json-schema.org/draft-04/schema#/properties/pattern"
				},
				maxItems: {
					$ref: "http://json-schema.org/draft-04/schema#/definitions/positiveInteger"
				},
				minItems: {
					$ref: "http://json-schema.org/draft-04/schema#/definitions/positiveIntegerDefault0"
				},
				uniqueItems: {
					$ref: "http://json-schema.org/draft-04/schema#/properties/uniqueItems"
				},
				maxProperties: {
					$ref: "http://json-schema.org/draft-04/schema#/definitions/positiveInteger"
				},
				minProperties: {
					$ref: "http://json-schema.org/draft-04/schema#/definitions/positiveIntegerDefault0"
				},
				required: {
					$ref: "http://json-schema.org/draft-04/schema#/definitions/stringArray"
				},
				"enum": {
					$ref: "http://json-schema.org/draft-04/schema#/properties/enum"
				},
				additionalProperties: {
					anyOf: [
						{
							$ref: "#/definitions/schema"
						},
						{
							type: "boolean"
						}
					],
					"default": {
					}
				},
				type: {
					$ref: "http://json-schema.org/draft-04/schema#/properties/type"
				},
				items: {
					anyOf: [
						{
							$ref: "#/definitions/schema"
						},
						{
							type: "array",
							minItems: 1,
							items: {
								$ref: "#/definitions/schema"
							}
						}
					],
					"default": {
					}
				},
				allOf: {
					type: "array",
					minItems: 1,
					items: {
						$ref: "#/definitions/schema"
					}
				},
				properties: {
					type: "object",
					additionalProperties: {
						$ref: "#/definitions/schema"
					},
					"default": {
					}
				},
				discriminator: {
					type: "string"
				},
				readOnly: {
					type: "boolean",
					"default": false
				},
				xml: {
					$ref: "#/definitions/xml"
				},
				externalDocs: {
					$ref: "#/definitions/externalDocs"
				},
				example: {
				}
			},
			additionalProperties: false
		},
		fileSchema: {
			type: "object",
			description: "A deterministic version of a JSON Schema object.",
			patternProperties: {
				"^x-": {
					$ref: "#/definitions/vendorExtension"
				}
			},
			required: [
				"type"
			],
			properties: {
				format: {
					type: "string"
				},
				title: {
					$ref: "http://json-schema.org/draft-04/schema#/properties/title"
				},
				description: {
					$ref: "http://json-schema.org/draft-04/schema#/properties/description"
				},
				"default": {
					$ref: "http://json-schema.org/draft-04/schema#/properties/default"
				},
				required: {
					$ref: "http://json-schema.org/draft-04/schema#/definitions/stringArray"
				},
				type: {
					type: "string",
					"enum": [
						"file"
					]
				},
				readOnly: {
					type: "boolean",
					"default": false
				},
				externalDocs: {
					$ref: "#/definitions/externalDocs"
				},
				example: {
				}
			},
			additionalProperties: false
		},
		primitivesItems: {
			type: "object",
			additionalProperties: false,
			properties: {
				type: {
					type: "string",
					"enum": [
						"string",
						"number",
						"integer",
						"boolean",
						"array"
					]
				},
				format: {
					type: "string"
				},
				items: {
					$ref: "#/definitions/primitivesItems"
				},
				collectionFormat: {
					$ref: "#/definitions/collectionFormat"
				},
				"default": {
					$ref: "#/definitions/default"
				},
				maximum: {
					$ref: "#/definitions/maximum"
				},
				exclusiveMaximum: {
					$ref: "#/definitions/exclusiveMaximum"
				},
				minimum: {
					$ref: "#/definitions/minimum"
				},
				exclusiveMinimum: {
					$ref: "#/definitions/exclusiveMinimum"
				},
				maxLength: {
					$ref: "#/definitions/maxLength"
				},
				minLength: {
					$ref: "#/definitions/minLength"
				},
				pattern: {
					$ref: "#/definitions/pattern"
				},
				maxItems: {
					$ref: "#/definitions/maxItems"
				},
				minItems: {
					$ref: "#/definitions/minItems"
				},
				uniqueItems: {
					$ref: "#/definitions/uniqueItems"
				},
				"enum": {
					$ref: "#/definitions/enum"
				},
				multipleOf: {
					$ref: "#/definitions/multipleOf"
				}
			},
			patternProperties: {
				"^x-": {
					$ref: "#/definitions/vendorExtension"
				}
			}
		},
		security: {
			type: "array",
			items: {
				$ref: "#/definitions/securityRequirement"
			},
			uniqueItems: true
		},
		securityRequirement: {
			type: "object",
			additionalProperties: {
				type: "array",
				items: {
					type: "string"
				},
				uniqueItems: true
			}
		},
		xml: {
			type: "object",
			additionalProperties: false,
			properties: {
				name: {
					type: "string"
				},
				namespace: {
					type: "string"
				},
				prefix: {
					type: "string"
				},
				attribute: {
					type: "boolean",
					"default": false
				},
				wrapped: {
					type: "boolean",
					"default": false
				}
			},
			patternProperties: {
				"^x-": {
					$ref: "#/definitions/vendorExtension"
				}
			}
		},
		tag: {
			type: "object",
			additionalProperties: false,
			required: [
				"name"
			],
			properties: {
				name: {
					type: "string"
				},
				description: {
					type: "string"
				},
				externalDocs: {
					$ref: "#/definitions/externalDocs"
				}
			},
			patternProperties: {
				"^x-": {
					$ref: "#/definitions/vendorExtension"
				}
			}
		},
		securityDefinitions: {
			type: "object",
			additionalProperties: {
				oneOf: [
					{
						$ref: "#/definitions/basicAuthenticationSecurity"
					},
					{
						$ref: "#/definitions/apiKeySecurity"
					},
					{
						$ref: "#/definitions/oauth2ImplicitSecurity"
					},
					{
						$ref: "#/definitions/oauth2PasswordSecurity"
					},
					{
						$ref: "#/definitions/oauth2ApplicationSecurity"
					},
					{
						$ref: "#/definitions/oauth2AccessCodeSecurity"
					}
				]
			}
		},
		basicAuthenticationSecurity: {
			type: "object",
			additionalProperties: false,
			required: [
				"type"
			],
			properties: {
				type: {
					type: "string",
					"enum": [
						"basic"
					]
				},
				description: {
					type: "string"
				}
			},
			patternProperties: {
				"^x-": {
					$ref: "#/definitions/vendorExtension"
				}
			}
		},
		apiKeySecurity: {
			type: "object",
			additionalProperties: false,
			required: [
				"type",
				"name",
				"in"
			],
			properties: {
				type: {
					type: "string",
					"enum": [
						"apiKey"
					]
				},
				name: {
					type: "string"
				},
				"in": {
					type: "string",
					"enum": [
						"header",
						"query"
					]
				},
				description: {
					type: "string"
				}
			},
			patternProperties: {
				"^x-": {
					$ref: "#/definitions/vendorExtension"
				}
			}
		},
		oauth2ImplicitSecurity: {
			type: "object",
			additionalProperties: false,
			required: [
				"type",
				"flow",
				"authorizationUrl"
			],
			properties: {
				type: {
					type: "string",
					"enum": [
						"oauth2"
					]
				},
				flow: {
					type: "string",
					"enum": [
						"implicit"
					]
				},
				scopes: {
					$ref: "#/definitions/oauth2Scopes"
				},
				authorizationUrl: {
					type: "string",
					format: "uri"
				},
				description: {
					type: "string"
				}
			},
			patternProperties: {
				"^x-": {
					$ref: "#/definitions/vendorExtension"
				}
			}
		},
		oauth2PasswordSecurity: {
			type: "object",
			additionalProperties: false,
			required: [
				"type",
				"flow",
				"tokenUrl"
			],
			properties: {
				type: {
					type: "string",
					"enum": [
						"oauth2"
					]
				},
				flow: {
					type: "string",
					"enum": [
						"password"
					]
				},
				scopes: {
					$ref: "#/definitions/oauth2Scopes"
				},
				tokenUrl: {
					type: "string",
					format: "uri"
				},
				description: {
					type: "string"
				}
			},
			patternProperties: {
				"^x-": {
					$ref: "#/definitions/vendorExtension"
				}
			}
		},
		oauth2ApplicationSecurity: {
			type: "object",
			additionalProperties: false,
			required: [
				"type",
				"flow",
				"tokenUrl"
			],
			properties: {
				type: {
					type: "string",
					"enum": [
						"oauth2"
					]
				},
				flow: {
					type: "string",
					"enum": [
						"application"
					]
				},
				scopes: {
					$ref: "#/definitions/oauth2Scopes"
				},
				tokenUrl: {
					type: "string",
					format: "uri"
				},
				description: {
					type: "string"
				}
			},
			patternProperties: {
				"^x-": {
					$ref: "#/definitions/vendorExtension"
				}
			}
		},
		oauth2AccessCodeSecurity: {
			type: "object",
			additionalProperties: false,
			required: [
				"type",
				"flow",
				"authorizationUrl",
				"tokenUrl"
			],
			properties: {
				type: {
					type: "string",
					"enum": [
						"oauth2"
					]
				},
				flow: {
					type: "string",
					"enum": [
						"accessCode"
					]
				},
				scopes: {
					$ref: "#/definitions/oauth2Scopes"
				},
				authorizationUrl: {
					type: "string",
					format: "uri"
				},
				tokenUrl: {
					type: "string",
					format: "uri"
				},
				description: {
					type: "string"
				}
			},
			patternProperties: {
				"^x-": {
					$ref: "#/definitions/vendorExtension"
				}
			}
		},
		oauth2Scopes: {
			type: "object",
			additionalProperties: {
				type: "string"
			}
		},
		mediaTypeList: {
			type: "array",
			items: {
				$ref: "#/definitions/mimeType"
			},
			uniqueItems: true
		},
		parametersList: {
			type: "array",
			description: "The parameters needed to send a valid API call.",
			additionalItems: false,
			items: {
				oneOf: [
					{
						$ref: "#/definitions/parameter"
					},
					{
						$ref: "#/definitions/jsonReference"
					}
				]
			},
			uniqueItems: true
		},
		schemesList: {
			type: "array",
			description: "The transfer protocol of the API.",
			items: {
				type: "string",
				"enum": [
					"http",
					"https",
					"ws",
					"wss"
				]
			},
			uniqueItems: true
		},
		collectionFormat: {
			type: "string",
			"enum": [
				"csv",
				"ssv",
				"tsv",
				"pipes"
			],
			"default": "csv"
		},
		collectionFormatWithMulti: {
			type: "string",
			"enum": [
				"csv",
				"ssv",
				"tsv",
				"pipes",
				"multi"
			],
			"default": "csv"
		},
		title: {
			$ref: "http://json-schema.org/draft-04/schema#/properties/title"
		},
		description: {
			$ref: "http://json-schema.org/draft-04/schema#/properties/description"
		},
		"default": {
			$ref: "http://json-schema.org/draft-04/schema#/properties/default"
		},
		multipleOf: {
			$ref: "http://json-schema.org/draft-04/schema#/properties/multipleOf"
		},
		maximum: {
			$ref: "http://json-schema.org/draft-04/schema#/properties/maximum"
		},
		exclusiveMaximum: {
			$ref: "http://json-schema.org/draft-04/schema#/properties/exclusiveMaximum"
		},
		minimum: {
			$ref: "http://json-schema.org/draft-04/schema#/properties/minimum"
		},
		exclusiveMinimum: {
			$ref: "http://json-schema.org/draft-04/schema#/properties/exclusiveMinimum"
		},
		maxLength: {
			$ref: "http://json-schema.org/draft-04/schema#/definitions/positiveInteger"
		},
		minLength: {
			$ref: "http://json-schema.org/draft-04/schema#/definitions/positiveIntegerDefault0"
		},
		pattern: {
			$ref: "http://json-schema.org/draft-04/schema#/properties/pattern"
		},
		maxItems: {
			$ref: "http://json-schema.org/draft-04/schema#/definitions/positiveInteger"
		},
		minItems: {
			$ref: "http://json-schema.org/draft-04/schema#/definitions/positiveIntegerDefault0"
		},
		uniqueItems: {
			$ref: "http://json-schema.org/draft-04/schema#/properties/uniqueItems"
		},
		"enum": {
			$ref: "http://json-schema.org/draft-04/schema#/properties/enum"
		},
		jsonReference: {
			type: "object",
			required: [
				"$ref"
			],
			additionalProperties: false,
			properties: {
				$ref: {
					type: "string"
				}
			}
		}
	};
	var require$$1$1 = {
		title: title,
		id: id$1,
		$schema: $schema$2,
		type: type$3,
		required: required$2,
		additionalProperties: additionalProperties$1,
		patternProperties: patternProperties$1,
		properties: properties$2,
		definitions: definitions$1
	};

	var id = "https://spec.openapis.org/oas/3.0/schema/2019-04-02";
	var $schema$1 = "http://json-schema.org/draft-04/schema#";
	var description = "Validation schema for OpenAPI Specification 3.0.X.";
	var type$2 = "object";
	var required$1 = [
		"openapi",
		"info",
		"paths"
	];
	var properties$1 = {
		openapi: {
			type: "string",
			pattern: "^3\\.0\\.\\d(-.+)?$"
		},
		info: {
			$ref: "#/definitions/Info"
		},
		externalDocs: {
			$ref: "#/definitions/ExternalDocumentation"
		},
		servers: {
			type: "array",
			items: {
				$ref: "#/definitions/Server"
			}
		},
		security: {
			type: "array",
			items: {
				$ref: "#/definitions/SecurityRequirement"
			}
		},
		tags: {
			type: "array",
			items: {
				$ref: "#/definitions/Tag"
			},
			uniqueItems: true
		},
		paths: {
			$ref: "#/definitions/Paths"
		},
		components: {
			$ref: "#/definitions/Components"
		}
	};
	var patternProperties = {
		"^x-": {
		}
	};
	var additionalProperties = false;
	var definitions = {
		Reference: {
			type: "object",
			required: [
				"$ref"
			],
			patternProperties: {
				"^\\$ref$": {
					type: "string",
					format: "uri-reference"
				}
			}
		},
		Info: {
			type: "object",
			required: [
				"title",
				"version"
			],
			properties: {
				title: {
					type: "string"
				},
				description: {
					type: "string"
				},
				termsOfService: {
					type: "string",
					format: "uri-reference"
				},
				contact: {
					$ref: "#/definitions/Contact"
				},
				license: {
					$ref: "#/definitions/License"
				},
				version: {
					type: "string"
				}
			},
			patternProperties: {
				"^x-": {
				}
			},
			additionalProperties: false
		},
		Contact: {
			type: "object",
			properties: {
				name: {
					type: "string"
				},
				url: {
					type: "string",
					format: "uri-reference"
				},
				email: {
					type: "string",
					format: "email"
				}
			},
			patternProperties: {
				"^x-": {
				}
			},
			additionalProperties: false
		},
		License: {
			type: "object",
			required: [
				"name"
			],
			properties: {
				name: {
					type: "string"
				},
				url: {
					type: "string",
					format: "uri-reference"
				}
			},
			patternProperties: {
				"^x-": {
				}
			},
			additionalProperties: false
		},
		Server: {
			type: "object",
			required: [
				"url"
			],
			properties: {
				url: {
					type: "string"
				},
				description: {
					type: "string"
				},
				variables: {
					type: "object",
					additionalProperties: {
						$ref: "#/definitions/ServerVariable"
					}
				}
			},
			patternProperties: {
				"^x-": {
				}
			},
			additionalProperties: false
		},
		ServerVariable: {
			type: "object",
			required: [
				"default"
			],
			properties: {
				"enum": {
					type: "array",
					items: {
						type: "string"
					}
				},
				"default": {
					type: "string"
				},
				description: {
					type: "string"
				}
			},
			patternProperties: {
				"^x-": {
				}
			},
			additionalProperties: false
		},
		Components: {
			type: "object",
			properties: {
				schemas: {
					type: "object",
					patternProperties: {
						"^[a-zA-Z0-9\\.\\-_]+$": {
							oneOf: [
								{
									$ref: "#/definitions/Schema"
								},
								{
									$ref: "#/definitions/Reference"
								}
							]
						}
					}
				},
				responses: {
					type: "object",
					patternProperties: {
						"^[a-zA-Z0-9\\.\\-_]+$": {
							oneOf: [
								{
									$ref: "#/definitions/Reference"
								},
								{
									$ref: "#/definitions/Response"
								}
							]
						}
					}
				},
				parameters: {
					type: "object",
					patternProperties: {
						"^[a-zA-Z0-9\\.\\-_]+$": {
							oneOf: [
								{
									$ref: "#/definitions/Reference"
								},
								{
									$ref: "#/definitions/Parameter"
								}
							]
						}
					}
				},
				examples: {
					type: "object",
					patternProperties: {
						"^[a-zA-Z0-9\\.\\-_]+$": {
							oneOf: [
								{
									$ref: "#/definitions/Reference"
								},
								{
									$ref: "#/definitions/Example"
								}
							]
						}
					}
				},
				requestBodies: {
					type: "object",
					patternProperties: {
						"^[a-zA-Z0-9\\.\\-_]+$": {
							oneOf: [
								{
									$ref: "#/definitions/Reference"
								},
								{
									$ref: "#/definitions/RequestBody"
								}
							]
						}
					}
				},
				headers: {
					type: "object",
					patternProperties: {
						"^[a-zA-Z0-9\\.\\-_]+$": {
							oneOf: [
								{
									$ref: "#/definitions/Reference"
								},
								{
									$ref: "#/definitions/Header"
								}
							]
						}
					}
				},
				securitySchemes: {
					type: "object",
					patternProperties: {
						"^[a-zA-Z0-9\\.\\-_]+$": {
							oneOf: [
								{
									$ref: "#/definitions/Reference"
								},
								{
									$ref: "#/definitions/SecurityScheme"
								}
							]
						}
					}
				},
				links: {
					type: "object",
					patternProperties: {
						"^[a-zA-Z0-9\\.\\-_]+$": {
							oneOf: [
								{
									$ref: "#/definitions/Reference"
								},
								{
									$ref: "#/definitions/Link"
								}
							]
						}
					}
				},
				callbacks: {
					type: "object",
					patternProperties: {
						"^[a-zA-Z0-9\\.\\-_]+$": {
							oneOf: [
								{
									$ref: "#/definitions/Reference"
								},
								{
									$ref: "#/definitions/Callback"
								}
							]
						}
					}
				}
			},
			patternProperties: {
				"^x-": {
				}
			},
			additionalProperties: false
		},
		Schema: {
			type: "object",
			properties: {
				title: {
					type: "string"
				},
				multipleOf: {
					type: "number",
					minimum: 0,
					exclusiveMinimum: true
				},
				maximum: {
					type: "number"
				},
				exclusiveMaximum: {
					type: "boolean",
					"default": false
				},
				minimum: {
					type: "number"
				},
				exclusiveMinimum: {
					type: "boolean",
					"default": false
				},
				maxLength: {
					type: "integer",
					minimum: 0
				},
				minLength: {
					type: "integer",
					minimum: 0,
					"default": 0
				},
				pattern: {
					type: "string",
					format: "regex"
				},
				maxItems: {
					type: "integer",
					minimum: 0
				},
				minItems: {
					type: "integer",
					minimum: 0,
					"default": 0
				},
				uniqueItems: {
					type: "boolean",
					"default": false
				},
				maxProperties: {
					type: "integer",
					minimum: 0
				},
				minProperties: {
					type: "integer",
					minimum: 0,
					"default": 0
				},
				required: {
					type: "array",
					items: {
						type: "string"
					},
					minItems: 1,
					uniqueItems: true
				},
				"enum": {
					type: "array",
					items: {
					},
					minItems: 1,
					uniqueItems: false
				},
				type: {
					type: "string",
					"enum": [
						"array",
						"boolean",
						"integer",
						"number",
						"object",
						"string"
					]
				},
				not: {
					oneOf: [
						{
							$ref: "#/definitions/Schema"
						},
						{
							$ref: "#/definitions/Reference"
						}
					]
				},
				allOf: {
					type: "array",
					items: {
						oneOf: [
							{
								$ref: "#/definitions/Schema"
							},
							{
								$ref: "#/definitions/Reference"
							}
						]
					}
				},
				oneOf: {
					type: "array",
					items: {
						oneOf: [
							{
								$ref: "#/definitions/Schema"
							},
							{
								$ref: "#/definitions/Reference"
							}
						]
					}
				},
				anyOf: {
					type: "array",
					items: {
						oneOf: [
							{
								$ref: "#/definitions/Schema"
							},
							{
								$ref: "#/definitions/Reference"
							}
						]
					}
				},
				items: {
					oneOf: [
						{
							$ref: "#/definitions/Schema"
						},
						{
							$ref: "#/definitions/Reference"
						}
					]
				},
				properties: {
					type: "object",
					additionalProperties: {
						oneOf: [
							{
								$ref: "#/definitions/Schema"
							},
							{
								$ref: "#/definitions/Reference"
							}
						]
					}
				},
				additionalProperties: {
					oneOf: [
						{
							$ref: "#/definitions/Schema"
						},
						{
							$ref: "#/definitions/Reference"
						},
						{
							type: "boolean"
						}
					],
					"default": true
				},
				description: {
					type: "string"
				},
				format: {
					type: "string"
				},
				"default": {
				},
				nullable: {
					type: "boolean",
					"default": false
				},
				discriminator: {
					$ref: "#/definitions/Discriminator"
				},
				readOnly: {
					type: "boolean",
					"default": false
				},
				writeOnly: {
					type: "boolean",
					"default": false
				},
				example: {
				},
				externalDocs: {
					$ref: "#/definitions/ExternalDocumentation"
				},
				deprecated: {
					type: "boolean",
					"default": false
				},
				xml: {
					$ref: "#/definitions/XML"
				}
			},
			patternProperties: {
				"^x-": {
				}
			},
			additionalProperties: false
		},
		Discriminator: {
			type: "object",
			required: [
				"propertyName"
			],
			properties: {
				propertyName: {
					type: "string"
				},
				mapping: {
					type: "object",
					additionalProperties: {
						type: "string"
					}
				}
			}
		},
		XML: {
			type: "object",
			properties: {
				name: {
					type: "string"
				},
				namespace: {
					type: "string",
					format: "uri"
				},
				prefix: {
					type: "string"
				},
				attribute: {
					type: "boolean",
					"default": false
				},
				wrapped: {
					type: "boolean",
					"default": false
				}
			},
			patternProperties: {
				"^x-": {
				}
			},
			additionalProperties: false
		},
		Response: {
			type: "object",
			required: [
				"description"
			],
			properties: {
				description: {
					type: "string"
				},
				headers: {
					type: "object",
					additionalProperties: {
						oneOf: [
							{
								$ref: "#/definitions/Header"
							},
							{
								$ref: "#/definitions/Reference"
							}
						]
					}
				},
				content: {
					type: "object",
					additionalProperties: {
						$ref: "#/definitions/MediaType"
					}
				},
				links: {
					type: "object",
					additionalProperties: {
						oneOf: [
							{
								$ref: "#/definitions/Link"
							},
							{
								$ref: "#/definitions/Reference"
							}
						]
					}
				}
			},
			patternProperties: {
				"^x-": {
				}
			},
			additionalProperties: false
		},
		MediaType: {
			type: "object",
			properties: {
				schema: {
					oneOf: [
						{
							$ref: "#/definitions/Schema"
						},
						{
							$ref: "#/definitions/Reference"
						}
					]
				},
				example: {
				},
				examples: {
					type: "object",
					additionalProperties: {
						oneOf: [
							{
								$ref: "#/definitions/Example"
							},
							{
								$ref: "#/definitions/Reference"
							}
						]
					}
				},
				encoding: {
					type: "object",
					additionalProperties: {
						$ref: "#/definitions/Encoding"
					}
				}
			},
			patternProperties: {
				"^x-": {
				}
			},
			additionalProperties: false,
			allOf: [
				{
					$ref: "#/definitions/ExampleXORExamples"
				}
			]
		},
		Example: {
			type: "object",
			properties: {
				summary: {
					type: "string"
				},
				description: {
					type: "string"
				},
				value: {
				},
				externalValue: {
					type: "string",
					format: "uri-reference"
				}
			},
			patternProperties: {
				"^x-": {
				}
			},
			additionalProperties: false
		},
		Header: {
			type: "object",
			properties: {
				description: {
					type: "string"
				},
				required: {
					type: "boolean",
					"default": false
				},
				deprecated: {
					type: "boolean",
					"default": false
				},
				allowEmptyValue: {
					type: "boolean",
					"default": false
				},
				style: {
					type: "string",
					"enum": [
						"simple"
					],
					"default": "simple"
				},
				explode: {
					type: "boolean"
				},
				allowReserved: {
					type: "boolean",
					"default": false
				},
				schema: {
					oneOf: [
						{
							$ref: "#/definitions/Schema"
						},
						{
							$ref: "#/definitions/Reference"
						}
					]
				},
				content: {
					type: "object",
					additionalProperties: {
						$ref: "#/definitions/MediaType"
					},
					minProperties: 1,
					maxProperties: 1
				},
				example: {
				},
				examples: {
					type: "object",
					additionalProperties: {
						oneOf: [
							{
								$ref: "#/definitions/Example"
							},
							{
								$ref: "#/definitions/Reference"
							}
						]
					}
				}
			},
			patternProperties: {
				"^x-": {
				}
			},
			additionalProperties: false,
			allOf: [
				{
					$ref: "#/definitions/ExampleXORExamples"
				},
				{
					$ref: "#/definitions/SchemaXORContent"
				}
			]
		},
		Paths: {
			type: "object",
			patternProperties: {
				"^\\/": {
					$ref: "#/definitions/PathItem"
				},
				"^x-": {
				}
			},
			additionalProperties: false
		},
		PathItem: {
			type: "object",
			properties: {
				$ref: {
					type: "string"
				},
				summary: {
					type: "string"
				},
				description: {
					type: "string"
				},
				servers: {
					type: "array",
					items: {
						$ref: "#/definitions/Server"
					}
				},
				parameters: {
					type: "array",
					items: {
						oneOf: [
							{
								$ref: "#/definitions/Parameter"
							},
							{
								$ref: "#/definitions/Reference"
							}
						]
					},
					uniqueItems: true
				}
			},
			patternProperties: {
				"^(get|put|post|delete|options|head|patch|trace)$": {
					$ref: "#/definitions/Operation"
				},
				"^x-": {
				}
			},
			additionalProperties: false
		},
		Operation: {
			type: "object",
			required: [
				"responses"
			],
			properties: {
				tags: {
					type: "array",
					items: {
						type: "string"
					}
				},
				summary: {
					type: "string"
				},
				description: {
					type: "string"
				},
				externalDocs: {
					$ref: "#/definitions/ExternalDocumentation"
				},
				operationId: {
					type: "string"
				},
				parameters: {
					type: "array",
					items: {
						oneOf: [
							{
								$ref: "#/definitions/Parameter"
							},
							{
								$ref: "#/definitions/Reference"
							}
						]
					},
					uniqueItems: true
				},
				requestBody: {
					oneOf: [
						{
							$ref: "#/definitions/RequestBody"
						},
						{
							$ref: "#/definitions/Reference"
						}
					]
				},
				responses: {
					$ref: "#/definitions/Responses"
				},
				callbacks: {
					type: "object",
					additionalProperties: {
						oneOf: [
							{
								$ref: "#/definitions/Callback"
							},
							{
								$ref: "#/definitions/Reference"
							}
						]
					}
				},
				deprecated: {
					type: "boolean",
					"default": false
				},
				security: {
					type: "array",
					items: {
						$ref: "#/definitions/SecurityRequirement"
					}
				},
				servers: {
					type: "array",
					items: {
						$ref: "#/definitions/Server"
					}
				}
			},
			patternProperties: {
				"^x-": {
				}
			},
			additionalProperties: false
		},
		Responses: {
			type: "object",
			properties: {
				"default": {
					oneOf: [
						{
							$ref: "#/definitions/Response"
						},
						{
							$ref: "#/definitions/Reference"
						}
					]
				}
			},
			patternProperties: {
				"^[1-5](?:\\d{2}|XX)$": {
					oneOf: [
						{
							$ref: "#/definitions/Response"
						},
						{
							$ref: "#/definitions/Reference"
						}
					]
				},
				"^x-": {
				}
			},
			minProperties: 1,
			additionalProperties: false
		},
		SecurityRequirement: {
			type: "object",
			additionalProperties: {
				type: "array",
				items: {
					type: "string"
				}
			}
		},
		Tag: {
			type: "object",
			required: [
				"name"
			],
			properties: {
				name: {
					type: "string"
				},
				description: {
					type: "string"
				},
				externalDocs: {
					$ref: "#/definitions/ExternalDocumentation"
				}
			},
			patternProperties: {
				"^x-": {
				}
			},
			additionalProperties: false
		},
		ExternalDocumentation: {
			type: "object",
			required: [
				"url"
			],
			properties: {
				description: {
					type: "string"
				},
				url: {
					type: "string",
					format: "uri-reference"
				}
			},
			patternProperties: {
				"^x-": {
				}
			},
			additionalProperties: false
		},
		ExampleXORExamples: {
			description: "Example and examples are mutually exclusive",
			not: {
				required: [
					"example",
					"examples"
				]
			}
		},
		SchemaXORContent: {
			description: "Schema and content are mutually exclusive, at least one is required",
			not: {
				required: [
					"schema",
					"content"
				]
			},
			oneOf: [
				{
					required: [
						"schema"
					]
				},
				{
					required: [
						"content"
					],
					description: "Some properties are not allowed if content is present",
					allOf: [
						{
							not: {
								required: [
									"style"
								]
							}
						},
						{
							not: {
								required: [
									"explode"
								]
							}
						},
						{
							not: {
								required: [
									"allowReserved"
								]
							}
						},
						{
							not: {
								required: [
									"example"
								]
							}
						},
						{
							not: {
								required: [
									"examples"
								]
							}
						}
					]
				}
			]
		},
		Parameter: {
			type: "object",
			properties: {
				name: {
					type: "string"
				},
				"in": {
					type: "string"
				},
				description: {
					type: "string"
				},
				required: {
					type: "boolean",
					"default": false
				},
				deprecated: {
					type: "boolean",
					"default": false
				},
				allowEmptyValue: {
					type: "boolean",
					"default": false
				},
				style: {
					type: "string"
				},
				explode: {
					type: "boolean"
				},
				allowReserved: {
					type: "boolean",
					"default": false
				},
				schema: {
					oneOf: [
						{
							$ref: "#/definitions/Schema"
						},
						{
							$ref: "#/definitions/Reference"
						}
					]
				},
				content: {
					type: "object",
					additionalProperties: {
						$ref: "#/definitions/MediaType"
					},
					minProperties: 1,
					maxProperties: 1
				},
				example: {
				},
				examples: {
					type: "object",
					additionalProperties: {
						oneOf: [
							{
								$ref: "#/definitions/Example"
							},
							{
								$ref: "#/definitions/Reference"
							}
						]
					}
				}
			},
			patternProperties: {
				"^x-": {
				}
			},
			additionalProperties: false,
			required: [
				"name",
				"in"
			],
			allOf: [
				{
					$ref: "#/definitions/ExampleXORExamples"
				},
				{
					$ref: "#/definitions/SchemaXORContent"
				},
				{
					$ref: "#/definitions/ParameterLocation"
				}
			]
		},
		ParameterLocation: {
			description: "Parameter location",
			oneOf: [
				{
					description: "Parameter in path",
					required: [
						"required"
					],
					properties: {
						"in": {
							"enum": [
								"path"
							]
						},
						style: {
							"enum": [
								"matrix",
								"label",
								"simple"
							],
							"default": "simple"
						},
						required: {
							"enum": [
								true
							]
						}
					}
				},
				{
					description: "Parameter in query",
					properties: {
						"in": {
							"enum": [
								"query"
							]
						},
						style: {
							"enum": [
								"form",
								"spaceDelimited",
								"pipeDelimited",
								"deepObject"
							],
							"default": "form"
						}
					}
				},
				{
					description: "Parameter in header",
					properties: {
						"in": {
							"enum": [
								"header"
							]
						},
						style: {
							"enum": [
								"simple"
							],
							"default": "simple"
						}
					}
				},
				{
					description: "Parameter in cookie",
					properties: {
						"in": {
							"enum": [
								"cookie"
							]
						},
						style: {
							"enum": [
								"form"
							],
							"default": "form"
						}
					}
				}
			]
		},
		RequestBody: {
			type: "object",
			required: [
				"content"
			],
			properties: {
				description: {
					type: "string"
				},
				content: {
					type: "object",
					additionalProperties: {
						$ref: "#/definitions/MediaType"
					}
				},
				required: {
					type: "boolean",
					"default": false
				}
			},
			patternProperties: {
				"^x-": {
				}
			},
			additionalProperties: false
		},
		SecurityScheme: {
			oneOf: [
				{
					$ref: "#/definitions/APIKeySecurityScheme"
				},
				{
					$ref: "#/definitions/HTTPSecurityScheme"
				},
				{
					$ref: "#/definitions/OAuth2SecurityScheme"
				},
				{
					$ref: "#/definitions/OpenIdConnectSecurityScheme"
				}
			]
		},
		APIKeySecurityScheme: {
			type: "object",
			required: [
				"type",
				"name",
				"in"
			],
			properties: {
				type: {
					type: "string",
					"enum": [
						"apiKey"
					]
				},
				name: {
					type: "string"
				},
				"in": {
					type: "string",
					"enum": [
						"header",
						"query",
						"cookie"
					]
				},
				description: {
					type: "string"
				}
			},
			patternProperties: {
				"^x-": {
				}
			},
			additionalProperties: false
		},
		HTTPSecurityScheme: {
			type: "object",
			required: [
				"scheme",
				"type"
			],
			properties: {
				scheme: {
					type: "string"
				},
				bearerFormat: {
					type: "string"
				},
				description: {
					type: "string"
				},
				type: {
					type: "string",
					"enum": [
						"http"
					]
				}
			},
			patternProperties: {
				"^x-": {
				}
			},
			additionalProperties: false,
			oneOf: [
				{
					description: "Bearer",
					properties: {
						scheme: {
							"enum": [
								"bearer"
							]
						}
					}
				},
				{
					description: "Non Bearer",
					not: {
						required: [
							"bearerFormat"
						]
					},
					properties: {
						scheme: {
							not: {
								"enum": [
									"bearer"
								]
							}
						}
					}
				}
			]
		},
		OAuth2SecurityScheme: {
			type: "object",
			required: [
				"type",
				"flows"
			],
			properties: {
				type: {
					type: "string",
					"enum": [
						"oauth2"
					]
				},
				flows: {
					$ref: "#/definitions/OAuthFlows"
				},
				description: {
					type: "string"
				}
			},
			patternProperties: {
				"^x-": {
				}
			},
			additionalProperties: false
		},
		OpenIdConnectSecurityScheme: {
			type: "object",
			required: [
				"type",
				"openIdConnectUrl"
			],
			properties: {
				type: {
					type: "string",
					"enum": [
						"openIdConnect"
					]
				},
				openIdConnectUrl: {
					type: "string",
					format: "uri-reference"
				},
				description: {
					type: "string"
				}
			},
			patternProperties: {
				"^x-": {
				}
			},
			additionalProperties: false
		},
		OAuthFlows: {
			type: "object",
			properties: {
				implicit: {
					$ref: "#/definitions/ImplicitOAuthFlow"
				},
				password: {
					$ref: "#/definitions/PasswordOAuthFlow"
				},
				clientCredentials: {
					$ref: "#/definitions/ClientCredentialsFlow"
				},
				authorizationCode: {
					$ref: "#/definitions/AuthorizationCodeOAuthFlow"
				}
			},
			patternProperties: {
				"^x-": {
				}
			},
			additionalProperties: false
		},
		ImplicitOAuthFlow: {
			type: "object",
			required: [
				"authorizationUrl",
				"scopes"
			],
			properties: {
				authorizationUrl: {
					type: "string",
					format: "uri-reference"
				},
				refreshUrl: {
					type: "string",
					format: "uri-reference"
				},
				scopes: {
					type: "object",
					additionalProperties: {
						type: "string"
					}
				}
			},
			patternProperties: {
				"^x-": {
				}
			},
			additionalProperties: false
		},
		PasswordOAuthFlow: {
			type: "object",
			required: [
				"tokenUrl"
			],
			properties: {
				tokenUrl: {
					type: "string",
					format: "uri-reference"
				},
				refreshUrl: {
					type: "string",
					format: "uri-reference"
				},
				scopes: {
					type: "object",
					additionalProperties: {
						type: "string"
					}
				}
			},
			patternProperties: {
				"^x-": {
				}
			},
			additionalProperties: false
		},
		ClientCredentialsFlow: {
			type: "object",
			required: [
				"tokenUrl"
			],
			properties: {
				tokenUrl: {
					type: "string",
					format: "uri-reference"
				},
				refreshUrl: {
					type: "string",
					format: "uri-reference"
				},
				scopes: {
					type: "object",
					additionalProperties: {
						type: "string"
					}
				}
			},
			patternProperties: {
				"^x-": {
				}
			},
			additionalProperties: false
		},
		AuthorizationCodeOAuthFlow: {
			type: "object",
			required: [
				"authorizationUrl",
				"tokenUrl"
			],
			properties: {
				authorizationUrl: {
					type: "string",
					format: "uri-reference"
				},
				tokenUrl: {
					type: "string",
					format: "uri-reference"
				},
				refreshUrl: {
					type: "string",
					format: "uri-reference"
				},
				scopes: {
					type: "object",
					additionalProperties: {
						type: "string"
					}
				}
			},
			patternProperties: {
				"^x-": {
				}
			},
			additionalProperties: false
		},
		Link: {
			type: "object",
			properties: {
				operationId: {
					type: "string"
				},
				operationRef: {
					type: "string",
					format: "uri-reference"
				},
				parameters: {
					type: "object",
					additionalProperties: {
					}
				},
				requestBody: {
				},
				description: {
					type: "string"
				},
				server: {
					$ref: "#/definitions/Server"
				}
			},
			patternProperties: {
				"^x-": {
				}
			},
			additionalProperties: false,
			not: {
				description: "Operation Id and Operation Ref are mutually exclusive",
				required: [
					"operationId",
					"operationRef"
				]
			}
		},
		Callback: {
			type: "object",
			additionalProperties: {
				$ref: "#/definitions/PathItem"
			},
			patternProperties: {
				"^x-": {
				}
			}
		},
		Encoding: {
			type: "object",
			properties: {
				contentType: {
					type: "string"
				},
				headers: {
					type: "object",
					additionalProperties: {
						$ref: "#/definitions/Header"
					}
				},
				style: {
					type: "string",
					"enum": [
						"form",
						"spaceDelimited",
						"pipeDelimited",
						"deepObject"
					]
				},
				explode: {
					type: "boolean"
				},
				allowReserved: {
					type: "boolean",
					"default": false
				}
			},
			additionalProperties: false
		}
	};
	var require$$2 = {
		id: id,
		$schema: $schema$1,
		description: description,
		type: type$2,
		required: required$1,
		properties: properties$1,
		patternProperties: patternProperties,
		additionalProperties: additionalProperties,
		definitions: definitions
	};

	var $id = "https://spec.openapis.org/oas/3.1/schema/2021-04-15";
	var $schema = "https://json-schema.org/draft/2020-12/schema";
	var type$1 = "object";
	var properties = {
		openapi: {
			type: "string",
			pattern: "^3\\.1\\.\\d+(-.+)?$"
		},
		info: {
			$ref: "#/$defs/info"
		},
		jsonSchemaDialect: {
			$ref: "#/$defs/uri",
			"default": "https://spec.openapis.org/oas/3.1/dialect/base"
		},
		servers: {
			type: "array",
			items: {
				$ref: "#/$defs/server"
			}
		},
		paths: {
			$ref: "#/$defs/paths"
		},
		webhooks: {
			type: "object",
			additionalProperties: {
				$ref: "#/$defs/path-item-or-reference"
			}
		},
		components: {
			$ref: "#/$defs/components"
		},
		security: {
			type: "array",
			items: {
				$ref: "#/$defs/security-requirement"
			}
		},
		tags: {
			type: "array",
			items: {
				$ref: "#/$defs/tag"
			}
		},
		externalDocs: {
			$ref: "#/$defs/external-documentation"
		}
	};
	var required = [
		"openapi",
		"info"
	];
	var anyOf = [
		{
			required: [
				"paths"
			]
		},
		{
			required: [
				"components"
			]
		},
		{
			required: [
				"webhooks"
			]
		}
	];
	var $ref = "#/$defs/specification-extensions";
	var unevaluatedProperties = false;
	var $defs = {
		info: {
			type: "object",
			properties: {
				title: {
					type: "string"
				},
				summary: {
					type: "string"
				},
				description: {
					type: "string"
				},
				termsOfService: {
					type: "string"
				},
				contact: {
					$ref: "#/$defs/contact"
				},
				license: {
					$ref: "#/$defs/license"
				},
				version: {
					type: "string"
				}
			},
			required: [
				"title",
				"version"
			],
			$ref: "#/$defs/specification-extensions",
			unevaluatedProperties: false
		},
		contact: {
			type: "object",
			properties: {
				name: {
					type: "string"
				},
				url: {
					type: "string"
				},
				email: {
					type: "string"
				}
			},
			$ref: "#/$defs/specification-extensions",
			unevaluatedProperties: false
		},
		license: {
			type: "object",
			properties: {
				name: {
					type: "string"
				},
				identifier: {
					type: "string"
				},
				url: {
					$ref: "#/$defs/uri"
				}
			},
			required: [
				"name"
			],
			oneOf: [
				{
					required: [
						"identifier"
					]
				},
				{
					required: [
						"url"
					]
				}
			],
			$ref: "#/$defs/specification-extensions",
			unevaluatedProperties: false
		},
		server: {
			type: "object",
			properties: {
				url: {
					$ref: "#/$defs/uri"
				},
				description: {
					type: "string"
				},
				variables: {
					type: "object",
					additionalProperties: {
						$ref: "#/$defs/server-variable"
					}
				}
			},
			required: [
				"url"
			],
			$ref: "#/$defs/specification-extensions",
			unevaluatedProperties: false
		},
		"server-variable": {
			type: "object",
			properties: {
				"enum": {
					type: "array",
					items: {
						type: "string"
					},
					minItems: 1
				},
				"default": {
					type: "string"
				},
				descriptions: {
					type: "string"
				}
			},
			required: [
				"default"
			],
			$ref: "#/$defs/specification-extensions",
			unevaluatedProperties: false
		},
		components: {
			type: "object",
			properties: {
				schemas: {
					type: "object",
					additionalProperties: {
						$dynamicRef: "#meta"
					}
				},
				responses: {
					type: "object",
					additionalProperties: {
						$ref: "#/$defs/response-or-reference"
					}
				},
				parameters: {
					type: "object",
					additionalProperties: {
						$ref: "#/$defs/parameter-or-reference"
					}
				},
				examples: {
					type: "object",
					additionalProperties: {
						$ref: "#/$defs/example-or-reference"
					}
				},
				requestBodies: {
					type: "object",
					additionalProperties: {
						$ref: "#/$defs/request-body-or-reference"
					}
				},
				headers: {
					type: "object",
					additionalProperties: {
						$ref: "#/$defs/header-or-reference"
					}
				},
				securitySchemes: {
					type: "object",
					additionalProperties: {
						$ref: "#/$defs/security-scheme-or-reference"
					}
				},
				links: {
					type: "object",
					additionalProperties: {
						$ref: "#/$defs/link-or-reference"
					}
				},
				callbacks: {
					type: "object",
					additionalProperties: {
						$ref: "#/$defs/callbacks-or-reference"
					}
				},
				pathItems: {
					type: "object",
					additionalProperties: {
						$ref: "#/$defs/path-item-or-reference"
					}
				}
			},
			patternProperties: {
				"^(schemas|responses|parameters|examples|requestBodies|headers|securitySchemes|links|callbacks|pathItems)$": {
					$comment: "Enumerating all of the property names in the regex above is necessary for unevaluatedProperties to work as expected",
					propertyNames: {
						pattern: "^[a-zA-Z0-9._-]+$"
					}
				}
			},
			$ref: "#/$defs/specification-extensions",
			unevaluatedProperties: false
		},
		paths: {
			type: "object",
			patternProperties: {
				"^/": {
					$ref: "#/$defs/path-item"
				}
			},
			$ref: "#/$defs/specification-extensions",
			unevaluatedProperties: false
		},
		"path-item": {
			type: "object",
			properties: {
				summary: {
					type: "string"
				},
				description: {
					type: "string"
				},
				servers: {
					type: "array",
					items: {
						$ref: "#/$defs/server"
					}
				},
				parameters: {
					type: "array",
					items: {
						$ref: "#/$defs/parameter-or-reference"
					}
				}
			},
			patternProperties: {
				"^(get|put|post|delete|options|head|patch|trace)$": {
					$ref: "#/$defs/operation"
				}
			},
			$ref: "#/$defs/specification-extensions",
			unevaluatedProperties: false
		},
		"path-item-or-reference": {
			"if": {
				required: [
					"$ref"
				]
			},
			then: {
				$ref: "#/$defs/reference"
			},
			"else": {
				$ref: "#/$defs/path-item"
			}
		},
		operation: {
			type: "object",
			properties: {
				tags: {
					type: "array",
					items: {
						type: "string"
					}
				},
				summary: {
					type: "string"
				},
				description: {
					type: "string"
				},
				externalDocs: {
					$ref: "#/$defs/external-documentation"
				},
				operationId: {
					type: "string"
				},
				parameters: {
					type: "array",
					items: {
						$ref: "#/$defs/parameter-or-reference"
					}
				},
				requestBody: {
					$ref: "#/$defs/request-body-or-reference"
				},
				responses: {
					$ref: "#/$defs/responses"
				},
				callbacks: {
					type: "object",
					additionalProperties: {
						$ref: "#/$defs/callbacks-or-reference"
					}
				},
				deprecated: {
					"default": false,
					type: "boolean"
				},
				security: {
					type: "array",
					items: {
						$ref: "#/$defs/security-requirement"
					}
				},
				servers: {
					type: "array",
					items: {
						$ref: "#/$defs/server"
					}
				}
			},
			$ref: "#/$defs/specification-extensions",
			unevaluatedProperties: false
		},
		"external-documentation": {
			type: "object",
			properties: {
				description: {
					type: "string"
				},
				url: {
					$ref: "#/$defs/uri"
				}
			},
			required: [
				"url"
			],
			$ref: "#/$defs/specification-extensions",
			unevaluatedProperties: false
		},
		parameter: {
			type: "object",
			properties: {
				name: {
					type: "string"
				},
				"in": {
					"enum": [
						"query",
						"header",
						"path",
						"cookie"
					]
				},
				description: {
					type: "string"
				},
				required: {
					"default": false,
					type: "boolean"
				},
				deprecated: {
					"default": false,
					type: "boolean"
				},
				allowEmptyValue: {
					"default": false,
					type: "boolean"
				},
				schema: {
					$dynamicRef: "#meta"
				},
				content: {
					$ref: "#/$defs/content"
				}
			},
			required: [
				"in"
			],
			oneOf: [
				{
					required: [
						"schema"
					]
				},
				{
					required: [
						"content"
					]
				}
			],
			dependentSchemas: {
				schema: {
					properties: {
						style: {
							type: "string"
						},
						explode: {
							type: "boolean"
						},
						allowReserved: {
							"default": false,
							type: "boolean"
						}
					},
					allOf: [
						{
							$ref: "#/$defs/examples"
						},
						{
							$ref: "#/$defs/parameter/dependentSchemas/schema/$defs/styles-for-path"
						},
						{
							$ref: "#/$defs/parameter/dependentSchemas/schema/$defs/styles-for-header"
						},
						{
							$ref: "#/$defs/parameter/dependentSchemas/schema/$defs/styles-for-query"
						},
						{
							$ref: "#/$defs/parameter/dependentSchemas/schema/$defs/styles-for-cookie"
						},
						{
							$ref: "#/$defs/parameter/dependentSchemas/schema/$defs/styles-for-form"
						}
					],
					$defs: {
						"styles-for-path": {
							"if": {
								properties: {
									"in": {
										"const": "path"
									}
								},
								required: [
									"in"
								]
							},
							then: {
								properties: {
									style: {
										"default": "simple",
										"enum": [
											"matrix",
											"label",
											"simple"
										]
									},
									required: {
										"const": true
									}
								},
								required: [
									"required"
								]
							}
						},
						"styles-for-header": {
							"if": {
								properties: {
									"in": {
										"const": "header"
									}
								},
								required: [
									"in"
								]
							},
							then: {
								properties: {
									style: {
										"default": "simple",
										"enum": [
											"simple"
										]
									}
								}
							}
						},
						"styles-for-query": {
							"if": {
								properties: {
									"in": {
										"const": "query"
									}
								},
								required: [
									"in"
								]
							},
							then: {
								properties: {
									style: {
										"default": "form",
										"enum": [
											"form",
											"spaceDelimited",
											"pipeDelimited",
											"deepObject"
										]
									}
								}
							}
						},
						"styles-for-cookie": {
							"if": {
								properties: {
									"in": {
										"const": "cookie"
									}
								},
								required: [
									"in"
								]
							},
							then: {
								properties: {
									style: {
										"default": "form",
										"enum": [
											"form"
										]
									}
								}
							}
						},
						"styles-for-form": {
							"if": {
								properties: {
									style: {
										"const": "form"
									}
								},
								required: [
									"style"
								]
							},
							then: {
								properties: {
									explode: {
										"default": true
									}
								}
							},
							"else": {
								properties: {
									explode: {
										"default": false
									}
								}
							}
						}
					}
				}
			},
			$ref: "#/$defs/specification-extensions",
			unevaluatedProperties: false
		},
		"parameter-or-reference": {
			"if": {
				required: [
					"$ref"
				]
			},
			then: {
				$ref: "#/$defs/reference"
			},
			"else": {
				$ref: "#/$defs/parameter"
			}
		},
		"request-body": {
			type: "object",
			properties: {
				description: {
					type: "string"
				},
				content: {
					$ref: "#/$defs/content"
				},
				required: {
					"default": false,
					type: "boolean"
				}
			},
			required: [
				"content"
			],
			$ref: "#/$defs/specification-extensions",
			unevaluatedProperties: false
		},
		"request-body-or-reference": {
			"if": {
				required: [
					"$ref"
				]
			},
			then: {
				$ref: "#/$defs/reference"
			},
			"else": {
				$ref: "#/$defs/request-body"
			}
		},
		content: {
			type: "object",
			additionalProperties: {
				$ref: "#/$defs/media-type"
			},
			propertyNames: {
				format: "media-range"
			}
		},
		"media-type": {
			type: "object",
			properties: {
				schema: {
					$dynamicRef: "#meta"
				},
				encoding: {
					type: "object",
					additionalProperties: {
						$ref: "#/$defs/encoding"
					}
				}
			},
			allOf: [
				{
					$ref: "#/$defs/specification-extensions"
				},
				{
					$ref: "#/$defs/examples"
				}
			],
			unevaluatedProperties: false
		},
		encoding: {
			type: "object",
			properties: {
				contentType: {
					type: "string",
					format: "media-range"
				},
				headers: {
					type: "object",
					additionalProperties: {
						$ref: "#/$defs/header-or-reference"
					}
				},
				style: {
					"default": "form",
					"enum": [
						"form",
						"spaceDelimited",
						"pipeDelimited",
						"deepObject"
					]
				},
				explode: {
					type: "boolean"
				},
				allowReserved: {
					"default": false,
					type: "boolean"
				}
			},
			allOf: [
				{
					$ref: "#/$defs/specification-extensions"
				},
				{
					$ref: "#/$defs/encoding/$defs/explode-default"
				}
			],
			unevaluatedProperties: false,
			$defs: {
				"explode-default": {
					"if": {
						properties: {
							style: {
								"const": "form"
							}
						},
						required: [
							"style"
						]
					},
					then: {
						properties: {
							explode: {
								"default": true
							}
						}
					},
					"else": {
						properties: {
							explode: {
								"default": false
							}
						}
					}
				}
			}
		},
		responses: {
			type: "object",
			properties: {
				"default": {
					$ref: "#/$defs/response-or-reference"
				}
			},
			patternProperties: {
				"^[1-5][0-9X]{2}$": {
					$ref: "#/$defs/response-or-reference"
				}
			},
			$ref: "#/$defs/specification-extensions",
			unevaluatedProperties: false
		},
		response: {
			type: "object",
			properties: {
				description: {
					type: "string"
				},
				headers: {
					type: "object",
					additionalProperties: {
						$ref: "#/$defs/header-or-reference"
					}
				},
				content: {
					$ref: "#/$defs/content"
				},
				links: {
					type: "object",
					additionalProperties: {
						$ref: "#/$defs/link-or-reference"
					}
				}
			},
			required: [
				"description"
			],
			$ref: "#/$defs/specification-extensions",
			unevaluatedProperties: false
		},
		"response-or-reference": {
			"if": {
				required: [
					"$ref"
				]
			},
			then: {
				$ref: "#/$defs/reference"
			},
			"else": {
				$ref: "#/$defs/response"
			}
		},
		callbacks: {
			type: "object",
			$ref: "#/$defs/specification-extensions",
			additionalProperties: {
				$ref: "#/$defs/path-item-or-reference"
			}
		},
		"callbacks-or-reference": {
			"if": {
				required: [
					"$ref"
				]
			},
			then: {
				$ref: "#/$defs/reference"
			},
			"else": {
				$ref: "#/$defs/callbacks"
			}
		},
		example: {
			type: "object",
			properties: {
				summary: {
					type: "string"
				},
				description: {
					type: "string"
				},
				value: true,
				externalValue: {
					$ref: "#/$defs/uri"
				}
			},
			$ref: "#/$defs/specification-extensions",
			unevaluatedProperties: false
		},
		"example-or-reference": {
			"if": {
				required: [
					"$ref"
				]
			},
			then: {
				$ref: "#/$defs/reference"
			},
			"else": {
				$ref: "#/$defs/example"
			}
		},
		link: {
			type: "object",
			properties: {
				operationRef: {
					$ref: "#/$defs/uri"
				},
				operationId: true,
				parameters: {
					$ref: "#/$defs/map-of-strings"
				},
				requestBody: true,
				description: {
					type: "string"
				},
				body: {
					$ref: "#/$defs/server"
				}
			},
			oneOf: [
				{
					required: [
						"operationRef"
					]
				},
				{
					required: [
						"operationId"
					]
				}
			],
			$ref: "#/$defs/specification-extensions",
			unevaluatedProperties: false
		},
		"link-or-reference": {
			"if": {
				required: [
					"$ref"
				]
			},
			then: {
				$ref: "#/$defs/reference"
			},
			"else": {
				$ref: "#/$defs/link"
			}
		},
		header: {
			type: "object",
			properties: {
				description: {
					type: "string"
				},
				required: {
					"default": false,
					type: "boolean"
				},
				deprecated: {
					"default": false,
					type: "boolean"
				},
				allowEmptyValue: {
					"default": false,
					type: "boolean"
				}
			},
			dependentSchemas: {
				schema: {
					properties: {
						style: {
							"default": "simple",
							"enum": [
								"simple"
							]
						},
						explode: {
							"default": false,
							type: "boolean"
						},
						allowReserved: {
							"default": false,
							type: "boolean"
						},
						schema: {
							$dynamicRef: "#meta"
						}
					},
					$ref: "#/$defs/examples"
				},
				content: {
					properties: {
						content: {
							$ref: "#/$defs/content"
						}
					}
				}
			},
			$ref: "#/$defs/specification-extensions",
			unevaluatedProperties: false
		},
		"header-or-reference": {
			"if": {
				required: [
					"$ref"
				]
			},
			then: {
				$ref: "#/$defs/reference"
			},
			"else": {
				$ref: "#/$defs/header"
			}
		},
		tag: {
			type: "object",
			properties: {
				name: {
					type: "string"
				},
				description: {
					type: "string"
				},
				externalDocs: {
					$ref: "#/$defs/external-documentation"
				}
			},
			required: [
				"name"
			],
			$ref: "#/$defs/specification-extensions",
			unevaluatedProperties: false
		},
		reference: {
			type: "object",
			properties: {
				$ref: {
					$ref: "#/$defs/uri"
				},
				summary: {
					type: "string"
				},
				description: {
					type: "string"
				}
			},
			unevaluatedProperties: false
		},
		schema: {
			$dynamicAnchor: "meta",
			type: [
				"object",
				"boolean"
			]
		},
		"security-scheme": {
			type: "object",
			properties: {
				type: {
					"enum": [
						"apiKey",
						"http",
						"mutualTLS",
						"oauth2",
						"openIdConnect"
					]
				},
				description: {
					type: "string"
				}
			},
			required: [
				"type"
			],
			allOf: [
				{
					$ref: "#/$defs/specification-extensions"
				},
				{
					$ref: "#/$defs/security-scheme/$defs/type-apikey"
				},
				{
					$ref: "#/$defs/security-scheme/$defs/type-http"
				},
				{
					$ref: "#/$defs/security-scheme/$defs/type-http-bearer"
				},
				{
					$ref: "#/$defs/security-scheme/$defs/type-oauth2"
				},
				{
					$ref: "#/$defs/security-scheme/$defs/type-oidc"
				}
			],
			unevaluatedProperties: false,
			$defs: {
				"type-apikey": {
					"if": {
						properties: {
							type: {
								"const": "apiKey"
							}
						},
						required: [
							"type"
						]
					},
					then: {
						properties: {
							name: {
								type: "string"
							},
							"in": {
								"enum": [
									"query",
									"header",
									"cookie"
								]
							}
						},
						required: [
							"name",
							"in"
						]
					}
				},
				"type-http": {
					"if": {
						properties: {
							type: {
								"const": "http"
							}
						},
						required: [
							"type"
						]
					},
					then: {
						properties: {
							scheme: {
								type: "string"
							}
						},
						required: [
							"scheme"
						]
					}
				},
				"type-http-bearer": {
					"if": {
						properties: {
							type: {
								"const": "http"
							},
							scheme: {
								"const": "bearer"
							}
						},
						required: [
							"type",
							"scheme"
						]
					},
					then: {
						properties: {
							bearerFormat: {
								type: "string"
							}
						},
						required: [
							"scheme"
						]
					}
				},
				"type-oauth2": {
					"if": {
						properties: {
							type: {
								"const": "oauth2"
							}
						},
						required: [
							"type"
						]
					},
					then: {
						properties: {
							flows: {
								$ref: "#/$defs/oauth-flows"
							}
						},
						required: [
							"flows"
						]
					}
				},
				"type-oidc": {
					"if": {
						properties: {
							type: {
								"const": "openIdConnect"
							}
						},
						required: [
							"type"
						]
					},
					then: {
						properties: {
							openIdConnectUrl: {
								$ref: "#/$defs/uri"
							}
						},
						required: [
							"openIdConnectUrl"
						]
					}
				}
			}
		},
		"security-scheme-or-reference": {
			"if": {
				required: [
					"$ref"
				]
			},
			then: {
				$ref: "#/$defs/reference"
			},
			"else": {
				$ref: "#/$defs/security-scheme"
			}
		},
		"oauth-flows": {
			type: "object",
			properties: {
				implicit: {
					$ref: "#/$defs/oauth-flows/$defs/implicit"
				},
				password: {
					$ref: "#/$defs/oauth-flows/$defs/password"
				},
				clientCredentials: {
					$ref: "#/$defs/oauth-flows/$defs/client-credentials"
				},
				authorizationCode: {
					$ref: "#/$defs/oauth-flows/$defs/authorization-code"
				}
			},
			$ref: "#/$defs/specification-extensions",
			unevaluatedProperties: false,
			$defs: {
				implicit: {
					type: "object",
					properties: {
						authorizationUrl: {
							type: "string"
						},
						refreshUrl: {
							type: "string"
						},
						scopes: {
							$ref: "#/$defs/map-of-strings"
						}
					},
					required: [
						"authorizationUrl",
						"scopes"
					],
					$ref: "#/$defs/specification-extensions",
					unevaluatedProperties: false
				},
				password: {
					type: "object",
					properties: {
						tokenUrl: {
							type: "string"
						},
						refreshUrl: {
							type: "string"
						},
						scopes: {
							$ref: "#/$defs/map-of-strings"
						}
					},
					required: [
						"tokenUrl",
						"scopes"
					],
					$ref: "#/$defs/specification-extensions",
					unevaluatedProperties: false
				},
				"client-credentials": {
					type: "object",
					properties: {
						tokenUrl: {
							type: "string"
						},
						refreshUrl: {
							type: "string"
						},
						scopes: {
							$ref: "#/$defs/map-of-strings"
						}
					},
					required: [
						"tokenUrl",
						"scopes"
					],
					$ref: "#/$defs/specification-extensions",
					unevaluatedProperties: false
				},
				"authorization-code": {
					type: "object",
					properties: {
						authorizationUrl: {
							type: "string"
						},
						tokenUrl: {
							type: "string"
						},
						refreshUrl: {
							type: "string"
						},
						scopes: {
							$ref: "#/$defs/map-of-strings"
						}
					},
					required: [
						"authorizationUrl",
						"tokenUrl",
						"scopes"
					],
					$ref: "#/$defs/specification-extensions",
					unevaluatedProperties: false
				}
			}
		},
		"security-requirement": {
			type: "object",
			additionalProperties: {
				type: "array",
				items: {
					type: "string"
				}
			}
		},
		"specification-extensions": {
			patternProperties: {
				"^x-": true
			}
		},
		examples: {
			properties: {
				example: true,
				examples: {
					type: "object",
					additionalProperties: {
						$ref: "#/$defs/example-or-reference"
					}
				}
			}
		},
		uri: {
			type: "string",
			format: "uri"
		},
		"map-of-strings": {
			type: "object",
			additionalProperties: {
				type: "string"
			}
		}
	};
	var require$$3 = {
		$id: $id,
		$schema: $schema,
		type: type$1,
		properties: properties,
		required: required,
		anyOf: anyOf,
		$ref: $ref,
		unevaluatedProperties: unevaluatedProperties,
		$defs: $defs
	};

	(function (module, exports) {
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.openapi = exports.openapiV31 = exports.openapiV3 = exports.openapiV2 = exports.openapiV1 = void 0;
		/**
		 * JSON Schema for OpenAPI Specification v1.2
		 */
		exports.openapiV1 = require$$0$3;
		/**
		 * JSON Schema for OpenAPI Specification v2.0
		 */
		exports.openapiV2 = require$$1$1;
		/**
		 * JSON Schema for OpenAPI Specification v3.0
		 */
		exports.openapiV3 = require$$2;
		/**
		 * JSON Schema for OpenAPI Specification v3.1
		 */
		exports.openapiV31 = require$$3;
		/**
		 * JSON Schemas for every version of the OpenAPI Specification
		 */
		exports.openapi = {
		    v1: exports.openapiV1,
		    v2: exports.openapiV2,
		    v3: exports.openapiV3,
		    v31: exports.openapiV31,
		};
		// Export `openapi` as the default export
		exports.default = exports.openapi;
		// CommonJS default export hack
		/* eslint-env commonjs */
		{
		    module.exports = Object.assign(module.exports.default, module.exports);
		}
		
	} (lib$3, libExports$1));

	const util$3 = util$5;
	const { ono: ono$8 } = require$$6;
	const ZSchema = ZSchema_1;
	const { openapi } = libExports$1;

	var schema$1 = validateSchema$2;

	let zSchema = initializeZSchema();

	/**
	 * Validates the given Swagger API against the Swagger 2.0 or 3.0 schema.
	 *
	 * @param {SwaggerObject} api
	 */
	function validateSchema$2 (api) {
	  // Choose the appropriate schema (Swagger or OpenAPI)
	  let schema = api.swagger ? openapi.v2 : openapi.v3;

	  // Validate against the schema
	  let isValid = zSchema.validate(api, schema);

	  if (!isValid) {
	    let err = zSchema.getLastError();
	    let message = "Swagger schema validation failed. \n" + formatZSchemaError(err.details);
	    throw ono$8.syntax(err, { details: err.details }, message);
	  }
	}

	/**
	 * Performs one-time initialization logic to prepare for Swagger Schema validation.
	 */
	function initializeZSchema () {
	  // HACK: Delete the OpenAPI schema IDs because ZSchema can't resolve them
	  delete openapi.v2.id;
	  delete openapi.v3.id;

	  // The OpenAPI 3.0 schema uses "uri-reference" formats.
	  // Assume that any non-whitespace string is valid.
	  ZSchema.registerFormat("uri-reference", (value) => value.trim().length > 0);

	  // Configure ZSchema
	  return new ZSchema({
	    breakOnFirstError: true,
	    noExtraKeywords: true,
	    ignoreUnknownFormats: false,
	    reportPathAsArray: true
	  });
	}

	/**
	 * Z-Schema validation errors are a nested tree structure.
	 * This function crawls that tree and builds an error message string.
	 *
	 * @param {object[]}  errors     - The Z-Schema error details
	 * @param {string}    [indent]   - The whitespace used to indent the error message
	 * @returns {string}
	 */
	function formatZSchemaError (errors, indent) {
	  indent = indent || "  ";
	  let message = "";
	  for (let error of errors) {
	    message += util$3.format(`${indent}${error.message} at #/${error.path.join("/")}\n`);
	    if (error.inner) {
	      message += formatZSchemaError(error.inner, indent + "  ");
	    }
	  }
	  return message;
	}

	var lib$2 = [
	  "get", "put", "post", "delete", "options", "head", "patch"
	];

	const util$2 = util$5;
	const { ono: ono$7 } = require$$6;
	const swaggerMethods = lib$2;
	const primitiveTypes = ["array", "boolean", "integer", "number", "string"];
	const schemaTypes = ["array", "boolean", "integer", "number", "string", "object", "null", undefined];

	var spec = validateSpec$2;

	/**
	 * Validates parts of the Swagger 2.0 spec that aren't covered by the Swagger 2.0 JSON Schema.
	 *
	 * @param {SwaggerObject} api
	 */
	function validateSpec$2 (api) {
	  if (api.openapi) {
	    // We don't (yet) support validating against the OpenAPI spec
	    return;
	  }

	  let paths = Object.keys(api.paths || {});
	  let operationIds = [];
	  for (let pathName of paths) {
	    let path = api.paths[pathName];
	    let pathId = "/paths" + pathName;

	    if (path && pathName.indexOf("/") === 0) {
	      validatePath(api, path, pathId, operationIds);
	    }
	  }

	  let definitions = Object.keys(api.definitions || {});
	  for (let definitionName of definitions) {
	    let definition = api.definitions[definitionName];
	    let definitionId = "/definitions/" + definitionName;
	    validateRequiredPropertiesExist(definition, definitionId);
	  }
	}

	/**
	 * Validates the given path.
	 *
	 * @param {SwaggerObject} api           - The entire Swagger API object
	 * @param {object}        path          - A Path object, from the Swagger API
	 * @param {string}        pathId        - A value that uniquely identifies the path
	 * @param {string}        operationIds  - An array of collected operationIds found in other paths
	 */
	function validatePath (api, path, pathId, operationIds) {
	  for (let operationName of swaggerMethods) {
	    let operation = path[operationName];
	    let operationId = pathId + "/" + operationName;

	    if (operation) {
	      let declaredOperationId = operation.operationId;
	      if (declaredOperationId) {
	        if (operationIds.indexOf(declaredOperationId) === -1) {
	          operationIds.push(declaredOperationId);
	        }
	        else {
	          throw ono$7.syntax(`Validation failed. Duplicate operation id '${declaredOperationId}'`);
	        }
	      }
	      validateParameters(api, path, pathId, operation, operationId);

	      let responses = Object.keys(operation.responses || {});
	      for (let responseName of responses) {
	        let response = operation.responses[responseName];
	        let responseId = operationId + "/responses/" + responseName;
	        validateResponse(responseName, (response || {}), responseId);
	      }
	    }
	  }
	}

	/**
	 * Validates the parameters for the given operation.
	 *
	 * @param {SwaggerObject} api           - The entire Swagger API object
	 * @param {object}        path          - A Path object, from the Swagger API
	 * @param {string}        pathId        - A value that uniquely identifies the path
	 * @param {object}        operation     - An Operation object, from the Swagger API
	 * @param {string}        operationId   - A value that uniquely identifies the operation
	 */
	function validateParameters (api, path, pathId, operation, operationId) {
	  let pathParams = path.parameters || [];
	  let operationParams = operation.parameters || [];

	  // Check for duplicate path parameters
	  try {
	    checkForDuplicates(pathParams);
	  }
	  catch (e) {
	    throw ono$7.syntax(e, `Validation failed. ${pathId} has duplicate parameters`);
	  }

	  // Check for duplicate operation parameters
	  try {
	    checkForDuplicates(operationParams);
	  }
	  catch (e) {
	    throw ono$7.syntax(e, `Validation failed. ${operationId} has duplicate parameters`);
	  }

	  // Combine the path and operation parameters,
	  // with the operation params taking precedence over the path params
	  let params = pathParams.reduce((combinedParams, value) => {
	    let duplicate = combinedParams.some((param) => {
	      return param.in === value.in && param.name === value.name;
	    });
	    if (!duplicate) {
	      combinedParams.push(value);
	    }
	    return combinedParams;
	  }, operationParams.slice());

	  validateBodyParameters(params, operationId);
	  validatePathParameters(params, pathId, operationId);
	  validateParameterTypes(params, api, operation, operationId);
	}

	/**
	 * Validates body and formData parameters for the given operation.
	 *
	 * @param   {object[]}  params       -  An array of Parameter objects
	 * @param   {string}    operationId  -  A value that uniquely identifies the operation
	 */
	function validateBodyParameters (params, operationId) {
	  let bodyParams = params.filter((param) => { return param.in === "body"; });
	  let formParams = params.filter((param) => { return param.in === "formData"; });

	  // There can only be one "body" parameter
	  if (bodyParams.length > 1) {
	    throw ono$7.syntax(
	      `Validation failed. ${operationId} has ${bodyParams.length} body parameters. Only one is allowed.`,
	    );
	  }
	  else if (bodyParams.length > 0 && formParams.length > 0) {
	    // "body" params and "formData" params are mutually exclusive
	    throw ono$7.syntax(
	      `Validation failed. ${operationId} has body parameters and formData parameters. Only one or the other is allowed.`,
	    );
	  }
	}

	/**
	 * Validates path parameters for the given path.
	 *
	 * @param   {object[]}  params        - An array of Parameter objects
	 * @param   {string}    pathId        - A value that uniquely identifies the path
	 * @param   {string}    operationId   - A value that uniquely identifies the operation
	 */
	function validatePathParameters (params, pathId, operationId) {
	  // Find all {placeholders} in the path string
	  let placeholders = pathId.match(util$2.swaggerParamRegExp) || [];

	  // Check for duplicates
	  for (let i = 0; i < placeholders.length; i++) {
	    for (let j = i + 1; j < placeholders.length; j++) {
	      if (placeholders[i] === placeholders[j]) {
	        throw ono$7.syntax(
	          `Validation failed. ${operationId} has multiple path placeholders named ${placeholders[i]}`);
	      }
	    }
	  }

	  params = params.filter((param) => { return param.in === "path"; });

	  for (let param of params) {
	    if (param.required !== true) {
	      throw ono$7.syntax(
	        "Validation failed. Path parameters cannot be optional. " +
	        `Set required=true for the "${param.name}" parameter at ${operationId}`,
	      );
	    }
	    let match = placeholders.indexOf("{" + param.name + "}");
	    if (match === -1) {
	      throw ono$7.syntax(
	        `Validation failed. ${operationId} has a path parameter named "${param.name}", ` +
	        `but there is no corresponding {${param.name}} in the path string`
	      );
	    }
	    placeholders.splice(match, 1);
	  }

	  if (placeholders.length > 0) {
	    throw ono$7.syntax(`Validation failed. ${operationId} is missing path parameter(s) for ${placeholders}`);
	  }
	}

	/**
	 * Validates data types of parameters for the given operation.
	 *
	 * @param   {object[]}  params       -  An array of Parameter objects
	 * @param   {object}    api          -  The entire Swagger API object
	 * @param   {object}    operation    -  An Operation object, from the Swagger API
	 * @param   {string}    operationId  -  A value that uniquely identifies the operation
	 */
	function validateParameterTypes (params, api, operation, operationId) {
	  for (let param of params) {
	    let parameterId = operationId + "/parameters/" + param.name;
	    let schema, validTypes;

	    switch (param.in) {
	      case "body":
	        schema = param.schema;
	        validTypes = schemaTypes;
	        break;
	      case "formData":
	        schema = param;
	        validTypes = primitiveTypes.concat("file");
	        break;
	      default:
	        schema = param;
	        validTypes = primitiveTypes;
	    }

	    validateSchema$1(schema, parameterId, validTypes);
	    validateRequiredPropertiesExist(schema, parameterId);

	    if (schema.type === "file") {
	      // "file" params must consume at least one of these MIME types
	      let formData = /multipart\/(.*\+)?form-data/;
	      let urlEncoded = /application\/(.*\+)?x-www-form-urlencoded/;

	      let consumes = operation.consumes || api.consumes || [];

	      let hasValidMimeType = consumes.some((consume) => {
	        return formData.test(consume) || urlEncoded.test(consume);
	      });

	      if (!hasValidMimeType) {
	        throw ono$7.syntax(
	          `Validation failed. ${operationId} has a file parameter, so it must consume multipart/form-data ` +
	          "or application/x-www-form-urlencoded",
	        );
	      }
	    }
	  }
	}

	/**
	 * Checks the given parameter list for duplicates, and throws an error if found.
	 *
	 * @param   {object[]}  params  - An array of Parameter objects
	 */
	function checkForDuplicates (params) {
	  for (let i = 0; i < params.length - 1; i++) {
	    let outer = params[i];
	    for (let j = i + 1; j < params.length; j++) {
	      let inner = params[j];
	      if (outer.name === inner.name && outer.in === inner.in) {
	        throw ono$7.syntax(`Validation failed. Found multiple ${outer.in} parameters named "${outer.name}"`);
	      }
	    }
	  }
	}

	/**
	 * Validates the given response object.
	 *
	 * @param   {string}    code        -  The HTTP response code (or "default")
	 * @param   {object}    response    -  A Response object, from the Swagger API
	 * @param   {string}    responseId  -  A value that uniquely identifies the response
	 */
	function validateResponse (code, response, responseId) {
	  if (code !== "default" && (code < 100 || code > 599)) {
	    throw ono$7.syntax(`Validation failed. ${responseId} has an invalid response code (${code})`);
	  }

	  let headers = Object.keys(response.headers || {});
	  for (let headerName of headers) {
	    let header = response.headers[headerName];
	    let headerId = responseId + "/headers/" + headerName;
	    validateSchema$1(header, headerId, primitiveTypes);
	  }

	  if (response.schema) {
	    let validTypes = schemaTypes.concat("file");
	    if (validTypes.indexOf(response.schema.type) === -1) {
	      throw ono$7.syntax(
	        `Validation failed. ${responseId} has an invalid response schema type (${response.schema.type})`);
	    }
	    else {
	      validateSchema$1(response.schema, responseId + "/schema", validTypes);
	    }
	  }
	}

	/**
	 * Validates the given Swagger schema object.
	 *
	 * @param {object}    schema      - A Schema object, from the Swagger API
	 * @param {string}    schemaId    - A value that uniquely identifies the schema object
	 * @param {string[]}  validTypes  - An array of the allowed schema types
	 */
	function validateSchema$1 (schema, schemaId, validTypes) {
	  if (validTypes.indexOf(schema.type) === -1) {
	    throw ono$7.syntax(
	      `Validation failed. ${schemaId} has an invalid type (${schema.type})`);
	  }

	  if (schema.type === "array" && !schema.items) {
	    throw ono$7.syntax(`Validation failed. ${schemaId} is an array, so it must include an "items" schema`);
	  }
	}

	/**
	 * Validates that the declared properties of the given Swagger schema object actually exist.
	 *
	 * @param {object}    schema      - A Schema object, from the Swagger API
	 * @param {string}    schemaId    - A value that uniquely identifies the schema object
	 */
	function validateRequiredPropertiesExist (schema, schemaId) {
	  /**
	   * Recursively collects all properties of the schema and its ancestors. They are added to the props object.
	   */
	  function collectProperties (schemaObj, props) {
	    if (schemaObj.properties) {
	      for (let property in schemaObj.properties) {
	        if (schemaObj.properties.hasOwnProperty(property)) {
	          props[property] = schemaObj.properties[property];
	        }
	      }
	    }
	    if (schemaObj.allOf) {
	      for (let parent of schemaObj.allOf) {
	        collectProperties(parent, props);
	      }
	    }
	  }

	  if (schema.required && Array.isArray(schema.required)) {
	    let props = {};
	    collectProperties(schema, props);
	    for (let requiredProperty of schema.required) {
	      if (!props[requiredProperty]) {
	        throw ono$7.syntax(
	          `Validation failed. Property '${requiredProperty}' listed as required but does not exist in '${schemaId}'`
	        );
	      }
	    }
	  }
	}

	var errors$1 = {};

	var urlExports = {};
	var url$8 = {
	  get exports(){ return urlExports; },
	  set exports(v){ urlExports = v; },
	};

	/*! https://mths.be/punycode v1.4.1 by @mathias */


	/** Highest positive signed 32-bit float value */
	var maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1

	/** Bootstring parameters */
	var base = 36;
	var tMin = 1;
	var tMax = 26;
	var skew = 38;
	var damp = 700;
	var initialBias = 72;
	var initialN = 128; // 0x80
	var delimiter = '-'; // '\x2D'
	var regexNonASCII = /[^\x20-\x7E]/; // unprintable ASCII chars + non-ASCII chars
	var regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g; // RFC 3490 separators

	/** Error messages */
	var errors = {
	  'overflow': 'Overflow: input needs wider integers to process',
	  'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
	  'invalid-input': 'Invalid input'
	};

	/** Convenience shortcuts */
	var baseMinusTMin = base - tMin;
	var floor$1 = Math.floor;
	var stringFromCharCode = String.fromCharCode;

	/*--------------------------------------------------------------------------*/

	/**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */
	function error(type) {
	  throw new RangeError(errors[type]);
	}

	/**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */
	function map$3(array, fn) {
	  var length = array.length;
	  var result = [];
	  while (length--) {
	    result[length] = fn(array[length]);
	  }
	  return result;
	}

	/**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */
	function mapDomain(string, fn) {
	  var parts = string.split('@');
	  var result = '';
	  if (parts.length > 1) {
	    // In email addresses, only the domain name should be punycoded. Leave
	    // the local part (i.e. everything up to `@`) intact.
	    result = parts[0] + '@';
	    string = parts[1];
	  }
	  // Avoid `split(regex)` for IE8 compatibility. See #17.
	  string = string.replace(regexSeparators, '\x2E');
	  var labels = string.split('.');
	  var encoded = map$3(labels, fn).join('.');
	  return result + encoded;
	}

	/**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */
	function ucs2decode(string) {
	  var output = [],
	    counter = 0,
	    length = string.length,
	    value,
	    extra;
	  while (counter < length) {
	    value = string.charCodeAt(counter++);
	    if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
	      // high surrogate, and there is a next character
	      extra = string.charCodeAt(counter++);
	      if ((extra & 0xFC00) == 0xDC00) { // low surrogate
	        output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
	      } else {
	        // unmatched surrogate; only append this code unit, in case the next
	        // code unit is the high surrogate of a surrogate pair
	        output.push(value);
	        counter--;
	      }
	    } else {
	      output.push(value);
	    }
	  }
	  return output;
	}

	/**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */
	function digitToBasic(digit, flag) {
	  //  0..25 map to ASCII a..z or A..Z
	  // 26..35 map to ASCII 0..9
	  return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
	}

	/**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */
	function adapt(delta, numPoints, firstTime) {
	  var k = 0;
	  delta = firstTime ? floor$1(delta / damp) : delta >> 1;
	  delta += floor$1(delta / numPoints);
	  for ( /* no initialization */ ; delta > baseMinusTMin * tMax >> 1; k += base) {
	    delta = floor$1(delta / baseMinusTMin);
	  }
	  return floor$1(k + (baseMinusTMin + 1) * delta / (delta + skew));
	}

	/**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */
	function encode(input) {
	  var n,
	    delta,
	    handledCPCount,
	    basicLength,
	    bias,
	    j,
	    m,
	    q,
	    k,
	    t,
	    currentValue,
	    output = [],
	    /** `inputLength` will hold the number of code points in `input`. */
	    inputLength,
	    /** Cached calculation results */
	    handledCPCountPlusOne,
	    baseMinusT,
	    qMinusT;

	  // Convert the input in UCS-2 to Unicode
	  input = ucs2decode(input);

	  // Cache the length
	  inputLength = input.length;

	  // Initialize the state
	  n = initialN;
	  delta = 0;
	  bias = initialBias;

	  // Handle the basic code points
	  for (j = 0; j < inputLength; ++j) {
	    currentValue = input[j];
	    if (currentValue < 0x80) {
	      output.push(stringFromCharCode(currentValue));
	    }
	  }

	  handledCPCount = basicLength = output.length;

	  // `handledCPCount` is the number of code points that have been handled;
	  // `basicLength` is the number of basic code points.

	  // Finish the basic string - if it is not empty - with a delimiter
	  if (basicLength) {
	    output.push(delimiter);
	  }

	  // Main encoding loop:
	  while (handledCPCount < inputLength) {

	    // All non-basic code points < n have been handled already. Find the next
	    // larger one:
	    for (m = maxInt, j = 0; j < inputLength; ++j) {
	      currentValue = input[j];
	      if (currentValue >= n && currentValue < m) {
	        m = currentValue;
	      }
	    }

	    // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
	    // but guard against overflow
	    handledCPCountPlusOne = handledCPCount + 1;
	    if (m - n > floor$1((maxInt - delta) / handledCPCountPlusOne)) {
	      error('overflow');
	    }

	    delta += (m - n) * handledCPCountPlusOne;
	    n = m;

	    for (j = 0; j < inputLength; ++j) {
	      currentValue = input[j];

	      if (currentValue < n && ++delta > maxInt) {
	        error('overflow');
	      }

	      if (currentValue == n) {
	        // Represent delta as a generalized variable-length integer
	        for (q = delta, k = base; /* no condition */ ; k += base) {
	          t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
	          if (q < t) {
	            break;
	          }
	          qMinusT = q - t;
	          baseMinusT = base - t;
	          output.push(
	            stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
	          );
	          q = floor$1(qMinusT / baseMinusT);
	        }

	        output.push(stringFromCharCode(digitToBasic(q, 0)));
	        bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
	        delta = 0;
	        ++handledCPCount;
	      }
	    }

	    ++delta;
	    ++n;

	  }
	  return output.join('');
	}

	/**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */
	function toASCII(input) {
	  return mapDomain(input, function(string) {
	    return regexNonASCII.test(string) ?
	      'xn--' + encode(string) :
	      string;
	  });
	}

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.


	// If obj.hasOwnProperty has been overridden, then calling
	// obj.hasOwnProperty(prop) will break.
	// See: https://github.com/joyent/node/issues/1707
	function hasOwnProperty$1(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	var isArray$1 = Array.isArray || function (xs) {
	  return Object.prototype.toString.call(xs) === '[object Array]';
	};
	function stringifyPrimitive(v) {
	  switch (typeof v) {
	    case 'string':
	      return v;

	    case 'boolean':
	      return v ? 'true' : 'false';

	    case 'number':
	      return isFinite(v) ? v : '';

	    default:
	      return '';
	  }
	}

	function stringify$1 (obj, sep, eq, name) {
	  sep = sep || '&';
	  eq = eq || '=';
	  if (obj === null) {
	    obj = undefined;
	  }

	  if (typeof obj === 'object') {
	    return map$2(objectKeys(obj), function(k) {
	      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
	      if (isArray$1(obj[k])) {
	        return map$2(obj[k], function(v) {
	          return ks + encodeURIComponent(stringifyPrimitive(v));
	        }).join(sep);
	      } else {
	        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
	      }
	    }).join(sep);

	  }

	  if (!name) return '';
	  return encodeURIComponent(stringifyPrimitive(name)) + eq +
	         encodeURIComponent(stringifyPrimitive(obj));
	}
	function map$2 (xs, f) {
	  if (xs.map) return xs.map(f);
	  var res = [];
	  for (var i = 0; i < xs.length; i++) {
	    res.push(f(xs[i], i));
	  }
	  return res;
	}

	var objectKeys = Object.keys || function (obj) {
	  var res = [];
	  for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
	  }
	  return res;
	};

	function parse$a(qs, sep, eq, options) {
	  sep = sep || '&';
	  eq = eq || '=';
	  var obj = {};

	  if (typeof qs !== 'string' || qs.length === 0) {
	    return obj;
	  }

	  var regexp = /\+/g;
	  qs = qs.split(sep);

	  var maxKeys = 1000;
	  if (options && typeof options.maxKeys === 'number') {
	    maxKeys = options.maxKeys;
	  }

	  var len = qs.length;
	  // maxKeys <= 0 means that we should not limit keys count
	  if (maxKeys > 0 && len > maxKeys) {
	    len = maxKeys;
	  }

	  for (var i = 0; i < len; ++i) {
	    var x = qs[i].replace(regexp, '%20'),
	        idx = x.indexOf(eq),
	        kstr, vstr, k, v;

	    if (idx >= 0) {
	      kstr = x.substr(0, idx);
	      vstr = x.substr(idx + 1);
	    } else {
	      kstr = x;
	      vstr = '';
	    }

	    k = decodeURIComponent(kstr);
	    v = decodeURIComponent(vstr);

	    if (!hasOwnProperty$1(obj, k)) {
	      obj[k] = v;
	    } else if (isArray$1(obj[k])) {
	      obj[k].push(v);
	    } else {
	      obj[k] = [obj[k], v];
	    }
	  }

	  return obj;
	}

	// WHATWG API
	const URL = global$1.URL;
	const URLSearchParams = global$1.URLSearchParams;
	var _polyfillNode_url = {
	  parse: urlParse,
	  resolve: urlResolve,
	  resolveObject: urlResolveObject,
	  fileURLToPath: urlFileURLToPath,
	  format: urlFormat,
	  Url: Url,

	  // WHATWG API
	  URL,
	  URLSearchParams,  
	};
	function Url() {
	  this.protocol = null;
	  this.slashes = null;
	  this.auth = null;
	  this.host = null;
	  this.port = null;
	  this.hostname = null;
	  this.hash = null;
	  this.search = null;
	  this.query = null;
	  this.pathname = null;
	  this.path = null;
	  this.href = null;
	}

	// Reference: RFC 3986, RFC 1808, RFC 2396

	// define these here so at least they only have to be
	// compiled once on the first module load.
	var protocolPattern = /^([a-z0-9.+-]+:)/i,
	  portPattern = /:[0-9]*$/,

	  // Special case for a simple path URL
	  simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,

	  // RFC 2396: characters reserved for delimiting URLs.
	  // We actually just auto-escape these.
	  delims = ['<', '>', '"', '`', ' ', '\r', '\n', '\t'],

	  // RFC 2396: characters not allowed for various reasons.
	  unwise = ['{', '}', '|', '\\', '^', '`'].concat(delims),

	  // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
	  autoEscape = ['\''].concat(unwise),
	  // Characters that are never ever allowed in a hostname.
	  // Note that any invalid chars are also handled, but these
	  // are the ones that are *expected* to be seen, so we fast-path
	  // them.
	  nonHostChars = ['%', '/', '?', ';', '#'].concat(autoEscape),
	  hostEndingChars = ['/', '?', '#'],
	  hostnameMaxLen = 255,
	  hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/,
	  hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
	  // protocols that can allow "unsafe" and "unwise" chars.
	  unsafeProtocol = {
	    'javascript': true,
	    'javascript:': true
	  },
	  // protocols that never have a hostname.
	  hostlessProtocol = {
	    'javascript': true,
	    'javascript:': true
	  },
	  // protocols that always contain a // bit.
	  slashedProtocol = {
	    'http': true,
	    'https': true,
	    'ftp': true,
	    'gopher': true,
	    'file': true,
	    'http:': true,
	    'https:': true,
	    'ftp:': true,
	    'gopher:': true,
	    'file:': true
	  };

	function urlParse(url, parseQueryString, slashesDenoteHost) {
	  if (url && isObject$3(url) && url instanceof Url) return url;

	  var u = new Url;
	  u.parse(url, parseQueryString, slashesDenoteHost);
	  return u;
	}
	Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
	  return parse$9(this, url, parseQueryString, slashesDenoteHost);
	};

	function parse$9(self, url, parseQueryString, slashesDenoteHost) {
	  if (!isString$1(url)) {
	    throw new TypeError('Parameter \'url\' must be a string, not ' + typeof url);
	  }

	  // Copy chrome, IE, opera backslash-handling behavior.
	  // Back slashes before the query string get converted to forward slashes
	  // See: https://code.google.com/p/chromium/issues/detail?id=25916
	  var queryIndex = url.indexOf('?'),
	    splitter =
	    (queryIndex !== -1 && queryIndex < url.indexOf('#')) ? '?' : '#',
	    uSplit = url.split(splitter),
	    slashRegex = /\\/g;
	  uSplit[0] = uSplit[0].replace(slashRegex, '/');
	  url = uSplit.join(splitter);

	  var rest = url;

	  // trim before proceeding.
	  // This is to support parse stuff like "  http://foo.com  \n"
	  rest = rest.trim();

	  if (!slashesDenoteHost && url.split('#').length === 1) {
	    // Try fast path regexp
	    var simplePath = simplePathPattern.exec(rest);
	    if (simplePath) {
	      self.path = rest;
	      self.href = rest;
	      self.pathname = simplePath[1];
	      if (simplePath[2]) {
	        self.search = simplePath[2];
	        if (parseQueryString) {
	          self.query = parse$a(self.search.substr(1));
	        } else {
	          self.query = self.search.substr(1);
	        }
	      } else if (parseQueryString) {
	        self.search = '';
	        self.query = {};
	      }
	      return self;
	    }
	  }

	  var proto = protocolPattern.exec(rest);
	  if (proto) {
	    proto = proto[0];
	    var lowerProto = proto.toLowerCase();
	    self.protocol = lowerProto;
	    rest = rest.substr(proto.length);
	  }

	  // figure out if it's got a host
	  // user@server is *always* interpreted as a hostname, and url
	  // resolution will treat //foo/bar as host=foo,path=bar because that's
	  // how the browser resolves relative URLs.
	  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
	    var slashes = rest.substr(0, 2) === '//';
	    if (slashes && !(proto && hostlessProtocol[proto])) {
	      rest = rest.substr(2);
	      self.slashes = true;
	    }
	  }
	  var i, hec, l, p;
	  if (!hostlessProtocol[proto] &&
	    (slashes || (proto && !slashedProtocol[proto]))) {

	    // there's a hostname.
	    // the first instance of /, ?, ;, or # ends the host.
	    //
	    // If there is an @ in the hostname, then non-host chars *are* allowed
	    // to the left of the last @ sign, unless some host-ending character
	    // comes *before* the @-sign.
	    // URLs are obnoxious.
	    //
	    // ex:
	    // http://a@b@c/ => user:a@b host:c
	    // http://a@b?@c => user:a host:c path:/?@c

	    // v0.12 TODO(isaacs): This is not quite how Chrome does things.
	    // Review our test case against browsers more comprehensively.

	    // find the first instance of any hostEndingChars
	    var hostEnd = -1;
	    for (i = 0; i < hostEndingChars.length; i++) {
	      hec = rest.indexOf(hostEndingChars[i]);
	      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
	        hostEnd = hec;
	    }

	    // at this point, either we have an explicit point where the
	    // auth portion cannot go past, or the last @ char is the decider.
	    var auth, atSign;
	    if (hostEnd === -1) {
	      // atSign can be anywhere.
	      atSign = rest.lastIndexOf('@');
	    } else {
	      // atSign must be in auth portion.
	      // http://a@b/c@d => host:b auth:a path:/c@d
	      atSign = rest.lastIndexOf('@', hostEnd);
	    }

	    // Now we have a portion which is definitely the auth.
	    // Pull that off.
	    if (atSign !== -1) {
	      auth = rest.slice(0, atSign);
	      rest = rest.slice(atSign + 1);
	      self.auth = decodeURIComponent(auth);
	    }

	    // the host is the remaining to the left of the first non-host char
	    hostEnd = -1;
	    for (i = 0; i < nonHostChars.length; i++) {
	      hec = rest.indexOf(nonHostChars[i]);
	      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
	        hostEnd = hec;
	    }
	    // if we still have not hit it, then the entire thing is a host.
	    if (hostEnd === -1)
	      hostEnd = rest.length;

	    self.host = rest.slice(0, hostEnd);
	    rest = rest.slice(hostEnd);

	    // pull out port.
	    parseHost(self);

	    // we've indicated that there is a hostname,
	    // so even if it's empty, it has to be present.
	    self.hostname = self.hostname || '';

	    // if hostname begins with [ and ends with ]
	    // assume that it's an IPv6 address.
	    var ipv6Hostname = self.hostname[0] === '[' &&
	      self.hostname[self.hostname.length - 1] === ']';

	    // validate a little.
	    if (!ipv6Hostname) {
	      var hostparts = self.hostname.split(/\./);
	      for (i = 0, l = hostparts.length; i < l; i++) {
	        var part = hostparts[i];
	        if (!part) continue;
	        if (!part.match(hostnamePartPattern)) {
	          var newpart = '';
	          for (var j = 0, k = part.length; j < k; j++) {
	            if (part.charCodeAt(j) > 127) {
	              // we replace non-ASCII char with a temporary placeholder
	              // we need this to make sure size of hostname is not
	              // broken by replacing non-ASCII by nothing
	              newpart += 'x';
	            } else {
	              newpart += part[j];
	            }
	          }
	          // we test again with ASCII char only
	          if (!newpart.match(hostnamePartPattern)) {
	            var validParts = hostparts.slice(0, i);
	            var notHost = hostparts.slice(i + 1);
	            var bit = part.match(hostnamePartStart);
	            if (bit) {
	              validParts.push(bit[1]);
	              notHost.unshift(bit[2]);
	            }
	            if (notHost.length) {
	              rest = '/' + notHost.join('.') + rest;
	            }
	            self.hostname = validParts.join('.');
	            break;
	          }
	        }
	      }
	    }

	    if (self.hostname.length > hostnameMaxLen) {
	      self.hostname = '';
	    } else {
	      // hostnames are always lower case.
	      self.hostname = self.hostname.toLowerCase();
	    }

	    if (!ipv6Hostname) {
	      // IDNA Support: Returns a punycoded representation of "domain".
	      // It only converts parts of the domain name that
	      // have non-ASCII characters, i.e. it doesn't matter if
	      // you call it with a domain that already is ASCII-only.
	      self.hostname = toASCII(self.hostname);
	    }

	    p = self.port ? ':' + self.port : '';
	    var h = self.hostname || '';
	    self.host = h + p;
	    self.href += self.host;

	    // strip [ and ] from the hostname
	    // the host field still retains them, though
	    if (ipv6Hostname) {
	      self.hostname = self.hostname.substr(1, self.hostname.length - 2);
	      if (rest[0] !== '/') {
	        rest = '/' + rest;
	      }
	    }
	  }

	  // now rest is set to the post-host stuff.
	  // chop off any delim chars.
	  if (!unsafeProtocol[lowerProto]) {

	    // First, make 100% sure that any "autoEscape" chars get
	    // escaped, even if encodeURIComponent doesn't think they
	    // need to be.
	    for (i = 0, l = autoEscape.length; i < l; i++) {
	      var ae = autoEscape[i];
	      if (rest.indexOf(ae) === -1)
	        continue;
	      var esc = encodeURIComponent(ae);
	      if (esc === ae) {
	        esc = escape(ae);
	      }
	      rest = rest.split(ae).join(esc);
	    }
	  }


	  // chop off from the tail first.
	  var hash = rest.indexOf('#');
	  if (hash !== -1) {
	    // got a fragment string.
	    self.hash = rest.substr(hash);
	    rest = rest.slice(0, hash);
	  }
	  var qm = rest.indexOf('?');
	  if (qm !== -1) {
	    self.search = rest.substr(qm);
	    self.query = rest.substr(qm + 1);
	    if (parseQueryString) {
	      self.query = parse$a(self.query);
	    }
	    rest = rest.slice(0, qm);
	  } else if (parseQueryString) {
	    // no query string, but parseQueryString still requested
	    self.search = '';
	    self.query = {};
	  }
	  if (rest) self.pathname = rest;
	  if (slashedProtocol[lowerProto] &&
	    self.hostname && !self.pathname) {
	    self.pathname = '/';
	  }

	  //to support http.request
	  if (self.pathname || self.search) {
	    p = self.pathname || '';
	    var s = self.search || '';
	    self.path = p + s;
	  }

	  // finally, reconstruct the href based on what has been validated.
	  self.href = format$1(self);
	  return self;
	}

	function urlFileURLToPath(path) {
	  if (typeof path === 'string')
	    path = new Url().parse(path);
	  else if (!(path instanceof Url))
	    throw new TypeError('The "path" argument must be of type string or an instance of URL. Received type ' + (typeof path) + String(path));
	  if (path.protocol !== 'file:')
	    throw new TypeError('The URL must be of scheme file');
	  return getPathFromURLPosix(path);
	}

	function getPathFromURLPosix(url) {
	  const pathname = url.pathname;
	  for (let n = 0; n < pathname.length; n++) {
	    if (pathname[n] === '%') {
	      const third = pathname.codePointAt(n + 2) | 0x20;
	      if (pathname[n + 1] === '2' && third === 102) {
	        throw new TypeError(
	          'must not include encoded / characters'
	        );
	      }
	    }
	  }
	  return decodeURIComponent(pathname);
	}

	// format a parsed object into a url string
	function urlFormat(obj) {
	  // ensure it's an object, and not a string url.
	  // If it's an obj, this is a no-op.
	  // this way, you can call url_format() on strings
	  // to clean up potentially wonky urls.
	  if (isString$1(obj)) obj = parse$9({}, obj);
	  return format$1(obj);
	}

	function format$1(self) {
	  var auth = self.auth || '';
	  if (auth) {
	    auth = encodeURIComponent(auth);
	    auth = auth.replace(/%3A/i, ':');
	    auth += '@';
	  }

	  var protocol = self.protocol || '',
	    pathname = self.pathname || '',
	    hash = self.hash || '',
	    host = false,
	    query = '';

	  if (self.host) {
	    host = auth + self.host;
	  } else if (self.hostname) {
	    host = auth + (self.hostname.indexOf(':') === -1 ?
	      self.hostname :
	      '[' + this.hostname + ']');
	    if (self.port) {
	      host += ':' + self.port;
	    }
	  }

	  if (self.query &&
	    isObject$3(self.query) &&
	    Object.keys(self.query).length) {
	    query = stringify$1(self.query);
	  }

	  var search = self.search || (query && ('?' + query)) || '';

	  if (protocol && protocol.substr(-1) !== ':') protocol += ':';

	  // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
	  // unless they had them to begin with.
	  if (self.slashes ||
	    (!protocol || slashedProtocol[protocol]) && host !== false) {
	    host = '//' + (host || '');
	    if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
	  } else if (!host) {
	    host = '';
	  }

	  if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
	  if (search && search.charAt(0) !== '?') search = '?' + search;

	  pathname = pathname.replace(/[?#]/g, function(match) {
	    return encodeURIComponent(match);
	  });
	  search = search.replace('#', '%23');

	  return protocol + host + pathname + search + hash;
	}

	Url.prototype.format = function() {
	  return format$1(this);
	};

	function urlResolve(source, relative) {
	  return urlParse(source, false, true).resolve(relative);
	}

	Url.prototype.resolve = function(relative) {
	  return this.resolveObject(urlParse(relative, false, true)).format();
	};

	function urlResolveObject(source, relative) {
	  if (!source) return relative;
	  return urlParse(source, false, true).resolveObject(relative);
	}

	Url.prototype.resolveObject = function(relative) {
	  if (isString$1(relative)) {
	    var rel = new Url();
	    rel.parse(relative, false, true);
	    relative = rel;
	  }

	  var result = new Url();
	  var tkeys = Object.keys(this);
	  for (var tk = 0; tk < tkeys.length; tk++) {
	    var tkey = tkeys[tk];
	    result[tkey] = this[tkey];
	  }

	  // hash is always overridden, no matter what.
	  // even href="" will remove it.
	  result.hash = relative.hash;

	  // if the relative url is empty, then there's nothing left to do here.
	  if (relative.href === '') {
	    result.href = result.format();
	    return result;
	  }

	  // hrefs like //foo/bar always cut to the protocol.
	  if (relative.slashes && !relative.protocol) {
	    // take everything except the protocol from relative
	    var rkeys = Object.keys(relative);
	    for (var rk = 0; rk < rkeys.length; rk++) {
	      var rkey = rkeys[rk];
	      if (rkey !== 'protocol')
	        result[rkey] = relative[rkey];
	    }

	    //urlParse appends trailing / to urls like http://www.example.com
	    if (slashedProtocol[result.protocol] &&
	      result.hostname && !result.pathname) {
	      result.path = result.pathname = '/';
	    }

	    result.href = result.format();
	    return result;
	  }
	  var relPath;
	  if (relative.protocol && relative.protocol !== result.protocol) {
	    // if it's a known url protocol, then changing
	    // the protocol does weird things
	    // first, if it's not file:, then we MUST have a host,
	    // and if there was a path
	    // to begin with, then we MUST have a path.
	    // if it is file:, then the host is dropped,
	    // because that's known to be hostless.
	    // anything else is assumed to be absolute.
	    if (!slashedProtocol[relative.protocol]) {
	      var keys = Object.keys(relative);
	      for (var v = 0; v < keys.length; v++) {
	        var k = keys[v];
	        result[k] = relative[k];
	      }
	      result.href = result.format();
	      return result;
	    }

	    result.protocol = relative.protocol;
	    if (!relative.host && !hostlessProtocol[relative.protocol]) {
	      relPath = (relative.pathname || '').split('/');
	      while (relPath.length && !(relative.host = relPath.shift()));
	      if (!relative.host) relative.host = '';
	      if (!relative.hostname) relative.hostname = '';
	      if (relPath[0] !== '') relPath.unshift('');
	      if (relPath.length < 2) relPath.unshift('');
	      result.pathname = relPath.join('/');
	    } else {
	      result.pathname = relative.pathname;
	    }
	    result.search = relative.search;
	    result.query = relative.query;
	    result.host = relative.host || '';
	    result.auth = relative.auth;
	    result.hostname = relative.hostname || relative.host;
	    result.port = relative.port;
	    // to support http.request
	    if (result.pathname || result.search) {
	      var p = result.pathname || '';
	      var s = result.search || '';
	      result.path = p + s;
	    }
	    result.slashes = result.slashes || relative.slashes;
	    result.href = result.format();
	    return result;
	  }

	  var isSourceAbs = (result.pathname && result.pathname.charAt(0) === '/'),
	    isRelAbs = (
	      relative.host ||
	      relative.pathname && relative.pathname.charAt(0) === '/'
	    ),
	    mustEndAbs = (isRelAbs || isSourceAbs ||
	      (result.host && relative.pathname)),
	    removeAllDots = mustEndAbs,
	    srcPath = result.pathname && result.pathname.split('/') || [],
	    psychotic = result.protocol && !slashedProtocol[result.protocol];
	  relPath = relative.pathname && relative.pathname.split('/') || [];
	  // if the url is a non-slashed url, then relative
	  // links like ../.. should be able
	  // to crawl up to the hostname, as well.  This is strange.
	  // result.protocol has already been set by now.
	  // Later on, put the first path part into the host field.
	  if (psychotic) {
	    result.hostname = '';
	    result.port = null;
	    if (result.host) {
	      if (srcPath[0] === '') srcPath[0] = result.host;
	      else srcPath.unshift(result.host);
	    }
	    result.host = '';
	    if (relative.protocol) {
	      relative.hostname = null;
	      relative.port = null;
	      if (relative.host) {
	        if (relPath[0] === '') relPath[0] = relative.host;
	        else relPath.unshift(relative.host);
	      }
	      relative.host = null;
	    }
	    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
	  }
	  var authInHost;
	  if (isRelAbs) {
	    // it's absolute.
	    result.host = (relative.host || relative.host === '') ?
	      relative.host : result.host;
	    result.hostname = (relative.hostname || relative.hostname === '') ?
	      relative.hostname : result.hostname;
	    result.search = relative.search;
	    result.query = relative.query;
	    srcPath = relPath;
	    // fall through to the dot-handling below.
	  } else if (relPath.length) {
	    // it's relative
	    // throw away the existing file, and take the new path instead.
	    if (!srcPath) srcPath = [];
	    srcPath.pop();
	    srcPath = srcPath.concat(relPath);
	    result.search = relative.search;
	    result.query = relative.query;
	  } else if (!isNullOrUndefined(relative.search)) {
	    // just pull out the search.
	    // like href='?foo'.
	    // Put this after the other two cases because it simplifies the booleans
	    if (psychotic) {
	      result.hostname = result.host = srcPath.shift();
	      //occationaly the auth can get stuck only in host
	      //this especially happens in cases like
	      //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
	      authInHost = result.host && result.host.indexOf('@') > 0 ?
	        result.host.split('@') : false;
	      if (authInHost) {
	        result.auth = authInHost.shift();
	        result.host = result.hostname = authInHost.shift();
	      }
	    }
	    result.search = relative.search;
	    result.query = relative.query;
	    //to support http.request
	    if (!isNull$1(result.pathname) || !isNull$1(result.search)) {
	      result.path = (result.pathname ? result.pathname : '') +
	        (result.search ? result.search : '');
	    }
	    result.href = result.format();
	    return result;
	  }

	  if (!srcPath.length) {
	    // no path at all.  easy.
	    // we've already handled the other stuff above.
	    result.pathname = null;
	    //to support http.request
	    if (result.search) {
	      result.path = '/' + result.search;
	    } else {
	      result.path = null;
	    }
	    result.href = result.format();
	    return result;
	  }

	  // if a url ENDs in . or .., then it must get a trailing slash.
	  // however, if it ends in anything else non-slashy,
	  // then it must NOT get a trailing slash.
	  var last = srcPath.slice(-1)[0];
	  var hasTrailingSlash = (
	    (result.host || relative.host || srcPath.length > 1) &&
	    (last === '.' || last === '..') || last === '');

	  // strip single dots, resolve double dots to parent dir
	  // if the path tries to go above the root, `up` ends up > 0
	  var up = 0;
	  for (var i = srcPath.length; i >= 0; i--) {
	    last = srcPath[i];
	    if (last === '.') {
	      srcPath.splice(i, 1);
	    } else if (last === '..') {
	      srcPath.splice(i, 1);
	      up++;
	    } else if (up) {
	      srcPath.splice(i, 1);
	      up--;
	    }
	  }

	  // if the path is allowed to go above the root, restore leading ..s
	  if (!mustEndAbs && !removeAllDots) {
	    for (; up--; up) {
	      srcPath.unshift('..');
	    }
	  }

	  if (mustEndAbs && srcPath[0] !== '' &&
	    (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
	    srcPath.unshift('');
	  }

	  if (hasTrailingSlash && (srcPath.join('/').substr(-1) !== '/')) {
	    srcPath.push('');
	  }

	  var isAbsolute = srcPath[0] === '' ||
	    (srcPath[0] && srcPath[0].charAt(0) === '/');

	  // put the host back
	  if (psychotic) {
	    result.hostname = result.host = isAbsolute ? '' :
	      srcPath.length ? srcPath.shift() : '';
	    //occationaly the auth can get stuck only in host
	    //this especially happens in cases like
	    //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
	    authInHost = result.host && result.host.indexOf('@') > 0 ?
	      result.host.split('@') : false;
	    if (authInHost) {
	      result.auth = authInHost.shift();
	      result.host = result.hostname = authInHost.shift();
	    }
	  }

	  mustEndAbs = mustEndAbs || (result.host && srcPath.length);

	  if (mustEndAbs && !isAbsolute) {
	    srcPath.unshift('');
	  }

	  if (!srcPath.length) {
	    result.pathname = null;
	    result.path = null;
	  } else {
	    result.pathname = srcPath.join('/');
	  }

	  //to support request.http
	  if (!isNull$1(result.pathname) || !isNull$1(result.search)) {
	    result.path = (result.pathname ? result.pathname : '') +
	      (result.search ? result.search : '');
	  }
	  result.auth = relative.auth || result.auth;
	  result.slashes = result.slashes || relative.slashes;
	  result.href = result.format();
	  return result;
	};

	Url.prototype.parseHost = function() {
	  return parseHost(this);
	};

	function parseHost(self) {
	  var host = self.host;
	  var port = portPattern.exec(host);
	  if (port) {
	    port = port[0];
	    if (port !== ':') {
	      self.port = port.substr(1);
	    }
	    host = host.substr(0, host.length - port.length);
	  }
	  if (host) self.hostname = host;
	}

	var _polyfillNode_url$1 = /*#__PURE__*/Object.freeze({
		__proto__: null,
		parse: urlParse,
		resolve: urlResolve,
		resolveObject: urlResolveObject,
		fileURLToPath: urlFileURLToPath,
		format: urlFormat,
		URL: URL,
		URLSearchParams: URLSearchParams,
		'default': _polyfillNode_url,
		Url: Url
	});

	var require$$0$2 = /*@__PURE__*/getAugmentedNamespace(_polyfillNode_url$1);

	(function (module, exports) {

		let isWindows = /^win/.test(browser$1.platform),
		    forwardSlashPattern = /\//g,
		    protocolPattern = /^(\w{2,}):\/\//i,
		    url = module.exports,
		    jsonPointerSlash = /~1/g,
		    jsonPointerTilde = /~0/g;

		// RegExp patterns to URL-encode special characters in local filesystem paths
		let urlEncodePatterns = [
		  /\?/g, "%3F",
		  /\#/g, "%23",
		];

		// RegExp patterns to URL-decode special characters for local filesystem paths
		let urlDecodePatterns = [
		  /\%23/g, "#",
		  /\%24/g, "$",
		  /\%26/g, "&",
		  /\%2C/g, ",",
		  /\%40/g, "@"
		];

		exports.parse = require$$0$2.parse;
		exports.resolve = require$$0$2.resolve;

		/**
		 * Returns the current working directory (in Node) or the current page URL (in browsers).
		 *
		 * @returns {string}
		 */
		exports.cwd = function cwd () {
		  if (browser$1.browser) {
		    return location.href;
		  }

		  let path = browser$1.cwd();

		  let lastChar = path.slice(-1);
		  if (lastChar === "/" || lastChar === "\\") {
		    return path;
		  }
		  else {
		    return path + "/";
		  }
		};

		/**
		 * Returns the protocol of the given URL, or `undefined` if it has no protocol.
		 *
		 * @param   {string} path
		 * @returns {?string}
		 */
		exports.getProtocol = function getProtocol (path) {
		  let match = protocolPattern.exec(path);
		  if (match) {
		    return match[1].toLowerCase();
		  }
		};

		/**
		 * Returns the lowercased file extension of the given URL,
		 * or an empty string if it has no extension.
		 *
		 * @param   {string} path
		 * @returns {string}
		 */
		exports.getExtension = function getExtension (path) {
		  let lastDot = path.lastIndexOf(".");
		  if (lastDot >= 0) {
		    return url.stripQuery(path.substr(lastDot).toLowerCase());
		  }
		  return "";
		};

		/**
		 * Removes the query, if any, from the given path.
		 *
		 * @param   {string} path
		 * @returns {string}
		 */
		exports.stripQuery = function stripQuery (path) {
		  let queryIndex = path.indexOf("?");
		  if (queryIndex >= 0) {
		    path = path.substr(0, queryIndex);
		  }
		  return path;
		};

		/**
		 * Returns the hash (URL fragment), of the given path.
		 * If there is no hash, then the root hash ("#") is returned.
		 *
		 * @param   {string} path
		 * @returns {string}
		 */
		exports.getHash = function getHash (path) {
		  let hashIndex = path.indexOf("#");
		  if (hashIndex >= 0) {
		    return path.substr(hashIndex);
		  }
		  return "#";
		};

		/**
		 * Removes the hash (URL fragment), if any, from the given path.
		 *
		 * @param   {string} path
		 * @returns {string}
		 */
		exports.stripHash = function stripHash (path) {
		  let hashIndex = path.indexOf("#");
		  if (hashIndex >= 0) {
		    path = path.substr(0, hashIndex);
		  }
		  return path;
		};

		/**
		 * Determines whether the given path is an HTTP(S) URL.
		 *
		 * @param   {string} path
		 * @returns {boolean}
		 */
		exports.isHttp = function isHttp (path) {
		  let protocol = url.getProtocol(path);
		  if (protocol === "http" || protocol === "https") {
		    return true;
		  }
		  else if (protocol === undefined) {
		    // There is no protocol.  If we're running in a browser, then assume it's HTTP.
		    return browser$1.browser;
		  }
		  else {
		    // It's some other protocol, such as "ftp://", "mongodb://", etc.
		    return false;
		  }
		};

		/**
		 * Determines whether the given path is a filesystem path.
		 * This includes "file://" URLs.
		 *
		 * @param   {string} path
		 * @returns {boolean}
		 */
		exports.isFileSystemPath = function isFileSystemPath (path) {
		  if (browser$1.browser) {
		    // We're running in a browser, so assume that all paths are URLs.
		    // This way, even relative paths will be treated as URLs rather than as filesystem paths
		    return false;
		  }

		  let protocol = url.getProtocol(path);
		  return protocol === undefined || protocol === "file";
		};

		/**
		 * Converts a filesystem path to a properly-encoded URL.
		 *
		 * This is intended to handle situations where JSON Schema $Ref Parser is called
		 * with a filesystem path that contains characters which are not allowed in URLs.
		 *
		 * @example
		 * The following filesystem paths would be converted to the following URLs:
		 *
		 *    <"!@#$%^&*+=?'>.json              ==>   %3C%22!@%23$%25%5E&*+=%3F\'%3E.json
		 *    C:\\My Documents\\File (1).json   ==>   C:/My%20Documents/File%20(1).json
		 *    file://Project #42/file.json      ==>   file://Project%20%2342/file.json
		 *
		 * @param {string} path
		 * @returns {string}
		 */
		exports.fromFileSystemPath = function fromFileSystemPath (path) {
		  // Step 1: On Windows, replace backslashes with forward slashes,
		  // rather than encoding them as "%5C"
		  if (isWindows) {
		    path = path.replace(/\\/g, "/");
		  }

		  // Step 2: `encodeURI` will take care of MOST characters
		  path = encodeURI(path);

		  // Step 3: Manually encode characters that are not encoded by `encodeURI`.
		  // This includes characters such as "#" and "?", which have special meaning in URLs,
		  // but are just normal characters in a filesystem path.
		  for (let i = 0; i < urlEncodePatterns.length; i += 2) {
		    path = path.replace(urlEncodePatterns[i], urlEncodePatterns[i + 1]);
		  }

		  return path;
		};

		/**
		 * Converts a URL to a local filesystem path.
		 *
		 * @param {string}  path
		 * @param {boolean} [keepFileProtocol] - If true, then "file://" will NOT be stripped
		 * @returns {string}
		 */
		exports.toFileSystemPath = function toFileSystemPath (path, keepFileProtocol) {
		  // Step 1: `decodeURI` will decode characters such as Cyrillic characters, spaces, etc.
		  path = decodeURI(path);

		  // Step 2: Manually decode characters that are not decoded by `decodeURI`.
		  // This includes characters such as "#" and "?", which have special meaning in URLs,
		  // but are just normal characters in a filesystem path.
		  for (let i = 0; i < urlDecodePatterns.length; i += 2) {
		    path = path.replace(urlDecodePatterns[i], urlDecodePatterns[i + 1]);
		  }

		  // Step 3: If it's a "file://" URL, then format it consistently
		  // or convert it to a local filesystem path
		  let isFileUrl = path.substr(0, 7).toLowerCase() === "file://";
		  if (isFileUrl) {
		    // Strip-off the protocol, and the initial "/", if there is one
		    path = path[7] === "/" ? path.substr(8) : path.substr(7);

		    // insert a colon (":") after the drive letter on Windows
		    if (isWindows && path[1] === "/") {
		      path = path[0] + ":" + path.substr(1);
		    }

		    if (keepFileProtocol) {
		      // Return the consistently-formatted "file://" URL
		      path = "file:///" + path;
		    }
		    else {
		      // Convert the "file://" URL to a local filesystem path.
		      // On Windows, it will start with something like "C:/".
		      // On Posix, it will start with "/"
		      isFileUrl = false;
		      path = isWindows ? path : "/" + path;
		    }
		  }

		  // Step 4: Normalize Windows paths (unless it's a "file://" URL)
		  if (isWindows && !isFileUrl) {
		    // Replace forward slashes with backslashes
		    path = path.replace(forwardSlashPattern, "\\");

		    // Capitalize the drive letter
		    if (path.substr(1, 2) === ":\\") {
		      path = path[0].toUpperCase() + path.substr(1);
		    }
		  }

		  return path;
		};

		/**
		 * Converts a $ref pointer to a valid JSON Path.
		 *
		 * @param {string}  pointer
		 * @returns {Array<number | string>}
		 */
		exports.safePointerToPath = function safePointerToPath (pointer) {
		  if (pointer.length <= 1 || pointer[0] !== "#" || pointer[1] !== "/") {
		    return [];
		  }

		  return pointer
		    .slice(2)
		    .split("/")
		    .map((value) => {
		      return decodeURIComponent(value)
		        .replace(jsonPointerSlash, "/")
		        .replace(jsonPointerTilde, "~");
		    });
		};
	} (url$8, urlExports));

	const { Ono } = require$$6;

	const { stripHash, toFileSystemPath } = urlExports;

	const JSONParserError$1 = errors$1.JSONParserError = class JSONParserError extends Error {
	  constructor (message, source) {
	    super();

	    this.code = "EUNKNOWN";
	    this.message = message;
	    this.source = source;
	    this.path = null;

	    Ono.extend(this);
	  }

	  get footprint () {
	    return `${this.path}+${this.source}+${this.code}+${this.message}`;
	  }
	};

	setErrorName(JSONParserError$1);

	const JSONParserErrorGroup$1 = errors$1.JSONParserErrorGroup = class JSONParserErrorGroup extends Error {
	  constructor (parser) {
	    super();

	    this.files = parser;
	    this.message = `${this.errors.length} error${this.errors.length > 1 ? "s" : ""} occurred while reading '${toFileSystemPath(parser.$refs._root$Ref.path)}'`;

	    Ono.extend(this);
	  }

	  static getParserErrors (parser) {
	    const errors = [];

	    for (const $ref of Object.values(parser.$refs._$refs)) {
	      if ($ref.errors) {
	        errors.push(...$ref.errors);
	      }
	    }

	    return errors;
	  }

	  get errors () {
	    return JSONParserErrorGroup.getParserErrors(this.files);
	  }
	};

	setErrorName(JSONParserErrorGroup$1);

	const ParserError$5 = errors$1.ParserError = class ParserError extends JSONParserError$1 {
	  constructor (message, source) {
	    super(`Error parsing ${source}: ${message}`, source);

	    this.code = "EPARSER";
	  }
	};

	setErrorName(ParserError$5);

	const UnmatchedParserError$2 = errors$1.UnmatchedParserError = class UnmatchedParserError extends JSONParserError$1 {
	  constructor (source) {
	    super(`Could not find parser for "${source}"`, source);

	    this.code = "EUNMATCHEDPARSER";
	  }
	};

	setErrorName(UnmatchedParserError$2);

	const ResolverError$4 = errors$1.ResolverError = class ResolverError extends JSONParserError$1 {
	  constructor (ex, source) {
	    super(ex.message || `Error reading file "${source}"`, source);

	    this.code = "ERESOLVER";

	    if ("code" in ex) {
	      this.ioErrorCode = String(ex.code);
	    }
	  }
	};

	setErrorName(ResolverError$4);

	const UnmatchedResolverError$2 = errors$1.UnmatchedResolverError = class UnmatchedResolverError extends JSONParserError$1 {
	  constructor (source) {
	    super(`Could not find resolver for "${source}"`, source);

	    this.code = "EUNMATCHEDRESOLVER";
	  }
	};

	setErrorName(UnmatchedResolverError$2);

	const MissingPointerError$1 = errors$1.MissingPointerError = class MissingPointerError extends JSONParserError$1 {
	  constructor (token, path) {
	    super(`Token "${token}" does not exist.`, stripHash(path));

	    this.code = "EMISSINGPOINTER";
	  }
	};

	setErrorName(MissingPointerError$1);

	const InvalidPointerError$1 = errors$1.InvalidPointerError = class InvalidPointerError extends JSONParserError$1 {
	  constructor (pointer, path) {
	    super(`Invalid $ref pointer "${pointer}". Pointers must begin with "#/"`, stripHash(path));

	    this.code = "EINVALIDPOINTER";
	  }
	};

	setErrorName(InvalidPointerError$1);

	function setErrorName (err) {
	  Object.defineProperty(err.prototype, "name", {
	    value: err.name,
	    enumerable: true,
	  });
	}

	errors$1.isHandledError = function (err) {
	  return err instanceof JSONParserError$1 || err instanceof JSONParserErrorGroup$1;
	};

	errors$1.normalizeError = function (err) {
	  if (err.path === null) {
	    err.path = [];
	  }

	  return err;
	};

	const { ParserError: ParserError$4 } = errors$1;

	var json$2 = {
	  /**
	   * The order that this parser will run, in relation to other parsers.
	   *
	   * @type {number}
	   */
	  order: 100,

	  /**
	   * Whether to allow "empty" files. This includes zero-byte files, as well as empty JSON objects.
	   *
	   * @type {boolean}
	   */
	  allowEmpty: true,

	  /**
	   * Determines whether this parser can parse a given file reference.
	   * Parsers that match will be tried, in order, until one successfully parses the file.
	   * Parsers that don't match will be skipped, UNLESS none of the parsers match, in which case
	   * every parser will be tried.
	   *
	   * @type {RegExp|string|string[]|function}
	   */
	  canParse: ".json",

	  /**
	   * Parses the given file as JSON
	   *
	   * @param {object} file           - An object containing information about the referenced file
	   * @param {string} file.url       - The full URL of the referenced file
	   * @param {string} file.extension - The lowercased file extension (e.g. ".txt", ".html", etc.)
	   * @param {*}      file.data      - The file contents. This will be whatever data type was returned by the resolver
	   * @returns {Promise}
	   */
	  async parse (file) {      // eslint-disable-line require-await
	    let data = file.data;
	    if (Buffer.isBuffer(data)) {
	      data = data.toString();
	    }

	    if (typeof data === "string") {
	      if (data.trim().length === 0) {
	        return; // This mirrors the YAML behavior
	      }
	      else {
	        try {
	          return JSON.parse(data);
	        }
	        catch (e) {
	          throw new ParserError$4(e.message, file.url);
	        }
	      }
	    }
	    else {
	      // data is already a JavaScript value (object, array, number, null, NaN, etc.)
	      return data;
	    }
	  }
	};

	var jsYaml = {};

	var loader$1 = {};

	var common$5 = {};

	function isNothing(subject) {
	  return (typeof subject === 'undefined') || (subject === null);
	}


	function isObject$1(subject) {
	  return (typeof subject === 'object') && (subject !== null);
	}


	function toArray$1(sequence) {
	  if (Array.isArray(sequence)) return sequence;
	  else if (isNothing(sequence)) return [];

	  return [ sequence ];
	}


	function extend(target, source) {
	  var index, length, key, sourceKeys;

	  if (source) {
	    sourceKeys = Object.keys(source);

	    for (index = 0, length = sourceKeys.length; index < length; index += 1) {
	      key = sourceKeys[index];
	      target[key] = source[key];
	    }
	  }

	  return target;
	}


	function repeat(string, count) {
	  var result = '', cycle;

	  for (cycle = 0; cycle < count; cycle += 1) {
	    result += string;
	  }

	  return result;
	}


	function isNegativeZero(number) {
	  return (number === 0) && (Number.NEGATIVE_INFINITY === 1 / number);
	}


	common$5.isNothing      = isNothing;
	common$5.isObject       = isObject$1;
	common$5.toArray        = toArray$1;
	common$5.repeat         = repeat;
	common$5.isNegativeZero = isNegativeZero;
	common$5.extend         = extend;

	function formatError(exception, compact) {
	  var where = '', message = exception.reason || '(unknown reason)';

	  if (!exception.mark) return message;

	  if (exception.mark.name) {
	    where += 'in "' + exception.mark.name + '" ';
	  }

	  where += '(' + (exception.mark.line + 1) + ':' + (exception.mark.column + 1) + ')';

	  if (!compact && exception.mark.snippet) {
	    where += '\n\n' + exception.mark.snippet;
	  }

	  return message + ' ' + where;
	}


	function YAMLException$4(reason, mark) {
	  // Super constructor
	  Error.call(this);

	  this.name = 'YAMLException';
	  this.reason = reason;
	  this.mark = mark;
	  this.message = formatError(this, false);

	  // Include stack trace in error object
	  if (Error.captureStackTrace) {
	    // Chrome and NodeJS
	    Error.captureStackTrace(this, this.constructor);
	  } else {
	    // FF, IE 10+ and Safari 6+. Fallback for others
	    this.stack = (new Error()).stack || '';
	  }
	}


	// Inherit from Error
	YAMLException$4.prototype = Object.create(Error.prototype);
	YAMLException$4.prototype.constructor = YAMLException$4;


	YAMLException$4.prototype.toString = function toString(compact) {
	  return this.name + ': ' + formatError(this, compact);
	};


	var exception = YAMLException$4;

	var common$4 = common$5;


	// get snippet for a single line, respecting maxLength
	function getLine(buffer, lineStart, lineEnd, position, maxLineLength) {
	  var head = '';
	  var tail = '';
	  var maxHalfLength = Math.floor(maxLineLength / 2) - 1;

	  if (position - lineStart > maxHalfLength) {
	    head = ' ... ';
	    lineStart = position - maxHalfLength + head.length;
	  }

	  if (lineEnd - position > maxHalfLength) {
	    tail = ' ...';
	    lineEnd = position + maxHalfLength - tail.length;
	  }

	  return {
	    str: head + buffer.slice(lineStart, lineEnd).replace(/\t/g, '→') + tail,
	    pos: position - lineStart + head.length // relative position
	  };
	}


	function padStart$1(string, max) {
	  return common$4.repeat(' ', max - string.length) + string;
	}


	function makeSnippet$1(mark, options) {
	  options = Object.create(options || null);

	  if (!mark.buffer) return null;

	  if (!options.maxLength) options.maxLength = 79;
	  if (typeof options.indent      !== 'number') options.indent      = 1;
	  if (typeof options.linesBefore !== 'number') options.linesBefore = 3;
	  if (typeof options.linesAfter  !== 'number') options.linesAfter  = 2;

	  var re = /\r?\n|\r|\0/g;
	  var lineStarts = [ 0 ];
	  var lineEnds = [];
	  var match;
	  var foundLineNo = -1;

	  while ((match = re.exec(mark.buffer))) {
	    lineEnds.push(match.index);
	    lineStarts.push(match.index + match[0].length);

	    if (mark.position <= match.index && foundLineNo < 0) {
	      foundLineNo = lineStarts.length - 2;
	    }
	  }

	  if (foundLineNo < 0) foundLineNo = lineStarts.length - 1;

	  var result = '', i, line;
	  var lineNoLength = Math.min(mark.line + options.linesAfter, lineEnds.length).toString().length;
	  var maxLineLength = options.maxLength - (options.indent + lineNoLength + 3);

	  for (i = 1; i <= options.linesBefore; i++) {
	    if (foundLineNo - i < 0) break;
	    line = getLine(
	      mark.buffer,
	      lineStarts[foundLineNo - i],
	      lineEnds[foundLineNo - i],
	      mark.position - (lineStarts[foundLineNo] - lineStarts[foundLineNo - i]),
	      maxLineLength
	    );
	    result = common$4.repeat(' ', options.indent) + padStart$1((mark.line - i + 1).toString(), lineNoLength) +
	      ' | ' + line.str + '\n' + result;
	  }

	  line = getLine(mark.buffer, lineStarts[foundLineNo], lineEnds[foundLineNo], mark.position, maxLineLength);
	  result += common$4.repeat(' ', options.indent) + padStart$1((mark.line + 1).toString(), lineNoLength) +
	    ' | ' + line.str + '\n';
	  result += common$4.repeat('-', options.indent + lineNoLength + 3 + line.pos) + '^' + '\n';

	  for (i = 1; i <= options.linesAfter; i++) {
	    if (foundLineNo + i >= lineEnds.length) break;
	    line = getLine(
	      mark.buffer,
	      lineStarts[foundLineNo + i],
	      lineEnds[foundLineNo + i],
	      mark.position - (lineStarts[foundLineNo] - lineStarts[foundLineNo + i]),
	      maxLineLength
	    );
	    result += common$4.repeat(' ', options.indent) + padStart$1((mark.line + i + 1).toString(), lineNoLength) +
	      ' | ' + line.str + '\n';
	  }

	  return result.replace(/\n$/, '');
	}


	var snippet = makeSnippet$1;

	var coreExports = {};
	var core = {
	  get exports(){ return coreExports; },
	  set exports(v){ coreExports = v; },
	};

	var YAMLException$3 = exception;

	var TYPE_CONSTRUCTOR_OPTIONS = [
	  'kind',
	  'multi',
	  'resolve',
	  'construct',
	  'instanceOf',
	  'predicate',
	  'represent',
	  'representName',
	  'defaultStyle',
	  'styleAliases'
	];

	var YAML_NODE_KINDS = [
	  'scalar',
	  'sequence',
	  'mapping'
	];

	function compileStyleAliases(map) {
	  var result = {};

	  if (map !== null) {
	    Object.keys(map).forEach(function (style) {
	      map[style].forEach(function (alias) {
	        result[String(alias)] = style;
	      });
	    });
	  }

	  return result;
	}

	function Type$e(tag, options) {
	  options = options || {};

	  Object.keys(options).forEach(function (name) {
	    if (TYPE_CONSTRUCTOR_OPTIONS.indexOf(name) === -1) {
	      throw new YAMLException$3('Unknown option "' + name + '" is met in definition of "' + tag + '" YAML type.');
	    }
	  });

	  // TODO: Add tag format check.
	  this.options       = options; // keep original options in case user wants to extend this type later
	  this.tag           = tag;
	  this.kind          = options['kind']          || null;
	  this.resolve       = options['resolve']       || function () { return true; };
	  this.construct     = options['construct']     || function (data) { return data; };
	  this.instanceOf    = options['instanceOf']    || null;
	  this.predicate     = options['predicate']     || null;
	  this.represent     = options['represent']     || null;
	  this.representName = options['representName'] || null;
	  this.defaultStyle  = options['defaultStyle']  || null;
	  this.multi         = options['multi']         || false;
	  this.styleAliases  = compileStyleAliases(options['styleAliases'] || null);

	  if (YAML_NODE_KINDS.indexOf(this.kind) === -1) {
	    throw new YAMLException$3('Unknown kind "' + this.kind + '" is specified for "' + tag + '" YAML type.');
	  }
	}

	var type = Type$e;

	/*eslint-disable max-len*/

	var YAMLException$2 = exception;
	var Type$d          = type;


	function compileList(schema, name) {
	  var result = [];

	  schema[name].forEach(function (currentType) {
	    var newIndex = result.length;

	    result.forEach(function (previousType, previousIndex) {
	      if (previousType.tag === currentType.tag &&
	          previousType.kind === currentType.kind &&
	          previousType.multi === currentType.multi) {

	        newIndex = previousIndex;
	      }
	    });

	    result[newIndex] = currentType;
	  });

	  return result;
	}


	function compileMap(/* lists... */) {
	  var result = {
	        scalar: {},
	        sequence: {},
	        mapping: {},
	        fallback: {},
	        multi: {
	          scalar: [],
	          sequence: [],
	          mapping: [],
	          fallback: []
	        }
	      }, index, length;

	  function collectType(type) {
	    if (type.multi) {
	      result.multi[type.kind].push(type);
	      result.multi['fallback'].push(type);
	    } else {
	      result[type.kind][type.tag] = result['fallback'][type.tag] = type;
	    }
	  }

	  for (index = 0, length = arguments.length; index < length; index += 1) {
	    arguments[index].forEach(collectType);
	  }
	  return result;
	}


	function Schema$1(definition) {
	  return this.extend(definition);
	}


	Schema$1.prototype.extend = function extend(definition) {
	  var implicit = [];
	  var explicit = [];

	  if (definition instanceof Type$d) {
	    // Schema.extend(type)
	    explicit.push(definition);

	  } else if (Array.isArray(definition)) {
	    // Schema.extend([ type1, type2, ... ])
	    explicit = explicit.concat(definition);

	  } else if (definition && (Array.isArray(definition.implicit) || Array.isArray(definition.explicit))) {
	    // Schema.extend({ explicit: [ type1, type2, ... ], implicit: [ type1, type2, ... ] })
	    if (definition.implicit) implicit = implicit.concat(definition.implicit);
	    if (definition.explicit) explicit = explicit.concat(definition.explicit);

	  } else {
	    throw new YAMLException$2('Schema.extend argument should be a Type, [ Type ], ' +
	      'or a schema definition ({ implicit: [...], explicit: [...] })');
	  }

	  implicit.forEach(function (type) {
	    if (!(type instanceof Type$d)) {
	      throw new YAMLException$2('Specified list of YAML types (or a single Type object) contains a non-Type object.');
	    }

	    if (type.loadKind && type.loadKind !== 'scalar') {
	      throw new YAMLException$2('There is a non-scalar type in the implicit list of a schema. Implicit resolving of such types is not supported.');
	    }

	    if (type.multi) {
	      throw new YAMLException$2('There is a multi type in the implicit list of a schema. Multi tags can only be listed as explicit.');
	    }
	  });

	  explicit.forEach(function (type) {
	    if (!(type instanceof Type$d)) {
	      throw new YAMLException$2('Specified list of YAML types (or a single Type object) contains a non-Type object.');
	    }
	  });

	  var result = Object.create(Schema$1.prototype);

	  result.implicit = (this.implicit || []).concat(implicit);
	  result.explicit = (this.explicit || []).concat(explicit);

	  result.compiledImplicit = compileList(result, 'implicit');
	  result.compiledExplicit = compileList(result, 'explicit');
	  result.compiledTypeMap  = compileMap(result.compiledImplicit, result.compiledExplicit);

	  return result;
	};


	var schema = Schema$1;

	var Type$c = type;

	var str = new Type$c('tag:yaml.org,2002:str', {
	  kind: 'scalar',
	  construct: function (data) { return data !== null ? data : ''; }
	});

	var Type$b = type;

	var seq = new Type$b('tag:yaml.org,2002:seq', {
	  kind: 'sequence',
	  construct: function (data) { return data !== null ? data : []; }
	});

	var Type$a = type;

	var map$1 = new Type$a('tag:yaml.org,2002:map', {
	  kind: 'mapping',
	  construct: function (data) { return data !== null ? data : {}; }
	});

	var Schema = schema;


	var failsafe = new Schema({
	  explicit: [
	    str,
	    seq,
	    map$1
	  ]
	});

	var Type$9 = type;

	function resolveYamlNull(data) {
	  if (data === null) return true;

	  var max = data.length;

	  return (max === 1 && data === '~') ||
	         (max === 4 && (data === 'null' || data === 'Null' || data === 'NULL'));
	}

	function constructYamlNull() {
	  return null;
	}

	function isNull(object) {
	  return object === null;
	}

	var _null = new Type$9('tag:yaml.org,2002:null', {
	  kind: 'scalar',
	  resolve: resolveYamlNull,
	  construct: constructYamlNull,
	  predicate: isNull,
	  represent: {
	    canonical: function () { return '~';    },
	    lowercase: function () { return 'null'; },
	    uppercase: function () { return 'NULL'; },
	    camelcase: function () { return 'Null'; },
	    empty:     function () { return '';     }
	  },
	  defaultStyle: 'lowercase'
	});

	var Type$8 = type;

	function resolveYamlBoolean(data) {
	  if (data === null) return false;

	  var max = data.length;

	  return (max === 4 && (data === 'true' || data === 'True' || data === 'TRUE')) ||
	         (max === 5 && (data === 'false' || data === 'False' || data === 'FALSE'));
	}

	function constructYamlBoolean(data) {
	  return data === 'true' ||
	         data === 'True' ||
	         data === 'TRUE';
	}

	function isBoolean(object) {
	  return Object.prototype.toString.call(object) === '[object Boolean]';
	}

	var bool = new Type$8('tag:yaml.org,2002:bool', {
	  kind: 'scalar',
	  resolve: resolveYamlBoolean,
	  construct: constructYamlBoolean,
	  predicate: isBoolean,
	  represent: {
	    lowercase: function (object) { return object ? 'true' : 'false'; },
	    uppercase: function (object) { return object ? 'TRUE' : 'FALSE'; },
	    camelcase: function (object) { return object ? 'True' : 'False'; }
	  },
	  defaultStyle: 'lowercase'
	});

	var common$3 = common$5;
	var Type$7   = type;

	function isHexCode(c) {
	  return ((0x30/* 0 */ <= c) && (c <= 0x39/* 9 */)) ||
	         ((0x41/* A */ <= c) && (c <= 0x46/* F */)) ||
	         ((0x61/* a */ <= c) && (c <= 0x66/* f */));
	}

	function isOctCode(c) {
	  return ((0x30/* 0 */ <= c) && (c <= 0x37/* 7 */));
	}

	function isDecCode(c) {
	  return ((0x30/* 0 */ <= c) && (c <= 0x39/* 9 */));
	}

	function resolveYamlInteger(data) {
	  if (data === null) return false;

	  var max = data.length,
	      index = 0,
	      hasDigits = false,
	      ch;

	  if (!max) return false;

	  ch = data[index];

	  // sign
	  if (ch === '-' || ch === '+') {
	    ch = data[++index];
	  }

	  if (ch === '0') {
	    // 0
	    if (index + 1 === max) return true;
	    ch = data[++index];

	    // base 2, base 8, base 16

	    if (ch === 'b') {
	      // base 2
	      index++;

	      for (; index < max; index++) {
	        ch = data[index];
	        if (ch === '_') continue;
	        if (ch !== '0' && ch !== '1') return false;
	        hasDigits = true;
	      }
	      return hasDigits && ch !== '_';
	    }


	    if (ch === 'x') {
	      // base 16
	      index++;

	      for (; index < max; index++) {
	        ch = data[index];
	        if (ch === '_') continue;
	        if (!isHexCode(data.charCodeAt(index))) return false;
	        hasDigits = true;
	      }
	      return hasDigits && ch !== '_';
	    }


	    if (ch === 'o') {
	      // base 8
	      index++;

	      for (; index < max; index++) {
	        ch = data[index];
	        if (ch === '_') continue;
	        if (!isOctCode(data.charCodeAt(index))) return false;
	        hasDigits = true;
	      }
	      return hasDigits && ch !== '_';
	    }
	  }

	  // base 10 (except 0)

	  // value should not start with `_`;
	  if (ch === '_') return false;

	  for (; index < max; index++) {
	    ch = data[index];
	    if (ch === '_') continue;
	    if (!isDecCode(data.charCodeAt(index))) {
	      return false;
	    }
	    hasDigits = true;
	  }

	  // Should have digits and should not end with `_`
	  if (!hasDigits || ch === '_') return false;

	  return true;
	}

	function constructYamlInteger(data) {
	  var value = data, sign = 1, ch;

	  if (value.indexOf('_') !== -1) {
	    value = value.replace(/_/g, '');
	  }

	  ch = value[0];

	  if (ch === '-' || ch === '+') {
	    if (ch === '-') sign = -1;
	    value = value.slice(1);
	    ch = value[0];
	  }

	  if (value === '0') return 0;

	  if (ch === '0') {
	    if (value[1] === 'b') return sign * parseInt(value.slice(2), 2);
	    if (value[1] === 'x') return sign * parseInt(value.slice(2), 16);
	    if (value[1] === 'o') return sign * parseInt(value.slice(2), 8);
	  }

	  return sign * parseInt(value, 10);
	}

	function isInteger(object) {
	  return (Object.prototype.toString.call(object)) === '[object Number]' &&
	         (object % 1 === 0 && !common$3.isNegativeZero(object));
	}

	var int = new Type$7('tag:yaml.org,2002:int', {
	  kind: 'scalar',
	  resolve: resolveYamlInteger,
	  construct: constructYamlInteger,
	  predicate: isInteger,
	  represent: {
	    binary:      function (obj) { return obj >= 0 ? '0b' + obj.toString(2) : '-0b' + obj.toString(2).slice(1); },
	    octal:       function (obj) { return obj >= 0 ? '0o'  + obj.toString(8) : '-0o'  + obj.toString(8).slice(1); },
	    decimal:     function (obj) { return obj.toString(10); },
	    /* eslint-disable max-len */
	    hexadecimal: function (obj) { return obj >= 0 ? '0x' + obj.toString(16).toUpperCase() :  '-0x' + obj.toString(16).toUpperCase().slice(1); }
	  },
	  defaultStyle: 'decimal',
	  styleAliases: {
	    binary:      [ 2,  'bin' ],
	    octal:       [ 8,  'oct' ],
	    decimal:     [ 10, 'dec' ],
	    hexadecimal: [ 16, 'hex' ]
	  }
	});

	var common$2 = common$5;
	var Type$6   = type;

	var YAML_FLOAT_PATTERN = new RegExp(
	  // 2.5e4, 2.5 and integers
	  '^(?:[-+]?(?:[0-9][0-9_]*)(?:\\.[0-9_]*)?(?:[eE][-+]?[0-9]+)?' +
	  // .2e4, .2
	  // special case, seems not from spec
	  '|\\.[0-9_]+(?:[eE][-+]?[0-9]+)?' +
	  // .inf
	  '|[-+]?\\.(?:inf|Inf|INF)' +
	  // .nan
	  '|\\.(?:nan|NaN|NAN))$');

	function resolveYamlFloat(data) {
	  if (data === null) return false;

	  if (!YAML_FLOAT_PATTERN.test(data) ||
	      // Quick hack to not allow integers end with `_`
	      // Probably should update regexp & check speed
	      data[data.length - 1] === '_') {
	    return false;
	  }

	  return true;
	}

	function constructYamlFloat(data) {
	  var value, sign;

	  value  = data.replace(/_/g, '').toLowerCase();
	  sign   = value[0] === '-' ? -1 : 1;

	  if ('+-'.indexOf(value[0]) >= 0) {
	    value = value.slice(1);
	  }

	  if (value === '.inf') {
	    return (sign === 1) ? Number.POSITIVE_INFINITY : Number.NEGATIVE_INFINITY;

	  } else if (value === '.nan') {
	    return NaN;
	  }
	  return sign * parseFloat(value, 10);
	}


	var SCIENTIFIC_WITHOUT_DOT = /^[-+]?[0-9]+e/;

	function representYamlFloat(object, style) {
	  var res;

	  if (isNaN(object)) {
	    switch (style) {
	      case 'lowercase': return '.nan';
	      case 'uppercase': return '.NAN';
	      case 'camelcase': return '.NaN';
	    }
	  } else if (Number.POSITIVE_INFINITY === object) {
	    switch (style) {
	      case 'lowercase': return '.inf';
	      case 'uppercase': return '.INF';
	      case 'camelcase': return '.Inf';
	    }
	  } else if (Number.NEGATIVE_INFINITY === object) {
	    switch (style) {
	      case 'lowercase': return '-.inf';
	      case 'uppercase': return '-.INF';
	      case 'camelcase': return '-.Inf';
	    }
	  } else if (common$2.isNegativeZero(object)) {
	    return '-0.0';
	  }

	  res = object.toString(10);

	  // JS stringifier can build scientific format without dots: 5e-100,
	  // while YAML requres dot: 5.e-100. Fix it with simple hack

	  return SCIENTIFIC_WITHOUT_DOT.test(res) ? res.replace('e', '.e') : res;
	}

	function isFloat(object) {
	  return (Object.prototype.toString.call(object) === '[object Number]') &&
	         (object % 1 !== 0 || common$2.isNegativeZero(object));
	}

	var float = new Type$6('tag:yaml.org,2002:float', {
	  kind: 'scalar',
	  resolve: resolveYamlFloat,
	  construct: constructYamlFloat,
	  predicate: isFloat,
	  represent: representYamlFloat,
	  defaultStyle: 'lowercase'
	});

	var json$1 = failsafe.extend({
	  implicit: [
	    _null,
	    bool,
	    int,
	    float
	  ]
	});

	(function (module) {


		module.exports = json$1;
	} (core));

	var Type$5 = type;

	var YAML_DATE_REGEXP = new RegExp(
	  '^([0-9][0-9][0-9][0-9])'          + // [1] year
	  '-([0-9][0-9])'                    + // [2] month
	  '-([0-9][0-9])$');                   // [3] day

	var YAML_TIMESTAMP_REGEXP = new RegExp(
	  '^([0-9][0-9][0-9][0-9])'          + // [1] year
	  '-([0-9][0-9]?)'                   + // [2] month
	  '-([0-9][0-9]?)'                   + // [3] day
	  '(?:[Tt]|[ \\t]+)'                 + // ...
	  '([0-9][0-9]?)'                    + // [4] hour
	  ':([0-9][0-9])'                    + // [5] minute
	  ':([0-9][0-9])'                    + // [6] second
	  '(?:\\.([0-9]*))?'                 + // [7] fraction
	  '(?:[ \\t]*(Z|([-+])([0-9][0-9]?)' + // [8] tz [9] tz_sign [10] tz_hour
	  '(?::([0-9][0-9]))?))?$');           // [11] tz_minute

	function resolveYamlTimestamp(data) {
	  if (data === null) return false;
	  if (YAML_DATE_REGEXP.exec(data) !== null) return true;
	  if (YAML_TIMESTAMP_REGEXP.exec(data) !== null) return true;
	  return false;
	}

	function constructYamlTimestamp(data) {
	  var match, year, month, day, hour, minute, second, fraction = 0,
	      delta = null, tz_hour, tz_minute, date;

	  match = YAML_DATE_REGEXP.exec(data);
	  if (match === null) match = YAML_TIMESTAMP_REGEXP.exec(data);

	  if (match === null) throw new Error('Date resolve error');

	  // match: [1] year [2] month [3] day

	  year = +(match[1]);
	  month = +(match[2]) - 1; // JS month starts with 0
	  day = +(match[3]);

	  if (!match[4]) { // no hour
	    return new Date(Date.UTC(year, month, day));
	  }

	  // match: [4] hour [5] minute [6] second [7] fraction

	  hour = +(match[4]);
	  minute = +(match[5]);
	  second = +(match[6]);

	  if (match[7]) {
	    fraction = match[7].slice(0, 3);
	    while (fraction.length < 3) { // milli-seconds
	      fraction += '0';
	    }
	    fraction = +fraction;
	  }

	  // match: [8] tz [9] tz_sign [10] tz_hour [11] tz_minute

	  if (match[9]) {
	    tz_hour = +(match[10]);
	    tz_minute = +(match[11] || 0);
	    delta = (tz_hour * 60 + tz_minute) * 60000; // delta in mili-seconds
	    if (match[9] === '-') delta = -delta;
	  }

	  date = new Date(Date.UTC(year, month, day, hour, minute, second, fraction));

	  if (delta) date.setTime(date.getTime() - delta);

	  return date;
	}

	function representYamlTimestamp(object /*, style*/) {
	  return object.toISOString();
	}

	var timestamp = new Type$5('tag:yaml.org,2002:timestamp', {
	  kind: 'scalar',
	  resolve: resolveYamlTimestamp,
	  construct: constructYamlTimestamp,
	  instanceOf: Date,
	  represent: representYamlTimestamp
	});

	var Type$4 = type;

	function resolveYamlMerge(data) {
	  return data === '<<' || data === null;
	}

	var merge$1 = new Type$4('tag:yaml.org,2002:merge', {
	  kind: 'scalar',
	  resolve: resolveYamlMerge
	});

	/*eslint-disable no-bitwise*/


	var Type$3 = type;


	// [ 64, 65, 66 ] -> [ padding, CR, LF ]
	var BASE64_MAP = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=\n\r';


	function resolveYamlBinary(data) {
	  if (data === null) return false;

	  var code, idx, bitlen = 0, max = data.length, map = BASE64_MAP;

	  // Convert one by one.
	  for (idx = 0; idx < max; idx++) {
	    code = map.indexOf(data.charAt(idx));

	    // Skip CR/LF
	    if (code > 64) continue;

	    // Fail on illegal characters
	    if (code < 0) return false;

	    bitlen += 6;
	  }

	  // If there are any bits left, source was corrupted
	  return (bitlen % 8) === 0;
	}

	function constructYamlBinary(data) {
	  var idx, tailbits,
	      input = data.replace(/[\r\n=]/g, ''), // remove CR/LF & padding to simplify scan
	      max = input.length,
	      map = BASE64_MAP,
	      bits = 0,
	      result = [];

	  // Collect by 6*4 bits (3 bytes)

	  for (idx = 0; idx < max; idx++) {
	    if ((idx % 4 === 0) && idx) {
	      result.push((bits >> 16) & 0xFF);
	      result.push((bits >> 8) & 0xFF);
	      result.push(bits & 0xFF);
	    }

	    bits = (bits << 6) | map.indexOf(input.charAt(idx));
	  }

	  // Dump tail

	  tailbits = (max % 4) * 6;

	  if (tailbits === 0) {
	    result.push((bits >> 16) & 0xFF);
	    result.push((bits >> 8) & 0xFF);
	    result.push(bits & 0xFF);
	  } else if (tailbits === 18) {
	    result.push((bits >> 10) & 0xFF);
	    result.push((bits >> 2) & 0xFF);
	  } else if (tailbits === 12) {
	    result.push((bits >> 4) & 0xFF);
	  }

	  return new Uint8Array(result);
	}

	function representYamlBinary(object /*, style*/) {
	  var result = '', bits = 0, idx, tail,
	      max = object.length,
	      map = BASE64_MAP;

	  // Convert every three bytes to 4 ASCII characters.

	  for (idx = 0; idx < max; idx++) {
	    if ((idx % 3 === 0) && idx) {
	      result += map[(bits >> 18) & 0x3F];
	      result += map[(bits >> 12) & 0x3F];
	      result += map[(bits >> 6) & 0x3F];
	      result += map[bits & 0x3F];
	    }

	    bits = (bits << 8) + object[idx];
	  }

	  // Dump tail

	  tail = max % 3;

	  if (tail === 0) {
	    result += map[(bits >> 18) & 0x3F];
	    result += map[(bits >> 12) & 0x3F];
	    result += map[(bits >> 6) & 0x3F];
	    result += map[bits & 0x3F];
	  } else if (tail === 2) {
	    result += map[(bits >> 10) & 0x3F];
	    result += map[(bits >> 4) & 0x3F];
	    result += map[(bits << 2) & 0x3F];
	    result += map[64];
	  } else if (tail === 1) {
	    result += map[(bits >> 2) & 0x3F];
	    result += map[(bits << 4) & 0x3F];
	    result += map[64];
	    result += map[64];
	  }

	  return result;
	}

	function isBinary(obj) {
	  return Object.prototype.toString.call(obj) ===  '[object Uint8Array]';
	}

	var binary$1 = new Type$3('tag:yaml.org,2002:binary', {
	  kind: 'scalar',
	  resolve: resolveYamlBinary,
	  construct: constructYamlBinary,
	  predicate: isBinary,
	  represent: representYamlBinary
	});

	var Type$2 = type;

	var _hasOwnProperty$3 = Object.prototype.hasOwnProperty;
	var _toString$2       = Object.prototype.toString;

	function resolveYamlOmap(data) {
	  if (data === null) return true;

	  var objectKeys = [], index, length, pair, pairKey, pairHasKey,
	      object = data;

	  for (index = 0, length = object.length; index < length; index += 1) {
	    pair = object[index];
	    pairHasKey = false;

	    if (_toString$2.call(pair) !== '[object Object]') return false;

	    for (pairKey in pair) {
	      if (_hasOwnProperty$3.call(pair, pairKey)) {
	        if (!pairHasKey) pairHasKey = true;
	        else return false;
	      }
	    }

	    if (!pairHasKey) return false;

	    if (objectKeys.indexOf(pairKey) === -1) objectKeys.push(pairKey);
	    else return false;
	  }

	  return true;
	}

	function constructYamlOmap(data) {
	  return data !== null ? data : [];
	}

	var omap = new Type$2('tag:yaml.org,2002:omap', {
	  kind: 'sequence',
	  resolve: resolveYamlOmap,
	  construct: constructYamlOmap
	});

	var Type$1 = type;

	var _toString$1 = Object.prototype.toString;

	function resolveYamlPairs(data) {
	  if (data === null) return true;

	  var index, length, pair, keys, result,
	      object = data;

	  result = new Array(object.length);

	  for (index = 0, length = object.length; index < length; index += 1) {
	    pair = object[index];

	    if (_toString$1.call(pair) !== '[object Object]') return false;

	    keys = Object.keys(pair);

	    if (keys.length !== 1) return false;

	    result[index] = [ keys[0], pair[keys[0]] ];
	  }

	  return true;
	}

	function constructYamlPairs(data) {
	  if (data === null) return [];

	  var index, length, pair, keys, result,
	      object = data;

	  result = new Array(object.length);

	  for (index = 0, length = object.length; index < length; index += 1) {
	    pair = object[index];

	    keys = Object.keys(pair);

	    result[index] = [ keys[0], pair[keys[0]] ];
	  }

	  return result;
	}

	var pairs = new Type$1('tag:yaml.org,2002:pairs', {
	  kind: 'sequence',
	  resolve: resolveYamlPairs,
	  construct: constructYamlPairs
	});

	var Type = type;

	var _hasOwnProperty$2 = Object.prototype.hasOwnProperty;

	function resolveYamlSet(data) {
	  if (data === null) return true;

	  var key, object = data;

	  for (key in object) {
	    if (_hasOwnProperty$2.call(object, key)) {
	      if (object[key] !== null) return false;
	    }
	  }

	  return true;
	}

	function constructYamlSet(data) {
	  return data !== null ? data : {};
	}

	var set = new Type('tag:yaml.org,2002:set', {
	  kind: 'mapping',
	  resolve: resolveYamlSet,
	  construct: constructYamlSet
	});

	var _default = coreExports.extend({
	  implicit: [
	    timestamp,
	    merge$1
	  ],
	  explicit: [
	    binary$1,
	    omap,
	    pairs,
	    set
	  ]
	});

	/*eslint-disable max-len,no-use-before-define*/

	var common$1              = common$5;
	var YAMLException$1       = exception;
	var makeSnippet         = snippet;
	var DEFAULT_SCHEMA$1      = _default;


	var _hasOwnProperty$1 = Object.prototype.hasOwnProperty;


	var CONTEXT_FLOW_IN   = 1;
	var CONTEXT_FLOW_OUT  = 2;
	var CONTEXT_BLOCK_IN  = 3;
	var CONTEXT_BLOCK_OUT = 4;


	var CHOMPING_CLIP  = 1;
	var CHOMPING_STRIP = 2;
	var CHOMPING_KEEP  = 3;


	var PATTERN_NON_PRINTABLE         = /[\x00-\x08\x0B\x0C\x0E-\x1F\x7F-\x84\x86-\x9F\uFFFE\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;
	var PATTERN_NON_ASCII_LINE_BREAKS = /[\x85\u2028\u2029]/;
	var PATTERN_FLOW_INDICATORS       = /[,\[\]\{\}]/;
	var PATTERN_TAG_HANDLE            = /^(?:!|!!|![a-z\-]+!)$/i;
	var PATTERN_TAG_URI               = /^(?:!|[^,\[\]\{\}])(?:%[0-9a-f]{2}|[0-9a-z\-#;\/\?:@&=\+\$,_\.!~\*'\(\)\[\]])*$/i;


	function _class(obj) { return Object.prototype.toString.call(obj); }

	function is_EOL(c) {
	  return (c === 0x0A/* LF */) || (c === 0x0D/* CR */);
	}

	function is_WHITE_SPACE(c) {
	  return (c === 0x09/* Tab */) || (c === 0x20/* Space */);
	}

	function is_WS_OR_EOL(c) {
	  return (c === 0x09/* Tab */) ||
	         (c === 0x20/* Space */) ||
	         (c === 0x0A/* LF */) ||
	         (c === 0x0D/* CR */);
	}

	function is_FLOW_INDICATOR(c) {
	  return c === 0x2C/* , */ ||
	         c === 0x5B/* [ */ ||
	         c === 0x5D/* ] */ ||
	         c === 0x7B/* { */ ||
	         c === 0x7D/* } */;
	}

	function fromHexCode(c) {
	  var lc;

	  if ((0x30/* 0 */ <= c) && (c <= 0x39/* 9 */)) {
	    return c - 0x30;
	  }

	  /*eslint-disable no-bitwise*/
	  lc = c | 0x20;

	  if ((0x61/* a */ <= lc) && (lc <= 0x66/* f */)) {
	    return lc - 0x61 + 10;
	  }

	  return -1;
	}

	function escapedHexLen(c) {
	  if (c === 0x78/* x */) { return 2; }
	  if (c === 0x75/* u */) { return 4; }
	  if (c === 0x55/* U */) { return 8; }
	  return 0;
	}

	function fromDecimalCode(c) {
	  if ((0x30/* 0 */ <= c) && (c <= 0x39/* 9 */)) {
	    return c - 0x30;
	  }

	  return -1;
	}

	function simpleEscapeSequence(c) {
	  /* eslint-disable indent */
	  return (c === 0x30/* 0 */) ? '\x00' :
	        (c === 0x61/* a */) ? '\x07' :
	        (c === 0x62/* b */) ? '\x08' :
	        (c === 0x74/* t */) ? '\x09' :
	        (c === 0x09/* Tab */) ? '\x09' :
	        (c === 0x6E/* n */) ? '\x0A' :
	        (c === 0x76/* v */) ? '\x0B' :
	        (c === 0x66/* f */) ? '\x0C' :
	        (c === 0x72/* r */) ? '\x0D' :
	        (c === 0x65/* e */) ? '\x1B' :
	        (c === 0x20/* Space */) ? ' ' :
	        (c === 0x22/* " */) ? '\x22' :
	        (c === 0x2F/* / */) ? '/' :
	        (c === 0x5C/* \ */) ? '\x5C' :
	        (c === 0x4E/* N */) ? '\x85' :
	        (c === 0x5F/* _ */) ? '\xA0' :
	        (c === 0x4C/* L */) ? '\u2028' :
	        (c === 0x50/* P */) ? '\u2029' : '';
	}

	function charFromCodepoint(c) {
	  if (c <= 0xFFFF) {
	    return String.fromCharCode(c);
	  }
	  // Encode UTF-16 surrogate pair
	  // https://en.wikipedia.org/wiki/UTF-16#Code_points_U.2B010000_to_U.2B10FFFF
	  return String.fromCharCode(
	    ((c - 0x010000) >> 10) + 0xD800,
	    ((c - 0x010000) & 0x03FF) + 0xDC00
	  );
	}

	var simpleEscapeCheck = new Array(256); // integer, for fast access
	var simpleEscapeMap = new Array(256);
	for (var i = 0; i < 256; i++) {
	  simpleEscapeCheck[i] = simpleEscapeSequence(i) ? 1 : 0;
	  simpleEscapeMap[i] = simpleEscapeSequence(i);
	}


	function State$1(input, options) {
	  this.input = input;

	  this.filename  = options['filename']  || null;
	  this.schema    = options['schema']    || DEFAULT_SCHEMA$1;
	  this.onWarning = options['onWarning'] || null;
	  // (Hidden) Remove? makes the loader to expect YAML 1.1 documents
	  // if such documents have no explicit %YAML directive
	  this.legacy    = options['legacy']    || false;

	  this.json      = options['json']      || false;
	  this.listener  = options['listener']  || null;

	  this.implicitTypes = this.schema.compiledImplicit;
	  this.typeMap       = this.schema.compiledTypeMap;

	  this.length     = input.length;
	  this.position   = 0;
	  this.line       = 0;
	  this.lineStart  = 0;
	  this.lineIndent = 0;

	  // position of first leading tab in the current line,
	  // used to make sure there are no tabs in the indentation
	  this.firstTabInLine = -1;

	  this.documents = [];

	  /*
	  this.version;
	  this.checkLineBreaks;
	  this.tagMap;
	  this.anchorMap;
	  this.tag;
	  this.anchor;
	  this.kind;
	  this.result;*/

	}


	function generateError(state, message) {
	  var mark = {
	    name:     state.filename,
	    buffer:   state.input.slice(0, -1), // omit trailing \0
	    position: state.position,
	    line:     state.line,
	    column:   state.position - state.lineStart
	  };

	  mark.snippet = makeSnippet(mark);

	  return new YAMLException$1(message, mark);
	}

	function throwError(state, message) {
	  throw generateError(state, message);
	}

	function throwWarning(state, message) {
	  if (state.onWarning) {
	    state.onWarning.call(null, generateError(state, message));
	  }
	}


	var directiveHandlers = {

	  YAML: function handleYamlDirective(state, name, args) {

	    var match, major, minor;

	    if (state.version !== null) {
	      throwError(state, 'duplication of %YAML directive');
	    }

	    if (args.length !== 1) {
	      throwError(state, 'YAML directive accepts exactly one argument');
	    }

	    match = /^([0-9]+)\.([0-9]+)$/.exec(args[0]);

	    if (match === null) {
	      throwError(state, 'ill-formed argument of the YAML directive');
	    }

	    major = parseInt(match[1], 10);
	    minor = parseInt(match[2], 10);

	    if (major !== 1) {
	      throwError(state, 'unacceptable YAML version of the document');
	    }

	    state.version = args[0];
	    state.checkLineBreaks = (minor < 2);

	    if (minor !== 1 && minor !== 2) {
	      throwWarning(state, 'unsupported YAML version of the document');
	    }
	  },

	  TAG: function handleTagDirective(state, name, args) {

	    var handle, prefix;

	    if (args.length !== 2) {
	      throwError(state, 'TAG directive accepts exactly two arguments');
	    }

	    handle = args[0];
	    prefix = args[1];

	    if (!PATTERN_TAG_HANDLE.test(handle)) {
	      throwError(state, 'ill-formed tag handle (first argument) of the TAG directive');
	    }

	    if (_hasOwnProperty$1.call(state.tagMap, handle)) {
	      throwError(state, 'there is a previously declared suffix for "' + handle + '" tag handle');
	    }

	    if (!PATTERN_TAG_URI.test(prefix)) {
	      throwError(state, 'ill-formed tag prefix (second argument) of the TAG directive');
	    }

	    try {
	      prefix = decodeURIComponent(prefix);
	    } catch (err) {
	      throwError(state, 'tag prefix is malformed: ' + prefix);
	    }

	    state.tagMap[handle] = prefix;
	  }
	};


	function captureSegment(state, start, end, checkJson) {
	  var _position, _length, _character, _result;

	  if (start < end) {
	    _result = state.input.slice(start, end);

	    if (checkJson) {
	      for (_position = 0, _length = _result.length; _position < _length; _position += 1) {
	        _character = _result.charCodeAt(_position);
	        if (!(_character === 0x09 ||
	              (0x20 <= _character && _character <= 0x10FFFF))) {
	          throwError(state, 'expected valid JSON character');
	        }
	      }
	    } else if (PATTERN_NON_PRINTABLE.test(_result)) {
	      throwError(state, 'the stream contains non-printable characters');
	    }

	    state.result += _result;
	  }
	}

	function mergeMappings(state, destination, source, overridableKeys) {
	  var sourceKeys, key, index, quantity;

	  if (!common$1.isObject(source)) {
	    throwError(state, 'cannot merge mappings; the provided source object is unacceptable');
	  }

	  sourceKeys = Object.keys(source);

	  for (index = 0, quantity = sourceKeys.length; index < quantity; index += 1) {
	    key = sourceKeys[index];

	    if (!_hasOwnProperty$1.call(destination, key)) {
	      destination[key] = source[key];
	      overridableKeys[key] = true;
	    }
	  }
	}

	function storeMappingPair(state, _result, overridableKeys, keyTag, keyNode, valueNode,
	  startLine, startLineStart, startPos) {

	  var index, quantity;

	  // The output is a plain object here, so keys can only be strings.
	  // We need to convert keyNode to a string, but doing so can hang the process
	  // (deeply nested arrays that explode exponentially using aliases).
	  if (Array.isArray(keyNode)) {
	    keyNode = Array.prototype.slice.call(keyNode);

	    for (index = 0, quantity = keyNode.length; index < quantity; index += 1) {
	      if (Array.isArray(keyNode[index])) {
	        throwError(state, 'nested arrays are not supported inside keys');
	      }

	      if (typeof keyNode === 'object' && _class(keyNode[index]) === '[object Object]') {
	        keyNode[index] = '[object Object]';
	      }
	    }
	  }

	  // Avoid code execution in load() via toString property
	  // (still use its own toString for arrays, timestamps,
	  // and whatever user schema extensions happen to have @@toStringTag)
	  if (typeof keyNode === 'object' && _class(keyNode) === '[object Object]') {
	    keyNode = '[object Object]';
	  }


	  keyNode = String(keyNode);

	  if (_result === null) {
	    _result = {};
	  }

	  if (keyTag === 'tag:yaml.org,2002:merge') {
	    if (Array.isArray(valueNode)) {
	      for (index = 0, quantity = valueNode.length; index < quantity; index += 1) {
	        mergeMappings(state, _result, valueNode[index], overridableKeys);
	      }
	    } else {
	      mergeMappings(state, _result, valueNode, overridableKeys);
	    }
	  } else {
	    if (!state.json &&
	        !_hasOwnProperty$1.call(overridableKeys, keyNode) &&
	        _hasOwnProperty$1.call(_result, keyNode)) {
	      state.line = startLine || state.line;
	      state.lineStart = startLineStart || state.lineStart;
	      state.position = startPos || state.position;
	      throwError(state, 'duplicated mapping key');
	    }

	    // used for this specific key only because Object.defineProperty is slow
	    if (keyNode === '__proto__') {
	      Object.defineProperty(_result, keyNode, {
	        configurable: true,
	        enumerable: true,
	        writable: true,
	        value: valueNode
	      });
	    } else {
	      _result[keyNode] = valueNode;
	    }
	    delete overridableKeys[keyNode];
	  }

	  return _result;
	}

	function readLineBreak(state) {
	  var ch;

	  ch = state.input.charCodeAt(state.position);

	  if (ch === 0x0A/* LF */) {
	    state.position++;
	  } else if (ch === 0x0D/* CR */) {
	    state.position++;
	    if (state.input.charCodeAt(state.position) === 0x0A/* LF */) {
	      state.position++;
	    }
	  } else {
	    throwError(state, 'a line break is expected');
	  }

	  state.line += 1;
	  state.lineStart = state.position;
	  state.firstTabInLine = -1;
	}

	function skipSeparationSpace(state, allowComments, checkIndent) {
	  var lineBreaks = 0,
	      ch = state.input.charCodeAt(state.position);

	  while (ch !== 0) {
	    while (is_WHITE_SPACE(ch)) {
	      if (ch === 0x09/* Tab */ && state.firstTabInLine === -1) {
	        state.firstTabInLine = state.position;
	      }
	      ch = state.input.charCodeAt(++state.position);
	    }

	    if (allowComments && ch === 0x23/* # */) {
	      do {
	        ch = state.input.charCodeAt(++state.position);
	      } while (ch !== 0x0A/* LF */ && ch !== 0x0D/* CR */ && ch !== 0);
	    }

	    if (is_EOL(ch)) {
	      readLineBreak(state);

	      ch = state.input.charCodeAt(state.position);
	      lineBreaks++;
	      state.lineIndent = 0;

	      while (ch === 0x20/* Space */) {
	        state.lineIndent++;
	        ch = state.input.charCodeAt(++state.position);
	      }
	    } else {
	      break;
	    }
	  }

	  if (checkIndent !== -1 && lineBreaks !== 0 && state.lineIndent < checkIndent) {
	    throwWarning(state, 'deficient indentation');
	  }

	  return lineBreaks;
	}

	function testDocumentSeparator(state) {
	  var _position = state.position,
	      ch;

	  ch = state.input.charCodeAt(_position);

	  // Condition state.position === state.lineStart is tested
	  // in parent on each call, for efficiency. No needs to test here again.
	  if ((ch === 0x2D/* - */ || ch === 0x2E/* . */) &&
	      ch === state.input.charCodeAt(_position + 1) &&
	      ch === state.input.charCodeAt(_position + 2)) {

	    _position += 3;

	    ch = state.input.charCodeAt(_position);

	    if (ch === 0 || is_WS_OR_EOL(ch)) {
	      return true;
	    }
	  }

	  return false;
	}

	function writeFoldedLines(state, count) {
	  if (count === 1) {
	    state.result += ' ';
	  } else if (count > 1) {
	    state.result += common$1.repeat('\n', count - 1);
	  }
	}


	function readPlainScalar(state, nodeIndent, withinFlowCollection) {
	  var preceding,
	      following,
	      captureStart,
	      captureEnd,
	      hasPendingContent,
	      _line,
	      _lineStart,
	      _lineIndent,
	      _kind = state.kind,
	      _result = state.result,
	      ch;

	  ch = state.input.charCodeAt(state.position);

	  if (is_WS_OR_EOL(ch)      ||
	      is_FLOW_INDICATOR(ch) ||
	      ch === 0x23/* # */    ||
	      ch === 0x26/* & */    ||
	      ch === 0x2A/* * */    ||
	      ch === 0x21/* ! */    ||
	      ch === 0x7C/* | */    ||
	      ch === 0x3E/* > */    ||
	      ch === 0x27/* ' */    ||
	      ch === 0x22/* " */    ||
	      ch === 0x25/* % */    ||
	      ch === 0x40/* @ */    ||
	      ch === 0x60/* ` */) {
	    return false;
	  }

	  if (ch === 0x3F/* ? */ || ch === 0x2D/* - */) {
	    following = state.input.charCodeAt(state.position + 1);

	    if (is_WS_OR_EOL(following) ||
	        withinFlowCollection && is_FLOW_INDICATOR(following)) {
	      return false;
	    }
	  }

	  state.kind = 'scalar';
	  state.result = '';
	  captureStart = captureEnd = state.position;
	  hasPendingContent = false;

	  while (ch !== 0) {
	    if (ch === 0x3A/* : */) {
	      following = state.input.charCodeAt(state.position + 1);

	      if (is_WS_OR_EOL(following) ||
	          withinFlowCollection && is_FLOW_INDICATOR(following)) {
	        break;
	      }

	    } else if (ch === 0x23/* # */) {
	      preceding = state.input.charCodeAt(state.position - 1);

	      if (is_WS_OR_EOL(preceding)) {
	        break;
	      }

	    } else if ((state.position === state.lineStart && testDocumentSeparator(state)) ||
	               withinFlowCollection && is_FLOW_INDICATOR(ch)) {
	      break;

	    } else if (is_EOL(ch)) {
	      _line = state.line;
	      _lineStart = state.lineStart;
	      _lineIndent = state.lineIndent;
	      skipSeparationSpace(state, false, -1);

	      if (state.lineIndent >= nodeIndent) {
	        hasPendingContent = true;
	        ch = state.input.charCodeAt(state.position);
	        continue;
	      } else {
	        state.position = captureEnd;
	        state.line = _line;
	        state.lineStart = _lineStart;
	        state.lineIndent = _lineIndent;
	        break;
	      }
	    }

	    if (hasPendingContent) {
	      captureSegment(state, captureStart, captureEnd, false);
	      writeFoldedLines(state, state.line - _line);
	      captureStart = captureEnd = state.position;
	      hasPendingContent = false;
	    }

	    if (!is_WHITE_SPACE(ch)) {
	      captureEnd = state.position + 1;
	    }

	    ch = state.input.charCodeAt(++state.position);
	  }

	  captureSegment(state, captureStart, captureEnd, false);

	  if (state.result) {
	    return true;
	  }

	  state.kind = _kind;
	  state.result = _result;
	  return false;
	}

	function readSingleQuotedScalar(state, nodeIndent) {
	  var ch,
	      captureStart, captureEnd;

	  ch = state.input.charCodeAt(state.position);

	  if (ch !== 0x27/* ' */) {
	    return false;
	  }

	  state.kind = 'scalar';
	  state.result = '';
	  state.position++;
	  captureStart = captureEnd = state.position;

	  while ((ch = state.input.charCodeAt(state.position)) !== 0) {
	    if (ch === 0x27/* ' */) {
	      captureSegment(state, captureStart, state.position, true);
	      ch = state.input.charCodeAt(++state.position);

	      if (ch === 0x27/* ' */) {
	        captureStart = state.position;
	        state.position++;
	        captureEnd = state.position;
	      } else {
	        return true;
	      }

	    } else if (is_EOL(ch)) {
	      captureSegment(state, captureStart, captureEnd, true);
	      writeFoldedLines(state, skipSeparationSpace(state, false, nodeIndent));
	      captureStart = captureEnd = state.position;

	    } else if (state.position === state.lineStart && testDocumentSeparator(state)) {
	      throwError(state, 'unexpected end of the document within a single quoted scalar');

	    } else {
	      state.position++;
	      captureEnd = state.position;
	    }
	  }

	  throwError(state, 'unexpected end of the stream within a single quoted scalar');
	}

	function readDoubleQuotedScalar(state, nodeIndent) {
	  var captureStart,
	      captureEnd,
	      hexLength,
	      hexResult,
	      tmp,
	      ch;

	  ch = state.input.charCodeAt(state.position);

	  if (ch !== 0x22/* " */) {
	    return false;
	  }

	  state.kind = 'scalar';
	  state.result = '';
	  state.position++;
	  captureStart = captureEnd = state.position;

	  while ((ch = state.input.charCodeAt(state.position)) !== 0) {
	    if (ch === 0x22/* " */) {
	      captureSegment(state, captureStart, state.position, true);
	      state.position++;
	      return true;

	    } else if (ch === 0x5C/* \ */) {
	      captureSegment(state, captureStart, state.position, true);
	      ch = state.input.charCodeAt(++state.position);

	      if (is_EOL(ch)) {
	        skipSeparationSpace(state, false, nodeIndent);

	        // TODO: rework to inline fn with no type cast?
	      } else if (ch < 256 && simpleEscapeCheck[ch]) {
	        state.result += simpleEscapeMap[ch];
	        state.position++;

	      } else if ((tmp = escapedHexLen(ch)) > 0) {
	        hexLength = tmp;
	        hexResult = 0;

	        for (; hexLength > 0; hexLength--) {
	          ch = state.input.charCodeAt(++state.position);

	          if ((tmp = fromHexCode(ch)) >= 0) {
	            hexResult = (hexResult << 4) + tmp;

	          } else {
	            throwError(state, 'expected hexadecimal character');
	          }
	        }

	        state.result += charFromCodepoint(hexResult);

	        state.position++;

	      } else {
	        throwError(state, 'unknown escape sequence');
	      }

	      captureStart = captureEnd = state.position;

	    } else if (is_EOL(ch)) {
	      captureSegment(state, captureStart, captureEnd, true);
	      writeFoldedLines(state, skipSeparationSpace(state, false, nodeIndent));
	      captureStart = captureEnd = state.position;

	    } else if (state.position === state.lineStart && testDocumentSeparator(state)) {
	      throwError(state, 'unexpected end of the document within a double quoted scalar');

	    } else {
	      state.position++;
	      captureEnd = state.position;
	    }
	  }

	  throwError(state, 'unexpected end of the stream within a double quoted scalar');
	}

	function readFlowCollection(state, nodeIndent) {
	  var readNext = true,
	      _line,
	      _lineStart,
	      _pos,
	      _tag     = state.tag,
	      _result,
	      _anchor  = state.anchor,
	      following,
	      terminator,
	      isPair,
	      isExplicitPair,
	      isMapping,
	      overridableKeys = Object.create(null),
	      keyNode,
	      keyTag,
	      valueNode,
	      ch;

	  ch = state.input.charCodeAt(state.position);

	  if (ch === 0x5B/* [ */) {
	    terminator = 0x5D;/* ] */
	    isMapping = false;
	    _result = [];
	  } else if (ch === 0x7B/* { */) {
	    terminator = 0x7D;/* } */
	    isMapping = true;
	    _result = {};
	  } else {
	    return false;
	  }

	  if (state.anchor !== null) {
	    state.anchorMap[state.anchor] = _result;
	  }

	  ch = state.input.charCodeAt(++state.position);

	  while (ch !== 0) {
	    skipSeparationSpace(state, true, nodeIndent);

	    ch = state.input.charCodeAt(state.position);

	    if (ch === terminator) {
	      state.position++;
	      state.tag = _tag;
	      state.anchor = _anchor;
	      state.kind = isMapping ? 'mapping' : 'sequence';
	      state.result = _result;
	      return true;
	    } else if (!readNext) {
	      throwError(state, 'missed comma between flow collection entries');
	    } else if (ch === 0x2C/* , */) {
	      // "flow collection entries can never be completely empty", as per YAML 1.2, section 7.4
	      throwError(state, "expected the node content, but found ','");
	    }

	    keyTag = keyNode = valueNode = null;
	    isPair = isExplicitPair = false;

	    if (ch === 0x3F/* ? */) {
	      following = state.input.charCodeAt(state.position + 1);

	      if (is_WS_OR_EOL(following)) {
	        isPair = isExplicitPair = true;
	        state.position++;
	        skipSeparationSpace(state, true, nodeIndent);
	      }
	    }

	    _line = state.line; // Save the current line.
	    _lineStart = state.lineStart;
	    _pos = state.position;
	    composeNode(state, nodeIndent, CONTEXT_FLOW_IN, false, true);
	    keyTag = state.tag;
	    keyNode = state.result;
	    skipSeparationSpace(state, true, nodeIndent);

	    ch = state.input.charCodeAt(state.position);

	    if ((isExplicitPair || state.line === _line) && ch === 0x3A/* : */) {
	      isPair = true;
	      ch = state.input.charCodeAt(++state.position);
	      skipSeparationSpace(state, true, nodeIndent);
	      composeNode(state, nodeIndent, CONTEXT_FLOW_IN, false, true);
	      valueNode = state.result;
	    }

	    if (isMapping) {
	      storeMappingPair(state, _result, overridableKeys, keyTag, keyNode, valueNode, _line, _lineStart, _pos);
	    } else if (isPair) {
	      _result.push(storeMappingPair(state, null, overridableKeys, keyTag, keyNode, valueNode, _line, _lineStart, _pos));
	    } else {
	      _result.push(keyNode);
	    }

	    skipSeparationSpace(state, true, nodeIndent);

	    ch = state.input.charCodeAt(state.position);

	    if (ch === 0x2C/* , */) {
	      readNext = true;
	      ch = state.input.charCodeAt(++state.position);
	    } else {
	      readNext = false;
	    }
	  }

	  throwError(state, 'unexpected end of the stream within a flow collection');
	}

	function readBlockScalar(state, nodeIndent) {
	  var captureStart,
	      folding,
	      chomping       = CHOMPING_CLIP,
	      didReadContent = false,
	      detectedIndent = false,
	      textIndent     = nodeIndent,
	      emptyLines     = 0,
	      atMoreIndented = false,
	      tmp,
	      ch;

	  ch = state.input.charCodeAt(state.position);

	  if (ch === 0x7C/* | */) {
	    folding = false;
	  } else if (ch === 0x3E/* > */) {
	    folding = true;
	  } else {
	    return false;
	  }

	  state.kind = 'scalar';
	  state.result = '';

	  while (ch !== 0) {
	    ch = state.input.charCodeAt(++state.position);

	    if (ch === 0x2B/* + */ || ch === 0x2D/* - */) {
	      if (CHOMPING_CLIP === chomping) {
	        chomping = (ch === 0x2B/* + */) ? CHOMPING_KEEP : CHOMPING_STRIP;
	      } else {
	        throwError(state, 'repeat of a chomping mode identifier');
	      }

	    } else if ((tmp = fromDecimalCode(ch)) >= 0) {
	      if (tmp === 0) {
	        throwError(state, 'bad explicit indentation width of a block scalar; it cannot be less than one');
	      } else if (!detectedIndent) {
	        textIndent = nodeIndent + tmp - 1;
	        detectedIndent = true;
	      } else {
	        throwError(state, 'repeat of an indentation width identifier');
	      }

	    } else {
	      break;
	    }
	  }

	  if (is_WHITE_SPACE(ch)) {
	    do { ch = state.input.charCodeAt(++state.position); }
	    while (is_WHITE_SPACE(ch));

	    if (ch === 0x23/* # */) {
	      do { ch = state.input.charCodeAt(++state.position); }
	      while (!is_EOL(ch) && (ch !== 0));
	    }
	  }

	  while (ch !== 0) {
	    readLineBreak(state);
	    state.lineIndent = 0;

	    ch = state.input.charCodeAt(state.position);

	    while ((!detectedIndent || state.lineIndent < textIndent) &&
	           (ch === 0x20/* Space */)) {
	      state.lineIndent++;
	      ch = state.input.charCodeAt(++state.position);
	    }

	    if (!detectedIndent && state.lineIndent > textIndent) {
	      textIndent = state.lineIndent;
	    }

	    if (is_EOL(ch)) {
	      emptyLines++;
	      continue;
	    }

	    // End of the scalar.
	    if (state.lineIndent < textIndent) {

	      // Perform the chomping.
	      if (chomping === CHOMPING_KEEP) {
	        state.result += common$1.repeat('\n', didReadContent ? 1 + emptyLines : emptyLines);
	      } else if (chomping === CHOMPING_CLIP) {
	        if (didReadContent) { // i.e. only if the scalar is not empty.
	          state.result += '\n';
	        }
	      }

	      // Break this `while` cycle and go to the funciton's epilogue.
	      break;
	    }

	    // Folded style: use fancy rules to handle line breaks.
	    if (folding) {

	      // Lines starting with white space characters (more-indented lines) are not folded.
	      if (is_WHITE_SPACE(ch)) {
	        atMoreIndented = true;
	        // except for the first content line (cf. Example 8.1)
	        state.result += common$1.repeat('\n', didReadContent ? 1 + emptyLines : emptyLines);

	      // End of more-indented block.
	      } else if (atMoreIndented) {
	        atMoreIndented = false;
	        state.result += common$1.repeat('\n', emptyLines + 1);

	      // Just one line break - perceive as the same line.
	      } else if (emptyLines === 0) {
	        if (didReadContent) { // i.e. only if we have already read some scalar content.
	          state.result += ' ';
	        }

	      // Several line breaks - perceive as different lines.
	      } else {
	        state.result += common$1.repeat('\n', emptyLines);
	      }

	    // Literal style: just add exact number of line breaks between content lines.
	    } else {
	      // Keep all line breaks except the header line break.
	      state.result += common$1.repeat('\n', didReadContent ? 1 + emptyLines : emptyLines);
	    }

	    didReadContent = true;
	    detectedIndent = true;
	    emptyLines = 0;
	    captureStart = state.position;

	    while (!is_EOL(ch) && (ch !== 0)) {
	      ch = state.input.charCodeAt(++state.position);
	    }

	    captureSegment(state, captureStart, state.position, false);
	  }

	  return true;
	}

	function readBlockSequence(state, nodeIndent) {
	  var _line,
	      _tag      = state.tag,
	      _anchor   = state.anchor,
	      _result   = [],
	      following,
	      detected  = false,
	      ch;

	  // there is a leading tab before this token, so it can't be a block sequence/mapping;
	  // it can still be flow sequence/mapping or a scalar
	  if (state.firstTabInLine !== -1) return false;

	  if (state.anchor !== null) {
	    state.anchorMap[state.anchor] = _result;
	  }

	  ch = state.input.charCodeAt(state.position);

	  while (ch !== 0) {
	    if (state.firstTabInLine !== -1) {
	      state.position = state.firstTabInLine;
	      throwError(state, 'tab characters must not be used in indentation');
	    }

	    if (ch !== 0x2D/* - */) {
	      break;
	    }

	    following = state.input.charCodeAt(state.position + 1);

	    if (!is_WS_OR_EOL(following)) {
	      break;
	    }

	    detected = true;
	    state.position++;

	    if (skipSeparationSpace(state, true, -1)) {
	      if (state.lineIndent <= nodeIndent) {
	        _result.push(null);
	        ch = state.input.charCodeAt(state.position);
	        continue;
	      }
	    }

	    _line = state.line;
	    composeNode(state, nodeIndent, CONTEXT_BLOCK_IN, false, true);
	    _result.push(state.result);
	    skipSeparationSpace(state, true, -1);

	    ch = state.input.charCodeAt(state.position);

	    if ((state.line === _line || state.lineIndent > nodeIndent) && (ch !== 0)) {
	      throwError(state, 'bad indentation of a sequence entry');
	    } else if (state.lineIndent < nodeIndent) {
	      break;
	    }
	  }

	  if (detected) {
	    state.tag = _tag;
	    state.anchor = _anchor;
	    state.kind = 'sequence';
	    state.result = _result;
	    return true;
	  }
	  return false;
	}

	function readBlockMapping(state, nodeIndent, flowIndent) {
	  var following,
	      allowCompact,
	      _line,
	      _keyLine,
	      _keyLineStart,
	      _keyPos,
	      _tag          = state.tag,
	      _anchor       = state.anchor,
	      _result       = {},
	      overridableKeys = Object.create(null),
	      keyTag        = null,
	      keyNode       = null,
	      valueNode     = null,
	      atExplicitKey = false,
	      detected      = false,
	      ch;

	  // there is a leading tab before this token, so it can't be a block sequence/mapping;
	  // it can still be flow sequence/mapping or a scalar
	  if (state.firstTabInLine !== -1) return false;

	  if (state.anchor !== null) {
	    state.anchorMap[state.anchor] = _result;
	  }

	  ch = state.input.charCodeAt(state.position);

	  while (ch !== 0) {
	    if (!atExplicitKey && state.firstTabInLine !== -1) {
	      state.position = state.firstTabInLine;
	      throwError(state, 'tab characters must not be used in indentation');
	    }

	    following = state.input.charCodeAt(state.position + 1);
	    _line = state.line; // Save the current line.

	    //
	    // Explicit notation case. There are two separate blocks:
	    // first for the key (denoted by "?") and second for the value (denoted by ":")
	    //
	    if ((ch === 0x3F/* ? */ || ch === 0x3A/* : */) && is_WS_OR_EOL(following)) {

	      if (ch === 0x3F/* ? */) {
	        if (atExplicitKey) {
	          storeMappingPair(state, _result, overridableKeys, keyTag, keyNode, null, _keyLine, _keyLineStart, _keyPos);
	          keyTag = keyNode = valueNode = null;
	        }

	        detected = true;
	        atExplicitKey = true;
	        allowCompact = true;

	      } else if (atExplicitKey) {
	        // i.e. 0x3A/* : */ === character after the explicit key.
	        atExplicitKey = false;
	        allowCompact = true;

	      } else {
	        throwError(state, 'incomplete explicit mapping pair; a key node is missed; or followed by a non-tabulated empty line');
	      }

	      state.position += 1;
	      ch = following;

	    //
	    // Implicit notation case. Flow-style node as the key first, then ":", and the value.
	    //
	    } else {
	      _keyLine = state.line;
	      _keyLineStart = state.lineStart;
	      _keyPos = state.position;

	      if (!composeNode(state, flowIndent, CONTEXT_FLOW_OUT, false, true)) {
	        // Neither implicit nor explicit notation.
	        // Reading is done. Go to the epilogue.
	        break;
	      }

	      if (state.line === _line) {
	        ch = state.input.charCodeAt(state.position);

	        while (is_WHITE_SPACE(ch)) {
	          ch = state.input.charCodeAt(++state.position);
	        }

	        if (ch === 0x3A/* : */) {
	          ch = state.input.charCodeAt(++state.position);

	          if (!is_WS_OR_EOL(ch)) {
	            throwError(state, 'a whitespace character is expected after the key-value separator within a block mapping');
	          }

	          if (atExplicitKey) {
	            storeMappingPair(state, _result, overridableKeys, keyTag, keyNode, null, _keyLine, _keyLineStart, _keyPos);
	            keyTag = keyNode = valueNode = null;
	          }

	          detected = true;
	          atExplicitKey = false;
	          allowCompact = false;
	          keyTag = state.tag;
	          keyNode = state.result;

	        } else if (detected) {
	          throwError(state, 'can not read an implicit mapping pair; a colon is missed');

	        } else {
	          state.tag = _tag;
	          state.anchor = _anchor;
	          return true; // Keep the result of `composeNode`.
	        }

	      } else if (detected) {
	        throwError(state, 'can not read a block mapping entry; a multiline key may not be an implicit key');

	      } else {
	        state.tag = _tag;
	        state.anchor = _anchor;
	        return true; // Keep the result of `composeNode`.
	      }
	    }

	    //
	    // Common reading code for both explicit and implicit notations.
	    //
	    if (state.line === _line || state.lineIndent > nodeIndent) {
	      if (atExplicitKey) {
	        _keyLine = state.line;
	        _keyLineStart = state.lineStart;
	        _keyPos = state.position;
	      }

	      if (composeNode(state, nodeIndent, CONTEXT_BLOCK_OUT, true, allowCompact)) {
	        if (atExplicitKey) {
	          keyNode = state.result;
	        } else {
	          valueNode = state.result;
	        }
	      }

	      if (!atExplicitKey) {
	        storeMappingPair(state, _result, overridableKeys, keyTag, keyNode, valueNode, _keyLine, _keyLineStart, _keyPos);
	        keyTag = keyNode = valueNode = null;
	      }

	      skipSeparationSpace(state, true, -1);
	      ch = state.input.charCodeAt(state.position);
	    }

	    if ((state.line === _line || state.lineIndent > nodeIndent) && (ch !== 0)) {
	      throwError(state, 'bad indentation of a mapping entry');
	    } else if (state.lineIndent < nodeIndent) {
	      break;
	    }
	  }

	  //
	  // Epilogue.
	  //

	  // Special case: last mapping's node contains only the key in explicit notation.
	  if (atExplicitKey) {
	    storeMappingPair(state, _result, overridableKeys, keyTag, keyNode, null, _keyLine, _keyLineStart, _keyPos);
	  }

	  // Expose the resulting mapping.
	  if (detected) {
	    state.tag = _tag;
	    state.anchor = _anchor;
	    state.kind = 'mapping';
	    state.result = _result;
	  }

	  return detected;
	}

	function readTagProperty(state) {
	  var _position,
	      isVerbatim = false,
	      isNamed    = false,
	      tagHandle,
	      tagName,
	      ch;

	  ch = state.input.charCodeAt(state.position);

	  if (ch !== 0x21/* ! */) return false;

	  if (state.tag !== null) {
	    throwError(state, 'duplication of a tag property');
	  }

	  ch = state.input.charCodeAt(++state.position);

	  if (ch === 0x3C/* < */) {
	    isVerbatim = true;
	    ch = state.input.charCodeAt(++state.position);

	  } else if (ch === 0x21/* ! */) {
	    isNamed = true;
	    tagHandle = '!!';
	    ch = state.input.charCodeAt(++state.position);

	  } else {
	    tagHandle = '!';
	  }

	  _position = state.position;

	  if (isVerbatim) {
	    do { ch = state.input.charCodeAt(++state.position); }
	    while (ch !== 0 && ch !== 0x3E/* > */);

	    if (state.position < state.length) {
	      tagName = state.input.slice(_position, state.position);
	      ch = state.input.charCodeAt(++state.position);
	    } else {
	      throwError(state, 'unexpected end of the stream within a verbatim tag');
	    }
	  } else {
	    while (ch !== 0 && !is_WS_OR_EOL(ch)) {

	      if (ch === 0x21/* ! */) {
	        if (!isNamed) {
	          tagHandle = state.input.slice(_position - 1, state.position + 1);

	          if (!PATTERN_TAG_HANDLE.test(tagHandle)) {
	            throwError(state, 'named tag handle cannot contain such characters');
	          }

	          isNamed = true;
	          _position = state.position + 1;
	        } else {
	          throwError(state, 'tag suffix cannot contain exclamation marks');
	        }
	      }

	      ch = state.input.charCodeAt(++state.position);
	    }

	    tagName = state.input.slice(_position, state.position);

	    if (PATTERN_FLOW_INDICATORS.test(tagName)) {
	      throwError(state, 'tag suffix cannot contain flow indicator characters');
	    }
	  }

	  if (tagName && !PATTERN_TAG_URI.test(tagName)) {
	    throwError(state, 'tag name cannot contain such characters: ' + tagName);
	  }

	  try {
	    tagName = decodeURIComponent(tagName);
	  } catch (err) {
	    throwError(state, 'tag name is malformed: ' + tagName);
	  }

	  if (isVerbatim) {
	    state.tag = tagName;

	  } else if (_hasOwnProperty$1.call(state.tagMap, tagHandle)) {
	    state.tag = state.tagMap[tagHandle] + tagName;

	  } else if (tagHandle === '!') {
	    state.tag = '!' + tagName;

	  } else if (tagHandle === '!!') {
	    state.tag = 'tag:yaml.org,2002:' + tagName;

	  } else {
	    throwError(state, 'undeclared tag handle "' + tagHandle + '"');
	  }

	  return true;
	}

	function readAnchorProperty(state) {
	  var _position,
	      ch;

	  ch = state.input.charCodeAt(state.position);

	  if (ch !== 0x26/* & */) return false;

	  if (state.anchor !== null) {
	    throwError(state, 'duplication of an anchor property');
	  }

	  ch = state.input.charCodeAt(++state.position);
	  _position = state.position;

	  while (ch !== 0 && !is_WS_OR_EOL(ch) && !is_FLOW_INDICATOR(ch)) {
	    ch = state.input.charCodeAt(++state.position);
	  }

	  if (state.position === _position) {
	    throwError(state, 'name of an anchor node must contain at least one character');
	  }

	  state.anchor = state.input.slice(_position, state.position);
	  return true;
	}

	function readAlias(state) {
	  var _position, alias,
	      ch;

	  ch = state.input.charCodeAt(state.position);

	  if (ch !== 0x2A/* * */) return false;

	  ch = state.input.charCodeAt(++state.position);
	  _position = state.position;

	  while (ch !== 0 && !is_WS_OR_EOL(ch) && !is_FLOW_INDICATOR(ch)) {
	    ch = state.input.charCodeAt(++state.position);
	  }

	  if (state.position === _position) {
	    throwError(state, 'name of an alias node must contain at least one character');
	  }

	  alias = state.input.slice(_position, state.position);

	  if (!_hasOwnProperty$1.call(state.anchorMap, alias)) {
	    throwError(state, 'unidentified alias "' + alias + '"');
	  }

	  state.result = state.anchorMap[alias];
	  skipSeparationSpace(state, true, -1);
	  return true;
	}

	function composeNode(state, parentIndent, nodeContext, allowToSeek, allowCompact) {
	  var allowBlockStyles,
	      allowBlockScalars,
	      allowBlockCollections,
	      indentStatus = 1, // 1: this>parent, 0: this=parent, -1: this<parent
	      atNewLine  = false,
	      hasContent = false,
	      typeIndex,
	      typeQuantity,
	      typeList,
	      type,
	      flowIndent,
	      blockIndent;

	  if (state.listener !== null) {
	    state.listener('open', state);
	  }

	  state.tag    = null;
	  state.anchor = null;
	  state.kind   = null;
	  state.result = null;

	  allowBlockStyles = allowBlockScalars = allowBlockCollections =
	    CONTEXT_BLOCK_OUT === nodeContext ||
	    CONTEXT_BLOCK_IN  === nodeContext;

	  if (allowToSeek) {
	    if (skipSeparationSpace(state, true, -1)) {
	      atNewLine = true;

	      if (state.lineIndent > parentIndent) {
	        indentStatus = 1;
	      } else if (state.lineIndent === parentIndent) {
	        indentStatus = 0;
	      } else if (state.lineIndent < parentIndent) {
	        indentStatus = -1;
	      }
	    }
	  }

	  if (indentStatus === 1) {
	    while (readTagProperty(state) || readAnchorProperty(state)) {
	      if (skipSeparationSpace(state, true, -1)) {
	        atNewLine = true;
	        allowBlockCollections = allowBlockStyles;

	        if (state.lineIndent > parentIndent) {
	          indentStatus = 1;
	        } else if (state.lineIndent === parentIndent) {
	          indentStatus = 0;
	        } else if (state.lineIndent < parentIndent) {
	          indentStatus = -1;
	        }
	      } else {
	        allowBlockCollections = false;
	      }
	    }
	  }

	  if (allowBlockCollections) {
	    allowBlockCollections = atNewLine || allowCompact;
	  }

	  if (indentStatus === 1 || CONTEXT_BLOCK_OUT === nodeContext) {
	    if (CONTEXT_FLOW_IN === nodeContext || CONTEXT_FLOW_OUT === nodeContext) {
	      flowIndent = parentIndent;
	    } else {
	      flowIndent = parentIndent + 1;
	    }

	    blockIndent = state.position - state.lineStart;

	    if (indentStatus === 1) {
	      if (allowBlockCollections &&
	          (readBlockSequence(state, blockIndent) ||
	           readBlockMapping(state, blockIndent, flowIndent)) ||
	          readFlowCollection(state, flowIndent)) {
	        hasContent = true;
	      } else {
	        if ((allowBlockScalars && readBlockScalar(state, flowIndent)) ||
	            readSingleQuotedScalar(state, flowIndent) ||
	            readDoubleQuotedScalar(state, flowIndent)) {
	          hasContent = true;

	        } else if (readAlias(state)) {
	          hasContent = true;

	          if (state.tag !== null || state.anchor !== null) {
	            throwError(state, 'alias node should not have any properties');
	          }

	        } else if (readPlainScalar(state, flowIndent, CONTEXT_FLOW_IN === nodeContext)) {
	          hasContent = true;

	          if (state.tag === null) {
	            state.tag = '?';
	          }
	        }

	        if (state.anchor !== null) {
	          state.anchorMap[state.anchor] = state.result;
	        }
	      }
	    } else if (indentStatus === 0) {
	      // Special case: block sequences are allowed to have same indentation level as the parent.
	      // http://www.yaml.org/spec/1.2/spec.html#id2799784
	      hasContent = allowBlockCollections && readBlockSequence(state, blockIndent);
	    }
	  }

	  if (state.tag === null) {
	    if (state.anchor !== null) {
	      state.anchorMap[state.anchor] = state.result;
	    }

	  } else if (state.tag === '?') {
	    // Implicit resolving is not allowed for non-scalar types, and '?'
	    // non-specific tag is only automatically assigned to plain scalars.
	    //
	    // We only need to check kind conformity in case user explicitly assigns '?'
	    // tag, for example like this: "!<?> [0]"
	    //
	    if (state.result !== null && state.kind !== 'scalar') {
	      throwError(state, 'unacceptable node kind for !<?> tag; it should be "scalar", not "' + state.kind + '"');
	    }

	    for (typeIndex = 0, typeQuantity = state.implicitTypes.length; typeIndex < typeQuantity; typeIndex += 1) {
	      type = state.implicitTypes[typeIndex];

	      if (type.resolve(state.result)) { // `state.result` updated in resolver if matched
	        state.result = type.construct(state.result);
	        state.tag = type.tag;
	        if (state.anchor !== null) {
	          state.anchorMap[state.anchor] = state.result;
	        }
	        break;
	      }
	    }
	  } else if (state.tag !== '!') {
	    if (_hasOwnProperty$1.call(state.typeMap[state.kind || 'fallback'], state.tag)) {
	      type = state.typeMap[state.kind || 'fallback'][state.tag];
	    } else {
	      // looking for multi type
	      type = null;
	      typeList = state.typeMap.multi[state.kind || 'fallback'];

	      for (typeIndex = 0, typeQuantity = typeList.length; typeIndex < typeQuantity; typeIndex += 1) {
	        if (state.tag.slice(0, typeList[typeIndex].tag.length) === typeList[typeIndex].tag) {
	          type = typeList[typeIndex];
	          break;
	        }
	      }
	    }

	    if (!type) {
	      throwError(state, 'unknown tag !<' + state.tag + '>');
	    }

	    if (state.result !== null && type.kind !== state.kind) {
	      throwError(state, 'unacceptable node kind for !<' + state.tag + '> tag; it should be "' + type.kind + '", not "' + state.kind + '"');
	    }

	    if (!type.resolve(state.result, state.tag)) { // `state.result` updated in resolver if matched
	      throwError(state, 'cannot resolve a node with !<' + state.tag + '> explicit tag');
	    } else {
	      state.result = type.construct(state.result, state.tag);
	      if (state.anchor !== null) {
	        state.anchorMap[state.anchor] = state.result;
	      }
	    }
	  }

	  if (state.listener !== null) {
	    state.listener('close', state);
	  }
	  return state.tag !== null ||  state.anchor !== null || hasContent;
	}

	function readDocument(state) {
	  var documentStart = state.position,
	      _position,
	      directiveName,
	      directiveArgs,
	      hasDirectives = false,
	      ch;

	  state.version = null;
	  state.checkLineBreaks = state.legacy;
	  state.tagMap = Object.create(null);
	  state.anchorMap = Object.create(null);

	  while ((ch = state.input.charCodeAt(state.position)) !== 0) {
	    skipSeparationSpace(state, true, -1);

	    ch = state.input.charCodeAt(state.position);

	    if (state.lineIndent > 0 || ch !== 0x25/* % */) {
	      break;
	    }

	    hasDirectives = true;
	    ch = state.input.charCodeAt(++state.position);
	    _position = state.position;

	    while (ch !== 0 && !is_WS_OR_EOL(ch)) {
	      ch = state.input.charCodeAt(++state.position);
	    }

	    directiveName = state.input.slice(_position, state.position);
	    directiveArgs = [];

	    if (directiveName.length < 1) {
	      throwError(state, 'directive name must not be less than one character in length');
	    }

	    while (ch !== 0) {
	      while (is_WHITE_SPACE(ch)) {
	        ch = state.input.charCodeAt(++state.position);
	      }

	      if (ch === 0x23/* # */) {
	        do { ch = state.input.charCodeAt(++state.position); }
	        while (ch !== 0 && !is_EOL(ch));
	        break;
	      }

	      if (is_EOL(ch)) break;

	      _position = state.position;

	      while (ch !== 0 && !is_WS_OR_EOL(ch)) {
	        ch = state.input.charCodeAt(++state.position);
	      }

	      directiveArgs.push(state.input.slice(_position, state.position));
	    }

	    if (ch !== 0) readLineBreak(state);

	    if (_hasOwnProperty$1.call(directiveHandlers, directiveName)) {
	      directiveHandlers[directiveName](state, directiveName, directiveArgs);
	    } else {
	      throwWarning(state, 'unknown document directive "' + directiveName + '"');
	    }
	  }

	  skipSeparationSpace(state, true, -1);

	  if (state.lineIndent === 0 &&
	      state.input.charCodeAt(state.position)     === 0x2D/* - */ &&
	      state.input.charCodeAt(state.position + 1) === 0x2D/* - */ &&
	      state.input.charCodeAt(state.position + 2) === 0x2D/* - */) {
	    state.position += 3;
	    skipSeparationSpace(state, true, -1);

	  } else if (hasDirectives) {
	    throwError(state, 'directives end mark is expected');
	  }

	  composeNode(state, state.lineIndent - 1, CONTEXT_BLOCK_OUT, false, true);
	  skipSeparationSpace(state, true, -1);

	  if (state.checkLineBreaks &&
	      PATTERN_NON_ASCII_LINE_BREAKS.test(state.input.slice(documentStart, state.position))) {
	    throwWarning(state, 'non-ASCII line breaks are interpreted as content');
	  }

	  state.documents.push(state.result);

	  if (state.position === state.lineStart && testDocumentSeparator(state)) {

	    if (state.input.charCodeAt(state.position) === 0x2E/* . */) {
	      state.position += 3;
	      skipSeparationSpace(state, true, -1);
	    }
	    return;
	  }

	  if (state.position < (state.length - 1)) {
	    throwError(state, 'end of the stream or a document separator is expected');
	  } else {
	    return;
	  }
	}


	function loadDocuments(input, options) {
	  input = String(input);
	  options = options || {};

	  if (input.length !== 0) {

	    // Add tailing `\n` if not exists
	    if (input.charCodeAt(input.length - 1) !== 0x0A/* LF */ &&
	        input.charCodeAt(input.length - 1) !== 0x0D/* CR */) {
	      input += '\n';
	    }

	    // Strip BOM
	    if (input.charCodeAt(0) === 0xFEFF) {
	      input = input.slice(1);
	    }
	  }

	  var state = new State$1(input, options);

	  var nullpos = input.indexOf('\0');

	  if (nullpos !== -1) {
	    state.position = nullpos;
	    throwError(state, 'null byte is not allowed in input');
	  }

	  // Use 0 as string terminator. That significantly simplifies bounds check.
	  state.input += '\0';

	  while (state.input.charCodeAt(state.position) === 0x20/* Space */) {
	    state.lineIndent += 1;
	    state.position += 1;
	  }

	  while (state.position < (state.length - 1)) {
	    readDocument(state);
	  }

	  return state.documents;
	}


	function loadAll(input, iterator, options) {
	  if (iterator !== null && typeof iterator === 'object' && typeof options === 'undefined') {
	    options = iterator;
	    iterator = null;
	  }

	  var documents = loadDocuments(input, options);

	  if (typeof iterator !== 'function') {
	    return documents;
	  }

	  for (var index = 0, length = documents.length; index < length; index += 1) {
	    iterator(documents[index]);
	  }
	}


	function load(input, options) {
	  var documents = loadDocuments(input, options);

	  if (documents.length === 0) {
	    /*eslint-disable no-undefined*/
	    return undefined;
	  } else if (documents.length === 1) {
	    return documents[0];
	  }
	  throw new YAMLException$1('expected a single document in the stream, but found more');
	}


	loader$1.loadAll = loadAll;
	loader$1.load    = load;

	var dumper$1 = {};

	/*eslint-disable no-use-before-define*/

	var common              = common$5;
	var YAMLException       = exception;
	var DEFAULT_SCHEMA      = _default;

	var _toString       = Object.prototype.toString;
	var _hasOwnProperty = Object.prototype.hasOwnProperty;

	var CHAR_BOM                  = 0xFEFF;
	var CHAR_TAB                  = 0x09; /* Tab */
	var CHAR_LINE_FEED            = 0x0A; /* LF */
	var CHAR_CARRIAGE_RETURN      = 0x0D; /* CR */
	var CHAR_SPACE                = 0x20; /* Space */
	var CHAR_EXCLAMATION          = 0x21; /* ! */
	var CHAR_DOUBLE_QUOTE         = 0x22; /* " */
	var CHAR_SHARP                = 0x23; /* # */
	var CHAR_PERCENT              = 0x25; /* % */
	var CHAR_AMPERSAND            = 0x26; /* & */
	var CHAR_SINGLE_QUOTE         = 0x27; /* ' */
	var CHAR_ASTERISK             = 0x2A; /* * */
	var CHAR_COMMA                = 0x2C; /* , */
	var CHAR_MINUS                = 0x2D; /* - */
	var CHAR_COLON                = 0x3A; /* : */
	var CHAR_EQUALS               = 0x3D; /* = */
	var CHAR_GREATER_THAN         = 0x3E; /* > */
	var CHAR_QUESTION             = 0x3F; /* ? */
	var CHAR_COMMERCIAL_AT        = 0x40; /* @ */
	var CHAR_LEFT_SQUARE_BRACKET  = 0x5B; /* [ */
	var CHAR_RIGHT_SQUARE_BRACKET = 0x5D; /* ] */
	var CHAR_GRAVE_ACCENT         = 0x60; /* ` */
	var CHAR_LEFT_CURLY_BRACKET   = 0x7B; /* { */
	var CHAR_VERTICAL_LINE        = 0x7C; /* | */
	var CHAR_RIGHT_CURLY_BRACKET  = 0x7D; /* } */

	var ESCAPE_SEQUENCES = {};

	ESCAPE_SEQUENCES[0x00]   = '\\0';
	ESCAPE_SEQUENCES[0x07]   = '\\a';
	ESCAPE_SEQUENCES[0x08]   = '\\b';
	ESCAPE_SEQUENCES[0x09]   = '\\t';
	ESCAPE_SEQUENCES[0x0A]   = '\\n';
	ESCAPE_SEQUENCES[0x0B]   = '\\v';
	ESCAPE_SEQUENCES[0x0C]   = '\\f';
	ESCAPE_SEQUENCES[0x0D]   = '\\r';
	ESCAPE_SEQUENCES[0x1B]   = '\\e';
	ESCAPE_SEQUENCES[0x22]   = '\\"';
	ESCAPE_SEQUENCES[0x5C]   = '\\\\';
	ESCAPE_SEQUENCES[0x85]   = '\\N';
	ESCAPE_SEQUENCES[0xA0]   = '\\_';
	ESCAPE_SEQUENCES[0x2028] = '\\L';
	ESCAPE_SEQUENCES[0x2029] = '\\P';

	var DEPRECATED_BOOLEANS_SYNTAX = [
	  'y', 'Y', 'yes', 'Yes', 'YES', 'on', 'On', 'ON',
	  'n', 'N', 'no', 'No', 'NO', 'off', 'Off', 'OFF'
	];

	var DEPRECATED_BASE60_SYNTAX = /^[-+]?[0-9_]+(?::[0-9_]+)+(?:\.[0-9_]*)?$/;

	function compileStyleMap(schema, map) {
	  var result, keys, index, length, tag, style, type;

	  if (map === null) return {};

	  result = {};
	  keys = Object.keys(map);

	  for (index = 0, length = keys.length; index < length; index += 1) {
	    tag = keys[index];
	    style = String(map[tag]);

	    if (tag.slice(0, 2) === '!!') {
	      tag = 'tag:yaml.org,2002:' + tag.slice(2);
	    }
	    type = schema.compiledTypeMap['fallback'][tag];

	    if (type && _hasOwnProperty.call(type.styleAliases, style)) {
	      style = type.styleAliases[style];
	    }

	    result[tag] = style;
	  }

	  return result;
	}

	function encodeHex(character) {
	  var string, handle, length;

	  string = character.toString(16).toUpperCase();

	  if (character <= 0xFF) {
	    handle = 'x';
	    length = 2;
	  } else if (character <= 0xFFFF) {
	    handle = 'u';
	    length = 4;
	  } else if (character <= 0xFFFFFFFF) {
	    handle = 'U';
	    length = 8;
	  } else {
	    throw new YAMLException('code point within a string may not be greater than 0xFFFFFFFF');
	  }

	  return '\\' + handle + common.repeat('0', length - string.length) + string;
	}


	var QUOTING_TYPE_SINGLE = 1,
	    QUOTING_TYPE_DOUBLE = 2;

	function State(options) {
	  this.schema        = options['schema'] || DEFAULT_SCHEMA;
	  this.indent        = Math.max(1, (options['indent'] || 2));
	  this.noArrayIndent = options['noArrayIndent'] || false;
	  this.skipInvalid   = options['skipInvalid'] || false;
	  this.flowLevel     = (common.isNothing(options['flowLevel']) ? -1 : options['flowLevel']);
	  this.styleMap      = compileStyleMap(this.schema, options['styles'] || null);
	  this.sortKeys      = options['sortKeys'] || false;
	  this.lineWidth     = options['lineWidth'] || 80;
	  this.noRefs        = options['noRefs'] || false;
	  this.noCompatMode  = options['noCompatMode'] || false;
	  this.condenseFlow  = options['condenseFlow'] || false;
	  this.quotingType   = options['quotingType'] === '"' ? QUOTING_TYPE_DOUBLE : QUOTING_TYPE_SINGLE;
	  this.forceQuotes   = options['forceQuotes'] || false;
	  this.replacer      = typeof options['replacer'] === 'function' ? options['replacer'] : null;

	  this.implicitTypes = this.schema.compiledImplicit;
	  this.explicitTypes = this.schema.compiledExplicit;

	  this.tag = null;
	  this.result = '';

	  this.duplicates = [];
	  this.usedDuplicates = null;
	}

	// Indents every line in a string. Empty lines (\n only) are not indented.
	function indentString(string, spaces) {
	  var ind = common.repeat(' ', spaces),
	      position = 0,
	      next = -1,
	      result = '',
	      line,
	      length = string.length;

	  while (position < length) {
	    next = string.indexOf('\n', position);
	    if (next === -1) {
	      line = string.slice(position);
	      position = length;
	    } else {
	      line = string.slice(position, next + 1);
	      position = next + 1;
	    }

	    if (line.length && line !== '\n') result += ind;

	    result += line;
	  }

	  return result;
	}

	function generateNextLine(state, level) {
	  return '\n' + common.repeat(' ', state.indent * level);
	}

	function testImplicitResolving(state, str) {
	  var index, length, type;

	  for (index = 0, length = state.implicitTypes.length; index < length; index += 1) {
	    type = state.implicitTypes[index];

	    if (type.resolve(str)) {
	      return true;
	    }
	  }

	  return false;
	}

	// [33] s-white ::= s-space | s-tab
	function isWhitespace(c) {
	  return c === CHAR_SPACE || c === CHAR_TAB;
	}

	// Returns true if the character can be printed without escaping.
	// From YAML 1.2: "any allowed characters known to be non-printable
	// should also be escaped. [However,] This isn’t mandatory"
	// Derived from nb-char - \t - #x85 - #xA0 - #x2028 - #x2029.
	function isPrintable(c) {
	  return  (0x00020 <= c && c <= 0x00007E)
	      || ((0x000A1 <= c && c <= 0x00D7FF) && c !== 0x2028 && c !== 0x2029)
	      || ((0x0E000 <= c && c <= 0x00FFFD) && c !== CHAR_BOM)
	      ||  (0x10000 <= c && c <= 0x10FFFF);
	}

	// [34] ns-char ::= nb-char - s-white
	// [27] nb-char ::= c-printable - b-char - c-byte-order-mark
	// [26] b-char  ::= b-line-feed | b-carriage-return
	// Including s-white (for some reason, examples doesn't match specs in this aspect)
	// ns-char ::= c-printable - b-line-feed - b-carriage-return - c-byte-order-mark
	function isNsCharOrWhitespace(c) {
	  return isPrintable(c)
	    && c !== CHAR_BOM
	    // - b-char
	    && c !== CHAR_CARRIAGE_RETURN
	    && c !== CHAR_LINE_FEED;
	}

	// [127]  ns-plain-safe(c) ::= c = flow-out  ⇒ ns-plain-safe-out
	//                             c = flow-in   ⇒ ns-plain-safe-in
	//                             c = block-key ⇒ ns-plain-safe-out
	//                             c = flow-key  ⇒ ns-plain-safe-in
	// [128] ns-plain-safe-out ::= ns-char
	// [129]  ns-plain-safe-in ::= ns-char - c-flow-indicator
	// [130]  ns-plain-char(c) ::=  ( ns-plain-safe(c) - “:” - “#” )
	//                            | ( /* An ns-char preceding */ “#” )
	//                            | ( “:” /* Followed by an ns-plain-safe(c) */ )
	function isPlainSafe(c, prev, inblock) {
	  var cIsNsCharOrWhitespace = isNsCharOrWhitespace(c);
	  var cIsNsChar = cIsNsCharOrWhitespace && !isWhitespace(c);
	  return (
	    // ns-plain-safe
	    inblock ? // c = flow-in
	      cIsNsCharOrWhitespace
	      : cIsNsCharOrWhitespace
	        // - c-flow-indicator
	        && c !== CHAR_COMMA
	        && c !== CHAR_LEFT_SQUARE_BRACKET
	        && c !== CHAR_RIGHT_SQUARE_BRACKET
	        && c !== CHAR_LEFT_CURLY_BRACKET
	        && c !== CHAR_RIGHT_CURLY_BRACKET
	  )
	    // ns-plain-char
	    && c !== CHAR_SHARP // false on '#'
	    && !(prev === CHAR_COLON && !cIsNsChar) // false on ': '
	    || (isNsCharOrWhitespace(prev) && !isWhitespace(prev) && c === CHAR_SHARP) // change to true on '[^ ]#'
	    || (prev === CHAR_COLON && cIsNsChar); // change to true on ':[^ ]'
	}

	// Simplified test for values allowed as the first character in plain style.
	function isPlainSafeFirst(c) {
	  // Uses a subset of ns-char - c-indicator
	  // where ns-char = nb-char - s-white.
	  // No support of ( ( “?” | “:” | “-” ) /* Followed by an ns-plain-safe(c)) */ ) part
	  return isPrintable(c) && c !== CHAR_BOM
	    && !isWhitespace(c) // - s-white
	    // - (c-indicator ::=
	    // “-” | “?” | “:” | “,” | “[” | “]” | “{” | “}”
	    && c !== CHAR_MINUS
	    && c !== CHAR_QUESTION
	    && c !== CHAR_COLON
	    && c !== CHAR_COMMA
	    && c !== CHAR_LEFT_SQUARE_BRACKET
	    && c !== CHAR_RIGHT_SQUARE_BRACKET
	    && c !== CHAR_LEFT_CURLY_BRACKET
	    && c !== CHAR_RIGHT_CURLY_BRACKET
	    // | “#” | “&” | “*” | “!” | “|” | “=” | “>” | “'” | “"”
	    && c !== CHAR_SHARP
	    && c !== CHAR_AMPERSAND
	    && c !== CHAR_ASTERISK
	    && c !== CHAR_EXCLAMATION
	    && c !== CHAR_VERTICAL_LINE
	    && c !== CHAR_EQUALS
	    && c !== CHAR_GREATER_THAN
	    && c !== CHAR_SINGLE_QUOTE
	    && c !== CHAR_DOUBLE_QUOTE
	    // | “%” | “@” | “`”)
	    && c !== CHAR_PERCENT
	    && c !== CHAR_COMMERCIAL_AT
	    && c !== CHAR_GRAVE_ACCENT;
	}

	// Simplified test for values allowed as the last character in plain style.
	function isPlainSafeLast(c) {
	  // just not whitespace or colon, it will be checked to be plain character later
	  return !isWhitespace(c) && c !== CHAR_COLON;
	}

	// Same as 'string'.codePointAt(pos), but works in older browsers.
	function codePointAt(string, pos) {
	  var first = string.charCodeAt(pos), second;
	  if (first >= 0xD800 && first <= 0xDBFF && pos + 1 < string.length) {
	    second = string.charCodeAt(pos + 1);
	    if (second >= 0xDC00 && second <= 0xDFFF) {
	      // https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
	      return (first - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
	    }
	  }
	  return first;
	}

	// Determines whether block indentation indicator is required.
	function needIndentIndicator(string) {
	  var leadingSpaceRe = /^\n* /;
	  return leadingSpaceRe.test(string);
	}

	var STYLE_PLAIN   = 1,
	    STYLE_SINGLE  = 2,
	    STYLE_LITERAL = 3,
	    STYLE_FOLDED  = 4,
	    STYLE_DOUBLE  = 5;

	// Determines which scalar styles are possible and returns the preferred style.
	// lineWidth = -1 => no limit.
	// Pre-conditions: str.length > 0.
	// Post-conditions:
	//    STYLE_PLAIN or STYLE_SINGLE => no \n are in the string.
	//    STYLE_LITERAL => no lines are suitable for folding (or lineWidth is -1).
	//    STYLE_FOLDED => a line > lineWidth and can be folded (and lineWidth != -1).
	function chooseScalarStyle(string, singleLineOnly, indentPerLevel, lineWidth,
	  testAmbiguousType, quotingType, forceQuotes, inblock) {

	  var i;
	  var char = 0;
	  var prevChar = null;
	  var hasLineBreak = false;
	  var hasFoldableLine = false; // only checked if shouldTrackWidth
	  var shouldTrackWidth = lineWidth !== -1;
	  var previousLineBreak = -1; // count the first line correctly
	  var plain = isPlainSafeFirst(codePointAt(string, 0))
	          && isPlainSafeLast(codePointAt(string, string.length - 1));

	  if (singleLineOnly || forceQuotes) {
	    // Case: no block styles.
	    // Check for disallowed characters to rule out plain and single.
	    for (i = 0; i < string.length; char >= 0x10000 ? i += 2 : i++) {
	      char = codePointAt(string, i);
	      if (!isPrintable(char)) {
	        return STYLE_DOUBLE;
	      }
	      plain = plain && isPlainSafe(char, prevChar, inblock);
	      prevChar = char;
	    }
	  } else {
	    // Case: block styles permitted.
	    for (i = 0; i < string.length; char >= 0x10000 ? i += 2 : i++) {
	      char = codePointAt(string, i);
	      if (char === CHAR_LINE_FEED) {
	        hasLineBreak = true;
	        // Check if any line can be folded.
	        if (shouldTrackWidth) {
	          hasFoldableLine = hasFoldableLine ||
	            // Foldable line = too long, and not more-indented.
	            (i - previousLineBreak - 1 > lineWidth &&
	             string[previousLineBreak + 1] !== ' ');
	          previousLineBreak = i;
	        }
	      } else if (!isPrintable(char)) {
	        return STYLE_DOUBLE;
	      }
	      plain = plain && isPlainSafe(char, prevChar, inblock);
	      prevChar = char;
	    }
	    // in case the end is missing a \n
	    hasFoldableLine = hasFoldableLine || (shouldTrackWidth &&
	      (i - previousLineBreak - 1 > lineWidth &&
	       string[previousLineBreak + 1] !== ' '));
	  }
	  // Although every style can represent \n without escaping, prefer block styles
	  // for multiline, since they're more readable and they don't add empty lines.
	  // Also prefer folding a super-long line.
	  if (!hasLineBreak && !hasFoldableLine) {
	    // Strings interpretable as another type have to be quoted;
	    // e.g. the string 'true' vs. the boolean true.
	    if (plain && !forceQuotes && !testAmbiguousType(string)) {
	      return STYLE_PLAIN;
	    }
	    return quotingType === QUOTING_TYPE_DOUBLE ? STYLE_DOUBLE : STYLE_SINGLE;
	  }
	  // Edge case: block indentation indicator can only have one digit.
	  if (indentPerLevel > 9 && needIndentIndicator(string)) {
	    return STYLE_DOUBLE;
	  }
	  // At this point we know block styles are valid.
	  // Prefer literal style unless we want to fold.
	  if (!forceQuotes) {
	    return hasFoldableLine ? STYLE_FOLDED : STYLE_LITERAL;
	  }
	  return quotingType === QUOTING_TYPE_DOUBLE ? STYLE_DOUBLE : STYLE_SINGLE;
	}

	// Note: line breaking/folding is implemented for only the folded style.
	// NB. We drop the last trailing newline (if any) of a returned block scalar
	//  since the dumper adds its own newline. This always works:
	//    • No ending newline => unaffected; already using strip "-" chomping.
	//    • Ending newline    => removed then restored.
	//  Importantly, this keeps the "+" chomp indicator from gaining an extra line.
	function writeScalar(state, string, level, iskey, inblock) {
	  state.dump = (function () {
	    if (string.length === 0) {
	      return state.quotingType === QUOTING_TYPE_DOUBLE ? '""' : "''";
	    }
	    if (!state.noCompatMode) {
	      if (DEPRECATED_BOOLEANS_SYNTAX.indexOf(string) !== -1 || DEPRECATED_BASE60_SYNTAX.test(string)) {
	        return state.quotingType === QUOTING_TYPE_DOUBLE ? ('"' + string + '"') : ("'" + string + "'");
	      }
	    }

	    var indent = state.indent * Math.max(1, level); // no 0-indent scalars
	    // As indentation gets deeper, let the width decrease monotonically
	    // to the lower bound min(state.lineWidth, 40).
	    // Note that this implies
	    //  state.lineWidth ≤ 40 + state.indent: width is fixed at the lower bound.
	    //  state.lineWidth > 40 + state.indent: width decreases until the lower bound.
	    // This behaves better than a constant minimum width which disallows narrower options,
	    // or an indent threshold which causes the width to suddenly increase.
	    var lineWidth = state.lineWidth === -1
	      ? -1 : Math.max(Math.min(state.lineWidth, 40), state.lineWidth - indent);

	    // Without knowing if keys are implicit/explicit, assume implicit for safety.
	    var singleLineOnly = iskey
	      // No block styles in flow mode.
	      || (state.flowLevel > -1 && level >= state.flowLevel);
	    function testAmbiguity(string) {
	      return testImplicitResolving(state, string);
	    }

	    switch (chooseScalarStyle(string, singleLineOnly, state.indent, lineWidth,
	      testAmbiguity, state.quotingType, state.forceQuotes && !iskey, inblock)) {

	      case STYLE_PLAIN:
	        return string;
	      case STYLE_SINGLE:
	        return "'" + string.replace(/'/g, "''") + "'";
	      case STYLE_LITERAL:
	        return '|' + blockHeader(string, state.indent)
	          + dropEndingNewline(indentString(string, indent));
	      case STYLE_FOLDED:
	        return '>' + blockHeader(string, state.indent)
	          + dropEndingNewline(indentString(foldString(string, lineWidth), indent));
	      case STYLE_DOUBLE:
	        return '"' + escapeString(string) + '"';
	      default:
	        throw new YAMLException('impossible error: invalid scalar style');
	    }
	  }());
	}

	// Pre-conditions: string is valid for a block scalar, 1 <= indentPerLevel <= 9.
	function blockHeader(string, indentPerLevel) {
	  var indentIndicator = needIndentIndicator(string) ? String(indentPerLevel) : '';

	  // note the special case: the string '\n' counts as a "trailing" empty line.
	  var clip =          string[string.length - 1] === '\n';
	  var keep = clip && (string[string.length - 2] === '\n' || string === '\n');
	  var chomp = keep ? '+' : (clip ? '' : '-');

	  return indentIndicator + chomp + '\n';
	}

	// (See the note for writeScalar.)
	function dropEndingNewline(string) {
	  return string[string.length - 1] === '\n' ? string.slice(0, -1) : string;
	}

	// Note: a long line without a suitable break point will exceed the width limit.
	// Pre-conditions: every char in str isPrintable, str.length > 0, width > 0.
	function foldString(string, width) {
	  // In folded style, $k$ consecutive newlines output as $k+1$ newlines—
	  // unless they're before or after a more-indented line, or at the very
	  // beginning or end, in which case $k$ maps to $k$.
	  // Therefore, parse each chunk as newline(s) followed by a content line.
	  var lineRe = /(\n+)([^\n]*)/g;

	  // first line (possibly an empty line)
	  var result = (function () {
	    var nextLF = string.indexOf('\n');
	    nextLF = nextLF !== -1 ? nextLF : string.length;
	    lineRe.lastIndex = nextLF;
	    return foldLine(string.slice(0, nextLF), width);
	  }());
	  // If we haven't reached the first content line yet, don't add an extra \n.
	  var prevMoreIndented = string[0] === '\n' || string[0] === ' ';
	  var moreIndented;

	  // rest of the lines
	  var match;
	  while ((match = lineRe.exec(string))) {
	    var prefix = match[1], line = match[2];
	    moreIndented = (line[0] === ' ');
	    result += prefix
	      + (!prevMoreIndented && !moreIndented && line !== ''
	        ? '\n' : '')
	      + foldLine(line, width);
	    prevMoreIndented = moreIndented;
	  }

	  return result;
	}

	// Greedy line breaking.
	// Picks the longest line under the limit each time,
	// otherwise settles for the shortest line over the limit.
	// NB. More-indented lines *cannot* be folded, as that would add an extra \n.
	function foldLine(line, width) {
	  if (line === '' || line[0] === ' ') return line;

	  // Since a more-indented line adds a \n, breaks can't be followed by a space.
	  var breakRe = / [^ ]/g; // note: the match index will always be <= length-2.
	  var match;
	  // start is an inclusive index. end, curr, and next are exclusive.
	  var start = 0, end, curr = 0, next = 0;
	  var result = '';

	  // Invariants: 0 <= start <= length-1.
	  //   0 <= curr <= next <= max(0, length-2). curr - start <= width.
	  // Inside the loop:
	  //   A match implies length >= 2, so curr and next are <= length-2.
	  while ((match = breakRe.exec(line))) {
	    next = match.index;
	    // maintain invariant: curr - start <= width
	    if (next - start > width) {
	      end = (curr > start) ? curr : next; // derive end <= length-2
	      result += '\n' + line.slice(start, end);
	      // skip the space that was output as \n
	      start = end + 1;                    // derive start <= length-1
	    }
	    curr = next;
	  }

	  // By the invariants, start <= length-1, so there is something left over.
	  // It is either the whole string or a part starting from non-whitespace.
	  result += '\n';
	  // Insert a break if the remainder is too long and there is a break available.
	  if (line.length - start > width && curr > start) {
	    result += line.slice(start, curr) + '\n' + line.slice(curr + 1);
	  } else {
	    result += line.slice(start);
	  }

	  return result.slice(1); // drop extra \n joiner
	}

	// Escapes a double-quoted string.
	function escapeString(string) {
	  var result = '';
	  var char = 0;
	  var escapeSeq;

	  for (var i = 0; i < string.length; char >= 0x10000 ? i += 2 : i++) {
	    char = codePointAt(string, i);
	    escapeSeq = ESCAPE_SEQUENCES[char];

	    if (!escapeSeq && isPrintable(char)) {
	      result += string[i];
	      if (char >= 0x10000) result += string[i + 1];
	    } else {
	      result += escapeSeq || encodeHex(char);
	    }
	  }

	  return result;
	}

	function writeFlowSequence(state, level, object) {
	  var _result = '',
	      _tag    = state.tag,
	      index,
	      length,
	      value;

	  for (index = 0, length = object.length; index < length; index += 1) {
	    value = object[index];

	    if (state.replacer) {
	      value = state.replacer.call(object, String(index), value);
	    }

	    // Write only valid elements, put null instead of invalid elements.
	    if (writeNode(state, level, value, false, false) ||
	        (typeof value === 'undefined' &&
	         writeNode(state, level, null, false, false))) {

	      if (_result !== '') _result += ',' + (!state.condenseFlow ? ' ' : '');
	      _result += state.dump;
	    }
	  }

	  state.tag = _tag;
	  state.dump = '[' + _result + ']';
	}

	function writeBlockSequence(state, level, object, compact) {
	  var _result = '',
	      _tag    = state.tag,
	      index,
	      length,
	      value;

	  for (index = 0, length = object.length; index < length; index += 1) {
	    value = object[index];

	    if (state.replacer) {
	      value = state.replacer.call(object, String(index), value);
	    }

	    // Write only valid elements, put null instead of invalid elements.
	    if (writeNode(state, level + 1, value, true, true, false, true) ||
	        (typeof value === 'undefined' &&
	         writeNode(state, level + 1, null, true, true, false, true))) {

	      if (!compact || _result !== '') {
	        _result += generateNextLine(state, level);
	      }

	      if (state.dump && CHAR_LINE_FEED === state.dump.charCodeAt(0)) {
	        _result += '-';
	      } else {
	        _result += '- ';
	      }

	      _result += state.dump;
	    }
	  }

	  state.tag = _tag;
	  state.dump = _result || '[]'; // Empty sequence if no valid values.
	}

	function writeFlowMapping(state, level, object) {
	  var _result       = '',
	      _tag          = state.tag,
	      objectKeyList = Object.keys(object),
	      index,
	      length,
	      objectKey,
	      objectValue,
	      pairBuffer;

	  for (index = 0, length = objectKeyList.length; index < length; index += 1) {

	    pairBuffer = '';
	    if (_result !== '') pairBuffer += ', ';

	    if (state.condenseFlow) pairBuffer += '"';

	    objectKey = objectKeyList[index];
	    objectValue = object[objectKey];

	    if (state.replacer) {
	      objectValue = state.replacer.call(object, objectKey, objectValue);
	    }

	    if (!writeNode(state, level, objectKey, false, false)) {
	      continue; // Skip this pair because of invalid key;
	    }

	    if (state.dump.length > 1024) pairBuffer += '? ';

	    pairBuffer += state.dump + (state.condenseFlow ? '"' : '') + ':' + (state.condenseFlow ? '' : ' ');

	    if (!writeNode(state, level, objectValue, false, false)) {
	      continue; // Skip this pair because of invalid value.
	    }

	    pairBuffer += state.dump;

	    // Both key and value are valid.
	    _result += pairBuffer;
	  }

	  state.tag = _tag;
	  state.dump = '{' + _result + '}';
	}

	function writeBlockMapping(state, level, object, compact) {
	  var _result       = '',
	      _tag          = state.tag,
	      objectKeyList = Object.keys(object),
	      index,
	      length,
	      objectKey,
	      objectValue,
	      explicitPair,
	      pairBuffer;

	  // Allow sorting keys so that the output file is deterministic
	  if (state.sortKeys === true) {
	    // Default sorting
	    objectKeyList.sort();
	  } else if (typeof state.sortKeys === 'function') {
	    // Custom sort function
	    objectKeyList.sort(state.sortKeys);
	  } else if (state.sortKeys) {
	    // Something is wrong
	    throw new YAMLException('sortKeys must be a boolean or a function');
	  }

	  for (index = 0, length = objectKeyList.length; index < length; index += 1) {
	    pairBuffer = '';

	    if (!compact || _result !== '') {
	      pairBuffer += generateNextLine(state, level);
	    }

	    objectKey = objectKeyList[index];
	    objectValue = object[objectKey];

	    if (state.replacer) {
	      objectValue = state.replacer.call(object, objectKey, objectValue);
	    }

	    if (!writeNode(state, level + 1, objectKey, true, true, true)) {
	      continue; // Skip this pair because of invalid key.
	    }

	    explicitPair = (state.tag !== null && state.tag !== '?') ||
	                   (state.dump && state.dump.length > 1024);

	    if (explicitPair) {
	      if (state.dump && CHAR_LINE_FEED === state.dump.charCodeAt(0)) {
	        pairBuffer += '?';
	      } else {
	        pairBuffer += '? ';
	      }
	    }

	    pairBuffer += state.dump;

	    if (explicitPair) {
	      pairBuffer += generateNextLine(state, level);
	    }

	    if (!writeNode(state, level + 1, objectValue, true, explicitPair)) {
	      continue; // Skip this pair because of invalid value.
	    }

	    if (state.dump && CHAR_LINE_FEED === state.dump.charCodeAt(0)) {
	      pairBuffer += ':';
	    } else {
	      pairBuffer += ': ';
	    }

	    pairBuffer += state.dump;

	    // Both key and value are valid.
	    _result += pairBuffer;
	  }

	  state.tag = _tag;
	  state.dump = _result || '{}'; // Empty mapping if no valid pairs.
	}

	function detectType(state, object, explicit) {
	  var _result, typeList, index, length, type, style;

	  typeList = explicit ? state.explicitTypes : state.implicitTypes;

	  for (index = 0, length = typeList.length; index < length; index += 1) {
	    type = typeList[index];

	    if ((type.instanceOf  || type.predicate) &&
	        (!type.instanceOf || ((typeof object === 'object') && (object instanceof type.instanceOf))) &&
	        (!type.predicate  || type.predicate(object))) {

	      if (explicit) {
	        if (type.multi && type.representName) {
	          state.tag = type.representName(object);
	        } else {
	          state.tag = type.tag;
	        }
	      } else {
	        state.tag = '?';
	      }

	      if (type.represent) {
	        style = state.styleMap[type.tag] || type.defaultStyle;

	        if (_toString.call(type.represent) === '[object Function]') {
	          _result = type.represent(object, style);
	        } else if (_hasOwnProperty.call(type.represent, style)) {
	          _result = type.represent[style](object, style);
	        } else {
	          throw new YAMLException('!<' + type.tag + '> tag resolver accepts not "' + style + '" style');
	        }

	        state.dump = _result;
	      }

	      return true;
	    }
	  }

	  return false;
	}

	// Serializes `object` and writes it to global `result`.
	// Returns true on success, or false on invalid object.
	//
	function writeNode(state, level, object, block, compact, iskey, isblockseq) {
	  state.tag = null;
	  state.dump = object;

	  if (!detectType(state, object, false)) {
	    detectType(state, object, true);
	  }

	  var type = _toString.call(state.dump);
	  var inblock = block;
	  var tagStr;

	  if (block) {
	    block = (state.flowLevel < 0 || state.flowLevel > level);
	  }

	  var objectOrArray = type === '[object Object]' || type === '[object Array]',
	      duplicateIndex,
	      duplicate;

	  if (objectOrArray) {
	    duplicateIndex = state.duplicates.indexOf(object);
	    duplicate = duplicateIndex !== -1;
	  }

	  if ((state.tag !== null && state.tag !== '?') || duplicate || (state.indent !== 2 && level > 0)) {
	    compact = false;
	  }

	  if (duplicate && state.usedDuplicates[duplicateIndex]) {
	    state.dump = '*ref_' + duplicateIndex;
	  } else {
	    if (objectOrArray && duplicate && !state.usedDuplicates[duplicateIndex]) {
	      state.usedDuplicates[duplicateIndex] = true;
	    }
	    if (type === '[object Object]') {
	      if (block && (Object.keys(state.dump).length !== 0)) {
	        writeBlockMapping(state, level, state.dump, compact);
	        if (duplicate) {
	          state.dump = '&ref_' + duplicateIndex + state.dump;
	        }
	      } else {
	        writeFlowMapping(state, level, state.dump);
	        if (duplicate) {
	          state.dump = '&ref_' + duplicateIndex + ' ' + state.dump;
	        }
	      }
	    } else if (type === '[object Array]') {
	      if (block && (state.dump.length !== 0)) {
	        if (state.noArrayIndent && !isblockseq && level > 0) {
	          writeBlockSequence(state, level - 1, state.dump, compact);
	        } else {
	          writeBlockSequence(state, level, state.dump, compact);
	        }
	        if (duplicate) {
	          state.dump = '&ref_' + duplicateIndex + state.dump;
	        }
	      } else {
	        writeFlowSequence(state, level, state.dump);
	        if (duplicate) {
	          state.dump = '&ref_' + duplicateIndex + ' ' + state.dump;
	        }
	      }
	    } else if (type === '[object String]') {
	      if (state.tag !== '?') {
	        writeScalar(state, state.dump, level, iskey, inblock);
	      }
	    } else if (type === '[object Undefined]') {
	      return false;
	    } else {
	      if (state.skipInvalid) return false;
	      throw new YAMLException('unacceptable kind of an object to dump ' + type);
	    }

	    if (state.tag !== null && state.tag !== '?') {
	      // Need to encode all characters except those allowed by the spec:
	      //
	      // [35] ns-dec-digit    ::=  [#x30-#x39] /* 0-9 */
	      // [36] ns-hex-digit    ::=  ns-dec-digit
	      //                         | [#x41-#x46] /* A-F */ | [#x61-#x66] /* a-f */
	      // [37] ns-ascii-letter ::=  [#x41-#x5A] /* A-Z */ | [#x61-#x7A] /* a-z */
	      // [38] ns-word-char    ::=  ns-dec-digit | ns-ascii-letter | “-”
	      // [39] ns-uri-char     ::=  “%” ns-hex-digit ns-hex-digit | ns-word-char | “#”
	      //                         | “;” | “/” | “?” | “:” | “@” | “&” | “=” | “+” | “$” | “,”
	      //                         | “_” | “.” | “!” | “~” | “*” | “'” | “(” | “)” | “[” | “]”
	      //
	      // Also need to encode '!' because it has special meaning (end of tag prefix).
	      //
	      tagStr = encodeURI(
	        state.tag[0] === '!' ? state.tag.slice(1) : state.tag
	      ).replace(/!/g, '%21');

	      if (state.tag[0] === '!') {
	        tagStr = '!' + tagStr;
	      } else if (tagStr.slice(0, 18) === 'tag:yaml.org,2002:') {
	        tagStr = '!!' + tagStr.slice(18);
	      } else {
	        tagStr = '!<' + tagStr + '>';
	      }

	      state.dump = tagStr + ' ' + state.dump;
	    }
	  }

	  return true;
	}

	function getDuplicateReferences(object, state) {
	  var objects = [],
	      duplicatesIndexes = [],
	      index,
	      length;

	  inspectNode(object, objects, duplicatesIndexes);

	  for (index = 0, length = duplicatesIndexes.length; index < length; index += 1) {
	    state.duplicates.push(objects[duplicatesIndexes[index]]);
	  }
	  state.usedDuplicates = new Array(length);
	}

	function inspectNode(object, objects, duplicatesIndexes) {
	  var objectKeyList,
	      index,
	      length;

	  if (object !== null && typeof object === 'object') {
	    index = objects.indexOf(object);
	    if (index !== -1) {
	      if (duplicatesIndexes.indexOf(index) === -1) {
	        duplicatesIndexes.push(index);
	      }
	    } else {
	      objects.push(object);

	      if (Array.isArray(object)) {
	        for (index = 0, length = object.length; index < length; index += 1) {
	          inspectNode(object[index], objects, duplicatesIndexes);
	        }
	      } else {
	        objectKeyList = Object.keys(object);

	        for (index = 0, length = objectKeyList.length; index < length; index += 1) {
	          inspectNode(object[objectKeyList[index]], objects, duplicatesIndexes);
	        }
	      }
	    }
	  }
	}

	function dump(input, options) {
	  options = options || {};

	  var state = new State(options);

	  if (!state.noRefs) getDuplicateReferences(input, state);

	  var value = input;

	  if (state.replacer) {
	    value = state.replacer.call({ '': value }, '', value);
	  }

	  if (writeNode(state, 0, value, true, true)) return state.dump + '\n';

	  return '';
	}

	dumper$1.dump = dump;

	var loader = loader$1;
	var dumper = dumper$1;


	function renamed(from, to) {
	  return function () {
	    throw new Error('Function yaml.' + from + ' is removed in js-yaml 4. ' +
	      'Use yaml.' + to + ' instead, which is now safe by default.');
	  };
	}


	jsYaml.Type                = type;
	jsYaml.Schema              = schema;
	jsYaml.FAILSAFE_SCHEMA     = failsafe;
	jsYaml.JSON_SCHEMA         = json$1;
	jsYaml.CORE_SCHEMA         = coreExports;
	jsYaml.DEFAULT_SCHEMA      = _default;
	jsYaml.load                = loader.load;
	jsYaml.loadAll             = loader.loadAll;
	jsYaml.dump                = dumper.dump;
	jsYaml.YAMLException       = exception;

	// Re-export all types in case user wants to create custom schema
	jsYaml.types = {
	  binary:    binary$1,
	  float:     float,
	  map:       map$1,
	  null:      _null,
	  pairs:     pairs,
	  set:       set,
	  timestamp: timestamp,
	  bool:      bool,
	  int:       int,
	  merge:     merge$1,
	  omap:      omap,
	  seq:       seq,
	  str:       str
	};

	// Removed functions from JS-YAML 3.0.x
	jsYaml.safeLoad            = renamed('safeLoad', 'load');
	jsYaml.safeLoadAll         = renamed('safeLoadAll', 'loadAll');
	jsYaml.safeDump            = renamed('safeDump', 'dump');

	const { ParserError: ParserError$3 } = errors$1;
	const yaml = jsYaml;
	const { JSON_SCHEMA } = jsYaml;

	var yaml_1 = {
	  /**
	   * The order that this parser will run, in relation to other parsers.
	   *
	   * @type {number}
	   */
	  order: 200,

	  /**
	   * Whether to allow "empty" files. This includes zero-byte files, as well as empty JSON objects.
	   *
	   * @type {boolean}
	   */
	  allowEmpty: true,

	  /**
	   * Determines whether this parser can parse a given file reference.
	   * Parsers that match will be tried, in order, until one successfully parses the file.
	   * Parsers that don't match will be skipped, UNLESS none of the parsers match, in which case
	   * every parser will be tried.
	   *
	   * @type {RegExp|string[]|function}
	   */
	  canParse: [".yaml", ".yml", ".json"],  // JSON is valid YAML

	  /**
	   * Parses the given file as YAML
	   *
	   * @param {object} file           - An object containing information about the referenced file
	   * @param {string} file.url       - The full URL of the referenced file
	   * @param {string} file.extension - The lowercased file extension (e.g. ".txt", ".html", etc.)
	   * @param {*}      file.data      - The file contents. This will be whatever data type was returned by the resolver
	   * @returns {Promise}
	   */
	  async parse (file) {      // eslint-disable-line require-await
	    let data = file.data;
	    if (Buffer.isBuffer(data)) {
	      data = data.toString();
	    }

	    if (typeof data === "string") {
	      try {
	        return yaml.load(data, { schema: JSON_SCHEMA });
	      }
	      catch (e) {
	        throw new ParserError$3(e.message, file.url);
	      }
	    }
	    else {
	      // data is already a JavaScript value (object, array, number, null, NaN, etc.)
	      return data;
	    }
	  }
	};

	const { ParserError: ParserError$2 } = errors$1;

	let TEXT_REGEXP = /\.(txt|htm|html|md|xml|js|min|map|css|scss|less|svg)$/i;

	var text = {
	  /**
	   * The order that this parser will run, in relation to other parsers.
	   *
	   * @type {number}
	   */
	  order: 300,

	  /**
	   * Whether to allow "empty" files (zero bytes).
	   *
	   * @type {boolean}
	   */
	  allowEmpty: true,

	  /**
	   * The encoding that the text is expected to be in.
	   *
	   * @type {string}
	   */
	  encoding: "utf8",

	  /**
	   * Determines whether this parser can parse a given file reference.
	   * Parsers that return true will be tried, in order, until one successfully parses the file.
	   * Parsers that return false will be skipped, UNLESS all parsers returned false, in which case
	   * every parser will be tried.
	   *
	   * @param {object} file           - An object containing information about the referenced file
	   * @param {string} file.url       - The full URL of the referenced file
	   * @param {string} file.extension - The lowercased file extension (e.g. ".txt", ".html", etc.)
	   * @param {*}      file.data      - The file contents. This will be whatever data type was returned by the resolver
	   * @returns {boolean}
	   */
	  canParse (file) {
	    // Use this parser if the file is a string or Buffer, and has a known text-based extension
	    return (typeof file.data === "string" || Buffer.isBuffer(file.data)) && TEXT_REGEXP.test(file.url);
	  },

	  /**
	   * Parses the given file as text
	   *
	   * @param {object} file           - An object containing information about the referenced file
	   * @param {string} file.url       - The full URL of the referenced file
	   * @param {string} file.extension - The lowercased file extension (e.g. ".txt", ".html", etc.)
	   * @param {*}      file.data      - The file contents. This will be whatever data type was returned by the resolver
	   * @returns {string}
	   */
	  parse (file) {
	    if (typeof file.data === "string") {
	      return file.data;
	    }
	    else if (Buffer.isBuffer(file.data)) {
	      return file.data.toString(this.encoding);
	    }
	    else {
	      throw new ParserError$2("data is not text", file.url);
	    }
	  }
	};

	let BINARY_REGEXP = /\.(jpeg|jpg|gif|png|bmp|ico)$/i;

	var binary = {
	  /**
	   * The order that this parser will run, in relation to other parsers.
	   *
	   * @type {number}
	   */
	  order: 400,

	  /**
	   * Whether to allow "empty" files (zero bytes).
	   *
	   * @type {boolean}
	   */
	  allowEmpty: true,

	  /**
	   * Determines whether this parser can parse a given file reference.
	   * Parsers that return true will be tried, in order, until one successfully parses the file.
	   * Parsers that return false will be skipped, UNLESS all parsers returned false, in which case
	   * every parser will be tried.
	   *
	   * @param {object} file           - An object containing information about the referenced file
	   * @param {string} file.url       - The full URL of the referenced file
	   * @param {string} file.extension - The lowercased file extension (e.g. ".txt", ".html", etc.)
	   * @param {*}      file.data      - The file contents. This will be whatever data type was returned by the resolver
	   * @returns {boolean}
	   */
	  canParse (file) {
	    // Use this parser if the file is a Buffer, and has a known binary extension
	    return Buffer.isBuffer(file.data) && BINARY_REGEXP.test(file.url);
	  },

	  /**
	   * Parses the given data as a Buffer (byte array).
	   *
	   * @param {object} file           - An object containing information about the referenced file
	   * @param {string} file.url       - The full URL of the referenced file
	   * @param {string} file.extension - The lowercased file extension (e.g. ".txt", ".html", etc.)
	   * @param {*}      file.data      - The file contents. This will be whatever data type was returned by the resolver
	   * @returns {Buffer}
	   */
	  parse (file) {
	    if (Buffer.isBuffer(file.data)) {
	      return file.data;
	    }
	    else {
	      // This will reject if data is anything other than a string or typed array
	      return Buffer.from(file.data);
	    }
	  }
	};

	var _polyfillNode_fs = {};

	var _polyfillNode_fs$1 = /*#__PURE__*/Object.freeze({
		__proto__: null,
		'default': _polyfillNode_fs
	});

	var require$$0$1 = /*@__PURE__*/getAugmentedNamespace(_polyfillNode_fs$1);

	const fs$1 = require$$0$1;
	const { ono: ono$6 } = require$$6;
	const url$7 = urlExports;
	const { ResolverError: ResolverError$3 } = errors$1;

	var file = {
	  /**
	   * The order that this resolver will run, in relation to other resolvers.
	   *
	   * @type {number}
	   */
	  order: 100,

	  /**
	   * Determines whether this resolver can read a given file reference.
	   * Resolvers that return true will be tried, in order, until one successfully resolves the file.
	   * Resolvers that return false will not be given a chance to resolve the file.
	   *
	   * @param {object} file           - An object containing information about the referenced file
	   * @param {string} file.url       - The full URL of the referenced file
	   * @param {string} file.extension - The lowercased file extension (e.g. ".txt", ".html", etc.)
	   * @returns {boolean}
	   */
	  canRead (file) {
	    return url$7.isFileSystemPath(file.url);
	  },

	  /**
	   * Reads the given file and returns its raw contents as a Buffer.
	   *
	   * @param {object} file           - An object containing information about the referenced file
	   * @param {string} file.url       - The full URL of the referenced file
	   * @param {string} file.extension - The lowercased file extension (e.g. ".txt", ".html", etc.)
	   * @returns {Promise<Buffer>}
	   */
	  read (file) {
	    return new Promise(((resolve, reject) => {
	      let path;
	      try {
	        path = url$7.toFileSystemPath(file.url);
	      }
	      catch (err) {
	        reject(new ResolverError$3(ono$6.uri(err, `Malformed URI: ${file.url}`), file.url));
	      }

	      // console.log('Opening file: %s', path);

	      try {
	        fs$1.readFile(path, (err, data) => {
	          if (err) {
	            reject(new ResolverError$3(ono$6(err, `Error opening file "${path}"`), path));
	          }
	          else {
	            resolve(data);
	          }
	        });
	      }
	      catch (err) {
	        reject(new ResolverError$3(ono$6(err, `Error opening file "${path}"`), path));
	      }
	    }));
	  }
	};

	var hasFetch = isFunction$1(global$1.fetch) && isFunction$1(global$1.ReadableStream);

	var _blobConstructor;
	function blobConstructor() {
	  if (typeof _blobConstructor !== 'undefined') {
	    return _blobConstructor;
	  }
	  try {
	    new global$1.Blob([new ArrayBuffer(1)]);
	    _blobConstructor = true;
	  } catch (e) {
	    _blobConstructor = false;
	  }
	  return _blobConstructor
	}
	var xhr;

	function checkTypeSupport(type) {
	  if (!xhr) {
	    xhr = new global$1.XMLHttpRequest();
	    // If location.host is empty, e.g. if this page/worker was loaded
	    // from a Blob, then use example.com to avoid an error
	    xhr.open('GET', global$1.location.host ? '/' : 'https://example.com');
	  }
	  try {
	    xhr.responseType = type;
	    return xhr.responseType === type
	  } catch (e) {
	    return false
	  }

	}

	// For some strange reason, Safari 7.0 reports typeof global.ArrayBuffer === 'object'.
	// Safari 7.1 appears to have fixed this bug.
	var haveArrayBuffer = typeof global$1.ArrayBuffer !== 'undefined';
	var haveSlice = haveArrayBuffer && isFunction$1(global$1.ArrayBuffer.prototype.slice);

	var arraybuffer = haveArrayBuffer && checkTypeSupport('arraybuffer');
	  // These next two tests unavoidably show warnings in Chrome. Since fetch will always
	  // be used if it's available, just return false for these to avoid the warnings.
	var msstream = !hasFetch && haveSlice && checkTypeSupport('ms-stream');
	var mozchunkedarraybuffer = !hasFetch && haveArrayBuffer &&
	  checkTypeSupport('moz-chunked-arraybuffer');
	var overrideMimeType = isFunction$1(xhr.overrideMimeType);
	var vbArray = isFunction$1(global$1.VBArray);

	function isFunction$1(value) {
	  return typeof value === 'function'
	}

	xhr = null; // Help gc

	var domain;

	// This constructor is used to store event handlers. Instantiating this is
	// faster than explicitly calling `Object.create(null)` to get a "clean" empty
	// object (tested with v8 v4.9).
	function EventHandlers() {}
	EventHandlers.prototype = Object.create(null);

	function EventEmitter() {
	  EventEmitter.init.call(this);
	}

	// nodejs oddity
	// require('events') === require('events').EventEmitter
	EventEmitter.EventEmitter = EventEmitter;

	EventEmitter.usingDomains = false;

	EventEmitter.prototype.domain = undefined;
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;

	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;

	EventEmitter.init = function() {
	  this.domain = null;
	  if (EventEmitter.usingDomains) {
	    // if there is an active domain, then attach to it.
	    if (domain.active ) ;
	  }

	  if (!this._events || this._events === Object.getPrototypeOf(this)._events) {
	    this._events = new EventHandlers();
	    this._eventsCount = 0;
	  }

	  this._maxListeners = this._maxListeners || undefined;
	};

	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
	  if (typeof n !== 'number' || n < 0 || isNaN(n))
	    throw new TypeError('"n" argument must be a positive number');
	  this._maxListeners = n;
	  return this;
	};

	function $getMaxListeners(that) {
	  if (that._maxListeners === undefined)
	    return EventEmitter.defaultMaxListeners;
	  return that._maxListeners;
	}

	EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
	  return $getMaxListeners(this);
	};

	// These standalone emit* functions are used to optimize calling of event
	// handlers for fast cases because emit() itself often has a variable number of
	// arguments and can be deoptimized because of that. These functions always have
	// the same number of arguments and thus do not get deoptimized, so the code
	// inside them can execute faster.
	function emitNone(handler, isFn, self) {
	  if (isFn)
	    handler.call(self);
	  else {
	    var len = handler.length;
	    var listeners = arrayClone(handler, len);
	    for (var i = 0; i < len; ++i)
	      listeners[i].call(self);
	  }
	}
	function emitOne(handler, isFn, self, arg1) {
	  if (isFn)
	    handler.call(self, arg1);
	  else {
	    var len = handler.length;
	    var listeners = arrayClone(handler, len);
	    for (var i = 0; i < len; ++i)
	      listeners[i].call(self, arg1);
	  }
	}
	function emitTwo(handler, isFn, self, arg1, arg2) {
	  if (isFn)
	    handler.call(self, arg1, arg2);
	  else {
	    var len = handler.length;
	    var listeners = arrayClone(handler, len);
	    for (var i = 0; i < len; ++i)
	      listeners[i].call(self, arg1, arg2);
	  }
	}
	function emitThree(handler, isFn, self, arg1, arg2, arg3) {
	  if (isFn)
	    handler.call(self, arg1, arg2, arg3);
	  else {
	    var len = handler.length;
	    var listeners = arrayClone(handler, len);
	    for (var i = 0; i < len; ++i)
	      listeners[i].call(self, arg1, arg2, arg3);
	  }
	}

	function emitMany(handler, isFn, self, args) {
	  if (isFn)
	    handler.apply(self, args);
	  else {
	    var len = handler.length;
	    var listeners = arrayClone(handler, len);
	    for (var i = 0; i < len; ++i)
	      listeners[i].apply(self, args);
	  }
	}

	EventEmitter.prototype.emit = function emit(type) {
	  var er, handler, len, args, i, events, domain;
	  var doError = (type === 'error');

	  events = this._events;
	  if (events)
	    doError = (doError && events.error == null);
	  else if (!doError)
	    return false;

	  domain = this.domain;

	  // If there is no 'error' event listener then throw.
	  if (doError) {
	    er = arguments[1];
	    if (domain) {
	      if (!er)
	        er = new Error('Uncaught, unspecified "error" event');
	      er.domainEmitter = this;
	      er.domain = domain;
	      er.domainThrown = false;
	      domain.emit('error', er);
	    } else if (er instanceof Error) {
	      throw er; // Unhandled 'error' event
	    } else {
	      // At least give some kind of context to the user
	      var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
	      err.context = er;
	      throw err;
	    }
	    return false;
	  }

	  handler = events[type];

	  if (!handler)
	    return false;

	  var isFn = typeof handler === 'function';
	  len = arguments.length;
	  switch (len) {
	    // fast cases
	    case 1:
	      emitNone(handler, isFn, this);
	      break;
	    case 2:
	      emitOne(handler, isFn, this, arguments[1]);
	      break;
	    case 3:
	      emitTwo(handler, isFn, this, arguments[1], arguments[2]);
	      break;
	    case 4:
	      emitThree(handler, isFn, this, arguments[1], arguments[2], arguments[3]);
	      break;
	    // slower
	    default:
	      args = new Array(len - 1);
	      for (i = 1; i < len; i++)
	        args[i - 1] = arguments[i];
	      emitMany(handler, isFn, this, args);
	  }

	  return true;
	};

	function _addListener(target, type, listener, prepend) {
	  var m;
	  var events;
	  var existing;

	  if (typeof listener !== 'function')
	    throw new TypeError('"listener" argument must be a function');

	  events = target._events;
	  if (!events) {
	    events = target._events = new EventHandlers();
	    target._eventsCount = 0;
	  } else {
	    // To avoid recursion in the case that type === "newListener"! Before
	    // adding it to the listeners, first emit "newListener".
	    if (events.newListener) {
	      target.emit('newListener', type,
	                  listener.listener ? listener.listener : listener);

	      // Re-assign `events` because a newListener handler could have caused the
	      // this._events to be assigned to a new object
	      events = target._events;
	    }
	    existing = events[type];
	  }

	  if (!existing) {
	    // Optimize the case of one listener. Don't need the extra array object.
	    existing = events[type] = listener;
	    ++target._eventsCount;
	  } else {
	    if (typeof existing === 'function') {
	      // Adding the second element, need to change to array.
	      existing = events[type] = prepend ? [listener, existing] :
	                                          [existing, listener];
	    } else {
	      // If we've already got an array, just append.
	      if (prepend) {
	        existing.unshift(listener);
	      } else {
	        existing.push(listener);
	      }
	    }

	    // Check for listener leak
	    if (!existing.warned) {
	      m = $getMaxListeners(target);
	      if (m && m > 0 && existing.length > m) {
	        existing.warned = true;
	        var w = new Error('Possible EventEmitter memory leak detected. ' +
	                            existing.length + ' ' + type + ' listeners added. ' +
	                            'Use emitter.setMaxListeners() to increase limit');
	        w.name = 'MaxListenersExceededWarning';
	        w.emitter = target;
	        w.type = type;
	        w.count = existing.length;
	        emitWarning(w);
	      }
	    }
	  }

	  return target;
	}
	function emitWarning(e) {
	  typeof console.warn === 'function' ? console.warn(e) : console.log(e);
	}
	EventEmitter.prototype.addListener = function addListener(type, listener) {
	  return _addListener(this, type, listener, false);
	};

	EventEmitter.prototype.on = EventEmitter.prototype.addListener;

	EventEmitter.prototype.prependListener =
	    function prependListener(type, listener) {
	      return _addListener(this, type, listener, true);
	    };

	function _onceWrap(target, type, listener) {
	  var fired = false;
	  function g() {
	    target.removeListener(type, g);
	    if (!fired) {
	      fired = true;
	      listener.apply(target, arguments);
	    }
	  }
	  g.listener = listener;
	  return g;
	}

	EventEmitter.prototype.once = function once(type, listener) {
	  if (typeof listener !== 'function')
	    throw new TypeError('"listener" argument must be a function');
	  this.on(type, _onceWrap(this, type, listener));
	  return this;
	};

	EventEmitter.prototype.prependOnceListener =
	    function prependOnceListener(type, listener) {
	      if (typeof listener !== 'function')
	        throw new TypeError('"listener" argument must be a function');
	      this.prependListener(type, _onceWrap(this, type, listener));
	      return this;
	    };

	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener =
	    function removeListener(type, listener) {
	      var list, events, position, i, originalListener;

	      if (typeof listener !== 'function')
	        throw new TypeError('"listener" argument must be a function');

	      events = this._events;
	      if (!events)
	        return this;

	      list = events[type];
	      if (!list)
	        return this;

	      if (list === listener || (list.listener && list.listener === listener)) {
	        if (--this._eventsCount === 0)
	          this._events = new EventHandlers();
	        else {
	          delete events[type];
	          if (events.removeListener)
	            this.emit('removeListener', type, list.listener || listener);
	        }
	      } else if (typeof list !== 'function') {
	        position = -1;

	        for (i = list.length; i-- > 0;) {
	          if (list[i] === listener ||
	              (list[i].listener && list[i].listener === listener)) {
	            originalListener = list[i].listener;
	            position = i;
	            break;
	          }
	        }

	        if (position < 0)
	          return this;

	        if (list.length === 1) {
	          list[0] = undefined;
	          if (--this._eventsCount === 0) {
	            this._events = new EventHandlers();
	            return this;
	          } else {
	            delete events[type];
	          }
	        } else {
	          spliceOne(list, position);
	        }

	        if (events.removeListener)
	          this.emit('removeListener', type, originalListener || listener);
	      }

	      return this;
	    };
	    
	// Alias for removeListener added in NodeJS 10.0
	// https://nodejs.org/api/events.html#events_emitter_off_eventname_listener
	EventEmitter.prototype.off = function(type, listener){
	    return this.removeListener(type, listener);
	};

	EventEmitter.prototype.removeAllListeners =
	    function removeAllListeners(type) {
	      var listeners, events;

	      events = this._events;
	      if (!events)
	        return this;

	      // not listening for removeListener, no need to emit
	      if (!events.removeListener) {
	        if (arguments.length === 0) {
	          this._events = new EventHandlers();
	          this._eventsCount = 0;
	        } else if (events[type]) {
	          if (--this._eventsCount === 0)
	            this._events = new EventHandlers();
	          else
	            delete events[type];
	        }
	        return this;
	      }

	      // emit removeListener for all listeners on all events
	      if (arguments.length === 0) {
	        var keys = Object.keys(events);
	        for (var i = 0, key; i < keys.length; ++i) {
	          key = keys[i];
	          if (key === 'removeListener') continue;
	          this.removeAllListeners(key);
	        }
	        this.removeAllListeners('removeListener');
	        this._events = new EventHandlers();
	        this._eventsCount = 0;
	        return this;
	      }

	      listeners = events[type];

	      if (typeof listeners === 'function') {
	        this.removeListener(type, listeners);
	      } else if (listeners) {
	        // LIFO order
	        do {
	          this.removeListener(type, listeners[listeners.length - 1]);
	        } while (listeners[0]);
	      }

	      return this;
	    };

	EventEmitter.prototype.listeners = function listeners(type) {
	  var evlistener;
	  var ret;
	  var events = this._events;

	  if (!events)
	    ret = [];
	  else {
	    evlistener = events[type];
	    if (!evlistener)
	      ret = [];
	    else if (typeof evlistener === 'function')
	      ret = [evlistener.listener || evlistener];
	    else
	      ret = unwrapListeners(evlistener);
	  }

	  return ret;
	};

	EventEmitter.listenerCount = function(emitter, type) {
	  if (typeof emitter.listenerCount === 'function') {
	    return emitter.listenerCount(type);
	  } else {
	    return listenerCount$1.call(emitter, type);
	  }
	};

	EventEmitter.prototype.listenerCount = listenerCount$1;
	function listenerCount$1(type) {
	  var events = this._events;

	  if (events) {
	    var evlistener = events[type];

	    if (typeof evlistener === 'function') {
	      return 1;
	    } else if (evlistener) {
	      return evlistener.length;
	    }
	  }

	  return 0;
	}

	EventEmitter.prototype.eventNames = function eventNames() {
	  return this._eventsCount > 0 ? Reflect.ownKeys(this._events) : [];
	};

	// About 1.5x faster than the two-arg version of Array#splice().
	function spliceOne(list, index) {
	  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)
	    list[i] = list[k];
	  list.pop();
	}

	function arrayClone(arr, i) {
	  var copy = new Array(i);
	  while (i--)
	    copy[i] = arr[i];
	  return copy;
	}

	function unwrapListeners(arr) {
	  var ret = new Array(arr.length);
	  for (var i = 0; i < ret.length; ++i) {
	    ret[i] = arr[i].listener || arr[i];
	  }
	  return ret;
	}

	function BufferList() {
	  this.head = null;
	  this.tail = null;
	  this.length = 0;
	}

	BufferList.prototype.push = function (v) {
	  var entry = { data: v, next: null };
	  if (this.length > 0) this.tail.next = entry;else this.head = entry;
	  this.tail = entry;
	  ++this.length;
	};

	BufferList.prototype.unshift = function (v) {
	  var entry = { data: v, next: this.head };
	  if (this.length === 0) this.tail = entry;
	  this.head = entry;
	  ++this.length;
	};

	BufferList.prototype.shift = function () {
	  if (this.length === 0) return;
	  var ret = this.head.data;
	  if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
	  --this.length;
	  return ret;
	};

	BufferList.prototype.clear = function () {
	  this.head = this.tail = null;
	  this.length = 0;
	};

	BufferList.prototype.join = function (s) {
	  if (this.length === 0) return '';
	  var p = this.head;
	  var ret = '' + p.data;
	  while (p = p.next) {
	    ret += s + p.data;
	  }return ret;
	};

	BufferList.prototype.concat = function (n) {
	  if (this.length === 0) return Buffer.alloc(0);
	  if (this.length === 1) return this.head.data;
	  var ret = Buffer.allocUnsafe(n >>> 0);
	  var p = this.head;
	  var i = 0;
	  while (p) {
	    p.data.copy(ret, i);
	    i += p.data.length;
	    p = p.next;
	  }
	  return ret;
	};

	// Copyright Joyent, Inc. and other Node contributors.
	var isBufferEncoding = Buffer.isEncoding
	  || function(encoding) {
	       switch (encoding && encoding.toLowerCase()) {
	         case 'hex': case 'utf8': case 'utf-8': case 'ascii': case 'binary': case 'base64': case 'ucs2': case 'ucs-2': case 'utf16le': case 'utf-16le': case 'raw': return true;
	         default: return false;
	       }
	     };


	function assertEncoding(encoding) {
	  if (encoding && !isBufferEncoding(encoding)) {
	    throw new Error('Unknown encoding: ' + encoding);
	  }
	}

	// StringDecoder provides an interface for efficiently splitting a series of
	// buffers into a series of JS strings without breaking apart multi-byte
	// characters. CESU-8 is handled as part of the UTF-8 encoding.
	//
	// @TODO Handling all encodings inside a single object makes it very difficult
	// to reason about this code, so it should be split up in the future.
	// @TODO There should be a utf8-strict encoding that rejects invalid UTF-8 code
	// points as used by CESU-8.
	function StringDecoder(encoding) {
	  this.encoding = (encoding || 'utf8').toLowerCase().replace(/[-_]/, '');
	  assertEncoding(encoding);
	  switch (this.encoding) {
	    case 'utf8':
	      // CESU-8 represents each of Surrogate Pair by 3-bytes
	      this.surrogateSize = 3;
	      break;
	    case 'ucs2':
	    case 'utf16le':
	      // UTF-16 represents each of Surrogate Pair by 2-bytes
	      this.surrogateSize = 2;
	      this.detectIncompleteChar = utf16DetectIncompleteChar;
	      break;
	    case 'base64':
	      // Base-64 stores 3 bytes in 4 chars, and pads the remainder.
	      this.surrogateSize = 3;
	      this.detectIncompleteChar = base64DetectIncompleteChar;
	      break;
	    default:
	      this.write = passThroughWrite;
	      return;
	  }

	  // Enough space to store all bytes of a single character. UTF-8 needs 4
	  // bytes, but CESU-8 may require up to 6 (3 bytes per surrogate).
	  this.charBuffer = new Buffer(6);
	  // Number of bytes received for the current incomplete multi-byte character.
	  this.charReceived = 0;
	  // Number of bytes expected for the current incomplete multi-byte character.
	  this.charLength = 0;
	}

	// write decodes the given buffer and returns it as JS string that is
	// guaranteed to not contain any partial multi-byte characters. Any partial
	// character found at the end of the buffer is buffered up, and will be
	// returned when calling write again with the remaining bytes.
	//
	// Note: Converting a Buffer containing an orphan surrogate to a String
	// currently works, but converting a String to a Buffer (via `new Buffer`, or
	// Buffer#write) will replace incomplete surrogates with the unicode
	// replacement character. See https://codereview.chromium.org/121173009/ .
	StringDecoder.prototype.write = function(buffer) {
	  var charStr = '';
	  // if our last write ended with an incomplete multibyte character
	  while (this.charLength) {
	    // determine how many remaining bytes this buffer has to offer for this char
	    var available = (buffer.length >= this.charLength - this.charReceived) ?
	        this.charLength - this.charReceived :
	        buffer.length;

	    // add the new bytes to the char buffer
	    buffer.copy(this.charBuffer, this.charReceived, 0, available);
	    this.charReceived += available;

	    if (this.charReceived < this.charLength) {
	      // still not enough chars in this buffer? wait for more ...
	      return '';
	    }

	    // remove bytes belonging to the current character from the buffer
	    buffer = buffer.slice(available, buffer.length);

	    // get the character that was split
	    charStr = this.charBuffer.slice(0, this.charLength).toString(this.encoding);

	    // CESU-8: lead surrogate (D800-DBFF) is also the incomplete character
	    var charCode = charStr.charCodeAt(charStr.length - 1);
	    if (charCode >= 0xD800 && charCode <= 0xDBFF) {
	      this.charLength += this.surrogateSize;
	      charStr = '';
	      continue;
	    }
	    this.charReceived = this.charLength = 0;

	    // if there are no more bytes in this buffer, just emit our char
	    if (buffer.length === 0) {
	      return charStr;
	    }
	    break;
	  }

	  // determine and set charLength / charReceived
	  this.detectIncompleteChar(buffer);

	  var end = buffer.length;
	  if (this.charLength) {
	    // buffer the incomplete character bytes we got
	    buffer.copy(this.charBuffer, 0, buffer.length - this.charReceived, end);
	    end -= this.charReceived;
	  }

	  charStr += buffer.toString(this.encoding, 0, end);

	  var end = charStr.length - 1;
	  var charCode = charStr.charCodeAt(end);
	  // CESU-8: lead surrogate (D800-DBFF) is also the incomplete character
	  if (charCode >= 0xD800 && charCode <= 0xDBFF) {
	    var size = this.surrogateSize;
	    this.charLength += size;
	    this.charReceived += size;
	    this.charBuffer.copy(this.charBuffer, size, 0, size);
	    buffer.copy(this.charBuffer, 0, 0, size);
	    return charStr.substring(0, end);
	  }

	  // or just emit the charStr
	  return charStr;
	};

	// detectIncompleteChar determines if there is an incomplete UTF-8 character at
	// the end of the given buffer. If so, it sets this.charLength to the byte
	// length that character, and sets this.charReceived to the number of bytes
	// that are available for this character.
	StringDecoder.prototype.detectIncompleteChar = function(buffer) {
	  // determine how many bytes we have to check at the end of this buffer
	  var i = (buffer.length >= 3) ? 3 : buffer.length;

	  // Figure out if one of the last i bytes of our buffer announces an
	  // incomplete char.
	  for (; i > 0; i--) {
	    var c = buffer[buffer.length - i];

	    // See http://en.wikipedia.org/wiki/UTF-8#Description

	    // 110XXXXX
	    if (i == 1 && c >> 5 == 0x06) {
	      this.charLength = 2;
	      break;
	    }

	    // 1110XXXX
	    if (i <= 2 && c >> 4 == 0x0E) {
	      this.charLength = 3;
	      break;
	    }

	    // 11110XXX
	    if (i <= 3 && c >> 3 == 0x1E) {
	      this.charLength = 4;
	      break;
	    }
	  }
	  this.charReceived = i;
	};

	StringDecoder.prototype.end = function(buffer) {
	  var res = '';
	  if (buffer && buffer.length)
	    res = this.write(buffer);

	  if (this.charReceived) {
	    var cr = this.charReceived;
	    var buf = this.charBuffer;
	    var enc = this.encoding;
	    res += buf.slice(0, cr).toString(enc);
	  }

	  return res;
	};

	function passThroughWrite(buffer) {
	  return buffer.toString(this.encoding);
	}

	function utf16DetectIncompleteChar(buffer) {
	  this.charReceived = buffer.length % 2;
	  this.charLength = this.charReceived ? 2 : 0;
	}

	function base64DetectIncompleteChar(buffer) {
	  this.charReceived = buffer.length % 3;
	  this.charLength = this.charReceived ? 3 : 0;
	}

	Readable.ReadableState = ReadableState;

	var debug$2 = debuglog('stream');
	inherits$1(Readable, EventEmitter);

	function prependListener(emitter, event, fn) {
	  // Sadly this is not cacheable as some libraries bundle their own
	  // event emitter implementation with them.
	  if (typeof emitter.prependListener === 'function') {
	    return emitter.prependListener(event, fn);
	  } else {
	    // This is a hack to make sure that our error handler is attached before any
	    // userland ones.  NEVER DO THIS. This is here only because this code needs
	    // to continue to work with older versions of Node.js that do not include
	    // the prependListener() method. The goal is to eventually remove this hack.
	    if (!emitter._events || !emitter._events[event])
	      emitter.on(event, fn);
	    else if (Array.isArray(emitter._events[event]))
	      emitter._events[event].unshift(fn);
	    else
	      emitter._events[event] = [fn, emitter._events[event]];
	  }
	}
	function listenerCount (emitter, type) {
	  return emitter.listeners(type).length;
	}
	function ReadableState(options, stream) {

	  options = options || {};

	  // object stream flag. Used to make read(n) ignore n and to
	  // make all the buffer merging and length checks go away
	  this.objectMode = !!options.objectMode;

	  if (stream instanceof Duplex) this.objectMode = this.objectMode || !!options.readableObjectMode;

	  // the point at which it stops calling _read() to fill the buffer
	  // Note: 0 is a valid value, means "don't call _read preemptively ever"
	  var hwm = options.highWaterMark;
	  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
	  this.highWaterMark = hwm || hwm === 0 ? hwm : defaultHwm;

	  // cast to ints.
	  this.highWaterMark = ~ ~this.highWaterMark;

	  // A linked list is used to store data chunks instead of an array because the
	  // linked list can remove elements from the beginning faster than
	  // array.shift()
	  this.buffer = new BufferList();
	  this.length = 0;
	  this.pipes = null;
	  this.pipesCount = 0;
	  this.flowing = null;
	  this.ended = false;
	  this.endEmitted = false;
	  this.reading = false;

	  // a flag to be able to tell if the onwrite cb is called immediately,
	  // or on a later tick.  We set this to true at first, because any
	  // actions that shouldn't happen until "later" should generally also
	  // not happen before the first write call.
	  this.sync = true;

	  // whenever we return null, then we set a flag to say
	  // that we're awaiting a 'readable' event emission.
	  this.needReadable = false;
	  this.emittedReadable = false;
	  this.readableListening = false;
	  this.resumeScheduled = false;

	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';

	  // when piping, we only care about 'readable' events that happen
	  // after read()ing all the bytes and not getting any pushback.
	  this.ranOut = false;

	  // the number of writers that are awaiting a drain event in .pipe()s
	  this.awaitDrain = 0;

	  // if true, a maybeReadMore has been scheduled
	  this.readingMore = false;

	  this.decoder = null;
	  this.encoding = null;
	  if (options.encoding) {
	    this.decoder = new StringDecoder(options.encoding);
	    this.encoding = options.encoding;
	  }
	}
	function Readable(options) {

	  if (!(this instanceof Readable)) return new Readable(options);

	  this._readableState = new ReadableState(options, this);

	  // legacy
	  this.readable = true;

	  if (options && typeof options.read === 'function') this._read = options.read;

	  EventEmitter.call(this);
	}

	// Manually shove something into the read() buffer.
	// This returns true if the highWaterMark has not been hit yet,
	// similar to how Writable.write() returns true if you should
	// write() some more.
	Readable.prototype.push = function (chunk, encoding) {
	  var state = this._readableState;

	  if (!state.objectMode && typeof chunk === 'string') {
	    encoding = encoding || state.defaultEncoding;
	    if (encoding !== state.encoding) {
	      chunk = Buffer.from(chunk, encoding);
	      encoding = '';
	    }
	  }

	  return readableAddChunk(this, state, chunk, encoding, false);
	};

	// Unshift should *always* be something directly out of read()
	Readable.prototype.unshift = function (chunk) {
	  var state = this._readableState;
	  return readableAddChunk(this, state, chunk, '', true);
	};

	Readable.prototype.isPaused = function () {
	  return this._readableState.flowing === false;
	};

	function readableAddChunk(stream, state, chunk, encoding, addToFront) {
	  var er = chunkInvalid(state, chunk);
	  if (er) {
	    stream.emit('error', er);
	  } else if (chunk === null) {
	    state.reading = false;
	    onEofChunk(stream, state);
	  } else if (state.objectMode || chunk && chunk.length > 0) {
	    if (state.ended && !addToFront) {
	      var e = new Error('stream.push() after EOF');
	      stream.emit('error', e);
	    } else if (state.endEmitted && addToFront) {
	      var _e = new Error('stream.unshift() after end event');
	      stream.emit('error', _e);
	    } else {
	      var skipAdd;
	      if (state.decoder && !addToFront && !encoding) {
	        chunk = state.decoder.write(chunk);
	        skipAdd = !state.objectMode && chunk.length === 0;
	      }

	      if (!addToFront) state.reading = false;

	      // Don't add to the buffer if we've decoded to an empty string chunk and
	      // we're not in object mode
	      if (!skipAdd) {
	        // if we want the data now, just emit it.
	        if (state.flowing && state.length === 0 && !state.sync) {
	          stream.emit('data', chunk);
	          stream.read(0);
	        } else {
	          // update the buffer info.
	          state.length += state.objectMode ? 1 : chunk.length;
	          if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);

	          if (state.needReadable) emitReadable(stream);
	        }
	      }

	      maybeReadMore(stream, state);
	    }
	  } else if (!addToFront) {
	    state.reading = false;
	  }

	  return needMoreData(state);
	}

	// if it's past the high water mark, we can push in some more.
	// Also, if we have no data yet, we can stand some
	// more bytes.  This is to work around cases where hwm=0,
	// such as the repl.  Also, if the push() triggered a
	// readable event, and the user called read(largeNumber) such that
	// needReadable was set, then we ought to push more, so that another
	// 'readable' event will be triggered.
	function needMoreData(state) {
	  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
	}

	// backwards compatibility.
	Readable.prototype.setEncoding = function (enc) {
	  this._readableState.decoder = new StringDecoder(enc);
	  this._readableState.encoding = enc;
	  return this;
	};

	// Don't raise the hwm > 8MB
	var MAX_HWM = 0x800000;
	function computeNewHighWaterMark(n) {
	  if (n >= MAX_HWM) {
	    n = MAX_HWM;
	  } else {
	    // Get the next highest power of 2 to prevent increasing hwm excessively in
	    // tiny amounts
	    n--;
	    n |= n >>> 1;
	    n |= n >>> 2;
	    n |= n >>> 4;
	    n |= n >>> 8;
	    n |= n >>> 16;
	    n++;
	  }
	  return n;
	}

	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function howMuchToRead(n, state) {
	  if (n <= 0 || state.length === 0 && state.ended) return 0;
	  if (state.objectMode) return 1;
	  if (n !== n) {
	    // Only flow one buffer at a time
	    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
	  }
	  // If we're asking for more than the current hwm, then raise the hwm.
	  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
	  if (n <= state.length) return n;
	  // Don't have enough
	  if (!state.ended) {
	    state.needReadable = true;
	    return 0;
	  }
	  return state.length;
	}

	// you can override either this method, or the async _read(n) below.
	Readable.prototype.read = function (n) {
	  debug$2('read', n);
	  n = parseInt(n, 10);
	  var state = this._readableState;
	  var nOrig = n;

	  if (n !== 0) state.emittedReadable = false;

	  // if we're doing read(0) to trigger a readable event, but we
	  // already have a bunch of data in the buffer, then just trigger
	  // the 'readable' event and move on.
	  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
	    debug$2('read: emitReadable', state.length, state.ended);
	    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
	    return null;
	  }

	  n = howMuchToRead(n, state);

	  // if we've ended, and we're now clear, then finish it up.
	  if (n === 0 && state.ended) {
	    if (state.length === 0) endReadable(this);
	    return null;
	  }

	  // All the actual chunk generation logic needs to be
	  // *below* the call to _read.  The reason is that in certain
	  // synthetic stream cases, such as passthrough streams, _read
	  // may be a completely synchronous operation which may change
	  // the state of the read buffer, providing enough data when
	  // before there was *not* enough.
	  //
	  // So, the steps are:
	  // 1. Figure out what the state of things will be after we do
	  // a read from the buffer.
	  //
	  // 2. If that resulting state will trigger a _read, then call _read.
	  // Note that this may be asynchronous, or synchronous.  Yes, it is
	  // deeply ugly to write APIs this way, but that still doesn't mean
	  // that the Readable class should behave improperly, as streams are
	  // designed to be sync/async agnostic.
	  // Take note if the _read call is sync or async (ie, if the read call
	  // has returned yet), so that we know whether or not it's safe to emit
	  // 'readable' etc.
	  //
	  // 3. Actually pull the requested chunks out of the buffer and return.

	  // if we need a readable event, then we need to do some reading.
	  var doRead = state.needReadable;
	  debug$2('need readable', doRead);

	  // if we currently have less than the highWaterMark, then also read some
	  if (state.length === 0 || state.length - n < state.highWaterMark) {
	    doRead = true;
	    debug$2('length less than watermark', doRead);
	  }

	  // however, if we've ended, then there's no point, and if we're already
	  // reading, then it's unnecessary.
	  if (state.ended || state.reading) {
	    doRead = false;
	    debug$2('reading or ended', doRead);
	  } else if (doRead) {
	    debug$2('do read');
	    state.reading = true;
	    state.sync = true;
	    // if the length is currently zero, then we *need* a readable event.
	    if (state.length === 0) state.needReadable = true;
	    // call internal read method
	    this._read(state.highWaterMark);
	    state.sync = false;
	    // If _read pushed data synchronously, then `reading` will be false,
	    // and we need to re-evaluate how much data we can return to the user.
	    if (!state.reading) n = howMuchToRead(nOrig, state);
	  }

	  var ret;
	  if (n > 0) ret = fromList(n, state);else ret = null;

	  if (ret === null) {
	    state.needReadable = true;
	    n = 0;
	  } else {
	    state.length -= n;
	  }

	  if (state.length === 0) {
	    // If we have nothing in the buffer, then we want to know
	    // as soon as we *do* get something into the buffer.
	    if (!state.ended) state.needReadable = true;

	    // If we tried to read() past the EOF, then emit end on the next tick.
	    if (nOrig !== n && state.ended) endReadable(this);
	  }

	  if (ret !== null) this.emit('data', ret);

	  return ret;
	};

	function chunkInvalid(state, chunk) {
	  var er = null;
	  if (!Buffer.isBuffer(chunk) && typeof chunk !== 'string' && chunk !== null && chunk !== undefined && !state.objectMode) {
	    er = new TypeError('Invalid non-string/buffer chunk');
	  }
	  return er;
	}

	function onEofChunk(stream, state) {
	  if (state.ended) return;
	  if (state.decoder) {
	    var chunk = state.decoder.end();
	    if (chunk && chunk.length) {
	      state.buffer.push(chunk);
	      state.length += state.objectMode ? 1 : chunk.length;
	    }
	  }
	  state.ended = true;

	  // emit 'readable' now to make sure it gets picked up.
	  emitReadable(stream);
	}

	// Don't emit readable right away in sync mode, because this can trigger
	// another read() call => stack overflow.  This way, it might trigger
	// a nextTick recursion warning, but that's not so bad.
	function emitReadable(stream) {
	  var state = stream._readableState;
	  state.needReadable = false;
	  if (!state.emittedReadable) {
	    debug$2('emitReadable', state.flowing);
	    state.emittedReadable = true;
	    if (state.sync) nextTick(emitReadable_, stream);else emitReadable_(stream);
	  }
	}

	function emitReadable_(stream) {
	  debug$2('emit readable');
	  stream.emit('readable');
	  flow(stream);
	}

	// at this point, the user has presumably seen the 'readable' event,
	// and called read() to consume some data.  that may have triggered
	// in turn another _read(n) call, in which case reading = true if
	// it's in progress.
	// However, if we're not ended, or reading, and the length < hwm,
	// then go ahead and try to read some more preemptively.
	function maybeReadMore(stream, state) {
	  if (!state.readingMore) {
	    state.readingMore = true;
	    nextTick(maybeReadMore_, stream, state);
	  }
	}

	function maybeReadMore_(stream, state) {
	  var len = state.length;
	  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
	    debug$2('maybeReadMore read 0');
	    stream.read(0);
	    if (len === state.length)
	      // didn't get any data, stop spinning.
	      break;else len = state.length;
	  }
	  state.readingMore = false;
	}

	// abstract method.  to be overridden in specific implementation classes.
	// call cb(er, data) where data is <= n in length.
	// for virtual (non-string, non-buffer) streams, "length" is somewhat
	// arbitrary, and perhaps not very meaningful.
	Readable.prototype._read = function (n) {
	  this.emit('error', new Error('not implemented'));
	};

	Readable.prototype.pipe = function (dest, pipeOpts) {
	  var src = this;
	  var state = this._readableState;

	  switch (state.pipesCount) {
	    case 0:
	      state.pipes = dest;
	      break;
	    case 1:
	      state.pipes = [state.pipes, dest];
	      break;
	    default:
	      state.pipes.push(dest);
	      break;
	  }
	  state.pipesCount += 1;
	  debug$2('pipe count=%d opts=%j', state.pipesCount, pipeOpts);

	  var doEnd = (!pipeOpts || pipeOpts.end !== false);

	  var endFn = doEnd ? onend : cleanup;
	  if (state.endEmitted) nextTick(endFn);else src.once('end', endFn);

	  dest.on('unpipe', onunpipe);
	  function onunpipe(readable) {
	    debug$2('onunpipe');
	    if (readable === src) {
	      cleanup();
	    }
	  }

	  function onend() {
	    debug$2('onend');
	    dest.end();
	  }

	  // when the dest drains, it reduces the awaitDrain counter
	  // on the source.  This would be more elegant with a .once()
	  // handler in flow(), but adding and removing repeatedly is
	  // too slow.
	  var ondrain = pipeOnDrain(src);
	  dest.on('drain', ondrain);

	  var cleanedUp = false;
	  function cleanup() {
	    debug$2('cleanup');
	    // cleanup event handlers once the pipe is broken
	    dest.removeListener('close', onclose);
	    dest.removeListener('finish', onfinish);
	    dest.removeListener('drain', ondrain);
	    dest.removeListener('error', onerror);
	    dest.removeListener('unpipe', onunpipe);
	    src.removeListener('end', onend);
	    src.removeListener('end', cleanup);
	    src.removeListener('data', ondata);

	    cleanedUp = true;

	    // if the reader is waiting for a drain event from this
	    // specific writer, then it would cause it to never start
	    // flowing again.
	    // So, if this is awaiting a drain, then we just call it now.
	    // If we don't know, then assume that we are waiting for one.
	    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
	  }

	  // If the user pushes more data while we're writing to dest then we'll end up
	  // in ondata again. However, we only want to increase awaitDrain once because
	  // dest will only emit one 'drain' event for the multiple writes.
	  // => Introduce a guard on increasing awaitDrain.
	  var increasedAwaitDrain = false;
	  src.on('data', ondata);
	  function ondata(chunk) {
	    debug$2('ondata');
	    increasedAwaitDrain = false;
	    var ret = dest.write(chunk);
	    if (false === ret && !increasedAwaitDrain) {
	      // If the user unpiped during `dest.write()`, it is possible
	      // to get stuck in a permanently paused state if that write
	      // also returned false.
	      // => Check whether `dest` is still a piping destination.
	      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
	        debug$2('false write response, pause', src._readableState.awaitDrain);
	        src._readableState.awaitDrain++;
	        increasedAwaitDrain = true;
	      }
	      src.pause();
	    }
	  }

	  // if the dest has an error, then stop piping into it.
	  // however, don't suppress the throwing behavior for this.
	  function onerror(er) {
	    debug$2('onerror', er);
	    unpipe();
	    dest.removeListener('error', onerror);
	    if (listenerCount(dest, 'error') === 0) dest.emit('error', er);
	  }

	  // Make sure our error handler is attached before userland ones.
	  prependListener(dest, 'error', onerror);

	  // Both close and finish should trigger unpipe, but only once.
	  function onclose() {
	    dest.removeListener('finish', onfinish);
	    unpipe();
	  }
	  dest.once('close', onclose);
	  function onfinish() {
	    debug$2('onfinish');
	    dest.removeListener('close', onclose);
	    unpipe();
	  }
	  dest.once('finish', onfinish);

	  function unpipe() {
	    debug$2('unpipe');
	    src.unpipe(dest);
	  }

	  // tell the dest that it's being piped to
	  dest.emit('pipe', src);

	  // start the flow if it hasn't been started already.
	  if (!state.flowing) {
	    debug$2('pipe resume');
	    src.resume();
	  }

	  return dest;
	};

	function pipeOnDrain(src) {
	  return function () {
	    var state = src._readableState;
	    debug$2('pipeOnDrain', state.awaitDrain);
	    if (state.awaitDrain) state.awaitDrain--;
	    if (state.awaitDrain === 0 && src.listeners('data').length) {
	      state.flowing = true;
	      flow(src);
	    }
	  };
	}

	Readable.prototype.unpipe = function (dest) {
	  var state = this._readableState;

	  // if we're not piping anywhere, then do nothing.
	  if (state.pipesCount === 0) return this;

	  // just one destination.  most common case.
	  if (state.pipesCount === 1) {
	    // passed in one, but it's not the right one.
	    if (dest && dest !== state.pipes) return this;

	    if (!dest) dest = state.pipes;

	    // got a match.
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;
	    if (dest) dest.emit('unpipe', this);
	    return this;
	  }

	  // slow case. multiple pipe destinations.

	  if (!dest) {
	    // remove all.
	    var dests = state.pipes;
	    var len = state.pipesCount;
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;

	    for (var _i = 0; _i < len; _i++) {
	      dests[_i].emit('unpipe', this);
	    }return this;
	  }

	  // try to find the right one.
	  var i = indexOf(state.pipes, dest);
	  if (i === -1) return this;

	  state.pipes.splice(i, 1);
	  state.pipesCount -= 1;
	  if (state.pipesCount === 1) state.pipes = state.pipes[0];

	  dest.emit('unpipe', this);

	  return this;
	};

	// set up data events if they are asked for
	// Ensure readable listeners eventually get something
	Readable.prototype.on = function (ev, fn) {
	  var res = EventEmitter.prototype.on.call(this, ev, fn);

	  if (ev === 'data') {
	    // Start flowing on next tick if stream isn't explicitly paused
	    if (this._readableState.flowing !== false) this.resume();
	  } else if (ev === 'readable') {
	    var state = this._readableState;
	    if (!state.endEmitted && !state.readableListening) {
	      state.readableListening = state.needReadable = true;
	      state.emittedReadable = false;
	      if (!state.reading) {
	        nextTick(nReadingNextTick, this);
	      } else if (state.length) {
	        emitReadable(this);
	      }
	    }
	  }

	  return res;
	};
	Readable.prototype.addListener = Readable.prototype.on;

	function nReadingNextTick(self) {
	  debug$2('readable nexttick read 0');
	  self.read(0);
	}

	// pause() and resume() are remnants of the legacy readable stream API
	// If the user uses them, then switch into old mode.
	Readable.prototype.resume = function () {
	  var state = this._readableState;
	  if (!state.flowing) {
	    debug$2('resume');
	    state.flowing = true;
	    resume(this, state);
	  }
	  return this;
	};

	function resume(stream, state) {
	  if (!state.resumeScheduled) {
	    state.resumeScheduled = true;
	    nextTick(resume_, stream, state);
	  }
	}

	function resume_(stream, state) {
	  if (!state.reading) {
	    debug$2('resume read 0');
	    stream.read(0);
	  }

	  state.resumeScheduled = false;
	  state.awaitDrain = 0;
	  stream.emit('resume');
	  flow(stream);
	  if (state.flowing && !state.reading) stream.read(0);
	}

	Readable.prototype.pause = function () {
	  debug$2('call pause flowing=%j', this._readableState.flowing);
	  if (false !== this._readableState.flowing) {
	    debug$2('pause');
	    this._readableState.flowing = false;
	    this.emit('pause');
	  }
	  return this;
	};

	function flow(stream) {
	  var state = stream._readableState;
	  debug$2('flow', state.flowing);
	  while (state.flowing && stream.read() !== null) {}
	}

	// wrap an old-style stream as the async data source.
	// This is *not* part of the readable stream interface.
	// It is an ugly unfortunate mess of history.
	Readable.prototype.wrap = function (stream) {
	  var state = this._readableState;
	  var paused = false;

	  var self = this;
	  stream.on('end', function () {
	    debug$2('wrapped end');
	    if (state.decoder && !state.ended) {
	      var chunk = state.decoder.end();
	      if (chunk && chunk.length) self.push(chunk);
	    }

	    self.push(null);
	  });

	  stream.on('data', function (chunk) {
	    debug$2('wrapped data');
	    if (state.decoder) chunk = state.decoder.write(chunk);

	    // don't skip over falsy values in objectMode
	    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;

	    var ret = self.push(chunk);
	    if (!ret) {
	      paused = true;
	      stream.pause();
	    }
	  });

	  // proxy all the other methods.
	  // important when wrapping filters and duplexes.
	  for (var i in stream) {
	    if (this[i] === undefined && typeof stream[i] === 'function') {
	      this[i] = function (method) {
	        return function () {
	          return stream[method].apply(stream, arguments);
	        };
	      }(i);
	    }
	  }

	  // proxy certain important events.
	  var events = ['error', 'close', 'destroy', 'pause', 'resume'];
	  forEach(events, function (ev) {
	    stream.on(ev, self.emit.bind(self, ev));
	  });

	  // when we try to consume some more bytes, simply unpause the
	  // underlying stream.
	  self._read = function (n) {
	    debug$2('wrapped _read', n);
	    if (paused) {
	      paused = false;
	      stream.resume();
	    }
	  };

	  return self;
	};

	// exposed for testing purposes only.
	Readable._fromList = fromList;

	// Pluck off n bytes from an array of buffers.
	// Length is the combined lengths of all the buffers in the list.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function fromList(n, state) {
	  // nothing buffered
	  if (state.length === 0) return null;

	  var ret;
	  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
	    // read it all, truncate the list
	    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
	    state.buffer.clear();
	  } else {
	    // read part of list
	    ret = fromListPartial(n, state.buffer, state.decoder);
	  }

	  return ret;
	}

	// Extracts only enough buffered data to satisfy the amount requested.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function fromListPartial(n, list, hasStrings) {
	  var ret;
	  if (n < list.head.data.length) {
	    // slice is the same for buffers and strings
	    ret = list.head.data.slice(0, n);
	    list.head.data = list.head.data.slice(n);
	  } else if (n === list.head.data.length) {
	    // first chunk is a perfect match
	    ret = list.shift();
	  } else {
	    // result spans more than one buffer
	    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
	  }
	  return ret;
	}

	// Copies a specified amount of characters from the list of buffered data
	// chunks.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function copyFromBufferString(n, list) {
	  var p = list.head;
	  var c = 1;
	  var ret = p.data;
	  n -= ret.length;
	  while (p = p.next) {
	    var str = p.data;
	    var nb = n > str.length ? str.length : n;
	    if (nb === str.length) ret += str;else ret += str.slice(0, n);
	    n -= nb;
	    if (n === 0) {
	      if (nb === str.length) {
	        ++c;
	        if (p.next) list.head = p.next;else list.head = list.tail = null;
	      } else {
	        list.head = p;
	        p.data = str.slice(nb);
	      }
	      break;
	    }
	    ++c;
	  }
	  list.length -= c;
	  return ret;
	}

	// Copies a specified amount of bytes from the list of buffered data chunks.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function copyFromBuffer(n, list) {
	  var ret = Buffer.allocUnsafe(n);
	  var p = list.head;
	  var c = 1;
	  p.data.copy(ret);
	  n -= p.data.length;
	  while (p = p.next) {
	    var buf = p.data;
	    var nb = n > buf.length ? buf.length : n;
	    buf.copy(ret, ret.length - n, 0, nb);
	    n -= nb;
	    if (n === 0) {
	      if (nb === buf.length) {
	        ++c;
	        if (p.next) list.head = p.next;else list.head = list.tail = null;
	      } else {
	        list.head = p;
	        p.data = buf.slice(nb);
	      }
	      break;
	    }
	    ++c;
	  }
	  list.length -= c;
	  return ret;
	}

	function endReadable(stream) {
	  var state = stream._readableState;

	  // If we get here before consuming all the bytes, then that is a
	  // bug in node.  Should never happen.
	  if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');

	  if (!state.endEmitted) {
	    state.ended = true;
	    nextTick(endReadableNT, state, stream);
	  }
	}

	function endReadableNT(state, stream) {
	  // Check that we didn't get one last unshift.
	  if (!state.endEmitted && state.length === 0) {
	    state.endEmitted = true;
	    stream.readable = false;
	    stream.emit('end');
	  }
	}

	function forEach(xs, f) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    f(xs[i], i);
	  }
	}

	function indexOf(xs, x) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    if (xs[i] === x) return i;
	  }
	  return -1;
	}

	// A bit simpler than readable streams.
	Writable.WritableState = WritableState;
	inherits$1(Writable, EventEmitter);

	function nop() {}

	function WriteReq(chunk, encoding, cb) {
	  this.chunk = chunk;
	  this.encoding = encoding;
	  this.callback = cb;
	  this.next = null;
	}

	function WritableState(options, stream) {
	  Object.defineProperty(this, 'buffer', {
	    get: deprecate(function () {
	      return this.getBuffer();
	    }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.')
	  });
	  options = options || {};

	  // object stream flag to indicate whether or not this stream
	  // contains buffers or objects.
	  this.objectMode = !!options.objectMode;

	  if (stream instanceof Duplex) this.objectMode = this.objectMode || !!options.writableObjectMode;

	  // the point at which write() starts returning false
	  // Note: 0 is a valid value, means that we always return false if
	  // the entire buffer is not flushed immediately on write()
	  var hwm = options.highWaterMark;
	  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
	  this.highWaterMark = hwm || hwm === 0 ? hwm : defaultHwm;

	  // cast to ints.
	  this.highWaterMark = ~ ~this.highWaterMark;

	  this.needDrain = false;
	  // at the start of calling end()
	  this.ending = false;
	  // when end() has been called, and returned
	  this.ended = false;
	  // when 'finish' is emitted
	  this.finished = false;

	  // should we decode strings into buffers before passing to _write?
	  // this is here so that some node-core streams can optimize string
	  // handling at a lower level.
	  var noDecode = options.decodeStrings === false;
	  this.decodeStrings = !noDecode;

	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';

	  // not an actual buffer we keep track of, but a measurement
	  // of how much we're waiting to get pushed to some underlying
	  // socket or file.
	  this.length = 0;

	  // a flag to see when we're in the middle of a write.
	  this.writing = false;

	  // when true all writes will be buffered until .uncork() call
	  this.corked = 0;

	  // a flag to be able to tell if the onwrite cb is called immediately,
	  // or on a later tick.  We set this to true at first, because any
	  // actions that shouldn't happen until "later" should generally also
	  // not happen before the first write call.
	  this.sync = true;

	  // a flag to know if we're processing previously buffered items, which
	  // may call the _write() callback in the same tick, so that we don't
	  // end up in an overlapped onwrite situation.
	  this.bufferProcessing = false;

	  // the callback that's passed to _write(chunk,cb)
	  this.onwrite = function (er) {
	    onwrite(stream, er);
	  };

	  // the callback that the user supplies to write(chunk,encoding,cb)
	  this.writecb = null;

	  // the amount that is being written when _write is called.
	  this.writelen = 0;

	  this.bufferedRequest = null;
	  this.lastBufferedRequest = null;

	  // number of pending user-supplied write callbacks
	  // this must be 0 before 'finish' can be emitted
	  this.pendingcb = 0;

	  // emit prefinish if the only thing we're waiting for is _write cbs
	  // This is relevant for synchronous Transform streams
	  this.prefinished = false;

	  // True if the error was already emitted and should not be thrown again
	  this.errorEmitted = false;

	  // count buffered requests
	  this.bufferedRequestCount = 0;

	  // allocate the first CorkedRequest, there is always
	  // one allocated and free to use, and we maintain at most two
	  this.corkedRequestsFree = new CorkedRequest(this);
	}

	WritableState.prototype.getBuffer = function writableStateGetBuffer() {
	  var current = this.bufferedRequest;
	  var out = [];
	  while (current) {
	    out.push(current);
	    current = current.next;
	  }
	  return out;
	};
	function Writable(options) {

	  // Writable ctor is applied to Duplexes, though they're not
	  // instanceof Writable, they're instanceof Readable.
	  if (!(this instanceof Writable) && !(this instanceof Duplex)) return new Writable(options);

	  this._writableState = new WritableState(options, this);

	  // legacy.
	  this.writable = true;

	  if (options) {
	    if (typeof options.write === 'function') this._write = options.write;

	    if (typeof options.writev === 'function') this._writev = options.writev;
	  }

	  EventEmitter.call(this);
	}

	// Otherwise people can pipe Writable streams, which is just wrong.
	Writable.prototype.pipe = function () {
	  this.emit('error', new Error('Cannot pipe, not readable'));
	};

	function writeAfterEnd(stream, cb) {
	  var er = new Error('write after end');
	  // TODO: defer error events consistently everywhere, not just the cb
	  stream.emit('error', er);
	  nextTick(cb, er);
	}

	// If we get something that is not a buffer, string, null, or undefined,
	// and we're not in objectMode, then that's an error.
	// Otherwise stream chunks are all considered to be of length=1, and the
	// watermarks determine how many objects to keep in the buffer, rather than
	// how many bytes or characters.
	function validChunk(stream, state, chunk, cb) {
	  var valid = true;
	  var er = false;
	  // Always throw error if a null is written
	  // if we are not in object mode then throw
	  // if it is not a buffer, string, or undefined.
	  if (chunk === null) {
	    er = new TypeError('May not write null values to stream');
	  } else if (!Buffer.isBuffer(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
	    er = new TypeError('Invalid non-string/buffer chunk');
	  }
	  if (er) {
	    stream.emit('error', er);
	    nextTick(cb, er);
	    valid = false;
	  }
	  return valid;
	}

	Writable.prototype.write = function (chunk, encoding, cb) {
	  var state = this._writableState;
	  var ret = false;

	  if (typeof encoding === 'function') {
	    cb = encoding;
	    encoding = null;
	  }

	  if (Buffer.isBuffer(chunk)) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;

	  if (typeof cb !== 'function') cb = nop;

	  if (state.ended) writeAfterEnd(this, cb);else if (validChunk(this, state, chunk, cb)) {
	    state.pendingcb++;
	    ret = writeOrBuffer(this, state, chunk, encoding, cb);
	  }

	  return ret;
	};

	Writable.prototype.cork = function () {
	  var state = this._writableState;

	  state.corked++;
	};

	Writable.prototype.uncork = function () {
	  var state = this._writableState;

	  if (state.corked) {
	    state.corked--;

	    if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
	  }
	};

	Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
	  // node::ParseEncoding() requires lower case.
	  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
	  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
	  this._writableState.defaultEncoding = encoding;
	  return this;
	};

	function decodeChunk(state, chunk, encoding) {
	  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
	    chunk = Buffer.from(chunk, encoding);
	  }
	  return chunk;
	}

	// if we're already writing something, then just put this
	// in the queue, and wait our turn.  Otherwise, call _write
	// If we return false, then we need a drain event, so set that flag.
	function writeOrBuffer(stream, state, chunk, encoding, cb) {
	  chunk = decodeChunk(state, chunk, encoding);

	  if (Buffer.isBuffer(chunk)) encoding = 'buffer';
	  var len = state.objectMode ? 1 : chunk.length;

	  state.length += len;

	  var ret = state.length < state.highWaterMark;
	  // we must ensure that previous needDrain will not be reset to false.
	  if (!ret) state.needDrain = true;

	  if (state.writing || state.corked) {
	    var last = state.lastBufferedRequest;
	    state.lastBufferedRequest = new WriteReq(chunk, encoding, cb);
	    if (last) {
	      last.next = state.lastBufferedRequest;
	    } else {
	      state.bufferedRequest = state.lastBufferedRequest;
	    }
	    state.bufferedRequestCount += 1;
	  } else {
	    doWrite(stream, state, false, len, chunk, encoding, cb);
	  }

	  return ret;
	}

	function doWrite(stream, state, writev, len, chunk, encoding, cb) {
	  state.writelen = len;
	  state.writecb = cb;
	  state.writing = true;
	  state.sync = true;
	  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
	  state.sync = false;
	}

	function onwriteError(stream, state, sync, er, cb) {
	  --state.pendingcb;
	  if (sync) nextTick(cb, er);else cb(er);

	  stream._writableState.errorEmitted = true;
	  stream.emit('error', er);
	}

	function onwriteStateUpdate(state) {
	  state.writing = false;
	  state.writecb = null;
	  state.length -= state.writelen;
	  state.writelen = 0;
	}

	function onwrite(stream, er) {
	  var state = stream._writableState;
	  var sync = state.sync;
	  var cb = state.writecb;

	  onwriteStateUpdate(state);

	  if (er) onwriteError(stream, state, sync, er, cb);else {
	    // Check if we're actually ready to finish, but don't emit yet
	    var finished = needFinish(state);

	    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
	      clearBuffer(stream, state);
	    }

	    if (sync) {
	      /*<replacement>*/
	        nextTick(afterWrite, stream, state, finished, cb);
	      /*</replacement>*/
	    } else {
	        afterWrite(stream, state, finished, cb);
	      }
	  }
	}

	function afterWrite(stream, state, finished, cb) {
	  if (!finished) onwriteDrain(stream, state);
	  state.pendingcb--;
	  cb();
	  finishMaybe(stream, state);
	}

	// Must force callback to be called on nextTick, so that we don't
	// emit 'drain' before the write() consumer gets the 'false' return
	// value, and has a chance to attach a 'drain' listener.
	function onwriteDrain(stream, state) {
	  if (state.length === 0 && state.needDrain) {
	    state.needDrain = false;
	    stream.emit('drain');
	  }
	}

	// if there's something in the buffer waiting, then process it
	function clearBuffer(stream, state) {
	  state.bufferProcessing = true;
	  var entry = state.bufferedRequest;

	  if (stream._writev && entry && entry.next) {
	    // Fast case, write everything using _writev()
	    var l = state.bufferedRequestCount;
	    var buffer = new Array(l);
	    var holder = state.corkedRequestsFree;
	    holder.entry = entry;

	    var count = 0;
	    while (entry) {
	      buffer[count] = entry;
	      entry = entry.next;
	      count += 1;
	    }

	    doWrite(stream, state, true, state.length, buffer, '', holder.finish);

	    // doWrite is almost always async, defer these to save a bit of time
	    // as the hot path ends with doWrite
	    state.pendingcb++;
	    state.lastBufferedRequest = null;
	    if (holder.next) {
	      state.corkedRequestsFree = holder.next;
	      holder.next = null;
	    } else {
	      state.corkedRequestsFree = new CorkedRequest(state);
	    }
	  } else {
	    // Slow case, write chunks one-by-one
	    while (entry) {
	      var chunk = entry.chunk;
	      var encoding = entry.encoding;
	      var cb = entry.callback;
	      var len = state.objectMode ? 1 : chunk.length;

	      doWrite(stream, state, false, len, chunk, encoding, cb);
	      entry = entry.next;
	      // if we didn't call the onwrite immediately, then
	      // it means that we need to wait until it does.
	      // also, that means that the chunk and cb are currently
	      // being processed, so move the buffer counter past them.
	      if (state.writing) {
	        break;
	      }
	    }

	    if (entry === null) state.lastBufferedRequest = null;
	  }

	  state.bufferedRequestCount = 0;
	  state.bufferedRequest = entry;
	  state.bufferProcessing = false;
	}

	Writable.prototype._write = function (chunk, encoding, cb) {
	  cb(new Error('not implemented'));
	};

	Writable.prototype._writev = null;

	Writable.prototype.end = function (chunk, encoding, cb) {
	  var state = this._writableState;

	  if (typeof chunk === 'function') {
	    cb = chunk;
	    chunk = null;
	    encoding = null;
	  } else if (typeof encoding === 'function') {
	    cb = encoding;
	    encoding = null;
	  }

	  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);

	  // .end() fully uncorks
	  if (state.corked) {
	    state.corked = 1;
	    this.uncork();
	  }

	  // ignore unnecessary end() calls.
	  if (!state.ending && !state.finished) endWritable(this, state, cb);
	};

	function needFinish(state) {
	  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
	}

	function prefinish(stream, state) {
	  if (!state.prefinished) {
	    state.prefinished = true;
	    stream.emit('prefinish');
	  }
	}

	function finishMaybe(stream, state) {
	  var need = needFinish(state);
	  if (need) {
	    if (state.pendingcb === 0) {
	      prefinish(stream, state);
	      state.finished = true;
	      stream.emit('finish');
	    } else {
	      prefinish(stream, state);
	    }
	  }
	  return need;
	}

	function endWritable(stream, state, cb) {
	  state.ending = true;
	  finishMaybe(stream, state);
	  if (cb) {
	    if (state.finished) nextTick(cb);else stream.once('finish', cb);
	  }
	  state.ended = true;
	  stream.writable = false;
	}

	// It seems a linked list but it is not
	// there will be only 2 of these for each stream
	function CorkedRequest(state) {
	  var _this = this;

	  this.next = null;
	  this.entry = null;

	  this.finish = function (err) {
	    var entry = _this.entry;
	    _this.entry = null;
	    while (entry) {
	      var cb = entry.callback;
	      state.pendingcb--;
	      cb(err);
	      entry = entry.next;
	    }
	    if (state.corkedRequestsFree) {
	      state.corkedRequestsFree.next = _this;
	    } else {
	      state.corkedRequestsFree = _this;
	    }
	  };
	}

	inherits$1(Duplex, Readable);

	var keys = Object.keys(Writable.prototype);
	for (var v = 0; v < keys.length; v++) {
	  var method = keys[v];
	  if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
	}
	function Duplex(options) {
	  if (!(this instanceof Duplex)) return new Duplex(options);

	  Readable.call(this, options);
	  Writable.call(this, options);

	  if (options && options.readable === false) this.readable = false;

	  if (options && options.writable === false) this.writable = false;

	  this.allowHalfOpen = true;
	  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;

	  this.once('end', onend);
	}

	// the no-half-open enforcer
	function onend() {
	  // if we allow half-open state, or if the writable side ended,
	  // then we're ok.
	  if (this.allowHalfOpen || this._writableState.ended) return;

	  // no more data can be written.
	  // But allow more writes to happen in this tick.
	  nextTick(onEndNT, this);
	}

	function onEndNT(self) {
	  self.end();
	}

	// a transform stream is a readable/writable stream where you do
	inherits$1(Transform, Duplex);

	function TransformState(stream) {
	  this.afterTransform = function (er, data) {
	    return afterTransform(stream, er, data);
	  };

	  this.needTransform = false;
	  this.transforming = false;
	  this.writecb = null;
	  this.writechunk = null;
	  this.writeencoding = null;
	}

	function afterTransform(stream, er, data) {
	  var ts = stream._transformState;
	  ts.transforming = false;

	  var cb = ts.writecb;

	  if (!cb) return stream.emit('error', new Error('no writecb in Transform class'));

	  ts.writechunk = null;
	  ts.writecb = null;

	  if (data !== null && data !== undefined) stream.push(data);

	  cb(er);

	  var rs = stream._readableState;
	  rs.reading = false;
	  if (rs.needReadable || rs.length < rs.highWaterMark) {
	    stream._read(rs.highWaterMark);
	  }
	}
	function Transform(options) {
	  if (!(this instanceof Transform)) return new Transform(options);

	  Duplex.call(this, options);

	  this._transformState = new TransformState(this);

	  // when the writable side finishes, then flush out anything remaining.
	  var stream = this;

	  // start out asking for a readable event once data is transformed.
	  this._readableState.needReadable = true;

	  // we have implemented the _read method, and done the other things
	  // that Readable wants before the first _read call, so unset the
	  // sync guard flag.
	  this._readableState.sync = false;

	  if (options) {
	    if (typeof options.transform === 'function') this._transform = options.transform;

	    if (typeof options.flush === 'function') this._flush = options.flush;
	  }

	  this.once('prefinish', function () {
	    if (typeof this._flush === 'function') this._flush(function (er) {
	      done(stream, er);
	    });else done(stream);
	  });
	}

	Transform.prototype.push = function (chunk, encoding) {
	  this._transformState.needTransform = false;
	  return Duplex.prototype.push.call(this, chunk, encoding);
	};

	// This is the part where you do stuff!
	// override this function in implementation classes.
	// 'chunk' is an input chunk.
	//
	// Call `push(newChunk)` to pass along transformed output
	// to the readable side.  You may call 'push' zero or more times.
	//
	// Call `cb(err)` when you are done with this chunk.  If you pass
	// an error, then that'll put the hurt on the whole operation.  If you
	// never call cb(), then you'll never get another chunk.
	Transform.prototype._transform = function (chunk, encoding, cb) {
	  throw new Error('Not implemented');
	};

	Transform.prototype._write = function (chunk, encoding, cb) {
	  var ts = this._transformState;
	  ts.writecb = cb;
	  ts.writechunk = chunk;
	  ts.writeencoding = encoding;
	  if (!ts.transforming) {
	    var rs = this._readableState;
	    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
	  }
	};

	// Doesn't matter what the args are here.
	// _transform does all the work.
	// That we got here means that the readable side wants more data.
	Transform.prototype._read = function (n) {
	  var ts = this._transformState;

	  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
	    ts.transforming = true;
	    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
	  } else {
	    // mark that we need a transform, so that any data that comes in
	    // will get processed, now that we've asked for it.
	    ts.needTransform = true;
	  }
	};

	function done(stream, er) {
	  if (er) return stream.emit('error', er);

	  // if there's nothing in the write buffer, then that means
	  // that nothing more will ever be provided
	  var ws = stream._writableState;
	  var ts = stream._transformState;

	  if (ws.length) throw new Error('Calling transform done when ws.length != 0');

	  if (ts.transforming) throw new Error('Calling transform done when still transforming');

	  return stream.push(null);
	}

	inherits$1(PassThrough, Transform);
	function PassThrough(options) {
	  if (!(this instanceof PassThrough)) return new PassThrough(options);

	  Transform.call(this, options);
	}

	PassThrough.prototype._transform = function (chunk, encoding, cb) {
	  cb(null, chunk);
	};

	inherits$1(Stream, EventEmitter);
	Stream.Readable = Readable;
	Stream.Writable = Writable;
	Stream.Duplex = Duplex;
	Stream.Transform = Transform;
	Stream.PassThrough = PassThrough;

	// Backwards-compat with node 0.4.x
	Stream.Stream = Stream;

	// old-style streams.  Note that the pipe method (the only relevant
	// part of this class) is overridden in the Readable class.

	function Stream() {
	  EventEmitter.call(this);
	}

	Stream.prototype.pipe = function(dest, options) {
	  var source = this;

	  function ondata(chunk) {
	    if (dest.writable) {
	      if (false === dest.write(chunk) && source.pause) {
	        source.pause();
	      }
	    }
	  }

	  source.on('data', ondata);

	  function ondrain() {
	    if (source.readable && source.resume) {
	      source.resume();
	    }
	  }

	  dest.on('drain', ondrain);

	  // If the 'end' option is not supplied, dest.end() will be called when
	  // source gets the 'end' or 'close' events.  Only dest.end() once.
	  if (!dest._isStdio && (!options || options.end !== false)) {
	    source.on('end', onend);
	    source.on('close', onclose);
	  }

	  var didOnEnd = false;
	  function onend() {
	    if (didOnEnd) return;
	    didOnEnd = true;

	    dest.end();
	  }


	  function onclose() {
	    if (didOnEnd) return;
	    didOnEnd = true;

	    if (typeof dest.destroy === 'function') dest.destroy();
	  }

	  // don't leave dangling pipes when there are errors.
	  function onerror(er) {
	    cleanup();
	    if (EventEmitter.listenerCount(this, 'error') === 0) {
	      throw er; // Unhandled stream error in pipe.
	    }
	  }

	  source.on('error', onerror);
	  dest.on('error', onerror);

	  // remove all the event listeners that were added.
	  function cleanup() {
	    source.removeListener('data', ondata);
	    dest.removeListener('drain', ondrain);

	    source.removeListener('end', onend);
	    source.removeListener('close', onclose);

	    source.removeListener('error', onerror);
	    dest.removeListener('error', onerror);

	    source.removeListener('end', cleanup);
	    source.removeListener('close', cleanup);

	    dest.removeListener('close', cleanup);
	  }

	  source.on('end', cleanup);
	  source.on('close', cleanup);

	  dest.on('close', cleanup);

	  dest.emit('pipe', source);

	  // Allow for unix-like usage: A.pipe(B).pipe(C)
	  return dest;
	};

	var rStates = {
	  UNSENT: 0,
	  OPENED: 1,
	  HEADERS_RECEIVED: 2,
	  LOADING: 3,
	  DONE: 4
	};
	function IncomingMessage(xhr, response, mode) {
	  var self = this;
	  Readable.call(self);

	  self._mode = mode;
	  self.headers = {};
	  self.rawHeaders = [];
	  self.trailers = {};
	  self.rawTrailers = [];

	  // Fake the 'close' event, but only once 'end' fires
	  self.on('end', function() {
	    // The nextTick is necessary to prevent the 'request' module from causing an infinite loop
	    browser$1.nextTick(function() {
	      self.emit('close');
	    });
	  });
	  var read;
	  if (mode === 'fetch') {
	    self._fetchResponse = response;

	    self.url = response.url;
	    self.statusCode = response.status;
	    self.statusMessage = response.statusText;
	      // backwards compatible version of for (<item> of <iterable>):
	      // for (var <item>,_i,_it = <iterable>[Symbol.iterator](); <item> = (_i = _it.next()).value,!_i.done;)
	    for (var header, _i, _it = response.headers[Symbol.iterator](); header = (_i = _it.next()).value, !_i.done;) {
	      self.headers[header[0].toLowerCase()] = header[1];
	      self.rawHeaders.push(header[0], header[1]);
	    }

	    // TODO: this doesn't respect backpressure. Once WritableStream is available, this can be fixed
	    var reader = response.body.getReader();

	    read = function () {
	      reader.read().then(function(result) {
	        if (self._destroyed)
	          return
	        if (result.done) {
	          self.push(null);
	          return
	        }
	        self.push(new Buffer(result.value));
	        read();
	      });
	    };
	    read();

	  } else {
	    self._xhr = xhr;
	    self._pos = 0;

	    self.url = xhr.responseURL;
	    self.statusCode = xhr.status;
	    self.statusMessage = xhr.statusText;
	    var headers = xhr.getAllResponseHeaders().split(/\r?\n/);
	    headers.forEach(function(header) {
	      var matches = header.match(/^([^:]+):\s*(.*)/);
	      if (matches) {
	        var key = matches[1].toLowerCase();
	        if (key === 'set-cookie') {
	          if (self.headers[key] === undefined) {
	            self.headers[key] = [];
	          }
	          self.headers[key].push(matches[2]);
	        } else if (self.headers[key] !== undefined) {
	          self.headers[key] += ', ' + matches[2];
	        } else {
	          self.headers[key] = matches[2];
	        }
	        self.rawHeaders.push(matches[1], matches[2]);
	      }
	    });

	    self._charset = 'x-user-defined';
	    if (!overrideMimeType) {
	      var mimeType = self.rawHeaders['mime-type'];
	      if (mimeType) {
	        var charsetMatch = mimeType.match(/;\s*charset=([^;])(;|$)/);
	        if (charsetMatch) {
	          self._charset = charsetMatch[1].toLowerCase();
	        }
	      }
	      if (!self._charset)
	        self._charset = 'utf-8'; // best guess
	    }
	  }
	}

	inherits$1(IncomingMessage, Readable);

	IncomingMessage.prototype._read = function() {};

	IncomingMessage.prototype._onXHRProgress = function() {
	  var self = this;

	  var xhr = self._xhr;

	  var response = null;
	  switch (self._mode) {
	  case 'text:vbarray': // For IE9
	    if (xhr.readyState !== rStates.DONE)
	      break
	    try {
	      // This fails in IE8
	      response = new global$1.VBArray(xhr.responseBody).toArray();
	    } catch (e) {
	      // pass
	    }
	    if (response !== null) {
	      self.push(new Buffer(response));
	      break
	    }
	    // Falls through in IE8
	  case 'text':
	    try { // This will fail when readyState = 3 in IE9. Switch mode and wait for readyState = 4
	      response = xhr.responseText;
	    } catch (e) {
	      self._mode = 'text:vbarray';
	      break
	    }
	    if (response.length > self._pos) {
	      var newData = response.substr(self._pos);
	      if (self._charset === 'x-user-defined') {
	        var buffer = new Buffer(newData.length);
	        for (var i = 0; i < newData.length; i++)
	          buffer[i] = newData.charCodeAt(i) & 0xff;

	        self.push(buffer);
	      } else {
	        self.push(newData, self._charset);
	      }
	      self._pos = response.length;
	    }
	    break
	  case 'arraybuffer':
	    if (xhr.readyState !== rStates.DONE || !xhr.response)
	      break
	    response = xhr.response;
	    self.push(new Buffer(new Uint8Array(response)));
	    break
	  case 'moz-chunked-arraybuffer': // take whole
	    response = xhr.response;
	    if (xhr.readyState !== rStates.LOADING || !response)
	      break
	    self.push(new Buffer(new Uint8Array(response)));
	    break
	  case 'ms-stream':
	    response = xhr.response;
	    if (xhr.readyState !== rStates.LOADING)
	      break
	    var reader = new global$1.MSStreamReader();
	    reader.onprogress = function() {
	      if (reader.result.byteLength > self._pos) {
	        self.push(new Buffer(new Uint8Array(reader.result.slice(self._pos))));
	        self._pos = reader.result.byteLength;
	      }
	    };
	    reader.onload = function() {
	      self.push(null);
	    };
	      // reader.onerror = ??? // TODO: this
	    reader.readAsArrayBuffer(response);
	    break
	  }

	  // The ms-stream case handles end separately in reader.onload()
	  if (self._xhr.readyState === rStates.DONE && self._mode !== 'ms-stream') {
	    self.push(null);
	  }
	};

	// from https://github.com/jhiesey/to-arraybuffer/blob/6502d9850e70ba7935a7df4ad86b358fc216f9f0/index.js
	function toArrayBuffer (buf) {
	  // If the buffer is backed by a Uint8Array, a faster version will work
	  if (buf instanceof Uint8Array) {
	    // If the buffer isn't a subarray, return the underlying ArrayBuffer
	    if (buf.byteOffset === 0 && buf.byteLength === buf.buffer.byteLength) {
	      return buf.buffer
	    } else if (typeof buf.buffer.slice === 'function') {
	      // Otherwise we need to get a proper copy
	      return buf.buffer.slice(buf.byteOffset, buf.byteOffset + buf.byteLength)
	    }
	  }

	  if (isBuffer$1(buf)) {
	    // This is the slow version that will work with any Buffer
	    // implementation (even in old browsers)
	    var arrayCopy = new Uint8Array(buf.length);
	    var len = buf.length;
	    for (var i = 0; i < len; i++) {
	      arrayCopy[i] = buf[i];
	    }
	    return arrayCopy.buffer
	  } else {
	    throw new Error('Argument must be a Buffer')
	  }
	}

	function decideMode(preferBinary, useFetch) {
	  if (hasFetch && useFetch) {
	    return 'fetch'
	  } else if (mozchunkedarraybuffer) {
	    return 'moz-chunked-arraybuffer'
	  } else if (msstream) {
	    return 'ms-stream'
	  } else if (arraybuffer && preferBinary) {
	    return 'arraybuffer'
	  } else if (vbArray && preferBinary) {
	    return 'text:vbarray'
	  } else {
	    return 'text'
	  }
	}

	function ClientRequest(opts) {
	  var self = this;
	  Writable.call(self);

	  self._opts = opts;
	  self._body = [];
	  self._headers = {};
	  if (opts.auth)
	    self.setHeader('Authorization', 'Basic ' + new Buffer(opts.auth).toString('base64'));
	  Object.keys(opts.headers).forEach(function(name) {
	    self.setHeader(name, opts.headers[name]);
	  });

	  var preferBinary;
	  var useFetch = true;
	  if (opts.mode === 'disable-fetch') {
	    // If the use of XHR should be preferred and includes preserving the 'content-type' header
	    useFetch = false;
	    preferBinary = true;
	  } else if (opts.mode === 'prefer-streaming') {
	    // If streaming is a high priority but binary compatibility and
	    // the accuracy of the 'content-type' header aren't
	    preferBinary = false;
	  } else if (opts.mode === 'allow-wrong-content-type') {
	    // If streaming is more important than preserving the 'content-type' header
	    preferBinary = !overrideMimeType;
	  } else if (!opts.mode || opts.mode === 'default' || opts.mode === 'prefer-fast') {
	    // Use binary if text streaming may corrupt data or the content-type header, or for speed
	    preferBinary = true;
	  } else {
	    throw new Error('Invalid value for opts.mode')
	  }
	  self._mode = decideMode(preferBinary, useFetch);

	  self.on('finish', function() {
	    self._onFinish();
	  });
	}

	inherits$1(ClientRequest, Writable);
	// Taken from http://www.w3.org/TR/XMLHttpRequest/#the-setrequestheader%28%29-method
	var unsafeHeaders = [
	  'accept-charset',
	  'accept-encoding',
	  'access-control-request-headers',
	  'access-control-request-method',
	  'connection',
	  'content-length',
	  'cookie',
	  'cookie2',
	  'date',
	  'dnt',
	  'expect',
	  'host',
	  'keep-alive',
	  'origin',
	  'referer',
	  'te',
	  'trailer',
	  'transfer-encoding',
	  'upgrade',
	  'user-agent',
	  'via'
	];
	ClientRequest.prototype.setHeader = function(name, value) {
	  var self = this;
	  var lowerName = name.toLowerCase();
	    // This check is not necessary, but it prevents warnings from browsers about setting unsafe
	    // headers. To be honest I'm not entirely sure hiding these warnings is a good thing, but
	    // http-browserify did it, so I will too.
	  if (unsafeHeaders.indexOf(lowerName) !== -1)
	    return

	  self._headers[lowerName] = {
	    name: name,
	    value: value
	  };
	};

	ClientRequest.prototype.getHeader = function(name) {
	  var self = this;
	  return self._headers[name.toLowerCase()].value
	};

	ClientRequest.prototype.removeHeader = function(name) {
	  var self = this;
	  delete self._headers[name.toLowerCase()];
	};

	ClientRequest.prototype._onFinish = function() {
	  var self = this;

	  if (self._destroyed)
	    return
	  var opts = self._opts;

	  var headersObj = self._headers;
	  var body;
	  if (opts.method === 'POST' || opts.method === 'PUT' || opts.method === 'PATCH') {
	    if (blobConstructor()) {
	      body = new global$1.Blob(self._body.map(function(buffer) {
	        return toArrayBuffer(buffer)
	      }), {
	        type: (headersObj['content-type'] || {}).value || ''
	      });
	    } else {
	      // get utf8 string
	      body = Buffer.concat(self._body).toString();
	    }
	  }

	  if (self._mode === 'fetch') {
	    var headers = Object.keys(headersObj).map(function(name) {
	      return [headersObj[name].name, headersObj[name].value]
	    });

	    global$1.fetch(self._opts.url, {
	      method: self._opts.method,
	      headers: headers,
	      body: body,
	      mode: 'cors',
	      credentials: opts.withCredentials ? 'include' : 'same-origin'
	    }).then(function(response) {
	      self._fetchResponse = response;
	      self._connect();
	    }, function(reason) {
	      self.emit('error', reason);
	    });
	  } else {
	    var xhr = self._xhr = new global$1.XMLHttpRequest();
	    try {
	      xhr.open(self._opts.method, self._opts.url, true);
	    } catch (err) {
	      browser$1.nextTick(function() {
	        self.emit('error', err);
	      });
	      return
	    }

	    // Can't set responseType on really old browsers
	    if ('responseType' in xhr)
	      xhr.responseType = self._mode.split(':')[0];

	    if ('withCredentials' in xhr)
	      xhr.withCredentials = !!opts.withCredentials;

	    if (self._mode === 'text' && 'overrideMimeType' in xhr)
	      xhr.overrideMimeType('text/plain; charset=x-user-defined');

	    Object.keys(headersObj).forEach(function(name) {
	      xhr.setRequestHeader(headersObj[name].name, headersObj[name].value);
	    });

	    self._response = null;
	    xhr.onreadystatechange = function() {
	      switch (xhr.readyState) {
	      case rStates.LOADING:
	      case rStates.DONE:
	        self._onXHRProgress();
	        break
	      }
	    };
	      // Necessary for streaming in Firefox, since xhr.response is ONLY defined
	      // in onprogress, not in onreadystatechange with xhr.readyState = 3
	    if (self._mode === 'moz-chunked-arraybuffer') {
	      xhr.onprogress = function() {
	        self._onXHRProgress();
	      };
	    }

	    xhr.onerror = function() {
	      if (self._destroyed)
	        return
	      self.emit('error', new Error('XHR error'));
	    };

	    try {
	      xhr.send(body);
	    } catch (err) {
	      browser$1.nextTick(function() {
	        self.emit('error', err);
	      });
	      return
	    }
	  }
	};

	/**
	 * Checks if xhr.status is readable and non-zero, indicating no error.
	 * Even though the spec says it should be available in readyState 3,
	 * accessing it throws an exception in IE8
	 */
	function statusValid(xhr) {
	  try {
	    var status = xhr.status;
	    return (status !== null && status !== 0)
	  } catch (e) {
	    return false
	  }
	}

	ClientRequest.prototype._onXHRProgress = function() {
	  var self = this;

	  if (!statusValid(self._xhr) || self._destroyed)
	    return

	  if (!self._response)
	    self._connect();

	  self._response._onXHRProgress();
	};

	ClientRequest.prototype._connect = function() {
	  var self = this;

	  if (self._destroyed)
	    return

	  self._response = new IncomingMessage(self._xhr, self._fetchResponse, self._mode);
	  self.emit('response', self._response);
	};

	ClientRequest.prototype._write = function(chunk, encoding, cb) {
	  var self = this;

	  self._body.push(chunk);
	  cb();
	};

	ClientRequest.prototype.abort = ClientRequest.prototype.destroy = function() {
	  var self = this;
	  self._destroyed = true;
	  if (self._response)
	    self._response._destroyed = true;
	  if (self._xhr)
	    self._xhr.abort();
	    // Currently, there isn't a way to truly abort a fetch.
	    // If you like bikeshedding, see https://github.com/whatwg/fetch/issues/27
	};

	ClientRequest.prototype.end = function(data, encoding, cb) {
	  var self = this;
	  if (typeof data === 'function') {
	    cb = data;
	    data = undefined;
	  }

	  Writable.prototype.end.call(self, data, encoding, cb);
	};

	ClientRequest.prototype.flushHeaders = function() {};
	ClientRequest.prototype.setTimeout = function() {};
	ClientRequest.prototype.setNoDelay = function() {};
	ClientRequest.prototype.setSocketKeepAlive = function() {};

	function request$1(opts, cb) {
	  if (typeof opts === 'string')
	    opts = urlParse(opts);


	  // Normally, the page is loaded from http or https, so not specifying a protocol
	  // will result in a (valid) protocol-relative url. However, this won't work if
	  // the protocol is something else, like 'file:'
	  var defaultProtocol = global$1.location.protocol.search(/^https?:$/) === -1 ? 'http:' : '';

	  var protocol = opts.protocol || defaultProtocol;
	  var host = opts.hostname || opts.host;
	  var port = opts.port;
	  var path = opts.path || '/';

	  // Necessary for IPv6 addresses
	  if (host && host.indexOf(':') !== -1)
	    host = '[' + host + ']';

	  // This may be a relative url. The browser should always be able to interpret it correctly.
	  opts.url = (host ? (protocol + '//' + host) : '') + (port ? ':' + port : '') + path;
	  opts.method = (opts.method || 'GET').toUpperCase();
	  opts.headers = opts.headers || {};

	  // Also valid opts.auth, opts.mode

	  var req = new ClientRequest(opts);
	  if (cb)
	    req.on('response', cb);
	  return req
	}

	function get$3(opts, cb) {
	  var req = request$1(opts, cb);
	  req.end();
	  return req
	}

	function Agent$1() {}
	Agent$1.defaultMaxSockets = 4;

	var METHODS$1 = [
	  'CHECKOUT',
	  'CONNECT',
	  'COPY',
	  'DELETE',
	  'GET',
	  'HEAD',
	  'LOCK',
	  'M-SEARCH',
	  'MERGE',
	  'MKACTIVITY',
	  'MKCOL',
	  'MOVE',
	  'NOTIFY',
	  'OPTIONS',
	  'PATCH',
	  'POST',
	  'PROPFIND',
	  'PROPPATCH',
	  'PURGE',
	  'PUT',
	  'REPORT',
	  'SEARCH',
	  'SUBSCRIBE',
	  'TRACE',
	  'UNLOCK',
	  'UNSUBSCRIBE'
	];
	var STATUS_CODES$1 = {
	  100: 'Continue',
	  101: 'Switching Protocols',
	  102: 'Processing', // RFC 2518, obsoleted by RFC 4918
	  200: 'OK',
	  201: 'Created',
	  202: 'Accepted',
	  203: 'Non-Authoritative Information',
	  204: 'No Content',
	  205: 'Reset Content',
	  206: 'Partial Content',
	  207: 'Multi-Status', // RFC 4918
	  300: 'Multiple Choices',
	  301: 'Moved Permanently',
	  302: 'Moved Temporarily',
	  303: 'See Other',
	  304: 'Not Modified',
	  305: 'Use Proxy',
	  307: 'Temporary Redirect',
	  400: 'Bad Request',
	  401: 'Unauthorized',
	  402: 'Payment Required',
	  403: 'Forbidden',
	  404: 'Not Found',
	  405: 'Method Not Allowed',
	  406: 'Not Acceptable',
	  407: 'Proxy Authentication Required',
	  408: 'Request Time-out',
	  409: 'Conflict',
	  410: 'Gone',
	  411: 'Length Required',
	  412: 'Precondition Failed',
	  413: 'Request Entity Too Large',
	  414: 'Request-URI Too Large',
	  415: 'Unsupported Media Type',
	  416: 'Requested Range Not Satisfiable',
	  417: 'Expectation Failed',
	  418: 'I\'m a teapot', // RFC 2324
	  422: 'Unprocessable Entity', // RFC 4918
	  423: 'Locked', // RFC 4918
	  424: 'Failed Dependency', // RFC 4918
	  425: 'Unordered Collection', // RFC 4918
	  426: 'Upgrade Required', // RFC 2817
	  428: 'Precondition Required', // RFC 6585
	  429: 'Too Many Requests', // RFC 6585
	  431: 'Request Header Fields Too Large', // RFC 6585
	  500: 'Internal Server Error',
	  501: 'Not Implemented',
	  502: 'Bad Gateway',
	  503: 'Service Unavailable',
	  504: 'Gateway Time-out',
	  505: 'HTTP Version Not Supported',
	  506: 'Variant Also Negotiates', // RFC 2295
	  507: 'Insufficient Storage', // RFC 4918
	  509: 'Bandwidth Limit Exceeded',
	  510: 'Not Extended', // RFC 2774
	  511: 'Network Authentication Required' // RFC 6585
	};

	var _polyfillNode_http = {
	  request: request$1,
	  get: get$3,
	  Agent: Agent$1,
	  METHODS: METHODS$1,
	  STATUS_CODES: STATUS_CODES$1
	};

	var _polyfillNode_http$1 = /*#__PURE__*/Object.freeze({
		__proto__: null,
		request: request$1,
		get: get$3,
		Agent: Agent$1,
		METHODS: METHODS$1,
		STATUS_CODES: STATUS_CODES$1,
		'default': _polyfillNode_http
	});

	var require$$0 = /*@__PURE__*/getAugmentedNamespace(_polyfillNode_http$1);

	function request(opts, cb) {
	  if (typeof opts === 'string')
	    opts = urlParse(opts);


	  // Normally, the page is loaded from http or https, so not specifying a protocol
	  // will result in a (valid) protocol-relative url. However, this won't work if
	  // the protocol is something else, like 'file:'
	  var defaultProtocol = global$1.location.protocol.search(/^https?:$/) === -1 ? 'http:' : '';

	  var protocol = opts.protocol || defaultProtocol;
	  var host = opts.hostname || opts.host;
	  var port = opts.port;
	  var path = opts.path || '/';

	  // Necessary for IPv6 addresses
	  if (host && host.indexOf(':') !== -1)
	    host = '[' + host + ']';

	  // This may be a relative url. The browser should always be able to interpret it correctly.
	  opts.url = (host ? (protocol + '//' + host) : '') + (port ? ':' + port : '') + path;
	  opts.method = (opts.method || 'GET').toUpperCase();
	  opts.headers = opts.headers || {};

	  // Also valid opts.auth, opts.mode

	  var req = new ClientRequest(opts);
	  if (cb)
	    req.on('response', cb);
	  return req
	}

	function get$2(opts, cb) {
	  var req = request(opts, cb);
	  req.end();
	  return req
	}

	function Agent() {}
	Agent.defaultMaxSockets = 4;

	var METHODS = [
	  'CHECKOUT',
	  'CONNECT',
	  'COPY',
	  'DELETE',
	  'GET',
	  'HEAD',
	  'LOCK',
	  'M-SEARCH',
	  'MERGE',
	  'MKACTIVITY',
	  'MKCOL',
	  'MOVE',
	  'NOTIFY',
	  'OPTIONS',
	  'PATCH',
	  'POST',
	  'PROPFIND',
	  'PROPPATCH',
	  'PURGE',
	  'PUT',
	  'REPORT',
	  'SEARCH',
	  'SUBSCRIBE',
	  'TRACE',
	  'UNLOCK',
	  'UNSUBSCRIBE'
	];
	var STATUS_CODES = {
	  100: 'Continue',
	  101: 'Switching Protocols',
	  102: 'Processing', // RFC 2518, obsoleted by RFC 4918
	  200: 'OK',
	  201: 'Created',
	  202: 'Accepted',
	  203: 'Non-Authoritative Information',
	  204: 'No Content',
	  205: 'Reset Content',
	  206: 'Partial Content',
	  207: 'Multi-Status', // RFC 4918
	  300: 'Multiple Choices',
	  301: 'Moved Permanently',
	  302: 'Moved Temporarily',
	  303: 'See Other',
	  304: 'Not Modified',
	  305: 'Use Proxy',
	  307: 'Temporary Redirect',
	  400: 'Bad Request',
	  401: 'Unauthorized',
	  402: 'Payment Required',
	  403: 'Forbidden',
	  404: 'Not Found',
	  405: 'Method Not Allowed',
	  406: 'Not Acceptable',
	  407: 'Proxy Authentication Required',
	  408: 'Request Time-out',
	  409: 'Conflict',
	  410: 'Gone',
	  411: 'Length Required',
	  412: 'Precondition Failed',
	  413: 'Request Entity Too Large',
	  414: 'Request-URI Too Large',
	  415: 'Unsupported Media Type',
	  416: 'Requested Range Not Satisfiable',
	  417: 'Expectation Failed',
	  418: 'I\'m a teapot', // RFC 2324
	  422: 'Unprocessable Entity', // RFC 4918
	  423: 'Locked', // RFC 4918
	  424: 'Failed Dependency', // RFC 4918
	  425: 'Unordered Collection', // RFC 4918
	  426: 'Upgrade Required', // RFC 2817
	  428: 'Precondition Required', // RFC 6585
	  429: 'Too Many Requests', // RFC 6585
	  431: 'Request Header Fields Too Large', // RFC 6585
	  500: 'Internal Server Error',
	  501: 'Not Implemented',
	  502: 'Bad Gateway',
	  503: 'Service Unavailable',
	  504: 'Gateway Time-out',
	  505: 'HTTP Version Not Supported',
	  506: 'Variant Also Negotiates', // RFC 2295
	  507: 'Insufficient Storage', // RFC 4918
	  509: 'Bandwidth Limit Exceeded',
	  510: 'Not Extended', // RFC 2774
	  511: 'Network Authentication Required' // RFC 6585
	};

	var _polyfillNode_https = {
	  request,
	  get: get$2,
	  Agent,
	  METHODS,
	  STATUS_CODES
	};

	var _polyfillNode_https$1 = /*#__PURE__*/Object.freeze({
		__proto__: null,
		request: request,
		get: get$2,
		Agent: Agent,
		METHODS: METHODS,
		STATUS_CODES: STATUS_CODES,
		'default': _polyfillNode_https
	});

	var require$$1 = /*@__PURE__*/getAugmentedNamespace(_polyfillNode_https$1);

	const http = require$$0;
	const https = require$$1;
	const { ono: ono$5 } = require$$6;
	const url$6 = urlExports;
	const { ResolverError: ResolverError$2 } = errors$1;

	var http_1 = {
	  /**
	   * The order that this resolver will run, in relation to other resolvers.
	   *
	   * @type {number}
	   */
	  order: 200,

	  /**
	   * HTTP headers to send when downloading files.
	   *
	   * @example:
	   * {
	   *   "User-Agent": "JSON Schema $Ref Parser",
	   *   Accept: "application/json"
	   * }
	   *
	   * @type {object}
	   */
	  headers: null,

	  /**
	   * HTTP request timeout (in milliseconds).
	   *
	   * @type {number}
	   */
	  timeout: 5000, // 5 seconds

	  /**
	   * The maximum number of HTTP redirects to follow.
	   * To disable automatic following of redirects, set this to zero.
	   *
	   * @type {number}
	   */
	  redirects: 5,

	  /**
	   * The `withCredentials` option of XMLHttpRequest.
	   * Set this to `true` if you're downloading files from a CORS-enabled server that requires authentication
	   *
	   * @type {boolean}
	   */
	  withCredentials: false,

	  /**
	   * Determines whether this resolver can read a given file reference.
	   * Resolvers that return true will be tried in order, until one successfully resolves the file.
	   * Resolvers that return false will not be given a chance to resolve the file.
	   *
	   * @param {object} file           - An object containing information about the referenced file
	   * @param {string} file.url       - The full URL of the referenced file
	   * @param {string} file.extension - The lowercased file extension (e.g. ".txt", ".html", etc.)
	   * @returns {boolean}
	   */
	  canRead (file) {
	    return url$6.isHttp(file.url);
	  },

	  /**
	   * Reads the given URL and returns its raw contents as a Buffer.
	   *
	   * @param {object} file           - An object containing information about the referenced file
	   * @param {string} file.url       - The full URL of the referenced file
	   * @param {string} file.extension - The lowercased file extension (e.g. ".txt", ".html", etc.)
	   * @returns {Promise<Buffer>}
	   */
	  read (file) {
	    let u = url$6.parse(file.url);

	    if (!u.protocol) {
	      // Use the protocol of the current page
	      u.protocol = url$6.parse(location.href).protocol;
	    }

	    return download(u, this);
	  }
	};

	/**
	 * Downloads the given file.
	 *
	 * @param {Url|string} u        - The url to download (can be a parsed {@link Url} object)
	 * @param {object} httpOptions  - The `options.resolve.http` object
	 * @param {number} [redirects]  - The redirect URLs that have already been followed
	 *
	 * @returns {Promise<Buffer>}
	 * The promise resolves with the raw downloaded data, or rejects if there is an HTTP error.
	 */
	function download (u, httpOptions, redirects) {
	  return new Promise(((resolve, reject) => {
	    u = url$6.parse(u);
	    redirects = redirects || [];
	    redirects.push(u.href);

	    get$1(u, httpOptions)
	      .then((res) => {
	        if (res.statusCode >= 400) {
	          throw ono$5({ status: res.statusCode }, `HTTP ERROR ${res.statusCode}`);
	        }
	        else if (res.statusCode >= 300) {
	          if (redirects.length > httpOptions.redirects) {
	            reject(new ResolverError$2(ono$5({ status: res.statusCode },
	              `Error downloading ${redirects[0]}. \nToo many redirects: \n  ${redirects.join(" \n  ")}`)));
	          }
	          else if (!res.headers.location) {
	            throw ono$5({ status: res.statusCode }, `HTTP ${res.statusCode} redirect with no location header`);
	          }
	          else {
	            // console.log('HTTP %d redirect %s -> %s', res.statusCode, u.href, res.headers.location);
	            let redirectTo = url$6.resolve(u, res.headers.location);
	            download(redirectTo, httpOptions, redirects).then(resolve, reject);
	          }
	        }
	        else {
	          resolve(res.body || Buffer.alloc(0));
	        }
	      })
	      .catch((err) => {
	        reject(new ResolverError$2(ono$5(err, `Error downloading ${u.href}`), u.href));
	      });
	  }));
	}

	/**
	 * Sends an HTTP GET request.
	 *
	 * @param {Url} u - A parsed {@link Url} object
	 * @param {object} httpOptions - The `options.resolve.http` object
	 *
	 * @returns {Promise<Response>}
	 * The promise resolves with the HTTP Response object.
	 */
	function get$1 (u, httpOptions) {
	  return new Promise(((resolve, reject) => {
	    // console.log('GET', u.href);

	    let protocol = u.protocol === "https:" ? https : http;
	    let req = protocol.get({
	      hostname: u.hostname,
	      port: u.port,
	      path: u.path,
	      auth: u.auth,
	      protocol: u.protocol,
	      headers: httpOptions.headers || {},
	      withCredentials: httpOptions.withCredentials
	    });

	    if (typeof req.setTimeout === "function") {
	      req.setTimeout(httpOptions.timeout);
	    }

	    req.on("timeout", () => {
	      req.abort();
	    });

	    req.on("error", reject);

	    req.once("response", (res) => {
	      res.body = Buffer.alloc(0);

	      res.on("data", (data) => {
	        res.body = Buffer.concat([res.body, Buffer.from(data)]);
	      });

	      res.on("error", reject);

	      res.on("end", () => {
	        resolve(res);
	      });
	    });
	  }));
	}

	/* eslint lines-around-comment: [2, {beforeBlockComment: false}] */

	const jsonParser = json$2;
	const yamlParser = yaml_1;
	const textParser = text;
	const binaryParser = binary;
	const fileResolver = file;
	const httpResolver = http_1;

	var options$1 = $RefParserOptions$1;

	/**
	 * Options that determine how JSON schemas are parsed, resolved, and dereferenced.
	 *
	 * @param {object|$RefParserOptions} [options] - Overridden options
	 * @constructor
	 */
	function $RefParserOptions$1 (options) {
	  merge(this, $RefParserOptions$1.defaults);
	  merge(this, options);
	}

	$RefParserOptions$1.defaults = {
	  /**
	   * Determines how different types of files will be parsed.
	   *
	   * You can add additional parsers of your own, replace an existing one with
	   * your own implementation, or disable any parser by setting it to false.
	   */
	  parse: {
	    json: jsonParser,
	    yaml: yamlParser,
	    text: textParser,
	    binary: binaryParser,
	  },

	  /**
	   * Determines how JSON References will be resolved.
	   *
	   * You can add additional resolvers of your own, replace an existing one with
	   * your own implementation, or disable any resolver by setting it to false.
	   */
	  resolve: {
	    file: fileResolver,
	    http: httpResolver,

	    /**
	     * Determines whether external $ref pointers will be resolved.
	     * If this option is disabled, then none of above resolvers will be called.
	     * Instead, external $ref pointers will simply be ignored.
	     *
	     * @type {boolean}
	     */
	    external: true,
	  },

	  /**
	   * By default, JSON Schema $Ref Parser throws the first error it encounters. Setting `continueOnError` to `true`
	   * causes it to keep processing as much as possible and then throw a single error that contains all errors
	   * that were encountered.
	  */
	  continueOnError: false,

	  /**
	   * Determines the types of JSON references that are allowed.
	   */
	  dereference: {
	    /**
	     * Dereference circular (recursive) JSON references?
	     * If false, then a {@link ReferenceError} will be thrown if a circular reference is found.
	     * If "ignore", then circular references will not be dereferenced.
	     *
	     * @type {boolean|string}
	     */
	    circular: true,

	    /**
	     * A function, called for each path, which can return true to stop this path and all
	     * subpaths from being dereferenced further. This is useful in schemas where some
	     * subpaths contain literal $ref keys that should not be dereferenced.
	     *
	     * @type {function}
	     */
	    excludedPathMatcher: () => false
	  },
	};

	/**
	 * Merges the properties of the source object into the target object.
	 *
	 * @param {object} target - The object that we're populating
	 * @param {?object} source - The options that are being merged
	 * @returns {object}
	 */
	function merge (target, source) {
	  if (isMergeable(source)) {
	    let keys = Object.keys(source);
	    for (let i = 0; i < keys.length; i++) {
	      let key = keys[i];
	      let sourceSetting = source[key];
	      let targetSetting = target[key];

	      if (isMergeable(sourceSetting)) {
	        // It's a nested object, so merge it recursively
	        target[key] = merge(targetSetting || {}, sourceSetting);
	      }
	      else if (sourceSetting !== undefined) {
	        // It's a scalar value, function, or array. No merging necessary. Just overwrite the target value.
	        target[key] = sourceSetting;
	      }
	    }
	  }
	  return target;
	}

	/**
	 * Determines whether the given value can be merged,
	 * or if it is a scalar value that should just override the target value.
	 *
	 * @param   {*}  val
	 * @returns {Boolean}
	 */
	function isMergeable (val) {
	  return val &&
	    (typeof val === "object") &&
	    !Array.isArray(val) &&
	    !(val instanceof RegExp) &&
	    !(val instanceof Date);
	}

	const Options$1 = options$1;

	var normalizeArgs_1 = normalizeArgs$2;

	/**
	 * Normalizes the given arguments, accounting for optional args.
	 *
	 * @param {Arguments} args
	 * @returns {object}
	 */
	function normalizeArgs$2 (args) {
	  let path, schema, options, callback;
	  args = Array.prototype.slice.call(args);

	  if (typeof args[args.length - 1] === "function") {
	    // The last parameter is a callback function
	    callback = args.pop();
	  }

	  if (typeof args[0] === "string") {
	    // The first parameter is the path
	    path = args[0];
	    if (typeof args[2] === "object") {
	      // The second parameter is the schema, and the third parameter is the options
	      schema = args[1];
	      options = args[2];
	    }
	    else {
	      // The second parameter is the options
	      schema = undefined;
	      options = args[1];
	    }
	  }
	  else {
	    // The first parameter is the schema
	    path = "";
	    schema = args[0];
	    options = args[1];
	  }

	  if (!(options instanceof Options$1)) {
	    options = new Options$1(options);
	  }

	  return {
	    path,
	    schema,
	    options,
	    callback
	  };
	}

	const $RefParserOptions = options$1;
	const schemaValidator = schema$1;
	const specValidator = spec;
	const util$1 = require$$3$1;

	var options = ParserOptions;

	/**
	 * Options that determine how Swagger APIs are parsed, resolved, dereferenced, and validated.
	 *
	 * @param {object|ParserOptions} [_options] - Overridden options
	 * @class
	 * @augments $RefParserOptions
	 */
	function ParserOptions (_options) {
	  $RefParserOptions.call(this, ParserOptions.defaults);
	  $RefParserOptions.apply(this, arguments);
	}

	ParserOptions.defaults = {
	  /**
	   * Determines how the API definition will be validated.
	   *
	   * You can add additional validators of your own, replace an existing one with
	   * your own implemenation, or disable any validator by setting it to false.
	   */
	  validate: {
	    schema: schemaValidator,
	    spec: specValidator,
	  },
	};

	util$1.inherits(ParserOptions, $RefParserOptions);

	function makeNext () {
	  if (typeof browser$1 === 'object' && typeof browser$1.nextTick === 'function') {
	    return browser$1.nextTick
	  } else if (typeof setImmediate === 'function') {
	    return setImmediate
	  } else {
	    return function next (f) {
	      setTimeout(f, 0);
	    }
	  }
	}

	var next$1 = makeNext();

	var next = next$1;

	var maybe$2 = function maybe (cb, promise) {
	  if (cb) {
	    promise
	      .then(function (result) {
	        next(function () { cb(null, result); });
	      }, function (err) {
	        next(function () { cb(err); });
	      });
	    return undefined
	  }
	  else {
	    return promise
	  }
	};

	var libExports = {};
	var lib$1 = {
	  get exports(){ return libExports; },
	  set exports(v){ libExports = v; },
	};

	var pointer;
	var hasRequiredPointer;

	function requirePointer () {
		if (hasRequiredPointer) return pointer;
		hasRequiredPointer = 1;

		pointer = Pointer;

		const $Ref = requireRef();
		const url = urlExports;
		const { JSONParserError, InvalidPointerError, MissingPointerError, isHandledError } = errors$1;
		const slashes = /\//g;
		const tildes = /~/g;
		const escapedSlash = /~1/g;
		const escapedTilde = /~0/g;

		/**
		 * This class represents a single JSON pointer and its resolved value.
		 *
		 * @param {$Ref} $ref
		 * @param {string} path
		 * @param {string} [friendlyPath] - The original user-specified path (used for error messages)
		 * @constructor
		 */
		function Pointer ($ref, path, friendlyPath) {
		  /**
		   * The {@link $Ref} object that contains this {@link Pointer} object.
		   * @type {$Ref}
		   */
		  this.$ref = $ref;

		  /**
		   * The file path or URL, containing the JSON pointer in the hash.
		   * This path is relative to the path of the main JSON schema file.
		   * @type {string}
		   */
		  this.path = path;

		  /**
		   * The original path or URL, used for error messages.
		   * @type {string}
		   */
		  this.originalPath = friendlyPath || path;

		  /**
		   * The value of the JSON pointer.
		   * Can be any JSON type, not just objects. Unknown file types are represented as Buffers (byte arrays).
		   * @type {?*}
		   */
		  this.value = undefined;

		  /**
		   * Indicates whether the pointer references itself.
		   * @type {boolean}
		   */
		  this.circular = false;

		  /**
		   * The number of indirect references that were traversed to resolve the value.
		   * Resolving a single pointer may require resolving multiple $Refs.
		   * @type {number}
		   */
		  this.indirections = 0;
		}

		/**
		 * Resolves the value of a nested property within the given object.
		 *
		 * @param {*} obj - The object that will be crawled
		 * @param {$RefParserOptions} options
		 * @param {string} pathFromRoot - the path of place that initiated resolving
		 *
		 * @returns {Pointer}
		 * Returns a JSON pointer whose {@link Pointer#value} is the resolved value.
		 * If resolving this value required resolving other JSON references, then
		 * the {@link Pointer#$ref} and {@link Pointer#path} will reflect the resolution path
		 * of the resolved value.
		 */
		Pointer.prototype.resolve = function (obj, options, pathFromRoot) {
		  let tokens = Pointer.parse(this.path, this.originalPath);

		  // Crawl the object, one token at a time
		  this.value = unwrapOrThrow(obj);

		  for (let i = 0; i < tokens.length; i++) {
		    if (resolveIf$Ref(this, options)) {
		      // The $ref path has changed, so append the remaining tokens to the path
		      this.path = Pointer.join(this.path, tokens.slice(i));
		    }

		    if (typeof this.value === "object" && this.value !== null && "$ref" in this.value) {
		      return this;
		    }

		    let token = tokens[i];
		    if (this.value[token] === undefined || this.value[token] === null) {
		      this.value = null;
		      throw new MissingPointerError(token, decodeURI(this.originalPath));
		    }
		    else {
		      this.value = this.value[token];
		    }
		  }

		  // Resolve the final value
		  if (!this.value || this.value.$ref && url.resolve(this.path, this.value.$ref) !== pathFromRoot) {
		    resolveIf$Ref(this, options);
		  }

		  return this;
		};

		/**
		 * Sets the value of a nested property within the given object.
		 *
		 * @param {*} obj - The object that will be crawled
		 * @param {*} value - the value to assign
		 * @param {$RefParserOptions} options
		 *
		 * @returns {*}
		 * Returns the modified object, or an entirely new object if the entire object is overwritten.
		 */
		Pointer.prototype.set = function (obj, value, options) {
		  let tokens = Pointer.parse(this.path);
		  let token;

		  if (tokens.length === 0) {
		    // There are no tokens, replace the entire object with the new value
		    this.value = value;
		    return value;
		  }

		  // Crawl the object, one token at a time
		  this.value = unwrapOrThrow(obj);

		  for (let i = 0; i < tokens.length - 1; i++) {
		    resolveIf$Ref(this, options);

		    token = tokens[i];
		    if (this.value && this.value[token] !== undefined) {
		      // The token exists
		      this.value = this.value[token];
		    }
		    else {
		      // The token doesn't exist, so create it
		      this.value = setValue(this, token, {});
		    }
		  }

		  // Set the value of the final token
		  resolveIf$Ref(this, options);
		  token = tokens[tokens.length - 1];
		  setValue(this, token, value);

		  // Return the updated object
		  return obj;
		};

		/**
		 * Parses a JSON pointer (or a path containing a JSON pointer in the hash)
		 * and returns an array of the pointer's tokens.
		 * (e.g. "schema.json#/definitions/person/name" => ["definitions", "person", "name"])
		 *
		 * The pointer is parsed according to RFC 6901
		 * {@link https://tools.ietf.org/html/rfc6901#section-3}
		 *
		 * @param {string} path
		 * @param {string} [originalPath]
		 * @returns {string[]}
		 */
		Pointer.parse = function (path, originalPath) {
		  // Get the JSON pointer from the path's hash
		  let pointer = url.getHash(path).substr(1);

		  // If there's no pointer, then there are no tokens,
		  // so return an empty array
		  if (!pointer) {
		    return [];
		  }

		  // Split into an array
		  pointer = pointer.split("/");

		  // Decode each part, according to RFC 6901
		  for (let i = 0; i < pointer.length; i++) {
		    pointer[i] = decodeURIComponent(pointer[i].replace(escapedSlash, "/").replace(escapedTilde, "~"));
		  }

		  if (pointer[0] !== "") {
		    throw new InvalidPointerError(pointer, originalPath === undefined ? path : originalPath);
		  }

		  return pointer.slice(1);
		};

		/**
		 * Creates a JSON pointer path, by joining one or more tokens to a base path.
		 *
		 * @param {string} base - The base path (e.g. "schema.json#/definitions/person")
		 * @param {string|string[]} tokens - The token(s) to append (e.g. ["name", "first"])
		 * @returns {string}
		 */
		Pointer.join = function (base, tokens) {
		  // Ensure that the base path contains a hash
		  if (base.indexOf("#") === -1) {
		    base += "#";
		  }

		  // Append each token to the base path
		  tokens = Array.isArray(tokens) ? tokens : [tokens];
		  for (let i = 0; i < tokens.length; i++) {
		    let token = tokens[i];
		    // Encode the token, according to RFC 6901
		    base += "/" + encodeURIComponent(token.replace(tildes, "~0").replace(slashes, "~1"));
		  }

		  return base;
		};

		/**
		 * If the given pointer's {@link Pointer#value} is a JSON reference,
		 * then the reference is resolved and {@link Pointer#value} is replaced with the resolved value.
		 * In addition, {@link Pointer#path} and {@link Pointer#$ref} are updated to reflect the
		 * resolution path of the new value.
		 *
		 * @param {Pointer} pointer
		 * @param {$RefParserOptions} options
		 * @returns {boolean} - Returns `true` if the resolution path changed
		 */
		function resolveIf$Ref (pointer, options) {
		  // Is the value a JSON reference? (and allowed?)

		  if ($Ref.isAllowed$Ref(pointer.value, options)) {
		    let $refPath = url.resolve(pointer.path, pointer.value.$ref);

		    if ($refPath === pointer.path) {
		      // The value is a reference to itself, so there's nothing to do.
		      pointer.circular = true;
		    }
		    else {
		      let resolved = pointer.$ref.$refs._resolve($refPath, pointer.path, options);
		      if (resolved === null) {
		        return false;
		      }

		      pointer.indirections += resolved.indirections + 1;

		      if ($Ref.isExtended$Ref(pointer.value)) {
		        // This JSON reference "extends" the resolved value, rather than simply pointing to it.
		        // So the resolved path does NOT change.  Just the value does.
		        pointer.value = $Ref.dereference(pointer.value, resolved.value);
		        return false;
		      }
		      else {
		        // Resolve the reference
		        pointer.$ref = resolved.$ref;
		        pointer.path = resolved.path;
		        pointer.value = resolved.value;
		      }

		      return true;
		    }
		  }
		}

		/**
		 * Sets the specified token value of the {@link Pointer#value}.
		 *
		 * The token is evaluated according to RFC 6901.
		 * {@link https://tools.ietf.org/html/rfc6901#section-4}
		 *
		 * @param {Pointer} pointer - The JSON Pointer whose value will be modified
		 * @param {string} token - A JSON Pointer token that indicates how to modify `obj`
		 * @param {*} value - The value to assign
		 * @returns {*} - Returns the assigned value
		 */
		function setValue (pointer, token, value) {
		  if (pointer.value && typeof pointer.value === "object") {
		    if (token === "-" && Array.isArray(pointer.value)) {
		      pointer.value.push(value);
		    }
		    else {
		      pointer.value[token] = value;
		    }
		  }
		  else {
		    throw new JSONParserError(`Error assigning $ref pointer "${pointer.path}". \nCannot set "${token}" of a non-object.`);
		  }
		  return value;
		}


		function unwrapOrThrow (value) {
		  if (isHandledError(value)) {
		    throw value;
		  }

		  return value;
		}
		return pointer;
	}

	var ref;
	var hasRequiredRef;

	function requireRef () {
		if (hasRequiredRef) return ref;
		hasRequiredRef = 1;

		ref = $Ref;

		const Pointer = requirePointer();
		const { InvalidPointerError, isHandledError, normalizeError } = errors$1;
		const { safePointerToPath, stripHash, getHash } = urlExports;

		/**
		 * This class represents a single JSON reference and its resolved value.
		 *
		 * @class
		 */
		function $Ref () {
		  /**
		   * The file path or URL of the referenced file.
		   * This path is relative to the path of the main JSON schema file.
		   *
		   * This path does NOT contain document fragments (JSON pointers). It always references an ENTIRE file.
		   * Use methods such as {@link $Ref#get}, {@link $Ref#resolve}, and {@link $Ref#exists} to get
		   * specific JSON pointers within the file.
		   *
		   * @type {string}
		   */
		  this.path = undefined;

		  /**
		   * The resolved value of the JSON reference.
		   * Can be any JSON type, not just objects. Unknown file types are represented as Buffers (byte arrays).
		   *
		   * @type {?*}
		   */
		  this.value = undefined;

		  /**
		   * The {@link $Refs} object that contains this {@link $Ref} object.
		   *
		   * @type {$Refs}
		   */
		  this.$refs = undefined;

		  /**
		   * Indicates the type of {@link $Ref#path} (e.g. "file", "http", etc.)
		   *
		   * @type {?string}
		   */
		  this.pathType = undefined;

		  /**
		   * List of all errors. Undefined if no errors.
		   *
		   * @type {Array<JSONParserError | ResolverError | ParserError | MissingPointerError>}
		   */
		  this.errors = undefined;
		}

		/**
		 * Pushes an error to errors array.
		 *
		 * @param {Array<JSONParserError | JSONParserErrorGroup>} err - The error to be pushed
		 * @returns {void}
		 */
		$Ref.prototype.addError = function (err) {
		  if (this.errors === undefined) {
		    this.errors = [];
		  }

		  const existingErrors = this.errors.map(({ footprint }) => footprint);

		  // the path has been almost certainly set at this point,
		  // but just in case something went wrong, normalizeError injects path if necessary
		  // moreover, certain errors might point at the same spot, so filter them out to reduce noise
		  if (Array.isArray(err.errors)) {
		    this.errors.push(...err.errors
		      .map(normalizeError)
		      .filter(({ footprint }) => !existingErrors.includes(footprint)),
		    );
		  }
		  else if (!existingErrors.includes(err.footprint)) {
		    this.errors.push(normalizeError(err));
		  }
		};

		/**
		 * Determines whether the given JSON reference exists within this {@link $Ref#value}.
		 *
		 * @param {string} path - The full path being resolved, optionally with a JSON pointer in the hash
		 * @param {$RefParserOptions} options
		 * @returns {boolean}
		 */
		$Ref.prototype.exists = function (path, options) {
		  try {
		    this.resolve(path, options);
		    return true;
		  }
		  catch (e) {
		    return false;
		  }
		};

		/**
		 * Resolves the given JSON reference within this {@link $Ref#value} and returns the resolved value.
		 *
		 * @param {string} path - The full path being resolved, optionally with a JSON pointer in the hash
		 * @param {$RefParserOptions} options
		 * @returns {*} - Returns the resolved value
		 */
		$Ref.prototype.get = function (path, options) {
		  return this.resolve(path, options).value;
		};

		/**
		 * Resolves the given JSON reference within this {@link $Ref#value}.
		 *
		 * @param {string} path - The full path being resolved, optionally with a JSON pointer in the hash
		 * @param {$RefParserOptions} options
		 * @param {string} friendlyPath - The original user-specified path (used for error messages)
		 *  @param {string} pathFromRoot - The path of `obj` from the schema root
		 * @returns {Pointer | null}
		 */
		$Ref.prototype.resolve = function (path, options, friendlyPath, pathFromRoot) {
		  let pointer = new Pointer(this, path, friendlyPath);
		  try {
		    return pointer.resolve(this.value, options, pathFromRoot);
		  }
		  catch (err) {
		    if (!options || !options.continueOnError || !isHandledError(err)) {
		      throw err;
		    }

		    if (err.path === null) {
		      err.path = safePointerToPath(getHash(pathFromRoot));
		    }

		    if (err instanceof InvalidPointerError) {
		      // this is a special case - InvalidPointerError is thrown when dereferencing external file,
		      // but the issue is caused by the source file that referenced the file that undergoes dereferencing
		      err.source = decodeURI(stripHash(pathFromRoot));
		    }

		    this.addError(err);
		    return null;
		  }
		};

		/**
		 * Sets the value of a nested property within this {@link $Ref#value}.
		 * If the property, or any of its parents don't exist, they will be created.
		 *
		 * @param {string} path - The full path of the property to set, optionally with a JSON pointer in the hash
		 * @param {*} value - The value to assign
		 */
		$Ref.prototype.set = function (path, value) {
		  let pointer = new Pointer(this, path);
		  this.value = pointer.set(this.value, value);
		};

		/**
		 * Determines whether the given value is a JSON reference.
		 *
		 * @param {*} value - The value to inspect
		 * @returns {boolean}
		 */
		$Ref.is$Ref = function (value) {
		  return value && typeof value === "object" && typeof value.$ref === "string" && value.$ref.length > 0;
		};

		/**
		 * Determines whether the given value is an external JSON reference.
		 *
		 * @param {*} value - The value to inspect
		 * @returns {boolean}
		 */
		$Ref.isExternal$Ref = function (value) {
		  return $Ref.is$Ref(value) && value.$ref[0] !== "#";
		};

		/**
		 * Determines whether the given value is a JSON reference, and whether it is allowed by the options.
		 * For example, if it references an external file, then options.resolve.external must be true.
		 *
		 * @param {*} value - The value to inspect
		 * @param {$RefParserOptions} options
		 * @returns {boolean}
		 */
		$Ref.isAllowed$Ref = function (value, options) {
		  if ($Ref.is$Ref(value)) {
		    if (value.$ref.substr(0, 2) === "#/" || value.$ref === "#") {
		      // It's a JSON Pointer reference, which is always allowed
		      return true;
		    }
		    else if (value.$ref[0] !== "#" && (!options || options.resolve.external)) {
		      // It's an external reference, which is allowed by the options
		      return true;
		    }
		  }
		};

		/**
		 * Determines whether the given value is a JSON reference that "extends" its resolved value.
		 * That is, it has extra properties (in addition to "$ref"), so rather than simply pointing to
		 * an existing value, this $ref actually creates a NEW value that is a shallow copy of the resolved
		 * value, plus the extra properties.
		 *
		 * @example:
		 *  {
		 *    person: {
		 *      properties: {
		 *        firstName: { type: string }
		 *        lastName: { type: string }
		 *      }
		 *    }
		 *    employee: {
		 *      properties: {
		 *        $ref: #/person/properties
		 *        salary: { type: number }
		 *      }
		 *    }
		 *  }
		 *
		 *  In this example, "employee" is an extended $ref, since it extends "person" with an additional
		 *  property (salary).  The result is a NEW value that looks like this:
		 *
		 *  {
		 *    properties: {
		 *      firstName: { type: string }
		 *      lastName: { type: string }
		 *      salary: { type: number }
		 *    }
		 *  }
		 *
		 * @param {*} value - The value to inspect
		 * @returns {boolean}
		 */
		$Ref.isExtended$Ref = function (value) {
		  return $Ref.is$Ref(value) && Object.keys(value).length > 1;
		};

		/**
		 * Returns the resolved value of a JSON Reference.
		 * If necessary, the resolved value is merged with the JSON Reference to create a new object
		 *
		 * @example:
		 *  {
		 *    person: {
		 *      properties: {
		 *        firstName: { type: string }
		 *        lastName: { type: string }
		 *      }
		 *    }
		 *    employee: {
		 *      properties: {
		 *        $ref: #/person/properties
		 *        salary: { type: number }
		 *      }
		 *    }
		 *  }
		 *
		 *  When "person" and "employee" are merged, you end up with the following object:
		 *
		 *  {
		 *    properties: {
		 *      firstName: { type: string }
		 *      lastName: { type: string }
		 *      salary: { type: number }
		 *    }
		 *  }
		 *
		 * @param {object} $ref - The JSON reference object (the one with the "$ref" property)
		 * @param {*} resolvedValue - The resolved value, which can be any type
		 * @returns {*} - Returns the dereferenced value
		 */
		$Ref.dereference = function ($ref, resolvedValue) {
		  if (resolvedValue && typeof resolvedValue === "object" && $Ref.isExtended$Ref($ref)) {
		    let merged = {};
		    for (let key of Object.keys($ref)) {
		      if (key !== "$ref") {
		        merged[key] = $ref[key];
		      }
		    }

		    for (let key of Object.keys(resolvedValue)) {
		      if (!(key in merged)) {
		        merged[key] = resolvedValue[key];
		      }
		    }

		    return merged;
		  }
		  else {
		    // Completely replace the original reference with the resolved value
		    return resolvedValue;
		  }
		};
		return ref;
	}

	const { ono: ono$4 } = require$$6;
	const $Ref$3 = requireRef();
	const url$5 = urlExports;

	var refs = $Refs$1;

	/**
	 * This class is a map of JSON references and their resolved values.
	 */
	function $Refs$1 () {
	  /**
	   * Indicates whether the schema contains any circular references.
	   *
	   * @type {boolean}
	   */
	  this.circular = false;

	  /**
	   * A map of paths/urls to {@link $Ref} objects
	   *
	   * @type {object}
	   * @protected
	   */
	  this._$refs = {};

	  /**
	   * The {@link $Ref} object that is the root of the JSON schema.
	   *
	   * @type {$Ref}
	   * @protected
	   */
	  this._root$Ref = null;
	}

	/**
	 * Returns the paths of all the files/URLs that are referenced by the JSON schema,
	 * including the schema itself.
	 *
	 * @param {...string|string[]} [types] - Only return paths of the given types ("file", "http", etc.)
	 * @returns {string[]}
	 */
	$Refs$1.prototype.paths = function (types) {    // eslint-disable-line no-unused-vars
	  let paths = getPaths(this._$refs, arguments);
	  return paths.map((path) => {
	    return path.decoded;
	  });
	};

	/**
	 * Returns the map of JSON references and their resolved values.
	 *
	 * @param {...string|string[]} [types] - Only return references of the given types ("file", "http", etc.)
	 * @returns {object}
	 */
	$Refs$1.prototype.values = function (types) {   // eslint-disable-line no-unused-vars
	  let $refs = this._$refs;
	  let paths = getPaths($refs, arguments);
	  return paths.reduce((obj, path) => {
	    obj[path.decoded] = $refs[path.encoded].value;
	    return obj;
	  }, {});
	};

	/**
	 * Returns a POJO (plain old JavaScript object) for serialization as JSON.
	 *
	 * @returns {object}
	 */
	$Refs$1.prototype.toJSON = $Refs$1.prototype.values;

	/**
	 * Determines whether the given JSON reference exists.
	 *
	 * @param {string} path - The path being resolved, optionally with a JSON pointer in the hash
	 * @param {$RefParserOptions} [options]
	 * @returns {boolean}
	 */
	$Refs$1.prototype.exists = function (path, options) {
	  try {
	    this._resolve(path, "", options);
	    return true;
	  }
	  catch (e) {
	    return false;
	  }
	};

	/**
	 * Resolves the given JSON reference and returns the resolved value.
	 *
	 * @param {string} path - The path being resolved, with a JSON pointer in the hash
	 * @param {$RefParserOptions} [options]
	 * @returns {*} - Returns the resolved value
	 */
	$Refs$1.prototype.get = function (path, options) {
	  return this._resolve(path, "", options).value;
	};

	/**
	 * Sets the value of a nested property within this {@link $Ref#value}.
	 * If the property, or any of its parents don't exist, they will be created.
	 *
	 * @param {string} path - The path of the property to set, optionally with a JSON pointer in the hash
	 * @param {*} value - The value to assign
	 */
	$Refs$1.prototype.set = function (path, value) {
	  let absPath = url$5.resolve(this._root$Ref.path, path);
	  let withoutHash = url$5.stripHash(absPath);
	  let $ref = this._$refs[withoutHash];

	  if (!$ref) {
	    throw ono$4(`Error resolving $ref pointer "${path}". \n"${withoutHash}" not found.`);
	  }

	  $ref.set(absPath, value);
	};

	/**
	 * Creates a new {@link $Ref} object and adds it to this {@link $Refs} object.
	 *
	 * @param {string} path  - The file path or URL of the referenced file
	 */
	$Refs$1.prototype._add = function (path) {
	  let withoutHash = url$5.stripHash(path);

	  let $ref = new $Ref$3();
	  $ref.path = withoutHash;
	  $ref.$refs = this;

	  this._$refs[withoutHash] = $ref;
	  this._root$Ref = this._root$Ref || $ref;

	  return $ref;
	};

	/**
	 * Resolves the given JSON reference.
	 *
	 * @param {string} path - The path being resolved, optionally with a JSON pointer in the hash
	 * @param {string} pathFromRoot - The path of `obj` from the schema root
	 * @param {$RefParserOptions} [options]
	 * @returns {Pointer}
	 * @protected
	 */
	$Refs$1.prototype._resolve = function (path, pathFromRoot, options) {
	  let absPath = url$5.resolve(this._root$Ref.path, path);
	  let withoutHash = url$5.stripHash(absPath);
	  let $ref = this._$refs[withoutHash];

	  if (!$ref) {
	    throw ono$4(`Error resolving $ref pointer "${path}". \n"${withoutHash}" not found.`);
	  }

	  return $ref.resolve(absPath, options, path, pathFromRoot);
	};

	/**
	 * Returns the specified {@link $Ref} object, or undefined.
	 *
	 * @param {string} path - The path being resolved, optionally with a JSON pointer in the hash
	 * @returns {$Ref|undefined}
	 * @protected
	 */
	$Refs$1.prototype._get$Ref = function (path) {
	  path = url$5.resolve(this._root$Ref.path, path);
	  let withoutHash = url$5.stripHash(path);
	  return this._$refs[withoutHash];
	};

	/**
	 * Returns the encoded and decoded paths keys of the given object.
	 *
	 * @param {object} $refs - The object whose keys are URL-encoded paths
	 * @param {...string|string[]} [types] - Only return paths of the given types ("file", "http", etc.)
	 * @returns {object[]}
	 */
	function getPaths ($refs, types) {
	  let paths = Object.keys($refs);

	  // Filter the paths by type
	  types = Array.isArray(types[0]) ? types[0] : Array.prototype.slice.call(types);
	  if (types.length > 0 && types[0]) {
	    paths = paths.filter((key) => {
	      return types.indexOf($refs[key].pathType) !== -1;
	    });
	  }

	  // Decode local filesystem paths
	  return paths.map((path) => {
	    return {
	      encoded: path,
	      decoded: $refs[path].pathType === "file" ? url$5.toFileSystemPath(path, true) : path
	    };
	  });
	}

	var plugins$1 = {};

	/**
	 * Returns the given plugins as an array, rather than an object map.
	 * All other methods in this module expect an array of plugins rather than an object map.
	 *
	 * @param  {object} plugins - A map of plugin objects
	 * @return {object[]}
	 */
	plugins$1.all = function (plugins) {
	  return Object.keys(plugins)
	    .filter((key) => {
	      return typeof plugins[key] === "object";
	    })
	    .map((key) => {
	      plugins[key].name = key;
	      return plugins[key];
	    });
	};

	/**
	 * Filters the given plugins, returning only the ones return `true` for the given method.
	 *
	 * @param  {object[]} plugins - An array of plugin objects
	 * @param  {string}   method  - The name of the filter method to invoke for each plugin
	 * @param  {object}   file    - A file info object, which will be passed to each method
	 * @return {object[]}
	 */
	plugins$1.filter = function (plugins, method, file) {
	  return plugins
	    .filter((plugin) => {
	      return !!getResult(plugin, method, file);
	    });
	};

	/**
	 * Sorts the given plugins, in place, by their `order` property.
	 *
	 * @param {object[]} plugins - An array of plugin objects
	 * @returns {object[]}
	 */
	plugins$1.sort = function (plugins) {
	  for (let plugin of plugins) {
	    plugin.order = plugin.order || Number.MAX_SAFE_INTEGER;
	  }

	  return plugins.sort((a, b) => { return a.order - b.order; });
	};

	/**
	 * Runs the specified method of the given plugins, in order, until one of them returns a successful result.
	 * Each method can return a synchronous value, a Promise, or call an error-first callback.
	 * If the promise resolves successfully, or the callback is called without an error, then the result
	 * is immediately returned and no further plugins are called.
	 * If the promise rejects, or the callback is called with an error, then the next plugin is called.
	 * If ALL plugins fail, then the last error is thrown.
	 *
	 * @param {object[]}  plugins - An array of plugin objects
	 * @param {string}    method  - The name of the method to invoke for each plugin
	 * @param {object}    file    - A file info object, which will be passed to each method
	 * @returns {Promise}
	 */
	plugins$1.run = function (plugins, method, file, $refs) {
	  let plugin, lastError, index = 0;

	  return new Promise(((resolve, reject) => {
	    runNextPlugin();

	    function runNextPlugin () {
	      plugin = plugins[index++];
	      if (!plugin) {
	        // There are no more functions, so re-throw the last error
	        return reject(lastError);
	      }

	      try {
	        // console.log('  %s', plugin.name);
	        let result = getResult(plugin, method, file, callback, $refs);
	        if (result && typeof result.then === "function") {
	          // A promise was returned
	          result.then(onSuccess, onError);
	        }
	        else if (result !== undefined) {
	          // A synchronous result was returned
	          onSuccess(result);
	        }
	        else if (index === plugins.length) {
	          throw new Error("No promise has been returned or callback has been called.");
	        }
	      }
	      catch (e) {
	        onError(e);
	      }
	    }

	    function callback (err, result) {
	      if (err) {
	        onError(err);
	      }
	      else {
	        onSuccess(result);
	      }
	    }

	    function onSuccess (result) {
	      // console.log('    success');
	      resolve({
	        plugin,
	        result
	      });
	    }

	    function onError (error) {
	      // console.log('    %s', err.message || err);
	      lastError = {
	        plugin,
	        error,
	      };
	      runNextPlugin();
	    }
	  }));
	};

	/**
	 * Returns the value of the given property.
	 * If the property is a function, then the result of the function is returned.
	 * If the value is a RegExp, then it will be tested against the file URL.
	 * If the value is an aray, then it will be compared against the file extension.
	 *
	 * @param   {object}   obj        - The object whose property/method is called
	 * @param   {string}   prop       - The name of the property/method to invoke
	 * @param   {object}   file       - A file info object, which will be passed to the method
	 * @param   {function} [callback] - A callback function, which will be passed to the method
	 * @returns {*}
	 */
	function getResult (obj, prop, file, callback, $refs) {
	  let value = obj[prop];

	  if (typeof value === "function") {
	    return value.apply(obj, [file, callback, $refs]);
	  }

	  if (!callback) {
	    // The synchronous plugin functions (canParse and canRead)
	    // allow a "shorthand" syntax, where the user can match
	    // files by RegExp or by file extension.
	    if (value instanceof RegExp) {
	      return value.test(file.url);
	    }
	    else if (typeof value === "string") {
	      return value === file.extension;
	    }
	    else if (Array.isArray(value)) {
	      return value.indexOf(file.extension) !== -1;
	    }
	  }

	  return value;
	}

	const { ono: ono$3 } = require$$6;
	const url$4 = urlExports;
	const plugins = plugins$1;
	const { ResolverError: ResolverError$1, ParserError: ParserError$1, UnmatchedParserError: UnmatchedParserError$1, UnmatchedResolverError: UnmatchedResolverError$1, isHandledError: isHandledError$2 } = errors$1;

	var parse_1$1 = parse$8;

	/**
	 * Reads and parses the specified file path or URL.
	 *
	 * @param {string} path - This path MUST already be resolved, since `read` doesn't know the resolution context
	 * @param {$Refs} $refs
	 * @param {$RefParserOptions} options
	 *
	 * @returns {Promise}
	 * The promise resolves with the parsed file contents, NOT the raw (Buffer) contents.
	 */
	async function parse$8 (path, $refs, options) {
	  // Remove the URL fragment, if any
	  path = url$4.stripHash(path);

	  // Add a new $Ref for this file, even though we don't have the value yet.
	  // This ensures that we don't simultaneously read & parse the same file multiple times
	  let $ref = $refs._add(path);

	  // This "file object" will be passed to all resolvers and parsers.
	  let file = {
	    url: path,
	    extension: url$4.getExtension(path),
	  };

	  // Read the file and then parse the data
	  try {
	    const resolver = await readFile$1(file, options, $refs);
	    $ref.pathType = resolver.plugin.name;
	    file.data = resolver.result;

	    const parser = await parseFile(file, options, $refs);
	    $ref.value = parser.result;

	    return parser.result;
	  }
	  catch (err) {
	    if (isHandledError$2(err)) {
	      $ref.value = err;
	    }

	    throw err;
	  }
	}

	/**
	 * Reads the given file, using the configured resolver plugins
	 *
	 * @param {object} file           - An object containing information about the referenced file
	 * @param {string} file.url       - The full URL of the referenced file
	 * @param {string} file.extension - The lowercased file extension (e.g. ".txt", ".html", etc.)
	 * @param {$RefParserOptions} options
	 *
	 * @returns {Promise}
	 * The promise resolves with the raw file contents and the resolver that was used.
	 */
	function readFile$1 (file, options, $refs) {
	  return new Promise(((resolve, reject) => {
	    // console.log('Reading %s', file.url);

	    // Find the resolvers that can read this file
	    let resolvers = plugins.all(options.resolve);
	    resolvers = plugins.filter(resolvers, "canRead", file);

	    // Run the resolvers, in order, until one of them succeeds
	    plugins.sort(resolvers);
	    plugins.run(resolvers, "read", file, $refs)
	      .then(resolve, onError);

	    function onError (err) {
	      if (!err && options.continueOnError) {
	        // No resolver could be matched
	        reject(new UnmatchedResolverError$1(file.url));
	      }
	      else if (!err || !("error" in err)) {
	        // Throw a generic, friendly error.
	        reject(ono$3.syntax(`Unable to resolve $ref pointer "${file.url}"`));
	      }
	      // Throw the original error, if it's one of our own (user-friendly) errors.
	      else if (err.error instanceof ResolverError$1) {
	        reject(err.error);
	      }
	      else {
	        reject(new ResolverError$1(err, file.url));
	      }
	    }
	  }));
	}

	/**
	 * Parses the given file's contents, using the configured parser plugins.
	 *
	 * @param {object} file           - An object containing information about the referenced file
	 * @param {string} file.url       - The full URL of the referenced file
	 * @param {string} file.extension - The lowercased file extension (e.g. ".txt", ".html", etc.)
	 * @param {*}      file.data      - The file contents. This will be whatever data type was returned by the resolver
	 * @param {$RefParserOptions} options
	 *
	 * @returns {Promise}
	 * The promise resolves with the parsed file contents and the parser that was used.
	 */
	function parseFile (file, options, $refs) {
	  return new Promise(((resolve, reject) => {
	    // console.log('Parsing %s', file.url);

	    // Find the parsers that can read this file type.
	    // If none of the parsers are an exact match for this file, then we'll try ALL of them.
	    // This handles situations where the file IS a supported type, just with an unknown extension.
	    let allParsers = plugins.all(options.parse);
	    let filteredParsers = plugins.filter(allParsers, "canParse", file);
	    let parsers = filteredParsers.length > 0 ? filteredParsers : allParsers;

	    // Run the parsers, in order, until one of them succeeds
	    plugins.sort(parsers);
	    plugins.run(parsers, "parse", file, $refs)
	      .then(onParsed, onError);

	    function onParsed (parser) {
	      if (!parser.plugin.allowEmpty && isEmpty(parser.result)) {
	        reject(ono$3.syntax(`Error parsing "${file.url}" as ${parser.plugin.name}. \nParsed value is empty`));
	      }
	      else {
	        resolve(parser);
	      }
	    }

	    function onError (err) {
	      if (!err && options.continueOnError) {
	        // No resolver could be matched
	        reject(new UnmatchedParserError$1(file.url));
	      }
	      else if (!err || !("error" in err)) {
	        reject(ono$3.syntax(`Unable to parse ${file.url}`));
	      }
	      else if (err.error instanceof ParserError$1) {
	        reject(err.error);
	      }
	      else {
	        reject(new ParserError$1(err.error.message, file.url));
	      }
	    }
	  }));
	}

	/**
	 * Determines whether the parsed value is "empty".
	 *
	 * @param {*} value
	 * @returns {boolean}
	 */
	function isEmpty (value) {
	  return value === undefined ||
	    (typeof value === "object" && Object.keys(value).length === 0) ||
	    (typeof value === "string" && value.trim().length === 0) ||
	    (Buffer.isBuffer(value) && value.length === 0);
	}

	const $Ref$2 = requireRef();
	const Pointer$2 = requirePointer();
	const parse$7 = parse_1$1;
	const url$3 = urlExports;
	const { isHandledError: isHandledError$1 } = errors$1;

	var resolveExternal_1 = resolveExternal$1;

	/**
	 * Crawls the JSON schema, finds all external JSON references, and resolves their values.
	 * This method does not mutate the JSON schema. The resolved values are added to {@link $RefParser#$refs}.
	 *
	 * NOTE: We only care about EXTERNAL references here. INTERNAL references are only relevant when dereferencing.
	 *
	 * @param {$RefParser} parser
	 * @param {$RefParserOptions} options
	 *
	 * @returns {Promise}
	 * The promise resolves once all JSON references in the schema have been resolved,
	 * including nested references that are contained in externally-referenced files.
	 */
	function resolveExternal$1 (parser, options) {
	  if (!options.resolve.external) {
	    // Nothing to resolve, so exit early
	    return Promise.resolve();
	  }

	  try {
	    // console.log('Resolving $ref pointers in %s', parser.$refs._root$Ref.path);
	    let promises = crawl$2(parser.schema, parser.$refs._root$Ref.path + "#", parser.$refs, options);
	    return Promise.all(promises);
	  }
	  catch (e) {
	    return Promise.reject(e);
	  }
	}

	/**
	 * Recursively crawls the given value, and resolves any external JSON references.
	 *
	 * @param {*} obj - The value to crawl. If it's not an object or array, it will be ignored.
	 * @param {string} path - The full path of `obj`, possibly with a JSON Pointer in the hash
	 * @param {$Refs} $refs
	 * @param {$RefParserOptions} options
	 * @param {Set} seen - Internal.
	 *
	 * @returns {Promise[]}
	 * Returns an array of promises. There will be one promise for each JSON reference in `obj`.
	 * If `obj` does not contain any JSON references, then the array will be empty.
	 * If any of the JSON references point to files that contain additional JSON references,
	 * then the corresponding promise will internally reference an array of promises.
	 */
	function crawl$2 (obj, path, $refs, options, seen) {
	  seen = seen || new Set();
	  let promises = [];

	  if (obj && typeof obj === "object" && !ArrayBuffer.isView(obj) && !seen.has(obj)) {
	    seen.add(obj); // Track previously seen objects to avoid infinite recursion
	    if ($Ref$2.isExternal$Ref(obj)) {
	      promises.push(resolve$Ref(obj, path, $refs, options));
	    }
	    else {
	      for (let key of Object.keys(obj)) {
	        let keyPath = Pointer$2.join(path, key);
	        let value = obj[key];

	        if ($Ref$2.isExternal$Ref(value)) {
	          promises.push(resolve$Ref(value, keyPath, $refs, options));
	        }
	        else {
	          promises = promises.concat(crawl$2(value, keyPath, $refs, options, seen));
	        }
	      }
	    }
	  }

	  return promises;
	}

	/**
	 * Resolves the given JSON Reference, and then crawls the resulting value.
	 *
	 * @param {{$ref: string}} $ref - The JSON Reference to resolve
	 * @param {string} path - The full path of `$ref`, possibly with a JSON Pointer in the hash
	 * @param {$Refs} $refs
	 * @param {$RefParserOptions} options
	 *
	 * @returns {Promise}
	 * The promise resolves once all JSON references in the object have been resolved,
	 * including nested references that are contained in externally-referenced files.
	 */
	async function resolve$Ref ($ref, path, $refs, options) {
	  // console.log('Resolving $ref pointer "%s" at %s', $ref.$ref, path);

	  let resolvedPath = url$3.resolve(path, $ref.$ref);
	  let withoutHash = url$3.stripHash(resolvedPath);

	  // Do we already have this $ref?
	  $ref = $refs._$refs[withoutHash];
	  if ($ref) {
	    // We've already parsed this $ref, so use the existing value
	    return Promise.resolve($ref.value);
	  }

	  // Parse the $referenced file/url
	  try {
	    const result = await parse$7(resolvedPath, $refs, options);

	    // Crawl the parsed value
	    // console.log('Resolving $ref pointers in %s', withoutHash);
	    let promises = crawl$2(result, withoutHash + "#", $refs, options);

	    return Promise.all(promises);
	  }
	  catch (err) {
	    if (!options.continueOnError || !isHandledError$1(err)) {
	      throw err;
	    }

	    if ($refs._$refs[withoutHash]) {
	      err.source = decodeURI(url$3.stripHash(path));
	      err.path = url$3.safePointerToPath(url$3.getHash(path));
	    }

	    return [];
	  }
	}

	const $Ref$1 = requireRef();
	const Pointer$1 = requirePointer();
	const url$2 = urlExports;

	var bundle_1 = bundle;

	/**
	 * Bundles all external JSON references into the main JSON schema, thus resulting in a schema that
	 * only has *internal* references, not any *external* references.
	 * This method mutates the JSON schema object, adding new references and re-mapping existing ones.
	 *
	 * @param {$RefParser} parser
	 * @param {$RefParserOptions} options
	 */
	function bundle (parser, options) {
	  // console.log('Bundling $ref pointers in %s', parser.$refs._root$Ref.path);

	  // Build an inventory of all $ref pointers in the JSON Schema
	  let inventory = [];
	  crawl$1(parser, "schema", parser.$refs._root$Ref.path + "#", "#", 0, inventory, parser.$refs, options);

	  // Remap all $ref pointers
	  remap(inventory);
	}

	/**
	 * Recursively crawls the given value, and inventories all JSON references.
	 *
	 * @param {object} parent - The object containing the value to crawl. If the value is not an object or array, it will be ignored.
	 * @param {string} key - The property key of `parent` to be crawled
	 * @param {string} path - The full path of the property being crawled, possibly with a JSON Pointer in the hash
	 * @param {string} pathFromRoot - The path of the property being crawled, from the schema root
	 * @param {object[]} inventory - An array of already-inventoried $ref pointers
	 * @param {$Refs} $refs
	 * @param {$RefParserOptions} options
	 */
	function crawl$1 (parent, key, path, pathFromRoot, indirections, inventory, $refs, options) {
	  let obj = key === null ? parent : parent[key];

	  if (obj && typeof obj === "object" && !ArrayBuffer.isView(obj)) {
	    if ($Ref$1.isAllowed$Ref(obj)) {
	      inventory$Ref(parent, key, path, pathFromRoot, indirections, inventory, $refs, options);
	    }
	    else {
	      // Crawl the object in a specific order that's optimized for bundling.
	      // This is important because it determines how `pathFromRoot` gets built,
	      // which later determines which keys get dereferenced and which ones get remapped
	      let keys = Object.keys(obj)
	        .sort((a, b) => {
	          // Most people will expect references to be bundled into the the "definitions" property,
	          // so we always crawl that property first, if it exists.
	          if (a === "definitions") {
	            return -1;
	          }
	          else if (b === "definitions") {
	            return 1;
	          }
	          else {
	            // Otherwise, crawl the keys based on their length.
	            // This produces the shortest possible bundled references
	            return a.length - b.length;
	          }
	        });

	      // eslint-disable-next-line no-shadow
	      for (let key of keys) {
	        let keyPath = Pointer$1.join(path, key);
	        let keyPathFromRoot = Pointer$1.join(pathFromRoot, key);
	        let value = obj[key];

	        if ($Ref$1.isAllowed$Ref(value)) {
	          inventory$Ref(obj, key, path, keyPathFromRoot, indirections, inventory, $refs, options);
	        }
	        else {
	          crawl$1(obj, key, keyPath, keyPathFromRoot, indirections, inventory, $refs, options);
	        }
	      }
	    }
	  }
	}

	/**
	 * Inventories the given JSON Reference (i.e. records detailed information about it so we can
	 * optimize all $refs in the schema), and then crawls the resolved value.
	 *
	 * @param {object} $refParent - The object that contains a JSON Reference as one of its keys
	 * @param {string} $refKey - The key in `$refParent` that is a JSON Reference
	 * @param {string} path - The full path of the JSON Reference at `$refKey`, possibly with a JSON Pointer in the hash
	 * @param {string} pathFromRoot - The path of the JSON Reference at `$refKey`, from the schema root
	 * @param {object[]} inventory - An array of already-inventoried $ref pointers
	 * @param {$Refs} $refs
	 * @param {$RefParserOptions} options
	 */
	function inventory$Ref ($refParent, $refKey, path, pathFromRoot, indirections, inventory, $refs, options) {
	  let $ref = $refKey === null ? $refParent : $refParent[$refKey];
	  let $refPath = url$2.resolve(path, $ref.$ref);
	  let pointer = $refs._resolve($refPath, pathFromRoot, options);
	  if (pointer === null) {
	    return;
	  }

	  let depth = Pointer$1.parse(pathFromRoot).length;
	  let file = url$2.stripHash(pointer.path);
	  let hash = url$2.getHash(pointer.path);
	  let external = file !== $refs._root$Ref.path;
	  let extended = $Ref$1.isExtended$Ref($ref);
	  indirections += pointer.indirections;

	  let existingEntry = findInInventory(inventory, $refParent, $refKey);
	  if (existingEntry) {
	    // This $Ref has already been inventoried, so we don't need to process it again
	    if (depth < existingEntry.depth || indirections < existingEntry.indirections) {
	      removeFromInventory(inventory, existingEntry);
	    }
	    else {
	      return;
	    }
	  }

	  inventory.push({
	    $ref,                   // The JSON Reference (e.g. {$ref: string})
	    parent: $refParent,           // The object that contains this $ref pointer
	    key: $refKey,                 // The key in `parent` that is the $ref pointer
	    pathFromRoot,   // The path to the $ref pointer, from the JSON Schema root
	    depth,                 // How far from the JSON Schema root is this $ref pointer?
	    file,                   // The file that the $ref pointer resolves to
	    hash,                   // The hash within `file` that the $ref pointer resolves to
	    value: pointer.value,         // The resolved value of the $ref pointer
	    circular: pointer.circular,   // Is this $ref pointer DIRECTLY circular? (i.e. it references itself)
	    extended,           // Does this $ref extend its resolved value? (i.e. it has extra properties, in addition to "$ref")
	    external,           // Does this $ref pointer point to a file other than the main JSON Schema file?
	    indirections,   // The number of indirect references that were traversed to resolve the value
	  });

	  // Recursively crawl the resolved value
	  if (!existingEntry) {
	    crawl$1(pointer.value, null, pointer.path, pathFromRoot, indirections + 1, inventory, $refs, options);
	  }
	}

	/**
	 * Re-maps every $ref pointer, so that they're all relative to the root of the JSON Schema.
	 * Each referenced value is dereferenced EXACTLY ONCE.  All subsequent references to the same
	 * value are re-mapped to point to the first reference.
	 *
	 * @example:
	 *  {
	 *    first: { $ref: somefile.json#/some/part },
	 *    second: { $ref: somefile.json#/another/part },
	 *    third: { $ref: somefile.json },
	 *    fourth: { $ref: somefile.json#/some/part/sub/part }
	 *  }
	 *
	 * In this example, there are four references to the same file, but since the third reference points
	 * to the ENTIRE file, that's the only one we need to dereference.  The other three can just be
	 * remapped to point inside the third one.
	 *
	 * On the other hand, if the third reference DIDN'T exist, then the first and second would both need
	 * to be dereferenced, since they point to different parts of the file. The fourth reference does NOT
	 * need to be dereferenced, because it can be remapped to point inside the first one.
	 *
	 * @param {object[]} inventory
	 */
	function remap (inventory) {
	  // Group & sort all the $ref pointers, so they're in the order that we need to dereference/remap them
	  inventory.sort((a, b) => {
	    if (a.file !== b.file) {
	      // Group all the $refs that point to the same file
	      return a.file < b.file ? -1 : +1;
	    }
	    else if (a.hash !== b.hash) {
	      // Group all the $refs that point to the same part of the file
	      return a.hash < b.hash ? -1 : +1;
	    }
	    else if (a.circular !== b.circular) {
	      // If the $ref points to itself, then sort it higher than other $refs that point to this $ref
	      return a.circular ? -1 : +1;
	    }
	    else if (a.extended !== b.extended) {
	      // If the $ref extends the resolved value, then sort it lower than other $refs that don't extend the value
	      return a.extended ? +1 : -1;
	    }
	    else if (a.indirections !== b.indirections) {
	      // Sort direct references higher than indirect references
	      return a.indirections - b.indirections;
	    }
	    else if (a.depth !== b.depth) {
	      // Sort $refs by how close they are to the JSON Schema root
	      return a.depth - b.depth;
	    }
	    else {
	      // Determine how far each $ref is from the "definitions" property.
	      // Most people will expect references to be bundled into the the "definitions" property if possible.
	      let aDefinitionsIndex = a.pathFromRoot.lastIndexOf("/definitions");
	      let bDefinitionsIndex = b.pathFromRoot.lastIndexOf("/definitions");

	      if (aDefinitionsIndex !== bDefinitionsIndex) {
	        // Give higher priority to the $ref that's closer to the "definitions" property
	        return bDefinitionsIndex - aDefinitionsIndex;
	      }
	      else {
	        // All else is equal, so use the shorter path, which will produce the shortest possible reference
	        return a.pathFromRoot.length - b.pathFromRoot.length;
	      }
	    }
	  });

	  let file, hash, pathFromRoot;
	  for (let entry of inventory) {
	    // console.log('Re-mapping $ref pointer "%s" at %s', entry.$ref.$ref, entry.pathFromRoot);

	    if (!entry.external) {
	      // This $ref already resolves to the main JSON Schema file
	      entry.$ref.$ref = entry.hash;
	    }
	    else if (entry.file === file && entry.hash === hash) {
	      // This $ref points to the same value as the prevous $ref, so remap it to the same path
	      entry.$ref.$ref = pathFromRoot;
	    }
	    else if (entry.file === file && entry.hash.indexOf(hash + "/") === 0) {
	      // This $ref points to a sub-value of the prevous $ref, so remap it beneath that path
	      entry.$ref.$ref = Pointer$1.join(pathFromRoot, Pointer$1.parse(entry.hash.replace(hash, "#")));
	    }
	    else {
	      // We've moved to a new file or new hash
	      file = entry.file;
	      hash = entry.hash;
	      pathFromRoot = entry.pathFromRoot;

	      // This is the first $ref to point to this value, so dereference the value.
	      // Any other $refs that point to the same value will point to this $ref instead
	      entry.$ref = entry.parent[entry.key] = $Ref$1.dereference(entry.$ref, entry.value);

	      if (entry.circular) {
	        // This $ref points to itself
	        entry.$ref.$ref = entry.pathFromRoot;
	      }
	    }

	    // console.log('    new value: %s', (entry.$ref && entry.$ref.$ref) ? entry.$ref.$ref : '[object Object]');
	  }
	}

	/**
	 * TODO
	 */
	function findInInventory (inventory, $refParent, $refKey) {
	  for (let i = 0; i < inventory.length; i++) {
	    let existingEntry = inventory[i];
	    if (existingEntry.parent === $refParent && existingEntry.key === $refKey) {
	      return existingEntry;
	    }
	  }
	}

	function removeFromInventory (inventory, entry) {
	  let index = inventory.indexOf(entry);
	  inventory.splice(index, 1);
	}

	const $Ref = requireRef();
	const Pointer = requirePointer();
	const { ono: ono$2 } = require$$6;
	const url$1 = urlExports;

	var dereference_1 = dereference$1;

	/**
	 * Crawls the JSON schema, finds all JSON references, and dereferences them.
	 * This method mutates the JSON schema object, replacing JSON references with their resolved value.
	 *
	 * @param {$RefParser} parser
	 * @param {$RefParserOptions} options
	 */
	function dereference$1 (parser, options) {
	  // console.log('Dereferencing $ref pointers in %s', parser.$refs._root$Ref.path);
	  let dereferenced = crawl(parser.schema, parser.$refs._root$Ref.path, "#", new Set(), new Set(), new Map(), parser.$refs, options);
	  parser.$refs.circular = dereferenced.circular;
	  parser.schema = dereferenced.value;
	}

	/**
	 * Recursively crawls the given value, and dereferences any JSON references.
	 *
	 * @param {*} obj - The value to crawl. If it's not an object or array, it will be ignored.
	 * @param {string} path - The full path of `obj`, possibly with a JSON Pointer in the hash
	 * @param {string} pathFromRoot - The path of `obj` from the schema root
	 * @param {Set<object>} parents - An array of the parent objects that have already been dereferenced
	 * @param {Set<object>} processedObjects - An array of all the objects that have already been processed
	 * @param {Map<string,object>} dereferencedCache - An map of all the dereferenced objects
	 * @param {$Refs} $refs
	 * @param {$RefParserOptions} options
	 * @returns {{value: object, circular: boolean}}
	 */
	function crawl (obj, path, pathFromRoot, parents, processedObjects, dereferencedCache, $refs, options) {
	  let dereferenced;
	  let result = {
	    value: obj,
	    circular: false
	  };

	  let isExcludedPath = options.dereference.excludedPathMatcher;

	  if (options.dereference.circular === "ignore" || !processedObjects.has(obj)) {
	    if (obj && typeof obj === "object" && !ArrayBuffer.isView(obj) && !isExcludedPath(pathFromRoot)) {
	      parents.add(obj);
	      processedObjects.add(obj);

	      if ($Ref.isAllowed$Ref(obj, options)) {
	        dereferenced = dereference$Ref(obj, path, pathFromRoot, parents, processedObjects, dereferencedCache, $refs, options);
	        result.circular = dereferenced.circular;
	        result.value = dereferenced.value;
	      }
	      else {
	        for (const key of Object.keys(obj)) {
	          let keyPath = Pointer.join(path, key);
	          let keyPathFromRoot = Pointer.join(pathFromRoot, key);

	          if (isExcludedPath(keyPathFromRoot)) {
	            continue;
	          }

	          let value = obj[key];
	          let circular = false;

	          if ($Ref.isAllowed$Ref(value, options)) {
	            dereferenced = dereference$Ref(value, keyPath, keyPathFromRoot, parents, processedObjects, dereferencedCache, $refs, options);
	            circular = dereferenced.circular;
	            // Avoid pointless mutations; breaks frozen objects to no profit
	            if (obj[key] !== dereferenced.value) {
	              obj[key] = dereferenced.value;
	            }
	          }
	          else {
	            if (!parents.has(value)) {
	              dereferenced = crawl(value, keyPath, keyPathFromRoot, parents, processedObjects, dereferencedCache, $refs, options);
	              circular = dereferenced.circular;
	              // Avoid pointless mutations; breaks frozen objects to no profit
	              if (obj[key] !== dereferenced.value) {
	                obj[key] = dereferenced.value;
	              }
	            }
	            else {
	              circular = foundCircularReference(keyPath, $refs, options);
	            }
	          }

	          // Set the "isCircular" flag if this or any other property is circular
	          result.circular = result.circular || circular;
	        }
	      }

	      parents.delete(obj);
	    }
	  }

	  return result;
	}

	/**
	 * Dereferences the given JSON Reference, and then crawls the resulting value.
	 *
	 * @param {{$ref: string}} $ref - The JSON Reference to resolve
	 * @param {string} path - The full path of `$ref`, possibly with a JSON Pointer in the hash
	 * @param {string} pathFromRoot - The path of `$ref` from the schema root
	 * @param {Set<object>} parents - An array of the parent objects that have already been dereferenced
	 * @param {Set<object>} processedObjects - An array of all the objects that have already been dereferenced
	 * @param {Map<string,object>} dereferencedCache - An map of all the dereferenced objects
	 * @param {$Refs} $refs
	 * @param {$RefParserOptions} options
	 * @returns {{value: object, circular: boolean}}
	 */
	function dereference$Ref ($ref, path, pathFromRoot, parents, processedObjects, dereferencedCache, $refs, options) {
	  // console.log('Dereferencing $ref pointer "%s" at %s', $ref.$ref, path);

	  let $refPath = url$1.resolve(path, $ref.$ref);

	  const cache = dereferencedCache.get($refPath);
	  if (cache) {
	    const refKeys = Object.keys($ref);
	    if (refKeys.length > 1) {
	      const extraKeys = {};
	      for (let key of refKeys) {
	        if (key !== "$ref" && !(key in cache.value)) {
	          extraKeys[key] = $ref[key];
	        }
	      }
	      return {
	        circular: cache.circular,
	        value: Object.assign({}, cache.value, extraKeys),
	      };
	    }

	    return cache;
	  }


	  let pointer = $refs._resolve($refPath, path, options);

	  if (pointer === null) {
	    return {
	      circular: false,
	      value: null,
	    };
	  }

	  // Check for circular references
	  let directCircular = pointer.circular;
	  let circular = directCircular || parents.has(pointer.value);
	  circular && foundCircularReference(path, $refs, options);

	  // Dereference the JSON reference
	  let dereferencedValue = $Ref.dereference($ref, pointer.value);

	  // Crawl the dereferenced value (unless it's circular)
	  if (!circular) {
	    // Determine if the dereferenced value is circular
	    let dereferenced = crawl(dereferencedValue, pointer.path, pathFromRoot, parents, processedObjects, dereferencedCache, $refs, options);
	    circular = dereferenced.circular;
	    dereferencedValue = dereferenced.value;
	  }

	  if (circular && !directCircular && options.dereference.circular === "ignore") {
	    // The user has chosen to "ignore" circular references, so don't change the value
	    dereferencedValue = $ref;
	  }

	  if (directCircular) {
	    // The pointer is a DIRECT circular reference (i.e. it references itself).
	    // So replace the $ref path with the absolute path from the JSON Schema root
	    dereferencedValue.$ref = pathFromRoot;
	  }


	  const dereferencedObject = {
	    circular,
	    value: dereferencedValue
	  };

	  // only cache if no extra properties than $ref
	  if (Object.keys($ref).length === 1) {
	    dereferencedCache.set($refPath, dereferencedObject);
	  }

	  return dereferencedObject;
	}

	/**
	 * Called when a circular reference is found.
	 * It sets the {@link $Refs#circular} flag, and throws an error if options.dereference.circular is false.
	 *
	 * @param {string} keyPath - The JSON Reference path of the circular reference
	 * @param {$Refs} $refs
	 * @param {$RefParserOptions} options
	 * @returns {boolean} - always returns true, to indicate that a circular reference was found
	 */
	function foundCircularReference (keyPath, $refs, options) {
	  $refs.circular = true;
	  if (!options.dereference.circular) {
	    throw ono$2.reference(`Circular $ref pointer found at ${keyPath}`);
	  }
	  return true;
	}

	const $Refs = refs;
	const _parse = parse_1$1;
	const normalizeArgs$1 = normalizeArgs_1;
	const resolveExternal = resolveExternal_1;
	const _bundle = bundle_1;
	const _dereference = dereference_1;
	const url = urlExports;
	const { JSONParserError, InvalidPointerError, MissingPointerError, ResolverError, ParserError, UnmatchedParserError, UnmatchedResolverError, isHandledError, JSONParserErrorGroup } = errors$1;
	const maybe$1 = maybe$2;
	const { ono: ono$1 } = require$$6;

	lib$1.exports = $RefParser$1;
	libExports.default = $RefParser$1;
	libExports.JSONParserError = JSONParserError;
	libExports.InvalidPointerError = InvalidPointerError;
	libExports.MissingPointerError = MissingPointerError;
	libExports.ResolverError = ResolverError;
	libExports.ParserError = ParserError;
	libExports.UnmatchedParserError = UnmatchedParserError;
	libExports.UnmatchedResolverError = UnmatchedResolverError;

	/**
	 * This class parses a JSON schema, builds a map of its JSON references and their resolved values,
	 * and provides methods for traversing, manipulating, and dereferencing those references.
	 *
	 * @constructor
	 */
	function $RefParser$1 () {
	  /**
	   * The parsed (and possibly dereferenced) JSON schema object
	   *
	   * @type {object}
	   * @readonly
	   */
	  this.schema = null;

	  /**
	   * The resolved JSON references
	   *
	   * @type {$Refs}
	   * @readonly
	   */
	  this.$refs = new $Refs();
	}

	/**
	 * Parses the given JSON schema.
	 * This method does not resolve any JSON references.
	 * It just reads a single file in JSON or YAML format, and parse it as a JavaScript object.
	 *
	 * @param {string} [path] - The file path or URL of the JSON schema
	 * @param {object} [schema] - A JSON schema object. This object will be used instead of reading from `path`.
	 * @param {$RefParserOptions} [options] - Options that determine how the schema is parsed
	 * @param {function} [callback] - An error-first callback. The second parameter is the parsed JSON schema object.
	 * @returns {Promise} - The returned promise resolves with the parsed JSON schema object.
	 */
	$RefParser$1.parse = function parse (path, schema, options, callback) {
	  let Class = this; // eslint-disable-line consistent-this
	  let instance = new Class();
	  return instance.parse.apply(instance, arguments);
	};

	/**
	 * Parses the given JSON schema.
	 * This method does not resolve any JSON references.
	 * It just reads a single file in JSON or YAML format, and parse it as a JavaScript object.
	 *
	 * @param {string} [path] - The file path or URL of the JSON schema
	 * @param {object} [schema] - A JSON schema object. This object will be used instead of reading from `path`.
	 * @param {$RefParserOptions} [options] - Options that determine how the schema is parsed
	 * @param {function} [callback] - An error-first callback. The second parameter is the parsed JSON schema object.
	 * @returns {Promise} - The returned promise resolves with the parsed JSON schema object.
	 */
	$RefParser$1.prototype.parse = async function parse (path, schema, options, callback) {
	  let args = normalizeArgs$1(arguments);
	  let promise;

	  if (!args.path && !args.schema) {
	    let err = ono$1(`Expected a file path, URL, or object. Got ${args.path || args.schema}`);
	    return maybe$1(args.callback, Promise.reject(err));
	  }

	  // Reset everything
	  this.schema = null;
	  this.$refs = new $Refs();

	  // If the path is a filesystem path, then convert it to a URL.
	  // NOTE: According to the JSON Reference spec, these should already be URLs,
	  // but, in practice, many people use local filesystem paths instead.
	  // So we're being generous here and doing the conversion automatically.
	  // This is not intended to be a 100% bulletproof solution.
	  // If it doesn't work for your use-case, then use a URL instead.
	  let pathType = "http";
	  if (url.isFileSystemPath(args.path)) {
	    args.path = url.fromFileSystemPath(args.path);
	    pathType = "file";
	  }

	  // Resolve the absolute path of the schema
	  args.path = url.resolve(url.cwd(), args.path);

	  if (args.schema && typeof args.schema === "object") {
	    // A schema object was passed-in.
	    // So immediately add a new $Ref with the schema object as its value
	    let $ref = this.$refs._add(args.path);
	    $ref.value = args.schema;
	    $ref.pathType = pathType;
	    promise = Promise.resolve(args.schema);
	  }
	  else {
	    // Parse the schema file/url
	    promise = _parse(args.path, this.$refs, args.options);
	  }

	  let me = this;
	  try {
	    let result = await promise;

	    if (result !== null && typeof result === "object" && !Buffer.isBuffer(result)) {
	      me.schema = result;
	      return maybe$1(args.callback, Promise.resolve(me.schema));
	    }
	    else if (args.options.continueOnError) {
	      me.schema = null; // it's already set to null at line 79, but let's set it again for the sake of readability
	      return maybe$1(args.callback, Promise.resolve(me.schema));
	    }
	    else {
	      throw ono$1.syntax(`"${me.$refs._root$Ref.path || result}" is not a valid JSON Schema`);
	    }
	  }
	  catch (err) {
	    if (!args.options.continueOnError || !isHandledError(err)) {
	      return maybe$1(args.callback, Promise.reject(err));
	    }

	    if (this.$refs._$refs[url.stripHash(args.path)]) {
	      this.$refs._$refs[url.stripHash(args.path)].addError(err);
	    }

	    return maybe$1(args.callback, Promise.resolve(null));
	  }
	};

	/**
	 * Parses the given JSON schema and resolves any JSON references, including references in
	 * externally-referenced files.
	 *
	 * @param {string} [path] - The file path or URL of the JSON schema
	 * @param {object} [schema] - A JSON schema object. This object will be used instead of reading from `path`.
	 * @param {$RefParserOptions} [options] - Options that determine how the schema is parsed and resolved
	 * @param {function} [callback]
	 * - An error-first callback. The second parameter is a {@link $Refs} object containing the resolved JSON references
	 *
	 * @returns {Promise}
	 * The returned promise resolves with a {@link $Refs} object containing the resolved JSON references
	 */
	$RefParser$1.resolve = function resolve (path, schema, options, callback) {
	  let Class = this; // eslint-disable-line consistent-this
	  let instance = new Class();
	  return instance.resolve.apply(instance, arguments);
	};

	/**
	 * Parses the given JSON schema and resolves any JSON references, including references in
	 * externally-referenced files.
	 *
	 * @param {string} [path] - The file path or URL of the JSON schema
	 * @param {object} [schema] - A JSON schema object. This object will be used instead of reading from `path`.
	 * @param {$RefParserOptions} [options] - Options that determine how the schema is parsed and resolved
	 * @param {function} [callback]
	 * - An error-first callback. The second parameter is a {@link $Refs} object containing the resolved JSON references
	 *
	 * @returns {Promise}
	 * The returned promise resolves with a {@link $Refs} object containing the resolved JSON references
	 */
	$RefParser$1.prototype.resolve = async function resolve (path, schema, options, callback) {
	  let me = this;
	  let args = normalizeArgs$1(arguments);

	  try {
	    await this.parse(args.path, args.schema, args.options);
	    await resolveExternal(me, args.options);
	    finalize(me);
	    return maybe$1(args.callback, Promise.resolve(me.$refs));
	  }
	  catch (err) {
	    return maybe$1(args.callback, Promise.reject(err));
	  }
	};

	/**
	 * Parses the given JSON schema, resolves any JSON references, and bundles all external references
	 * into the main JSON schema. This produces a JSON schema that only has *internal* references,
	 * not any *external* references.
	 *
	 * @param {string} [path] - The file path or URL of the JSON schema
	 * @param {object} [schema] - A JSON schema object. This object will be used instead of reading from `path`.
	 * @param {$RefParserOptions} [options] - Options that determine how the schema is parsed, resolved, and dereferenced
	 * @param {function} [callback] - An error-first callback. The second parameter is the bundled JSON schema object
	 * @returns {Promise} - The returned promise resolves with the bundled JSON schema object.
	 */
	$RefParser$1.bundle = function bundle (path, schema, options, callback) {
	  let Class = this; // eslint-disable-line consistent-this
	  let instance = new Class();
	  return instance.bundle.apply(instance, arguments);
	};

	/**
	 * Parses the given JSON schema, resolves any JSON references, and bundles all external references
	 * into the main JSON schema. This produces a JSON schema that only has *internal* references,
	 * not any *external* references.
	 *
	 * @param {string} [path] - The file path or URL of the JSON schema
	 * @param {object} [schema] - A JSON schema object. This object will be used instead of reading from `path`.
	 * @param {$RefParserOptions} [options] - Options that determine how the schema is parsed, resolved, and dereferenced
	 * @param {function} [callback] - An error-first callback. The second parameter is the bundled JSON schema object
	 * @returns {Promise} - The returned promise resolves with the bundled JSON schema object.
	 */
	$RefParser$1.prototype.bundle = async function bundle (path, schema, options, callback) {
	  let me = this;
	  let args = normalizeArgs$1(arguments);

	  try {
	    await this.resolve(args.path, args.schema, args.options);
	    _bundle(me, args.options);
	    finalize(me);
	    return maybe$1(args.callback, Promise.resolve(me.schema));
	  }
	  catch (err) {
	    return maybe$1(args.callback, Promise.reject(err));
	  }
	};

	/**
	 * Parses the given JSON schema, resolves any JSON references, and dereferences the JSON schema.
	 * That is, all JSON references are replaced with their resolved values.
	 *
	 * @param {string} [path] - The file path or URL of the JSON schema
	 * @param {object} [schema] - A JSON schema object. This object will be used instead of reading from `path`.
	 * @param {$RefParserOptions} [options] - Options that determine how the schema is parsed, resolved, and dereferenced
	 * @param {function} [callback] - An error-first callback. The second parameter is the dereferenced JSON schema object
	 * @returns {Promise} - The returned promise resolves with the dereferenced JSON schema object.
	 */
	$RefParser$1.dereference = function dereference (path, schema, options, callback) {
	  let Class = this; // eslint-disable-line consistent-this
	  let instance = new Class();
	  return instance.dereference.apply(instance, arguments);
	};

	/**
	 * Parses the given JSON schema, resolves any JSON references, and dereferences the JSON schema.
	 * That is, all JSON references are replaced with their resolved values.
	 *
	 * @param {string} [path] - The file path or URL of the JSON schema
	 * @param {object} [schema] - A JSON schema object. This object will be used instead of reading from `path`.
	 * @param {$RefParserOptions} [options] - Options that determine how the schema is parsed, resolved, and dereferenced
	 * @param {function} [callback] - An error-first callback. The second parameter is the dereferenced JSON schema object
	 * @returns {Promise} - The returned promise resolves with the dereferenced JSON schema object.
	 */
	$RefParser$1.prototype.dereference = async function dereference (path, schema, options, callback) {
	  let me = this;
	  let args = normalizeArgs$1(arguments);

	  try {
	    await this.resolve(args.path, args.schema, args.options);
	    _dereference(me, args.options);
	    finalize(me);
	    return maybe$1(args.callback, Promise.resolve(me.schema));
	  }
	  catch (err) {
	    return maybe$1(args.callback, Promise.reject(err));
	  }
	};

	function finalize (parser) {
	  const errors = JSONParserErrorGroup.getParserErrors(parser);
	  if (errors.length > 0) {
	    throw new JSONParserErrorGroup(parser);
	  }
	}

	/* eslint-disable no-unused-vars */

	const validateSchema = schema$1;
	const validateSpec$1 = spec;
	const normalizeArgs = normalizeArgs_1;
	const util = util$5;
	const Options = options;
	const maybe = maybe$2;
	const { ono } = require$$6;
	const $RefParser = libExports;
	const dereference = dereference_1;

	var lib = SwaggerParser;

	/**
	 * This class parses a Swagger 2.0 or 3.0 API, resolves its JSON references and their resolved values,
	 * and provides methods for traversing, dereferencing, and validating the API.
	 *
	 * @class
	 * @augments $RefParser
	 */
	function SwaggerParser () {
	  $RefParser.apply(this, arguments);
	}

	util.inherits(SwaggerParser, $RefParser);
	SwaggerParser.parse = $RefParser.parse;
	SwaggerParser.resolve = $RefParser.resolve;
	SwaggerParser.bundle = $RefParser.bundle;
	SwaggerParser.dereference = $RefParser.dereference;

	/**
	 * Alias {@link $RefParser#schema} as {@link SwaggerParser#api}
	 */
	Object.defineProperty(SwaggerParser.prototype, "api", {
	  configurable: true,
	  enumerable: true,
	  get () {
	    return this.schema;
	  }
	});

	/**
	 * Parses the given Swagger API.
	 * This method does not resolve any JSON references.
	 * It just reads a single file in JSON or YAML format, and parse it as a JavaScript object.
	 *
	 * @param {string} [path] - The file path or URL of the JSON schema
	 * @param {object} [api] - The Swagger API object. This object will be used instead of reading from `path`.
	 * @param {ParserOptions} [options] - Options that determine how the API is parsed
	 * @param {Function} [callback] - An error-first callback. The second parameter is the parsed API object.
	 * @returns {Promise} - The returned promise resolves with the parsed API object.
	 */
	SwaggerParser.prototype.parse = async function (path, api, options, callback) {
	  let args = normalizeArgs(arguments);
	  args.options = new Options(args.options);

	  try {
	    let schema = await $RefParser.prototype.parse.call(this, args.path, args.schema, args.options);

	    if (schema.swagger) {
	      // Verify that the parsed object is a Swagger API
	      if (schema.swagger === undefined || schema.info === undefined || schema.paths === undefined) {
	        throw ono.syntax(`${args.path || args.schema} is not a valid Swagger API definition`);
	      }
	      else if (typeof schema.swagger === "number") {
	        // This is a very common mistake, so give a helpful error message
	        throw ono.syntax('Swagger version number must be a string (e.g. "2.0") not a number.');
	      }
	      else if (typeof schema.info.version === "number") {
	        // This is a very common mistake, so give a helpful error message
	        throw ono.syntax('API version number must be a string (e.g. "1.0.0") not a number.');
	      }
	      else if (schema.swagger !== "2.0") {
	        throw ono.syntax(`Unrecognized Swagger version: ${schema.swagger}. Expected 2.0`);
	      }
	    }
	    else {
	      let supportedVersions = ["3.0.0", "3.0.1", "3.0.2", "3.0.3"];

	      // Verify that the parsed object is a Openapi API
	      if (schema.openapi === undefined || schema.info === undefined || schema.paths === undefined) {
	        throw ono.syntax(`${args.path || args.schema} is not a valid Openapi API definition`);
	      }
	      else if (typeof schema.openapi === "number") {
	        // This is a very common mistake, so give a helpful error message
	        throw ono.syntax('Openapi version number must be a string (e.g. "3.0.0") not a number.');
	      }
	      else if (typeof schema.info.version === "number") {
	        // This is a very common mistake, so give a helpful error message
	        throw ono.syntax('API version number must be a string (e.g. "1.0.0") not a number.');
	      }
	      else if (supportedVersions.indexOf(schema.openapi) === -1) {
	        throw ono.syntax(
	          `Unsupported OpenAPI version: ${schema.openapi}. ` +
	          `Swagger Parser only supports versions ${supportedVersions.join(", ")}`
	        );
	      }
	    }

	    // Looks good!
	    return maybe(args.callback, Promise.resolve(schema));
	  }
	  catch (err) {
	    return maybe(args.callback, Promise.reject(err));
	  }
	};

	/**
	 * Parses, dereferences, and validates the given Swagger API.
	 * Depending on the options, validation can include JSON Schema validation and/or Swagger Spec validation.
	 *
	 * @param {string} [path] - The file path or URL of the JSON schema
	 * @param {object} [api] - The Swagger API object. This object will be used instead of reading from `path`.
	 * @param {ParserOptions} [options] - Options that determine how the API is parsed, dereferenced, and validated
	 * @param {Function} [callback] - An error-first callback. The second parameter is the parsed API object.
	 * @returns {Promise} - The returned promise resolves with the parsed API object.
	 */
	SwaggerParser.validate = function (path, api, options, callback) {
	  let Class = this; // eslint-disable-line consistent-this
	  let instance = new Class();
	  return instance.validate.apply(instance, arguments);
	};

	/**
	 * Parses, dereferences, and validates the given Swagger API.
	 * Depending on the options, validation can include JSON Schema validation and/or Swagger Spec validation.
	 *
	 * @param {string} [path] - The file path or URL of the JSON schema
	 * @param {object} [api] - The Swagger API object. This object will be used instead of reading from `path`.
	 * @param {ParserOptions} [options] - Options that determine how the API is parsed, dereferenced, and validated
	 * @param {Function} [callback] - An error-first callback. The second parameter is the parsed API object.
	 * @returns {Promise} - The returned promise resolves with the parsed API object.
	 */
	SwaggerParser.prototype.validate = async function (path, api, options, callback) {
	  let me = this;
	  let args = normalizeArgs(arguments);
	  args.options = new Options(args.options);

	  // ZSchema doesn't support circular objects, so don't dereference circular $refs yet
	  // (see https://github.com/zaggino/z-schema/issues/137)
	  let circular$RefOption = args.options.dereference.circular;
	  args.options.validate.schema && (args.options.dereference.circular = "ignore");

	  try {
	    await this.dereference(args.path, args.schema, args.options);

	    // Restore the original options, now that we're done dereferencing
	    args.options.dereference.circular = circular$RefOption;

	    if (args.options.validate.schema) {
	      // Validate the API against the Swagger schema
	      // NOTE: This is safe to do, because we haven't dereferenced circular $refs yet
	      validateSchema(me.api);

	      if (me.$refs.circular) {
	        if (circular$RefOption === true) {
	          // The API has circular references,
	          // so we need to do a second-pass to fully-dereference it
	          dereference(me, args.options);
	        }
	        else if (circular$RefOption === false) {
	          // The API has circular references, and they're not allowed, so throw an error
	          throw ono.reference("The API contains circular references");
	        }
	      }
	    }

	    if (args.options.validate.spec) {
	      // Validate the API against the Swagger spec
	      validateSpec$1(me.api);
	    }

	    return maybe(args.callback, Promise.resolve(me.schema));
	  }
	  catch (err) {
	    return maybe(args.callback, Promise.reject(err));
	  }
	};

	/*
	 * liquidjs@10.3.2, https://github.com/harttle/liquidjs
	 * (c) 2016-2022 harttle
	 * Released under the MIT License.
	 */
	class Token {
	    constructor(kind, input, begin, end, file) {
	        this.kind = kind;
	        this.input = input;
	        this.begin = begin;
	        this.end = end;
	        this.file = file;
	    }
	    getText() {
	        return this.input.slice(this.begin, this.end);
	    }
	    getPosition() {
	        let [row, col] = [1, 1];
	        for (let i = 0; i < this.begin; i++) {
	            if (this.input[i] === '\n') {
	                row++;
	                col = 1;
	            }
	            else
	                col++;
	        }
	        return [row, col];
	    }
	    size() {
	        return this.end - this.begin;
	    }
	}

	class Drop {
	    liquidMethodMissing(key) {
	        return undefined;
	    }
	}

	const toString$1 = Object.prototype.toString;
	const toLowerCase = String.prototype.toLowerCase;
	const hasOwnProperty = Object.hasOwnProperty;
	function isString(value) {
	    return typeof value === 'string';
	}
	// eslint-disable-next-line @typescript-eslint/ban-types
	function isFunction(value) {
	    return typeof value === 'function';
	}
	function isPromise(val) {
	    return val && isFunction(val.then);
	}
	function isIterator(val) {
	    return val && isFunction(val.next) && isFunction(val.throw) && isFunction(val.return);
	}
	function escapeRegex(str) {
	    return str.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
	}
	function stringify(value) {
	    value = toValue(value);
	    if (isString(value))
	        return value;
	    if (isNil(value))
	        return '';
	    if (isArray(value))
	        return value.map(x => stringify(x)).join('');
	    return String(value);
	}
	function toValue(value) {
	    return (value instanceof Drop && isFunction(value.valueOf)) ? value.valueOf() : value;
	}
	function isNumber(value) {
	    return typeof value === 'number';
	}
	function toLiquid(value) {
	    if (value && isFunction(value.toLiquid))
	        return toLiquid(value.toLiquid());
	    return value;
	}
	function isNil(value) {
	    return value == null;
	}
	function isArray(value) {
	    // be compatible with IE 8
	    return toString$1.call(value) === '[object Array]';
	}
	function isIterable(value) {
	    return isObject(value) && Symbol.iterator in value;
	}
	/*
	 * Iterates over own enumerable string keyed properties of an object and invokes iteratee for each property.
	 * The iteratee is invoked with three arguments: (value, key, object).
	 * Iteratee functions may exit iteration early by explicitly returning false.
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @return {Object} Returns object.
	 */
	function forOwn(obj, iteratee) {
	    obj = obj || {};
	    for (const k in obj) {
	        if (hasOwnProperty.call(obj, k)) {
	            if (iteratee(obj[k], k, obj) === false)
	                break;
	        }
	    }
	    return obj;
	}
	function last$1(arr) {
	    return arr[arr.length - 1];
	}
	/*
	 * Checks if value is the language type of Object.
	 * (e.g. arrays, functions, objects, regexes, new Number(0), and new String(''))
	 * @param {any} value The value to check.
	 * @return {Boolean} Returns true if value is an object, else false.
	 */
	function isObject(value) {
	    const type = typeof value;
	    return value !== null && (type === 'object' || type === 'function');
	}
	function range$1(start, stop, step = 1) {
	    const arr = [];
	    for (let i = start; i < stop; i += step) {
	        arr.push(i);
	    }
	    return arr;
	}
	function padStart(str, length, ch = ' ') {
	    return pad(str, length, ch, (str, ch) => ch + str);
	}
	function padEnd(str, length, ch = ' ') {
	    return pad(str, length, ch, (str, ch) => str + ch);
	}
	function pad(str, length, ch, add) {
	    str = String(str);
	    let n = length - str.length;
	    while (n-- > 0)
	        str = add(str, ch);
	    return str;
	}
	function identify(val) {
	    return val;
	}
	function changeCase(str) {
	    const hasLowerCase = [...str].some(ch => ch >= 'a' && ch <= 'z');
	    return hasLowerCase ? str.toUpperCase() : str.toLowerCase();
	}
	function ellipsis(str, N) {
	    return str.length > N ? str.slice(0, N - 3) + '...' : str;
	}
	// compare string in case-insensitive way, undefined values to the tail
	function caseInsensitiveCompare(a, b) {
	    if (a == null && b == null)
	        return 0;
	    if (a == null)
	        return 1;
	    if (b == null)
	        return -1;
	    a = toLowerCase.call(a);
	    b = toLowerCase.call(b);
	    if (a < b)
	        return -1;
	    if (a > b)
	        return 1;
	    return 0;
	}
	function argumentsToValue(fn) {
	    return (...args) => fn(...args.map(toValue));
	}
	function escapeRegExp(text) {
	    return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
	}

	class LiquidError extends Error {
	    constructor(err, token) {
	        super(err.message);
	        this.originalError = err;
	        this.token = token;
	        this.context = '';
	    }
	    update() {
	        const err = this.originalError;
	        this.context = mkContext(this.token);
	        this.message = mkMessage(err.message, this.token);
	        this.stack = this.message + '\n' + this.context +
	            '\n' + this.stack + '\nFrom ' + err.stack;
	    }
	}
	class TokenizationError extends LiquidError {
	    constructor(message, token) {
	        super(new Error(message), token);
	        this.name = 'TokenizationError';
	        super.update();
	    }
	}
	class ParseError extends LiquidError {
	    constructor(err, token) {
	        super(err, token);
	        this.name = 'ParseError';
	        this.message = err.message;
	        super.update();
	    }
	}
	class RenderError extends LiquidError {
	    constructor(err, tpl) {
	        super(err, tpl.token);
	        this.name = 'RenderError';
	        this.message = err.message;
	        super.update();
	    }
	    static is(obj) {
	        return obj.name === 'RenderError';
	    }
	}
	class UndefinedVariableError extends LiquidError {
	    constructor(err, token) {
	        super(err, token);
	        this.name = 'UndefinedVariableError';
	        this.message = err.message;
	        super.update();
	    }
	}
	// only used internally; raised where we don't have token information,
	// so it can't be an UndefinedVariableError.
	class InternalUndefinedVariableError extends Error {
	    constructor(variableName) {
	        super(`undefined variable: ${variableName}`);
	        this.name = 'InternalUndefinedVariableError';
	        this.variableName = variableName;
	    }
	}
	class AssertionError extends Error {
	    constructor(message) {
	        super(message);
	        this.name = 'AssertionError';
	        this.message = message + '';
	    }
	}
	function mkContext(token) {
	    const [line] = token.getPosition();
	    const lines = token.input.split('\n');
	    const begin = Math.max(line - 2, 1);
	    const end = Math.min(line + 3, lines.length);
	    const context = range$1(begin, end + 1)
	        .map(lineNumber => {
	        const indicator = (lineNumber === line) ? '>> ' : '   ';
	        const num = padStart(String(lineNumber), String(end).length);
	        const text = lines[lineNumber - 1];
	        return `${indicator}${num}| ${text}`;
	    })
	        .join('\n');
	    return context;
	}
	function mkMessage(msg, token) {
	    if (token.file)
	        msg += `, file:${token.file}`;
	    const [line, col] = token.getPosition();
	    msg += `, line:${line}, col:${col}`;
	    return msg;
	}

	// **DO NOT CHANGE THIS FILE**
	//
	// This file is generated by bin/character-gen.js
	// bitmask character types to boost performance
	const TYPES = [0, 0, 0, 0, 0, 0, 0, 0, 0, 20, 4, 4, 4, 20, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 20, 2, 8, 0, 0, 0, 0, 8, 0, 0, 0, 64, 0, 65, 0, 0, 33, 33, 33, 33, 33, 33, 33, 33, 33, 33, 0, 0, 2, 2, 2, 1, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 1, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0];
	const IDENTIFIER = 1;
	const BLANK = 4;
	const QUOTE = 8;
	const INLINE_BLANK = 16;
	const NUMBER = 32;
	const SIGN = 64;
	TYPES[160] = TYPES[5760] = TYPES[6158] = TYPES[8192] = TYPES[8193] = TYPES[8194] = TYPES[8195] = TYPES[8196] = TYPES[8197] = TYPES[8198] = TYPES[8199] = TYPES[8200] = TYPES[8201] = TYPES[8202] = TYPES[8232] = TYPES[8233] = TYPES[8239] = TYPES[8287] = TYPES[12288] = BLANK;

	function assert(predicate, message) {
	    if (!predicate) {
	        const msg = typeof message === 'function'
	            ? message()
	            : (message || `expect ${predicate} to be true`);
	        throw new AssertionError(msg);
	    }
	}

	class NullDrop extends Drop {
	    equals(value) {
	        return isNil(toValue(value));
	    }
	    gt() {
	        return false;
	    }
	    geq() {
	        return false;
	    }
	    lt() {
	        return false;
	    }
	    leq() {
	        return false;
	    }
	    valueOf() {
	        return null;
	    }
	}

	class EmptyDrop extends Drop {
	    equals(value) {
	        if (value instanceof EmptyDrop)
	            return false;
	        value = toValue(value);
	        if (isString(value) || isArray(value))
	            return value.length === 0;
	        if (isObject(value))
	            return Object.keys(value).length === 0;
	        return false;
	    }
	    gt() {
	        return false;
	    }
	    geq() {
	        return false;
	    }
	    lt() {
	        return false;
	    }
	    leq() {
	        return false;
	    }
	    valueOf() {
	        return '';
	    }
	}

	class BlankDrop extends EmptyDrop {
	    equals(value) {
	        if (value === false)
	            return true;
	        if (isNil(toValue(value)))
	            return true;
	        if (isString(value))
	            return /^\s*$/.test(value);
	        return super.equals(value);
	    }
	}

	class ForloopDrop extends Drop {
	    constructor(length, collection, variable) {
	        super();
	        this.i = 0;
	        this.length = length;
	        this.name = `${variable}-${collection}`;
	    }
	    next() {
	        this.i++;
	    }
	    index0() {
	        return this.i;
	    }
	    index() {
	        return this.i + 1;
	    }
	    first() {
	        return this.i === 0;
	    }
	    last() {
	        return this.i === this.length - 1;
	    }
	    rindex() {
	        return this.length - this.i;
	    }
	    rindex0() {
	        return this.length - this.i - 1;
	    }
	    valueOf() {
	        return JSON.stringify(this);
	    }
	}

	class BlockDrop extends Drop {
	    constructor(
	    // the block render from layout template
	    superBlockRender = () => '') {
	        super();
	        this.superBlockRender = superBlockRender;
	    }
	    /**
	     * Provide parent access in child block by
	     * {{ block.super }}
	     */
	    super() {
	        return this.superBlockRender();
	    }
	}

	function isComparable(arg) {
	    return arg && isFunction(arg.equals);
	}

	const nil = new NullDrop();
	const literalValues = {
	    'true': true,
	    'false': false,
	    'nil': nil,
	    'null': nil,
	    'empty': new EmptyDrop(),
	    'blank': new BlankDrop()
	};

	function createTrie(operators) {
	    const trie = {};
	    for (const [name, handler] of Object.entries(operators)) {
	        let node = trie;
	        for (let i = 0; i < name.length; i++) {
	            const c = name[i];
	            node[c] = node[c] || {};
	            if (i === name.length - 1 && (TYPES[name.charCodeAt(i)] & IDENTIFIER)) {
	                node[c].needBoundary = true;
	            }
	            node = node[c];
	        }
	        node.handler = handler;
	        node.end = true;
	    }
	    return trie;
	}

	/*! *****************************************************************************
	Copyright (c) Microsoft Corporation.

	Permission to use, copy, modify, and/or distribute this software for any
	purpose with or without fee is hereby granted.

	THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
	REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
	AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
	INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
	LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
	OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
	PERFORMANCE OF THIS SOFTWARE.
	***************************************************************************** */

	var __assign = function() {
	    __assign = Object.assign || function __assign(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};

	function __awaiter(thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	}

	// convert an async iterator to a Promise
	function toPromise(val) {
	    return __awaiter(this, void 0, void 0, function* () {
	        if (!isIterator(val))
	            return val;
	        let value;
	        let done = false;
	        let next = 'next';
	        do {
	            const state = val[next](value);
	            done = state.done;
	            value = state.value;
	            next = 'next';
	            try {
	                if (isIterator(value))
	                    value = toPromise(value);
	                if (isPromise(value))
	                    value = yield value;
	            }
	            catch (err) {
	                next = 'throw';
	                value = err;
	            }
	        } while (!done);
	        return value;
	    });
	}
	// convert an async iterator to a value in a synchronous manner
	function toValueSync(val) {
	    if (!isIterator(val))
	        return val;
	    let value;
	    let done = false;
	    let next = 'next';
	    do {
	        const state = val[next](value);
	        done = state.done;
	        value = state.value;
	        next = 'next';
	        if (isIterator(value)) {
	            try {
	                value = toValueSync(value);
	            }
	            catch (err) {
	                next = 'throw';
	                value = err;
	            }
	        }
	    } while (!done);
	    return value;
	}

	function toEnumerable(val) {
	    val = toValue(val);
	    if (isArray(val))
	        return val;
	    if (isString(val) && val.length > 0)
	        return [val];
	    if (isIterable(val))
	        return Array.from(val);
	    if (isObject(val))
	        return Object.keys(val).map((key) => [key, val[key]]);
	    return [];
	}
	function toArray(val) {
	    if (isNil(val))
	        return [];
	    if (isArray(val))
	        return val;
	    return [val];
	}

	const rFormat = /%([-_0^#:]+)?(\d+)?([EO])?(.)/;
	const monthNames = [
	    'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August',
	    'September', 'October', 'November', 'December'
	];
	const dayNames = [
	    'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'
	];
	const monthNamesShort = monthNames.map(abbr);
	const dayNamesShort = dayNames.map(abbr);
	const suffixes = {
	    1: 'st',
	    2: 'nd',
	    3: 'rd',
	    'default': 'th'
	};
	function abbr(str) {
	    return str.slice(0, 3);
	}
	// prototype extensions
	function daysInMonth(d) {
	    const feb = isLeapYear(d) ? 29 : 28;
	    return [31, feb, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
	}
	function getDayOfYear(d) {
	    let num = 0;
	    for (let i = 0; i < d.getMonth(); ++i) {
	        num += daysInMonth(d)[i];
	    }
	    return num + d.getDate();
	}
	function getWeekOfYear(d, startDay) {
	    // Skip to startDay of this week
	    const now = getDayOfYear(d) + (startDay - d.getDay());
	    // Find the first startDay of the year
	    const jan1 = new Date(d.getFullYear(), 0, 1);
	    const then = (7 - jan1.getDay() + startDay);
	    return String(Math.floor((now - then) / 7) + 1);
	}
	function isLeapYear(d) {
	    const year = d.getFullYear();
	    return !!((year & 3) === 0 && (year % 100 || (year % 400 === 0 && year)));
	}
	function getSuffix(d) {
	    const str = d.getDate().toString();
	    const index = parseInt(str.slice(-1));
	    return suffixes[index] || suffixes['default'];
	}
	function century(d) {
	    return parseInt(d.getFullYear().toString().substring(0, 2), 10);
	}
	// default to 0
	const padWidths = {
	    d: 2,
	    e: 2,
	    H: 2,
	    I: 2,
	    j: 3,
	    k: 2,
	    l: 2,
	    L: 3,
	    m: 2,
	    M: 2,
	    S: 2,
	    U: 2,
	    W: 2
	};
	// default to '0'
	const padChars = {
	    a: ' ',
	    A: ' ',
	    b: ' ',
	    B: ' ',
	    c: ' ',
	    e: ' ',
	    k: ' ',
	    l: ' ',
	    p: ' ',
	    P: ' '
	};
	const formatCodes = {
	    a: (d) => dayNamesShort[d.getDay()],
	    A: (d) => dayNames[d.getDay()],
	    b: (d) => monthNamesShort[d.getMonth()],
	    B: (d) => monthNames[d.getMonth()],
	    c: (d) => d.toLocaleString(),
	    C: (d) => century(d),
	    d: (d) => d.getDate(),
	    e: (d) => d.getDate(),
	    H: (d) => d.getHours(),
	    I: (d) => String(d.getHours() % 12 || 12),
	    j: (d) => getDayOfYear(d),
	    k: (d) => d.getHours(),
	    l: (d) => String(d.getHours() % 12 || 12),
	    L: (d) => d.getMilliseconds(),
	    m: (d) => d.getMonth() + 1,
	    M: (d) => d.getMinutes(),
	    N: (d, opts) => {
	        const width = Number(opts.width) || 9;
	        const str = String(d.getMilliseconds()).slice(0, width);
	        return padEnd(str, width, '0');
	    },
	    p: (d) => (d.getHours() < 12 ? 'AM' : 'PM'),
	    P: (d) => (d.getHours() < 12 ? 'am' : 'pm'),
	    q: (d) => getSuffix(d),
	    s: (d) => Math.round(d.getTime() / 1000),
	    S: (d) => d.getSeconds(),
	    u: (d) => d.getDay() || 7,
	    U: (d) => getWeekOfYear(d, 0),
	    w: (d) => d.getDay(),
	    W: (d) => getWeekOfYear(d, 1),
	    x: (d) => d.toLocaleDateString(),
	    X: (d) => d.toLocaleTimeString(),
	    y: (d) => d.getFullYear().toString().slice(2, 4),
	    Y: (d) => d.getFullYear(),
	    z: (d, opts) => {
	        const nOffset = Math.abs(d.getTimezoneOffset());
	        const h = Math.floor(nOffset / 60);
	        const m = nOffset % 60;
	        return (d.getTimezoneOffset() > 0 ? '-' : '+') +
	            padStart(h, 2, '0') +
	            (opts.flags[':'] ? ':' : '') +
	            padStart(m, 2, '0');
	    },
	    't': () => '\t',
	    'n': () => '\n',
	    '%': () => '%'
	};
	formatCodes.h = formatCodes.b;
	function strftime(d, formatStr) {
	    let output = '';
	    let remaining = formatStr;
	    let match;
	    while ((match = rFormat.exec(remaining))) {
	        output += remaining.slice(0, match.index);
	        remaining = remaining.slice(match.index + match[0].length);
	        output += format(d, match);
	    }
	    return output + remaining;
	}
	function format(d, match) {
	    const [input, flagStr = '', width, modifier, conversion] = match;
	    const convert = formatCodes[conversion];
	    if (!convert)
	        return input;
	    const flags = {};
	    for (const flag of flagStr)
	        flags[flag] = true;
	    let ret = String(convert(d, { flags, width, modifier }));
	    let padChar = padChars[conversion] || '0';
	    let padWidth = width || padWidths[conversion] || 0;
	    if (flags['^'])
	        ret = ret.toUpperCase();
	    else if (flags['#'])
	        ret = changeCase(ret);
	    if (flags['_'])
	        padChar = ' ';
	    else if (flags['0'])
	        padChar = '0';
	    if (flags['-'])
	        padWidth = 0;
	    return padStart(ret, padWidth, padChar);
	}

	// one minute in milliseconds
	const OneMinute = 60000;
	const hostTimezoneOffset = new Date().getTimezoneOffset();
	const ISO8601_TIMEZONE_PATTERN = /([zZ]|([+-])(\d{2}):(\d{2}))$/;
	/**
	 * A date implementation with timezone info, just like Ruby date
	 *
	 * Implementation:
	 * - create a Date offset by it's timezone difference, avoiding overriding a bunch of methods
	 * - rewrite getTimezoneOffset() to trick strftime
	 */
	class TimezoneDate {
	    constructor(init, timezoneOffset) {
	        if (init instanceof TimezoneDate) {
	            this.date = init.date;
	            timezoneOffset = init.timezoneOffset;
	        }
	        else {
	            const diff = (hostTimezoneOffset - timezoneOffset) * OneMinute;
	            const time = new Date(init).getTime() + diff;
	            this.date = new Date(time);
	        }
	        this.timezoneOffset = timezoneOffset;
	    }
	    getTime() {
	        return this.date.getTime();
	    }
	    getMilliseconds() {
	        return this.date.getMilliseconds();
	    }
	    getSeconds() {
	        return this.date.getSeconds();
	    }
	    getMinutes() {
	        return this.date.getMinutes();
	    }
	    getHours() {
	        return this.date.getHours();
	    }
	    getDay() {
	        return this.date.getDay();
	    }
	    getDate() {
	        return this.date.getDate();
	    }
	    getMonth() {
	        return this.date.getMonth();
	    }
	    getFullYear() {
	        return this.date.getFullYear();
	    }
	    toLocaleTimeString(locale) {
	        return this.date.toLocaleTimeString(locale);
	    }
	    toLocaleDateString(locale) {
	        return this.date.toLocaleDateString(locale);
	    }
	    getTimezoneOffset() {
	        return this.timezoneOffset;
	    }
	    /**
	     * Create a Date object fixed to it's declared Timezone. Both
	     * - 2021-08-06T02:29:00.000Z and
	     * - 2021-08-06T02:29:00.000+08:00
	     * will always be displayed as
	     * - 2021-08-06 02:29:00
	     * regardless timezoneOffset in JavaScript realm
	     *
	     * The implementation hack:
	     * Instead of calling `.getMonth()`/`.getUTCMonth()` respect to `preserveTimezones`,
	     * we create a different Date to trick strftime, it's both simpler and more performant.
	     * Given that a template is expected to be parsed fewer times than rendered.
	     */
	    static createDateFixedToTimezone(dateString) {
	        const m = dateString.match(ISO8601_TIMEZONE_PATTERN);
	        // representing a UTC timestamp
	        if (m && m[1] === 'Z') {
	            return new TimezoneDate(+new Date(dateString), 0);
	        }
	        // has a timezone specified
	        if (m && m[2] && m[3] && m[4]) {
	            const [, , sign, hours, minutes] = m;
	            const delta = (sign === '+' ? -1 : 1) * (parseInt(hours, 10) * 60 + parseInt(minutes, 10));
	            return new TimezoneDate(+new Date(dateString), delta);
	        }
	        return new Date(dateString);
	    }
	}

	class DelimitedToken extends Token {
	    constructor(kind, content, input, begin, end, trimLeft, trimRight, file) {
	        super(kind, input, begin, end, file);
	        this.trimLeft = false;
	        this.trimRight = false;
	        this.content = this.getText();
	        const tl = content[0] === '-';
	        const tr = last$1(content) === '-';
	        this.content = content
	            .slice(tl ? 1 : 0, tr ? -1 : content.length)
	            .trim();
	        this.trimLeft = tl || trimLeft;
	        this.trimRight = tr || trimRight;
	    }
	}

	class TagToken extends DelimitedToken {
	    constructor(input, begin, end, options, file) {
	        const { trimTagLeft, trimTagRight, tagDelimiterLeft, tagDelimiterRight } = options;
	        const value = input.slice(begin + tagDelimiterLeft.length, end - tagDelimiterRight.length);
	        super(TokenKind.Tag, value, input, begin, end, trimTagLeft, trimTagRight, file);
	        const tokenizer = new Tokenizer(this.content, options.operators);
	        this.name = tokenizer.readTagName();
	        if (!this.name)
	            throw new TokenizationError(`illegal tag syntax`, this);
	        tokenizer.skipBlank();
	        this.args = tokenizer.remaining();
	    }
	}

	class OutputToken extends DelimitedToken {
	    constructor(input, begin, end, options, file) {
	        const { trimOutputLeft, trimOutputRight, outputDelimiterLeft, outputDelimiterRight } = options;
	        const value = input.slice(begin + outputDelimiterLeft.length, end - outputDelimiterRight.length);
	        super(TokenKind.Output, value, input, begin, end, trimOutputLeft, trimOutputRight, file);
	    }
	}

	class HTMLToken extends Token {
	    constructor(input, begin, end, file) {
	        super(TokenKind.HTML, input, begin, end, file);
	        this.input = input;
	        this.begin = begin;
	        this.end = end;
	        this.file = file;
	        this.trimLeft = 0;
	        this.trimRight = 0;
	    }
	    getContent() {
	        return this.input.slice(this.begin + this.trimLeft, this.end - this.trimRight);
	    }
	}

	class NumberToken extends Token {
	    constructor(whole, decimal) {
	        super(TokenKind.Number, whole.input, whole.begin, decimal ? decimal.end : whole.end, whole.file);
	        this.whole = whole;
	        this.decimal = decimal;
	    }
	}

	class IdentifierToken extends Token {
	    constructor(input, begin, end, file) {
	        super(TokenKind.Word, input, begin, end, file);
	        this.input = input;
	        this.begin = begin;
	        this.end = end;
	        this.file = file;
	        this.content = this.getText();
	    }
	    isNumber(allowSign = false) {
	        const begin = allowSign && TYPES[this.input.charCodeAt(this.begin)] & SIGN
	            ? this.begin + 1
	            : this.begin;
	        for (let i = begin; i < this.end; i++) {
	            if (!(TYPES[this.input.charCodeAt(i)] & NUMBER))
	                return false;
	        }
	        return true;
	    }
	}

	class LiteralToken extends Token {
	    constructor(input, begin, end, file) {
	        super(TokenKind.Literal, input, begin, end, file);
	        this.input = input;
	        this.begin = begin;
	        this.end = end;
	        this.file = file;
	        this.literal = this.getText();
	    }
	}

	const precedence = {
	    '==': 1,
	    '!=': 1,
	    '>': 1,
	    '<': 1,
	    '>=': 1,
	    '<=': 1,
	    'contains': 1,
	    'and': 0,
	    'or': 0
	};
	class OperatorToken extends Token {
	    constructor(input, begin, end, file) {
	        super(TokenKind.Operator, input, begin, end, file);
	        this.input = input;
	        this.begin = begin;
	        this.end = end;
	        this.file = file;
	        this.operator = this.getText();
	    }
	    getPrecedence() {
	        const key = this.getText();
	        return key in precedence ? precedence[key] : 1;
	    }
	}

	class PropertyAccessToken extends Token {
	    constructor(variable, props, end) {
	        super(TokenKind.PropertyAccess, variable.input, variable.begin, end, variable.file);
	        this.variable = variable;
	        this.props = props;
	        this.propertyName = this.variable instanceof IdentifierToken
	            ? this.variable.getText()
	            : parseStringLiteral(this.variable.getText());
	    }
	}

	class FilterToken extends Token {
	    constructor(name, args, input, begin, end, file) {
	        super(TokenKind.Filter, input, begin, end, file);
	        this.name = name;
	        this.args = args;
	    }
	}

	class HashToken extends Token {
	    constructor(input, begin, end, name, value, file) {
	        super(TokenKind.Hash, input, begin, end, file);
	        this.input = input;
	        this.begin = begin;
	        this.end = end;
	        this.name = name;
	        this.value = value;
	        this.file = file;
	    }
	}

	class QuotedToken extends Token {
	    constructor(input, begin, end, file) {
	        super(TokenKind.Quoted, input, begin, end, file);
	        this.input = input;
	        this.begin = begin;
	        this.end = end;
	        this.file = file;
	    }
	}

	class RangeToken extends Token {
	    constructor(input, begin, end, lhs, rhs, file) {
	        super(TokenKind.Range, input, begin, end, file);
	        this.input = input;
	        this.begin = begin;
	        this.end = end;
	        this.lhs = lhs;
	        this.rhs = rhs;
	        this.file = file;
	    }
	}

	class LiquidTagToken extends DelimitedToken {
	    constructor(input, begin, end, options, file) {
	        const value = input.slice(begin, end);
	        super(TokenKind.Tag, value, input, begin, end, false, false, file);
	        if (!/\S/.test(value)) {
	            // A line that contains only whitespace.
	            this.name = '';
	            this.args = '';
	        }
	        else {
	            const tokenizer = new Tokenizer(this.content, options.operators);
	            this.name = tokenizer.readTagName();
	            if (!this.name)
	                throw new TokenizationError(`illegal liquid tag syntax`, this);
	            tokenizer.skipBlank();
	            this.args = tokenizer.remaining();
	        }
	    }
	}

	class SimpleEmitter {
	    constructor() {
	        this.buffer = '';
	    }
	    write(html) {
	        this.buffer += stringify(html);
	    }
	}

	class StreamedEmitter {
	    constructor() {
	        this.buffer = '';
	        this.stream = null;
	        throw new Error('streaming not supported in browser');
	    }
	}

	class KeepingTypeEmitter {
	    constructor() {
	        this.buffer = '';
	    }
	    write(html) {
	        html = toValue(html);
	        // This will only preserve the type if the value is isolated.
	        // I.E:
	        // {{ my-port }} -> 42
	        // {{ my-host }}:{{ my-port }} -> 'host:42'
	        if (typeof html !== 'string' && this.buffer === '') {
	            this.buffer = html;
	        }
	        else {
	            this.buffer = stringify(this.buffer) + stringify(html);
	        }
	    }
	}

	class Render {
	    renderTemplatesToNodeStream(templates, ctx) {
	        const emitter = new StreamedEmitter();
	        Promise.resolve().then(() => toPromise(this.renderTemplates(templates, ctx, emitter)))
	            .then(() => emitter.end(), err => emitter.error(err));
	        return emitter.stream;
	    }
	    *renderTemplates(templates, ctx, emitter) {
	        if (!emitter) {
	            emitter = ctx.opts.keepOutputType ? new KeepingTypeEmitter() : new SimpleEmitter();
	        }
	        for (const tpl of templates) {
	            try {
	                // if tpl.render supports emitter, it'll return empty `html`
	                const html = yield tpl.render(ctx, emitter);
	                // if not, it'll return an `html`, write to the emitter for it
	                html && emitter.write(html);
	                if (emitter['break'] || emitter['continue'])
	                    break;
	            }
	            catch (e) {
	                const err = RenderError.is(e) ? e : new RenderError(e, tpl);
	                throw err;
	            }
	        }
	        return emitter.buffer;
	    }
	}

	class Expression {
	    constructor(tokens) {
	        this.postfix = [...toPostfix(tokens)];
	    }
	    *evaluate(ctx, lenient) {
	        assert(ctx, 'unable to evaluate: context not defined');
	        const operands = [];
	        for (const token of this.postfix) {
	            if (isOperatorToken(token)) {
	                const r = operands.pop();
	                const l = operands.pop();
	                const result = yield evalOperatorToken(ctx.opts.operators, token, l, r, ctx);
	                operands.push(result);
	            }
	            else {
	                operands.push(yield evalToken(token, ctx, lenient && this.postfix.length === 1));
	            }
	        }
	        return operands[0];
	    }
	}
	function* evalToken(token, ctx, lenient = false) {
	    if (isPropertyAccessToken(token))
	        return yield evalPropertyAccessToken(token, ctx, lenient);
	    if (isRangeToken(token))
	        return yield evalRangeToken(token, ctx);
	    if (isLiteralToken(token))
	        return evalLiteralToken(token);
	    if (isNumberToken(token))
	        return evalNumberToken(token);
	    if (isWordToken(token))
	        return token.getText();
	    if (isQuotedToken(token))
	        return evalQuotedToken(token);
	}
	function* evalPropertyAccessToken(token, ctx, lenient) {
	    const props = [];
	    for (const prop of token.props) {
	        props.push((yield evalToken(prop, ctx, false)));
	    }
	    try {
	        return yield ctx._get([token.propertyName, ...props]);
	    }
	    catch (e) {
	        if (lenient && e.name === 'InternalUndefinedVariableError')
	            return null;
	        throw (new UndefinedVariableError(e, token));
	    }
	}
	function evalNumberToken(token) {
	    const str = token.whole.content + '.' + (token.decimal ? token.decimal.content : '');
	    return Number(str);
	}
	function evalQuotedToken(token) {
	    return parseStringLiteral(token.getText());
	}
	function evalOperatorToken(operators, token, lhs, rhs, ctx) {
	    const impl = operators[token.operator];
	    return impl(lhs, rhs, ctx);
	}
	function evalLiteralToken(token) {
	    return literalValues[token.literal];
	}
	function* evalRangeToken(token, ctx) {
	    const low = yield evalToken(token.lhs, ctx);
	    const high = yield evalToken(token.rhs, ctx);
	    return range$1(+low, +high + 1);
	}
	function* toPostfix(tokens) {
	    const ops = [];
	    for (const token of tokens) {
	        if (isOperatorToken(token)) {
	            while (ops.length && ops[ops.length - 1].getPrecedence() > token.getPrecedence()) {
	                yield ops.pop();
	            }
	            ops.push(token);
	        }
	        else
	            yield token;
	    }
	    while (ops.length) {
	        yield ops.pop();
	    }
	}

	function isTruthy(val, ctx) {
	    return !isFalsy(val, ctx);
	}
	function isFalsy(val, ctx) {
	    if (ctx.opts.jsTruthy) {
	        return !val;
	    }
	    else {
	        return val === false || undefined === val || val === null;
	    }
	}

	const defaultOperators = {
	    '==': (l, r) => {
	        if (isComparable(l))
	            return l.equals(r);
	        if (isComparable(r))
	            return r.equals(l);
	        return toValue(l) === toValue(r);
	    },
	    '!=': (l, r) => {
	        if (isComparable(l))
	            return !l.equals(r);
	        if (isComparable(r))
	            return !r.equals(l);
	        return toValue(l) !== toValue(r);
	    },
	    '>': (l, r) => {
	        if (isComparable(l))
	            return l.gt(r);
	        if (isComparable(r))
	            return r.lt(l);
	        return toValue(l) > toValue(r);
	    },
	    '<': (l, r) => {
	        if (isComparable(l))
	            return l.lt(r);
	        if (isComparable(r))
	            return r.gt(l);
	        return toValue(l) < toValue(r);
	    },
	    '>=': (l, r) => {
	        if (isComparable(l))
	            return l.geq(r);
	        if (isComparable(r))
	            return r.leq(l);
	        return toValue(l) >= toValue(r);
	    },
	    '<=': (l, r) => {
	        if (isComparable(l))
	            return l.leq(r);
	        if (isComparable(r))
	            return r.geq(l);
	        return toValue(l) <= toValue(r);
	    },
	    'contains': (l, r) => {
	        l = toValue(l);
	        r = toValue(r);
	        return l && isFunction(l.indexOf) ? l.indexOf(r) > -1 : false;
	    },
	    'and': (l, r, ctx) => isTruthy(toValue(l), ctx) && isTruthy(toValue(r), ctx),
	    'or': (l, r, ctx) => isTruthy(toValue(l), ctx) || isTruthy(toValue(r), ctx)
	};

	class Node$1 {
	    constructor(key, value, next, prev) {
	        this.key = key;
	        this.value = value;
	        this.next = next;
	        this.prev = prev;
	    }
	}
	class LRU {
	    constructor(limit, size = 0) {
	        this.limit = limit;
	        this.size = size;
	        this.cache = {};
	        this.head = new Node$1('HEAD', null, null, null);
	        this.tail = new Node$1('TAIL', null, null, null);
	        this.head.next = this.tail;
	        this.tail.prev = this.head;
	    }
	    write(key, value) {
	        if (this.cache[key]) {
	            this.cache[key].value = value;
	        }
	        else {
	            const node = new Node$1(key, value, this.head.next, this.head);
	            this.head.next.prev = node;
	            this.head.next = node;
	            this.cache[key] = node;
	            this.size++;
	            this.ensureLimit();
	        }
	    }
	    read(key) {
	        if (!this.cache[key])
	            return;
	        const { value } = this.cache[key];
	        this.remove(key);
	        this.write(key, value);
	        return value;
	    }
	    remove(key) {
	        const node = this.cache[key];
	        node.prev.next = node.next;
	        node.next.prev = node.prev;
	        delete this.cache[key];
	        this.size--;
	    }
	    clear() {
	        this.head.next = this.tail;
	        this.tail.prev = this.head;
	        this.size = 0;
	        this.cache = {};
	    }
	    ensureLimit() {
	        if (this.size > this.limit)
	            this.remove(this.tail.prev.key);
	    }
	}

	function domResolve(root, path) {
	    const base = document.createElement('base');
	    base.href = root;
	    const head = document.getElementsByTagName('head')[0];
	    head.insertBefore(base, head.firstChild);
	    const a = document.createElement('a');
	    a.href = path;
	    const resolved = a.href;
	    head.removeChild(base);
	    return resolved;
	}
	function resolve(root, filepath, ext) {
	    if (root.length && last$1(root) !== '/')
	        root += '/';
	    const url = domResolve(root, filepath);
	    return url.replace(/^(\w+:\/\/[^/]+)(\/[^?]+)/, (str, origin, path) => {
	        const last = path.split('/').pop();
	        if (/\.\w+$/.test(last))
	            return str;
	        return origin + path + ext;
	    });
	}
	function readFile(url) {
	    return __awaiter(this, void 0, void 0, function* () {
	        return new Promise((resolve, reject) => {
	            const xhr = new XMLHttpRequest();
	            xhr.onload = () => {
	                if (xhr.status >= 200 && xhr.status < 300) {
	                    resolve(xhr.responseText);
	                }
	                else {
	                    reject(new Error(xhr.statusText));
	                }
	            };
	            xhr.onerror = () => {
	                reject(new Error('An error occurred whilst receiving the response.'));
	            };
	            xhr.open('GET', url);
	            xhr.send();
	        });
	    });
	}
	function readFileSync(url) {
	    const xhr = new XMLHttpRequest();
	    xhr.open('GET', url, false);
	    xhr.send();
	    if (xhr.status < 200 || xhr.status >= 300) {
	        throw new Error(xhr.statusText);
	    }
	    return xhr.responseText;
	}
	function exists(filepath) {
	    return __awaiter(this, void 0, void 0, function* () {
	        return true;
	    });
	}
	function existsSync(filepath) {
	    return true;
	}
	function dirname(filepath) {
	    return domResolve(filepath, '.');
	}
	const sep = '/';

	var fs = /*#__PURE__*/Object.freeze({
	  __proto__: null,
	  resolve: resolve,
	  readFile: readFile,
	  readFileSync: readFileSync,
	  exists: exists,
	  existsSync: existsSync,
	  dirname: dirname,
	  sep: sep
	});

	function Default(value, defaultValue, ...args) {
	    value = toValue(value);
	    if (isArray(value) || isString(value))
	        return value.length ? value : defaultValue;
	    if (value === false && (new Map(args)).get('allow_false'))
	        return false;
	    return isFalsy(value, this.context) ? defaultValue : value;
	}
	function json(value) {
	    return JSON.stringify(value);
	}
	const raw = {
	    raw: true,
	    handler: identify
	};

	const escapeMap = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&#34;',
	    "'": '&#39;'
	};
	const unescapeMap = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&#34;': '"',
	    '&#39;': "'"
	};
	function escape$1(str) {
	    return stringify(str).replace(/&|<|>|"|'/g, m => escapeMap[m]);
	}
	function unescape(str) {
	    return stringify(str).replace(/&(amp|lt|gt|#34|#39);/g, m => unescapeMap[m]);
	}
	function escape_once(str) {
	    return escape$1(unescape(stringify(str)));
	}
	function newline_to_br(v) {
	    return stringify(v).replace(/\n/g, '<br />\n');
	}
	function strip_html(v) {
	    return stringify(v).replace(/<script.*?<\/script>|<!--.*?-->|<style.*?<\/style>|<.*?>/g, '');
	}

	var htmlFilters = /*#__PURE__*/Object.freeze({
	  __proto__: null,
	  escape: escape$1,
	  escape_once: escape_once,
	  newline_to_br: newline_to_br,
	  strip_html: strip_html
	});

	const defaultOptions = {
	    root: ['.'],
	    layouts: ['.'],
	    partials: ['.'],
	    relativeReference: true,
	    jekyllInclude: false,
	    cache: undefined,
	    extname: '',
	    fs: fs,
	    dynamicPartials: true,
	    jsTruthy: false,
	    trimTagRight: false,
	    trimTagLeft: false,
	    trimOutputRight: false,
	    trimOutputLeft: false,
	    greedy: true,
	    tagDelimiterLeft: '{%',
	    tagDelimiterRight: '%}',
	    outputDelimiterLeft: '{{',
	    outputDelimiterRight: '}}',
	    preserveTimezones: false,
	    strictFilters: false,
	    strictVariables: false,
	    ownPropertyOnly: true,
	    lenientIf: false,
	    globals: {},
	    keepOutputType: false,
	    operators: defaultOperators
	};
	function normalize(options) {
	    if (options.hasOwnProperty('root')) {
	        if (!options.hasOwnProperty('partials'))
	            options.partials = options.root;
	        if (!options.hasOwnProperty('layouts'))
	            options.layouts = options.root;
	    }
	    if (options.hasOwnProperty('cache')) {
	        let cache;
	        if (typeof options.cache === 'number')
	            cache = options.cache > 0 ? new LRU(options.cache) : undefined;
	        else if (typeof options.cache === 'object')
	            cache = options.cache;
	        else
	            cache = options.cache ? new LRU(1024) : undefined;
	        options.cache = cache;
	    }
	    options = Object.assign(Object.assign(Object.assign({}, defaultOptions), (options.jekyllInclude ? { dynamicPartials: false } : {})), options);
	    if (!options.fs.dirname && options.relativeReference) {
	        console.warn('[LiquidJS] `fs.dirname` is required for relativeReference, set relativeReference to `false` to suppress this warning, or provide implementation for `fs.dirname`');
	        options.relativeReference = false;
	    }
	    options.root = normalizeDirectoryList(options.root);
	    options.partials = normalizeDirectoryList(options.partials);
	    options.layouts = normalizeDirectoryList(options.layouts);
	    options.outputEscape = options.outputEscape && getOutputEscapeFunction(options.outputEscape);
	    return options;
	}
	function getOutputEscapeFunction(nameOrFunction) {
	    if (nameOrFunction === 'escape')
	        return escape$1;
	    if (nameOrFunction === 'json')
	        return json;
	    assert(isFunction(nameOrFunction), '`outputEscape` need to be of type string or function');
	    return nameOrFunction;
	}
	function normalizeDirectoryList(value) {
	    let list = [];
	    if (isArray(value))
	        list = value;
	    if (isString(value))
	        list = [value];
	    return list;
	}

	function matchOperator(str, begin, trie, end = str.length) {
	    let node = trie;
	    let i = begin;
	    let info;
	    while (node[str[i]] && i < end) {
	        node = node[str[i++]];
	        if (node['end'])
	            info = node;
	    }
	    if (!info)
	        return -1;
	    if (info['needBoundary'] && (TYPES[str.charCodeAt(i)] & IDENTIFIER))
	        return -1;
	    return i;
	}

	function whiteSpaceCtrl(tokens, options) {
	    let inRaw = false;
	    for (let i = 0; i < tokens.length; i++) {
	        const token = tokens[i];
	        if (!isDelimitedToken(token))
	            continue;
	        if (!inRaw && token.trimLeft) {
	            trimLeft(tokens[i - 1], options.greedy);
	        }
	        if (isTagToken(token)) {
	            if (token.name === 'raw')
	                inRaw = true;
	            else if (token.name === 'endraw')
	                inRaw = false;
	        }
	        if (!inRaw && token.trimRight) {
	            trimRight(tokens[i + 1], options.greedy);
	        }
	    }
	}
	function trimLeft(token, greedy) {
	    if (!token || !isHTMLToken(token))
	        return;
	    const mask = greedy ? BLANK : INLINE_BLANK;
	    while (TYPES[token.input.charCodeAt(token.end - 1 - token.trimRight)] & mask)
	        token.trimRight++;
	}
	function trimRight(token, greedy) {
	    if (!token || !isHTMLToken(token))
	        return;
	    const mask = greedy ? BLANK : INLINE_BLANK;
	    while (TYPES[token.input.charCodeAt(token.begin + token.trimLeft)] & mask)
	        token.trimLeft++;
	    if (token.input.charAt(token.begin + token.trimLeft) === '\n')
	        token.trimLeft++;
	}

	class Tokenizer {
	    constructor(input, operators = defaultOptions.operators, file) {
	        this.input = input;
	        this.file = file;
	        this.p = 0;
	        this.rawBeginAt = -1;
	        this.N = input.length;
	        this.opTrie = createTrie(operators);
	    }
	    readExpression() {
	        return new Expression(this.readExpressionTokens());
	    }
	    *readExpressionTokens() {
	        const operand = this.readValue();
	        if (!operand)
	            return;
	        yield operand;
	        while (this.p < this.N) {
	            const operator = this.readOperator();
	            if (!operator)
	                return;
	            const operand = this.readValue();
	            if (!operand)
	                return;
	            yield operator;
	            yield operand;
	        }
	    }
	    readOperator() {
	        this.skipBlank();
	        const end = matchOperator(this.input, this.p, this.opTrie);
	        if (end === -1)
	            return;
	        return new OperatorToken(this.input, this.p, (this.p = end), this.file);
	    }
	    readFilters() {
	        const filters = [];
	        while (true) {
	            const filter = this.readFilter();
	            if (!filter)
	                return filters;
	            filters.push(filter);
	        }
	    }
	    readFilter() {
	        this.skipBlank();
	        if (this.end())
	            return null;
	        assert(this.peek() === '|', () => `unexpected token at ${this.snapshot()}`);
	        this.p++;
	        const begin = this.p;
	        const name = this.readIdentifier();
	        if (!name.size())
	            return null;
	        const args = [];
	        this.skipBlank();
	        if (this.peek() === ':') {
	            do {
	                ++this.p;
	                const arg = this.readFilterArg();
	                arg && args.push(arg);
	                this.skipBlank();
	                assert(this.end() || this.peek() === ',' || this.peek() === '|', () => `unexpected character ${this.snapshot()}`);
	            } while (this.peek() === ',');
	        }
	        return new FilterToken(name.getText(), args, this.input, begin, this.p, this.file);
	    }
	    readFilterArg() {
	        const key = this.readValue();
	        if (!key)
	            return;
	        this.skipBlank();
	        if (this.peek() !== ':')
	            return key;
	        ++this.p;
	        const value = this.readValue();
	        return [key.getText(), value];
	    }
	    readTopLevelTokens(options = defaultOptions) {
	        const tokens = [];
	        while (this.p < this.N) {
	            const token = this.readTopLevelToken(options);
	            tokens.push(token);
	        }
	        whiteSpaceCtrl(tokens, options);
	        return tokens;
	    }
	    readTopLevelToken(options) {
	        const { tagDelimiterLeft, outputDelimiterLeft } = options;
	        if (this.rawBeginAt > -1)
	            return this.readEndrawOrRawContent(options);
	        if (this.match(tagDelimiterLeft))
	            return this.readTagToken(options);
	        if (this.match(outputDelimiterLeft))
	            return this.readOutputToken(options);
	        return this.readHTMLToken([tagDelimiterLeft, outputDelimiterLeft]);
	    }
	    readHTMLToken(stopStrings) {
	        const begin = this.p;
	        while (this.p < this.N) {
	            if (stopStrings.some(str => this.match(str)))
	                break;
	            ++this.p;
	        }
	        return new HTMLToken(this.input, begin, this.p, this.file);
	    }
	    readTagToken(options = defaultOptions) {
	        const { file, input } = this;
	        const begin = this.p;
	        if (this.readToDelimiter(options.tagDelimiterRight) === -1) {
	            throw this.mkError(`tag ${this.snapshot(begin)} not closed`, begin);
	        }
	        const token = new TagToken(input, begin, this.p, options, file);
	        if (token.name === 'raw')
	            this.rawBeginAt = begin;
	        return token;
	    }
	    readToDelimiter(delimiter) {
	        while (this.p < this.N) {
	            if ((this.peekType() & QUOTE)) {
	                this.readQuoted();
	                continue;
	            }
	            ++this.p;
	            if (this.rmatch(delimiter))
	                return this.p;
	        }
	        return -1;
	    }
	    readOutputToken(options = defaultOptions) {
	        const { file, input } = this;
	        const { outputDelimiterRight } = options;
	        const begin = this.p;
	        if (this.readToDelimiter(outputDelimiterRight) === -1) {
	            throw this.mkError(`output ${this.snapshot(begin)} not closed`, begin);
	        }
	        return new OutputToken(input, begin, this.p, options, file);
	    }
	    readEndrawOrRawContent(options) {
	        const { tagDelimiterLeft, tagDelimiterRight } = options;
	        const begin = this.p;
	        let leftPos = this.readTo(tagDelimiterLeft) - tagDelimiterLeft.length;
	        while (this.p < this.N) {
	            if (this.readIdentifier().getText() !== 'endraw') {
	                leftPos = this.readTo(tagDelimiterLeft) - tagDelimiterLeft.length;
	                continue;
	            }
	            while (this.p <= this.N) {
	                if (this.rmatch(tagDelimiterRight)) {
	                    const end = this.p;
	                    if (begin === leftPos) {
	                        this.rawBeginAt = -1;
	                        return new TagToken(this.input, begin, end, options, this.file);
	                    }
	                    else {
	                        this.p = leftPos;
	                        return new HTMLToken(this.input, begin, leftPos, this.file);
	                    }
	                }
	                if (this.rmatch(tagDelimiterLeft))
	                    break;
	                this.p++;
	            }
	        }
	        throw this.mkError(`raw ${this.snapshot(this.rawBeginAt)} not closed`, begin);
	    }
	    readLiquidTagTokens(options = defaultOptions) {
	        const tokens = [];
	        while (this.p < this.N) {
	            const token = this.readLiquidTagToken(options);
	            if (token.name)
	                tokens.push(token);
	        }
	        return tokens;
	    }
	    readLiquidTagToken(options) {
	        const { file, input } = this;
	        const begin = this.p;
	        let end = this.N;
	        if (this.readToDelimiter('\n') !== -1)
	            end = this.p;
	        return new LiquidTagToken(input, begin, end, options, file);
	    }
	    mkError(msg, begin) {
	        return new TokenizationError(msg, new IdentifierToken(this.input, begin, this.N, this.file));
	    }
	    snapshot(begin = this.p) {
	        return JSON.stringify(ellipsis(this.input.slice(begin), 16));
	    }
	    /**
	     * @deprecated
	     */
	    readWord() {
	        console.warn('Tokenizer#readWord() will be removed, use #readIdentifier instead');
	        return this.readIdentifier();
	    }
	    readIdentifier() {
	        this.skipBlank();
	        const begin = this.p;
	        while (this.peekType() & IDENTIFIER)
	            ++this.p;
	        return new IdentifierToken(this.input, begin, this.p, this.file);
	    }
	    readTagName() {
	        this.skipBlank();
	        // Handle inline comment tags
	        if (this.input[this.p] === '#')
	            return this.input.slice(this.p, ++this.p);
	        return this.readIdentifier().getText();
	    }
	    readHashes(jekyllStyle) {
	        const hashes = [];
	        while (true) {
	            const hash = this.readHash(jekyllStyle);
	            if (!hash)
	                return hashes;
	            hashes.push(hash);
	        }
	    }
	    readHash(jekyllStyle) {
	        this.skipBlank();
	        if (this.peek() === ',')
	            ++this.p;
	        const begin = this.p;
	        const name = this.readIdentifier();
	        if (!name.size())
	            return;
	        let value;
	        this.skipBlank();
	        const sep = jekyllStyle ? '=' : ':';
	        if (this.peek() === sep) {
	            ++this.p;
	            value = this.readValue();
	        }
	        return new HashToken(this.input, begin, this.p, name, value, this.file);
	    }
	    remaining() {
	        return this.input.slice(this.p);
	    }
	    advance(i = 1) {
	        this.p += i;
	    }
	    end() {
	        return this.p >= this.N;
	    }
	    readTo(end) {
	        while (this.p < this.N) {
	            ++this.p;
	            if (this.rmatch(end))
	                return this.p;
	        }
	        return -1;
	    }
	    readValue() {
	        const value = this.readQuoted() || this.readRange();
	        if (value)
	            return value;
	        if (this.peek() === '[') {
	            this.p++;
	            const prop = this.readQuoted();
	            if (!prop)
	                return;
	            if (this.peek() !== ']')
	                return;
	            this.p++;
	            return new PropertyAccessToken(prop, [], this.p);
	        }
	        const variable = this.readIdentifier();
	        if (!variable.size())
	            return;
	        let isNumber = variable.isNumber(true);
	        const props = [];
	        while (true) {
	            if (this.peek() === '[') {
	                isNumber = false;
	                this.p++;
	                const prop = this.readValue() || new IdentifierToken(this.input, this.p, this.p, this.file);
	                this.readTo(']');
	                props.push(prop);
	            }
	            else if (this.peek() === '.' && this.peek(1) !== '.') { // skip range syntax
	                this.p++;
	                const prop = this.readIdentifier();
	                if (!prop.size())
	                    break;
	                if (!prop.isNumber())
	                    isNumber = false;
	                props.push(prop);
	            }
	            else
	                break;
	        }
	        if (!props.length && literalValues.hasOwnProperty(variable.content)) {
	            return new LiteralToken(this.input, variable.begin, variable.end, this.file);
	        }
	        if (isNumber)
	            return new NumberToken(variable, props[0]);
	        return new PropertyAccessToken(variable, props, this.p);
	    }
	    readRange() {
	        this.skipBlank();
	        const begin = this.p;
	        if (this.peek() !== '(')
	            return;
	        ++this.p;
	        const lhs = this.readValueOrThrow();
	        this.p += 2;
	        const rhs = this.readValueOrThrow();
	        ++this.p;
	        return new RangeToken(this.input, begin, this.p, lhs, rhs, this.file);
	    }
	    readValueOrThrow() {
	        const value = this.readValue();
	        assert(value, () => `unexpected token ${this.snapshot()}, value expected`);
	        return value;
	    }
	    readQuoted() {
	        this.skipBlank();
	        const begin = this.p;
	        if (!(this.peekType() & QUOTE))
	            return;
	        ++this.p;
	        let escaped = false;
	        while (this.p < this.N) {
	            ++this.p;
	            if (this.input[this.p - 1] === this.input[begin] && !escaped)
	                break;
	            if (escaped)
	                escaped = false;
	            else if (this.input[this.p - 1] === '\\')
	                escaped = true;
	        }
	        return new QuotedToken(this.input, begin, this.p, this.file);
	    }
	    *readFileNameTemplate(options) {
	        const { outputDelimiterLeft } = options;
	        const htmlStopStrings = [',', ' ', outputDelimiterLeft];
	        const htmlStopStringSet = new Set(htmlStopStrings);
	        // break on ',' and ' ', outputDelimiterLeft only stops HTML token
	        while (this.p < this.N && !htmlStopStringSet.has(this.peek())) {
	            yield this.match(outputDelimiterLeft)
	                ? this.readOutputToken(options)
	                : this.readHTMLToken(htmlStopStrings);
	        }
	    }
	    match(word) {
	        for (let i = 0; i < word.length; i++) {
	            if (word[i] !== this.input[this.p + i])
	                return false;
	        }
	        return true;
	    }
	    rmatch(pattern) {
	        for (let i = 0; i < pattern.length; i++) {
	            if (pattern[pattern.length - 1 - i] !== this.input[this.p - 1 - i])
	                return false;
	        }
	        return true;
	    }
	    peekType(n = 0) {
	        return TYPES[this.input.charCodeAt(this.p + n)];
	    }
	    peek(n = 0) {
	        return this.input[this.p + n];
	    }
	    skipBlank() {
	        while (this.peekType() & BLANK)
	            ++this.p;
	    }
	}

	class ParseStream {
	    constructor(tokens, parseToken) {
	        this.handlers = {};
	        this.stopRequested = false;
	        this.tokens = tokens;
	        this.parseToken = parseToken;
	    }
	    on(name, cb) {
	        this.handlers[name] = cb;
	        return this;
	    }
	    trigger(event, arg) {
	        const h = this.handlers[event];
	        return h ? (h.call(this, arg), true) : false;
	    }
	    start() {
	        this.trigger('start');
	        let token;
	        while (!this.stopRequested && (token = this.tokens.shift())) {
	            if (this.trigger('token', token))
	                continue;
	            if (isTagToken(token) && this.trigger(`tag:${token.name}`, token)) {
	                continue;
	            }
	            const template = this.parseToken(token, this.tokens);
	            this.trigger('template', template);
	        }
	        if (!this.stopRequested)
	            this.trigger('end');
	        return this;
	    }
	    stop() {
	        this.stopRequested = true;
	        return this;
	    }
	}

	class TemplateImpl {
	    constructor(token) {
	        this.token = token;
	    }
	}

	class Tag extends TemplateImpl {
	    constructor(token, remainTokens, liquid) {
	        super(token);
	        this.name = token.name;
	        this.liquid = liquid;
	    }
	}

	/**
	 * Key-Value Pairs Representing Tag Arguments
	 * Example:
	 *    For the markup `, foo:'bar', coo:2 reversed %}`,
	 *    hash['foo'] === 'bar'
	 *    hash['coo'] === 2
	 *    hash['reversed'] === undefined
	 */
	class Hash {
	    constructor(markup, jekyllStyle) {
	        this.hash = {};
	        const tokenizer = new Tokenizer(markup, {});
	        for (const hash of tokenizer.readHashes(jekyllStyle)) {
	            this.hash[hash.name.content] = hash.value;
	        }
	    }
	    *render(ctx) {
	        const hash = {};
	        for (const key of Object.keys(this.hash)) {
	            hash[key] = this.hash[key] === undefined ? true : yield evalToken(this.hash[key], ctx);
	        }
	        return hash;
	    }
	}

	function createTagClass(options) {
	    return class extends Tag {
	        constructor(token, tokens, liquid) {
	            super(token, tokens, liquid);
	            if (isFunction(options.parse)) {
	                options.parse.call(this, token, tokens);
	            }
	        }
	        *render(ctx, emitter) {
	            const hash = (yield new Hash(this.token.args).render(ctx));
	            return yield options.render.call(this, ctx, emitter, hash);
	        }
	    };
	}

	function isKeyValuePair(arr) {
	    return isArray(arr);
	}

	class Filter {
	    constructor(name, options, args, liquid) {
	        this.name = name;
	        this.handler = isFunction(options)
	            ? options
	            : (isFunction(options === null || options === void 0 ? void 0 : options.handler) ? options.handler : identify);
	        this.raw = !isFunction(options) && !!(options === null || options === void 0 ? void 0 : options.raw);
	        this.args = args;
	        this.liquid = liquid;
	    }
	    *render(value, context) {
	        const argv = [];
	        for (const arg of this.args) {
	            if (isKeyValuePair(arg))
	                argv.push([arg[0], yield evalToken(arg[1], context)]);
	            else
	                argv.push(yield evalToken(arg, context));
	        }
	        return this.handler.apply({ context, liquid: this.liquid }, [value, ...argv]);
	    }
	}

	class Value {
	    /**
	     * @param str the value to be valuated, eg.: "foobar" | truncate: 3
	     */
	    constructor(str, liquid) {
	        this.filters = [];
	        const tokenizer = new Tokenizer(str, liquid.options.operators);
	        this.initial = tokenizer.readExpression();
	        this.filters = tokenizer.readFilters().map(({ name, args }) => new Filter(name, this.getFilter(liquid, name), args, liquid));
	    }
	    *value(ctx, lenient) {
	        lenient = lenient || (ctx.opts.lenientIf && this.filters.length > 0 && this.filters[0].name === 'default');
	        let val = yield this.initial.evaluate(ctx, lenient);
	        for (const filter of this.filters) {
	            val = yield filter.render(val, ctx);
	        }
	        return val;
	    }
	    getFilter(liquid, name) {
	        const impl = liquid.filters[name];
	        assert(impl || !liquid.options.strictFilters, () => `undefined filter: ${name}`);
	        return impl;
	    }
	}

	class Output extends TemplateImpl {
	    constructor(token, liquid) {
	        var _a;
	        super(token);
	        this.value = new Value(token.content, liquid);
	        const filters = this.value.filters;
	        const outputEscape = liquid.options.outputEscape;
	        if (!((_a = filters[filters.length - 1]) === null || _a === void 0 ? void 0 : _a.raw) && outputEscape) {
	            filters.push(new Filter(toString.call(outputEscape), outputEscape, [], liquid));
	        }
	    }
	    *render(ctx, emitter) {
	        const val = yield this.value.value(ctx, false);
	        emitter.write(val);
	    }
	}

	class HTML extends TemplateImpl {
	    constructor(token) {
	        super(token);
	        this.str = token.getContent();
	    }
	    *render(ctx, emitter) {
	        emitter.write(this.str);
	    }
	}

	var LookupType;
	(function (LookupType) {
	    LookupType["Partials"] = "partials";
	    LookupType["Layouts"] = "layouts";
	    LookupType["Root"] = "root";
	})(LookupType || (LookupType = {}));
	class Loader {
	    constructor(options) {
	        this.options = options;
	        if (options.relativeReference) {
	            const sep = options.fs.sep;
	            assert(sep, '`fs.sep` is required for relative reference');
	            const rRelativePath = new RegExp(['.' + sep, '..' + sep, './', '../'].map(prefix => escapeRegex(prefix)).join('|'));
	            this.shouldLoadRelative = (referencedFile) => rRelativePath.test(referencedFile);
	        }
	        else {
	            this.shouldLoadRelative = (referencedFile) => false;
	        }
	        this.contains = this.options.fs.contains || (() => true);
	    }
	    *lookup(file, type, sync, currentFile) {
	        const { fs } = this.options;
	        const dirs = this.options[type];
	        for (const filepath of this.candidates(file, dirs, currentFile, type !== LookupType.Root)) {
	            if (sync ? fs.existsSync(filepath) : yield fs.exists(filepath))
	                return filepath;
	        }
	        throw this.lookupError(file, dirs);
	    }
	    *candidates(file, dirs, currentFile, enforceRoot) {
	        const { fs, extname } = this.options;
	        if (this.shouldLoadRelative(file) && currentFile) {
	            const referenced = fs.resolve(this.dirname(currentFile), file, extname);
	            for (const dir of dirs) {
	                if (!enforceRoot || this.contains(dir, referenced)) {
	                    // the relatively referenced file is within one of root dirs
	                    yield referenced;
	                    break;
	                }
	            }
	        }
	        for (const dir of dirs) {
	            const referenced = fs.resolve(dir, file, extname);
	            if (!enforceRoot || this.contains(dir, referenced)) {
	                yield referenced;
	            }
	        }
	        if (fs.fallback !== undefined) {
	            const filepath = fs.fallback(file);
	            if (filepath !== undefined)
	                yield filepath;
	        }
	    }
	    dirname(path) {
	        const fs = this.options.fs;
	        assert(fs.dirname, '`fs.dirname` is required for relative reference');
	        return fs.dirname(path);
	    }
	    lookupError(file, roots) {
	        const err = new Error('ENOENT');
	        err.message = `ENOENT: Failed to lookup "${file}" in "${roots}"`;
	        err.code = 'ENOENT';
	        return err;
	    }
	}

	class Parser {
	    constructor(liquid) {
	        this.liquid = liquid;
	        this.cache = this.liquid.options.cache;
	        this.fs = this.liquid.options.fs;
	        this.parseFile = this.cache ? this._parseFileCached : this._parseFile;
	        this.loader = new Loader(this.liquid.options);
	    }
	    parse(html, filepath) {
	        const tokenizer = new Tokenizer(html, this.liquid.options.operators, filepath);
	        const tokens = tokenizer.readTopLevelTokens(this.liquid.options);
	        return this.parseTokens(tokens);
	    }
	    parseTokens(tokens) {
	        let token;
	        const templates = [];
	        while ((token = tokens.shift())) {
	            templates.push(this.parseToken(token, tokens));
	        }
	        return templates;
	    }
	    parseToken(token, remainTokens) {
	        try {
	            if (isTagToken(token)) {
	                const TagClass = this.liquid.tags[token.name];
	                assert(TagClass, `tag "${token.name}" not found`);
	                return new TagClass(token, remainTokens, this.liquid);
	            }
	            if (isOutputToken(token)) {
	                return new Output(token, this.liquid);
	            }
	            return new HTML(token);
	        }
	        catch (e) {
	            throw new ParseError(e, token);
	        }
	    }
	    parseStream(tokens) {
	        return new ParseStream(tokens, (token, tokens) => this.parseToken(token, tokens));
	    }
	    *_parseFileCached(file, sync, type = LookupType.Root, currentFile) {
	        const cache = this.cache;
	        const key = this.loader.shouldLoadRelative(file) ? currentFile + ',' + file : type + ':' + file;
	        const tpls = yield cache.read(key);
	        if (tpls)
	            return tpls;
	        const task = this._parseFile(file, sync, type, currentFile);
	        // sync mode: exec the task and cache the result
	        // async mode: cache the task before exec
	        const taskOrTpl = sync ? yield task : toPromise(task);
	        cache.write(key, taskOrTpl);
	        // note: concurrent tasks will be reused, cache for failed task is removed until its end
	        try {
	            return yield taskOrTpl;
	        }
	        catch (err) {
	            cache.remove(key);
	            throw err;
	        }
	    }
	    *_parseFile(file, sync, type = LookupType.Root, currentFile) {
	        const filepath = yield this.loader.lookup(file, type, sync, currentFile);
	        return this.liquid.parse(sync ? this.fs.readFileSync(filepath) : yield this.fs.readFile(filepath), filepath);
	    }
	}

	const rHex = /[\da-fA-F]/;
	const rOct = /[0-7]/;
	const escapeChar = {
	    b: '\b',
	    f: '\f',
	    n: '\n',
	    r: '\r',
	    t: '\t',
	    v: '\x0B'
	};
	function hexVal(c) {
	    const code = c.charCodeAt(0);
	    if (code >= 97)
	        return code - 87;
	    if (code >= 65)
	        return code - 55;
	    return code - 48;
	}
	function parseStringLiteral(str) {
	    let ret = '';
	    for (let i = 1; i < str.length - 1; i++) {
	        if (str[i] !== '\\') {
	            ret += str[i];
	            continue;
	        }
	        if (escapeChar[str[i + 1]] !== undefined) {
	            ret += escapeChar[str[++i]];
	        }
	        else if (str[i + 1] === 'u') {
	            let val = 0;
	            let j = i + 2;
	            while (j <= i + 5 && rHex.test(str[j])) {
	                val = val * 16 + hexVal(str[j++]);
	            }
	            i = j - 1;
	            ret += String.fromCharCode(val);
	        }
	        else if (!rOct.test(str[i + 1])) {
	            ret += str[++i];
	        }
	        else {
	            let j = i + 1;
	            let val = 0;
	            while (j <= i + 3 && rOct.test(str[j])) {
	                val = val * 8 + hexVal(str[j++]);
	            }
	            i = j - 1;
	            ret += String.fromCharCode(val);
	        }
	    }
	    return ret;
	}

	var TokenKind;
	(function (TokenKind) {
	    TokenKind[TokenKind["Number"] = 1] = "Number";
	    TokenKind[TokenKind["Literal"] = 2] = "Literal";
	    TokenKind[TokenKind["Tag"] = 4] = "Tag";
	    TokenKind[TokenKind["Output"] = 8] = "Output";
	    TokenKind[TokenKind["HTML"] = 16] = "HTML";
	    TokenKind[TokenKind["Filter"] = 32] = "Filter";
	    TokenKind[TokenKind["Hash"] = 64] = "Hash";
	    TokenKind[TokenKind["PropertyAccess"] = 128] = "PropertyAccess";
	    TokenKind[TokenKind["Word"] = 256] = "Word";
	    TokenKind[TokenKind["Range"] = 512] = "Range";
	    TokenKind[TokenKind["Quoted"] = 1024] = "Quoted";
	    TokenKind[TokenKind["Operator"] = 2048] = "Operator";
	    TokenKind[TokenKind["Delimited"] = 12] = "Delimited";
	})(TokenKind || (TokenKind = {}));

	function isDelimitedToken(val) {
	    return !!(getKind(val) & TokenKind.Delimited);
	}
	function isOperatorToken(val) {
	    return getKind(val) === TokenKind.Operator;
	}
	function isHTMLToken(val) {
	    return getKind(val) === TokenKind.HTML;
	}
	function isOutputToken(val) {
	    return getKind(val) === TokenKind.Output;
	}
	function isTagToken(val) {
	    return getKind(val) === TokenKind.Tag;
	}
	function isQuotedToken(val) {
	    return getKind(val) === TokenKind.Quoted;
	}
	function isLiteralToken(val) {
	    return getKind(val) === TokenKind.Literal;
	}
	function isNumberToken(val) {
	    return getKind(val) === TokenKind.Number;
	}
	function isPropertyAccessToken(val) {
	    return getKind(val) === TokenKind.PropertyAccess;
	}
	function isWordToken(val) {
	    return getKind(val) === TokenKind.Word;
	}
	function isRangeToken(val) {
	    return getKind(val) === TokenKind.Range;
	}
	function getKind(val) {
	    return val ? val.kind : -1;
	}

	class Context {
	    constructor(env = {}, opts = defaultOptions, renderOptions = {}) {
	        var _a, _b;
	        /**
	         * insert a Context-level empty scope,
	         * for tags like `{% capture %}` `{% assign %}` to operate
	         */
	        this.scopes = [{}];
	        this.registers = {};
	        this.sync = !!renderOptions.sync;
	        this.opts = opts;
	        this.globals = (_a = renderOptions.globals) !== null && _a !== void 0 ? _a : opts.globals;
	        this.environments = env;
	        this.strictVariables = (_b = renderOptions.strictVariables) !== null && _b !== void 0 ? _b : this.opts.strictVariables;
	    }
	    getRegister(key) {
	        return (this.registers[key] = this.registers[key] || {});
	    }
	    setRegister(key, value) {
	        return (this.registers[key] = value);
	    }
	    saveRegister(...keys) {
	        return keys.map(key => [key, this.getRegister(key)]);
	    }
	    restoreRegister(keyValues) {
	        return keyValues.forEach(([key, value]) => this.setRegister(key, value));
	    }
	    getAll() {
	        return [this.globals, this.environments, ...this.scopes]
	            .reduce((ctx, val) => __assign(ctx, val), {});
	    }
	    /**
	     * @deprecated use `_get()` instead
	     */
	    get(paths) {
	        return toValueSync(this._get(paths));
	    }
	    *_get(paths) {
	        const scope = this.findScope(paths[0]);
	        return yield this._getFromScope(scope, paths);
	    }
	    /**
	     * @deprecated use `_get()` instead
	     */
	    getFromScope(scope, paths) {
	        return toValueSync(this._getFromScope(scope, paths));
	    }
	    *_getFromScope(scope, paths) {
	        if (isString(paths))
	            paths = paths.split('.');
	        for (let i = 0; i < paths.length; i++) {
	            scope = yield readProperty(scope, paths[i], this.opts.ownPropertyOnly);
	            if (isNil(scope) && this.strictVariables) {
	                throw new InternalUndefinedVariableError(paths.slice(0, i + 1).join('.'));
	            }
	        }
	        return scope;
	    }
	    push(ctx) {
	        return this.scopes.push(ctx);
	    }
	    pop() {
	        return this.scopes.pop();
	    }
	    bottom() {
	        return this.scopes[0];
	    }
	    findScope(key) {
	        for (let i = this.scopes.length - 1; i >= 0; i--) {
	            const candidate = this.scopes[i];
	            if (key in candidate)
	                return candidate;
	        }
	        if (key in this.environments)
	            return this.environments;
	        return this.globals;
	    }
	}
	function readProperty(obj, key, ownPropertyOnly) {
	    obj = toLiquid(obj);
	    if (isNil(obj))
	        return obj;
	    if (isArray(obj) && key < 0)
	        return obj[obj.length + +key];
	    const value = readJSProperty(obj, key, ownPropertyOnly);
	    if (value === undefined && obj instanceof Drop)
	        return obj.liquidMethodMissing(key);
	    if (isFunction(value))
	        return value.call(obj);
	    if (key === 'size')
	        return readSize(obj);
	    else if (key === 'first')
	        return readFirst(obj);
	    else if (key === 'last')
	        return readLast(obj);
	    return value;
	}
	function readJSProperty(obj, key, ownPropertyOnly) {
	    if (ownPropertyOnly && !Object.hasOwnProperty.call(obj, key) && !(obj instanceof Drop))
	        return undefined;
	    return obj[key];
	}
	function readFirst(obj) {
	    if (isArray(obj))
	        return obj[0];
	    return obj['first'];
	}
	function readLast(obj) {
	    if (isArray(obj))
	        return obj[obj.length - 1];
	    return obj['last'];
	}
	function readSize(obj) {
	    if (obj.hasOwnProperty('size') || obj['size'] !== undefined)
	        return obj['size'];
	    if (isArray(obj) || isString(obj))
	        return obj.length;
	    if (typeof obj === 'object')
	        return Object.keys(obj).length;
	}

	var BlockMode;
	(function (BlockMode) {
	    /* store rendered html into blocks */
	    BlockMode[BlockMode["OUTPUT"] = 0] = "OUTPUT";
	    /* output rendered html directly */
	    BlockMode[BlockMode["STORE"] = 1] = "STORE";
	})(BlockMode || (BlockMode = {}));

	const abs = argumentsToValue(Math.abs);
	const at_least = argumentsToValue(Math.max);
	const at_most = argumentsToValue(Math.min);
	const ceil = argumentsToValue(Math.ceil);
	const divided_by = argumentsToValue((dividend, divisor, integerArithmetic = false) => integerArithmetic ? Math.floor(dividend / divisor) : dividend / divisor);
	const floor = argumentsToValue(Math.floor);
	const minus = argumentsToValue((v, arg) => v - arg);
	const modulo = argumentsToValue((v, arg) => v % arg);
	const times = argumentsToValue((v, arg) => v * arg);
	function round(v, arg = 0) {
	    v = toValue(v);
	    arg = toValue(arg);
	    const amp = Math.pow(10, arg);
	    return Math.round(v * amp) / amp;
	}
	function plus(v, arg) {
	    v = toValue(v);
	    arg = toValue(arg);
	    return Number(v) + Number(arg);
	}

	var mathFilters = /*#__PURE__*/Object.freeze({
	  __proto__: null,
	  abs: abs,
	  at_least: at_least,
	  at_most: at_most,
	  ceil: ceil,
	  divided_by: divided_by,
	  floor: floor,
	  minus: minus,
	  modulo: modulo,
	  times: times,
	  round: round,
	  plus: plus
	});

	const url_decode = (x) => stringify(x).split('+').map(decodeURIComponent).join(' ');
	const url_encode = (x) => stringify(x).split(' ').map(encodeURIComponent).join('+');

	var urlFilters = /*#__PURE__*/Object.freeze({
	  __proto__: null,
	  url_decode: url_decode,
	  url_encode: url_encode
	});

	const join = argumentsToValue((v, arg) => toArray(v).join(arg === undefined ? ' ' : arg));
	const last = argumentsToValue((v) => isArray(v) ? last$1(v) : '');
	const first = argumentsToValue((v) => isArray(v) ? v[0] : '');
	const reverse = argumentsToValue((v) => [...toArray(v)].reverse());
	function* sort$2(arr, property) {
	    const values = [];
	    for (const item of toArray(toValue(arr))) {
	        values.push([
	            item,
	            property ? yield this.context._getFromScope(item, stringify(property).split('.')) : item
	        ]);
	    }
	    return values.sort((lhs, rhs) => {
	        const lvalue = lhs[1];
	        const rvalue = rhs[1];
	        return lvalue < rvalue ? -1 : (lvalue > rvalue ? 1 : 0);
	    }).map(tuple => tuple[0]);
	}
	function sort_natural(input, property) {
	    input = toValue(input);
	    const propertyString = stringify(property);
	    const compare = property === undefined
	        ? caseInsensitiveCompare
	        : (lhs, rhs) => caseInsensitiveCompare(lhs[propertyString], rhs[propertyString]);
	    return [...toArray(input)].sort(compare);
	}
	const size = (v) => (v && v.length) || 0;
	function* map(arr, property) {
	    const results = [];
	    for (const item of toArray(toValue(arr))) {
	        results.push(yield this.context._getFromScope(item, stringify(property).split('.')));
	    }
	    return results;
	}
	function compact(arr) {
	    arr = toValue(arr);
	    return toArray(arr).filter(x => !isNil(toValue(x)));
	}
	function concat(v, arg = []) {
	    v = toValue(v);
	    arg = toArray(arg).map(v => toValue(v));
	    return toArray(v).concat(arg);
	}
	function slice(v, begin, length = 1) {
	    v = toValue(v);
	    if (isNil(v))
	        return [];
	    if (!isArray(v))
	        v = stringify(v);
	    begin = begin < 0 ? v.length + begin : begin;
	    return v.slice(begin, begin + length);
	}
	function* where(arr, property, expected) {
	    const values = [];
	    arr = toArray(toValue(arr));
	    for (const item of arr) {
	        values.push(yield this.context._getFromScope(item, stringify(property).split('.')));
	    }
	    return arr.filter((_, i) => {
	        if (expected === undefined)
	            return isTruthy(values[i], this.context);
	        if (isComparable(expected))
	            return expected.equals(values[i]);
	        return values[i] === expected;
	    });
	}
	function uniq(arr) {
	    arr = toValue(arr);
	    const u = {};
	    return (arr || []).filter(val => {
	        if (hasOwnProperty.call(u, String(val)))
	            return false;
	        u[String(val)] = true;
	        return true;
	    });
	}

	var arrayFilters = /*#__PURE__*/Object.freeze({
	  __proto__: null,
	  join: join,
	  last: last,
	  first: first,
	  reverse: reverse,
	  sort: sort$2,
	  sort_natural: sort_natural,
	  size: size,
	  map: map,
	  compact: compact,
	  concat: concat,
	  slice: slice,
	  where: where,
	  uniq: uniq
	});

	function date(v, format, timezoneOffset) {
	    const opts = this.context.opts;
	    let date;
	    v = toValue(v);
	    format = stringify(format);
	    if (v === 'now' || v === 'today') {
	        date = new Date();
	    }
	    else if (isNumber(v)) {
	        date = new Date(v * 1000);
	    }
	    else if (isString(v)) {
	        if (/^\d+$/.test(v)) {
	            date = new Date(+v * 1000);
	        }
	        else if (opts.preserveTimezones) {
	            date = TimezoneDate.createDateFixedToTimezone(v);
	        }
	        else {
	            date = new Date(v);
	        }
	    }
	    else {
	        date = v;
	    }
	    if (!isValidDate(date))
	        return v;
	    if (timezoneOffset !== undefined) {
	        date = new TimezoneDate(date, parseTimezoneOffset(date, timezoneOffset));
	    }
	    else if (opts.timezoneOffset !== undefined) {
	        date = new TimezoneDate(date, parseTimezoneOffset(date, opts.timezoneOffset));
	    }
	    return strftime(date, format);
	}
	function isValidDate(date) {
	    return (date instanceof Date || date instanceof TimezoneDate) && !isNaN(date.getTime());
	}
	/**
	 * need pass in a `date` because offset is dependent on whether DST is active
	 */
	function parseTimezoneOffset(date, timeZone) {
	    if (isNumber(timeZone))
	        return timeZone;
	    const utcDate = new Date(date.toLocaleString('en-US', { timeZone: 'UTC' }));
	    const tzDate = new Date(date.toLocaleString('en-US', { timeZone }));
	    return (utcDate.getTime() - tzDate.getTime()) / 6e4;
	}

	var dateFilters = /*#__PURE__*/Object.freeze({
	  __proto__: null,
	  date: date
	});

	/**
	 * String related filters
	 *
	 * * prefer stringify() to String() since `undefined`, `null` should eval ''
	 */
	function append(v, arg) {
	    assert(arguments.length === 2, 'append expect 2 arguments');
	    return stringify(v) + stringify(arg);
	}
	function prepend(v, arg) {
	    assert(arguments.length === 2, 'prepend expect 2 arguments');
	    return stringify(arg) + stringify(v);
	}
	function lstrip(v, chars) {
	    if (chars) {
	        chars = escapeRegExp(stringify(chars));
	        return stringify(v).replace(new RegExp(`^[${chars}]+`, 'g'), '');
	    }
	    return stringify(v).replace(/^\s+/, '');
	}
	function downcase(v) {
	    return stringify(v).toLowerCase();
	}
	function upcase(str) {
	    return stringify(str).toUpperCase();
	}
	function remove(v, arg) {
	    return stringify(v).split(String(arg)).join('');
	}
	function remove_first(v, l) {
	    return stringify(v).replace(String(l), '');
	}
	function remove_last(v, l) {
	    const str = stringify(v);
	    const pattern = String(l);
	    const index = str.lastIndexOf(pattern);
	    if (index === -1)
	        return str;
	    return str.substring(0, index) + str.substring(index + pattern.length + 1);
	}
	function rstrip(str, chars) {
	    if (chars) {
	        chars = escapeRegExp(stringify(chars));
	        return stringify(str).replace(new RegExp(`[${chars}]+$`, 'g'), '');
	    }
	    return stringify(str).replace(/\s+$/, '');
	}
	function split(v, arg) {
	    const arr = stringify(v).split(String(arg));
	    // align to ruby split, which is the behavior of shopify/liquid
	    // see: https://ruby-doc.org/core-2.4.0/String.html#method-i-split
	    while (arr.length && arr[arr.length - 1] === '')
	        arr.pop();
	    return arr;
	}
	function strip(v, chars) {
	    if (chars) {
	        chars = escapeRegExp(stringify(chars));
	        return stringify(v)
	            .replace(new RegExp(`^[${chars}]+`, 'g'), '')
	            .replace(new RegExp(`[${chars}]+$`, 'g'), '');
	    }
	    return stringify(v).trim();
	}
	function strip_newlines(v) {
	    return stringify(v).replace(/\n/g, '');
	}
	function capitalize(str) {
	    str = stringify(str);
	    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
	}
	function replace(v, pattern, replacement) {
	    return stringify(v).split(String(pattern)).join(replacement);
	}
	function replace_first(v, arg1, arg2) {
	    return stringify(v).replace(String(arg1), arg2);
	}
	function replace_last(v, arg1, arg2) {
	    const str = stringify(v);
	    const pattern = String(arg1);
	    const index = str.lastIndexOf(pattern);
	    if (index === -1)
	        return str;
	    const replacement = String(arg2);
	    return str.substring(0, index) + replacement + str.substring(index + pattern.length);
	}
	function truncate(v, l = 50, o = '...') {
	    v = stringify(v);
	    if (v.length <= l)
	        return v;
	    return v.substring(0, l - o.length) + o;
	}
	function truncatewords(v, words = 15, o = '...') {
	    const arr = stringify(v).split(/\s+/);
	    if (words <= 0)
	        words = 1;
	    let ret = arr.slice(0, words).join(' ');
	    if (arr.length >= words)
	        ret += o;
	    return ret;
	}

	var stringFilters = /*#__PURE__*/Object.freeze({
	  __proto__: null,
	  append: append,
	  prepend: prepend,
	  lstrip: lstrip,
	  downcase: downcase,
	  upcase: upcase,
	  remove: remove,
	  remove_first: remove_first,
	  remove_last: remove_last,
	  rstrip: rstrip,
	  split: split,
	  strip: strip,
	  strip_newlines: strip_newlines,
	  capitalize: capitalize,
	  replace: replace,
	  replace_first: replace_first,
	  replace_last: replace_last,
	  truncate: truncate,
	  truncatewords: truncatewords
	});

	const filters = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, htmlFilters), mathFilters), urlFilters), arrayFilters), dateFilters), stringFilters), { json,
	    raw, default: Default });

	class AssignTag extends Tag {
	    constructor(token, remainTokens, liquid) {
	        super(token, remainTokens, liquid);
	        const tokenizer = new Tokenizer(token.args, liquid.options.operators);
	        this.key = tokenizer.readIdentifier().content;
	        tokenizer.skipBlank();
	        assert(tokenizer.peek() === '=', () => `illegal token ${token.getText()}`);
	        tokenizer.advance();
	        this.value = new Value(tokenizer.remaining(), this.liquid);
	    }
	    *render(ctx) {
	        ctx.bottom()[this.key] = yield this.value.value(ctx, this.liquid.options.lenientIf);
	    }
	}

	const MODIFIERS = ['offset', 'limit', 'reversed'];
	class ForTag extends Tag {
	    constructor(token, remainTokens, liquid) {
	        super(token, remainTokens, liquid);
	        const tokenizer = new Tokenizer(token.args, this.liquid.options.operators);
	        const variable = tokenizer.readIdentifier();
	        const inStr = tokenizer.readIdentifier();
	        const collection = tokenizer.readValue();
	        if (!variable.size() || inStr.content !== 'in' || !collection) {
	            throw new Error(`illegal tag: ${token.getText()}`);
	        }
	        this.variable = variable.content;
	        this.collection = collection;
	        this.hash = new Hash(tokenizer.remaining());
	        this.templates = [];
	        this.elseTemplates = [];
	        let p;
	        const stream = this.liquid.parser.parseStream(remainTokens)
	            .on('start', () => (p = this.templates))
	            .on('tag:else', () => (p = this.elseTemplates))
	            .on('tag:endfor', () => stream.stop())
	            .on('template', (tpl) => p.push(tpl))
	            .on('end', () => {
	            throw new Error(`tag ${token.getText()} not closed`);
	        });
	        stream.start();
	    }
	    *render(ctx, emitter) {
	        const r = this.liquid.renderer;
	        let collection = toEnumerable(yield evalToken(this.collection, ctx));
	        if (!collection.length) {
	            yield r.renderTemplates(this.elseTemplates, ctx, emitter);
	            return;
	        }
	        const continueKey = 'continue-' + this.variable + '-' + this.collection.getText();
	        ctx.push({ continue: ctx.getRegister(continueKey) });
	        const hash = yield this.hash.render(ctx);
	        ctx.pop();
	        const modifiers = this.liquid.options.orderedFilterParameters
	            ? Object.keys(hash).filter(x => MODIFIERS.includes(x))
	            : MODIFIERS.filter(x => hash[x] !== undefined);
	        collection = modifiers.reduce((collection, modifier) => {
	            if (modifier === 'offset')
	                return offset(collection, hash['offset']);
	            if (modifier === 'limit')
	                return limit(collection, hash['limit']);
	            return reversed(collection);
	        }, collection);
	        ctx.setRegister(continueKey, (hash['offset'] || 0) + collection.length);
	        const scope = { forloop: new ForloopDrop(collection.length, this.collection.getText(), this.variable) };
	        ctx.push(scope);
	        for (const item of collection) {
	            scope[this.variable] = item;
	            yield r.renderTemplates(this.templates, ctx, emitter);
	            if (emitter['break']) {
	                emitter['break'] = false;
	                break;
	            }
	            emitter['continue'] = false;
	            scope.forloop.next();
	        }
	        ctx.pop();
	    }
	}
	function reversed(arr) {
	    return [...arr].reverse();
	}
	function offset(arr, count) {
	    return arr.slice(count);
	}
	function limit(arr, count) {
	    return arr.slice(0, count);
	}

	class CaptureTag extends Tag {
	    constructor(tagToken, remainTokens, liquid) {
	        super(tagToken, remainTokens, liquid);
	        this.templates = [];
	        const tokenizer = new Tokenizer(tagToken.args, this.liquid.options.operators);
	        this.variable = readVariableName(tokenizer);
	        assert(this.variable, () => `${tagToken.args} not valid identifier`);
	        while (remainTokens.length) {
	            const token = remainTokens.shift();
	            if (isTagToken(token) && token.name === 'endcapture')
	                return;
	            this.templates.push(liquid.parser.parseToken(token, remainTokens));
	        }
	        throw new Error(`tag ${tagToken.getText()} not closed`);
	    }
	    *render(ctx) {
	        const r = this.liquid.renderer;
	        const html = yield r.renderTemplates(this.templates, ctx);
	        ctx.bottom()[this.variable] = html;
	    }
	}
	function readVariableName(tokenizer) {
	    const word = tokenizer.readIdentifier().content;
	    if (word)
	        return word;
	    const quoted = tokenizer.readQuoted();
	    if (quoted)
	        return evalQuotedToken(quoted);
	}

	class CaseTag extends Tag {
	    constructor(tagToken, remainTokens, liquid) {
	        super(tagToken, remainTokens, liquid);
	        this.branches = [];
	        this.elseTemplates = [];
	        this.value = new Value(tagToken.args, this.liquid);
	        this.elseTemplates = [];
	        let p = [];
	        const stream = this.liquid.parser.parseStream(remainTokens)
	            .on('tag:when', (token) => {
	            p = [];
	            const tokenizer = new Tokenizer(token.args, this.liquid.options.operators);
	            const values = [];
	            while (!tokenizer.end()) {
	                values.push(tokenizer.readValueOrThrow());
	                tokenizer.readTo(',');
	            }
	            this.branches.push({
	                values,
	                templates: p
	            });
	        })
	            .on('tag:else', () => (p = this.elseTemplates))
	            .on('tag:endcase', () => stream.stop())
	            .on('template', (tpl) => p.push(tpl))
	            .on('end', () => {
	            throw new Error(`tag ${tagToken.getText()} not closed`);
	        });
	        stream.start();
	    }
	    *render(ctx, emitter) {
	        const r = this.liquid.renderer;
	        const target = toValue(yield this.value.value(ctx, ctx.opts.lenientIf));
	        let branchHit = false;
	        for (const branch of this.branches) {
	            for (const valueToken of branch.values) {
	                const value = yield evalToken(valueToken, ctx, ctx.opts.lenientIf);
	                if (target === value) {
	                    yield r.renderTemplates(branch.templates, ctx, emitter);
	                    branchHit = true;
	                    break;
	                }
	            }
	        }
	        if (!branchHit) {
	            yield r.renderTemplates(this.elseTemplates, ctx, emitter);
	        }
	    }
	}

	class CommentTag extends Tag {
	    constructor(tagToken, remainTokens, liquid) {
	        super(tagToken, remainTokens, liquid);
	        while (remainTokens.length) {
	            const token = remainTokens.shift();
	            if (isTagToken(token) && token.name === 'endcomment')
	                return;
	        }
	        throw new Error(`tag ${tagToken.getText()} not closed`);
	    }
	    render() { }
	}

	class RenderTag extends Tag {
	    constructor(token, remainTokens, liquid) {
	        super(token, remainTokens, liquid);
	        const args = token.args;
	        const tokenizer = new Tokenizer(args, this.liquid.options.operators);
	        this.file = parseFilePath(tokenizer, this.liquid);
	        this.currentFile = token.file;
	        while (!tokenizer.end()) {
	            tokenizer.skipBlank();
	            const begin = tokenizer.p;
	            const keyword = tokenizer.readIdentifier();
	            if (keyword.content === 'with' || keyword.content === 'for') {
	                tokenizer.skipBlank();
	                // can be normal key/value pair, like "with: true"
	                if (tokenizer.peek() !== ':') {
	                    const value = tokenizer.readValue();
	                    // can be normal key, like "with,"
	                    if (value) {
	                        const beforeAs = tokenizer.p;
	                        const asStr = tokenizer.readIdentifier();
	                        let alias;
	                        if (asStr.content === 'as')
	                            alias = tokenizer.readIdentifier();
	                        else
	                            tokenizer.p = beforeAs;
	                        this[keyword.content] = { value, alias: alias && alias.content };
	                        tokenizer.skipBlank();
	                        if (tokenizer.peek() === ',')
	                            tokenizer.advance();
	                        continue; // matched!
	                    }
	                }
	            }
	            /**
	             * restore cursor if with/for not matched
	             */
	            tokenizer.p = begin;
	            break;
	        }
	        this.hash = new Hash(tokenizer.remaining());
	    }
	    *render(ctx, emitter) {
	        const { liquid, hash } = this;
	        const filepath = (yield renderFilePath(this['file'], ctx, liquid));
	        assert(filepath, () => `illegal filename "${filepath}"`);
	        const childCtx = new Context({}, ctx.opts, { sync: ctx.sync, globals: ctx.globals, strictVariables: ctx.strictVariables });
	        const scope = childCtx.bottom();
	        __assign(scope, yield hash.render(ctx));
	        if (this['with']) {
	            const { value, alias } = this['with'];
	            scope[alias || filepath] = yield evalToken(value, ctx);
	        }
	        if (this['for']) {
	            const { value, alias } = this['for'];
	            const collection = toEnumerable(yield evalToken(value, ctx));
	            scope['forloop'] = new ForloopDrop(collection.length, value.getText(), alias);
	            for (const item of collection) {
	                scope[alias] = item;
	                const templates = (yield liquid._parsePartialFile(filepath, childCtx.sync, this['currentFile']));
	                yield liquid.renderer.renderTemplates(templates, childCtx, emitter);
	                scope['forloop'].next();
	            }
	        }
	        else {
	            const templates = (yield liquid._parsePartialFile(filepath, childCtx.sync, this['currentFile']));
	            yield liquid.renderer.renderTemplates(templates, childCtx, emitter);
	        }
	    }
	}
	/**
	 * @return null for "none",
	 * @return Template[] for quoted with tags and/or filters
	 * @return Token for expression (not quoted)
	 * @throws TypeError if cannot read next token
	 */
	function parseFilePath(tokenizer, liquid) {
	    if (liquid.options.dynamicPartials) {
	        const file = tokenizer.readValue();
	        if (file === undefined)
	            throw new TypeError(`illegal argument "${tokenizer.input}"`);
	        if (file.getText() === 'none')
	            return;
	        if (isQuotedToken(file)) {
	            // for filenames like "files/{{file}}", eval as liquid template
	            const templates = liquid.parse(evalQuotedToken(file));
	            return optimize(templates);
	        }
	        return file;
	    }
	    const tokens = [...tokenizer.readFileNameTemplate(liquid.options)];
	    const templates = optimize(liquid.parser.parseTokens(tokens));
	    return templates === 'none' ? undefined : templates;
	}
	function optimize(templates) {
	    // for filenames like "files/file.liquid", extract the string directly
	    if (templates.length === 1 && isHTMLToken(templates[0].token))
	        return templates[0].token.getContent();
	    return templates;
	}
	function* renderFilePath(file, ctx, liquid) {
	    if (typeof file === 'string')
	        return file;
	    if (Array.isArray(file))
	        return liquid.renderer.renderTemplates(file, ctx);
	    return yield evalToken(file, ctx);
	}

	class IncludeTag extends Tag {
	    constructor(token, remainTokens, liquid) {
	        super(token, remainTokens, liquid);
	        const args = token.args;
	        const tokenizer = new Tokenizer(args, this.liquid.options.operators);
	        this['file'] = parseFilePath(tokenizer, this.liquid);
	        this['currentFile'] = token.file;
	        const begin = tokenizer.p;
	        const withStr = tokenizer.readIdentifier();
	        if (withStr.content === 'with') {
	            tokenizer.skipBlank();
	            if (tokenizer.peek() !== ':') {
	                this.withVar = tokenizer.readValue();
	            }
	            else
	                tokenizer.p = begin;
	        }
	        else
	            tokenizer.p = begin;
	        this.hash = new Hash(tokenizer.remaining(), this.liquid.options.jekyllInclude);
	    }
	    *render(ctx, emitter) {
	        const { liquid, hash, withVar } = this;
	        const { renderer } = liquid;
	        const filepath = (yield renderFilePath(this['file'], ctx, liquid));
	        assert(filepath, () => `illegal filename "${filepath}"`);
	        const saved = ctx.saveRegister('blocks', 'blockMode');
	        ctx.setRegister('blocks', {});
	        ctx.setRegister('blockMode', BlockMode.OUTPUT);
	        const scope = (yield hash.render(ctx));
	        if (withVar)
	            scope[filepath] = yield evalToken(withVar, ctx);
	        const templates = (yield liquid._parsePartialFile(filepath, ctx.sync, this['currentFile']));
	        ctx.push(ctx.opts.jekyllInclude ? { include: scope } : scope);
	        yield renderer.renderTemplates(templates, ctx, emitter);
	        ctx.pop();
	        ctx.restoreRegister(saved);
	    }
	}

	class DecrementTag extends Tag {
	    constructor(token, remainTokens, liquid) {
	        super(token, remainTokens, liquid);
	        const tokenizer = new Tokenizer(token.args, this.liquid.options.operators);
	        this.variable = tokenizer.readIdentifier().content;
	    }
	    render(context, emitter) {
	        const scope = context.environments;
	        if (!isNumber(scope[this.variable])) {
	            scope[this.variable] = 0;
	        }
	        emitter.write(stringify(--scope[this.variable]));
	    }
	}

	class CycleTag extends Tag {
	    constructor(tagToken, remainTokens, liquid) {
	        super(tagToken, remainTokens, liquid);
	        this.candidates = [];
	        const tokenizer = new Tokenizer(tagToken.args, this.liquid.options.operators);
	        const group = tokenizer.readValue();
	        tokenizer.skipBlank();
	        if (group) {
	            if (tokenizer.peek() === ':') {
	                this.group = group;
	                tokenizer.advance();
	            }
	            else
	                this.candidates.push(group);
	        }
	        while (!tokenizer.end()) {
	            const value = tokenizer.readValue();
	            if (value)
	                this.candidates.push(value);
	            tokenizer.readTo(',');
	        }
	        assert(this.candidates.length, () => `empty candidates: ${tagToken.getText()}`);
	    }
	    *render(ctx, emitter) {
	        const group = (yield evalToken(this.group, ctx));
	        const fingerprint = `cycle:${group}:` + this.candidates.join(',');
	        const groups = ctx.getRegister('cycle');
	        let idx = groups[fingerprint];
	        if (idx === undefined) {
	            idx = groups[fingerprint] = 0;
	        }
	        const candidate = this.candidates[idx];
	        idx = (idx + 1) % this.candidates.length;
	        groups[fingerprint] = idx;
	        return yield evalToken(candidate, ctx);
	    }
	}

	class IfTag extends Tag {
	    constructor(tagToken, remainTokens, liquid) {
	        super(tagToken, remainTokens, liquid);
	        this.branches = [];
	        this.elseTemplates = [];
	        let p;
	        liquid.parser.parseStream(remainTokens)
	            .on('start', () => this.branches.push({
	            value: new Value(tagToken.args, this.liquid),
	            templates: (p = [])
	        }))
	            .on('tag:elsif', (token) => this.branches.push({
	            value: new Value(token.args, this.liquid),
	            templates: (p = [])
	        }))
	            .on('tag:else', () => (p = this.elseTemplates))
	            .on('tag:endif', function () { this.stop(); })
	            .on('template', (tpl) => p.push(tpl))
	            .on('end', () => { throw new Error(`tag ${tagToken.getText()} not closed`); })
	            .start();
	    }
	    *render(ctx, emitter) {
	        const r = this.liquid.renderer;
	        for (const { value, templates } of this.branches) {
	            const v = yield value.value(ctx, ctx.opts.lenientIf);
	            if (isTruthy(v, ctx)) {
	                yield r.renderTemplates(templates, ctx, emitter);
	                return;
	            }
	        }
	        yield r.renderTemplates(this.elseTemplates, ctx, emitter);
	    }
	}

	class IncrementTag extends Tag {
	    constructor(token, remainTokens, liquid) {
	        super(token, remainTokens, liquid);
	        const tokenizer = new Tokenizer(token.args, this.liquid.options.operators);
	        this.variable = tokenizer.readIdentifier().content;
	    }
	    render(context, emitter) {
	        const scope = context.environments;
	        if (!isNumber(scope[this.variable])) {
	            scope[this.variable] = 0;
	        }
	        const val = scope[this.variable];
	        scope[this.variable]++;
	        emitter.write(stringify(val));
	    }
	}

	class LayoutTag extends Tag {
	    constructor(token, remainTokens, liquid) {
	        super(token, remainTokens, liquid);
	        const tokenizer = new Tokenizer(token.args, this.liquid.options.operators);
	        this.file = parseFilePath(tokenizer, this.liquid);
	        this['currentFile'] = token.file;
	        this.args = new Hash(tokenizer.remaining());
	        this.templates = this.liquid.parser.parseTokens(remainTokens);
	    }
	    *render(ctx, emitter) {
	        const { liquid, args, file } = this;
	        const { renderer } = liquid;
	        if (file === undefined) {
	            ctx.setRegister('blockMode', BlockMode.OUTPUT);
	            yield renderer.renderTemplates(this.templates, ctx, emitter);
	            return;
	        }
	        const filepath = (yield renderFilePath(this.file, ctx, liquid));
	        assert(filepath, () => `illegal filename "${filepath}"`);
	        const templates = (yield liquid._parseLayoutFile(filepath, ctx.sync, this['currentFile']));
	        // render remaining contents and store rendered results
	        ctx.setRegister('blockMode', BlockMode.STORE);
	        const html = yield renderer.renderTemplates(this.templates, ctx);
	        const blocks = ctx.getRegister('blocks');
	        // set whole content to anonymous block if anonymous doesn't specified
	        if (blocks[''] === undefined)
	            blocks[''] = (parent, emitter) => emitter.write(html);
	        ctx.setRegister('blockMode', BlockMode.OUTPUT);
	        // render the layout file use stored blocks
	        ctx.push((yield args.render(ctx)));
	        yield renderer.renderTemplates(templates, ctx, emitter);
	        ctx.pop();
	    }
	}

	class BlockTag extends Tag {
	    constructor(token, remainTokens, liquid) {
	        super(token, remainTokens, liquid);
	        this.templates = [];
	        const match = /\w+/.exec(token.args);
	        this.block = match ? match[0] : '';
	        while (remainTokens.length) {
	            const token = remainTokens.shift();
	            if (isTagToken(token) && token.name === 'endblock')
	                return;
	            const template = liquid.parser.parseToken(token, remainTokens);
	            this.templates.push(template);
	        }
	        throw new Error(`tag ${token.getText()} not closed`);
	    }
	    *render(ctx, emitter) {
	        const blockRender = this.getBlockRender(ctx);
	        if (ctx.getRegister('blockMode') === BlockMode.STORE) {
	            ctx.getRegister('blocks')[this.block] = blockRender;
	        }
	        else {
	            yield blockRender(new BlockDrop(), emitter);
	        }
	    }
	    getBlockRender(ctx) {
	        const { liquid, templates } = this;
	        const renderChild = ctx.getRegister('blocks')[this.block];
	        const renderCurrent = function* (superBlock, emitter) {
	            // add {{ block.super }} support when rendering
	            ctx.push({ block: superBlock });
	            yield liquid.renderer.renderTemplates(templates, ctx, emitter);
	            ctx.pop();
	        };
	        return renderChild
	            ? (superBlock, emitter) => renderChild(new BlockDrop(() => renderCurrent(superBlock, emitter)), emitter)
	            : renderCurrent;
	    }
	}

	class RawTag extends Tag {
	    constructor(tagToken, remainTokens, liquid) {
	        super(tagToken, remainTokens, liquid);
	        this.tokens = [];
	        while (remainTokens.length) {
	            const token = remainTokens.shift();
	            if (isTagToken(token) && token.name === 'endraw')
	                return;
	            this.tokens.push(token);
	        }
	        throw new Error(`tag ${tagToken.getText()} not closed`);
	    }
	    render() {
	        return this.tokens.map((token) => token.getText()).join('');
	    }
	}

	class TablerowloopDrop extends ForloopDrop {
	    constructor(length, cols, collection, variable) {
	        super(length, collection, variable);
	        this.length = length;
	        this.cols = cols;
	    }
	    row() {
	        return Math.floor(this.i / this.cols) + 1;
	    }
	    col0() {
	        return (this.i % this.cols);
	    }
	    col() {
	        return this.col0() + 1;
	    }
	    col_first() {
	        return this.col0() === 0;
	    }
	    col_last() {
	        return this.col() === this.cols;
	    }
	}

	class TablerowTag extends Tag {
	    constructor(tagToken, remainTokens, liquid) {
	        super(tagToken, remainTokens, liquid);
	        const tokenizer = new Tokenizer(tagToken.args, this.liquid.options.operators);
	        const variable = tokenizer.readIdentifier();
	        tokenizer.skipBlank();
	        const predicate = tokenizer.readIdentifier();
	        const collectionToken = tokenizer.readValue();
	        if (predicate.content !== 'in' || !collectionToken) {
	            throw new Error(`illegal tag: ${tagToken.getText()}`);
	        }
	        this.variable = variable.content;
	        this.collection = collectionToken;
	        this.args = new Hash(tokenizer.remaining());
	        this.templates = [];
	        let p;
	        const stream = this.liquid.parser.parseStream(remainTokens)
	            .on('start', () => (p = this.templates))
	            .on('tag:endtablerow', () => stream.stop())
	            .on('template', (tpl) => p.push(tpl))
	            .on('end', () => {
	            throw new Error(`tag ${tagToken.getText()} not closed`);
	        });
	        stream.start();
	    }
	    *render(ctx, emitter) {
	        let collection = toEnumerable(yield evalToken(this.collection, ctx));
	        const args = (yield this.args.render(ctx));
	        const offset = args.offset || 0;
	        const limit = (args.limit === undefined) ? collection.length : args.limit;
	        collection = collection.slice(offset, offset + limit);
	        const cols = args.cols || collection.length;
	        const r = this.liquid.renderer;
	        const tablerowloop = new TablerowloopDrop(collection.length, cols, this.collection.getText(), this.variable);
	        const scope = { tablerowloop };
	        ctx.push(scope);
	        for (let idx = 0; idx < collection.length; idx++, tablerowloop.next()) {
	            scope[this.variable] = collection[idx];
	            if (tablerowloop.col0() === 0) {
	                if (tablerowloop.row() !== 1)
	                    emitter.write('</tr>');
	                emitter.write(`<tr class="row${tablerowloop.row()}">`);
	            }
	            emitter.write(`<td class="col${tablerowloop.col()}">`);
	            yield r.renderTemplates(this.templates, ctx, emitter);
	            emitter.write('</td>');
	        }
	        if (collection.length)
	            emitter.write('</tr>');
	        ctx.pop();
	    }
	}

	class UnlessTag extends Tag {
	    constructor(tagToken, remainTokens, liquid) {
	        super(tagToken, remainTokens, liquid);
	        this.branches = [];
	        this.elseTemplates = [];
	        let p;
	        this.liquid.parser.parseStream(remainTokens)
	            .on('start', () => this.branches.push({
	            value: new Value(tagToken.args, this.liquid),
	            test: isFalsy,
	            templates: (p = [])
	        }))
	            .on('tag:elsif', (token) => this.branches.push({
	            value: new Value(token.args, this.liquid),
	            test: isTruthy,
	            templates: (p = [])
	        }))
	            .on('tag:else', () => (p = this.elseTemplates))
	            .on('tag:endunless', function () { this.stop(); })
	            .on('template', (tpl) => p.push(tpl))
	            .on('end', () => { throw new Error(`tag ${tagToken.getText()} not closed`); })
	            .start();
	    }
	    *render(ctx, emitter) {
	        const r = this.liquid.renderer;
	        for (const { value, test, templates } of this.branches) {
	            const v = yield value.value(ctx, ctx.opts.lenientIf);
	            if (test(v, ctx)) {
	                yield r.renderTemplates(templates, ctx, emitter);
	                return;
	            }
	        }
	        yield r.renderTemplates(this.elseTemplates, ctx, emitter);
	    }
	}

	class BreakTag extends Tag {
	    render(ctx, emitter) {
	        emitter['break'] = true;
	    }
	}

	class ContinueTag extends Tag {
	    render(ctx, emitter) {
	        emitter['continue'] = true;
	    }
	}

	class EchoTag extends Tag {
	    constructor(token, remainTokens, liquid) {
	        super(token, remainTokens, liquid);
	        this.value = new Value(token.args, this.liquid);
	    }
	    *render(ctx, emitter) {
	        const val = yield this.value.value(ctx, false);
	        emitter.write(val);
	    }
	}

	class LiquidTag extends Tag {
	    constructor(token, remainTokens, liquid) {
	        super(token, remainTokens, liquid);
	        const tokenizer = new Tokenizer(token.args, this.liquid.options.operators);
	        const tokens = tokenizer.readLiquidTagTokens(this.liquid.options);
	        this.templates = this.liquid.parser.parseTokens(tokens);
	    }
	    *render(ctx, emitter) {
	        yield this.liquid.renderer.renderTemplates(this.templates, ctx, emitter);
	    }
	}

	class InlineCommentTag extends Tag {
	    constructor(tagToken, remainTokens, liquid) {
	        super(tagToken, remainTokens, liquid);
	        if (tagToken.args.search(/\n\s*[^#\s]/g) !== -1) {
	            throw new Error('every line of an inline comment must start with a \'#\' character');
	        }
	    }
	    render() { }
	}

	const tags = {
	    assign: AssignTag,
	    'for': ForTag,
	    capture: CaptureTag,
	    'case': CaseTag,
	    comment: CommentTag,
	    include: IncludeTag,
	    render: RenderTag,
	    decrement: DecrementTag,
	    increment: IncrementTag,
	    cycle: CycleTag,
	    'if': IfTag,
	    layout: LayoutTag,
	    block: BlockTag,
	    raw: RawTag,
	    tablerow: TablerowTag,
	    unless: UnlessTag,
	    'break': BreakTag,
	    'continue': ContinueTag,
	    echo: EchoTag,
	    liquid: LiquidTag,
	    '#': InlineCommentTag
	};

	class Liquid {
	    constructor(opts = {}) {
	        this.renderer = new Render();
	        this.filters = {};
	        this.tags = {};
	        this.options = normalize(opts);
	        this.parser = new Parser(this);
	        forOwn(tags, (conf, name) => this.registerTag(name, conf));
	        forOwn(filters, (handler, name) => this.registerFilter(name, handler));
	    }
	    parse(html, filepath) {
	        return this.parser.parse(html, filepath);
	    }
	    _render(tpl, scope, renderOptions) {
	        const ctx = new Context(scope, this.options, renderOptions);
	        return this.renderer.renderTemplates(tpl, ctx);
	    }
	    render(tpl, scope, renderOptions) {
	        return __awaiter(this, void 0, void 0, function* () {
	            return toPromise(this._render(tpl, scope, Object.assign(Object.assign({}, renderOptions), { sync: false })));
	        });
	    }
	    renderSync(tpl, scope, renderOptions) {
	        return toValueSync(this._render(tpl, scope, Object.assign(Object.assign({}, renderOptions), { sync: true })));
	    }
	    renderToNodeStream(tpl, scope, renderOptions = {}) {
	        const ctx = new Context(scope, this.options, renderOptions);
	        return this.renderer.renderTemplatesToNodeStream(tpl, ctx);
	    }
	    _parseAndRender(html, scope, renderOptions) {
	        const tpl = this.parse(html);
	        return this._render(tpl, scope, renderOptions);
	    }
	    parseAndRender(html, scope, renderOptions) {
	        return __awaiter(this, void 0, void 0, function* () {
	            return toPromise(this._parseAndRender(html, scope, Object.assign(Object.assign({}, renderOptions), { sync: false })));
	        });
	    }
	    parseAndRenderSync(html, scope, renderOptions) {
	        return toValueSync(this._parseAndRender(html, scope, Object.assign(Object.assign({}, renderOptions), { sync: true })));
	    }
	    _parsePartialFile(file, sync, currentFile) {
	        return this.parser.parseFile(file, sync, LookupType.Partials, currentFile);
	    }
	    _parseLayoutFile(file, sync, currentFile) {
	        return this.parser.parseFile(file, sync, LookupType.Layouts, currentFile);
	    }
	    parseFile(file) {
	        return __awaiter(this, void 0, void 0, function* () {
	            return toPromise(this.parser.parseFile(file, false));
	        });
	    }
	    parseFileSync(file) {
	        return toValueSync(this.parser.parseFile(file, true));
	    }
	    renderFile(file, ctx, renderOptions) {
	        return __awaiter(this, void 0, void 0, function* () {
	            const templates = yield this.parseFile(file);
	            return this.render(templates, ctx, renderOptions);
	        });
	    }
	    renderFileSync(file, ctx, renderOptions) {
	        const templates = this.parseFileSync(file);
	        return this.renderSync(templates, ctx, renderOptions);
	    }
	    renderFileToNodeStream(file, scope, renderOptions) {
	        return __awaiter(this, void 0, void 0, function* () {
	            const templates = yield this.parseFile(file);
	            return this.renderToNodeStream(templates, scope, renderOptions);
	        });
	    }
	    _evalValue(str, scope) {
	        const value = new Value(str, this);
	        const ctx = scope instanceof Context ? scope : new Context(scope, this.options);
	        return value.value(ctx);
	    }
	    evalValue(str, scope) {
	        return __awaiter(this, void 0, void 0, function* () {
	            return toPromise(this._evalValue(str, scope));
	        });
	    }
	    evalValueSync(str, scope) {
	        return toValueSync(this._evalValue(str, scope));
	    }
	    registerFilter(name, filter) {
	        this.filters[name] = filter;
	    }
	    registerTag(name, tag) {
	        this.tags[name] = isFunction(tag) ? tag : createTagClass(tag);
	    }
	    plugin(plugin) {
	        return plugin.call(this, Liquid);
	    }
	    express() {
	        const self = this; // eslint-disable-line
	        let firstCall = true;
	        return function (filePath, ctx, callback) {
	            if (firstCall) {
	                firstCall = false;
	                const dirs = normalizeDirectoryList(this.root);
	                self.options.root.unshift(...dirs);
	                self.options.layouts.unshift(...dirs);
	                self.options.partials.unshift(...dirs);
	            }
	            self.renderFile(filePath, ctx).then(html => callback(null, html), callback);
	        };
	    }
	}

	var ContentType;
	(function (ContentType) {
	    ContentType["JSON"] = "json";
	    ContentType["YAML"] = "yaml";
	    ContentType["UNKNOWN"] = "unknown";
	})(ContentType || (ContentType = {}));
	var WaylayTypes;
	(function (WaylayTypes) {
	    WaylayTypes["STRING"] = "string";
	    WaylayTypes["INTEGER"] = "integer";
	    WaylayTypes["DOUBLE"] = "double";
	    WaylayTypes["OBJECT"] = "object";
	    WaylayTypes["BOOLEAN"] = "boolean";
	    WaylayTypes["LONG"] = "long";
	    WaylayTypes["FLOAT"] = "enum";
	})(WaylayTypes || (WaylayTypes = {}));
	var IntegerFormats;
	(function (IntegerFormats) {
	    IntegerFormats["INT32"] = "int32";
	    IntegerFormats["INT64"] = "int64";
	})(IntegerFormats || (IntegerFormats = {}));

	/**
	 * Inside the plugin function, `this` refers to the Liquid instance.
	 */
	const convertSchema = (schema, componentsSchemas) => {
	    var _a;
	    if (schema === null || schema === void 0 ? void 0 : schema.$ref) {
	        const fullRef = (_a = schema === null || schema === void 0 ? void 0 : schema.$ref) === null || _a === void 0 ? void 0 : _a.split("/");
	        const ref = fullRef[fullRef.length - 1];
	        return convertSchema(componentsSchemas[ref], componentsSchemas);
	    }
	    else {
	        const type = schema.type;
	        const format = schema.format;
	        if (type != null) {
	            if (type === WaylayTypes.INTEGER) {
	                if (format === IntegerFormats.INT64) {
	                    return WaylayTypes.LONG;
	                }
	                else
	                    return WaylayTypes.INTEGER;
	            }
	            if (type === "number") {
	                if (format != null)
	                    return format;
	                else
	                    return WaylayTypes.INTEGER;
	            }
	            if (type === "boolean") {
	                console.log("RETURN");
	                return WaylayTypes.BOOLEAN;
	            }
	            if (type === "array")
	                return WaylayTypes.OBJECT;
	            return type;
	        }
	        return WaylayTypes.OBJECT;
	    }
	};
	function convertSchemaTypePlugin () {
	    this.registerFilter("convert_schema_type", (schema, componentsSchemas) => {
	        return convertSchema(schema, componentsSchemas);
	    });
	}

	/* eslint-disable no-template-curly-in-string */
	/**
	 * Inside the plugin function, `this` refers to the Liquid instance.
	 */
	function substitutePathParamsPlugin () {
	    this.registerFilter('substitute_path_params', (path) => {
	        const regex = /\/{(\w+)}/gm;
	        const subst = '/${options.requiredProperties.$1}';
	        return path.replace(regex, subst);
	    });
	}

	var reExports = {};
	var re$3 = {
	  get exports(){ return reExports; },
	  set exports(v){ reExports = v; },
	};

	// Note: this is the semver.org version of the spec that it implements
	// Not necessarily the package version of this code.
	const SEMVER_SPEC_VERSION = '2.0.0';

	const MAX_LENGTH$2 = 256;
	const MAX_SAFE_INTEGER$1 = Number.MAX_SAFE_INTEGER ||
	/* istanbul ignore next */ 9007199254740991;

	// Max safe segment length for coercion.
	const MAX_SAFE_COMPONENT_LENGTH = 16;

	var constants$1 = {
	  SEMVER_SPEC_VERSION,
	  MAX_LENGTH: MAX_LENGTH$2,
	  MAX_SAFE_INTEGER: MAX_SAFE_INTEGER$1,
	  MAX_SAFE_COMPONENT_LENGTH,
	};

	const debug$1 = (
	  typeof browser$1 === 'object' &&
	  browser$1.env &&
	  browser$1.env.NODE_DEBUG &&
	  /\bsemver\b/i.test(browser$1.env.NODE_DEBUG)
	) ? (...args) => console.error('SEMVER', ...args)
	  : () => {};

	var debug_1 = debug$1;

	(function (module, exports) {
		const { MAX_SAFE_COMPONENT_LENGTH } = constants$1;
		const debug = debug_1;
		exports = module.exports = {};

		// The actual regexps go on exports.re
		const re = exports.re = [];
		const src = exports.src = [];
		const t = exports.t = {};
		let R = 0;

		const createToken = (name, value, isGlobal) => {
		  const index = R++;
		  debug(name, index, value);
		  t[name] = index;
		  src[index] = value;
		  re[index] = new RegExp(value, isGlobal ? 'g' : undefined);
		};

		// The following Regular Expressions can be used for tokenizing,
		// validating, and parsing SemVer version strings.

		// ## Numeric Identifier
		// A single `0`, or a non-zero digit followed by zero or more digits.

		createToken('NUMERICIDENTIFIER', '0|[1-9]\\d*');
		createToken('NUMERICIDENTIFIERLOOSE', '[0-9]+');

		// ## Non-numeric Identifier
		// Zero or more digits, followed by a letter or hyphen, and then zero or
		// more letters, digits, or hyphens.

		createToken('NONNUMERICIDENTIFIER', '\\d*[a-zA-Z-][a-zA-Z0-9-]*');

		// ## Main Version
		// Three dot-separated numeric identifiers.

		createToken('MAINVERSION', `(${src[t.NUMERICIDENTIFIER]})\\.` +
		                   `(${src[t.NUMERICIDENTIFIER]})\\.` +
		                   `(${src[t.NUMERICIDENTIFIER]})`);

		createToken('MAINVERSIONLOOSE', `(${src[t.NUMERICIDENTIFIERLOOSE]})\\.` +
		                        `(${src[t.NUMERICIDENTIFIERLOOSE]})\\.` +
		                        `(${src[t.NUMERICIDENTIFIERLOOSE]})`);

		// ## Pre-release Version Identifier
		// A numeric identifier, or a non-numeric identifier.

		createToken('PRERELEASEIDENTIFIER', `(?:${src[t.NUMERICIDENTIFIER]
	}|${src[t.NONNUMERICIDENTIFIER]})`);

		createToken('PRERELEASEIDENTIFIERLOOSE', `(?:${src[t.NUMERICIDENTIFIERLOOSE]
	}|${src[t.NONNUMERICIDENTIFIER]})`);

		// ## Pre-release Version
		// Hyphen, followed by one or more dot-separated pre-release version
		// identifiers.

		createToken('PRERELEASE', `(?:-(${src[t.PRERELEASEIDENTIFIER]
	}(?:\\.${src[t.PRERELEASEIDENTIFIER]})*))`);

		createToken('PRERELEASELOOSE', `(?:-?(${src[t.PRERELEASEIDENTIFIERLOOSE]
	}(?:\\.${src[t.PRERELEASEIDENTIFIERLOOSE]})*))`);

		// ## Build Metadata Identifier
		// Any combination of digits, letters, or hyphens.

		createToken('BUILDIDENTIFIER', '[0-9A-Za-z-]+');

		// ## Build Metadata
		// Plus sign, followed by one or more period-separated build metadata
		// identifiers.

		createToken('BUILD', `(?:\\+(${src[t.BUILDIDENTIFIER]
	}(?:\\.${src[t.BUILDIDENTIFIER]})*))`);

		// ## Full Version String
		// A main version, followed optionally by a pre-release version and
		// build metadata.

		// Note that the only major, minor, patch, and pre-release sections of
		// the version string are capturing groups.  The build metadata is not a
		// capturing group, because it should not ever be used in version
		// comparison.

		createToken('FULLPLAIN', `v?${src[t.MAINVERSION]
	}${src[t.PRERELEASE]}?${
	  src[t.BUILD]}?`);

		createToken('FULL', `^${src[t.FULLPLAIN]}$`);

		// like full, but allows v1.2.3 and =1.2.3, which people do sometimes.
		// also, 1.0.0alpha1 (prerelease without the hyphen) which is pretty
		// common in the npm registry.
		createToken('LOOSEPLAIN', `[v=\\s]*${src[t.MAINVERSIONLOOSE]
	}${src[t.PRERELEASELOOSE]}?${
	  src[t.BUILD]}?`);

		createToken('LOOSE', `^${src[t.LOOSEPLAIN]}$`);

		createToken('GTLT', '((?:<|>)?=?)');

		// Something like "2.*" or "1.2.x".
		// Note that "x.x" is a valid xRange identifer, meaning "any version"
		// Only the first item is strictly required.
		createToken('XRANGEIDENTIFIERLOOSE', `${src[t.NUMERICIDENTIFIERLOOSE]}|x|X|\\*`);
		createToken('XRANGEIDENTIFIER', `${src[t.NUMERICIDENTIFIER]}|x|X|\\*`);

		createToken('XRANGEPLAIN', `[v=\\s]*(${src[t.XRANGEIDENTIFIER]})` +
		                   `(?:\\.(${src[t.XRANGEIDENTIFIER]})` +
		                   `(?:\\.(${src[t.XRANGEIDENTIFIER]})` +
		                   `(?:${src[t.PRERELEASE]})?${
	                     src[t.BUILD]}?` +
		                   `)?)?`);

		createToken('XRANGEPLAINLOOSE', `[v=\\s]*(${src[t.XRANGEIDENTIFIERLOOSE]})` +
		                        `(?:\\.(${src[t.XRANGEIDENTIFIERLOOSE]})` +
		                        `(?:\\.(${src[t.XRANGEIDENTIFIERLOOSE]})` +
		                        `(?:${src[t.PRERELEASELOOSE]})?${
	                          src[t.BUILD]}?` +
		                        `)?)?`);

		createToken('XRANGE', `^${src[t.GTLT]}\\s*${src[t.XRANGEPLAIN]}$`);
		createToken('XRANGELOOSE', `^${src[t.GTLT]}\\s*${src[t.XRANGEPLAINLOOSE]}$`);

		// Coercion.
		// Extract anything that could conceivably be a part of a valid semver
		createToken('COERCE', `${'(^|[^\\d])' +
	              '(\\d{1,'}${MAX_SAFE_COMPONENT_LENGTH}})` +
		              `(?:\\.(\\d{1,${MAX_SAFE_COMPONENT_LENGTH}}))?` +
		              `(?:\\.(\\d{1,${MAX_SAFE_COMPONENT_LENGTH}}))?` +
		              `(?:$|[^\\d])`);
		createToken('COERCERTL', src[t.COERCE], true);

		// Tilde ranges.
		// Meaning is "reasonably at or greater than"
		createToken('LONETILDE', '(?:~>?)');

		createToken('TILDETRIM', `(\\s*)${src[t.LONETILDE]}\\s+`, true);
		exports.tildeTrimReplace = '$1~';

		createToken('TILDE', `^${src[t.LONETILDE]}${src[t.XRANGEPLAIN]}$`);
		createToken('TILDELOOSE', `^${src[t.LONETILDE]}${src[t.XRANGEPLAINLOOSE]}$`);

		// Caret ranges.
		// Meaning is "at least and backwards compatible with"
		createToken('LONECARET', '(?:\\^)');

		createToken('CARETTRIM', `(\\s*)${src[t.LONECARET]}\\s+`, true);
		exports.caretTrimReplace = '$1^';

		createToken('CARET', `^${src[t.LONECARET]}${src[t.XRANGEPLAIN]}$`);
		createToken('CARETLOOSE', `^${src[t.LONECARET]}${src[t.XRANGEPLAINLOOSE]}$`);

		// A simple gt/lt/eq thing, or just "" to indicate "any version"
		createToken('COMPARATORLOOSE', `^${src[t.GTLT]}\\s*(${src[t.LOOSEPLAIN]})$|^$`);
		createToken('COMPARATOR', `^${src[t.GTLT]}\\s*(${src[t.FULLPLAIN]})$|^$`);

		// An expression to strip any whitespace between the gtlt and the thing
		// it modifies, so that `> 1.2.3` ==> `>1.2.3`
		createToken('COMPARATORTRIM', `(\\s*)${src[t.GTLT]
	}\\s*(${src[t.LOOSEPLAIN]}|${src[t.XRANGEPLAIN]})`, true);
		exports.comparatorTrimReplace = '$1$2$3';

		// Something like `1.2.3 - 1.2.4`
		// Note that these all use the loose form, because they'll be
		// checked against either the strict or loose comparator form
		// later.
		createToken('HYPHENRANGE', `^\\s*(${src[t.XRANGEPLAIN]})` +
		                   `\\s+-\\s+` +
		                   `(${src[t.XRANGEPLAIN]})` +
		                   `\\s*$`);

		createToken('HYPHENRANGELOOSE', `^\\s*(${src[t.XRANGEPLAINLOOSE]})` +
		                        `\\s+-\\s+` +
		                        `(${src[t.XRANGEPLAINLOOSE]})` +
		                        `\\s*$`);

		// Star ranges basically just allow anything at all.
		createToken('STAR', '(<|>)?=?\\s*\\*');
		// >=0.0.0 is like a star
		createToken('GTE0', '^\\s*>=\\s*0\\.0\\.0\\s*$');
		createToken('GTE0PRE', '^\\s*>=\\s*0\\.0\\.0-0\\s*$');
	} (re$3, reExports));

	// parse out just the options we care about so we always get a consistent
	// obj with keys in a consistent order.
	const opts = ['includePrerelease', 'loose', 'rtl'];
	const parseOptions$2 = options =>
	  !options ? {}
	  : typeof options !== 'object' ? { loose: true }
	  : opts.filter(k => options[k]).reduce((o, k) => {
	    o[k] = true;
	    return o
	  }, {});
	var parseOptions_1 = parseOptions$2;

	const numeric = /^[0-9]+$/;
	const compareIdentifiers$1 = (a, b) => {
	  const anum = numeric.test(a);
	  const bnum = numeric.test(b);

	  if (anum && bnum) {
	    a = +a;
	    b = +b;
	  }

	  return a === b ? 0
	    : (anum && !bnum) ? -1
	    : (bnum && !anum) ? 1
	    : a < b ? -1
	    : 1
	};

	const rcompareIdentifiers = (a, b) => compareIdentifiers$1(b, a);

	var identifiers$1 = {
	  compareIdentifiers: compareIdentifiers$1,
	  rcompareIdentifiers,
	};

	const debug = debug_1;
	const { MAX_LENGTH: MAX_LENGTH$1, MAX_SAFE_INTEGER } = constants$1;
	const { re: re$2, t: t$2 } = reExports;

	const parseOptions$1 = parseOptions_1;
	const { compareIdentifiers } = identifiers$1;
	class SemVer$d {
	  constructor (version, options) {
	    options = parseOptions$1(options);

	    if (version instanceof SemVer$d) {
	      if (version.loose === !!options.loose &&
	          version.includePrerelease === !!options.includePrerelease) {
	        return version
	      } else {
	        version = version.version;
	      }
	    } else if (typeof version !== 'string') {
	      throw new TypeError(`Invalid Version: ${version}`)
	    }

	    if (version.length > MAX_LENGTH$1) {
	      throw new TypeError(
	        `version is longer than ${MAX_LENGTH$1} characters`
	      )
	    }

	    debug('SemVer', version, options);
	    this.options = options;
	    this.loose = !!options.loose;
	    // this isn't actually relevant for versions, but keep it so that we
	    // don't run into trouble passing this.options around.
	    this.includePrerelease = !!options.includePrerelease;

	    const m = version.trim().match(options.loose ? re$2[t$2.LOOSE] : re$2[t$2.FULL]);

	    if (!m) {
	      throw new TypeError(`Invalid Version: ${version}`)
	    }

	    this.raw = version;

	    // these are actually numbers
	    this.major = +m[1];
	    this.minor = +m[2];
	    this.patch = +m[3];

	    if (this.major > MAX_SAFE_INTEGER || this.major < 0) {
	      throw new TypeError('Invalid major version')
	    }

	    if (this.minor > MAX_SAFE_INTEGER || this.minor < 0) {
	      throw new TypeError('Invalid minor version')
	    }

	    if (this.patch > MAX_SAFE_INTEGER || this.patch < 0) {
	      throw new TypeError('Invalid patch version')
	    }

	    // numberify any prerelease numeric ids
	    if (!m[4]) {
	      this.prerelease = [];
	    } else {
	      this.prerelease = m[4].split('.').map((id) => {
	        if (/^[0-9]+$/.test(id)) {
	          const num = +id;
	          if (num >= 0 && num < MAX_SAFE_INTEGER) {
	            return num
	          }
	        }
	        return id
	      });
	    }

	    this.build = m[5] ? m[5].split('.') : [];
	    this.format();
	  }

	  format () {
	    this.version = `${this.major}.${this.minor}.${this.patch}`;
	    if (this.prerelease.length) {
	      this.version += `-${this.prerelease.join('.')}`;
	    }
	    return this.version
	  }

	  toString () {
	    return this.version
	  }

	  compare (other) {
	    debug('SemVer.compare', this.version, this.options, other);
	    if (!(other instanceof SemVer$d)) {
	      if (typeof other === 'string' && other === this.version) {
	        return 0
	      }
	      other = new SemVer$d(other, this.options);
	    }

	    if (other.version === this.version) {
	      return 0
	    }

	    return this.compareMain(other) || this.comparePre(other)
	  }

	  compareMain (other) {
	    if (!(other instanceof SemVer$d)) {
	      other = new SemVer$d(other, this.options);
	    }

	    return (
	      compareIdentifiers(this.major, other.major) ||
	      compareIdentifiers(this.minor, other.minor) ||
	      compareIdentifiers(this.patch, other.patch)
	    )
	  }

	  comparePre (other) {
	    if (!(other instanceof SemVer$d)) {
	      other = new SemVer$d(other, this.options);
	    }

	    // NOT having a prerelease is > having one
	    if (this.prerelease.length && !other.prerelease.length) {
	      return -1
	    } else if (!this.prerelease.length && other.prerelease.length) {
	      return 1
	    } else if (!this.prerelease.length && !other.prerelease.length) {
	      return 0
	    }

	    let i = 0;
	    do {
	      const a = this.prerelease[i];
	      const b = other.prerelease[i];
	      debug('prerelease compare', i, a, b);
	      if (a === undefined && b === undefined) {
	        return 0
	      } else if (b === undefined) {
	        return 1
	      } else if (a === undefined) {
	        return -1
	      } else if (a === b) {
	        continue
	      } else {
	        return compareIdentifiers(a, b)
	      }
	    } while (++i)
	  }

	  compareBuild (other) {
	    if (!(other instanceof SemVer$d)) {
	      other = new SemVer$d(other, this.options);
	    }

	    let i = 0;
	    do {
	      const a = this.build[i];
	      const b = other.build[i];
	      debug('prerelease compare', i, a, b);
	      if (a === undefined && b === undefined) {
	        return 0
	      } else if (b === undefined) {
	        return 1
	      } else if (a === undefined) {
	        return -1
	      } else if (a === b) {
	        continue
	      } else {
	        return compareIdentifiers(a, b)
	      }
	    } while (++i)
	  }

	  // preminor will bump the version up to the next minor release, and immediately
	  // down to pre-release. premajor and prepatch work the same way.
	  inc (release, identifier) {
	    switch (release) {
	      case 'premajor':
	        this.prerelease.length = 0;
	        this.patch = 0;
	        this.minor = 0;
	        this.major++;
	        this.inc('pre', identifier);
	        break
	      case 'preminor':
	        this.prerelease.length = 0;
	        this.patch = 0;
	        this.minor++;
	        this.inc('pre', identifier);
	        break
	      case 'prepatch':
	        // If this is already a prerelease, it will bump to the next version
	        // drop any prereleases that might already exist, since they are not
	        // relevant at this point.
	        this.prerelease.length = 0;
	        this.inc('patch', identifier);
	        this.inc('pre', identifier);
	        break
	      // If the input is a non-prerelease version, this acts the same as
	      // prepatch.
	      case 'prerelease':
	        if (this.prerelease.length === 0) {
	          this.inc('patch', identifier);
	        }
	        this.inc('pre', identifier);
	        break

	      case 'major':
	        // If this is a pre-major version, bump up to the same major version.
	        // Otherwise increment major.
	        // 1.0.0-5 bumps to 1.0.0
	        // 1.1.0 bumps to 2.0.0
	        if (
	          this.minor !== 0 ||
	          this.patch !== 0 ||
	          this.prerelease.length === 0
	        ) {
	          this.major++;
	        }
	        this.minor = 0;
	        this.patch = 0;
	        this.prerelease = [];
	        break
	      case 'minor':
	        // If this is a pre-minor version, bump up to the same minor version.
	        // Otherwise increment minor.
	        // 1.2.0-5 bumps to 1.2.0
	        // 1.2.1 bumps to 1.3.0
	        if (this.patch !== 0 || this.prerelease.length === 0) {
	          this.minor++;
	        }
	        this.patch = 0;
	        this.prerelease = [];
	        break
	      case 'patch':
	        // If this is not a pre-release version, it will increment the patch.
	        // If it is a pre-release it will bump up to the same patch version.
	        // 1.2.0-5 patches to 1.2.0
	        // 1.2.0 patches to 1.2.1
	        if (this.prerelease.length === 0) {
	          this.patch++;
	        }
	        this.prerelease = [];
	        break
	      // This probably shouldn't be used publicly.
	      // 1.0.0 'pre' would become 1.0.0-0 which is the wrong direction.
	      case 'pre':
	        if (this.prerelease.length === 0) {
	          this.prerelease = [0];
	        } else {
	          let i = this.prerelease.length;
	          while (--i >= 0) {
	            if (typeof this.prerelease[i] === 'number') {
	              this.prerelease[i]++;
	              i = -2;
	            }
	          }
	          if (i === -1) {
	            // didn't increment anything
	            this.prerelease.push(0);
	          }
	        }
	        if (identifier) {
	          // 1.2.0-beta.1 bumps to 1.2.0-beta.2,
	          // 1.2.0-beta.fooblz or 1.2.0-beta bumps to 1.2.0-beta.0
	          if (compareIdentifiers(this.prerelease[0], identifier) === 0) {
	            if (isNaN(this.prerelease[1])) {
	              this.prerelease = [identifier, 0];
	            }
	          } else {
	            this.prerelease = [identifier, 0];
	          }
	        }
	        break

	      default:
	        throw new Error(`invalid increment argument: ${release}`)
	    }
	    this.format();
	    this.raw = this.version;
	    return this
	  }
	}

	var semver$1 = SemVer$d;

	const { MAX_LENGTH } = constants$1;
	const { re: re$1, t: t$1 } = reExports;
	const SemVer$c = semver$1;

	const parseOptions = parseOptions_1;
	const parse$6 = (version, options) => {
	  options = parseOptions(options);

	  if (version instanceof SemVer$c) {
	    return version
	  }

	  if (typeof version !== 'string') {
	    return null
	  }

	  if (version.length > MAX_LENGTH) {
	    return null
	  }

	  const r = options.loose ? re$1[t$1.LOOSE] : re$1[t$1.FULL];
	  if (!r.test(version)) {
	    return null
	  }

	  try {
	    return new SemVer$c(version, options)
	  } catch (er) {
	    return null
	  }
	};

	var parse_1 = parse$6;

	const parse$5 = parse_1;
	const valid$2 = (version, options) => {
	  const v = parse$5(version, options);
	  return v ? v.version : null
	};
	var valid_1 = valid$2;

	const parse$4 = parse_1;
	const clean$1 = (version, options) => {
	  const s = parse$4(version.trim().replace(/^[=v]+/, ''), options);
	  return s ? s.version : null
	};
	var clean_1 = clean$1;

	const SemVer$b = semver$1;

	const inc$1 = (version, release, options, identifier) => {
	  if (typeof (options) === 'string') {
	    identifier = options;
	    options = undefined;
	  }

	  try {
	    return new SemVer$b(
	      version instanceof SemVer$b ? version.version : version,
	      options
	    ).inc(release, identifier).version
	  } catch (er) {
	    return null
	  }
	};
	var inc_1 = inc$1;

	const SemVer$a = semver$1;
	const compare$b = (a, b, loose) =>
	  new SemVer$a(a, loose).compare(new SemVer$a(b, loose));

	var compare_1 = compare$b;

	const compare$a = compare_1;
	const eq$3 = (a, b, loose) => compare$a(a, b, loose) === 0;
	var eq_1 = eq$3;

	const parse$3 = parse_1;
	const eq$2 = eq_1;

	const diff$1 = (version1, version2) => {
	  if (eq$2(version1, version2)) {
	    return null
	  } else {
	    const v1 = parse$3(version1);
	    const v2 = parse$3(version2);
	    const hasPre = v1.prerelease.length || v2.prerelease.length;
	    const prefix = hasPre ? 'pre' : '';
	    const defaultResult = hasPre ? 'prerelease' : '';
	    for (const key in v1) {
	      if (key === 'major' || key === 'minor' || key === 'patch') {
	        if (v1[key] !== v2[key]) {
	          return prefix + key
	        }
	      }
	    }
	    return defaultResult // may be undefined
	  }
	};
	var diff_1 = diff$1;

	const SemVer$9 = semver$1;
	const major$1 = (a, loose) => new SemVer$9(a, loose).major;
	var major_1 = major$1;

	const SemVer$8 = semver$1;
	const minor$1 = (a, loose) => new SemVer$8(a, loose).minor;
	var minor_1 = minor$1;

	const SemVer$7 = semver$1;
	const patch$1 = (a, loose) => new SemVer$7(a, loose).patch;
	var patch_1 = patch$1;

	const parse$2 = parse_1;
	const prerelease$1 = (version, options) => {
	  const parsed = parse$2(version, options);
	  return (parsed && parsed.prerelease.length) ? parsed.prerelease : null
	};
	var prerelease_1 = prerelease$1;

	const compare$9 = compare_1;
	const rcompare$1 = (a, b, loose) => compare$9(b, a, loose);
	var rcompare_1 = rcompare$1;

	const compare$8 = compare_1;
	const compareLoose$1 = (a, b) => compare$8(a, b, true);
	var compareLoose_1 = compareLoose$1;

	const SemVer$6 = semver$1;
	const compareBuild$3 = (a, b, loose) => {
	  const versionA = new SemVer$6(a, loose);
	  const versionB = new SemVer$6(b, loose);
	  return versionA.compare(versionB) || versionA.compareBuild(versionB)
	};
	var compareBuild_1 = compareBuild$3;

	const compareBuild$2 = compareBuild_1;
	const sort$1 = (list, loose) => list.sort((a, b) => compareBuild$2(a, b, loose));
	var sort_1 = sort$1;

	const compareBuild$1 = compareBuild_1;
	const rsort$1 = (list, loose) => list.sort((a, b) => compareBuild$1(b, a, loose));
	var rsort_1 = rsort$1;

	const compare$7 = compare_1;
	const gt$4 = (a, b, loose) => compare$7(a, b, loose) > 0;
	var gt_1 = gt$4;

	const compare$6 = compare_1;
	const lt$3 = (a, b, loose) => compare$6(a, b, loose) < 0;
	var lt_1 = lt$3;

	const compare$5 = compare_1;
	const neq$2 = (a, b, loose) => compare$5(a, b, loose) !== 0;
	var neq_1 = neq$2;

	const compare$4 = compare_1;
	const gte$3 = (a, b, loose) => compare$4(a, b, loose) >= 0;
	var gte_1 = gte$3;

	const compare$3 = compare_1;
	const lte$3 = (a, b, loose) => compare$3(a, b, loose) <= 0;
	var lte_1 = lte$3;

	const eq$1 = eq_1;
	const neq$1 = neq_1;
	const gt$3 = gt_1;
	const gte$2 = gte_1;
	const lt$2 = lt_1;
	const lte$2 = lte_1;

	const cmp$1 = (a, op, b, loose) => {
	  switch (op) {
	    case '===':
	      if (typeof a === 'object') {
	        a = a.version;
	      }
	      if (typeof b === 'object') {
	        b = b.version;
	      }
	      return a === b

	    case '!==':
	      if (typeof a === 'object') {
	        a = a.version;
	      }
	      if (typeof b === 'object') {
	        b = b.version;
	      }
	      return a !== b

	    case '':
	    case '=':
	    case '==':
	      return eq$1(a, b, loose)

	    case '!=':
	      return neq$1(a, b, loose)

	    case '>':
	      return gt$3(a, b, loose)

	    case '>=':
	      return gte$2(a, b, loose)

	    case '<':
	      return lt$2(a, b, loose)

	    case '<=':
	      return lte$2(a, b, loose)

	    default:
	      throw new TypeError(`Invalid operator: ${op}`)
	  }
	};
	var cmp_1 = cmp$1;

	const SemVer$5 = semver$1;
	const parse$1 = parse_1;
	const { re, t } = reExports;

	const coerce$1 = (version, options) => {
	  if (version instanceof SemVer$5) {
	    return version
	  }

	  if (typeof version === 'number') {
	    version = String(version);
	  }

	  if (typeof version !== 'string') {
	    return null
	  }

	  options = options || {};

	  let match = null;
	  if (!options.rtl) {
	    match = version.match(re[t.COERCE]);
	  } else {
	    // Find the right-most coercible string that does not share
	    // a terminus with a more left-ward coercible string.
	    // Eg, '1.2.3.4' wants to coerce '2.3.4', not '3.4' or '4'
	    //
	    // Walk through the string checking with a /g regexp
	    // Manually set the index so as to pick up overlapping matches.
	    // Stop when we get a match that ends at the string end, since no
	    // coercible string can be more right-ward without the same terminus.
	    let next;
	    while ((next = re[t.COERCERTL].exec(version)) &&
	        (!match || match.index + match[0].length !== version.length)
	    ) {
	      if (!match ||
	            next.index + next[0].length !== match.index + match[0].length) {
	        match = next;
	      }
	      re[t.COERCERTL].lastIndex = next.index + next[1].length + next[2].length;
	    }
	    // leave it in a clean state
	    re[t.COERCERTL].lastIndex = -1;
	  }

	  if (match === null) {
	    return null
	  }

	  return parse$1(`${match[2]}.${match[3] || '0'}.${match[4] || '0'}`, options)
	};
	var coerce_1 = coerce$1;

	var iterator;
	var hasRequiredIterator;

	function requireIterator () {
		if (hasRequiredIterator) return iterator;
		hasRequiredIterator = 1;
		iterator = function (Yallist) {
		  Yallist.prototype[Symbol.iterator] = function* () {
		    for (let walker = this.head; walker; walker = walker.next) {
		      yield walker.value;
		    }
		  };
		};
		return iterator;
	}

	var yallist = Yallist$1;

	Yallist$1.Node = Node;
	Yallist$1.create = Yallist$1;

	function Yallist$1 (list) {
	  var self = this;
	  if (!(self instanceof Yallist$1)) {
	    self = new Yallist$1();
	  }

	  self.tail = null;
	  self.head = null;
	  self.length = 0;

	  if (list && typeof list.forEach === 'function') {
	    list.forEach(function (item) {
	      self.push(item);
	    });
	  } else if (arguments.length > 0) {
	    for (var i = 0, l = arguments.length; i < l; i++) {
	      self.push(arguments[i]);
	    }
	  }

	  return self
	}

	Yallist$1.prototype.removeNode = function (node) {
	  if (node.list !== this) {
	    throw new Error('removing node which does not belong to this list')
	  }

	  var next = node.next;
	  var prev = node.prev;

	  if (next) {
	    next.prev = prev;
	  }

	  if (prev) {
	    prev.next = next;
	  }

	  if (node === this.head) {
	    this.head = next;
	  }
	  if (node === this.tail) {
	    this.tail = prev;
	  }

	  node.list.length--;
	  node.next = null;
	  node.prev = null;
	  node.list = null;

	  return next
	};

	Yallist$1.prototype.unshiftNode = function (node) {
	  if (node === this.head) {
	    return
	  }

	  if (node.list) {
	    node.list.removeNode(node);
	  }

	  var head = this.head;
	  node.list = this;
	  node.next = head;
	  if (head) {
	    head.prev = node;
	  }

	  this.head = node;
	  if (!this.tail) {
	    this.tail = node;
	  }
	  this.length++;
	};

	Yallist$1.prototype.pushNode = function (node) {
	  if (node === this.tail) {
	    return
	  }

	  if (node.list) {
	    node.list.removeNode(node);
	  }

	  var tail = this.tail;
	  node.list = this;
	  node.prev = tail;
	  if (tail) {
	    tail.next = node;
	  }

	  this.tail = node;
	  if (!this.head) {
	    this.head = node;
	  }
	  this.length++;
	};

	Yallist$1.prototype.push = function () {
	  for (var i = 0, l = arguments.length; i < l; i++) {
	    push(this, arguments[i]);
	  }
	  return this.length
	};

	Yallist$1.prototype.unshift = function () {
	  for (var i = 0, l = arguments.length; i < l; i++) {
	    unshift(this, arguments[i]);
	  }
	  return this.length
	};

	Yallist$1.prototype.pop = function () {
	  if (!this.tail) {
	    return undefined
	  }

	  var res = this.tail.value;
	  this.tail = this.tail.prev;
	  if (this.tail) {
	    this.tail.next = null;
	  } else {
	    this.head = null;
	  }
	  this.length--;
	  return res
	};

	Yallist$1.prototype.shift = function () {
	  if (!this.head) {
	    return undefined
	  }

	  var res = this.head.value;
	  this.head = this.head.next;
	  if (this.head) {
	    this.head.prev = null;
	  } else {
	    this.tail = null;
	  }
	  this.length--;
	  return res
	};

	Yallist$1.prototype.forEach = function (fn, thisp) {
	  thisp = thisp || this;
	  for (var walker = this.head, i = 0; walker !== null; i++) {
	    fn.call(thisp, walker.value, i, this);
	    walker = walker.next;
	  }
	};

	Yallist$1.prototype.forEachReverse = function (fn, thisp) {
	  thisp = thisp || this;
	  for (var walker = this.tail, i = this.length - 1; walker !== null; i--) {
	    fn.call(thisp, walker.value, i, this);
	    walker = walker.prev;
	  }
	};

	Yallist$1.prototype.get = function (n) {
	  for (var i = 0, walker = this.head; walker !== null && i < n; i++) {
	    // abort out of the list early if we hit a cycle
	    walker = walker.next;
	  }
	  if (i === n && walker !== null) {
	    return walker.value
	  }
	};

	Yallist$1.prototype.getReverse = function (n) {
	  for (var i = 0, walker = this.tail; walker !== null && i < n; i++) {
	    // abort out of the list early if we hit a cycle
	    walker = walker.prev;
	  }
	  if (i === n && walker !== null) {
	    return walker.value
	  }
	};

	Yallist$1.prototype.map = function (fn, thisp) {
	  thisp = thisp || this;
	  var res = new Yallist$1();
	  for (var walker = this.head; walker !== null;) {
	    res.push(fn.call(thisp, walker.value, this));
	    walker = walker.next;
	  }
	  return res
	};

	Yallist$1.prototype.mapReverse = function (fn, thisp) {
	  thisp = thisp || this;
	  var res = new Yallist$1();
	  for (var walker = this.tail; walker !== null;) {
	    res.push(fn.call(thisp, walker.value, this));
	    walker = walker.prev;
	  }
	  return res
	};

	Yallist$1.prototype.reduce = function (fn, initial) {
	  var acc;
	  var walker = this.head;
	  if (arguments.length > 1) {
	    acc = initial;
	  } else if (this.head) {
	    walker = this.head.next;
	    acc = this.head.value;
	  } else {
	    throw new TypeError('Reduce of empty list with no initial value')
	  }

	  for (var i = 0; walker !== null; i++) {
	    acc = fn(acc, walker.value, i);
	    walker = walker.next;
	  }

	  return acc
	};

	Yallist$1.prototype.reduceReverse = function (fn, initial) {
	  var acc;
	  var walker = this.tail;
	  if (arguments.length > 1) {
	    acc = initial;
	  } else if (this.tail) {
	    walker = this.tail.prev;
	    acc = this.tail.value;
	  } else {
	    throw new TypeError('Reduce of empty list with no initial value')
	  }

	  for (var i = this.length - 1; walker !== null; i--) {
	    acc = fn(acc, walker.value, i);
	    walker = walker.prev;
	  }

	  return acc
	};

	Yallist$1.prototype.toArray = function () {
	  var arr = new Array(this.length);
	  for (var i = 0, walker = this.head; walker !== null; i++) {
	    arr[i] = walker.value;
	    walker = walker.next;
	  }
	  return arr
	};

	Yallist$1.prototype.toArrayReverse = function () {
	  var arr = new Array(this.length);
	  for (var i = 0, walker = this.tail; walker !== null; i++) {
	    arr[i] = walker.value;
	    walker = walker.prev;
	  }
	  return arr
	};

	Yallist$1.prototype.slice = function (from, to) {
	  to = to || this.length;
	  if (to < 0) {
	    to += this.length;
	  }
	  from = from || 0;
	  if (from < 0) {
	    from += this.length;
	  }
	  var ret = new Yallist$1();
	  if (to < from || to < 0) {
	    return ret
	  }
	  if (from < 0) {
	    from = 0;
	  }
	  if (to > this.length) {
	    to = this.length;
	  }
	  for (var i = 0, walker = this.head; walker !== null && i < from; i++) {
	    walker = walker.next;
	  }
	  for (; walker !== null && i < to; i++, walker = walker.next) {
	    ret.push(walker.value);
	  }
	  return ret
	};

	Yallist$1.prototype.sliceReverse = function (from, to) {
	  to = to || this.length;
	  if (to < 0) {
	    to += this.length;
	  }
	  from = from || 0;
	  if (from < 0) {
	    from += this.length;
	  }
	  var ret = new Yallist$1();
	  if (to < from || to < 0) {
	    return ret
	  }
	  if (from < 0) {
	    from = 0;
	  }
	  if (to > this.length) {
	    to = this.length;
	  }
	  for (var i = this.length, walker = this.tail; walker !== null && i > to; i--) {
	    walker = walker.prev;
	  }
	  for (; walker !== null && i > from; i--, walker = walker.prev) {
	    ret.push(walker.value);
	  }
	  return ret
	};

	Yallist$1.prototype.splice = function (start, deleteCount, ...nodes) {
	  if (start > this.length) {
	    start = this.length - 1;
	  }
	  if (start < 0) {
	    start = this.length + start;
	  }

	  for (var i = 0, walker = this.head; walker !== null && i < start; i++) {
	    walker = walker.next;
	  }

	  var ret = [];
	  for (var i = 0; walker && i < deleteCount; i++) {
	    ret.push(walker.value);
	    walker = this.removeNode(walker);
	  }
	  if (walker === null) {
	    walker = this.tail;
	  }

	  if (walker !== this.head && walker !== this.tail) {
	    walker = walker.prev;
	  }

	  for (var i = 0; i < nodes.length; i++) {
	    walker = insert(this, walker, nodes[i]);
	  }
	  return ret;
	};

	Yallist$1.prototype.reverse = function () {
	  var head = this.head;
	  var tail = this.tail;
	  for (var walker = head; walker !== null; walker = walker.prev) {
	    var p = walker.prev;
	    walker.prev = walker.next;
	    walker.next = p;
	  }
	  this.head = tail;
	  this.tail = head;
	  return this
	};

	function insert (self, node, value) {
	  var inserted = node === self.head ?
	    new Node(value, null, node, self) :
	    new Node(value, node, node.next, self);

	  if (inserted.next === null) {
	    self.tail = inserted;
	  }
	  if (inserted.prev === null) {
	    self.head = inserted;
	  }

	  self.length++;

	  return inserted
	}

	function push (self, item) {
	  self.tail = new Node(item, self.tail, null, self);
	  if (!self.head) {
	    self.head = self.tail;
	  }
	  self.length++;
	}

	function unshift (self, item) {
	  self.head = new Node(item, null, self.head, self);
	  if (!self.tail) {
	    self.tail = self.head;
	  }
	  self.length++;
	}

	function Node (value, prev, next, list) {
	  if (!(this instanceof Node)) {
	    return new Node(value, prev, next, list)
	  }

	  this.list = list;
	  this.value = value;

	  if (prev) {
	    prev.next = this;
	    this.prev = prev;
	  } else {
	    this.prev = null;
	  }

	  if (next) {
	    next.prev = this;
	    this.next = next;
	  } else {
	    this.next = null;
	  }
	}

	try {
	  // add if support for Symbol.iterator is present
	  requireIterator()(Yallist$1);
	} catch (er) {}

	// A linked list to keep track of recently-used-ness
	const Yallist = yallist;

	const MAX = Symbol('max');
	const LENGTH = Symbol('length');
	const LENGTH_CALCULATOR = Symbol('lengthCalculator');
	const ALLOW_STALE = Symbol('allowStale');
	const MAX_AGE = Symbol('maxAge');
	const DISPOSE = Symbol('dispose');
	const NO_DISPOSE_ON_SET = Symbol('noDisposeOnSet');
	const LRU_LIST = Symbol('lruList');
	const CACHE = Symbol('cache');
	const UPDATE_AGE_ON_GET = Symbol('updateAgeOnGet');

	const naiveLength = () => 1;

	// lruList is a yallist where the head is the youngest
	// item, and the tail is the oldest.  the list contains the Hit
	// objects as the entries.
	// Each Hit object has a reference to its Yallist.Node.  This
	// never changes.
	//
	// cache is a Map (or PseudoMap) that matches the keys to
	// the Yallist.Node object.
	class LRUCache {
	  constructor (options) {
	    if (typeof options === 'number')
	      options = { max: options };

	    if (!options)
	      options = {};

	    if (options.max && (typeof options.max !== 'number' || options.max < 0))
	      throw new TypeError('max must be a non-negative number')
	    // Kind of weird to have a default max of Infinity, but oh well.
	    this[MAX] = options.max || Infinity;

	    const lc = options.length || naiveLength;
	    this[LENGTH_CALCULATOR] = (typeof lc !== 'function') ? naiveLength : lc;
	    this[ALLOW_STALE] = options.stale || false;
	    if (options.maxAge && typeof options.maxAge !== 'number')
	      throw new TypeError('maxAge must be a number')
	    this[MAX_AGE] = options.maxAge || 0;
	    this[DISPOSE] = options.dispose;
	    this[NO_DISPOSE_ON_SET] = options.noDisposeOnSet || false;
	    this[UPDATE_AGE_ON_GET] = options.updateAgeOnGet || false;
	    this.reset();
	  }

	  // resize the cache when the max changes.
	  set max (mL) {
	    if (typeof mL !== 'number' || mL < 0)
	      throw new TypeError('max must be a non-negative number')

	    this[MAX] = mL || Infinity;
	    trim(this);
	  }
	  get max () {
	    return this[MAX]
	  }

	  set allowStale (allowStale) {
	    this[ALLOW_STALE] = !!allowStale;
	  }
	  get allowStale () {
	    return this[ALLOW_STALE]
	  }

	  set maxAge (mA) {
	    if (typeof mA !== 'number')
	      throw new TypeError('maxAge must be a non-negative number')

	    this[MAX_AGE] = mA;
	    trim(this);
	  }
	  get maxAge () {
	    return this[MAX_AGE]
	  }

	  // resize the cache when the lengthCalculator changes.
	  set lengthCalculator (lC) {
	    if (typeof lC !== 'function')
	      lC = naiveLength;

	    if (lC !== this[LENGTH_CALCULATOR]) {
	      this[LENGTH_CALCULATOR] = lC;
	      this[LENGTH] = 0;
	      this[LRU_LIST].forEach(hit => {
	        hit.length = this[LENGTH_CALCULATOR](hit.value, hit.key);
	        this[LENGTH] += hit.length;
	      });
	    }
	    trim(this);
	  }
	  get lengthCalculator () { return this[LENGTH_CALCULATOR] }

	  get length () { return this[LENGTH] }
	  get itemCount () { return this[LRU_LIST].length }

	  rforEach (fn, thisp) {
	    thisp = thisp || this;
	    for (let walker = this[LRU_LIST].tail; walker !== null;) {
	      const prev = walker.prev;
	      forEachStep(this, fn, walker, thisp);
	      walker = prev;
	    }
	  }

	  forEach (fn, thisp) {
	    thisp = thisp || this;
	    for (let walker = this[LRU_LIST].head; walker !== null;) {
	      const next = walker.next;
	      forEachStep(this, fn, walker, thisp);
	      walker = next;
	    }
	  }

	  keys () {
	    return this[LRU_LIST].toArray().map(k => k.key)
	  }

	  values () {
	    return this[LRU_LIST].toArray().map(k => k.value)
	  }

	  reset () {
	    if (this[DISPOSE] &&
	        this[LRU_LIST] &&
	        this[LRU_LIST].length) {
	      this[LRU_LIST].forEach(hit => this[DISPOSE](hit.key, hit.value));
	    }

	    this[CACHE] = new Map(); // hash of items by key
	    this[LRU_LIST] = new Yallist(); // list of items in order of use recency
	    this[LENGTH] = 0; // length of items in the list
	  }

	  dump () {
	    return this[LRU_LIST].map(hit =>
	      isStale(this, hit) ? false : {
	        k: hit.key,
	        v: hit.value,
	        e: hit.now + (hit.maxAge || 0)
	      }).toArray().filter(h => h)
	  }

	  dumpLru () {
	    return this[LRU_LIST]
	  }

	  set (key, value, maxAge) {
	    maxAge = maxAge || this[MAX_AGE];

	    if (maxAge && typeof maxAge !== 'number')
	      throw new TypeError('maxAge must be a number')

	    const now = maxAge ? Date.now() : 0;
	    const len = this[LENGTH_CALCULATOR](value, key);

	    if (this[CACHE].has(key)) {
	      if (len > this[MAX]) {
	        del(this, this[CACHE].get(key));
	        return false
	      }

	      const node = this[CACHE].get(key);
	      const item = node.value;

	      // dispose of the old one before overwriting
	      // split out into 2 ifs for better coverage tracking
	      if (this[DISPOSE]) {
	        if (!this[NO_DISPOSE_ON_SET])
	          this[DISPOSE](key, item.value);
	      }

	      item.now = now;
	      item.maxAge = maxAge;
	      item.value = value;
	      this[LENGTH] += len - item.length;
	      item.length = len;
	      this.get(key);
	      trim(this);
	      return true
	    }

	    const hit = new Entry(key, value, len, now, maxAge);

	    // oversized objects fall out of cache automatically.
	    if (hit.length > this[MAX]) {
	      if (this[DISPOSE])
	        this[DISPOSE](key, value);

	      return false
	    }

	    this[LENGTH] += hit.length;
	    this[LRU_LIST].unshift(hit);
	    this[CACHE].set(key, this[LRU_LIST].head);
	    trim(this);
	    return true
	  }

	  has (key) {
	    if (!this[CACHE].has(key)) return false
	    const hit = this[CACHE].get(key).value;
	    return !isStale(this, hit)
	  }

	  get (key) {
	    return get(this, key, true)
	  }

	  peek (key) {
	    return get(this, key, false)
	  }

	  pop () {
	    const node = this[LRU_LIST].tail;
	    if (!node)
	      return null

	    del(this, node);
	    return node.value
	  }

	  del (key) {
	    del(this, this[CACHE].get(key));
	  }

	  load (arr) {
	    // reset the cache
	    this.reset();

	    const now = Date.now();
	    // A previous serialized cache has the most recent items first
	    for (let l = arr.length - 1; l >= 0; l--) {
	      const hit = arr[l];
	      const expiresAt = hit.e || 0;
	      if (expiresAt === 0)
	        // the item was created without expiration in a non aged cache
	        this.set(hit.k, hit.v);
	      else {
	        const maxAge = expiresAt - now;
	        // dont add already expired items
	        if (maxAge > 0) {
	          this.set(hit.k, hit.v, maxAge);
	        }
	      }
	    }
	  }

	  prune () {
	    this[CACHE].forEach((value, key) => get(this, key, false));
	  }
	}

	const get = (self, key, doUse) => {
	  const node = self[CACHE].get(key);
	  if (node) {
	    const hit = node.value;
	    if (isStale(self, hit)) {
	      del(self, node);
	      if (!self[ALLOW_STALE])
	        return undefined
	    } else {
	      if (doUse) {
	        if (self[UPDATE_AGE_ON_GET])
	          node.value.now = Date.now();
	        self[LRU_LIST].unshiftNode(node);
	      }
	    }
	    return hit.value
	  }
	};

	const isStale = (self, hit) => {
	  if (!hit || (!hit.maxAge && !self[MAX_AGE]))
	    return false

	  const diff = Date.now() - hit.now;
	  return hit.maxAge ? diff > hit.maxAge
	    : self[MAX_AGE] && (diff > self[MAX_AGE])
	};

	const trim = self => {
	  if (self[LENGTH] > self[MAX]) {
	    for (let walker = self[LRU_LIST].tail;
	      self[LENGTH] > self[MAX] && walker !== null;) {
	      // We know that we're about to delete this one, and also
	      // what the next least recently used key will be, so just
	      // go ahead and set it now.
	      const prev = walker.prev;
	      del(self, walker);
	      walker = prev;
	    }
	  }
	};

	const del = (self, node) => {
	  if (node) {
	    const hit = node.value;
	    if (self[DISPOSE])
	      self[DISPOSE](hit.key, hit.value);

	    self[LENGTH] -= hit.length;
	    self[CACHE].delete(hit.key);
	    self[LRU_LIST].removeNode(node);
	  }
	};

	class Entry {
	  constructor (key, value, length, now, maxAge) {
	    this.key = key;
	    this.value = value;
	    this.length = length;
	    this.now = now;
	    this.maxAge = maxAge || 0;
	  }
	}

	const forEachStep = (self, fn, node, thisp) => {
	  let hit = node.value;
	  if (isStale(self, hit)) {
	    del(self, node);
	    if (!self[ALLOW_STALE])
	      hit = undefined;
	  }
	  if (hit)
	    fn.call(thisp, hit.value, hit.key, self);
	};

	var lruCache = LRUCache;

	var range;
	var hasRequiredRange;

	function requireRange () {
		if (hasRequiredRange) return range;
		hasRequiredRange = 1;
		// hoisted class for cyclic dependency
		class Range {
		  constructor (range, options) {
		    options = parseOptions(options);

		    if (range instanceof Range) {
		      if (
		        range.loose === !!options.loose &&
		        range.includePrerelease === !!options.includePrerelease
		      ) {
		        return range
		      } else {
		        return new Range(range.raw, options)
		      }
		    }

		    if (range instanceof Comparator) {
		      // just put it in the set and return
		      this.raw = range.value;
		      this.set = [[range]];
		      this.format();
		      return this
		    }

		    this.options = options;
		    this.loose = !!options.loose;
		    this.includePrerelease = !!options.includePrerelease;

		    // First, split based on boolean or ||
		    this.raw = range;
		    this.set = range
		      .split('||')
		      // map the range to a 2d array of comparators
		      .map(r => this.parseRange(r.trim()))
		      // throw out any comparator lists that are empty
		      // this generally means that it was not a valid range, which is allowed
		      // in loose mode, but will still throw if the WHOLE range is invalid.
		      .filter(c => c.length);

		    if (!this.set.length) {
		      throw new TypeError(`Invalid SemVer Range: ${range}`)
		    }

		    // if we have any that are not the null set, throw out null sets.
		    if (this.set.length > 1) {
		      // keep the first one, in case they're all null sets
		      const first = this.set[0];
		      this.set = this.set.filter(c => !isNullSet(c[0]));
		      if (this.set.length === 0) {
		        this.set = [first];
		      } else if (this.set.length > 1) {
		        // if we have any that are *, then the range is just *
		        for (const c of this.set) {
		          if (c.length === 1 && isAny(c[0])) {
		            this.set = [c];
		            break
		          }
		        }
		      }
		    }

		    this.format();
		  }

		  format () {
		    this.range = this.set
		      .map((comps) => {
		        return comps.join(' ').trim()
		      })
		      .join('||')
		      .trim();
		    return this.range
		  }

		  toString () {
		    return this.range
		  }

		  parseRange (range) {
		    range = range.trim();

		    // memoize range parsing for performance.
		    // this is a very hot path, and fully deterministic.
		    const memoOpts = Object.keys(this.options).join(',');
		    const memoKey = `parseRange:${memoOpts}:${range}`;
		    const cached = cache.get(memoKey);
		    if (cached) {
		      return cached
		    }

		    const loose = this.options.loose;
		    // `1.2.3 - 1.2.4` => `>=1.2.3 <=1.2.4`
		    const hr = loose ? re[t.HYPHENRANGELOOSE] : re[t.HYPHENRANGE];
		    range = range.replace(hr, hyphenReplace(this.options.includePrerelease));
		    debug('hyphen replace', range);
		    // `> 1.2.3 < 1.2.5` => `>1.2.3 <1.2.5`
		    range = range.replace(re[t.COMPARATORTRIM], comparatorTrimReplace);
		    debug('comparator trim', range);

		    // `~ 1.2.3` => `~1.2.3`
		    range = range.replace(re[t.TILDETRIM], tildeTrimReplace);

		    // `^ 1.2.3` => `^1.2.3`
		    range = range.replace(re[t.CARETTRIM], caretTrimReplace);

		    // normalize spaces
		    range = range.split(/\s+/).join(' ');

		    // At this point, the range is completely trimmed and
		    // ready to be split into comparators.

		    let rangeList = range
		      .split(' ')
		      .map(comp => parseComparator(comp, this.options))
		      .join(' ')
		      .split(/\s+/)
		      // >=0.0.0 is equivalent to *
		      .map(comp => replaceGTE0(comp, this.options));

		    if (loose) {
		      // in loose mode, throw out any that are not valid comparators
		      rangeList = rangeList.filter(comp => {
		        debug('loose invalid filter', comp, this.options);
		        return !!comp.match(re[t.COMPARATORLOOSE])
		      });
		    }
		    debug('range list', rangeList);

		    // if any comparators are the null set, then replace with JUST null set
		    // if more than one comparator, remove any * comparators
		    // also, don't include the same comparator more than once
		    const rangeMap = new Map();
		    const comparators = rangeList.map(comp => new Comparator(comp, this.options));
		    for (const comp of comparators) {
		      if (isNullSet(comp)) {
		        return [comp]
		      }
		      rangeMap.set(comp.value, comp);
		    }
		    if (rangeMap.size > 1 && rangeMap.has('')) {
		      rangeMap.delete('');
		    }

		    const result = [...rangeMap.values()];
		    cache.set(memoKey, result);
		    return result
		  }

		  intersects (range, options) {
		    if (!(range instanceof Range)) {
		      throw new TypeError('a Range is required')
		    }

		    return this.set.some((thisComparators) => {
		      return (
		        isSatisfiable(thisComparators, options) &&
		        range.set.some((rangeComparators) => {
		          return (
		            isSatisfiable(rangeComparators, options) &&
		            thisComparators.every((thisComparator) => {
		              return rangeComparators.every((rangeComparator) => {
		                return thisComparator.intersects(rangeComparator, options)
		              })
		            })
		          )
		        })
		      )
		    })
		  }

		  // if ANY of the sets match ALL of its comparators, then pass
		  test (version) {
		    if (!version) {
		      return false
		    }

		    if (typeof version === 'string') {
		      try {
		        version = new SemVer(version, this.options);
		      } catch (er) {
		        return false
		      }
		    }

		    for (let i = 0; i < this.set.length; i++) {
		      if (testSet(this.set[i], version, this.options)) {
		        return true
		      }
		    }
		    return false
		  }
		}
		range = Range;

		const LRU = lruCache;
		const cache = new LRU({ max: 1000 });

		const parseOptions = parseOptions_1;
		const Comparator = requireComparator();
		const debug = debug_1;
		const SemVer = semver$1;
		const {
		  re,
		  t,
		  comparatorTrimReplace,
		  tildeTrimReplace,
		  caretTrimReplace,
		} = reExports;

		const isNullSet = c => c.value === '<0.0.0-0';
		const isAny = c => c.value === '';

		// take a set of comparators and determine whether there
		// exists a version which can satisfy it
		const isSatisfiable = (comparators, options) => {
		  let result = true;
		  const remainingComparators = comparators.slice();
		  let testComparator = remainingComparators.pop();

		  while (result && remainingComparators.length) {
		    result = remainingComparators.every((otherComparator) => {
		      return testComparator.intersects(otherComparator, options)
		    });

		    testComparator = remainingComparators.pop();
		  }

		  return result
		};

		// comprised of xranges, tildes, stars, and gtlt's at this point.
		// already replaced the hyphen ranges
		// turn into a set of JUST comparators.
		const parseComparator = (comp, options) => {
		  debug('comp', comp, options);
		  comp = replaceCarets(comp, options);
		  debug('caret', comp);
		  comp = replaceTildes(comp, options);
		  debug('tildes', comp);
		  comp = replaceXRanges(comp, options);
		  debug('xrange', comp);
		  comp = replaceStars(comp, options);
		  debug('stars', comp);
		  return comp
		};

		const isX = id => !id || id.toLowerCase() === 'x' || id === '*';

		// ~, ~> --> * (any, kinda silly)
		// ~2, ~2.x, ~2.x.x, ~>2, ~>2.x ~>2.x.x --> >=2.0.0 <3.0.0-0
		// ~2.0, ~2.0.x, ~>2.0, ~>2.0.x --> >=2.0.0 <2.1.0-0
		// ~1.2, ~1.2.x, ~>1.2, ~>1.2.x --> >=1.2.0 <1.3.0-0
		// ~1.2.3, ~>1.2.3 --> >=1.2.3 <1.3.0-0
		// ~1.2.0, ~>1.2.0 --> >=1.2.0 <1.3.0-0
		// ~0.0.1 --> >=0.0.1 <0.1.0-0
		const replaceTildes = (comp, options) =>
		  comp.trim().split(/\s+/).map((c) => {
		    return replaceTilde(c, options)
		  }).join(' ');

		const replaceTilde = (comp, options) => {
		  const r = options.loose ? re[t.TILDELOOSE] : re[t.TILDE];
		  return comp.replace(r, (_, M, m, p, pr) => {
		    debug('tilde', comp, _, M, m, p, pr);
		    let ret;

		    if (isX(M)) {
		      ret = '';
		    } else if (isX(m)) {
		      ret = `>=${M}.0.0 <${+M + 1}.0.0-0`;
		    } else if (isX(p)) {
		      // ~1.2 == >=1.2.0 <1.3.0-0
		      ret = `>=${M}.${m}.0 <${M}.${+m + 1}.0-0`;
		    } else if (pr) {
		      debug('replaceTilde pr', pr);
		      ret = `>=${M}.${m}.${p}-${pr
	      } <${M}.${+m + 1}.0-0`;
		    } else {
		      // ~1.2.3 == >=1.2.3 <1.3.0-0
		      ret = `>=${M}.${m}.${p
	      } <${M}.${+m + 1}.0-0`;
		    }

		    debug('tilde return', ret);
		    return ret
		  })
		};

		// ^ --> * (any, kinda silly)
		// ^2, ^2.x, ^2.x.x --> >=2.0.0 <3.0.0-0
		// ^2.0, ^2.0.x --> >=2.0.0 <3.0.0-0
		// ^1.2, ^1.2.x --> >=1.2.0 <2.0.0-0
		// ^1.2.3 --> >=1.2.3 <2.0.0-0
		// ^1.2.0 --> >=1.2.0 <2.0.0-0
		// ^0.0.1 --> >=0.0.1 <0.0.2-0
		// ^0.1.0 --> >=0.1.0 <0.2.0-0
		const replaceCarets = (comp, options) =>
		  comp.trim().split(/\s+/).map((c) => {
		    return replaceCaret(c, options)
		  }).join(' ');

		const replaceCaret = (comp, options) => {
		  debug('caret', comp, options);
		  const r = options.loose ? re[t.CARETLOOSE] : re[t.CARET];
		  const z = options.includePrerelease ? '-0' : '';
		  return comp.replace(r, (_, M, m, p, pr) => {
		    debug('caret', comp, _, M, m, p, pr);
		    let ret;

		    if (isX(M)) {
		      ret = '';
		    } else if (isX(m)) {
		      ret = `>=${M}.0.0${z} <${+M + 1}.0.0-0`;
		    } else if (isX(p)) {
		      if (M === '0') {
		        ret = `>=${M}.${m}.0${z} <${M}.${+m + 1}.0-0`;
		      } else {
		        ret = `>=${M}.${m}.0${z} <${+M + 1}.0.0-0`;
		      }
		    } else if (pr) {
		      debug('replaceCaret pr', pr);
		      if (M === '0') {
		        if (m === '0') {
		          ret = `>=${M}.${m}.${p}-${pr
	          } <${M}.${m}.${+p + 1}-0`;
		        } else {
		          ret = `>=${M}.${m}.${p}-${pr
	          } <${M}.${+m + 1}.0-0`;
		        }
		      } else {
		        ret = `>=${M}.${m}.${p}-${pr
	        } <${+M + 1}.0.0-0`;
		      }
		    } else {
		      debug('no pr');
		      if (M === '0') {
		        if (m === '0') {
		          ret = `>=${M}.${m}.${p
	          }${z} <${M}.${m}.${+p + 1}-0`;
		        } else {
		          ret = `>=${M}.${m}.${p
	          }${z} <${M}.${+m + 1}.0-0`;
		        }
		      } else {
		        ret = `>=${M}.${m}.${p
	        } <${+M + 1}.0.0-0`;
		      }
		    }

		    debug('caret return', ret);
		    return ret
		  })
		};

		const replaceXRanges = (comp, options) => {
		  debug('replaceXRanges', comp, options);
		  return comp.split(/\s+/).map((c) => {
		    return replaceXRange(c, options)
		  }).join(' ')
		};

		const replaceXRange = (comp, options) => {
		  comp = comp.trim();
		  const r = options.loose ? re[t.XRANGELOOSE] : re[t.XRANGE];
		  return comp.replace(r, (ret, gtlt, M, m, p, pr) => {
		    debug('xRange', comp, ret, gtlt, M, m, p, pr);
		    const xM = isX(M);
		    const xm = xM || isX(m);
		    const xp = xm || isX(p);
		    const anyX = xp;

		    if (gtlt === '=' && anyX) {
		      gtlt = '';
		    }

		    // if we're including prereleases in the match, then we need
		    // to fix this to -0, the lowest possible prerelease value
		    pr = options.includePrerelease ? '-0' : '';

		    if (xM) {
		      if (gtlt === '>' || gtlt === '<') {
		        // nothing is allowed
		        ret = '<0.0.0-0';
		      } else {
		        // nothing is forbidden
		        ret = '*';
		      }
		    } else if (gtlt && anyX) {
		      // we know patch is an x, because we have any x at all.
		      // replace X with 0
		      if (xm) {
		        m = 0;
		      }
		      p = 0;

		      if (gtlt === '>') {
		        // >1 => >=2.0.0
		        // >1.2 => >=1.3.0
		        gtlt = '>=';
		        if (xm) {
		          M = +M + 1;
		          m = 0;
		          p = 0;
		        } else {
		          m = +m + 1;
		          p = 0;
		        }
		      } else if (gtlt === '<=') {
		        // <=0.7.x is actually <0.8.0, since any 0.7.x should
		        // pass.  Similarly, <=7.x is actually <8.0.0, etc.
		        gtlt = '<';
		        if (xm) {
		          M = +M + 1;
		        } else {
		          m = +m + 1;
		        }
		      }

		      if (gtlt === '<') {
		        pr = '-0';
		      }

		      ret = `${gtlt + M}.${m}.${p}${pr}`;
		    } else if (xm) {
		      ret = `>=${M}.0.0${pr} <${+M + 1}.0.0-0`;
		    } else if (xp) {
		      ret = `>=${M}.${m}.0${pr
	      } <${M}.${+m + 1}.0-0`;
		    }

		    debug('xRange return', ret);

		    return ret
		  })
		};

		// Because * is AND-ed with everything else in the comparator,
		// and '' means "any version", just remove the *s entirely.
		const replaceStars = (comp, options) => {
		  debug('replaceStars', comp, options);
		  // Looseness is ignored here.  star is always as loose as it gets!
		  return comp.trim().replace(re[t.STAR], '')
		};

		const replaceGTE0 = (comp, options) => {
		  debug('replaceGTE0', comp, options);
		  return comp.trim()
		    .replace(re[options.includePrerelease ? t.GTE0PRE : t.GTE0], '')
		};

		// This function is passed to string.replace(re[t.HYPHENRANGE])
		// M, m, patch, prerelease, build
		// 1.2 - 3.4.5 => >=1.2.0 <=3.4.5
		// 1.2.3 - 3.4 => >=1.2.0 <3.5.0-0 Any 3.4.x will do
		// 1.2 - 3.4 => >=1.2.0 <3.5.0-0
		const hyphenReplace = incPr => ($0,
		  from, fM, fm, fp, fpr, fb,
		  to, tM, tm, tp, tpr, tb) => {
		  if (isX(fM)) {
		    from = '';
		  } else if (isX(fm)) {
		    from = `>=${fM}.0.0${incPr ? '-0' : ''}`;
		  } else if (isX(fp)) {
		    from = `>=${fM}.${fm}.0${incPr ? '-0' : ''}`;
		  } else if (fpr) {
		    from = `>=${from}`;
		  } else {
		    from = `>=${from}${incPr ? '-0' : ''}`;
		  }

		  if (isX(tM)) {
		    to = '';
		  } else if (isX(tm)) {
		    to = `<${+tM + 1}.0.0-0`;
		  } else if (isX(tp)) {
		    to = `<${tM}.${+tm + 1}.0-0`;
		  } else if (tpr) {
		    to = `<=${tM}.${tm}.${tp}-${tpr}`;
		  } else if (incPr) {
		    to = `<${tM}.${tm}.${+tp + 1}-0`;
		  } else {
		    to = `<=${to}`;
		  }

		  return (`${from} ${to}`).trim()
		};

		const testSet = (set, version, options) => {
		  for (let i = 0; i < set.length; i++) {
		    if (!set[i].test(version)) {
		      return false
		    }
		  }

		  if (version.prerelease.length && !options.includePrerelease) {
		    // Find the set of versions that are allowed to have prereleases
		    // For example, ^1.2.3-pr.1 desugars to >=1.2.3-pr.1 <2.0.0
		    // That should allow `1.2.3-pr.2` to pass.
		    // However, `1.2.4-alpha.notready` should NOT be allowed,
		    // even though it's within the range set by the comparators.
		    for (let i = 0; i < set.length; i++) {
		      debug(set[i].semver);
		      if (set[i].semver === Comparator.ANY) {
		        continue
		      }

		      if (set[i].semver.prerelease.length > 0) {
		        const allowed = set[i].semver;
		        if (allowed.major === version.major &&
		            allowed.minor === version.minor &&
		            allowed.patch === version.patch) {
		          return true
		        }
		      }
		    }

		    // Version has a -pre, but it's not one of the ones we like.
		    return false
		  }

		  return true
		};
		return range;
	}

	var comparator;
	var hasRequiredComparator;

	function requireComparator () {
		if (hasRequiredComparator) return comparator;
		hasRequiredComparator = 1;
		const ANY = Symbol('SemVer ANY');
		// hoisted class for cyclic dependency
		class Comparator {
		  static get ANY () {
		    return ANY
		  }

		  constructor (comp, options) {
		    options = parseOptions(options);

		    if (comp instanceof Comparator) {
		      if (comp.loose === !!options.loose) {
		        return comp
		      } else {
		        comp = comp.value;
		      }
		    }

		    debug('comparator', comp, options);
		    this.options = options;
		    this.loose = !!options.loose;
		    this.parse(comp);

		    if (this.semver === ANY) {
		      this.value = '';
		    } else {
		      this.value = this.operator + this.semver.version;
		    }

		    debug('comp', this);
		  }

		  parse (comp) {
		    const r = this.options.loose ? re[t.COMPARATORLOOSE] : re[t.COMPARATOR];
		    const m = comp.match(r);

		    if (!m) {
		      throw new TypeError(`Invalid comparator: ${comp}`)
		    }

		    this.operator = m[1] !== undefined ? m[1] : '';
		    if (this.operator === '=') {
		      this.operator = '';
		    }

		    // if it literally is just '>' or '' then allow anything.
		    if (!m[2]) {
		      this.semver = ANY;
		    } else {
		      this.semver = new SemVer(m[2], this.options.loose);
		    }
		  }

		  toString () {
		    return this.value
		  }

		  test (version) {
		    debug('Comparator.test', version, this.options.loose);

		    if (this.semver === ANY || version === ANY) {
		      return true
		    }

		    if (typeof version === 'string') {
		      try {
		        version = new SemVer(version, this.options);
		      } catch (er) {
		        return false
		      }
		    }

		    return cmp(version, this.operator, this.semver, this.options)
		  }

		  intersects (comp, options) {
		    if (!(comp instanceof Comparator)) {
		      throw new TypeError('a Comparator is required')
		    }

		    if (!options || typeof options !== 'object') {
		      options = {
		        loose: !!options,
		        includePrerelease: false,
		      };
		    }

		    if (this.operator === '') {
		      if (this.value === '') {
		        return true
		      }
		      return new Range(comp.value, options).test(this.value)
		    } else if (comp.operator === '') {
		      if (comp.value === '') {
		        return true
		      }
		      return new Range(this.value, options).test(comp.semver)
		    }

		    const sameDirectionIncreasing =
		      (this.operator === '>=' || this.operator === '>') &&
		      (comp.operator === '>=' || comp.operator === '>');
		    const sameDirectionDecreasing =
		      (this.operator === '<=' || this.operator === '<') &&
		      (comp.operator === '<=' || comp.operator === '<');
		    const sameSemVer = this.semver.version === comp.semver.version;
		    const differentDirectionsInclusive =
		      (this.operator === '>=' || this.operator === '<=') &&
		      (comp.operator === '>=' || comp.operator === '<=');
		    const oppositeDirectionsLessThan =
		      cmp(this.semver, '<', comp.semver, options) &&
		      (this.operator === '>=' || this.operator === '>') &&
		        (comp.operator === '<=' || comp.operator === '<');
		    const oppositeDirectionsGreaterThan =
		      cmp(this.semver, '>', comp.semver, options) &&
		      (this.operator === '<=' || this.operator === '<') &&
		        (comp.operator === '>=' || comp.operator === '>');

		    return (
		      sameDirectionIncreasing ||
		      sameDirectionDecreasing ||
		      (sameSemVer && differentDirectionsInclusive) ||
		      oppositeDirectionsLessThan ||
		      oppositeDirectionsGreaterThan
		    )
		  }
		}

		comparator = Comparator;

		const parseOptions = parseOptions_1;
		const { re, t } = reExports;
		const cmp = cmp_1;
		const debug = debug_1;
		const SemVer = semver$1;
		const Range = requireRange();
		return comparator;
	}

	const Range$9 = requireRange();
	const satisfies$4 = (version, range, options) => {
	  try {
	    range = new Range$9(range, options);
	  } catch (er) {
	    return false
	  }
	  return range.test(version)
	};
	var satisfies_1 = satisfies$4;

	const Range$8 = requireRange();

	// Mostly just for testing and legacy API reasons
	const toComparators$1 = (range, options) =>
	  new Range$8(range, options).set
	    .map(comp => comp.map(c => c.value).join(' ').trim().split(' '));

	var toComparators_1 = toComparators$1;

	const SemVer$4 = semver$1;
	const Range$7 = requireRange();

	const maxSatisfying$1 = (versions, range, options) => {
	  let max = null;
	  let maxSV = null;
	  let rangeObj = null;
	  try {
	    rangeObj = new Range$7(range, options);
	  } catch (er) {
	    return null
	  }
	  versions.forEach((v) => {
	    if (rangeObj.test(v)) {
	      // satisfies(v, range, options)
	      if (!max || maxSV.compare(v) === -1) {
	        // compare(max, v, true)
	        max = v;
	        maxSV = new SemVer$4(max, options);
	      }
	    }
	  });
	  return max
	};
	var maxSatisfying_1 = maxSatisfying$1;

	const SemVer$3 = semver$1;
	const Range$6 = requireRange();
	const minSatisfying$1 = (versions, range, options) => {
	  let min = null;
	  let minSV = null;
	  let rangeObj = null;
	  try {
	    rangeObj = new Range$6(range, options);
	  } catch (er) {
	    return null
	  }
	  versions.forEach((v) => {
	    if (rangeObj.test(v)) {
	      // satisfies(v, range, options)
	      if (!min || minSV.compare(v) === 1) {
	        // compare(min, v, true)
	        min = v;
	        minSV = new SemVer$3(min, options);
	      }
	    }
	  });
	  return min
	};
	var minSatisfying_1 = minSatisfying$1;

	const SemVer$2 = semver$1;
	const Range$5 = requireRange();
	const gt$2 = gt_1;

	const minVersion$1 = (range, loose) => {
	  range = new Range$5(range, loose);

	  let minver = new SemVer$2('0.0.0');
	  if (range.test(minver)) {
	    return minver
	  }

	  minver = new SemVer$2('0.0.0-0');
	  if (range.test(minver)) {
	    return minver
	  }

	  minver = null;
	  for (let i = 0; i < range.set.length; ++i) {
	    const comparators = range.set[i];

	    let setMin = null;
	    comparators.forEach((comparator) => {
	      // Clone to avoid manipulating the comparator's semver object.
	      const compver = new SemVer$2(comparator.semver.version);
	      switch (comparator.operator) {
	        case '>':
	          if (compver.prerelease.length === 0) {
	            compver.patch++;
	          } else {
	            compver.prerelease.push(0);
	          }
	          compver.raw = compver.format();
	          /* fallthrough */
	        case '':
	        case '>=':
	          if (!setMin || gt$2(compver, setMin)) {
	            setMin = compver;
	          }
	          break
	        case '<':
	        case '<=':
	          /* Ignore maximum versions */
	          break
	        /* istanbul ignore next */
	        default:
	          throw new Error(`Unexpected operation: ${comparator.operator}`)
	      }
	    });
	    if (setMin && (!minver || gt$2(minver, setMin))) {
	      minver = setMin;
	    }
	  }

	  if (minver && range.test(minver)) {
	    return minver
	  }

	  return null
	};
	var minVersion_1 = minVersion$1;

	const Range$4 = requireRange();
	const validRange$1 = (range, options) => {
	  try {
	    // Return '*' instead of '' so that truthiness works.
	    // This will throw if it's invalid anyway
	    return new Range$4(range, options).range || '*'
	  } catch (er) {
	    return null
	  }
	};
	var valid$1 = validRange$1;

	const SemVer$1 = semver$1;
	const Comparator$2 = requireComparator();
	const { ANY: ANY$1 } = Comparator$2;
	const Range$3 = requireRange();
	const satisfies$3 = satisfies_1;
	const gt$1 = gt_1;
	const lt$1 = lt_1;
	const lte$1 = lte_1;
	const gte$1 = gte_1;

	const outside$3 = (version, range, hilo, options) => {
	  version = new SemVer$1(version, options);
	  range = new Range$3(range, options);

	  let gtfn, ltefn, ltfn, comp, ecomp;
	  switch (hilo) {
	    case '>':
	      gtfn = gt$1;
	      ltefn = lte$1;
	      ltfn = lt$1;
	      comp = '>';
	      ecomp = '>=';
	      break
	    case '<':
	      gtfn = lt$1;
	      ltefn = gte$1;
	      ltfn = gt$1;
	      comp = '<';
	      ecomp = '<=';
	      break
	    default:
	      throw new TypeError('Must provide a hilo val of "<" or ">"')
	  }

	  // If it satisfies the range it is not outside
	  if (satisfies$3(version, range, options)) {
	    return false
	  }

	  // From now on, variable terms are as if we're in "gtr" mode.
	  // but note that everything is flipped for the "ltr" function.

	  for (let i = 0; i < range.set.length; ++i) {
	    const comparators = range.set[i];

	    let high = null;
	    let low = null;

	    comparators.forEach((comparator) => {
	      if (comparator.semver === ANY$1) {
	        comparator = new Comparator$2('>=0.0.0');
	      }
	      high = high || comparator;
	      low = low || comparator;
	      if (gtfn(comparator.semver, high.semver, options)) {
	        high = comparator;
	      } else if (ltfn(comparator.semver, low.semver, options)) {
	        low = comparator;
	      }
	    });

	    // If the edge version comparator has a operator then our version
	    // isn't outside it
	    if (high.operator === comp || high.operator === ecomp) {
	      return false
	    }

	    // If the lowest version comparator has an operator and our version
	    // is less than it then it isn't higher than the range
	    if ((!low.operator || low.operator === comp) &&
	        ltefn(version, low.semver)) {
	      return false
	    } else if (low.operator === ecomp && ltfn(version, low.semver)) {
	      return false
	    }
	  }
	  return true
	};

	var outside_1 = outside$3;

	// Determine if version is greater than all the versions possible in the range.
	const outside$2 = outside_1;
	const gtr$1 = (version, range, options) => outside$2(version, range, '>', options);
	var gtr_1 = gtr$1;

	const outside$1 = outside_1;
	// Determine if version is less than all the versions possible in the range
	const ltr$1 = (version, range, options) => outside$1(version, range, '<', options);
	var ltr_1 = ltr$1;

	const Range$2 = requireRange();
	const intersects$1 = (r1, r2, options) => {
	  r1 = new Range$2(r1, options);
	  r2 = new Range$2(r2, options);
	  return r1.intersects(r2)
	};
	var intersects_1 = intersects$1;

	// given a set of versions and a range, create a "simplified" range
	// that includes the same versions that the original range does
	// If the original range is shorter than the simplified one, return that.
	const satisfies$2 = satisfies_1;
	const compare$2 = compare_1;
	var simplify = (versions, range, options) => {
	  const set = [];
	  let first = null;
	  let prev = null;
	  const v = versions.sort((a, b) => compare$2(a, b, options));
	  for (const version of v) {
	    const included = satisfies$2(version, range, options);
	    if (included) {
	      prev = version;
	      if (!first) {
	        first = version;
	      }
	    } else {
	      if (prev) {
	        set.push([first, prev]);
	      }
	      prev = null;
	      first = null;
	    }
	  }
	  if (first) {
	    set.push([first, null]);
	  }

	  const ranges = [];
	  for (const [min, max] of set) {
	    if (min === max) {
	      ranges.push(min);
	    } else if (!max && min === v[0]) {
	      ranges.push('*');
	    } else if (!max) {
	      ranges.push(`>=${min}`);
	    } else if (min === v[0]) {
	      ranges.push(`<=${max}`);
	    } else {
	      ranges.push(`${min} - ${max}`);
	    }
	  }
	  const simplified = ranges.join(' || ');
	  const original = typeof range.raw === 'string' ? range.raw : String(range);
	  return simplified.length < original.length ? simplified : range
	};

	const Range$1 = requireRange();
	const Comparator$1 = requireComparator();
	const { ANY } = Comparator$1;
	const satisfies$1 = satisfies_1;
	const compare$1 = compare_1;

	// Complex range `r1 || r2 || ...` is a subset of `R1 || R2 || ...` iff:
	// - Every simple range `r1, r2, ...` is a null set, OR
	// - Every simple range `r1, r2, ...` which is not a null set is a subset of
	//   some `R1, R2, ...`
	//
	// Simple range `c1 c2 ...` is a subset of simple range `C1 C2 ...` iff:
	// - If c is only the ANY comparator
	//   - If C is only the ANY comparator, return true
	//   - Else if in prerelease mode, return false
	//   - else replace c with `[>=0.0.0]`
	// - If C is only the ANY comparator
	//   - if in prerelease mode, return true
	//   - else replace C with `[>=0.0.0]`
	// - Let EQ be the set of = comparators in c
	// - If EQ is more than one, return true (null set)
	// - Let GT be the highest > or >= comparator in c
	// - Let LT be the lowest < or <= comparator in c
	// - If GT and LT, and GT.semver > LT.semver, return true (null set)
	// - If any C is a = range, and GT or LT are set, return false
	// - If EQ
	//   - If GT, and EQ does not satisfy GT, return true (null set)
	//   - If LT, and EQ does not satisfy LT, return true (null set)
	//   - If EQ satisfies every C, return true
	//   - Else return false
	// - If GT
	//   - If GT.semver is lower than any > or >= comp in C, return false
	//   - If GT is >=, and GT.semver does not satisfy every C, return false
	//   - If GT.semver has a prerelease, and not in prerelease mode
	//     - If no C has a prerelease and the GT.semver tuple, return false
	// - If LT
	//   - If LT.semver is greater than any < or <= comp in C, return false
	//   - If LT is <=, and LT.semver does not satisfy every C, return false
	//   - If GT.semver has a prerelease, and not in prerelease mode
	//     - If no C has a prerelease and the LT.semver tuple, return false
	// - Else return true

	const subset$1 = (sub, dom, options = {}) => {
	  if (sub === dom) {
	    return true
	  }

	  sub = new Range$1(sub, options);
	  dom = new Range$1(dom, options);
	  let sawNonNull = false;

	  OUTER: for (const simpleSub of sub.set) {
	    for (const simpleDom of dom.set) {
	      const isSub = simpleSubset(simpleSub, simpleDom, options);
	      sawNonNull = sawNonNull || isSub !== null;
	      if (isSub) {
	        continue OUTER
	      }
	    }
	    // the null set is a subset of everything, but null simple ranges in
	    // a complex range should be ignored.  so if we saw a non-null range,
	    // then we know this isn't a subset, but if EVERY simple range was null,
	    // then it is a subset.
	    if (sawNonNull) {
	      return false
	    }
	  }
	  return true
	};

	const simpleSubset = (sub, dom, options) => {
	  if (sub === dom) {
	    return true
	  }

	  if (sub.length === 1 && sub[0].semver === ANY) {
	    if (dom.length === 1 && dom[0].semver === ANY) {
	      return true
	    } else if (options.includePrerelease) {
	      sub = [new Comparator$1('>=0.0.0-0')];
	    } else {
	      sub = [new Comparator$1('>=0.0.0')];
	    }
	  }

	  if (dom.length === 1 && dom[0].semver === ANY) {
	    if (options.includePrerelease) {
	      return true
	    } else {
	      dom = [new Comparator$1('>=0.0.0')];
	    }
	  }

	  const eqSet = new Set();
	  let gt, lt;
	  for (const c of sub) {
	    if (c.operator === '>' || c.operator === '>=') {
	      gt = higherGT(gt, c, options);
	    } else if (c.operator === '<' || c.operator === '<=') {
	      lt = lowerLT(lt, c, options);
	    } else {
	      eqSet.add(c.semver);
	    }
	  }

	  if (eqSet.size > 1) {
	    return null
	  }

	  let gtltComp;
	  if (gt && lt) {
	    gtltComp = compare$1(gt.semver, lt.semver, options);
	    if (gtltComp > 0) {
	      return null
	    } else if (gtltComp === 0 && (gt.operator !== '>=' || lt.operator !== '<=')) {
	      return null
	    }
	  }

	  // will iterate one or zero times
	  for (const eq of eqSet) {
	    if (gt && !satisfies$1(eq, String(gt), options)) {
	      return null
	    }

	    if (lt && !satisfies$1(eq, String(lt), options)) {
	      return null
	    }

	    for (const c of dom) {
	      if (!satisfies$1(eq, String(c), options)) {
	        return false
	      }
	    }

	    return true
	  }

	  let higher, lower;
	  let hasDomLT, hasDomGT;
	  // if the subset has a prerelease, we need a comparator in the superset
	  // with the same tuple and a prerelease, or it's not a subset
	  let needDomLTPre = lt &&
	    !options.includePrerelease &&
	    lt.semver.prerelease.length ? lt.semver : false;
	  let needDomGTPre = gt &&
	    !options.includePrerelease &&
	    gt.semver.prerelease.length ? gt.semver : false;
	  // exception: <1.2.3-0 is the same as <1.2.3
	  if (needDomLTPre && needDomLTPre.prerelease.length === 1 &&
	      lt.operator === '<' && needDomLTPre.prerelease[0] === 0) {
	    needDomLTPre = false;
	  }

	  for (const c of dom) {
	    hasDomGT = hasDomGT || c.operator === '>' || c.operator === '>=';
	    hasDomLT = hasDomLT || c.operator === '<' || c.operator === '<=';
	    if (gt) {
	      if (needDomGTPre) {
	        if (c.semver.prerelease && c.semver.prerelease.length &&
	            c.semver.major === needDomGTPre.major &&
	            c.semver.minor === needDomGTPre.minor &&
	            c.semver.patch === needDomGTPre.patch) {
	          needDomGTPre = false;
	        }
	      }
	      if (c.operator === '>' || c.operator === '>=') {
	        higher = higherGT(gt, c, options);
	        if (higher === c && higher !== gt) {
	          return false
	        }
	      } else if (gt.operator === '>=' && !satisfies$1(gt.semver, String(c), options)) {
	        return false
	      }
	    }
	    if (lt) {
	      if (needDomLTPre) {
	        if (c.semver.prerelease && c.semver.prerelease.length &&
	            c.semver.major === needDomLTPre.major &&
	            c.semver.minor === needDomLTPre.minor &&
	            c.semver.patch === needDomLTPre.patch) {
	          needDomLTPre = false;
	        }
	      }
	      if (c.operator === '<' || c.operator === '<=') {
	        lower = lowerLT(lt, c, options);
	        if (lower === c && lower !== lt) {
	          return false
	        }
	      } else if (lt.operator === '<=' && !satisfies$1(lt.semver, String(c), options)) {
	        return false
	      }
	    }
	    if (!c.operator && (lt || gt) && gtltComp !== 0) {
	      return false
	    }
	  }

	  // if there was a < or >, and nothing in the dom, then must be false
	  // UNLESS it was limited by another range in the other direction.
	  // Eg, >1.0.0 <1.0.1 is still a subset of <2.0.0
	  if (gt && hasDomLT && !lt && gtltComp !== 0) {
	    return false
	  }

	  if (lt && hasDomGT && !gt && gtltComp !== 0) {
	    return false
	  }

	  // we needed a prerelease range in a specific tuple, but didn't get one
	  // then this isn't a subset.  eg >=1.2.3-pre is not a subset of >=1.0.0,
	  // because it includes prereleases in the 1.2.3 tuple
	  if (needDomGTPre || needDomLTPre) {
	    return false
	  }

	  return true
	};

	// >=1.2.3 is lower than >1.2.3
	const higherGT = (a, b, options) => {
	  if (!a) {
	    return b
	  }
	  const comp = compare$1(a.semver, b.semver, options);
	  return comp > 0 ? a
	    : comp < 0 ? b
	    : b.operator === '>' && a.operator === '>=' ? b
	    : a
	};

	// <=1.2.3 is higher than <1.2.3
	const lowerLT = (a, b, options) => {
	  if (!a) {
	    return b
	  }
	  const comp = compare$1(a.semver, b.semver, options);
	  return comp < 0 ? a
	    : comp > 0 ? b
	    : b.operator === '<' && a.operator === '<=' ? b
	    : a
	};

	var subset_1 = subset$1;

	// just pre-load all the stuff that index.js lazily exports
	const internalRe = reExports;
	const constants = constants$1;
	const SemVer = semver$1;
	const identifiers = identifiers$1;
	const parse = parse_1;
	const valid = valid_1;
	const clean = clean_1;
	const inc = inc_1;
	const diff = diff_1;
	const major = major_1;
	const minor = minor_1;
	const patch = patch_1;
	const prerelease = prerelease_1;
	const compare = compare_1;
	const rcompare = rcompare_1;
	const compareLoose = compareLoose_1;
	const compareBuild = compareBuild_1;
	const sort = sort_1;
	const rsort = rsort_1;
	const gt = gt_1;
	const lt = lt_1;
	const eq = eq_1;
	const neq = neq_1;
	const gte = gte_1;
	const lte = lte_1;
	const cmp = cmp_1;
	const coerce = coerce_1;
	const Comparator = requireComparator();
	const Range = requireRange();
	const satisfies = satisfies_1;
	const toComparators = toComparators_1;
	const maxSatisfying = maxSatisfying_1;
	const minSatisfying = minSatisfying_1;
	const minVersion = minVersion_1;
	const validRange = valid$1;
	const outside = outside_1;
	const gtr = gtr_1;
	const ltr = ltr_1;
	const intersects = intersects_1;
	const simplifyRange = simplify;
	const subset = subset_1;
	var semver = {
	  parse,
	  valid,
	  clean,
	  inc,
	  diff,
	  major,
	  minor,
	  patch,
	  prerelease,
	  compare,
	  rcompare,
	  compareLoose,
	  compareBuild,
	  sort,
	  rsort,
	  gt,
	  lt,
	  eq,
	  neq,
	  gte,
	  lte,
	  cmp,
	  coerce,
	  Comparator,
	  Range,
	  satisfies,
	  toComparators,
	  maxSatisfying,
	  minSatisfying,
	  minVersion,
	  validRange,
	  outside,
	  gtr,
	  ltr,
	  intersects,
	  simplifyRange,
	  subset,
	  SemVer,
	  re: internalRe.re,
	  src: internalRe.src,
	  tokens: internalRe.t,
	  SEMVER_SPEC_VERSION: constants.SEMVER_SPEC_VERSION,
	  compareIdentifiers: identifiers.compareIdentifiers,
	  rcompareIdentifiers: identifiers.rcompareIdentifiers,
	};

	/**
	 * Inside the plugin function, `this` refers to the Liquid instance.
	 */
	function convertVersion () {
	    this.registerFilter('convert_version', (version) => {
	        var _a, _b;
	        return (_b = (_a = semver.coerce(version)) === null || _a === void 0 ? void 0 : _a.version) !== null && _b !== void 0 ? _b : version;
	    });
	}

	const validateSpec = async function (content, type) {
	    var _a;
	    if (content == null) {
	        throw new Error('No content was provided');
	    }
	    const validatedSpec = await lib.validate(resolveSpec(content, type));
	    if ((_a = validatedSpec.swagger) === null || _a === void 0 ? void 0 : _a.startsWith('2.0')) {
	        throw new Error('Unsupported OpenAPI version. Expected "3.0".');
	    }
	    return validatedSpec;
	};
	const generatePlugin = async function (api, path, operation, server, name, securityType, securityFlow) {
	    var _a, _b, _c, _d;
	    const operationSpec = (_b = (_a = api.paths) === null || _a === void 0 ? void 0 : _a[path]) === null || _b === void 0 ? void 0 : _b[operation];
	    if (operationSpec == null) {
	        throw new Error(`No operation found in spec for path:${path}, operation=${operation}`);
	    }
	    const templateEngine = new Liquid({
	        root: ['static/templates/', 'static/templates/partials'],
	        extname: '.liquid'
	    });
	    templateEngine.plugin(substitutePathParamsPlugin);
	    templateEngine.plugin(convertSchemaTypePlugin);
	    templateEngine.plugin(convertVersion);
	    const securityScheme = (_d = (_c = api === null || api === void 0 ? void 0 : api.components) === null || _c === void 0 ? void 0 : _c.securitySchemes) === null || _d === void 0 ? void 0 : _d[securityType];
	    return await templateEngine.renderFile('oas-axios-plugin.liquid', { api, path, operation, server, name, securityScheme, securityFlow });
	};
	function isJsonString(json) {
	    try {
	        JSON.parse(json);
	        return true;
	    }
	    catch {
	        return false;
	    }
	}
	function isYamlString(yaml) {
	    try {
	        return typeof jsYaml.load(yaml) === 'object';
	    }
	    catch {
	        return false;
	    }
	}
	function detectContentType(content, type) {
	    if (type != null)
	        return type;
	    if (isJsonString(content)) {
	        return ContentType.JSON;
	    }
	    else if (isYamlString(content)) {
	        return ContentType.YAML;
	    }
	}
	function resolveSpec(content, type) {
	    let spec = content;
	    if (typeof spec !== 'object') {
	        const contentType = detectContentType(spec, type);
	        switch (contentType) {
	            case ContentType.JSON:
	                try {
	                    spec = JSON.parse(spec);
	                }
	                catch {
	                    throw new Error('Invalid JSON content.');
	                }
	                break;
	            case ContentType.YAML:
	                try {
	                    // As YAML is superset of JSON, JSON content is expected to be parsed
	                    spec = jsYaml.load(spec);
	                }
	                catch {
	                    throw new Error('Invalid YAML content.');
	                }
	                break;
	            default:
	                if (type != null) {
	                    throw new Error('Unsupported format. Expected "json" or "yaml".');
	                }
	        }
	    }
	    return spec;
	}

	exports.generatePlugin = generatePlugin;
	exports.validateSpec = validateSpec;

	Object.defineProperty(exports, '__esModule', { value: true });

}));
//# sourceMappingURL=index.umd.js.map
